import { d as defined$1, r as round$2, s as support, u as util, l as logToConsole, M as Matrix$2, C as Color, a as Class, R as Rect, P as Point$6, A as Arc$1, b as Path$7, G as Group$8, c as Animation$1, e as dotsPattern$1, v as verticalStripesPattern$1, f as crosshatchPattern$1, g as diagonalStripesPattern$1, h as gridPattern$1, i as Circle$1, j as Circle$2, k as MultiPath, t as transform, L as LinearGradient, m as RadialGradient, T as Text$2, n as measureText, S as Segment, o as AnimationFactory, p as Layout, q as parseColor, w as Surface$1, x as throttle, y as Arc$2, z as Size, I as Image } from './kendo.drawing.cmn.chunk.js';

const __meta__ = {
    id: "charts.cmn.chunk",
    name: "ChartsCmnChunk",
    category: "web",
    description: "A reusable outputed chunk of code",
    depends: ['drawing.cmn.chunk'],
    hidden: true,
    chunk: true
};



var ARC = "arc";
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
var TAB = "Tab";
var ARIA_ACTIVE_DESCENDANT = "aria-activedescendant";
var AXIS_LABEL_CLICK = "axisLabelClick";
var BLACK$1 = "#000";
var BOTTOM$1 = "bottom";
var CENTER = "center";
var CIRCLE = "circle";
var COORD_PRECISION = 3;
var CROSS = "cross";
var DATE = "date";
var DEFAULT_FONT = "12px sans-serif";
var DEFAULT_HEIGHT$1 = 400;
var DEFAULT_PRECISION = 10;
var DEFAULT_WIDTH$1 = 600;
var END$1 = "end";
var ENTER = "Enter";
var ESCAPE = "Escape";
var FORMAT_REGEX = /\{\d+:?/;
var HEIGHT = "height";
var HIGHLIGHT_ZINDEX = 100;
var INSIDE$2 = "inside";
var INHERIT = "inherit";
var LEFT = "left";
var MAX_VALUE = Number.MAX_VALUE;
var MIN_VALUE = -Number.MAX_VALUE;
var NONE = "none";
var NOTE_CLICK = "noteClick";
var NOTE_HOVER = "noteHover";
var NOTE_LEAVE = "noteLeave";
var OBJECT$1 = "object";
var OUTSIDE$1 = "outside";
var RIGHT = "right";
var ROUNDED_RECT = "roundedRect";
var START$1 = "start";
var STRING$1 = "string";
var TOP = "top";
var TRIANGLE = "triangle";
var SQUARE = "square";
var RECT = "rect";
var VALUE = "value";
var WHITE$1 = "#fff";
var WIDTH = "width";
var X = "x";
var Y = "y";
var DEFAULT_SERIES_OPACITY = 1;
var POINTER = "pointer";
var HORIZONTAL = "horizontal";
var VERTICAL = "vertical";

var constants$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ARC: ARC,
    ARIA_ACTIVE_DESCENDANT: ARIA_ACTIVE_DESCENDANT,
    ARROW_DOWN: ARROW_DOWN,
    ARROW_LEFT: ARROW_LEFT,
    ARROW_RIGHT: ARROW_RIGHT,
    ARROW_UP: ARROW_UP,
    AXIS_LABEL_CLICK: AXIS_LABEL_CLICK,
    BLACK: BLACK$1,
    BOTTOM: BOTTOM$1,
    CENTER: CENTER,
    CIRCLE: CIRCLE,
    COORD_PRECISION: COORD_PRECISION,
    CROSS: CROSS,
    DATE: DATE,
    DEFAULT_FONT: DEFAULT_FONT,
    DEFAULT_HEIGHT: DEFAULT_HEIGHT$1,
    DEFAULT_PRECISION: DEFAULT_PRECISION,
    DEFAULT_SERIES_OPACITY: DEFAULT_SERIES_OPACITY,
    DEFAULT_WIDTH: DEFAULT_WIDTH$1,
    END: END$1,
    ENTER: ENTER,
    ESCAPE: ESCAPE,
    FORMAT_REGEX: FORMAT_REGEX,
    HEIGHT: HEIGHT,
    HIGHLIGHT_ZINDEX: HIGHLIGHT_ZINDEX,
    HORIZONTAL: HORIZONTAL,
    INHERIT: INHERIT,
    INSIDE: INSIDE$2,
    LEFT: LEFT,
    MAX_VALUE: MAX_VALUE,
    MIN_VALUE: MIN_VALUE,
    NONE: NONE,
    NOTE_CLICK: NOTE_CLICK,
    NOTE_HOVER: NOTE_HOVER,
    NOTE_LEAVE: NOTE_LEAVE,
    OBJECT: OBJECT$1,
    OUTSIDE: OUTSIDE$1,
    POINTER: POINTER,
    RECT: RECT,
    RIGHT: RIGHT,
    ROUNDED_RECT: ROUNDED_RECT,
    SQUARE: SQUARE,
    START: START$1,
    STRING: STRING$1,
    TAB: TAB,
    TOP: TOP,
    TRIANGLE: TRIANGLE,
    VALUE: VALUE,
    VERTICAL: VERTICAL,
    WHITE: WHITE$1,
    WIDTH: WIDTH,
    X: X,
    Y: Y
});

function isArray(value) {
    return Array.isArray(value);
}

function addClass(element, classes) {
    var classArray = isArray(classes) ? classes : [ classes ];

    for (var idx = 0; idx < classArray.length; idx++) {
        var className = classArray[idx];
        if (element.className.indexOf(className) === -1) {
            element.className += " " + className;
        }
    }
}

var SPACE_REGEX = /\s+/g;

function removeClass(element, className) {
    if (element && element.className) {
        element.className = element.className.replace(className, "").replace(SPACE_REGEX, " ");
    }
}

function alignPathToPixel(path) {
    var offset = 0.5;
    if (path.options.stroke && defined$1(path.options.stroke.width)) {
        if (path.options.stroke.width % 2 === 0) {
            offset = 0;
        }
    }

    for (var i = 0; i < path.segments.length; i++) {
        path.segments[i].anchor().round(0).translate(offset, offset);
    }

    return path;
}

function clockwise(angle1, angle2) {
    // True if angle2 is clockwise of angle1
    // assuming angles grow in clock-wise direction
    // (as in the pie and radar charts)
    return -angle1.x * angle2.y + angle1.y * angle2.x < 0;
}

function isNumber(value) {
    return typeof value === "number" && !isNaN(value);
}

function isString$1(value) {
    return typeof value === STRING$1;
}

function convertableToNumber(value) {
    return isNumber(value) || (isString$1(value) && isFinite(value));
}

function cycleUp(index, count) {
    return (index + 1) % count;
}

function cycleDown(index, count) {
    var result = index - 1;

    return result < 0 ? count - 1 : result;
}

function cycleIndex(index, length) {
    if (length === 1 || (index % length) === 0) {
        return 0;
    }

    if (index < 0) {
        return length + (index % length);
    } else if (index >= length) {
        return index % length;
    }

    return index;
}

function isFunction(fn) {
    return typeof fn === "function";
}

var OBJECT = "object";
var UNDEFINED = "undefined";

function deepExtendOne(destination, source) {
    for (var property in source) {
        if (property === '__proto__' || property === 'constructor') {
            continue;
        }

        var propValue = source[property];
        var propType = typeof propValue;

        var propInit = (void 0);
        if (propType === OBJECT && propValue !== null) {
            propInit = propValue.constructor;
        } else {
            propInit = null;
        }

        if (propInit && propInit !== Array) {
            if (propValue instanceof Date) {
                destination[property] = new Date(propValue.getTime());
            } else if (isFunction(propValue.clone)) {
                destination[property] = propValue.clone();
            } else {
                var destProp = destination[property];
                if (typeof (destProp) === OBJECT) {
                    destination[property] = destProp || {};
                } else {
                    destination[property] = {};
                }
                deepExtendOne(destination[property], propValue);
            }
        } else if (propType !== UNDEFINED) {
            destination[property] = propValue;
        }
    }

    return destination;
}

function deepExtend(destination) {
    var arguments$1 = arguments;

    var length = arguments.length;

    for (var i = 1; i < length; i++) {
        deepExtendOne(destination, arguments$1[i]);
    }

    return destination;
}

function isObject(value) {
    return typeof value === "object";
}

function styleValue(value) {
    if (isNumber(value)) {
        return value + "px";
    }
    return value;
}

var SIZE_STYLES_REGEX = /width|height|top|left|bottom|right/i;

function isSizeField(field) {
    return SIZE_STYLES_REGEX.test(field);
}

function elementStyles$1(element, styles) {
    var stylesArray = isString$1(styles) ? [ styles ] : styles;

    if (isArray(stylesArray)) {
        var result = {};
        var style = window.getComputedStyle(element);

        for (var idx = 0; idx < stylesArray.length; idx++) {
            var field = stylesArray[idx];
            result[field] = isSizeField(field) ? parseFloat(style[field]) : style[field];
        }

        return result;
    } else if (isObject(styles)) {
        for (var field$1 in styles) {
            element.style[field$1] = styleValue(styles[field$1]);
        }
    }
}

function getSpacing(value, defaultSpacing) {
    if ( defaultSpacing === void 0 ) defaultSpacing = 0;

    var spacing = { top: 0, right: 0, bottom: 0, left: 0 };

    if (typeof(value) === "number") {
        spacing[TOP] = spacing[RIGHT] = spacing[BOTTOM$1] = spacing[LEFT] = value;
    } else {
        spacing[TOP] = value[TOP] || defaultSpacing;
        spacing[RIGHT] = value[RIGHT] || defaultSpacing;
        spacing[BOTTOM$1] = value[BOTTOM$1] || defaultSpacing;
        spacing[LEFT] = value[LEFT] || defaultSpacing;
    }

    return spacing;
}

var current$2 = {
    compile: function(template) {
        return template;
    }
};

var TemplateService = function TemplateService () {};

TemplateService.register = function register (userImplementation) {
    current$2 = userImplementation;
};

TemplateService.compile = function compile (template, options) {
    return current$2.compile(template, options);
};

function getTemplate$1(options) {
    if ( options === void 0 ) options = {};

    var template;
    if (options.template) {
        options.template = template = TemplateService.compile(options.template);
    } else if (isFunction(options.content)) {
        template = options.content;
    }

    return template;
}

function getTemplate(options) {
    if ( options === void 0 ) options = {};

    var ariaTemplate;
    if (options.ariaTemplate) {
        options.ariaTemplate = ariaTemplate = TemplateService.compile(options.ariaTemplate);
    } else if (isFunction(options.ariaContent)) {
        ariaTemplate = options.ariaContent;
    }

    return ariaTemplate;
}

var FIELD_REGEX = /\[(?:(\d+)|['"](.*?)['"])\]|((?:(?!\[.*?\]|\.).)+)/g;
var getterCache = {};

getterCache['undefined'] = function(obj) {
    return obj;
};

function getter(field) {
    if (getterCache[field]) {
        return getterCache[field];
    }

    var fields = [];
    field.replace(FIELD_REGEX, function(match, index, indexAccessor, field) {
        fields.push(defined$1(index) ? index : (indexAccessor || field));
    });

    getterCache[field] = function(obj) {
        var result = obj;
        for (var idx = 0; idx < fields.length && result; idx++) {
            result = result[fields[idx]];
        }

        return result;
    };

    return getterCache[field];
}

function grep(array, callback) {
    var length = array.length;
    var result = [];
    for (var idx = 0; idx < length; idx++) {
        if (callback(array[idx])) {
            result .push(array[idx]);
        }
    }

    return result;
}

function hasClasses(element, classNames) {
    if (element.className) {
        var names = classNames.split(" ");
        for (var idx = 0; idx < names.length; idx++) {
            if (element.className.indexOf && element.className.indexOf(names[idx]) !== -1) {
                return true;
            }
        }
    }
}

// TODO: Remove and replace with Map/WeakMap.
var HashMap = function HashMap() {
    this._map = new Map();
};

HashMap.prototype.get = function get (key) {
    return this._map.get(key);
};

HashMap.prototype.set = function set (key, value) {
    this._map.set(key, value);
};

function inArray(value, array) {
    if (array) {
        return array.indexOf(value) !== -1;
    }
}

function interpolateValue(start, end, progress) {
    return round$2(start + (end - start) * progress, COORD_PRECISION);
}

var TRIGGER = 'trigger';

var InstanceObserver = function InstanceObserver(observer, handlers) {
    this.observer = observer;
    this.handlerMap = deepExtend({}, this.handlerMap, handlers);
};

InstanceObserver.prototype.trigger = function trigger (name, args) {
    var ref = this;
        var observer = ref.observer;
        var handlerMap = ref.handlerMap;
    var isDefaultPrevented;
    if (handlerMap[name]) {
        isDefaultPrevented = this.callObserver(handlerMap[name], args);
    } else if (observer[TRIGGER]) {
        isDefaultPrevented = this.callObserver(TRIGGER, name, args);
    }

    return isDefaultPrevented;
};

InstanceObserver.prototype.callObserver = function callObserver (fnName) {
        var args = [], len = arguments.length - 1;
        while ( len-- > 0 ) args[ len ] = arguments[ len + 1 ];

    return this.observer[fnName].apply(this.observer, args);
};

InstanceObserver.prototype.requiresHandlers = function requiresHandlers (names) {
        var this$1$1 = this;

    if (this.observer.requiresHandlers) {
        return this.observer.requiresHandlers(names);
    }

    for (var idx = 0; idx < names.length; idx++) {
        if (this$1$1.handlerMap[names[idx]]) {
            return true;
        }
    }
};

function isPlainObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}

function map(array, callback) {
    var length = array.length;
    var result = [];
    for (var idx = 0; idx < length; idx++) {
        var value = callback(array[idx]);
        if (defined$1(value)) {
            result.push(value);
        }
    }
    return result;
}

var browser$1 = support.browser || {};

function mousewheelDelta(e) {
    var delta = 0;

    if (e.wheelDelta) {
        delta = -e.wheelDelta / 120;

        if (browser$1.webkit) {
            // Webkit browsers scale the delta by twice the device resolution.
            // Possibly related to https://bugs.webkit.org/show_bug.cgi?id=196339
            //
            // Low device resolutions (e.g. zoom-out to 30%) also behave strangely.
            delta = delta / (2 * Math.max(window.devicePixelRatio, 0.625));
        }
    } else if (e.detail) {
        delta = e.detail / 3;
    }

    delta = delta > 0 ? Math.ceil(delta) : Math.floor(delta);

    return delta;
}

var ref = util;
var append = ref.append;
var bindEvents = ref.bindEvents;
var defined = ref.defined;
var deg = ref.deg;
var elementOffset = ref.elementOffset;
var elementSize = ref.elementSize;
var eventCoordinates = ref.eventCoordinates;
var eventElement = ref.eventElement;
var hashKey = ref.hashKey;
var last = ref.last;
var limitValue = ref.limitValue;
var objectKey = ref.objectKey;
var rad = ref.rad;
var round$1 = ref.round;
var unbindEvents = ref.unbindEvents;
var valueOrDefault = ref.valueOrDefault;

var FontLoader = function FontLoader () {};

FontLoader.fetchFonts = function fetchFonts (options, fonts, state) {
        if ( state === void 0 ) state = { depth: 0 };

    var MAX_DEPTH = 5;

    if (!options || state.depth > MAX_DEPTH || !document.fonts) {
        return;
    }

    Object.keys(options).forEach(function(key) {
        var value = options[key];
        if (key === "dataSource" || key[0] === "$" || !value) {
            return;
        }

        if (key === "font") {
            fonts.push(value);
        } else if (typeof value === "object") {
            state.depth++;
            FontLoader.fetchFonts(value, fonts, state);
            state.depth--;
        }
    });
};

FontLoader.loadFonts = function loadFonts (fonts, callback) {
    var promises = [];

    if (fonts.length > 0 && document.fonts) {
        try {
            promises = fonts.map(function(font) {
                return document.fonts.load(font);
            });
        } catch (e) {
            // Silence font-loading errors
            logToConsole(e);
        }

        Promise.all(promises).then(callback, callback);
    } else {
        callback();
    }
};

FontLoader.preloadFonts = function preloadFonts (options, callback) {
    var fonts = [];
    FontLoader.fetchFonts(options, fonts);

    FontLoader.loadFonts(fonts, callback);
};

function setDefaultOptions(type, options) {
    var proto = type.prototype;
    if (proto.options) {
        proto.options = deepExtend({}, proto.options, options);
    } else {
        proto.options = options;
    }
}

var KICON = 'k-icon';
var KI_PREFFIX = 'k-i-';
var KFONTICON = 'k-font-icon';
var KSVGICON = 'k-svg-icon';
var KSVG_PREFFIX = 'k-svg-i-';

var HTMLBaseIcon = function HTMLBaseIcon(element, options) {
    this.element = element;
    this.options = deepExtend({}, this.options, options);

    this.wrapper();
};

HTMLBaseIcon.prototype.wrapper = function wrapper () {
    this.addClasses();
};

HTMLBaseIcon.prototype.addClasses = function addClasses () {
};

HTMLBaseIcon.prototype.html = function html () {
    return this.element.outerHTML;
};

setDefaultOptions(HTMLBaseIcon, {
    name: '',
    size: 'none',
    themeColor: 'none',
    flip: 'default',
    iconClass: '',
    stylingOptions: [ 'size', 'themeColor', 'fill' ]
});

var HTMLFontIcon = (function (HTMLBaseIcon) {
    function HTMLFontIcon(element, options) {
        HTMLBaseIcon.call(this, element, options);
    }

    if ( HTMLBaseIcon ) HTMLFontIcon.__proto__ = HTMLBaseIcon;
    HTMLFontIcon.prototype = Object.create( HTMLBaseIcon && HTMLBaseIcon.prototype );
    HTMLFontIcon.prototype.constructor = HTMLFontIcon;

    HTMLFontIcon.prototype.wrapper = function wrapper () {
        // Find if there is an existing k-i- class appended to the element.
        var currentIconClass = this.element.className.split(" ").find(function (x) { return x.startsWith(KI_PREFFIX); });
        var className = this.options.icon ? ("" + (this.options.icon.startsWith(KI_PREFFIX) ? "" : KI_PREFFIX) + (this.options.icon)) : "";

        this._className = className;

        addClass(this.element, KICON);
        addClass(this.element, KFONTICON);
        removeClass(this.element, currentIconClass); // Remove any existing icons.
        addClass(this.element, className);
        addClass(this.element, this.options.iconClass || '');

        HTMLBaseIcon.prototype.wrapper.call(this);
    };

    return HTMLFontIcon;
}(HTMLBaseIcon));

setDefaultOptions(HTMLFontIcon, {
    name: 'HTMLFontIcon',
    icon: null
});

var HTMLSvgIcon = (function (HTMLBaseIcon) {
    function HTMLSvgIcon(element, options) {
        // Ensure that the inner contents of the wrapping span element are always removed for re-rendering purposes.
        element.innerHTML = "";

        HTMLBaseIcon.call(this, element, options);
    }

    if ( HTMLBaseIcon ) HTMLSvgIcon.__proto__ = HTMLBaseIcon;
    HTMLSvgIcon.prototype = Object.create( HTMLBaseIcon && HTMLBaseIcon.prototype );
    HTMLSvgIcon.prototype.constructor = HTMLSvgIcon;

    HTMLSvgIcon.prototype.wrapper = function wrapper () {
        var icon = this.options.icon;
        var iconClass = this.options.iconClass;
        var currentIconClass = this.element.className.split(" ").find(function (x) { return x.startsWith(KSVG_PREFFIX); });

        if (!icon && iconClass) {
            // match k-i-(some-icon-name)
            var regex = /k-i-(\w+(?:-\w+)*)/;
            var iconNameMatch = iconClass.match(regex);
            if (iconNameMatch) {
                icon = iconNameMatch[1];
                iconClass = iconClass.replace(iconNameMatch[0], "");
            }
        }

        if (isString$1(icon)) {
            icon = icon.replace("k-i-", "").replace(/-./g, function (x) { return x[1].toUpperCase(); });
            icon = this.options.svgIcons[icon] || this.options.svgIcons[(icon + "Icon")];
        }

        var className = icon && icon.name ? ("" + KSVG_PREFFIX + (icon.name)) : "";
        this._className = className;

        addClass(this.element, KSVGICON);
        removeClass(this.element, currentIconClass);
        addClass(this.element, className);
        addClass(this.element, iconClass || "");
        this.element.setAttribute("aria-hidden", "true");

        if (icon && isPlainObject(icon)) {
            var svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svgElement.setAttribute("viewBox", icon.viewBox || "");
            svgElement.setAttribute("focusable", "false");
            svgElement.innerHTML = icon.content || "";

            this.element.appendChild(svgElement);
        }

        HTMLBaseIcon.prototype.wrapper.call(this);
    };

    return HTMLSvgIcon;
}(HTMLBaseIcon));

setDefaultOptions(HTMLSvgIcon, {
    name: 'HTMLSvgIcon',
    icon: null,
    svgIcons: {}
});

var ICON_TYPES = {
    'svg': HTMLSvgIcon,
    'font': HTMLFontIcon
};

function renderIcon(iconElement, iconOptions) {
    var element = iconElement;
    var options = iconOptions;

    if (!element
        || (isObject(element) && !(element instanceof HTMLElement))
        || isString$1(element)) {
        options = element;
        element = document.createElement("span");
    }

    if (isString$1(options)) {
        options = {
            icon: options
        };
    }

    if (!options.type) {
        options.type = 'svg';
    }

    if (!ICON_TYPES[options.type]) {
        return null;
    }

    return (new ICON_TYPES[options.type](element, options).html());
}

function sparseArrayLimits(arr) {
    var min = MAX_VALUE;
    var max = MIN_VALUE;

    for (var idx = 0, length = arr.length; idx < length; idx++) {
        var value = arr[idx];
        if (value !== null && isFinite(value)) {
            min = Math.min(min, value);
            max = Math.max(max, value);
        }
    }

    return {
        min: min === MAX_VALUE ? undefined : min,
        max: max === MIN_VALUE ? undefined : max
    };
}

function find(array, predicate) {
    for (var i = 0; i < array.length; i++) {
        var item = array[i];
        if (predicate(item, i, array)) {
            return item;
        }
    }
}

var Matrix$1 = Matrix$2;
var matrixRegexp = /matrix\((.*)\)/;

function parseMatrix(matrixString) {
    var match = matrixString.match(matrixRegexp);
    if (match === null || match.length !== 2) {
        return Matrix$1.unit();
    }

    var members = match[1].split(',').map(function (x) { return parseFloat(x); });
    return new (Function.prototype.bind.apply( Matrix$1, [ null ].concat( members) ));
}

function transformMatrix(element) {
    var transform = getComputedStyle(element).transform;

    if (transform === 'none') {
        return Matrix$1.unit();
    }

    return parseMatrix(transform);
}

function elementScale(element) {
    if (!element) {
        return Matrix$1.unit();
    }

    var matrix = transformMatrix(element);
    var parent = element.parentElement;
    while (parent) {
        var parentMatrix = transformMatrix(parent);
        matrix = matrix.multiplyCopy(parentMatrix);
        parent = parent.parentElement;
    }

    matrix.b = matrix.c = matrix.e = matrix.f = 0;
    return matrix;
}

function autoTextColor(color) {
    var isDark = new Color(color).isDark();
    if (isDark) {
        return WHITE$1;
    }

    return BLACK$1;
}

var DELETED = {};

var LegacySet = function LegacySet(values) {
    var this$1$1 = this;

    this._index = {};
    this._values = values ? values.slice(0) : [];

    for (var i = 0; i < this._values.length; i++) {
        this$1$1._index[this$1$1._values[i]] = i;
    }
};

var prototypeAccessors$2 = { size: { configurable: true } };

LegacySet.prototype.values = function values () {
    return this._values.filter(function (item) { return item !== DELETED; });
};

LegacySet.prototype.has = function has (value) {
    return this._index[value] !== undefined;
};

LegacySet.prototype.add = function add (value) {
    if (!this.has(value)) {
        this._index[value] = this._values.length;
        this._values.push(value);
    }
};

LegacySet.prototype.delete = function delete$1 (value) {
    var index = this._index[value];
    if (index !== undefined) {
        this._values[index] = DELETED;
        delete this._index[value];
    }
};

LegacySet.prototype.clear = function clear () {
    this._index = {};
    this._values = [];
};

prototypeAccessors$2.size.get = function () {
    return this._values.length;
};

Object.defineProperties( LegacySet.prototype, prototypeAccessors$2 );

var SetWrapper = function SetWrapper(values) {
    this._set = new Set(values);
};

var prototypeAccessors$1$1 = { size: { configurable: true } };

SetWrapper.prototype.values = function values () {
    return Array.from(this._set);
};

SetWrapper.prototype.has = function has (value) {
    return this._set.has(value);
};

SetWrapper.prototype.add = function add (value) {
    this._set.add(value);
};

SetWrapper.prototype.delete = function delete$2 (value) {
    this._set.delete(value);
};

SetWrapper.prototype.clear = function clear () {
    this._set.clear();
};

prototypeAccessors$1$1.size.get = function () {
    return this._set.size;
};

Object.defineProperties( SetWrapper.prototype, prototypeAccessors$1$1 );

// TODO: Drop LegacySet when removing support for IE10
var supportsSet = function () {
    var supported = false;

    if (typeof Set === 'function') {
        var set = new Set([1]);
        supported = set.has(1);
    }

    return supported;
};

function createHashSet(values) {
    if (supportsSet()) {
        return new SetWrapper(values);
    }

    return new LegacySet(values);
}

function defaultErrorHandler(error) {
    throw error;
}

var keys = {
    INSERT: 45,
    DELETE: 46,
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    END: 35,
    HOME: 36,
    SPACEBAR: 32,
    PAGEUP: 33,
    PAGEDOWN: 34,
    F2: 113,
    F10: 121,
    F12: 123,
    NUMPAD_PLUS: 107,
    NUMPAD_MINUS: 109,
    NUMPAD_DOT: 110
};

function hasOwnProperty(obj, property) {
    return Object.prototype.hasOwnProperty.call(obj, property);
}

// Based on the implementation from kendo-spreadsheet-common/src/calc.js
var Matrix = function Matrix() {
    this.height = 0;
    this.width = 0;
    this.data = [];
};

Matrix.prototype.clone = function clone () {
    var m = new Matrix();
    m.height = this.height;
    m.width = this.width;
    m.data = this.data.map(function (row) { return row.slice(); });
    return m;
};

Matrix.prototype.get = function get (row, col) {
    var line = this.data[row];
    var val = line ? line[col] : null;
    return val;
};

Matrix.prototype.set = function set (row, col, data) {
    var line = this.data[row];
    if (line == null) {
        line = this.data[row] = [];
    }
    line[col] = data;
    if (row >= this.height) {
        this.height = row + 1;
    }
    if (col >= this.width) {
        this.width = col + 1;
    }
};

Matrix.prototype.each = function each (f, includeEmpty) {
        var this$1$1 = this;

    for (var row = 0; row < this.height; ++row) {
        for (var col = 0; col < this.width; ++col) {
            var val = this$1$1.get(row, col);
            if (includeEmpty || val != null) {
                val = f(val, row, col);
                if (val !== undefined) {
                    return val;
                }
            }
        }
    }
};

Matrix.prototype.map = function map (f, includeEmpty) {
    var m = new Matrix();
    this.each(function(el, row, col) {
        m.set(row, col, f(el, row, col));
    }, includeEmpty);
    return m;
};

Matrix.prototype.transpose = function transpose () {
    var m = new Matrix();
    this.each(function(el, row, col) {
        m.set(col, row, el);
    });
    return m;
};

Matrix.prototype.unit = function unit (n) {
    this.width = this.height = n;
    var a = this.data = new Array(n);
    for (var i = n; --i >= 0;) {
        var row = a[i] = new Array(n);
        for (var j = n; --j >= 0;) {
            row[j] = i === j ? 1 : 0;
        }
    }
    return this;
};

Matrix.prototype.multiply = function multiply (b) {
    var a = this;
    var m = new Matrix();
    for (var row = 0; row < a.height; ++row) {
        for (var col = 0; col < b.width; ++col) {
            var s = 0;
            for (var i = 0; i < a.width; ++i) {
                var va = a.get(row, i);
                var vb = b.get(i, col);
                if (typeof va === "number" && typeof vb === "number") {
                    s += va * vb;
                }
            }
            m.set(row, col, s);
        }
    }
    return m;
};

Matrix.prototype.inverse = function inverse () {
    var n = this.width;
    var m = this.augment(new Matrix().unit(n));
    var a = m.data;

    // Gaussian elimination
    // https://en.wikipedia.org/wiki/Gaussian_elimination#Finding_the_inverse_of_a_matrix

    // 1. Get zeros below main diagonal
    var loop = function ( k ) {
        var imax = argmax(k, n, function(i) { return a[i][k]; });
        if (!a[imax][k]) {
            return { v: null }; // singular matrix
        }
        if (k !== imax) {
            var tmp = a[k];
            a[k] = a[imax];
            a[imax] = tmp;
        }
        for (var i = k + 1; i < n; ++i) {
            for (var j = k + 1; j < 2 * n; ++j) {
                a[i][j] -= a[k][j] * a[i][k] / a[k][k];
            }
            a[i][k] = 0;
        }
    };

        for (var k = 0; k < n; ++k) {
            var returned = loop( k );

            if ( returned ) return returned.v;
        }

    // 2. Get 1-s on main diagonal, dividing by pivot
    for (var i$1 = 0; i$1 < n; ++i$1) {
        for (var f = a[i$1][i$1], j$1 = 0; j$1 < 2 * n; ++j$1) {
            a[i$1][j$1] /= f;
        }
    }

    // 3. Get zeros above main diagonal.  Actually, we only care to compute the right side
    // here (that will be the inverse), so in the inner loop below we go while j >= n,
    // instead of j >= k.
    for (var k$1 = n; --k$1 >= 0;) {
        for (var i$2 = k$1; --i$2 >= 0;) {
            if (a[i$2][k$1]) {
                for (var j$2 = 2 * n; --j$2 >= n;) {
                    a[i$2][j$2] -= a[k$1][j$2] * a[i$2][k$1];
                }
            }
        }
    }

    return m.slice(0, n, n, n);
};

Matrix.prototype.augment = function augment (m) {
    var ret = this.clone();
    var n = ret.width;
    m.each(function(val, row, col) {
        ret.set(row, col + n, val);
    });
    return ret;
};

Matrix.prototype.slice = function slice (row, col, height, width) {
        var this$1$1 = this;

    var m = new Matrix();
    for (var i = 0; i < height; ++i) {
        for (var j = 0; j < width; ++j) {
            m.set(i, j, this$1$1.get(row + i, col + j));
        }
    }
    return m;
};

function argmax(start, end, f) {
    var max = f(start), pos = start;
    for (var i = start + 1; i < end; i++) {
        var v = f(start);
        if (v > max) {
            max = v;
            pos = start;
        }
    }
    return pos;
}

var eventMap = {
    down: "pointerdown",
    move: "pointermove",
    up: "pointerup",
    cancel: "pointercancel pointerleave"
};

function queryEventMap(e) {
    return eventMap[e] || e;
}

var applyEventMap = function (events) {
    var eventRegEx = /([^ ]+)/g;
    var appliedEvents = events.replace(eventRegEx, queryEventMap);

    return appliedEvents;
};

function guid() {
    var id = "";
    var i;
    var random;

    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;

        if (i === 8 || i === 12 || i === 16 || i === 20) {
            id += "-";
        }

        id += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16); // eslint-disable-line no-nested-ternary
    }

    return id;
}

var elementEventHandlers = new WeakMap();
var ID$1 = Symbol('id');

function on(element, events, filter, handler, useCapture) {
    addEventListeners(element, events, filter, handler, useCapture);
}

function off(element, events, filter, handler, useCapture) {
    removeEventListeners(element, events, filter, handler, useCapture);
}

function isString(value) {
    return typeof(value) === "string";
}

function addEventListeners(element, events, filter, handler, useCapture) {
    var eventNames = isArray(events) ? events : (events || "").split(" ");

    eventNames.forEach(function(eventName) {
        addEventListener(element, eventName, filter, handler, useCapture);
    });
}

function addEventListener(element, event, filter, handler, useCapture) {
    var eventHandler = handler;
    var eventFilter;

    if (filter && isFunction(filter) && !handler) {
        eventHandler = filter;
    } else if (filter && isString(filter) && isFunction(eventHandler)) {
        eventFilter = filter;
    }

    var attachedHandler = function(e) {
        var closestMatchingTarget = e.target ? e.target.closest(eventFilter) : null;

        if (!eventFilter ||
            (eventFilter && e.target && closestMatchingTarget)) {
            var currentTarget = eventFilter ? closestMatchingTarget : e.currentTarget;

            // reassign the property as it is a getters only
            Object.defineProperty(e, "currentTarget", { value: currentTarget });
            // keep a reference to the top-level target
            Object.defineProperty(e, "delegateTarget", { value: element });

            eventHandler(e);
        }
    };
    eventHandler[ID$1] = guid();

    var eventHandlers = elementEventHandlers.get(element);

    if (!eventHandlers) {
        eventHandlers = new Map();
        elementEventHandlers.set(element, eventHandlers);
    }

    eventHandlers.set(eventHandler[ID$1], attachedHandler);
    element.addEventListener(event, attachedHandler, Boolean(useCapture));
}

function removeEventListeners(element, events, handler, useCapture) {
    var eventNames = isArray(events) ? events : (events || "").split(" ");

    eventNames.forEach(function(eventName) {
        removeEventListener(element, eventName, handler, useCapture);
    });
}

function removeEventListener(element, event, handler, useCapture) {
    var eventHandlers = elementEventHandlers.get(element);

    if (eventHandlers && handler && handler[ID$1]) {
        var handlerId = handler[ID$1];
        var attachedHandler = eventHandlers.get(handlerId);

        eventHandlers.delete(handlerId);

        if (attachedHandler) {
            element.removeEventListener(event, attachedHandler, Boolean(useCapture));
        }
    }
}

function getSupportedFeatures() {
    var os = detectOS(navigator.userAgent);
    var support = {};

    support.mobileOS = os;

    return support;
}

function detectOS(ua) {
    var os = false;
    var agentRxs = {
            wp: /(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,
            fire: /(Silk)\/(\d+)\.(\d+(\.\d+)?)/,
            android: /(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.?(\d+(\.\d+)?)?/,
            iphone: /(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,
            ipad: /(iPad).*OS\s+(\d+)[\._]([\d_]+)/,
            playbook: /(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,
            windows: /(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,
            tizen: /(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,
            sailfish: /(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i
        },
        osRxs = {
            ios: /^i(phone|pad|pod)$/i,
            android: /^android|fire$/i,
            windows: /windows/,
            wp: /wp/,
            flat: /sailfish|ffos|tizen/i
        };

    for (var agent in agentRxs) {
        var match = ua.match(agentRxs[agent]);
        if (match) {
            if (agent === "windows" && "plugins" in navigator) { return false; } // Break if not Metro/Mobile Windows

            os = {};
            os.device = agent;
            os.name = testRegex(agent, osRxs);
            os[os.name] = true;

            break;
        }
    }

    return os;
}

function testRegex(agent, regexes, dflt) {
    for (var regex in regexes) {
        if (regexes[regex].test(agent)) {
            return regex;
        }
    }
    return dflt !== undefined ? dflt : agent;
}

function noop() {}

function now() {
    return new Date().getTime();
}

var STRING = "string";
var FUNCTION = "function";

var preventDefault$2 = function() {
    this._defaultPrevented = true;
};

var isDefaultPrevented = function() {
    return this._defaultPrevented === true;
};

var Observable = (function (Class) {
    function Observable() {
        Class.call(this);
        this._events = {};
    }

    if ( Class ) Observable.__proto__ = Class;
    Observable.prototype = Object.create( Class && Class.prototype );
    Observable.prototype.constructor = Observable;

    Observable.prototype.destroy = function destroy () {
        this.unbind();
    };

    Observable.prototype.bind = function bind (event, handlers, one) {
        var that = this,
            idx,
            eventNames = typeof event === STRING ? [event] : event || [],
            length,
            original,
            handler,
            handlersIsFunction = typeof handlers === FUNCTION,
            events;

        if (handlers === undefined) {
            for (idx in event) {
                that.bind(idx, event[idx]);
            }

            return that;
        }

        /* eslint-disable no-loop-func */
        var loop = function (  ) {
            var eventName = eventNames[idx];

            handler = handlersIsFunction ? handlers : handlers[eventName];

            if (handler) {
                if (one) {
                    original = handler;
                    handler = function() {
                        that.unbind(eventName, handler);
                        original.apply(that, arguments);
                    };

                    handler.original = original;
                }

                events = that._events[eventName] = that._events[eventName] || [];
                events.push(handler);
            }
        };

        for (idx = 0, length = eventNames.length; idx < length; idx++) loop(  );
        /* eslint-enable no-loop-func */

        return that;
    };

    Observable.prototype.one = function one (eventNames, handlers) {
        return this.bind(eventNames, handlers, true);
    };

    Observable.prototype.first = function first (eventName, handlers) {
        var that = this,
            idx,
            eventNames = typeof eventName === STRING ? [eventName] : eventName,
            length,
            handler,
            handlersIsFunction = typeof handlers === FUNCTION,
            events;

        for (idx = 0, length = eventNames.length; idx < length; idx++) {
            var eventName$1 = eventNames[idx];

            handler = handlersIsFunction ? handlers : handlers[eventName$1];

            if (handler) {
                events = that._events[eventName$1] = that._events[eventName$1] || [];
                events.unshift(handler);
            }
        }

        return that;
    };

    Observable.prototype.trigger = function trigger (eventName, eventArgs) {
        var that = this,
            events = that._events[eventName],
            idx,
            length;

        if (events) {
            var e = eventArgs || {};

            e.sender = that;

            e._defaultPrevented = false;

            e.preventDefault = preventDefault$2;

            e.isDefaultPrevented = isDefaultPrevented;

            events = events.slice();

            for (idx = 0, length = events.length; idx < length; idx++) {
                events[idx].call(that, e);
            }

            return e._defaultPrevented === true;
        }

        return false;
    };

    Observable.prototype.unbind = function unbind (eventName, handler) {
        var that = this,
            events = that._events[eventName],
            idx;

        if (eventName === undefined) {
            that._events = {};
        } else if (events) {
            if (handler) {
                for (idx = events.length - 1; idx >= 0; idx--) {
                    if (events[idx] === handler || events[idx].original === handler) {
                        events.splice(idx, 1);
                    }
                }
            } else {
                that._events[eventName] = [];
            }
        }

        return that;
    };

    Observable.prototype._setEvents = function _setEvents (options) {
        var this$1$1 = this;

        var length = (this.events || []).length;

        for (var idx = 0; idx < length; idx ++) {
            var e = this$1$1.events[idx];

            if (this$1$1.options[e] && options[e]) {
                this$1$1.unbind(e, this$1$1.options[e]);

                if (this$1$1._events && this$1$1._events[e]) {
                    delete this$1$1._events[e];
                }
            }
        }

        this.bind(this.events, options);
    };

    return Observable;
}(Class));

var extend$e = Object.assign;

var preventDefault$1 = function (e) {
    e.preventDefault();
};

var
    DEFAULT_MIN_HOLD = 800,
    CLICK_DELAY = 300,
    DEFAULT_THRESHOLD = 0,
    PRESS = 'press',
    HOLD = 'hold',
    SELECT$1 = 'select',
    START = 'start',
    MOVE = 'move',
    END = 'end',
    CANCEL = 'cancel',
    TAP = 'tap',
    DOUBLETAP = 'doubleTap',
    RELEASE = 'release',
    GESTURESTART = 'gesturestart',
    GESTURECHANGE = 'gesturechange',
    GESTUREEND = 'gestureend',
    GESTURETAP = 'gesturetap';

var THRESHOLD = {
    'api': 0,
    'touch': 0,
    'mouse': 9,
    'pointer': 9
};

function touchDelta(touch1, touch2) {
    var x1 = touch1.x.location,
        y1 = touch1.y.location,
        x2 = touch2.x.location,
        y2 = touch2.y.location,
        dx = x1 - x2,
        dy = y1 - y2;

    return {
        center: {
            x: (x1 + x2) / 2,
            y: (y1 + y2) / 2
        },
        distance: Math.sqrt(dx * dx + dy * dy)
    };
}

function getTouches(e) {
    var touches = [],
        originalEvent = e.originalEvent || e,
        currentTarget = e.currentTarget;

    if (e.api) {
        touches.push({
            id: 2, // hardcoded ID for API call
            event: e,
            target: e.target,
            currentTarget: e.target,
            location: e,
            type: 'api'
        });
    } else {
        touches.push({
            location: originalEvent,
            event: e,
            target: e.target,
            currentTarget: currentTarget,
            id: originalEvent.pointerId,
            type: 'pointer'
        });
    }

    return touches;
}
var TouchAxis = (function (Class) {
    function TouchAxis(axis, location) {
        Class.call(this);
        var that = this;

        that.support = getSupportedFeatures();
        that.invalidZeroEvents = this.support.mobileOS && this.support.mobileOS.android;
        that.axis = axis;
        that._updateLocationData(location);
        that.startLocation = that.location;
        that.velocity = that.delta = 0;
        that.timeStamp = now();
    }

    if ( Class ) TouchAxis.__proto__ = Class;
    TouchAxis.prototype = Object.create( Class && Class.prototype );
    TouchAxis.prototype.constructor = TouchAxis;

    TouchAxis.prototype.move = function move (location) {
        var that = this,
            offset = location['page' + that.axis],
            timeStamp = now(),
            timeDelta = timeStamp - that.timeStamp || 1;

        if (!offset && this.invalidZeroEvents) {
            return;
        }

        that.delta = offset - that.location;
        that._updateLocationData(location);
        that.initialDelta = offset - that.startLocation;
        that.velocity = that.delta / timeDelta;
        that.timeStamp = timeStamp;
    };

    TouchAxis.prototype._updateLocationData = function _updateLocationData (location) {
        var that = this,
            axis = that.axis;

        that.location = location['page' + axis];
        that.client = location['client' + axis];
        that.screen = location['screen' + axis];
    };

    return TouchAxis;
}(Class));

var Touch = (function (Class) {
    function Touch(userEvents, target, touchInfo) {
        Class.call(this);

        extend$e(this, {
            x: new TouchAxis('X', touchInfo.location),
            y: new TouchAxis('Y', touchInfo.location),
            type: touchInfo.type,
            threshold: userEvents.threshold || THRESHOLD[touchInfo.type],
            userEvents: userEvents,
            target: target,
            currentTarget: touchInfo.currentTarget,
            initialTouch: touchInfo.target,
            id: touchInfo.id,
            pressEvent: touchInfo,
            _clicks: userEvents._clicks,
            supportDoubleTap: userEvents.supportDoubleTap,
            _moved: false,
            _finished: false
        });
    }

    if ( Class ) Touch.__proto__ = Class;
    Touch.prototype = Object.create( Class && Class.prototype );
    Touch.prototype.constructor = Touch;

    Touch.prototype.press = function press () {
        var this$1$1 = this;

        this._holdTimeout = setTimeout(function () { return this$1$1._hold(); }, this.userEvents.minHold);
        this._trigger(PRESS, this.pressEvent);
    };

    Touch.prototype._tap = function _tap (touchInfo) {
        var that = this;

        that.userEvents._clicks++;

        if (that.userEvents._clicks === 1) {
            that._clickTimeout = setTimeout(function() {
                if (that.userEvents._clicks === 1) {
                    that._trigger(TAP, touchInfo);
                } else {
                    that._trigger(DOUBLETAP, touchInfo);
                }

                that.userEvents._clicks = 0;
            }, CLICK_DELAY);
        }
    };

    Touch.prototype._hold = function _hold () {
        this._trigger(HOLD, this.pressEvent);
    };

    /* eslint-disable consistent-return */
    Touch.prototype.move = function move (touchInfo) {
        var that = this;
        var preventMove = touchInfo.type !== 'api' && that.userEvents._shouldNotMove;

        if (that._finished || preventMove) {
            return;
        }

        that.x.move(touchInfo.location);
        that.y.move(touchInfo.location);

        if (!that._moved) {
            if (that._withinIgnoreThreshold()) {
                return;
            }

            if (!UserEvents.current || UserEvents.current === that.userEvents) {
                that._start(touchInfo);
            } else {
                return that.dispose();
            }
        }

        if (!that._finished) {
            that._trigger(MOVE, touchInfo);
        }
    };
    /* eslint-enable consistent-return */

    Touch.prototype.end = function end (touchInfo) {
        this.endTime = now();

        if (this._finished) {
            return;
        }

        this._finished = true;
        this._trigger(RELEASE, touchInfo);

        if (this._moved) {
            this._trigger(END, touchInfo);
        } else {
            if (this.supportDoubleTap) {
                this._tap(touchInfo);
            } else {
                this._trigger(TAP, touchInfo);
            }
        }

        clearTimeout(this._holdTimeout);
        this.dispose();
    };

    Touch.prototype.dispose = function dispose () {
        var userEvents = this.userEvents,
            activeTouches = userEvents.touches || [];

        this._finished = true;
        this.pressEvent = null;

        clearTimeout(this._holdTimeout);
        // activeTouches.splice($.inArray(this, activeTouches), 1);
        var activeTouchIndex = activeTouches.indexOf(this);
        activeTouches.splice(activeTouchIndex, 1);
    };

    Touch.prototype.skip = function skip () {
        this.dispose();
    };

    Touch.prototype.cancel = function cancel () {
        this.dispose();
    };

    Touch.prototype.isMoved = function isMoved () {
        return this._moved;
    };

    Touch.prototype._start = function _start (touchInfo) {
        clearTimeout(this._holdTimeout);
        this.startTime = now();
        this._moved = true;
        this._trigger(START, touchInfo);
    };

    Touch.prototype._trigger = function _trigger (name, touchInfo) {
        var e = touchInfo.event;
        var data = {
            touch: this,
            x: this.x,
            y: this.y,
            target: this.target,
            event: e
        };

        if (this.userEvents.notify(name, data)) {
            e.preventDefault();
        }
    };

    Touch.prototype._withinIgnoreThreshold = function _withinIgnoreThreshold () {
        var xDelta = this.x.initialDelta,
            yDelta = this.y.initialDelta;
        return Math.sqrt(xDelta * xDelta + yDelta * yDelta) <= this.threshold;
    };

    return Touch;
}(Class));

function withEachUpEvent(callback) {
    var downEvents = eventMap.up.split(' '),
        idx = 0,
        length = downEvents.length;

    for (; idx < length; idx++) {
        callback(downEvents[idx]);
    }
}

var UserEvents = (function (Observable) {
    function UserEvents(element, options) {
        Observable.call(this);
        var that = this;
        var filter;

        var support = getSupportedFeatures();
        this.support = support;

        /* eslint-disable no-param-reassign */
        options = options || {};
        /* eslint-enable no-param-reassign */
        this.options = options;

        filter = that.filter = options.filter;
        that.threshold = options.threshold || DEFAULT_THRESHOLD;
        that.minHold = options.minHold || DEFAULT_MIN_HOLD;
        that.touches = [];
        that._maxTouches = options.multiTouch ? 2 : 1;
        that.allowSelection = options.allowSelection;
        that.captureUpIfMoved = options.captureUpIfMoved;
        that._clicks = 0;
        that.supportDoubleTap = options.supportDoubleTap;

        extend$e(that, {
            element: element,
            surface: options.surface || element,
            stopPropagation: options.stopPropagation,
            pressed: false
        });

        this._surfaceMoveHandler = this._move.bind(this);
        on(that.surface, applyEventMap('move'), this._surfaceMoveHandler);

        this._surfaceEndHandler = this._end.bind(this);
        on(that.surface, applyEventMap('up cancel'), this._surfaceEndHandler);

        this._elementStartHandler = this._start.bind(this);
        on(element, applyEventMap('down'), filter, this._elementStartHandler);

        element.style['touch-action'] = options.touchAction || 'none';

        if (options.preventDragEvent) {
            this._elementDragStartHandler = preventDefault$1;
            on(element, applyEventMap('dragstart'), this._elementDragStartHandler);
        }

        // element.on(kendo.applyEventMap('mousedown'), filter, {
        //     root: element
        // } '_select');

        // todo: use root
        this._elementSelectHandler = this._select.bind(this);
        on(element, applyEventMap('mousedown'), filter, this._elementSelectHandler);

        if (that.captureUpIfMoved) {
            var surfaceElement = that.surface,
                preventIfMovingProxy = that.preventIfMoving.bind(that);

            withEachUpEvent(function(eventName) {
                surfaceElement.addEventListener(eventName, preventIfMovingProxy, true);
            });
        }

        that.bind([
            PRESS,
            HOLD,
            TAP,
            DOUBLETAP,
            START,
            MOVE,
            END,
            RELEASE,
            CANCEL,
            GESTURESTART,
            GESTURECHANGE,
            GESTUREEND,
            GESTURETAP,
            SELECT$1
        ], options);
    }

    if ( Observable ) UserEvents.__proto__ = Observable;
    UserEvents.prototype = Object.create( Observable && Observable.prototype );
    UserEvents.prototype.constructor = UserEvents;

    UserEvents.prototype.preventIfMoving = function preventIfMoving (e) {
        if (this._isMoved()) {
            e.preventDefault();
        }
    };

    UserEvents.prototype.destroy = function destroy () {
        var that = this;
        var options = this.options;
        var element = this.element;

        if (that._destroyed) {
            return;
        }

        that._destroyed = true;

        if (that.captureUpIfMoved) {
            var surfaceElement = that.surface;
            withEachUpEvent(function(eventName) {
                surfaceElement.removeEventListener(eventName, that.preventIfMoving);
            });
        }

        off(that.surface, applyEventMap('move'), this._surfaceMoveHandler);
        off(that.surface, applyEventMap('up cancel'), this._surfaceEndHandler);

        off(element, applyEventMap('down'), this._elementStartHandler);

        if (options.preventDragEvent) {
            off(element, applyEventMap('dragstart'), this._elementDragStartHandler);
        }

        off(element, applyEventMap('mousedown'), this._elementSelectHandler);

        that._disposeAll();
        that.unbind();

        delete that.surface;
        delete that.element;
        delete that.currentTarget;
    };

    UserEvents.prototype.capture = function capture () {
        UserEvents.current = this;
    };

    UserEvents.prototype.cancel = function cancel () {
        this._disposeAll();
        this.trigger(CANCEL);
    };

    UserEvents.prototype.notify = function notify (event, data) {
        var that = this,
            touches = that.touches;
        var eventName = event;

        if (this._isMultiTouch()) {
            switch (eventName) {
                case MOVE:
                    eventName = GESTURECHANGE;
                    break;
                case END:
                    eventName = GESTUREEND;
                    break;
                case TAP:
                    eventName = GESTURETAP;
                    break;
                default:
                    break;
            }

            extend$e(data, {
                touches: touches
            }, touchDelta(touches[0], touches[1]));
        }

        return this.trigger(eventName, extend$e(data, {
            type: eventName
        }));
    };

    UserEvents.prototype.press = function press (x, y, target) {
        this._apiCall('_start', x, y, target);
    };

    UserEvents.prototype.move = function move (x, y) {
        this._apiCall('_move', x, y);
    };

    UserEvents.prototype.end = function end (x, y) {
        this._apiCall('_end', x, y);
    };

    UserEvents.prototype._isMultiTouch = function _isMultiTouch () {
        return this.touches.length > 1;
    };

    UserEvents.prototype._maxTouchesReached = function _maxTouchesReached () {
        return this.touches.length >= this._maxTouches;
    };

    UserEvents.prototype._disposeAll = function _disposeAll () {
        var touches = this.touches;
        while (touches.length > 0) {
            touches.pop().dispose();
        }
    };

    UserEvents.prototype._isMoved = function _isMoved () {
        return grep(this.touches, function(touch) {
            return touch.isMoved();
        }).length;
    };

    UserEvents.prototype._select = function _select (e) {
        if (!this.allowSelection || this.trigger(SELECT$1, { event: e })) {
            e.preventDefault();
        }
    };

    UserEvents.prototype._start = function _start (e) {
        var this$1$1 = this;

        if (e.which && e.which > 1 || this._maxTouchesReached()) {
            return;
        }

        UserEvents.current = null;
        this.currentTarget = e.currentTarget;

        if (this.stopPropagation) {
            e.stopPropagation();
        }

        var target;
        var eventTouches = getTouches(e);
        for (var idx = 0; idx < eventTouches.length; idx++) {
            if (this$1$1._maxTouchesReached()) {
                break;
            }

            var eventTouch = eventTouches[idx];
            if (this$1$1.filter) {
                target = eventTouch.currentTarget;
            } else {
                target = this$1$1.element;
            }

            if (target && target.length === 0) {
                continue;
            }

            var touch = new Touch(this$1$1, target, eventTouch);
            this$1$1.touches.push(touch);
            touch.press();

            if (this$1$1._isMultiTouch()) {
                this$1$1.notify('gesturestart', {});
            }
        }
    };

    UserEvents.prototype._move = function _move (e) {
        this._eachTouch('move', e);
    };

    UserEvents.prototype._end = function _end (e) {
        this._eachTouch('end', e);
    };

    UserEvents.prototype._eachTouch = function _eachTouch (methodName, e) {
        var this$1$1 = this;

        var that = this,
            dict = {},
            touches = getTouches(e),
            activeTouches = that.touches,
            idx,
            touch,
            touchInfo,
            matchingTouch;

        for (idx = 0; idx < activeTouches.length; idx++) {
            touch = activeTouches[idx];
            dict[touch.id] = touch;
        }

        for (idx = 0; idx < touches.length; idx++) {
            touchInfo = touches[idx];
            matchingTouch = dict[touchInfo.id];

            if (matchingTouch) {
                var shouldCapture = methodName === 'move' && touchInfo.type === 'pointer' && !this$1$1.surface.hasPointerCapture(touchInfo.id);
                if (shouldCapture) {
                    this$1$1.surface.setPointerCapture(touchInfo.id);
                }

                matchingTouch[methodName](touchInfo);
            }
        }
    };

    UserEvents.prototype._apiCall = function _apiCall (type, x, y, target) {
        this[type]({
            api: true,
            pageX: x,
            pageY: y,
            clientX: x,
            clientY: y,
            target: target || this.element,
            stopPropagation: noop,
            preventDefault: noop
        });
    };

    UserEvents.defaultThreshold = function defaultThreshold (value) {
        DEFAULT_THRESHOLD = value;
    };

    UserEvents.minHold = function minHold (value) {
        DEFAULT_MIN_HOLD = value;
    };

    return UserEvents;
}(Observable));

function autoMajorUnit(min, max) {
    var diff = round$1(max - min, DEFAULT_PRECISION - 1);

    if (diff === 0) {
        if (max === 0) {
            return 0.1;
        }

        diff = Math.abs(max);
    }

    var scale = Math.pow(10, Math.floor(Math.log(diff) / Math.log(10)));
    var relativeValue = round$1((diff / scale), DEFAULT_PRECISION);
    var scaleMultiplier = 1;

    if (relativeValue < 1.904762) {
        scaleMultiplier = 0.2;
    } else if (relativeValue < 4.761904) {
        scaleMultiplier = 0.5;
    } else if (relativeValue < 9.523809) {
        scaleMultiplier = 1;
    } else {
        scaleMultiplier = 2;
    }

    return round$1(scale * scaleMultiplier, DEFAULT_PRECISION);
}

var Point$5 = (function (Class) {
    function Point(x, y) {
        Class.call(this);

        this.x = x || 0;
        this.y = y || 0;
    }

    if ( Class ) Point.__proto__ = Class;
    Point.prototype = Object.create( Class && Class.prototype );
    Point.prototype.constructor = Point;

    Point.prototype.clone = function clone () {
        return new Point(this.x, this.y);
    };

    Point.prototype.equals = function equals (point) {
        return point && this.x === point.x && this.y === point.y;
    };

    Point.prototype.rotate = function rotate (center, degrees) {
        var theta = rad(degrees);
        var cosT = Math.cos(theta);
        var sinT = Math.sin(theta);
        var cx = center.x;
        var cy = center.y;
        var ref = this;
        var x = ref.x;
        var y = ref.y;

        this.x = round$1(
            cx + (x - cx) * cosT + (y - cy) * sinT,
            COORD_PRECISION
        );

        this.y = round$1(
            cy + (y - cy) * cosT - (x - cx) * sinT,
            COORD_PRECISION
        );

        return this;
    };

    Point.prototype.multiply = function multiply (a) {

        this.x *= a;
        this.y *= a;

        return this;
    };

    Point.prototype.distanceTo = function distanceTo (point) {
        var dx = this.x - point.x;
        var dy = this.y - point.y;

        return Math.sqrt(dx * dx + dy * dy);
    };

    Point.onCircle = function onCircle (center, angle, radius) {
        var radians = rad(angle);

        return new Point(
            center.x - radius * Math.cos(radians),
            center.y - radius * Math.sin(radians)
        );
    };

    return Point;
}(Class));

var Box = (function (Class) {
    function Box(x1, y1, x2, y2) {
        Class.call(this);

        this.x1 = x1 || 0;
        this.y1 = y1 || 0;
        this.x2 = x2 || 0;
        this.y2 = y2 || 0;
    }

    if ( Class ) Box.__proto__ = Class;
    Box.prototype = Object.create( Class && Class.prototype );
    Box.prototype.constructor = Box;

    Box.prototype.equals = function equals (box) {
        return this.x1 === box.x1 && this.x2 === box.x2 &&
            this.y1 === box.y1 && this.y2 === box.y2;
    };

    Box.prototype.width = function width () {
        return this.x2 - this.x1;
    };

    Box.prototype.height = function height () {
        return this.y2 - this.y1;
    };

    Box.prototype.translate = function translate (dx, dy) {
        this.x1 += dx;
        this.x2 += dx;
        this.y1 += dy;
        this.y2 += dy;

        return this;
    };

    Box.prototype.move = function move (x, y) {
        var height = this.height();
        var width = this.width();

        if (defined(x)) {
            this.x1 = x;
            this.x2 = this.x1 + width;
        }

        if (defined(y)) {
            this.y1 = y;
            this.y2 = this.y1 + height;
        }

        return this;
    };

    Box.prototype.wrap = function wrap (targetBox) {
        this.x1 = Math.min(this.x1, targetBox.x1);
        this.y1 = Math.min(this.y1, targetBox.y1);
        this.x2 = Math.max(this.x2, targetBox.x2);
        this.y2 = Math.max(this.y2, targetBox.y2);

        return this;
    };

    Box.prototype.wrapPoint = function wrapPoint (point) {
        var arrayPoint = isArray(point);
        var x = arrayPoint ? point[0] : point.x;
        var y = arrayPoint ? point[1] : point.y;
        this.wrap(new Box(x, y, x, y));

        return this;
    };

    Box.prototype.snapTo = function snapTo (targetBox, axis) {

        if (axis === X || !axis) {
            this.x1 = targetBox.x1;
            this.x2 = targetBox.x2;
        }

        if (axis === Y || !axis) {
            this.y1 = targetBox.y1;
            this.y2 = targetBox.y2;
        }

        return this;
    };

    Box.prototype.alignTo = function alignTo (targetBox, anchor) {
        var height = this.height();
        var width = this.width();
        var axis = anchor === TOP || anchor === BOTTOM$1 ? Y : X;
        var offset = axis === Y ? height : width;

        if (anchor === CENTER) {
            var targetCenter = targetBox.center();
            var center = this.center();

            this.x1 += targetCenter.x - center.x;
            this.y1 += targetCenter.y - center.y;
        } else if (anchor === TOP || anchor === LEFT) {
            this[axis + 1] = targetBox[axis + 1] - offset;
        } else {
            this[axis + 1] = targetBox[axis + 2];
        }

        this.x2 = this.x1 + width;
        this.y2 = this.y1 + height;

        return this;
    };

    Box.prototype.shrink = function shrink (dw, dh) {

        this.x2 -= dw;
        this.y2 -= dh;

        return this;
    };

    Box.prototype.expand = function expand (dw, dh) {
        this.shrink(-dw, -dh);
        return this;
    };

    Box.prototype.pad = function pad (padding) {
        var spacing = getSpacing(padding);

        this.x1 -= spacing.left;
        this.x2 += spacing.right;
        this.y1 -= spacing.top;
        this.y2 += spacing.bottom;

        return this;
    };

    Box.prototype.unpad = function unpad (padding) {
        var spacing = getSpacing(padding);

        spacing.left = -spacing.left;
        spacing.top = -spacing.top;
        spacing.right = -spacing.right;
        spacing.bottom = -spacing.bottom;

        return this.pad(spacing);
    };

    Box.prototype.clone = function clone () {
        return new Box(this.x1, this.y1, this.x2, this.y2);
    };

    Box.prototype.center = function center () {
        return new Point$5(
            this.x1 + this.width() / 2,
            this.y1 + this.height() / 2
        );
    };

    Box.prototype.containsPoint = function containsPoint (point) {

        return point.x >= this.x1 && point.x <= this.x2 &&
               point.y >= this.y1 && point.y <= this.y2;
    };

    Box.prototype.points = function points () {
        return [
            new Point$5(this.x1, this.y1),
            new Point$5(this.x2, this.y1),
            new Point$5(this.x2, this.y2),
            new Point$5(this.x1, this.y2)
        ];
    };

    Box.prototype.getHash = function getHash () {
        return [ this.x1, this.y1, this.x2, this.y2 ].join(",");
    };

    Box.prototype.overlaps = function overlaps (box) {
        return !(box.y2 < this.y1 || this.y2 < box.y1 || box.x2 < this.x1 || this.x2 < box.x1);
    };

    Box.prototype.rotate = function rotate (rotation) {
        var width = this.width();
        var height = this.height();
        var ref = this.center();
        var cx = ref.x;
        var cy = ref.y;

        var r1 = rotatePoint(0, 0, cx, cy, rotation);
        var r2 = rotatePoint(width, 0, cx, cy, rotation);
        var r3 = rotatePoint(width, height, cx, cy, rotation);
        var r4 = rotatePoint(0, height, cx, cy, rotation);

        width = Math.max(r1.x, r2.x, r3.x, r4.x) - Math.min(r1.x, r2.x, r3.x, r4.x);
        height = Math.max(r1.y, r2.y, r3.y, r4.y) - Math.min(r1.y, r2.y, r3.y, r4.y);

        this.x2 = this.x1 + width;
        this.y2 = this.y1 + height;

        return this;
    };

    Box.prototype.toRect = function toRect () {
        return new Rect([ this.x1, this.y1 ], [ this.width(), this.height() ]);
    };

    Box.prototype.hasSize = function hasSize () {
        return this.width() !== 0 && this.height() !== 0;
    };

    Box.prototype.align = function align (targetBox, axis, alignment) {
        var c1 = axis + 1;
        var c2 = axis + 2;
        var sizeFunc = axis === X ? WIDTH : HEIGHT;
        var size = this[sizeFunc]();

        if (inArray(alignment, [ LEFT, TOP ])) {
            this[c1] = targetBox[c1];
            this[c2] = this[c1] + size;
        } else if (inArray(alignment, [ RIGHT, BOTTOM$1 ])) {
            this[c2] = targetBox[c2];
            this[c1] = this[c2] - size;
        } else if (alignment === CENTER) {
            this[c1] = targetBox[c1] + (targetBox[sizeFunc]() - size) / 2;
            this[c2] = this[c1] + size;
        }
    };

    return Box;
}(Class));

function rotatePoint(x, y, cx, cy, angle) {
    var theta = rad(angle);

    return new Point$5(
        cx + (x - cx) * Math.cos(theta) + (y - cy) * Math.sin(theta),
        cy - (x - cx) * Math.sin(theta) + (y - cy) * Math.cos(theta)
    );
}

var Ring = (function (Class) {
    function Ring(center, innerRadius, radius, startAngle, angle) {
        Class.call(this);

        this.center = center;
        this.innerRadius = innerRadius;
        this.radius = radius;
        this.startAngle = startAngle;
        this.angle = angle;
    }

    if ( Class ) Ring.__proto__ = Class;
    Ring.prototype = Object.create( Class && Class.prototype );
    Ring.prototype.constructor = Ring;

    Ring.prototype.clone = function clone () {
        return new Ring(this.center, this.innerRadius, this.radius, this.startAngle, this.angle);
    };

    Ring.prototype.middle = function middle () {
        return this.startAngle + this.angle / 2;
    };

    Ring.prototype.setRadius = function setRadius (newRadius, innerRadius) {
        if (innerRadius) {
            this.innerRadius = newRadius;
        } else {
            this.radius = newRadius;
        }

        return this;
    };

    // TODO: Remove and replace with Point.onCircle
    Ring.prototype.point = function point (angle, innerRadius) {
        var radianAngle = rad(angle);
        var ax = Math.cos(radianAngle);
        var ay = Math.sin(radianAngle);
        var radius = innerRadius ? this.innerRadius : this.radius;
        var x = round$1(this.center.x - (ax * radius), COORD_PRECISION);
        var y = round$1(this.center.y - (ay * radius), COORD_PRECISION);

        return new Point$5(x, y);
    };

    Ring.prototype.adjacentBox = function adjacentBox (distance, width, height) {
        var sector = this.clone().expand(distance);
        var midAndle = sector.middle();
        var midPoint = sector.point(midAndle);
        var hw = width / 2;
        var hh = height / 2;
        var sa = Math.sin(rad(midAndle));
        var ca = Math.cos(rad(midAndle));
        var x = midPoint.x - hw;
        var y = midPoint.y - hh;

        if (Math.abs(sa) < 0.9) {
            x += hw * -ca / Math.abs(ca);
        }

        if (Math.abs(ca) < 0.9) {
            y += hh * -sa / Math.abs(sa);
        }

        return new Box(x, y, x + width, y + height);
    };

    Ring.prototype.containsPoint = function containsPoint (p) {
        var center = this.center;
        var innerRadius = this.innerRadius;
        var radius = this.radius;
        var startAngle = this.startAngle;
        var endAngle = this.startAngle + this.angle;
        var dx = p.x - center.x;
        var dy = p.y - center.y;
        var vector = new Point$5(dx, dy);
        var startPoint = this.point(startAngle);
        var startVector = new Point$5(startPoint.x - center.x, startPoint.y - center.y);
        var endPoint = this.point(endAngle);
        var endVector = new Point$5(endPoint.x - center.x, endPoint.y - center.y);
        var dist = round$1(dx * dx + dy * dy, COORD_PRECISION);

        return (startVector.equals(vector) || clockwise(startVector, vector)) &&
               !clockwise(endVector, vector) &&
               dist >= innerRadius * innerRadius && dist <= radius * radius;
    };

    Ring.prototype.getBBox = function getBBox () {
        var this$1$1 = this;

        var box = new Box(MAX_VALUE, MAX_VALUE, MIN_VALUE, MIN_VALUE);
        var startAngle = round$1(this.startAngle % 360);
        var endAngle = round$1((startAngle + this.angle) % 360);
        var innerRadius = this.innerRadius;
        var allAngles = [ 0, 90, 180, 270, startAngle, endAngle ].sort(numericComparer);
        var startAngleIndex = allAngles.indexOf(startAngle);
        var endAngleIndex = allAngles.indexOf(endAngle);
        var angles;

        if (startAngle === endAngle) {
            angles = allAngles;
        } else {
            if (startAngleIndex < endAngleIndex) {
                angles = allAngles.slice(startAngleIndex, endAngleIndex + 1);
            } else {
                angles = [].concat(
                    allAngles.slice(0, endAngleIndex + 1),
                    allAngles.slice(startAngleIndex, allAngles.length)
                );
            }
        }

        for (var i = 0; i < angles.length; i++) {
            var point = this$1$1.point(angles[i]);
            box.wrapPoint(point);
            box.wrapPoint(point, innerRadius);
        }

        if (!innerRadius) {
            box.wrapPoint(this.center);
        }

        return box;
    };

    Ring.prototype.expand = function expand (value) {
        this.radius += value;
        return this;
    };

    return Ring;
}(Class));

function numericComparer(a, b) {
    return a - b;
}

var Sector = (function (Ring) {
    function Sector(center, radius, startAngle, angle) {
        Ring.call(this, center, 0, radius, startAngle, angle);
    }

    if ( Ring ) Sector.__proto__ = Ring;
    Sector.prototype = Object.create( Ring && Ring.prototype );
    Sector.prototype.constructor = Sector;

    Sector.prototype.expand = function expand (value) {
        return Ring.prototype.expand.call(this, value);
    };

    Sector.prototype.clone = function clone () {
        return new Sector(this.center, this.radius, this.startAngle, this.angle);
    };

    Sector.prototype.setRadius = function setRadius (newRadius) {
        this.radius = newRadius;

        return this;
    };

    return Sector;
}(Ring));

var DIRECTION_ANGLE = 0.001; //any value that will make the endAngle bigger than the start angle will work here.

var ShapeBuilder = (function (Class) {
    function ShapeBuilder () {
        Class.apply(this, arguments);
    }

    if ( Class ) ShapeBuilder.__proto__ = Class;
    ShapeBuilder.prototype = Object.create( Class && Class.prototype );
    ShapeBuilder.prototype.constructor = ShapeBuilder;

    ShapeBuilder.prototype.createRing = function createRing (sector, options) {
        var startAngle = sector.startAngle + 180;
        var endAngle = sector.angle + startAngle;

        //required in order to avoid reversing the arc direction in cases like 0.000000000000001 + 100 === 100
        if (sector.angle === 0 || sector.angle > 0 && startAngle === endAngle) {
            endAngle += DIRECTION_ANGLE;
        }

        var center = new Point$6(sector.center.x, sector.center.y);
        var radius = Math.max(sector.radius, 0);
        var innerRadius = Math.max(sector.innerRadius, 0);
        var arc = new Arc$1(center, {
            startAngle: startAngle,
            endAngle: endAngle,
            radiusX: radius,
            radiusY: radius
        });
        var path = Path$7.fromArc(arc, options).close();

        if (innerRadius) {
            arc.radiusX = arc.radiusY = innerRadius;
            var innerEnd = arc.pointAt(endAngle);
            path.lineTo(innerEnd.x, innerEnd.y);
            path.arc(endAngle, startAngle, innerRadius, innerRadius, true);
        } else {
            path.lineTo(center.x, center.y);
        }

        return path;
    };

    return ShapeBuilder;
}(Class));

ShapeBuilder.current = new ShapeBuilder();

var ChartElement = (function (Class) {
    function ChartElement(options) {
        Class.call(this);

        this.children = [];

        this.options = deepExtend({}, this.options, this.initUserOptions(options));
    }

    if ( Class ) ChartElement.__proto__ = Class;
    ChartElement.prototype = Object.create( Class && Class.prototype );
    ChartElement.prototype.constructor = ChartElement;

    ChartElement.prototype.initUserOptions = function initUserOptions (options) {
        return options;
    };

    ChartElement.prototype.reflow = function reflow (targetBox) {
        var children = this.children;
        var box;

        for (var i = 0; i < children.length; i++) {
            var currentChild = children[i];
            currentChild.reflow(targetBox);

            box = box ? box.wrap(currentChild.box) : currentChild.box.clone();
        }

        this.box = box || targetBox;
    };

    ChartElement.prototype.destroy = function destroy () {
        var children = this.children;

        if (this.animation) {
            this.animation.destroy();
        }

        for (var i = 0; i < children.length; i++) {
            children[i].destroy();
        }
    };

    ChartElement.prototype.getRoot = function getRoot () {
        var parent = this.parent;

        return parent ? parent.getRoot() : null;
    };

    ChartElement.prototype.getSender = function getSender () {
        var service = this.getService();
        if (service) {
            return service.sender;
        }
    };

    ChartElement.prototype.getService = function getService () {
        var element = this;
        while (element) {
            if (element.chartService) {
                return element.chartService;
            }
            element = element.parent;
        }
    };

    ChartElement.prototype.translateChildren = function translateChildren (dx, dy) {
        var children = this.children;
        var childrenCount = children.length;

        for (var i = 0; i < childrenCount; i++) {
            children[i].box.translate(dx, dy);
        }
    };

    ChartElement.prototype.append = function append () {
        var arguments$1 = arguments;
        var this$1$1 = this;

        for (var i = 0; i < arguments.length; i++) {
            var item = arguments$1[i];
            this$1$1.children.push(item);
            item.parent = this$1$1;
        }
    };

    ChartElement.prototype.renderVisual = function renderVisual () {
        if (this.options.visible === false) {
            return;
        }

        this.createVisual();

        this.addVisual();

        this.renderChildren();

        this.createAnimation();
        this.renderComplete();
    };

    ChartElement.prototype.addVisual = function addVisual () {
        if (this.visual) {
            this.visual.chartElement = this;

            if (this.parent) {
                this.parent.appendVisual(this.visual);
            }
        }
    };

    ChartElement.prototype.renderChildren = function renderChildren () {
        var children = this.children;
        var length = children.length;
        for (var i = 0; i < length; i++) {
            children[i].renderVisual();
        }
    };

    ChartElement.prototype.createVisual = function createVisual () {
        this.visual = new Group$8({
            zIndex: this.options.zIndex,
            visible: valueOrDefault(this.options.visible, true)
        });
    };

    ChartElement.prototype.createAnimation = function createAnimation () {
        if (this.visual && this.options.animation) {
            this.animation = Animation$1.create(
                this.visual, this.options.animation
            );
        }
    };

    ChartElement.prototype.appendVisual = function appendVisual (childVisual) {
        if (!childVisual.chartElement) {
            childVisual.chartElement = this;
        }

        if (childVisual.options.noclip) {
            this.clipRoot().visual.append(childVisual);
        } else if (defined(childVisual.options.zIndex)) {
            this.stackRoot().stackVisual(childVisual);
        } else if (this.isStackRoot) {
            this.stackVisual(childVisual);
        } else if (this.visual) {
            this.visual.append(childVisual);
        } else {
            // Allow chart elements without visuals to
            // pass through child visuals
            this.parent.appendVisual(childVisual);
        }
    };

    ChartElement.prototype.clipRoot = function clipRoot () {
        if (this.parent) {
            return this.parent.clipRoot();
        }

        return this;
    };

    ChartElement.prototype.stackRoot = function stackRoot () {
        if (this.parent) {
            return this.parent.stackRoot();
        }

        return this;
    };

    ChartElement.prototype.stackVisual = function stackVisual (childVisual) {
        var zIndex = childVisual.options.zIndex || 0;
        var visuals = this.visual.children;
        var length = visuals.length;
        var pos;

        for (pos = 0; pos < length; pos++) {
            var sibling = visuals[pos];
            var here = valueOrDefault(sibling.options.zIndex, 0);
            if (here > zIndex) {
                break;
            }
        }

        this.visual.insert(pos, childVisual);
    };

    ChartElement.prototype.traverse = function traverse (callback) {
        var children = this.children;
        var length = children.length;

        for (var i = 0; i < length; i++) {
            var child = children[i];

            callback(child);
            if (child.traverse) {
                child.traverse(callback);
            }
        }
    };

    ChartElement.prototype.closest = function closest (match) {
        var element = this;
        var matched = false;

        while (element && !matched) {
            matched = match(element);

            if (!matched) {
                element = element.parent;
            }
        }

        if (matched) {
            return element;
        }
    };

    ChartElement.prototype.renderComplete = function renderComplete () {};

    ChartElement.prototype.hasHighlight = function hasHighlight () {
        var options = (this.options || {}).highlight;
        return !(!this.createHighlight || (options && options.visible === false) || this.visible === false);
    };

    ChartElement.prototype.toggleHighlight = function toggleHighlight (show, opacity) {
        var this$1$1 = this;

        var options = (this.options || {}).highlight || {};
        var customVisual = options.visual;
        var highlight = this._highlight;

        if (!highlight) {
            var highlightOptions = {
                fill: {
                    color: WHITE$1,
                    opacity: opacity || 0.2
                },
                stroke: {
                    color: WHITE$1,
                    width: 1,
                    opacity: opacity || 0.2
                }
            };

            if (customVisual) {
                highlight = this._highlight = customVisual(
                    Object.assign(this.highlightVisualArgs(), {
                        createVisual: function () { return this$1$1.createHighlight(highlightOptions); },
                        sender: this.getSender(),
                        series: this.series,
                        dataItem: this.dataItem,
                        category: this.category,
                        value: this.value,
                        percentage: this.percentage,
                        runningTotal: this.runningTotal,
                        total: this.total
                    })
                );

                if (!highlight) {
                    return;
                }
            } else {
                highlight = this._highlight = this.createHighlight(highlightOptions);
            }

            if (!defined(highlight.options.zIndex)) {
                highlight.options.zIndex = valueOrDefault(options.zIndex, this.options.zIndex);
            }

            this.appendVisual(highlight);
        }

        highlight.visible(show);
    };

    ChartElement.prototype.toggleFocusHighlight = function toggleFocusHighlight (show) {
        var options = (this.options || {}).focusHighlight || {};
        var focusHighlight = this._focusHighlight;

        if (!show && !focusHighlight) {
            return;
        }

        if (!focusHighlight) {
            var rootBackground = this.getRoot().options.background;
            var highlightColor = autoTextColor(rootBackground);
            var focusHighlightOptions = {
                fill: {
                    opacity: options.opacity,
                    color: options.color
                },
                stroke: Object.assign({}, {color: highlightColor}, options.border),
                zIndex: options.zIndex
            };

            focusHighlight = this._focusHighlight = this.createFocusHighlight(focusHighlightOptions);

            this.appendVisual(focusHighlight);
        }

        focusHighlight.visible(show);
    };

    ChartElement.prototype.createGradientOverlay = function createGradientOverlay (element, options, gradientOptions) {
        var overlay = new Path$7(Object.assign({
            stroke: {
                color: "none"
            },
            fill: this.createGradient(gradientOptions),
            closed: element.options.closed
        }, options));

        overlay.segments.elements(element.segments.elements());

        return overlay;
    };

    ChartElement.prototype.createGradient = function createGradient (options) {
        if (this.parent) {
            return this.parent.createGradient(options);
        }
    };

    ChartElement.prototype.supportsPointInactiveOpacity = function supportsPointInactiveOpacity () {
        return true;
    };

    return ChartElement;
}(Class));

ChartElement.prototype.options = { };

var dotsPattern = dotsPattern$1;
var verticalStripesPattern = verticalStripesPattern$1;
var crosshatchPattern = crosshatchPattern$1;
var diagonalStripesPattern = diagonalStripesPattern$1;
var gridPattern = gridPattern$1;

var patternMap = {
    dots: dotsPattern,
    verticalStripes: verticalStripesPattern,
    crosshatch: crosshatchPattern,
    diagonalStripes: diagonalStripesPattern,
    grid: gridPattern
};

function evaluatePattern(options, point) {
    return isFunction(options) ? options(point) : options;
}

function createPatternFill(options, fill, point) {
    var patternOptions = evaluatePattern(options, point);
    var pattern = patternOptions && patternMap[patternOptions.type];

    return pattern ? pattern(Object.assign({}, fill, patternOptions)) : fill;
}

var BoxElement = (function (ChartElement) {
    function BoxElement(options) {
        ChartElement.call(this, options);

        this.options.margin = getSpacing(this.options.margin);
        this.options.padding = getSpacing(this.options.padding);
    }

    if ( ChartElement ) BoxElement.__proto__ = ChartElement;
    BoxElement.prototype = Object.create( ChartElement && ChartElement.prototype );
    BoxElement.prototype.constructor = BoxElement;

    BoxElement.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        var options = this.options;
        var width = options.width;
        var height = options.height;
        var shrinkToFit = options.shrinkToFit;
        var hasSetSize = width && height;
        var margin = options.margin;
        var padding = options.padding;
        var borderWidth = options.border.width;
        var box;

        var reflowPaddingBox = function () {
            this$1$1.align(targetBox, X, options.align);
            this$1$1.align(targetBox, Y, options.vAlign);
            this$1$1.paddingBox = box.clone().unpad(margin).unpad(borderWidth);
        };

        var contentBox = targetBox.clone();
        if (hasSetSize) {
            contentBox.x2 = contentBox.x1 + width;
            contentBox.y2 = contentBox.y1 + height;
        }

        if (shrinkToFit) {
            contentBox.unpad(margin).unpad(borderWidth).unpad(padding);
        }

        ChartElement.prototype.reflow.call(this, contentBox);

        if (hasSetSize) {
            box = this.box = new Box(0, 0, width, height);
        } else {
            box = this.box;
        }

        if (shrinkToFit && hasSetSize) {
            reflowPaddingBox();
            contentBox = this.contentBox = this.paddingBox.clone().unpad(padding);
        } else {
            contentBox = this.contentBox = box.clone();
            box.pad(padding).pad(borderWidth).pad(margin);
            reflowPaddingBox();
        }

        this.translateChildren(
            box.x1 - contentBox.x1 + margin.left + borderWidth + padding.left,
            box.y1 - contentBox.y1 + margin.top + borderWidth + padding.top
        );

        var children = this.children;
        for (var i = 0; i < children.length; i++) {
            var item = children[i];
            item.reflow(item.box);
        }
    };

    BoxElement.prototype.align = function align (targetBox, axis, alignment) {
        this.box.align(targetBox, axis, alignment);
    };

    BoxElement.prototype.hasBox = function hasBox () {
        var options = this.options;
        return options.border.width || options.background;
    };

    BoxElement.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        var options = this.options;
        if (options.visible && this.hasBox()) {
            this.visual.append(Path$7.fromRect(
                this.paddingBox.toRect(),
                this.visualStyle()
            ));
        }
    };

    BoxElement.prototype.visualStyle = function visualStyle () {
        var options = this.options;
        var border = options.border || {};

        return {
            stroke: {
                width: border.width,
                color: border.color,
                opacity: valueOrDefault(border.opacity, options.opacity),
                dashType: border.dashType
            },
            fill: createPatternFill(options.pattern, {
                color: options.background,
                opacity: options.opacity
            }, undefined),
            cursor: options.cursor
        };
    };

    return BoxElement;
}(ChartElement));

setDefaultOptions(BoxElement, {
    align: LEFT,
    vAlign: TOP,
    margin: {},
    padding: {},
    border: {
        color: BLACK$1,
        width: 0
    },
    background: "",
    shrinkToFit: false,
    width: 0,
    height: 0,
    visible: true
});

function addAccessibilityAttributesToVisual(visual, accessibilityOptions) {
    if (accessibilityOptions) {
        visual.options.className = accessibilityOptions.className;
        visual.options.role = accessibilityOptions.role;
        visual.options.ariaLabel = accessibilityOptions.ariaLabel;
        visual.options.ariaRoleDescription = accessibilityOptions.ariaRoleDescription;
        visual.options.ariaChecked = accessibilityOptions.ariaChecked;
    }
}

var ShapeElement = (function (BoxElement) {
    function ShapeElement(options, pointData) {
        BoxElement.call(this, options);

        this.pointData = pointData;
    }

    if ( BoxElement ) ShapeElement.__proto__ = BoxElement;
    ShapeElement.prototype = Object.create( BoxElement && BoxElement.prototype );
    ShapeElement.prototype.constructor = ShapeElement;

    ShapeElement.prototype.getElement = function getElement () {
        var ref = this;
        var options = ref.options;
        var box = ref.paddingBox;
        var type = options.type;
        var rotation = options.rotation;
        var center = box.center();
        var halfWidth = box.width() / 2;
        var halfHeight = box.height() / 2;

        if (!options.visible || !this.hasBox()) {
            return null;
        }

        var style = this.visualStyle();
        var element;

        if (type === CIRCLE) {
            element = new Circle$1(
                new Circle$2([
                    round$1(box.x1 + halfWidth, COORD_PRECISION),
                    round$1(box.y1 + halfHeight, COORD_PRECISION)
                ], Math.min(halfWidth, halfHeight)),
                style
            );
        } else if (type === TRIANGLE) {
            element = Path$7.fromPoints([
                [ box.x1 + halfWidth, box.y1 ],
                [ box.x1, box.y2 ],
                [ box.x2, box.y2 ]
            ], style).close();
        } else if (type === CROSS) {
            element = new MultiPath(style);

            element.moveTo(box.x1, box.y1).lineTo(box.x2, box.y2);
            element.moveTo(box.x1, box.y2).lineTo(box.x2, box.y1);
        } else {
            var rect = box.toRect();
            if (type === ROUNDED_RECT) {
                var borderRadius = valueOrDefault(options.borderRadius, rect.width() / 5);
                rect.setCornerRadius(borderRadius);
            }

            element = Path$7.fromRect(rect, style);
        }

        if (rotation) {
            element.transform(transform()
                .rotate(-rotation, [ center.x, center.y ])
            );
        }

        element.options.zIndex = options.zIndex;

        return element;
    };

    ShapeElement.prototype.createElement = function createElement () {
        var this$1$1 = this;

        var customVisual = this.options.visual;
        var pointData = this.pointData || {};
        var visual;

        if (customVisual) {
            visual = customVisual({
                value: pointData.value,
                dataItem: pointData.dataItem,
                sender: this.getSender(),
                series: pointData.series,
                category: pointData.category,
                rect: this.paddingBox.toRect(),
                options: this.visualOptions(),
                createVisual: function () { return this$1$1.getElement(); }
            });
        } else {
            visual = this.getElement();
        }

        return visual;
    };

    ShapeElement.prototype.visualOptions = function visualOptions () {
        var options = this.options;
        return {
            background: options.background,
            border: options.border,
            margin: options.margin,
            padding: options.padding,
            type: options.type,
            size: options.width,
            visible: options.visible
        };
    };

    ShapeElement.prototype.createVisual = function createVisual () {
        this.visual = this.createElement();

        addAccessibilityAttributesToVisual(this.visual, this.options.accessibilityOptions);
    };

    return ShapeElement;
}(BoxElement));

setDefaultOptions(ShapeElement, {
    type: CIRCLE,
    align: CENTER,
    vAlign: CENTER
});

var LINEAR$1 = "linear";
var RADIAL = "radial";

var GRADIENTS = {
    glass: {
        type: LINEAR$1,
        rotation: 0,
        stops: [ {
            offset: 0,
            color: WHITE$1,
            opacity: 0
        }, {
            offset: 0.25,
            color: WHITE$1,
            opacity: 0.3
        }, {
            offset: 1,
            color: WHITE$1,
            opacity: 0
        } ]
    },
    sharpBevel: {
        type: RADIAL,
        stops: [ {
            offset: 0,
            color: WHITE$1,
            opacity: 0.55
        }, {
            offset: 0.65,
            color: WHITE$1,
            opacity: 0
        }, {
            offset: 0.95,
            color: WHITE$1,
            opacity: 0.25
        } ]
    },
    roundedBevel: {
        type: RADIAL,
        stops: [ {
            offset: 0.33,
            color: WHITE$1,
            opacity: 0.06
        }, {
            offset: 0.83,
            color: WHITE$1,
            opacity: 0.2
        }, {
            offset: 0.95,
            color: WHITE$1,
            opacity: 0
        } ]
    },
    roundedGlass: {
        type: RADIAL,
        supportVML: false,
        stops: [ {
            offset: 0,
            color: WHITE$1,
            opacity: 0
        }, {
            offset: 0.5,
            color: WHITE$1,
            opacity: 0.3
        }, {
            offset: 0.99,
            color: WHITE$1,
            opacity: 0
        } ]
    },
    sharpGlass: {
        type: RADIAL,
        supportVML: false,
        stops: [ {
            offset: 0,
            color: WHITE$1,
            opacity: 0.2
        }, {
            offset: 0.15,
            color: WHITE$1,
            opacity: 0.15
        }, {
            offset: 0.17,
            color: WHITE$1,
            opacity: 0.35
        }, {
            offset: 0.85,
            color: WHITE$1,
            opacity: 0.05
        }, {
            offset: 0.87,
            color: WHITE$1,
            opacity: 0.15
        }, {
            offset: 0.99,
            color: WHITE$1,
            opacity: 0
        } ]
    },
    bubbleShadow: {
        type: RADIAL,
        center: [ 0.5, 0.5 ],
        radius: 0.5
    }
};

function boxDiff(r, s) {
    if (r.x1 === s.x1 && r.y1 === s.y1 && r.x2 === s.x2 && r.y2 === s.y2) {
        return s;
    }

    var a = Math.min(r.x1, s.x1);
    var b = Math.max(r.x1, s.x1);
    var c = Math.min(r.x2, s.x2);
    var d = Math.max(r.x2, s.x2);
    var e = Math.min(r.y1, s.y1);
    var f = Math.max(r.y1, s.y1);
    var g = Math.min(r.y2, s.y2);
    var h = Math.max(r.y2, s.y2);
    var boxes = [];

    // X = intersection, 0-7 = possible difference areas
    // h +-+-+-+
    // . |5|6|7|
    // g +-+-+-+
    // . |3|X|4|
    // f +-+-+-+
    // . |0|1|2|
    // e +-+-+-+
    // . a b c d

    // we'll always have rectangles 1, 3, 4 and 6
    boxes[0] = new Box(b, e, c, f);
    boxes[1] = new Box(a, f, b, g);
    boxes[2] = new Box(c, f, d, g);
    boxes[3] = new Box(b, g, c, h);

    // decide which corners
    if (r.x1 === a && r.y1 === e || s.x1 === a && s.y1 === e) { // corners 0 and 7
        boxes[4] = new Box(a, e, b, f);
        boxes[5] = new Box(c, g, d, h);
    } else { // corners 2 and 5
        boxes[4] = new Box(c, e, d, f);
        boxes[5] = new Box(a, g, b, h);
    }

    return grep(boxes, function(box) {
        return box.height() > 0 && box.width() > 0;
    })[0];
}

var RootElement = (function (ChartElement) {
    function RootElement(options) {
        ChartElement.call(this, options);

        var rootOptions = this.options;
        rootOptions.width = parseInt(rootOptions.width, 10);
        rootOptions.height = parseInt(rootOptions.height, 10);

        this.gradients = {};
    }

    if ( ChartElement ) RootElement.__proto__ = ChartElement;
    RootElement.prototype = Object.create( ChartElement && ChartElement.prototype );
    RootElement.prototype.constructor = RootElement;

    RootElement.prototype.reflow = function reflow () {
        var ref = this;
        var options = ref.options;
        var children = ref.children;
        var currentBox = new Box(0, 0, options.width, options.height);

        this.box = currentBox.unpad(options.margin);

        for (var i = 0; i < children.length; i++) {
            children[i].reflow(currentBox);
            currentBox = boxDiff(currentBox, children[i].box) || new Box();
        }
    };

    RootElement.prototype.createVisual = function createVisual () {
        this.visual = new Group$8();
        this.createBackground();
    };

    RootElement.prototype.createBackground = function createBackground () {
        var options = this.options;
        var border = options.border || {};
        var box = this.box.clone().pad(options.margin).unpad(border.width);

        var background = Path$7.fromRect(box.toRect(), {
            stroke: {
                color: border.width ? border.color : "",
                width: border.width,
                dashType: border.dashType
            },
            fill: {
                color: options.background,
                opacity: options.opacity
            },
            zIndex: -10
        });

        this.visual.append(background);
    };

    RootElement.prototype.getRoot = function getRoot () {
        return this;
    };

    RootElement.prototype.createGradient = function createGradient (options) {
        var gradients = this.gradients;
        var hashCode = objectKey(options);
        var gradient = GRADIENTS[options.gradient];
        var drawingGradient;

        if (gradients[hashCode]) {
            drawingGradient = gradients[hashCode];
        } else {
            var gradientOptions = Object.assign({}, gradient, options);
            if (gradient.type === "linear") {
                drawingGradient = new LinearGradient(gradientOptions);
            } else {
                if (options.innerRadius) {
                    gradientOptions.stops = innerRadialStops(gradientOptions);
                }
                drawingGradient = new RadialGradient(gradientOptions);
                drawingGradient.supportVML = gradient.supportVML !== false;
            }
            gradients[hashCode] = drawingGradient;
        }

        return drawingGradient;
    };

    RootElement.prototype.cleanGradients = function cleanGradients () {
        var gradients = this.gradients;
        for (var hashCode in gradients) {
            gradients[hashCode]._observers = [];//add clear observers method in drawing ObserversMixin
        }
    };

    RootElement.prototype.size = function size () {
        var options = this.options;
        return new Box(0, 0, options.width, options.height);
    };

    return RootElement;
}(ChartElement));

setDefaultOptions(RootElement, {
    width: DEFAULT_WIDTH$1,
    height: DEFAULT_HEIGHT$1,
    background: WHITE$1,
    border: {
        color: BLACK$1,
        width: 0
    },
    margin: getSpacing(5),
    zIndex: -2
});

function innerRadialStops(options) {
    var stops = options.stops;
    var usedSpace = ((options.innerRadius / options.radius) * 100);
    var length = stops.length;
    var currentStops = [];

    for (var i = 0; i < length; i++) {
        var currentStop = Object.assign({}, stops[i]);
        currentStop.offset = (currentStop.offset * (100 - usedSpace) + usedSpace) / 100;
        currentStops.push(currentStop);
    }

    return currentStops;
}

var FloatElement = (function (ChartElement) {
    function FloatElement(options) {
        ChartElement.call(this, options);
        this._initDirection();
    }

    if ( ChartElement ) FloatElement.__proto__ = ChartElement;
    FloatElement.prototype = Object.create( ChartElement && ChartElement.prototype );
    FloatElement.prototype.constructor = FloatElement;

    FloatElement.prototype._initDirection = function _initDirection () {
        var options = this.options;
        if (options.vertical) {
            this.groupAxis = X;
            this.elementAxis = Y;
            this.groupSizeField = WIDTH;
            this.elementSizeField = HEIGHT;
            this.groupSpacing = options.spacing;
            this.elementSpacing = options.vSpacing;
        } else {
            this.groupAxis = Y;
            this.elementAxis = X;
            this.groupSizeField = HEIGHT;
            this.elementSizeField = WIDTH;
            this.groupSpacing = options.vSpacing;
            this.elementSpacing = options.spacing;
        }
    };

    FloatElement.prototype.reflow = function reflow (targetBox) {
        this.box = targetBox.clone();
        this.reflowChildren();
    };

    FloatElement.prototype.reflowChildren = function reflowChildren () {
        var this$1$1 = this;

        var ref = this;
        var box = ref.box;
        var elementAxis = ref.elementAxis;
        var groupAxis = ref.groupAxis;
        var elementSizeField = ref.elementSizeField;
        var groupSizeField = ref.groupSizeField;
        var ref$1 = this.groupOptions();
        var groups = ref$1.groups;
        var groupsSize = ref$1.groupsSize;
        var maxGroupElementsSize = ref$1.maxGroupElementsSize;
        var groupsCount = groups.length;
        var groupsStart = box[groupAxis + 1] + this.alignStart(groupsSize, box[groupSizeField]());

        if (groupsCount) {
            var groupStart = groupsStart;

            for (var groupIdx = 0; groupIdx < groupsCount; groupIdx++) {
                var group = groups[groupIdx];
                var groupElements = group.groupElements;
                var elementStart = box[elementAxis + 1];
                var groupElementsCount = groupElements.length;

                for (var idx = 0; idx < groupElementsCount; idx++) {
                    var element = groupElements[idx];
                    var elementSize = this$1$1.elementSize(element);
                    var groupElementStart = groupStart + this$1$1.alignStart(elementSize[groupSizeField], group.groupSize);

                    var elementBox = new Box();
                    elementBox[groupAxis + 1] = groupElementStart;
                    elementBox[groupAxis + 2] = groupElementStart + elementSize[groupSizeField];
                    elementBox[elementAxis + 1] = elementStart;
                    elementBox[elementAxis + 2] = elementStart + elementSize[elementSizeField];

                    element.reflow(elementBox);

                    elementStart += elementSize[elementSizeField] + this$1$1.elementSpacing;
                }
                groupStart += group.groupSize + this$1$1.groupSpacing;
            }
            box[groupAxis + 1] = groupsStart;
            box[groupAxis + 2] = groupsStart + groupsSize;
            box[elementAxis + 2] = box[elementAxis + 1] + maxGroupElementsSize;
        }
    };

    FloatElement.prototype.alignStart = function alignStart (size, maxSize) {
        var start = 0;
        var align = this.options.align;
        if (align === RIGHT || align === BOTTOM$1) {
            start = maxSize - size;
        } else if (align === CENTER) {
            start = (maxSize - size) / 2;
        }
        return start;
    };

    FloatElement.prototype.groupOptions = function groupOptions () {
        var this$1$1 = this;

        var ref = this;
        var box = ref.box;
        var children = ref.children;
        var elementSizeField = ref.elementSizeField;
        var groupSizeField = ref.groupSizeField;
        var elementSpacing = ref.elementSpacing;
        var groupSpacing = ref.groupSpacing;
        var maxSize = round$1(box[elementSizeField]());
        var childrenCount = children.length;
        var groups = [];

        var groupSize = 0;
        var groupElementsSize = 0;
        var groupsSize = 0;
        var maxGroupElementsSize = 0;
        var groupElements = [];

        for (var idx = 0; idx < childrenCount; idx++) {
            var element = children[idx];
            if (!element.box) {
                element.reflow(box);
            }

            var elementSize = this$1$1.elementSize(element);
            if (this$1$1.options.wrap && round$1(groupElementsSize + elementSpacing + elementSize[elementSizeField]) > maxSize) {
                groups.push({
                    groupElements: groupElements,
                    groupSize: groupSize,
                    groupElementsSize: groupElementsSize
                });
                maxGroupElementsSize = Math.max(maxGroupElementsSize, groupElementsSize);
                groupsSize += groupSpacing + groupSize;
                groupSize = 0;
                groupElementsSize = 0;
                groupElements = [];
            }
            groupSize = Math.max(groupSize, elementSize[groupSizeField]);
            if (groupElementsSize > 0) {
                groupElementsSize += elementSpacing;
            }
            groupElementsSize += elementSize[elementSizeField];
            groupElements.push(element);
        }

        groups.push({
            groupElements: groupElements,
            groupSize: groupSize,
            groupElementsSize: groupElementsSize
        });
        maxGroupElementsSize = Math.max(maxGroupElementsSize, groupElementsSize);
        groupsSize += groupSize;

        return {
            groups: groups,
            groupsSize: groupsSize,
            maxGroupElementsSize: maxGroupElementsSize
        };
    };

    FloatElement.prototype.elementSize = function elementSize (element) {
        return {
            width: element.box.width(),
            height: element.box.height()
        };
    };

    FloatElement.prototype.createVisual = function createVisual () {};

    return FloatElement;
}(ChartElement));

setDefaultOptions(FloatElement, {
    vertical: true,
    wrap: true,
    vSpacing: 0,
    spacing: 0
});

var DrawingText = Text$2;

var Text$1 = (function (ChartElement) {
    function Text(content, options) {
        ChartElement.call(this, options);

        this.content = content;

        // Calculate size
        this.reflow(new Box());
    }

    if ( ChartElement ) Text.__proto__ = ChartElement;
    Text.prototype = Object.create( ChartElement && ChartElement.prototype );
    Text.prototype.constructor = Text;

    Text.prototype.reflow = function reflow (targetBox) {
        var options = this.options;
        var size = options.size = measureText(this.content, { font: options.font });

        this.baseline = size.baseline;

        this.box = new Box(targetBox.x1, targetBox.y1,
            targetBox.x1 + size.width, targetBox.y1 + size.height);
    };

    Text.prototype.createVisual = function createVisual () {
        var ref = this.options;
        var font = ref.font;
        var color = ref.color;
        var opacity = ref.opacity;
        var cursor = ref.cursor;
        var stroke = ref.stroke;
        var paintOrder = ref.paintOrder;

        this.visual = new DrawingText(this.content, this.box.toRect().topLeft(), {
            font: font,
            fill: { color: color, opacity: opacity },
            cursor: cursor,
            stroke: stroke,
            paintOrder: paintOrder
        });
    };

    return Text;
}(ChartElement));

setDefaultOptions(Text$1, {
    font: DEFAULT_FONT,
    color: BLACK$1
});

function rectToBox(rect) {
    var origin = rect.origin;
    var bottomRight = rect.bottomRight();

    return new Box(origin.x, origin.y, bottomRight.x, bottomRight.y);
}

var ROWS_SPLIT_REGEX = /\n/m;

var TextBox = (function (BoxElement) {
    function TextBox(content, options, data) {
        BoxElement.call(this, options);
        this.content = content;
        this.data = data;

        this._initContainer();
        if (this.options._autoReflow !== false) {
            this.reflow(new Box());
        }
    }

    if ( BoxElement ) TextBox.__proto__ = BoxElement;
    TextBox.prototype = Object.create( BoxElement && BoxElement.prototype );
    TextBox.prototype.constructor = TextBox;

    TextBox.prototype._initContainer = function _initContainer () {
        var options = this.options;
        var rows = String(this.content).split(ROWS_SPLIT_REGEX);
        var floatElement = new FloatElement({ vertical: true, align: options.align, wrap: false });
        var textOptions = deepExtend({ }, options, { opacity: 1, animation: null });

        this.container = floatElement;
        this.append(floatElement);

        for (var rowIdx = 0; rowIdx < rows.length; rowIdx++) {
            var text = new Text$1(rows[rowIdx].trim(), textOptions);
            floatElement.append(text);
        }
    };

    TextBox.prototype.reflow = function reflow (targetBox) {
        var options = this.options;
        var visualFn = options.visual;
        this.container.options.align = options.align;

        if (visualFn && !this._boxReflow) {
            var visualBox = targetBox;
            if (!visualBox.hasSize()) {
                this._boxReflow = true;
                this.reflow(visualBox);
                this._boxReflow = false;
                visualBox = this.box;
            }
            var visual = this.visual = visualFn(this.visualContext(visualBox));

            if (visual) {
                visualBox = rectToBox(visual.clippedBBox() || new Rect());

                visual.options.zIndex = options.zIndex;
            }

            this.box = this.contentBox = this.paddingBox = visualBox;
        } else {
            BoxElement.prototype.reflow.call(this, targetBox);

            if (options.rotation) {
                var margin = getSpacing(options.margin);
                var box = this.box.unpad(margin);

                this.targetBox = targetBox;
                this.normalBox = box.clone();

                box = this.rotate();
                box.translate(margin.left - margin.right, margin.top - margin.bottom);

                this.rotatedBox = box.clone();

                box.pad(margin);
            }
        }
    };

    TextBox.prototype.createVisual = function createVisual () {
        var options = this.options;

        this.visual = new Group$8({
            transform: this.rotationTransform(),
            zIndex: options.zIndex,
            noclip: options.noclip
        });

        if (this.hasBox()) {
            var box = Path$7.fromRect(this.paddingBox.toRect(), this.visualStyle());
            this.visual.append(box);
        }
    };

    TextBox.prototype.renderVisual = function renderVisual () {
        if (!this.options.visible) {
            return;
        }

        if (this.options.visual) {
            var visual = this.visual;
            if (visual && !defined(visual.options.noclip)) {
                visual.options.noclip = this.options.noclip;
            }
            this.addVisual();
            this.createAnimation();
        } else {
            BoxElement.prototype.renderVisual.call(this);
        }
    };

    TextBox.prototype.visualContext = function visualContext (targetBox) {
        var this$1$1 = this;

        var context = {
            text: this.content,
            rect: targetBox.toRect(),
            sender: this.getSender(),
            options: this.options,
            createVisual: function () {
                this$1$1._boxReflow = true;
                this$1$1.reflow(targetBox);
                this$1$1._boxReflow = false;
                return this$1$1.getDefaultVisual();
            }
        };
        if (this.data) {
            Object.assign(context, this.data);
        }

        return context;
    };

    TextBox.prototype.getDefaultVisual = function getDefaultVisual () {
        this.createVisual();
        this.renderChildren();
        var visual = this.visual;
        delete this.visual;
        return visual;
    };

    TextBox.prototype.rotate = function rotate () {
        var options = this.options;
        this.box.rotate(options.rotation);
        this.align(this.targetBox, X, options.align);
        this.align(this.targetBox, Y, options.vAlign);
        return this.box;
    };

    TextBox.prototype.rotationTransform = function rotationTransform () {
        var rotation = this.options.rotation;
        if (!rotation) {
            return null;
        }

        var ref = this.normalBox.center();
        var cx = ref.x;
        var cy = ref.y;
        var boxCenter = this.rotatedBox.center();

        return transform()
            .translate(boxCenter.x - cx, boxCenter.y - cy)
            .rotate(rotation, [ cx, cy ]);
    };

    return TextBox;
}(BoxElement));

var Title$1 = (function (ChartElement) {
    function Title(options) {
        ChartElement.call(this, options);

        this._textBox = new TextBox(this.options.text, Object.assign({}, this.options, {
            vAlign: this.options.position
        }));

        this.append(this._textBox);
    }

    if ( ChartElement ) Title.__proto__ = ChartElement;
    Title.prototype = Object.create( ChartElement && ChartElement.prototype );
    Title.prototype.constructor = Title;

    Title.prototype.reflow = function reflow (targetBox) {
        ChartElement.prototype.reflow.call(this, targetBox);
        this.box.snapTo(targetBox, X);
    };

    Title.buildTitle = function buildTitle (options, defaultOptions) {
        var titleOptions = options;

        if (typeof options === "string") {
            titleOptions = { text: options };
        }

        titleOptions = Object.assign({ visible: true }, defaultOptions, titleOptions);

        var title;
        if (titleOptions && titleOptions.visible && titleOptions.text) {
            title = new Title(titleOptions);
        }

        return title;
    };

    Title.orderTitles = function orderTitles (titles) {
        var items = [].concat(titles);
        var top = items.filter(function (item) { return item && item.options.position !== BOTTOM$1; });
        var bottom = items.filter(function (item) { return item && item.options.position === BOTTOM$1; });

        collapseVerticalMargins(top);
        collapseVerticalMargins(bottom);

        bottom.reverse();
        return top.concat(bottom);
    };

    return Title;
}(ChartElement));

function collapseVerticalMargins(items) {
    for (var i = 1; i < items.length; i++) {
        var box = items[i]._textBox;
        var prevBox = items[i - 1]._textBox;
        prevBox.options.margin = Object.assign(getSpacing(prevBox.options.margin), { bottom: 0 });
        box.options.margin = Object.assign(getSpacing(box.options.margin), { top: 0 });
    }
}

setDefaultOptions(Title$1, {
    color: BLACK$1,
    position: TOP,
    align: CENTER,
    margin: getSpacing(5),
    padding: getSpacing(5)
});

var AxisLabel = (function (TextBox) {
    function AxisLabel(value, text, index, dataItem, options) {
        TextBox.call(this, text, options);

        this.text = text;
        this.value = value;
        this.index = index;
        this.dataItem = dataItem;
        this.reflow(new Box());
    }

    if ( TextBox ) AxisLabel.__proto__ = TextBox;
    AxisLabel.prototype = Object.create( TextBox && TextBox.prototype );
    AxisLabel.prototype.constructor = AxisLabel;

    AxisLabel.prototype.visualContext = function visualContext (targetBox) {
        var context = TextBox.prototype.visualContext.call(this, targetBox);

        context.value = this.value;
        context.dataItem = this.dataItem;
        context.format = this.options.format;
        context.culture = this.options.culture;

        return context;
    };

    AxisLabel.prototype.click = function click (widget, e) {

        widget.trigger(AXIS_LABEL_CLICK, {
            element: eventElement(e),
            value: this.value,
            text: this.text,
            index: this.index,
            dataItem: this.dataItem,
            axis: this.parent.options
        });
    };

    AxisLabel.prototype.rotate = function rotate () {
        if (this.options.alignRotation !== CENTER) {
            var box = this.normalBox.toRect();
            var transform = this.rotationTransform();

            this.box = rectToBox(box.bbox(transform.matrix()));
        } else {
            TextBox.prototype.rotate.call(this);
        }

        return this.box;
    };

    AxisLabel.prototype.rotationTransform = function rotationTransform () {
        var options = this.options;
        var rotation = options.rotation;
        if (!rotation) {
            return null;
        }

        if (options.alignRotation === CENTER) {
            return TextBox.prototype.rotationTransform.call(this);
        }

        var rotationMatrix = transform().rotate(rotation).matrix();
        var box = this.normalBox.toRect();
        var rect = this.targetBox.toRect();

        var rotationOrigin = options.rotationOrigin || TOP;
        var alignAxis = rotationOrigin === TOP || rotationOrigin === BOTTOM$1 ? X : Y;
        var distanceAxis = rotationOrigin === TOP || rotationOrigin === BOTTOM$1 ? Y : X;
        var axisAnchor = rotationOrigin === TOP || rotationOrigin === LEFT ? rect.origin : rect.bottomRight();

        var topLeft = box.topLeft().transformCopy(rotationMatrix);
        var topRight = box.topRight().transformCopy(rotationMatrix);
        var bottomRight = box.bottomRight().transformCopy(rotationMatrix);
        var bottomLeft = box.bottomLeft().transformCopy(rotationMatrix);
        var rotatedBox = Rect.fromPoints(topLeft, topRight, bottomRight, bottomLeft);

        var translate = {};
        translate[distanceAxis] = rect.origin[distanceAxis] - rotatedBox.origin[distanceAxis];

        var distanceLeft = Math.abs(topLeft[distanceAxis] + translate[distanceAxis] - axisAnchor[distanceAxis]);
        var distanceRight = Math.abs(topRight[distanceAxis] + translate[distanceAxis] - axisAnchor[distanceAxis]);

        var alignStart, alignEnd;

        if (round$1(distanceLeft, DEFAULT_PRECISION) === round$1(distanceRight, DEFAULT_PRECISION)) {
            alignStart = topLeft;
            alignEnd = topRight;
        } else if (distanceRight < distanceLeft) {
            alignStart = topRight;
            alignEnd = bottomRight;
        } else {
            alignStart = topLeft;
            alignEnd = bottomLeft;
        }

        var alignCenter = alignStart[alignAxis] + (alignEnd[alignAxis] - alignStart[alignAxis]) / 2;
        translate[alignAxis] = rect.center()[alignAxis] - alignCenter;

        return transform()
            .translate(translate.x, translate.y)
            .rotate(rotation);
    };

    return AxisLabel;
}(TextBox));

setDefaultOptions(AxisLabel, {
    _autoReflow: false
});

var DEFAULT_ICON_SIZE = 7;
var DEFAULT_LABEL_COLOR = "#fff";

var Note = (function (BoxElement) {
    function Note(fields, options, chartService) {
        BoxElement.call(this, options);

        this.fields = fields;
        this.chartService = chartService;

        this.render();
    }

    if ( BoxElement ) Note.__proto__ = BoxElement;
    Note.prototype = Object.create( BoxElement && BoxElement.prototype );
    Note.prototype.constructor = Note;

    Note.prototype.hide = function hide () {
        this.options.visible = false;
    };

    Note.prototype.show = function show () {
        this.options.visible = true;
    };

    Note.prototype.render = function render () {
        var this$1$1 = this;

        var options = this.options;

        if (options.visible) {
            var label = options.label;
            var icon = options.icon;
            var box = new Box();
            var childAlias = function () { return this$1$1; };
            var size = icon.size;
            var text = this.fields.text;
            var width, height;

            if (defined(label) && label.visible) {
                var noteTemplate = getTemplate$1(label);
                if (noteTemplate) {
                    text = noteTemplate(this.fields);
                } else if (label.format) {
                    text = this.chartService.format.auto(label.format, text);
                }

                if (!label.color) {
                    label.color = label.position === INSIDE$2 ? DEFAULT_LABEL_COLOR : icon.background;
                }

                this.label = new TextBox(text, deepExtend({}, label));
                this.label.aliasFor = childAlias;

                if (label.position === INSIDE$2 && !defined(size)) {
                    if (icon.type === CIRCLE) {
                        size = Math.max(this.label.box.width(), this.label.box.height());
                    } else {
                        width = this.label.box.width();
                        height = this.label.box.height();
                    }
                    box.wrap(this.label.box);
                }
            }

            icon.width = width || size || DEFAULT_ICON_SIZE;
            icon.height = height || size || DEFAULT_ICON_SIZE;

            var marker = new ShapeElement(deepExtend({}, icon));
            marker.aliasFor = childAlias;

            this.marker = marker;
            this.append(marker);

            if (this.label) {
                this.append(this.label);
            }

            marker.reflow(new Box());
            this.wrapperBox = box.wrap(marker.box);
        }
    };

    Note.prototype.reflow = function reflow (targetBox) {
        var ref = this;
        var options = ref.options;
        var label = ref.label;
        var marker = ref.marker;
        var wrapperBox = ref.wrapperBox;
        var center = targetBox.center();
        var length = options.line.length;
        var position = options.position;

        // TODO: Review
        if (options.visible) {
            var lineStart, box, contentBox;

            if (inArray(position, [ LEFT, RIGHT ])) {
                if (position === LEFT) {
                    contentBox = wrapperBox.alignTo(targetBox, position).translate(-length, targetBox.center().y - wrapperBox.center().y);

                    if (options.line.visible) {
                        lineStart = [ targetBox.x1, center.y ];
                        this.linePoints = [
                            lineStart,
                            [ contentBox.x2, center.y ]
                        ];
                        box = contentBox.clone().wrapPoint(lineStart);
                    }
                } else {
                    contentBox = wrapperBox.alignTo(targetBox, position).translate(length, targetBox.center().y - wrapperBox.center().y);

                    if (options.line.visible) {
                        lineStart = [ targetBox.x2, center.y ];
                        this.linePoints = [
                            lineStart,
                            [ contentBox.x1, center.y ]
                        ];
                        box = contentBox.clone().wrapPoint(lineStart);
                    }
                }
            } else {
                if (position === BOTTOM$1) {
                    contentBox = wrapperBox.alignTo(targetBox, position).translate(targetBox.center().x - wrapperBox.center().x, length);

                    if (options.line.visible) {
                        lineStart = [ center.x, targetBox.y2 ];
                        this.linePoints = [
                            lineStart,
                            [ center.x, contentBox.y1 ]
                        ];
                        box = contentBox.clone().wrapPoint(lineStart);
                    }
                } else {
                    contentBox = wrapperBox.alignTo(targetBox, position).translate(targetBox.center().x - wrapperBox.center().x, -length);

                    if (options.line.visible) {
                        lineStart = [ center.x, targetBox.y1 ];
                        this.linePoints = [
                            lineStart,
                            [ center.x, contentBox.y2 ]
                        ];
                        box = contentBox.clone().wrapPoint(lineStart);
                    }
                }
            }

            if (marker) {
                marker.reflow(contentBox);
            }

            if (label) {
                label.reflow(contentBox);
                if (marker) {
                    if (options.label.position === OUTSIDE$1) {
                        label.box.alignTo(marker.box, position);
                    }
                    label.reflow(label.box);
                }
            }

            this.contentBox = contentBox;
            this.targetBox = targetBox;
            this.box = box || contentBox;
        }
    };

    Note.prototype.createVisual = function createVisual () {
        BoxElement.prototype.createVisual.call(this);
        this.visual.options.noclip = this.options.noclip;

        if (this.options.visible) {
            this.createLine();
        }
    };

    Note.prototype.renderVisual = function renderVisual () {
        var this$1$1 = this;

        var options = this.options;
        var customVisual = options.visual;
        if (options.visible && customVisual) {
            this.visual = customVisual(Object.assign(this.fields, {
                sender: this.getSender(),
                rect: this.targetBox.toRect(),
                options: {
                    background: options.background,
                    border: options.background,
                    icon: options.icon,
                    label: options.label,
                    line: options.line,
                    position: options.position,
                    visible: options.visible
                },
                createVisual: function () {
                    this$1$1.createVisual();
                    this$1$1.renderChildren();
                    var defaultVisual = this$1$1.visual;
                    delete this$1$1.visual;
                    return defaultVisual;
                }
            }));
            this.addVisual();
        } else {
            BoxElement.prototype.renderVisual.call(this);
        }
    };

    Note.prototype.createLine = function createLine () {
        var options = this.options.line;

        if (this.linePoints) {
            var path = Path$7.fromPoints(this.linePoints, {
                stroke: {
                    color: options.color,
                    width: options.width,
                    dashType: options.dashType
                }
            });

            alignPathToPixel(path);
            this.visual.append(path);
        }
    };

    Note.prototype.click = function click (widget, e) {
        var args = this.eventArgs(e);

        if (!widget.trigger(NOTE_CLICK, args)) {
            e.preventDefault();
        }
    };

    Note.prototype.over = function over (widget, e) {
        var args = this.eventArgs(e);

        if (!widget.trigger(NOTE_HOVER, args)) {
            e.preventDefault();
        }
    };

    Note.prototype.out = function out (widget, e) {
        var args = this.eventArgs(e);

        widget.trigger(NOTE_LEAVE, args);
    };

    Note.prototype.eventArgs = function eventArgs (e) {
        var options = this.options;

        return Object.assign(this.fields, {
            element: eventElement(e),
            text: defined(options.label) ? options.label.text : "",
            visual: this.visual
        });
    };

    return Note;
}(BoxElement));

setDefaultOptions(Note, {
    icon: {
        visible: true,
        type: CIRCLE
    },
    label: {
        position: INSIDE$2,
        visible: true,
        align: CENTER,
        vAlign: CENTER
    },
    line: {
        visible: true
    },
    visible: true,
    position: TOP,
    zIndex: 2
});

var defaultImplementation = {
    format: function (format, value) { return value; },

    toString: function (value) { return value; },

    parseDate: function (value) { return new Date(value); },

    firstDay: function () { return 0; }
};

var current$1 = defaultImplementation;

var IntlService = function IntlService () {};

var staticAccessors = { implementation: { configurable: true } };

IntlService.register = function register (userImplementation) {
    current$1 = userImplementation;
};

staticAccessors.implementation.get = function () {
    return current$1;
};

Object.defineProperties( IntlService, staticAccessors );

// eslint-disable-next-line no-useless-escape
var FORMAT_REPLACE_REGEX = /\{(\d+)(:[^\}]+)?\}/g;

var FormatService = function FormatService(intlService) {
    this._intlService = intlService;
};

var prototypeAccessors$1 = { intl: { configurable: true } };

prototypeAccessors$1.intl.get = function () {
    return this._intlService || IntlService.implementation;
};

prototypeAccessors$1.intl.set = function (value) {
    this._intlService = value;
};

FormatService.prototype.auto = function auto (formatString) {
        var values = [], len = arguments.length - 1;
        while ( len-- > 0 ) values[ len ] = arguments[ len + 1 ];

    var intl = this.intl;

    if (isString$1(formatString) && formatString.match(FORMAT_REGEX)) {
        return intl.format.apply(intl, [ formatString ].concat( values ));
    }

    return intl.toString(values[0], formatString);
};

FormatService.prototype.localeAuto = function localeAuto (formatString, values, locale) {
    var intl = this.intl;
    var result;

    if (isString$1(formatString) && formatString.match(FORMAT_REGEX)) {
        result = formatString.replace(FORMAT_REPLACE_REGEX, function(match, index, placeholderFormat) {
            var value = values[parseInt(index, 10)];

            return intl.toString(value, placeholderFormat ? placeholderFormat.substring(1) : "", locale);
        });
    } else {
        result = intl.toString(values[0], formatString, locale);
    }

    return result;
};

Object.defineProperties( FormatService.prototype, prototypeAccessors$1 );

var ChartService = function ChartService(chart, context) {
    if ( context === void 0 ) context = {};

    this._intlService = context.intlService;
    this.sender = context.sender || chart;
    this.format = new FormatService(context.intlService);
    this.chart = chart;
    this.rtl = Boolean(context.rtl);
};

var prototypeAccessors = { intl: { configurable: true } };

prototypeAccessors.intl.get = function () {
    return this._intlService || IntlService.implementation;
};

prototypeAccessors.intl.set = function (value) {
    this._intlService = value;
    this.format.intl = value;
};

ChartService.prototype.notify = function notify (name, args) {
    if (this.chart) {
        this.chart.trigger(name, args);
    }
};

ChartService.prototype.isPannable = function isPannable (axis) {
    var pannable = ((this.chart || {}).options || {}).pannable;
    return pannable && pannable.lock !== axis;
};

Object.defineProperties( ChartService.prototype, prototypeAccessors );

var current;

var DomEventsBuilder = function DomEventsBuilder () {};

DomEventsBuilder.register = function register (userImplementation) {
    current = userImplementation;
};

DomEventsBuilder.create = function create (element, events) {
    var builder;

    if (current) {
        builder = current.create(element, events);
    } else {
        builder = new UserEvents(element, Object.assign({}, {multiTouch: true},

            events));
    }

    return builder;
};

var services = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ChartService: ChartService,
    DomEventsBuilder: DomEventsBuilder,
    FormatService: FormatService,
    IntlService: IntlService,
    TemplateService: TemplateService
});

function createAxisTick(options, tickOptions) {
    var tickX = options.tickX;
    var tickY = options.tickY;
    var position = options.position;

    var tick = new Path$7({
        stroke: {
            width: tickOptions.width,
            color: tickOptions.color
        }
    });

    if (options.vertical) {
        tick.moveTo(tickX, position)
            .lineTo(tickX + tickOptions.size, position);
    } else {
        tick.moveTo(position, tickY)
            .lineTo(position, tickY + tickOptions.size);
    }

    alignPathToPixel(tick);

    return tick;
}

function createAxisGridLine(options, gridLine) {
    var lineStart = options.lineStart;
    var lineEnd = options.lineEnd;
    var position = options.position;

    var line = new Path$7({
        stroke: {
            width: gridLine.width,
            color: gridLine.color,
            dashType: gridLine.dashType
        }
    });

    if (options.vertical) {
        line.moveTo(lineStart, position)
            .lineTo(lineEnd, position);
    } else {
        line.moveTo(position, lineStart)
            .lineTo(position, lineEnd);
    }

    alignPathToPixel(line);

    return line;
}

var Axis = (function (ChartElement) {
    function Axis(options, chartService) {
        if ( chartService === void 0 ) chartService = new ChartService();

        ChartElement.call(this, options);

        this.chartService = chartService;

        if (!this.options.visible) {
            this.options = deepExtend({}, this.options, {
                labels: {
                    visible: false
                },
                line: {
                    visible: false
                },
                margin: 0,
                majorTickSize: 0,
                minorTickSize: 0
            });
        }

        this.options.minorTicks = deepExtend({}, {
            color: this.options.line.color,
            width: this.options.line.width,
            visible: this.options.minorTickType !== NONE
        }, this.options.minorTicks, {
            size: this.options.minorTickSize,
            align: this.options.minorTickType
        });

        this.options.majorTicks = deepExtend({}, {
            color: this.options.line.color,
            width: this.options.line.width,
            visible: this.options.majorTickType !== NONE
        }, this.options.majorTicks, {
            size: this.options.majorTickSize,
            align: this.options.majorTickType
        });

        this.initFields();

        if (!this.options._deferLabels) {
            this.createLabels();
        }

        this.createTitle();
        this.createNotes();
    }

    if ( ChartElement ) Axis.__proto__ = ChartElement;
    Axis.prototype = Object.create( ChartElement && ChartElement.prototype );
    Axis.prototype.constructor = Axis;

    Axis.prototype.initFields = function initFields () {
    };

    // abstract labelsCount(): Number
    // abstract createAxisLabel(index, options): AxisLabel

    Axis.prototype.labelsRange = function labelsRange () {
        return {
            min: this.options.labels.skip,
            max: this.labelsCount()
        };
    };

    Axis.prototype.normalizeLabelRotation = function normalizeLabelRotation (labelOptions) {
        var rotation = labelOptions.rotation;

        if (isObject(rotation)) {
            labelOptions.alignRotation = rotation.align;
            labelOptions.rotation = rotation.angle;
        }
    };

    Axis.prototype.createLabels = function createLabels () {
        var this$1$1 = this;

        var options = this.options;
        var align = options.vertical ? RIGHT : CENTER;
        var labelOptions = deepExtend({ }, options.labels, {
            align: align,
            zIndex: options.zIndex
        });
        var step = Math.max(1, labelOptions.step);

        this.clearLabels();

        if (labelOptions.visible) {
            this.normalizeLabelRotation(labelOptions);
            if (labelOptions.rotation === "auto") {
                labelOptions.rotation = 0;
                options.autoRotateLabels = true;
            }

            var range = this.labelsRange();
            for (var idx = range.min; idx < range.max; idx += step) {
                var labelContext = { index: idx, count: range.max };
                var label = this$1$1.createAxisLabel(idx, labelOptions, labelContext);
                if (label) {
                    this$1$1.append(label);
                    this$1$1.labels.push(label);
                }
            }
        }
    };

    Axis.prototype.clearLabels = function clearLabels () {
        this.children = grep(this.children, function (child) { return !(child instanceof AxisLabel); });
        this.labels = [];
    };

    Axis.prototype.clearTitle = function clearTitle () {
        var this$1$1 = this;

        if (this.title) {
            this.children = grep(this.children, function (child) { return child !== this$1$1.title; });
            this.title = undefined;
        }
    };

    Axis.prototype.clear = function clear () {
        this.clearLabels();
        this.clearTitle();
    };

    Axis.prototype.lineBox = function lineBox () {
        var ref = this;
        var options = ref.options;
        var box = ref.box;
        var vertical = options.vertical;
        var mirror = options.labels.mirror;
        var axisX = mirror ? box.x1 : box.x2;
        var axisY = mirror ? box.y2 : box.y1;
        var lineWidth = options.line.width || 0;

        return vertical ?
            new Box(axisX, box.y1, axisX, box.y2 - lineWidth) :
            new Box(box.x1, axisY, box.x2 - lineWidth, axisY);
    };

    Axis.prototype.createTitle = function createTitle () {
        var options = this.options;
        var titleOptions = deepExtend({
            rotation: options.vertical ? -90 : 0,
            text: "",
            zIndex: 1,
            visualSize: true
        }, options.title);

        if (titleOptions.visible && titleOptions.text) {
            var title = new TextBox(titleOptions.text, titleOptions);
            this.append(title);
            this.title = title;
        }
    };

    Axis.prototype.createNotes = function createNotes () {
        var this$1$1 = this;

        var options = this.options;
        var notes = options.notes;
        var items = notes.data || [];

        this.notes = [];

        for (var i = 0; i < items.length; i++) {
            var item = deepExtend({}, notes, items[i]);
            item.value = this$1$1.parseNoteValue(item.value);

            var note = new Note({
                value: item.value,
                text: item.label.text,
                dataItem: item
            }, item, this$1$1.chartService);

            if (note.options.visible) {
                if (defined(note.options.position)) {
                    if (options.vertical && !inArray(note.options.position, [ LEFT, RIGHT ])) {
                        note.options.position = options.reverse ? LEFT : RIGHT;
                    } else if (!options.vertical && !inArray(note.options.position, [ TOP, BOTTOM$1 ])) {
                        note.options.position = options.reverse ? BOTTOM$1 : TOP;
                    }
                } else {
                    if (options.vertical) {
                        note.options.position = options.reverse ? LEFT : RIGHT;
                    } else {
                        note.options.position = options.reverse ? BOTTOM$1 : TOP;
                    }
                }
                this$1$1.append(note);
                this$1$1.notes.push(note);
            }
        }
    };

    Axis.prototype.parseNoteValue = function parseNoteValue (value) {
        return value;
    };

    Axis.prototype.renderVisual = function renderVisual () {
        ChartElement.prototype.renderVisual.call(this);

        this.createPlotBands();
    };

    Axis.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        this.createBackground();
        this.createLine();
    };

    Axis.prototype.gridLinesVisual = function gridLinesVisual () {
        var gridLines = this._gridLines;
        if (!gridLines) {
            gridLines = this._gridLines = new Group$8({
                zIndex: -2
            });
            this.appendVisual(this._gridLines);
        }

        return gridLines;
    };

    Axis.prototype.createTicks = function createTicks (lineGroup) {
        var options = this.options;
        var lineBox = this.lineBox();
        var mirror = options.labels.mirror;
        var majorUnit = options.majorTicks.visible ? options.majorUnit : 0;
        var tickLineOptions = {
            // TODO
            // _alignLines: options._alignLines,
            vertical: options.vertical
        };

        function render(tickPositions, tickOptions, skipUnit) {
            var count = tickPositions.length;
            var step = Math.max(1, tickOptions.step);

            if (tickOptions.visible) {
                for (var i = tickOptions.skip; i < count; i += step) {
                    if (defined(skipUnit) && (i % skipUnit === 0)) {
                        continue;
                    }

                    tickLineOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
                    tickLineOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
                    tickLineOptions.position = tickPositions[i];

                    lineGroup.append(createAxisTick(tickLineOptions, tickOptions));
                }
            }
        }

        render(this.getMajorTickPositions(), options.majorTicks);
        render(this.getMinorTickPositions(), options.minorTicks, majorUnit / options.minorUnit);
    };

    Axis.prototype.createLine = function createLine () {
        var options = this.options;
        var line = options.line;
        var lineBox = this.lineBox();

        if (line.width > 0 && line.visible) {
            var path = new Path$7({
                stroke: {
                    width: line.width,
                    color: line.color,
                    dashType: line.dashType
                }

                /* TODO
                zIndex: line.zIndex,
                */
            });

            path.moveTo(lineBox.x1, lineBox.y1)
                .lineTo(lineBox.x2, lineBox.y2);

            if (options._alignLines) {
                alignPathToPixel(path);
            }

            var group = this._lineGroup = new Group$8();
            group.append(path);

            this.visual.append(group);
            this.createTicks(group);
        }
    };

    Axis.prototype.getActualTickSize = function getActualTickSize () {
        var options = this.options;
        var tickSize = 0;

        if (options.majorTicks.visible && options.minorTicks.visible) {
            tickSize = Math.max(options.majorTicks.size, options.minorTicks.size);
        } else if (options.majorTicks.visible) {
            tickSize = options.majorTicks.size;
        } else if (options.minorTicks.visible) {
            tickSize = options.minorTicks.size;
        }

        return tickSize;
    };

    Axis.prototype.createBackground = function createBackground () {
        var ref = this;
        var options = ref.options;
        var box = ref.box;
        var background = options.background;

        if (background) {
            this._backgroundPath = Path$7.fromRect(box.toRect(), {
                fill: {
                    color: background
                },
                stroke: null
            });

            this.visual.append(this._backgroundPath);
        }
    };

    Axis.prototype.createPlotBands = function createPlotBands () {
        var this$1$1 = this;

        var options = this.options;
        var plotBands = options.plotBands || [];
        var vertical = options.vertical;
        var plotArea = this.plotArea;

        if (plotBands.length === 0) {
            return;
        }

        var group = this._plotbandGroup = new Group$8({
            zIndex: -1
        });

        var altAxis = grep(this.pane.axes, function (axis) { return axis.options.vertical !== this$1$1.options.vertical; })[0];

        for (var idx = 0; idx < plotBands.length; idx++) {
            var item = plotBands[idx];
            var slotX = (void 0), slotY = (void 0);
            var labelOptions = item.label;
            var label = (void 0);

            if (vertical) {
                slotX = (altAxis || plotArea.axisX).lineBox();
                slotY = this$1$1.getSlot(item.from, item.to, true);
            } else {
                slotX = this$1$1.getSlot(item.from, item.to, true);
                slotY = (altAxis || plotArea.axisY).lineBox();
            }

            if (labelOptions) {
                labelOptions.vAlign = labelOptions.position || LEFT;
                label = this$1$1.createPlotBandLabel(
                    labelOptions,
                    item,
                    new Box(
                        slotX.x1,
                        slotY.y1,
                        slotX.x2,
                        slotY.y2
                    )

                );
            }

            if (slotX.width() !== 0 && slotY.height() !== 0) {
                var bandRect = new Rect(
                    [ slotX.x1, slotY.y1 ],
                    [ slotX.width(), slotY.height() ]
                );

                var path = Path$7.fromRect(bandRect, {
                    fill: {
                        color: item.color,
                        opacity: item.opacity
                    },
                    stroke: null
                });

                group.append(path);
                if (label) {
                    group.append(label);
                }
            }
        }

        this.appendVisual(group);
    };

    Axis.prototype.createPlotBandLabel = function createPlotBandLabel (label, item, box) {

        if (label.visible === false) {
            return null;
        }

        var text = label.text;
        var textbox;

        if (defined(label) && label.visible) {
            var labelTemplate = getTemplate$1(label);
            if (labelTemplate) {
                text = labelTemplate({ text: text, item: item });
            } else if (label.format) {
                text = this.chartService.format.auto(label.format, text);
            }

            if (!label.color) {
                label.color = this.options.labels.color;
            }
        }

        textbox = new TextBox(text, label);
        textbox.reflow(box);
        textbox.renderVisual();

        return textbox.visual;
    };

    Axis.prototype.createGridLines = function createGridLines (altAxis) {
        var options = this.options;
        var minorGridLines = options.minorGridLines;
        var majorGridLines = options.majorGridLines;
        var minorUnit = options.minorUnit;
        var vertical = options.vertical;
        var axisLineVisible = altAxis.options.line.visible;
        var majorUnit = majorGridLines.visible ? options.majorUnit : 0;
        var lineBox = altAxis.lineBox();
        var linePos = lineBox[vertical ? "y1" : "x1"];
        var lineOptions = {
            lineStart: lineBox[vertical ? "x1" : "y1"],
            lineEnd: lineBox[vertical ? "x2" : "y2"],
            vertical: vertical
        };
        var majorTicks = [];

        var container = this.gridLinesVisual();

        function render(tickPositions, gridLine, skipUnit) {
            var count = tickPositions.length;
            var step = Math.max(1, gridLine.step);

            if (gridLine.visible) {
                for (var i = gridLine.skip; i < count; i += step) {
                    var pos = round$1(tickPositions[i]);
                    if (!inArray(pos, majorTicks)) {
                        if (i % skipUnit !== 0 && (!axisLineVisible || linePos !== pos)) {
                            lineOptions.position = pos;
                            container.append(createAxisGridLine(lineOptions, gridLine));

                            majorTicks.push(pos);
                        }
                    }
                }
            }
        }

        render(this.getMajorTickPositions(), majorGridLines);
        render(this.getMinorTickPositions(), minorGridLines, majorUnit / minorUnit);

        return container.children;
    };

    Axis.prototype.reflow = function reflow (box) {
        var ref = this;
        var options = ref.options;
        var labels = ref.labels;
        var title = ref.title;
        var vertical = options.vertical;
        var count = labels.length;
        var sizeFn = vertical ? WIDTH : HEIGHT;
        var titleSize = title ? title.box[sizeFn]() : 0;
        var space = this.getActualTickSize() + options.margin + titleSize;
        var rootBox = (this.getRoot() || {}).box || box;
        var boxSize = rootBox[sizeFn]();
        var maxLabelSize = 0;

        for (var i = 0; i < count; i++) {
            var labelSize = labels[i].box[sizeFn]();
            if (labelSize + space <= boxSize) {
                maxLabelSize = Math.max(maxLabelSize, labelSize);
            }
        }

        if (vertical) {
            this.box = new Box(
                box.x1, box.y1,
                box.x1 + maxLabelSize + space, box.y2
            );
        } else {
            this.box = new Box(
                box.x1, box.y1,
                box.x2, box.y1 + maxLabelSize + space
            );
        }

        this.arrangeTitle();
        this.arrangeLabels();
        this.arrangeNotes();
    };

    Axis.prototype.getLabelsTickPositions = function getLabelsTickPositions () {
        return this.getMajorTickPositions();
    };

    Axis.prototype.labelTickIndex = function labelTickIndex (label) {
        return label.index;
    };

    Axis.prototype.arrangeLabels = function arrangeLabels () {
        var this$1$1 = this;

        var ref = this;
        var options = ref.options;
        var labels = ref.labels;
        var labelsBetweenTicks = this.labelsBetweenTicks();
        var vertical = options.vertical;
        var mirror = options.labels.mirror;
        var tickPositions = this.getLabelsTickPositions();

        for (var idx = 0; idx < labels.length; idx++) {
            var label = labels[idx];
            var tickIx = this$1$1.labelTickIndex(label);
            var labelSize = vertical ? label.box.height() : label.box.width();
            var firstTickPosition = tickPositions[tickIx];
            var nextTickPosition = tickPositions[tickIx + 1];
            var positionStart = (void 0), positionEnd = (void 0);

            if (vertical) {
                if (labelsBetweenTicks) {
                    var middle = firstTickPosition + (nextTickPosition - firstTickPosition) / 2;
                    positionStart = middle - (labelSize / 2);
                } else {
                    positionStart = firstTickPosition - (labelSize / 2);
                }

                positionEnd = positionStart;
            } else {
                if (labelsBetweenTicks) {
                    positionStart = firstTickPosition;
                    positionEnd = nextTickPosition;
                } else {
                    positionStart = firstTickPosition - (labelSize / 2);
                    positionEnd = positionStart + labelSize;
                }
            }

            this$1$1.positionLabel(label, mirror, positionStart, positionEnd);
        }
    };

    Axis.prototype.positionLabel = function positionLabel (label, mirror, positionStart, positionEnd) {
        if ( positionEnd === void 0 ) positionEnd = positionStart;

        var options = this.options;
        var vertical = options.vertical;
        var lineBox = this.lineBox();
        var labelOffset = this.getActualTickSize() + options.margin;
        var labelBox;

        if (vertical) {
            var labelX = lineBox.x2;

            if (mirror) {
                labelX += labelOffset;
                label.options.rotationOrigin = LEFT;
            } else {
                labelX -= labelOffset + label.box.width();
                label.options.rotationOrigin = RIGHT;
            }

            labelBox = label.box.move(labelX, positionStart);
        } else {
            var labelY = lineBox.y1;

            if (mirror) {
                labelY -= labelOffset + label.box.height();
                label.options.rotationOrigin = BOTTOM$1;
            } else {
                labelY += labelOffset;
                label.options.rotationOrigin = TOP;
            }

            labelBox = new Box(
                positionStart, labelY,
                positionEnd, labelY + label.box.height()
            );
        }

        label.reflow(labelBox);
    };

    Axis.prototype.autoRotateLabelAngle = function autoRotateLabelAngle (labelBox, slotWidth) {
        if (labelBox.width() < slotWidth) {
            return 0;
        }

        if (labelBox.height() > slotWidth) {
            return -90;
        }

        return -45;
    };

    Axis.prototype.autoRotateLabels = function autoRotateLabels () {
        var this$1$1 = this;

        if (!this.options.autoRotateLabels || this.options.vertical) {
            return false;
        }

        var tickPositions = this.getMajorTickPositions();
        var labels = this.labels;
        var limit = Math.min(labels.length, tickPositions.length - 1);
        var angle = 0;

        for (var idx = 0; idx < limit; idx++) {
            var width = Math.abs(tickPositions[idx + 1] - tickPositions[idx]);
            var labelBox = labels[idx].box;
            var labelAngle = this$1$1.autoRotateLabelAngle(labelBox, width);

            if (labelAngle !== 0) {
                angle = labelAngle;
            }

            if (angle === -90) {
                break;
            }
        }

        if (angle !== 0) {
            for (var idx$1 = 0; idx$1 < labels.length; idx$1++) {
                labels[idx$1].options.rotation = angle;
                labels[idx$1].reflow(new Box());
            }

            return true;
        }
    };

    Axis.prototype.arrangeTitle = function arrangeTitle () {
        var ref = this;
        var options = ref.options;
        var title = ref.title;
        var mirror = options.labels.mirror;
        var vertical = options.vertical;

        if (title) {
            if (vertical) {
                title.options.align = mirror ? RIGHT : LEFT;
                title.options.vAlign = title.options.position;
            } else {
                title.options.align = title.options.position;
                title.options.vAlign = mirror ? TOP : BOTTOM$1;
            }

            title.reflow(this.box);
        }
    };

    Axis.prototype.arrangeNotes = function arrangeNotes () {
        var this$1$1 = this;

        for (var idx = 0; idx < this.notes.length; idx++) {
            var item = this$1$1.notes[idx];
            var value = item.options.value;
            var slot = (void 0);

            if (defined(value)) {
                if (this$1$1.shouldRenderNote(value)) {
                    item.show();
                } else {
                    item.hide();
                }

                slot = this$1$1.noteSlot(value);
            } else {
                item.hide();
            }

            item.reflow(slot || this$1$1.lineBox());
        }
    };

    Axis.prototype.noteSlot = function noteSlot (value) {
        return this.getSlot(value);
    };

    Axis.prototype.alignTo = function alignTo (secondAxis) {
        var lineBox = secondAxis.lineBox();
        var vertical = this.options.vertical;
        var pos = vertical ? Y : X;

        this.box.snapTo(lineBox, pos);
        if (vertical) {
            this.box.shrink(0, this.lineBox().height() - lineBox.height());
        } else {
            this.box.shrink(this.lineBox().width() - lineBox.width(), 0);
        }
        this.box[pos + 1] -= this.lineBox()[pos + 1] - lineBox[pos + 1];
        this.box[pos + 2] -= this.lineBox()[pos + 2] - lineBox[pos + 2];
    };

    Axis.prototype.axisLabelText = function axisLabelText (value, options, context) {
        var this$1$1 = this;

        var text;
        var tmpl = getTemplate$1(options);
        var defaultText = function () {
            if (!options.format) {
                return value;
            }

            return this$1$1.chartService.format.localeAuto(
                options.format, [ value ], options.culture
            );
        };

        if (tmpl) {
            var templateContext = Object.assign({}, context, {
                get text() { return defaultText(); },
                value: value,
                format: options.format,
                culture: options.culture
            });

            text = tmpl(templateContext);
        } else {
            text = defaultText();
        }

        return text;
    };

    Axis.prototype.slot = function slot (from , to, limit) {
        var slot = this.getSlot(from, to, limit);
        if (slot) {
            return slot.toRect();
        }
    };

    Axis.prototype.contentBox = function contentBox () {
        var box = this.box.clone();
        var labels = this.labels;
        if (labels.length) {
            var axis = this.options.vertical ? Y : X;
            if (this.chartService.isPannable(axis)) {
                var offset = this.maxLabelOffset();
                box[axis + 1] -= offset.start;
                box[axis + 2] += offset.end;
            } else {
                if (labels[0].options.visible) {
                    box.wrap(labels[0].box);
                }
                var lastLabel = labels[labels.length - 1];
                if (lastLabel.options.visible) {
                    box.wrap(lastLabel.box);
                }
            }
        }

        return box;
    };

    Axis.prototype.maxLabelOffset = function maxLabelOffset () {
        var this$1$1 = this;

        var ref = this.options;
        var vertical = ref.vertical;
        var reverse = ref.reverse;
        var labelsBetweenTicks = this.labelsBetweenTicks();
        var tickPositions = this.getLabelsTickPositions();
        var offsetField = vertical ? Y : X;
        var labels = this.labels;
        var startPosition = reverse ? 1 : 0;
        var endPosition = reverse ? 0 : 1;
        var maxStartOffset = 0;
        var maxEndOffset = 0;

        for (var idx = 0; idx < labels.length; idx++) {
            var label = labels[idx];
            var tickIx = this$1$1.labelTickIndex(label);
            var startTick = (void 0), endTick = (void 0);

            if (labelsBetweenTicks) {
                startTick = tickPositions[tickIx + startPosition];
                endTick = tickPositions[tickIx + endPosition];
            } else {
                startTick = endTick = tickPositions[tickIx];
            }

            maxStartOffset = Math.max(maxStartOffset, startTick - label.box[offsetField + 1]);
            maxEndOffset = Math.max(maxEndOffset, label.box[offsetField + 2] - endTick);
        }

        return {
            start: maxStartOffset,
            end: maxEndOffset
        };
    };

    Axis.prototype.limitRange = function limitRange (from, to, min, max, offset) {
        var options = this.options;

        if ((from < min && offset < 0 && (!defined(options.min) || options.min <= min)) || (max < to && offset > 0 && (!defined(options.max) || max <= options.max))) {
            return null;
        }

        if ((to < min && offset > 0) || (max < from && offset < 0)) {
            return {
                min: from,
                max: to
            };
        }

        var rangeSize = to - from;
        var minValue = from;
        var maxValue = to;

        if (from < min && offset < 0) {
            minValue = limitValue(from, min, max);
            maxValue = limitValue(from + rangeSize, min + rangeSize, max);
        } else if (to > max && offset > 0) {
            maxValue = limitValue(to, min, max);
            minValue = limitValue(to - rangeSize, min, max - rangeSize);
        }

        return {
            min: minValue,
            max: maxValue
        };
    };

    Axis.prototype.valueRange = function valueRange () {
        return {
            min: this.seriesMin,
            max: this.seriesMax
        };
    };

    Axis.prototype.lineDir = function lineDir () {
        /*
         * Axis line direction:
         *   * Vertical: up.
         *   * Horizontal: right.
         */

        var ref = this.options;
        var vertical = ref.vertical;
        var reverse = ref.reverse;
        return (vertical ? -1 : 1) * (reverse ? -1 : 1);
    };

    Axis.prototype.lineInfo = function lineInfo () {
        var ref = this.options;
        var vertical = ref.vertical;
        var lineBox = this.lineBox();
        var lineSize = vertical ? lineBox.height() : lineBox.width();
        var axis = vertical ? Y : X;
        var axisDir = this.lineDir();
        var startEdge = axisDir === 1 ? 1 : 2;
        var axisOrigin = axis + startEdge.toString();
        var lineStart = lineBox[axisOrigin];

        return {
            axis: axis,
            axisOrigin: axisOrigin,
            axisDir: axisDir,
            lineBox: lineBox,
            lineSize: lineSize,
            lineStart: lineStart
        };
    };

    Axis.prototype.pointOffset = function pointOffset (point) {
        var ref = this.lineInfo();
        var axis = ref.axis;
        var axisDir = ref.axisDir;
        var axisOrigin = ref.axisOrigin;
        var lineBox = ref.lineBox;
        var lineSize = ref.lineSize;
        var relative = axisDir > 0 ? point[axis] - lineBox[axisOrigin] : lineBox[axisOrigin] - point[axis];
        var offset = relative / lineSize;

        return offset;
    };

    // Computes the axis range change (delta) for a given scale factor.
    // The delta is subtracted from the axis range:
    //   * delta > 0 reduces the axis range (zoom-in)
    //   * delta < 0 expands the axis range (zoom-out)
    Axis.prototype.scaleToDelta = function scaleToDelta (rawScale, range) {
        // Scale >= 1 would result in axis range of 0.
        // Scale <= -1 would reverse the scale direction.
        var MAX_SCALE = 0.999;
        var scale = limitValue(rawScale, -MAX_SCALE, MAX_SCALE);

        var delta;
        if (scale > 0) {
            delta = range * Math.min(1, scale);
        } else {
            delta = range - (range / (1 + scale));
        }

        return delta;
    };

    Axis.prototype.labelsBetweenTicks = function labelsBetweenTicks () {
        return !this.options.justified;
    };

    //add legacy fields to the options that are no longer generated by default
    Axis.prototype.prepareUserOptions = function prepareUserOptions () {
    };

    return Axis;
}(ChartElement));

setDefaultOptions(Axis, {
    labels: {
        visible: true,
        rotation: 0,
        mirror: false,
        step: 1,
        skip: 0
    },
    line: {
        width: 1,
        color: BLACK$1,
        visible: true
    },
    title: {
        visible: true,
        position: CENTER
    },
    majorTicks: {
        align: OUTSIDE$1,
        size: 4,
        skip: 0,
        step: 1
    },
    minorTicks: {
        align: OUTSIDE$1,
        size: 3,
        skip: 0,
        step: 1
    },
    axisCrossingValue: 0,
    majorTickType: OUTSIDE$1,
    minorTickType: NONE,
    majorGridLines: {
        skip: 0,
        step: 1
    },
    minorGridLines: {
        visible: false,
        width: 1,
        color: BLACK$1,
        skip: 0,
        step: 1
    },
    // TODO: Move to line or labels options
    margin: 5,
    visible: true,
    reverse: false,
    justified: true,
    notes: {
        label: {
            text: ""
        }
    },

    _alignLines: true,
    _deferLabels: false
});

var MILLISECONDS = "milliseconds";
var SECONDS = "seconds";
var MINUTES = "minutes";
var HOURS = "hours";
var DAYS = "days";
var WEEKS = "weeks";
var MONTHS = "months";
var YEARS = "years";

var TIME_PER_MILLISECOND = 1;
var TIME_PER_SECOND = 1000;
var TIME_PER_MINUTE = 60 * TIME_PER_SECOND;
var TIME_PER_HOUR = 60 * TIME_PER_MINUTE;
var TIME_PER_DAY = 24 * TIME_PER_HOUR;
var TIME_PER_WEEK = 7 * TIME_PER_DAY;
var TIME_PER_MONTH = 31 * TIME_PER_DAY;
var TIME_PER_YEAR = 365 * TIME_PER_DAY;
var TIME_PER_UNIT = {
    "years": TIME_PER_YEAR,
    "months": TIME_PER_MONTH,
    "weeks": TIME_PER_WEEK,
    "days": TIME_PER_DAY,
    "hours": TIME_PER_HOUR,
    "minutes": TIME_PER_MINUTE,
    "seconds": TIME_PER_SECOND,
    "milliseconds": TIME_PER_MILLISECOND
};

function absoluteDateDiff(a, b) {
    var diff = a.getTime() - b;
    var offsetDiff = a.getTimezoneOffset() - b.getTimezoneOffset();

    return diff - (offsetDiff * TIME_PER_MINUTE);
}

function addTicks(date, ticks) {
    return new Date(date.getTime() + ticks);
}

function toDate(value) {
    var result;

    if (value instanceof Date) {
        result = value;
    } else if (value) {
        result = new Date(value);
    }

    return result;
}

function startOfWeek(date, weekStartDay) {
    if ( weekStartDay === void 0 ) weekStartDay = 0;

    var daysToSubtract = 0;
    var day = date.getDay();

    if (!isNaN(day)) {
        while (day !== weekStartDay) {
            if (day === 0) {
                day = 6;
            } else {
                day--;
            }

            daysToSubtract++;
        }
    }

    return addTicks(date, -daysToSubtract * TIME_PER_DAY);
}

function adjustDST(date, hours) {
    if (hours === 0 && date.getHours() === 23) {
        date.setHours(date.getHours() + 2);
        return true;
    }

    return false;
}

function addHours(date, hours) {
    var roundedDate = new Date(date);

    roundedDate.setMinutes(0, 0, 0);

    var tzDiff = (date.getTimezoneOffset() - roundedDate.getTimezoneOffset()) * TIME_PER_MINUTE;

    return addTicks(roundedDate, tzDiff + hours * TIME_PER_HOUR);
}

function addDuration(dateValue, value, unit, weekStartDay) {
    var result = dateValue;

    if (dateValue) {
        var date = toDate(dateValue);
        var hours = date.getHours();

        if (unit === YEARS) {
            result = new Date(date.getFullYear() + value, 0, 1);
            adjustDST(result, 0);
        } else if (unit === MONTHS) {
            result = new Date(date.getFullYear(), date.getMonth() + value, 1);
            adjustDST(result, hours);
        } else if (unit === WEEKS) {
            result = addDuration(startOfWeek(date, weekStartDay), value * 7, DAYS);
            adjustDST(result, hours);
        } else if (unit === DAYS) {
            result = new Date(date.getFullYear(), date.getMonth(), date.getDate() + value);
            adjustDST(result, hours);
        } else if (unit === HOURS) {
            result = addHours(date, value);
        } else if (unit === MINUTES) {
            result = addTicks(date, value * TIME_PER_MINUTE);

            if (result.getSeconds() > 0) {
                result.setSeconds(0);
            }
        } else if (unit === SECONDS) {
            result = addTicks(date, value * TIME_PER_SECOND);
        } else if (unit === MILLISECONDS) {
            result = addTicks(date, value);
        }

        if (unit !== MILLISECONDS && result.getMilliseconds() > 0) {
            result.setMilliseconds(0);
        }
    }

    return result;
}

function floorDate(date, unit, weekStartDay) {
    return addDuration(toDate(date), 0, unit, weekStartDay);
}

function ceilDate(dateValue, unit, weekStartDay) {
    var date = toDate(dateValue);

    if (date && floorDate(date, unit, weekStartDay).getTime() === date.getTime()) {
        return date;
    }

    return addDuration(date, 1, unit, weekStartDay);
}

function dateComparer(a, b) {
    if (a && b) {
        return a.getTime() - b.getTime();
    }

    return -1;
}

function dateDiff(a, b) {
    return a.getTime() - b;
}

function toTime(value) {
    if (isArray(value)) {
        var result = [];
        for (var idx = 0; idx < value.length; idx++) {
            result.push(toTime(value[idx]));
        }

        return result;
    } else if (value) {
        return toDate(value).getTime();
    }
}

function dateEquals(a, b) {
    if (a && b) {
        return toTime(a) === toTime(b);
    }

    return a === b;
}

function timeIndex(date, start, baseUnit) {
    return absoluteDateDiff(date, start) / TIME_PER_UNIT[baseUnit];
}

function dateIndex(value, start, baseUnit, baseUnitStep) {
    var date = toDate(value);
    var startDate = toDate(start);
    var index;

    if (baseUnit === MONTHS) {
        index = (date.getMonth() - startDate.getMonth() + (date.getFullYear() - startDate.getFullYear()) * 12) +
            timeIndex(date, new Date(date.getFullYear(), date.getMonth()), DAYS) / new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    } else if (baseUnit === YEARS) {
        index = date.getFullYear() - startDate.getFullYear() + dateIndex(date, new Date(date.getFullYear(), 0), MONTHS, 1) / 12;
    } else if (baseUnit === DAYS || baseUnit === WEEKS) {
        index = timeIndex(date, startDate, baseUnit);
    } else {
        index = dateDiff(date, start) / TIME_PER_UNIT[baseUnit];
    }

    return index / baseUnitStep;
}

function duration(a, b, unit) {
    var diff;

    if (unit === YEARS) {
        diff = b.getFullYear() - a.getFullYear();
    } else if (unit === MONTHS) {
        diff = duration(a, b, YEARS) * 12 + b.getMonth() - a.getMonth();
    } else if (unit === DAYS) {
        diff = Math.floor(dateDiff(b, a) / TIME_PER_DAY);
    } else {
        diff = Math.floor(dateDiff(b, a) / TIME_PER_UNIT[unit]);
    }

    return diff;
}

function lteDateIndex(date, sortedDates) {
    var low = 0;
    var high = sortedDates.length - 1;
    var index;

    while (low <= high) {
        index = Math.floor((low + high) / 2);
        var currentDate = sortedDates[index];

        if (currentDate < date) {
            low = index + 1;
            continue;
        }

        if (currentDate > date) {
            high = index - 1;
            continue;
        }

        while (dateEquals(sortedDates[index - 1], date)) {
            index--;
        }

        return index;
    }

    if (sortedDates[index] <= date) {
        return index;
    }

    return index - 1;
}

function parseDate(intlService, date) {
    var result;
    if (isString$1(date)) {
        result = intlService.parseDate(date) || toDate(date);
    } else {
        result = toDate(date);
    }
    return result;
}

function parseDates(intlService, dates) {
    if (isArray(dates)) {
        var result = [];
        for (var idx = 0; idx < dates.length; idx++) {
            result.push(parseDate(intlService, dates[idx]));
        }

        return result;
    }

    return parseDate(intlService, dates);
}

function firstDay(options, intlService) {
    if (isNumber(options.weekStartDay)) {
        return options.weekStartDay;
    }

    if (intlService && intlService.firstDay) {
        return intlService.firstDay();
    }

    return 0;
}

var MIN_CATEGORY_POINTS_RANGE = 0.01;
var MIN_CATEGORY_RANGE = 0.1;

function indexOf(value, arr) {
    if (value instanceof Date) {
        var length = arr.length;
        for (var idx = 0; idx < length; idx++) {
            if (dateEquals(arr[idx], value)) {
                return idx;
            }
        }

        return -1;
    }

    return arr.indexOf(value);
}

var CategoryAxis = (function (Axis) {
    function CategoryAxis () {
        Axis.apply(this, arguments);
    }

    if ( Axis ) CategoryAxis.__proto__ = Axis;
    CategoryAxis.prototype = Object.create( Axis && Axis.prototype );
    CategoryAxis.prototype.constructor = CategoryAxis;

    CategoryAxis.prototype.initFields = function initFields () {
        this._ticks = {};
    };

    CategoryAxis.prototype.categoriesHash = function categoriesHash () {
        return "";
    };

    CategoryAxis.prototype.clone = function clone () {
        var copy = new CategoryAxis(Object.assign({}, this.options, {
            categories: this.options.srcCategories
        }), this.chartService);
        copy.createLabels();

        return copy;
    };

    CategoryAxis.prototype.initUserOptions = function initUserOptions (options) {
        var categories = options.categories || [];
        var definedMin = defined(options.min);
        var definedMax = defined(options.max);
        options.srcCategories = options.categories = categories;

        if ((definedMin || definedMax) && categories.length) {
            var min = definedMin ? Math.floor(options.min) : 0;
            var max;

            if (definedMax) {
                max = options.justified ? Math.floor(options.max) + 1 : Math.ceil(options.max);
            } else {
                max = categories.length;
            }

            options.categories = options.categories.slice(min, max);
        }

        return options;
    };

    CategoryAxis.prototype.rangeIndices = function rangeIndices () {
        var options = this.options;
        var length = options.categories.length || 1;
        var min = isNumber(options.min) ? options.min % 1 : 0;
        var max;

        if (isNumber(options.max) && options.max % 1 !== 0 && options.max < this.totalRange().max) {
            max = length - (1 - options.max % 1);
        } else {
            max = length - (options.justified ? 1 : 0);
        }

        return {
            min: min,
            max: max
        };
    };

    CategoryAxis.prototype.range = function range () {
        var options = this.options;
        var min = isNumber(options.min) ? options.min : 0;
        var max = isNumber(options.max) ? options.max : this.totalRange().max;

        return {
            min: min,
            max: max
        };
    };

    CategoryAxis.prototype.roundedRange = function roundedRange () {
        return this.range();
    };

    CategoryAxis.prototype.totalRange = function totalRange () {
        var options = this.options;
        return { min: 0, max: Math.max(this._seriesMax || 0, options.srcCategories.length) - (options.justified ? 1 : 0) };
    };

    CategoryAxis.prototype.scaleOptions = function scaleOptions () {
        var ref = this.rangeIndices();
        var min = ref.min;
        var max = ref.max;
        var lineBox = this.lineBox();
        var size = this.options.vertical ? lineBox.height() : lineBox.width();
        var scale = size / ((max - min) || 1);

        return {
            scale: scale * (this.options.reverse ? -1 : 1),
            box: lineBox,
            min: min,
            max: max
        };
    };

    CategoryAxis.prototype.arrangeLabels = function arrangeLabels () {
        Axis.prototype.arrangeLabels.call(this);
        this.hideOutOfRangeLabels();
    };

    CategoryAxis.prototype.hideOutOfRangeLabels = function hideOutOfRangeLabels () {
        var ref = this;
        var box = ref.box;
        var labels = ref.labels;

        if (labels.length > 0) {
            var valueAxis = this.options.vertical ? Y : X;
            var start = box[valueAxis + 1];
            var end = box[valueAxis + 2];
            var firstLabel = labels[0];
            var lastLabel = last(labels);

            if (firstLabel.box[valueAxis + 1] > end || firstLabel.box[valueAxis + 2] < start) {
                firstLabel.options.visible = false;
            }
            if (lastLabel.box[valueAxis + 1] > end || lastLabel.box[valueAxis + 2] < start) {
                lastLabel.options.visible = false;
            }
        }
    };

    CategoryAxis.prototype.getMajorTickPositions = function getMajorTickPositions () {
        return this.getTicks().majorTicks;
    };

    CategoryAxis.prototype.getMinorTickPositions = function getMinorTickPositions () {
        return this.getTicks().minorTicks;
    };

    CategoryAxis.prototype.getLabelsTickPositions = function getLabelsTickPositions () {
        return this.getTicks().labelTicks;
    };

    CategoryAxis.prototype.tickIndices = function tickIndices (stepSize) {
        var ref = this.rangeIndices();
        var min = ref.min;
        var max = ref.max;
        var limit = Math.ceil(max);
        var current = Math.floor(min);
        var indices = [];

        while (current <= limit) {
            indices.push(current);
            current += stepSize;
        }

        return indices;
    };

    CategoryAxis.prototype.getTickPositions = function getTickPositions (stepSize) {
        var ref = this.options;
        var vertical = ref.vertical;
        var reverse = ref.reverse;
        var ref$1 = this.scaleOptions();
        var scale = ref$1.scale;
        var box = ref$1.box;
        var min = ref$1.min;
        var pos = box[(vertical ? Y : X) + (reverse ? 2 : 1)];
        var indices = this.tickIndices(stepSize);
        var positions = [];

        for (var idx = 0; idx < indices.length; idx++) {
            positions.push(pos + round$1(scale * (indices[idx] - min), COORD_PRECISION));
        }

        return positions;
    };

    CategoryAxis.prototype.getTicks = function getTicks () {
        var options = this.options;
        var cache = this._ticks;
        var range = this.rangeIndices();
        var lineBox = this.lineBox();
        var hash = lineBox.getHash() + range.min + "," + range.max + options.reverse + options.justified;

        if (cache._hash !== hash) {
            var hasMinor = options.minorTicks.visible || options.minorGridLines.visible;
            cache._hash = hash;
            cache.labelTicks = this.getTickPositions(1);
            cache.majorTicks = this.filterOutOfRangePositions(cache.labelTicks, lineBox);
            cache.minorTicks = hasMinor ? this.filterOutOfRangePositions(this.getTickPositions(0.5), lineBox) : [];
        }

        return cache;
    };

    CategoryAxis.prototype.filterOutOfRangePositions = function filterOutOfRangePositions (positions, lineBox) {
        if (!positions.length) {
            return positions;
        }

        var axis = this.options.vertical ? Y : X;
        var inRange = function (position) { return lineBox[axis + 1] <= position && position <= lineBox[axis + 2]; };

        var end = positions.length - 1;
        var startIndex = 0;
        while (!inRange(positions[startIndex]) && startIndex <= end) {
            startIndex++;
        }

        var endIndex = end;

        while (!inRange(positions[endIndex]) && endIndex >= 0) {
            endIndex--;
        }

        return positions.slice(startIndex, endIndex + 1);
    };

    CategoryAxis.prototype.lineInfo = function lineInfo () {
        var ref = this.options;
        var vertical = ref.vertical;
        var reverse = ref.reverse;
        var lineBox = this.lineBox();
        var lineSize = vertical ? lineBox.height() : lineBox.width();
        var axis = vertical ? Y : X;
        var axisDir = reverse ? -1 : 1;
        var startEdge = axisDir === 1 ? 1 : 2;
        var axisOrigin = axis + startEdge.toString();
        var lineStart = lineBox[axisOrigin];

        return {
            axis: axis,
            axisOrigin: axisOrigin,
            axisDir: axisDir,
            lineBox: lineBox,
            lineSize: lineSize,
            lineStart: lineStart
        };
    };

    CategoryAxis.prototype.lineDir = function lineDir () {
        /*
         *  Category axis line direction:
         *    * Vertical: down.
         *    * Horizontal: right.
         */

        var ref = this.options;
        var reverse = ref.reverse;
        return reverse ? -1 : 1;
    };

    // TODO: Rename to slotBox, valueSlot, slotByIndex?
    CategoryAxis.prototype.getSlot = function getSlot (from, to, limit) {
        var options = this.options;
        var reverse = options.reverse;
        var justified = options.justified;
        var ref = this.scaleOptions();
        var scale = ref.scale;
        var box = ref.box;
        var min = ref.min;
        var ref$1 = this.lineInfo();
        var valueAxis = ref$1.axis;
        var lineStart = ref$1.lineStart;

        var slotBox = box.clone();
        var singleSlot = !defined(to);

        var start = valueOrDefault(from, 0);
        var end = valueOrDefault(to, start);
        end = Math.max(end - 1, start);

        // Fixes transient bug caused by iOS 6.0 JIT
        // (one can never be too sure)
        end = Math.max(start, end);

        var p1 = lineStart + (start - min) * scale;
        var p2 = lineStart + (end + 1 - min) * scale;

        if (singleSlot && justified) {
            p2 = p1;
        }

        if (limit) {
            p1 = limitValue(p1, box[valueAxis + 1], box[valueAxis + 2]);
            p2 = limitValue(p2, box[valueAxis + 1], box[valueAxis + 2]);
        }

        slotBox[valueAxis + 1] = reverse ? p2 : p1;
        slotBox[valueAxis + 2] = reverse ? p1 : p2;

        return slotBox;
    };

    CategoryAxis.prototype.limitSlot = function limitSlot (slot) {
        var vertical = this.options.vertical;
        var valueAxis = vertical ? Y : X;
        var lineBox = this.lineBox();
        var limittedSlot = slot.clone();

        limittedSlot[valueAxis + 1] = limitValue(slot[valueAxis + 1], lineBox[valueAxis + 1], lineBox[valueAxis + 2]);
        limittedSlot[valueAxis + 2] = limitValue(slot[valueAxis + 2], lineBox[valueAxis + 1], lineBox[valueAxis + 2]);

        return limittedSlot;
    };

    CategoryAxis.prototype.slot = function slot (from, to, limit) {
        var min = Math.floor(this.options.min || 0);
        var start = from;
        var end = to;

        if (typeof start === "string") {
            start = this.categoryIndex(start);
        } else if (isNumber(start)) {
            start -= min;
        }

        if (typeof end === "string") {
            end = this.categoryIndex(end);
        } else if (isNumber(end)) {
            end -= min;
        }

        return Axis.prototype.slot.call(this, start, end, limit);
    };

    CategoryAxis.prototype.pointCategoryIndex = function pointCategoryIndex (point) {
        var ref = this.options;
        var reverse = ref.reverse;
        var justified = ref.justified;
        var vertical = ref.vertical;
        var valueAxis = vertical ? Y : X;
        var ref$1 = this.scaleOptions();
        var scale = ref$1.scale;
        var box = ref$1.box;
        var min = ref$1.min;
        var max = ref$1.max;
        var startValue = reverse ? max : min;
        var lineStart = box[valueAxis + 1];
        var lineEnd = box[valueAxis + 2];
        var pos = point[valueAxis];

        if (pos < lineStart || pos > lineEnd) {
            return null;
        }

        var value = startValue + (pos - lineStart) / scale;
        var diff = value % 1;

        if (justified) {
            value = Math.round(value);
        } else if (diff === 0 && value > 0) {
            value--;
        }

        return Math.floor(value);
    };

    CategoryAxis.prototype.getCategory = function getCategory (point) {
        var index = this.pointCategoryIndex(point);

        if (index === null) {
            return null;
        }

        return this.options.categories[index];
    };

    CategoryAxis.prototype.categoryIndex = function categoryIndex (value) {
        return this.totalIndex(value) - Math.floor(this.options.min || 0);
    };

    CategoryAxis.prototype.categoryAt = function categoryAt (index, total) {
        var options = this.options;

        return (total ? options.srcCategories : options.categories)[index];
    };

    CategoryAxis.prototype.categoriesCount = function categoriesCount () {
        return (this.options.categories || []).length;
    };

    CategoryAxis.prototype.translateRange = function translateRange (delta) {
        var options = this.options;
        var lineBox = this.lineBox();
        var size = options.vertical ? lineBox.height() : lineBox.width();
        var range = options.categories.length;
        var scale = size / range;
        var offset = round$1(delta / scale, DEFAULT_PRECISION);

        return {
            min: offset,
            max: range + offset
        };
    };

    CategoryAxis.prototype.scaleRange = function scaleRange (scale, cursor) {
        var position = Math.abs(this.pointOffset(cursor));
        var rangeIndices = this.limitedRangeIndices();
        var range = rangeIndices.max - rangeIndices.min;
        var delta = this.scaleToDelta(scale, range);
        var minDelta = position * delta;
        var maxDelta = (1 - position) * delta;
        var min = rangeIndices.min + minDelta;
        var max = rangeIndices.max - maxDelta;

        if (max - min < MIN_CATEGORY_RANGE) {
            max = min + MIN_CATEGORY_RANGE;
        }

        return {
            min: min,
            max: max
        };
    };

    CategoryAxis.prototype.zoomRange = function zoomRange (scale, cursor) {
        var ref = this.totalRange();
        var totalMin = ref.min;
        var totalMax = ref.max;
        var range = this.scaleRange(scale, cursor);

        return {
            min: limitValue(range.min, totalMin, totalMax),
            max: limitValue(range.max, totalMin, totalMax)
        };
    };

    CategoryAxis.prototype.labelsCount = function labelsCount () {
        var labelsRange = this.labelsRange();

        return labelsRange.max - labelsRange.min;
    };

    CategoryAxis.prototype.labelsRange = function labelsRange () {
        var options = this.options;
        var justified = options.justified;
        var labelOptions = options.labels;
        var ref = this.limitedRangeIndices(true);
        var min = ref.min;
        var max = ref.max;
        var start = Math.floor(min);

        if (!justified) {
            min = Math.floor(min);
            max = Math.ceil(max);
        } else {
            min = Math.ceil(min);
            max = Math.floor(max);
        }

        var skip;

        if (min > labelOptions.skip) {
            skip = labelOptions.skip + labelOptions.step * Math.ceil((min - labelOptions.skip) / labelOptions.step);
        } else {
            skip = labelOptions.skip;
        }

        return {
            min: skip - start,
            max: (options.categories.length ? max + (justified ? 1 : 0) : 0) - start
        };
    };

    CategoryAxis.prototype.createAxisLabel = function createAxisLabel (index, labelOptions, labelContext) {
        var options = this.options;
        var dataItem = options.dataItems ? options.dataItems[index] : null;
        var category = valueOrDefault(options.categories[index], "");

        labelContext.dataItem = dataItem;
        var text = this.axisLabelText(category, labelOptions, labelContext);

        return new AxisLabel(category, text, index, dataItem, labelOptions);
    };

    CategoryAxis.prototype.shouldRenderNote = function shouldRenderNote (value) {
        var range = this.limitedRangeIndices();

        return Math.floor(range.min) <= value && value <= Math.ceil(range.max);
    };

    CategoryAxis.prototype.noteSlot = function noteSlot (value) {
        var options = this.options;
        var index = value - Math.floor(options.min || 0);
        return this.getSlot(index);
    };

    CategoryAxis.prototype.arrangeNotes = function arrangeNotes () {
        Axis.prototype.arrangeNotes.call(this);
        this.hideOutOfRangeNotes();
    };

    CategoryAxis.prototype.hideOutOfRangeNotes = function hideOutOfRangeNotes () {
        var ref = this;
        var notes = ref.notes;
        var box = ref.box;
        if (notes && notes.length) {
            var valueAxis = this.options.vertical ? Y : X;
            var start = box[valueAxis + 1];
            var end = box[valueAxis + 2];

            for (var idx = 0; idx < notes.length; idx++) {
                var note = notes[idx];
                if (note.box && (end < note.box[valueAxis + 1] || note.box[valueAxis + 2] < start)) {
                    note.hide();
                }
            }
        }
    };

    CategoryAxis.prototype.pan = function pan (delta) {
        var range = this.limitedRangeIndices(true);
        var ref = this.scaleOptions();
        var scale = ref.scale;
        var offset = round$1(delta / scale, DEFAULT_PRECISION);
        var totalRange = this.totalRange();
        var min = range.min + offset;
        var max = range.max + offset;

        return this.limitRange(min, max, 0, totalRange.max, offset);
    };

    CategoryAxis.prototype.pointsRange = function pointsRange (start, end) {
        var ref = this.options;
        var reverse = ref.reverse;
        var vertical = ref.vertical;
        var valueAxis = vertical ? Y : X;
        var range = this.limitedRangeIndices(true);
        var ref$1 = this.scaleOptions();
        var scale = ref$1.scale;
        var box = ref$1.box;
        var lineStart = box[valueAxis + (reverse ? 2 : 1)];

        var diffStart = start[valueAxis] - lineStart;
        var diffEnd = end[valueAxis] - lineStart;

        var min = range.min + diffStart / scale;
        var max = range.min + diffEnd / scale;
        var rangeMin = Math.min(min, max);
        var rangeMax = Math.max(min, max);

        if (rangeMax - rangeMin >= MIN_CATEGORY_POINTS_RANGE) {
            return {
                min: rangeMin,
                max: rangeMax
            };
        }
    };

    CategoryAxis.prototype.valueRange = function valueRange () {
        return this.range();
    };

    CategoryAxis.prototype.totalIndex = function totalIndex (value) {
        var options = this.options;
        var index = this._categoriesMap ?
            this._categoriesMap.get(value) : indexOf(value, options.srcCategories);

        return index;
    };

    CategoryAxis.prototype.currentRangeIndices = function currentRangeIndices () {
        var options = this.options;
        var min = 0;

        if (isNumber(options.min)) {
            min = Math.floor(options.min);
        }

        var max;
        if (isNumber(options.max)) {
            max = options.justified ? Math.floor(options.max) : Math.ceil(options.max) - 1;
        } else {
            max = this.totalCount() - 1;
        }

        return {
            min: min,
            max: max
        };
    };

    CategoryAxis.prototype.limitedRangeIndices = function limitedRangeIndices (totalLimit) {
        var options = this.options;
        var min = isNumber(options.min) ? options.min : 0;
        var max;

        if (isNumber(options.max)) {
            max = options.max;
        } else if (isNumber(options.min)) {
            max = min + options.categories.length;
        } else {
            max = this.totalRange().max || 1;
        }

        if (totalLimit) {
            var totalRange = this.totalRange();
            min = limitValue(min, 0, totalRange.max);
            max = limitValue(max, 0, totalRange.max);
        }

        return {
            min: min,
            max: max
        };
    };

    CategoryAxis.prototype.totalRangeIndices = function totalRangeIndices () {
        return {
            min: 0,
            max: this.totalRange().max || 1
        };
    };

    CategoryAxis.prototype.indexCategories = function indexCategories () {
        if (!this._categoriesMap) {
            var map = this._categoriesMap = new HashMap();
            var srcCategories = this.options.srcCategories;
            for (var idx = 0; idx < srcCategories.length; idx++) {
                map.set(srcCategories[idx], idx);
            }
        }
    };

    CategoryAxis.prototype.totalCount = function totalCount () {
        return Math.max(this.options.srcCategories.length, this._seriesMax || 0);
    };

    return CategoryAxis;
}(Axis));

setDefaultOptions(CategoryAxis, {
    type: "category",
    vertical: false,
    majorGridLines: {
        visible: false,
        width: 1,
        color: BLACK$1
    },
    labels: {
        zIndex: 1
    },
    justified: false,
    _deferLabels: true
});

var COORDINATE_LIMIT = 300000;

var DateLabelFormats = {
    milliseconds: "HH:mm:ss.fff",
    seconds: "HH:mm:ss",
    minutes: "HH:mm",
    hours: "HH:mm",
    days: "M/d",
    weeks: "M/d",
    months: "MMM 'yy",
    years: "yyyy"
};

var ZERO_THRESHOLD = 0.2;

var AUTO$1 = "auto";
var BASE_UNITS = [
    MILLISECONDS, SECONDS, MINUTES, HOURS, DAYS, WEEKS, MONTHS, YEARS
];
var FIT = "fit";


function categoryRange(categories, clearCache) {
    if (clearCache) {
        categories._range = undefined;
    }

    var range = categories._range;
    if (!range) {
        range = categories._range = sparseArrayLimits(categories);
        range.min = toDate(range.min);
        range.max = toDate(range.max);
    }

    return range;
}

var EmptyDateRange = function EmptyDateRange(options) {
    this.options = options;
};

EmptyDateRange.prototype.displayIndices = function displayIndices () {
    return {
        min: 0,
        max: 1
    };
};

EmptyDateRange.prototype.displayRange = function displayRange () {
    return {};
};

EmptyDateRange.prototype.total = function total () {
    return {};
};

EmptyDateRange.prototype.valueRange = function valueRange () {
    return {};
};

EmptyDateRange.prototype.valueIndex = function valueIndex () {
    return -1;
};

EmptyDateRange.prototype.values = function values () {
    return [];
};

EmptyDateRange.prototype.totalIndex = function totalIndex () {
    return -1;
};

EmptyDateRange.prototype.valuesCount = function valuesCount () {
    return 0;
};

EmptyDateRange.prototype.totalCount = function totalCount () {
    return 0;
};

EmptyDateRange.prototype.dateAt = function dateAt () {
    return null;
};

var DateRange = function DateRange(start, end, options) {
    this.options = options;
    options.baseUnitStep = options.baseUnitStep || 1;

    var roundToBaseUnit = options.roundToBaseUnit;
    var justified = options.justified;

    this.start = addDuration(start, 0, options.baseUnit, options.weekStartDay);
    var lowerEnd = this.roundToTotalStep(end);
    var expandEnd = !justified && dateEquals(end, lowerEnd) && !options.justifyEnd;

    this.end = this.roundToTotalStep(end, !justified, expandEnd ? 1 : 0);

    var min = options.min || start;
    this.valueStart = this.roundToTotalStep(min);
    this.displayStart = roundToBaseUnit ? this.valueStart : min;

    var max = options.max;
    if (!max) {
        this.valueEnd = lowerEnd;
        this.displayEnd = roundToBaseUnit || expandEnd ? this.end : end;
    } else {
        var next = !justified && dateEquals(max, this.roundToTotalStep(max)) ? -1 : 0;
        this.valueEnd = this.roundToTotalStep(max, false, next);
        this.displayEnd = roundToBaseUnit ? this.roundToTotalStep(max, !justified) : options.max;
    }

    if (this.valueEnd < this.valueStart) {
        this.valueEnd = this.valueStart;
    }
    if (this.displayEnd <= this.displayStart) {
        this.displayEnd = this.roundToTotalStep(this.displayStart, false, 1);
    }
};

DateRange.prototype.displayRange = function displayRange () {
    return {
        min: this.displayStart,
        max: this.displayEnd
    };
};

DateRange.prototype.displayIndices = function displayIndices () {
    if (!this._indices) {
        var options = this.options;

        var baseUnit = options.baseUnit;
            var baseUnitStep = options.baseUnitStep;

        var minIdx = dateIndex(this.displayStart, this.valueStart, baseUnit, baseUnitStep);
        var maxIdx = dateIndex(this.displayEnd, this.valueStart, baseUnit, baseUnitStep);

        this._indices = { min: minIdx, max: maxIdx };
    }

    return this._indices;
};

DateRange.prototype.total = function total () {
    return {
        min: this.start,
        max: this.end
    };
};

DateRange.prototype.totalCount = function totalCount () {
    var last = this.totalIndex(this.end);

    return last + (this.options.justified ? 1 : 0);
};

DateRange.prototype.valueRange = function valueRange () {
    return {
        min: this.valueStart,
        max: this.valueEnd
    };
};

DateRange.prototype.valueIndex = function valueIndex (value) {
    var options = this.options;
    return Math.floor(dateIndex(value, this.valueStart, options.baseUnit, options.baseUnitStep));
};

DateRange.prototype.totalIndex = function totalIndex (value) {
    var options = this.options;
    return Math.floor(dateIndex(value, this.start, options.baseUnit, options.baseUnitStep));
};

DateRange.prototype.dateIndex = function dateIndex$1 (value) {
    var options = this.options;
    return dateIndex(value, this.valueStart, options.baseUnit, options.baseUnitStep);
};

DateRange.prototype.valuesCount = function valuesCount () {
    var maxIdx = this.valueIndex(this.valueEnd);

    return maxIdx + 1;
};

DateRange.prototype.values = function values () {
    var values = this._values;
    if (!values) {
        var options = this.options;
        var range = this.valueRange();
        this._values = values = [];

        for (var date = range.min; date <= range.max;) {
            values.push(date);
            date = addDuration(date, options.baseUnitStep, options.baseUnit, options.weekStartDay);
        }
    }

    return values;
};

DateRange.prototype.dateAt = function dateAt (index, total) {
    var options = this.options;

    return addDuration(total ? this.start : this.valueStart, options.baseUnitStep * index, options.baseUnit, options.weekStartDay);
};

DateRange.prototype.roundToTotalStep = function roundToTotalStep (value, upper, next) {
    var ref = this.options;
        var baseUnit = ref.baseUnit;
        var baseUnitStep = ref.baseUnitStep;
        var weekStartDay = ref.weekStartDay;
    var start = this.start;

    var step = dateIndex(value, start, baseUnit, baseUnitStep);
    var roundedStep = upper ? Math.ceil(step) : Math.floor(step);

    if (next) {
        roundedStep += next;
    }

    return addDuration(start, roundedStep * baseUnitStep, baseUnit, weekStartDay);
};

function autoBaseUnit(options, startUnit, startStep) {
    var categoryLimits = categoryRange(options.categories);
    var span = (options.max || categoryLimits.max) - (options.min || categoryLimits.min);
    var autoBaseUnitSteps = options.autoBaseUnitSteps;
    var maxDateGroups = options.maxDateGroups;
    var autoUnit = options.baseUnit === FIT;
    var autoUnitIx = startUnit ? BASE_UNITS.indexOf(startUnit) : 0;
    var baseUnit = autoUnit ? BASE_UNITS[autoUnitIx++] : options.baseUnit;
    var units = span / TIME_PER_UNIT[baseUnit];
    var totalUnits = units;
    var unitSteps, step, nextStep;

    while (!step || units >= maxDateGroups) {
        unitSteps = unitSteps || autoBaseUnitSteps[baseUnit].slice(0);

        do {
            nextStep = unitSteps.shift();
        } while (nextStep && startUnit === baseUnit && nextStep < startStep);

        if (nextStep) {
            step = nextStep;
            units = totalUnits / step;
        } else if (baseUnit === last(BASE_UNITS)) {
            step = Math.ceil(totalUnits / maxDateGroups);
            break;
        } else if (autoUnit) {
            baseUnit = BASE_UNITS[autoUnitIx++] || last(BASE_UNITS);
            totalUnits = span / TIME_PER_UNIT[baseUnit];
            unitSteps = null;
        } else {
            if (units > maxDateGroups) {
                step = Math.ceil(totalUnits / maxDateGroups);
            }
            break;
        }
    }

    options.baseUnitStep = step;
    options.baseUnit = baseUnit;
}

function defaultBaseUnit(options) {
    var categories = options.categories;
    var count = defined(categories) ? categories.length : 0;
    var minDiff = MAX_VALUE;
    var lastCategory, unit;

    for (var categoryIx = 0; categoryIx < count; categoryIx++) {
        var category = categories[categoryIx];

        if (category && lastCategory) {
            var diff = Math.abs(absoluteDateDiff(category, lastCategory));

            if (diff !== 0) {
                minDiff = Math.min(minDiff, diff);

                if (minDiff >= TIME_PER_YEAR) {
                    unit = YEARS;
                } else if (minDiff >= TIME_PER_MONTH - TIME_PER_DAY * 3) {
                    unit = MONTHS;
                } else if (minDiff >= TIME_PER_WEEK) {
                    unit = WEEKS;
                } else if (minDiff >= TIME_PER_DAY) {
                    unit = DAYS;
                } else if (minDiff >= TIME_PER_HOUR) {
                    unit = HOURS;
                } else if (minDiff >= TIME_PER_MINUTE) {
                    unit = MINUTES;
                } else {
                    unit = SECONDS;
                }
            }
        }

        lastCategory = category;
    }

    options.baseUnit = unit || DAYS;
}

function initUnit(options) {
    var baseUnit = (options.baseUnit || "").toLowerCase();
    var useDefault = baseUnit !== FIT && !inArray(baseUnit, BASE_UNITS);

    if (useDefault) {
        defaultBaseUnit(options);
    }

    if (baseUnit === FIT || options.baseUnitStep === AUTO$1) {
        autoBaseUnit(options);
    }

    return options;
}

var DateCategoryAxis = (function (CategoryAxis) {
    function DateCategoryAxis () {
        CategoryAxis.apply(this, arguments);
    }

    if ( CategoryAxis ) DateCategoryAxis.__proto__ = CategoryAxis;
    DateCategoryAxis.prototype = Object.create( CategoryAxis && CategoryAxis.prototype );
    DateCategoryAxis.prototype.constructor = DateCategoryAxis;

    DateCategoryAxis.prototype.clone = function clone () {
        var copy = new DateCategoryAxis(Object.assign({}, this.options), this.chartService);
        copy.createLabels();

        return copy;
    };

    DateCategoryAxis.prototype.categoriesHash = function categoriesHash () {
        var start = this.dataRange.total().min;
        return this.options.baseUnit + this.options.baseUnitStep + start;
    };

    DateCategoryAxis.prototype.initUserOptions = function initUserOptions (options) {
        return options;
    };

    DateCategoryAxis.prototype.initFields = function initFields () {
        CategoryAxis.prototype.initFields.call(this);

        var chartService = this.chartService;
        var intlService = chartService.intl;
        var options = this.options;

        var categories = options.categories || [];
        if (!categories._parsed) {
            categories = parseDates(intlService, categories);
            categories._parsed = true;
        }

        options = deepExtend({
            roundToBaseUnit: true
        }, options, {
            categories: categories,
            min: parseDate(intlService, options.min),
            max: parseDate(intlService, options.max),
            weekStartDay: firstDay(options, intlService)
        });

        if (chartService.panning && chartService.isPannable(options.vertical ? Y : X)) {
            options.roundToBaseUnit = false;
        }

        options.userSetBaseUnit = options.userSetBaseUnit || options.baseUnit;
        options.userSetBaseUnitStep = options.userSetBaseUnitStep || options.baseUnitStep;

        this.options = options;
        options.srcCategories = categories;

        if (categories.length > 0) {
            var range = categoryRange(categories, true);
            var maxDivisions = options.maxDivisions;
            var safeOptions = initUnit(options);

            var forecast = options._forecast;
            if (forecast) {
                if (forecast.before > 0) {
                    range.min = addDuration(range.min, -forecast.before, safeOptions.baseUnit, safeOptions.weekStartDay);
                }

                if (forecast.after > 0) {
                    range.max = addDuration(range.max, forecast.after, safeOptions.baseUnit, safeOptions.weekStartDay);
                }
            }

            this.dataRange = new DateRange(range.min, range.max, safeOptions);

            if (maxDivisions) {
                var dataRange = this.dataRange.displayRange();

                var divisionOptions = Object.assign({}, options, {
                    justified: true,
                    roundToBaseUnit: false,
                    baseUnit: 'fit',
                    min: dataRange.min,
                    max: dataRange.max,
                    maxDateGroups: maxDivisions
                });

                var dataRangeOptions = this.dataRange.options;

                autoBaseUnit(divisionOptions, dataRangeOptions.baseUnit, dataRangeOptions.baseUnitStep);

                this.divisionRange = new DateRange(range.min, range.max, divisionOptions);
            } else {
                this.divisionRange = this.dataRange;
            }

        } else {
            options.baseUnit = options.baseUnit || DAYS;
            this.dataRange = this.divisionRange = new EmptyDateRange(options);
        }

        this.rangeLabels = [];
    };

    DateCategoryAxis.prototype.tickIndices = function tickIndices (stepSize) {
        var ref = this;
        var dataRange = ref.dataRange;
        var divisionRange = ref.divisionRange;
        var valuesCount = divisionRange.valuesCount();

        if (!this.options.maxDivisions || !valuesCount) {
            return CategoryAxis.prototype.tickIndices.call(this, stepSize);
        }

        var indices = [];
        var values = divisionRange.values();
        var offset = 0;

        if (!this.options.justified) {
            values = values.concat(divisionRange.dateAt(valuesCount));
            offset = 0.5;//align ticks to the center of not justified categories
        }

        for (var idx = 0; idx < values.length; idx++) {
            indices.push(dataRange.dateIndex(values[idx]) + offset);
            if (stepSize !== 1 && idx >= 1) {
                var last = indices.length - 1;
                indices.splice(idx, 0, indices[last - 1] + (indices[last] - indices[last - 1]) * stepSize);
            }
        }

        return indices;
    };

    DateCategoryAxis.prototype.shouldRenderNote = function shouldRenderNote (value) {
        var range = this.range();
        var categories = this.options.categories || [];

        return dateComparer(value, range.min) >= 0 && dateComparer(value, range.max) <= 0 && categories.length;
    };

    DateCategoryAxis.prototype.parseNoteValue = function parseNoteValue (value) {
        return parseDate(this.chartService.intl, value);
    };

    DateCategoryAxis.prototype.noteSlot = function noteSlot (value) {
        return this.getSlot(value);
    };

    DateCategoryAxis.prototype.translateRange = function translateRange (delta) {
        var options = this.options;
        var baseUnit = options.baseUnit;
        var weekStartDay = options.weekStartDay;
        var vertical = options.vertical;
        var lineBox = this.lineBox();
        var size = vertical ? lineBox.height() : lineBox.width();
        var range = this.range();
        var scale = size / (range.max - range.min);
        var offset = round$1(delta / scale, DEFAULT_PRECISION);

        if (range.min && range.max) {
            var from = addTicks(options.min || range.min, offset);
            var to = addTicks(options.max || range.max, offset);

            range = {
                min: addDuration(from, 0, baseUnit, weekStartDay),
                max: addDuration(to, 0, baseUnit, weekStartDay)
            };
        }

        return range;
    };

    DateCategoryAxis.prototype.labelsRange = function labelsRange () {
        return {
            min: this.options.labels.skip,
            max: this.divisionRange.valuesCount()
        };
    };

    DateCategoryAxis.prototype.pan = function pan (delta) {
        if (this.isEmpty()) {
            return null;
        }

        var options = this.options;
        var lineBox = this.lineBox();
        var size = options.vertical ? lineBox.height() : lineBox.width();
        var ref = this.dataRange.displayRange();
        var min = ref.min;
        var max = ref.max;
        var totalLimits = this.dataRange.total();
        var scale = size / (max - min);
        var offset = round$1(delta / scale, DEFAULT_PRECISION) * (options.reverse ? -1 : 1);
        var from = addTicks(min, offset);
        var to = addTicks(max, offset);

        var panRange = this.limitRange(toTime(from), toTime(to), toTime(totalLimits.min), toTime(totalLimits.max), offset);

        if (panRange) {
            panRange.min = toDate(panRange.min);
            panRange.max = toDate(panRange.max);
            panRange.baseUnit = options.baseUnit;
            panRange.baseUnitStep = options.baseUnitStep || 1;
            panRange.userSetBaseUnit = options.userSetBaseUnit;
            panRange.userSetBaseUnitStep = options.userSetBaseUnitStep;

            return panRange;
        }
    };

    DateCategoryAxis.prototype.pointsRange = function pointsRange (start, end) {
        if (this.isEmpty()) {
            return null;
        }

        var pointsRange = CategoryAxis.prototype.pointsRange.call(this, start, end);
        var datesRange = this.dataRange.displayRange();
        var indicesRange = this.dataRange.displayIndices();
        var scale = dateDiff(datesRange.max, datesRange.min) / (indicesRange.max - indicesRange.min);
        var options = this.options;

        var min = addTicks(datesRange.min, pointsRange.min * scale);
        var max = addTicks(datesRange.min, pointsRange.max * scale);

        return {
            min: min,
            max: max,
            baseUnit: options.userSetBaseUnit || options.baseUnit,
            baseUnitStep: options.userSetBaseUnitStep || options.baseUnitStep
        };
    };

    DateCategoryAxis.prototype.scaleRange = function scaleRange (scale, cursor) {
        if (this.isEmpty()) {
            return {};
        }

        var options = this.options;
        var fit = options.userSetBaseUnit === FIT;
        var totalLimits = this.dataRange.total();
        var ref = this.dataRange.displayRange();
        var rangeMin = ref.min;
        var rangeMax = ref.max;

        var position = Math.abs(this.pointOffset(cursor));
        var range = rangeMax - rangeMin;
        var delta = this.scaleToDelta(scale, range);
        var minDelta = Math.round(position * delta);
        var maxDelta = Math.round((1 - position) * delta);

        var ref$1 = this.dataRange.options;
        var baseUnit = ref$1.baseUnit;
        var min = new Date(rangeMin.getTime() + minDelta);
        var max = new Date(rangeMax.getTime() - maxDelta);

        if (fit) {
            var autoBaseUnitSteps = options.autoBaseUnitSteps;
            var maxDateGroups = options.maxDateGroups;

            var maxDiff = last(autoBaseUnitSteps[baseUnit]) * maxDateGroups * TIME_PER_UNIT[baseUnit];
            var rangeDiff = dateDiff(rangeMax, rangeMin);
            var diff = dateDiff(max, min);
            var baseUnitIndex = BASE_UNITS.indexOf(baseUnit);
            var autoBaseUnitStep, ticks;

            if (diff < TIME_PER_UNIT[baseUnit] && baseUnit !== MILLISECONDS) {
                baseUnit = BASE_UNITS[baseUnitIndex - 1];
                autoBaseUnitStep = last(autoBaseUnitSteps[baseUnit]);
                ticks = (rangeDiff - (maxDateGroups - 1) * autoBaseUnitStep * TIME_PER_UNIT[baseUnit]) / 2;
                min = addTicks(rangeMin, ticks);
                max = addTicks(rangeMax, -ticks);

            } else if (diff > maxDiff && baseUnit !== YEARS) {
                var stepIndex = 0;

                do {
                    baseUnitIndex++;
                    baseUnit = BASE_UNITS[baseUnitIndex];
                    stepIndex = 0;
                    ticks = 2 * TIME_PER_UNIT[baseUnit];
                    do {
                        autoBaseUnitStep = autoBaseUnitSteps[baseUnit][stepIndex];
                        stepIndex++;
                    } while (stepIndex < autoBaseUnitSteps[baseUnit].length && ticks * autoBaseUnitStep < rangeDiff);
                } while (baseUnit !== YEARS && ticks * autoBaseUnitStep < rangeDiff);

                ticks = (ticks * autoBaseUnitStep - rangeDiff) / 2;
                if (ticks > 0) {
                    min = addTicks(rangeMin, -ticks);
                    max = addTicks(rangeMax, ticks);
                    min = addTicks(min, limitValue(max, totalLimits.min, totalLimits.max) - max);
                    max = addTicks(max, limitValue(min, totalLimits.min, totalLimits.max) - min);
                }
            }
        }

        if (min && max && dateDiff(max, min) > 0) {
            return {
                min: min,
                max: max,
                baseUnit: options.userSetBaseUnit || options.baseUnit,
                baseUnitStep: options.userSetBaseUnitStep || options.baseUnitStep
            };
        }
    };

    DateCategoryAxis.prototype.zoomRange = function zoomRange (scale, cursor) {
        var totalLimits = this.dataRange.total();
        var range = this.scaleRange(scale, cursor);

        if (range) {
            if (range.min < totalLimits.min) {
                range.min = totalLimits.min;
            }
            if (range.max > totalLimits.max) {
                range.max = totalLimits.max;
            }
        }

        return range;
    };

    DateCategoryAxis.prototype.range = function range () {
        return this.dataRange.displayRange();
    };

    DateCategoryAxis.prototype.createLabels = function createLabels () {
        CategoryAxis.prototype.createLabels.call(this);
        this.createRangeLabels();
    };

    DateCategoryAxis.prototype.clearLabels = function clearLabels () {
        CategoryAxis.prototype.clearLabels.call(this);
        this.rangeLabels = [];
    };

    DateCategoryAxis.prototype.arrangeLabels = function arrangeLabels () {
        this.arrangeRangeLabels();
        CategoryAxis.prototype.arrangeLabels.call(this);
    };

    DateCategoryAxis.prototype.arrangeRangeLabels = function arrangeRangeLabels () {
        var ref = this;
        var options = ref.options;
        var rangeLabels = ref.rangeLabels;
        if (rangeLabels.length === 0) {
            return;
        }

        var lineBox = this.lineBox();
        var vertical = options.vertical;
        var mirror = options.rangeLabels.mirror || options.labels.mirror;

        var firstLabel = rangeLabels[0];
        if (firstLabel) {
            var position = vertical ? lineBox.y1 - (firstLabel.box.height() / 2) : lineBox.x1;
            this.positionLabel(firstLabel, mirror, position);
        }

        var lastLabel = rangeLabels[1];
        if (lastLabel) {
            var position$1 = vertical ? lineBox.y2 - (lastLabel.box.height() / 2) : lineBox.x2;
            this.positionLabel(lastLabel, mirror, position$1);
        }
    };

    DateCategoryAxis.prototype.autoRotateLabels = function autoRotateLabels () {
        CategoryAxis.prototype.autoRotateLabels.call(this);
        this.autoRotateRangeLabels();
    };

    DateCategoryAxis.prototype.hideOutOfRangeLabels = function hideOutOfRangeLabels () {
        CategoryAxis.prototype.hideOutOfRangeLabels.call(this);
        this.hideOverlappingLabels();
    };

    DateCategoryAxis.prototype.hideOverlappingLabels = function hideOverlappingLabels () {
        var ref = this;
        var rangeLabels = ref.rangeLabels;
        var labels = ref.labels;
        if (rangeLabels.length === 0) {
            return;
        }

        function clip(rangeLabel, label) {
            if (!label.options.visible || label.box.overlaps(rangeLabel.box)) {
                label.options.visible = false;
                return true;
            }

            return false;
        }

        var firstRangeLabel = rangeLabels[0];
        if (firstRangeLabel && firstRangeLabel.options.visible) {
            for (var i = 0; i < labels.length; i++) {
                var overlaps = clip(firstRangeLabel, labels[i]);
                if (!overlaps) {
                    break;
                }
            }
        }

        var lastRangeLabel = rangeLabels[1];
        if (lastRangeLabel && lastRangeLabel.options.visible) {
            for (var i$1 = labels.length - 1; i$1 > 0; --i$1) {
                var overlaps$1 = clip(lastRangeLabel, labels[i$1]);
                if (!overlaps$1) {
                    break;
                }
            }
        }
    };

    DateCategoryAxis.prototype.contentBox = function contentBox () {
        var box = CategoryAxis.prototype.contentBox.call(this);
        var rangeLabels = this.rangeLabels;

        for (var i = 0; i < rangeLabels.length; i++) {
            var label = rangeLabels[i];
            if (label.options.visible) {
                box.wrap(label.box);
            }
        }

        return box;
    };

    DateCategoryAxis.prototype.createAxisLabel = function createAxisLabel (index, labelOptions, labelContext) {
        if ( labelContext === void 0 ) labelContext = {};

        var options = this.options;
        var dataItem = options.dataItems && !options.maxDivisions ? options.dataItems[index] : null;
        var date = this.divisionRange.dateAt(index);
        var unitFormat = labelOptions.dateFormats[this.divisionRange.options.baseUnit];

        labelOptions.format = labelOptions.format || unitFormat;
        labelContext.dataItem = dataItem;

        var text = this.axisLabelText(date, labelOptions, labelContext);
        if (text) {
            return new AxisLabel(date, text, index, dataItem, labelOptions);
        }
    };

    DateCategoryAxis.prototype.createRangeLabels = function createRangeLabels () {
        var this$1$1 = this;

        var ref = this.divisionRange;
        var displayStart = ref.displayStart;
        var displayEnd = ref.displayEnd;
        var options = this.options;
        var labelOptions = Object.assign({}, options.labels, options.rangeLabels, {
            align: CENTER,
            zIndex: options.zIndex
        });

        if (labelOptions.visible !== true) {
            return;
        }

        this.normalizeLabelRotation(labelOptions);
        labelOptions.alignRotation = CENTER;

        if (labelOptions.rotation === "auto") {
            labelOptions.rotation = 0;
            options.autoRotateRangeLabels = true;
        }

        var unitFormat = labelOptions.dateFormats[this.divisionRange.options.baseUnit];
        labelOptions.format = labelOptions.format || unitFormat;

        var createLabel = function (index, date, text) {
            if (text) {
                var label = new AxisLabel(date, text, index, null, labelOptions);
                this$1$1.append(label);
                this$1$1.rangeLabels.push(label);
            }
        };

        var startText = this.axisLabelText(displayStart, labelOptions, { index: 0, count: 2 });
        createLabel(0, displayStart, startText);

        var endText = this.axisLabelText(displayEnd, labelOptions, { index: 1, count: 2 });
        createLabel(1, displayEnd, endText);
    };

    DateCategoryAxis.prototype.autoRotateRangeLabels = function autoRotateRangeLabels () {
        var this$1$1 = this;

        var labels = this.rangeLabels;
        if (!this.options.autoRotateRangeLabels || this.options.vertical || labels.length !== 2) {
            return;
        }

        var rotateLabel = function (label, tickPositions, index) {
            var width = Math.abs(tickPositions[index + 1] - tickPositions[index]) * 2;
            var angle = this$1$1.autoRotateLabelAngle(label.box, width);
            if (angle !== 0) {
                label.options.rotation = angle;
                label.reflow(new Box());
            }
        };

        var tickPositions = this.getMajorTickPositions();
        rotateLabel(labels[0], tickPositions, 0);
        rotateLabel(labels[1], tickPositions, tickPositions.length - 2);
    };

    DateCategoryAxis.prototype.categoryIndex = function categoryIndex (value) {
        return this.dataRange.valueIndex(value);
    };

    DateCategoryAxis.prototype.slot = function slot (from, to, limit) {
        var dateRange = this.dataRange;
        var start = from;
        var end = to;

        if (start instanceof Date) {
            start = dateRange.dateIndex(start);
        }

        if (end instanceof Date) {
            end = dateRange.dateIndex(end);
        }

        var slot = this.getSlot(start, end, limit);
        if (slot) {
            return slot.toRect();
        }
    };

    DateCategoryAxis.prototype.getSlot = function getSlot (a, b, limit) {
        var start = a;
        var end = b;

        if (typeof start === OBJECT$1) {
            start = this.categoryIndex(start);
        }

        if (typeof end === OBJECT$1) {
            end = this.categoryIndex(end);
        }

        return CategoryAxis.prototype.getSlot.call(this, start, end, limit);
    };

    DateCategoryAxis.prototype.valueRange = function valueRange () {
        var options = this.options;
        var range = categoryRange(options.srcCategories);

        return {
            min: toDate(range.min),
            max: toDate(range.max)
        };
    };

    DateCategoryAxis.prototype.categoryAt = function categoryAt (index, total) {
        return this.dataRange.dateAt(index, total);
    };

    DateCategoryAxis.prototype.categoriesCount = function categoriesCount () {
        return this.dataRange.valuesCount();
    };

    DateCategoryAxis.prototype.rangeIndices = function rangeIndices () {
        return this.dataRange.displayIndices();
    };

    DateCategoryAxis.prototype.labelsBetweenTicks = function labelsBetweenTicks () {
        return !this.divisionRange.options.justified;
    };

    DateCategoryAxis.prototype.prepareUserOptions = function prepareUserOptions () {
        if (this.isEmpty()) {
            return;
        }

        this.options.categories = this.dataRange.values();
    };

    DateCategoryAxis.prototype.getCategory = function getCategory (point) {
        var index = this.pointCategoryIndex(point);

        if (index === null) {
            return null;
        }

        return this.dataRange.dateAt(index);
    };

    DateCategoryAxis.prototype.totalIndex = function totalIndex (value) {
        return this.dataRange.totalIndex(value);
    };

    DateCategoryAxis.prototype.currentRangeIndices = function currentRangeIndices () {
        var range = this.dataRange.valueRange();
        return {
            min: this.dataRange.totalIndex(range.min),
            max: this.dataRange.totalIndex(range.max)
        };
    };

    DateCategoryAxis.prototype.totalRange = function totalRange () {
        return this.dataRange.total();
    };

    DateCategoryAxis.prototype.totalRangeIndices = function totalRangeIndices () {
        var range = this.dataRange.total();
        return {
            min: this.dataRange.totalIndex(range.min),
            max: this.dataRange.totalIndex(range.max)
        };
    };

    DateCategoryAxis.prototype.totalCount = function totalCount () {
        return this.dataRange.totalCount();
    };

    DateCategoryAxis.prototype.isEmpty = function isEmpty () {
        return !this.options.srcCategories.length;
    };

    DateCategoryAxis.prototype.roundedRange = function roundedRange () {
        if (this.options.roundToBaseUnit !== false || this.isEmpty()) {
            return this.range();
        }

        var options = this.options;
        var datesRange = categoryRange(options.srcCategories);

        var dateRange = new DateRange(datesRange.min, datesRange.max, Object.assign({}, options, {
            justified: false,
            roundToBaseUnit: true,
            justifyEnd: false
        }));

        return dateRange.displayRange();
    };

    return DateCategoryAxis;
}(CategoryAxis));

setDefaultOptions(DateCategoryAxis, {
    type: DATE,
    labels: {
        dateFormats: DateLabelFormats
    },
    rangeLabels: {
        visible: false
    },
    autoBaseUnitSteps: {
        milliseconds: [ 1, 10, 100 ],
        seconds: [ 1, 2, 5, 15, 30 ],
        minutes: [ 1, 2, 5, 15, 30 ],
        hours: [ 1, 2, 3 ],
        days: [ 1, 2, 3 ],
        weeks: [ 1, 2 ],
        months: [ 1, 2, 3, 6 ],
        years: [ 1, 2, 3, 5, 10, 25, 50 ]
    },
    maxDateGroups: 10
});

function autoAxisMin$1(min, max, narrow) {
    if (!min && !max) {
        return 0;
    }

    var axisMin;

    if (min >= 0 && max >= 0) {
        var minValue = min === max ? 0 : min;

        var diff = (max - minValue) / max;
        if (narrow === false || (!narrow && diff > ZERO_THRESHOLD)) {
            return 0;
        }

        axisMin = Math.max(0, minValue - ((max - minValue) / 2));
    } else {
        axisMin = min;
    }

    return axisMin;
}

function autoAxisMax$1(min, max, narrow) {
    if (!min && !max) {
        return 1;
    }

    var axisMax;

    if (min <= 0 && max <= 0) {
        var maxValue = min === max ? 0 : max;

        var diff = Math.abs((maxValue - min) / maxValue);
        if (narrow === false || (!narrow && diff > ZERO_THRESHOLD)) {
            return 0;
        }

        axisMax = Math.min(0, maxValue - ((min - maxValue) / 2));
    } else {
        axisMax = max;
    }

    return axisMax;
}

function floor(value, step) {
    return round$1(Math.floor(value / step) * step, DEFAULT_PRECISION);
}

function ceil(value, step) {
    return round$1(Math.ceil(value / step) * step, DEFAULT_PRECISION);
}

function limitCoordinate(value) {
    return Math.max(Math.min(value, COORDINATE_LIMIT), -COORDINATE_LIMIT);
}

var MIN_VALUE_RANGE$2 = Math.pow(10, -DEFAULT_PRECISION + 1);

var NumericAxis = (function (Axis) {
    function NumericAxis(seriesMin, seriesMax, options, chartService) {
        Axis.call(this, Object.assign({}, options, {
            seriesMin: seriesMin,
            seriesMax: seriesMax
        }), chartService);
    }

    if ( Axis ) NumericAxis.__proto__ = Axis;
    NumericAxis.prototype = Object.create( Axis && Axis.prototype );
    NumericAxis.prototype.constructor = NumericAxis;

    NumericAxis.prototype.initUserOptions = function initUserOptions (options) {
        var autoOptions = autoAxisOptions(options.seriesMin, options.seriesMax, options);
        this.totalOptions = totalAxisOptions(autoOptions, options);

        return axisOptions(autoOptions, options);
    };

    NumericAxis.prototype.initFields = function initFields () {
        this.totalMin = this.totalOptions.min;
        this.totalMax = this.totalOptions.max;
        this.totalMajorUnit = this.totalOptions.majorUnit;
        this.seriesMin = this.options.seriesMin;
        this.seriesMax = this.options.seriesMax;
    };

    NumericAxis.prototype.clone = function clone () {
        return new NumericAxis(
            this.seriesMin,
            this.seriesMax,
            Object.assign({}, this.options),
            this.chartService
        );
    };

    NumericAxis.prototype.startValue = function startValue () {
        return 0;
    };

    NumericAxis.prototype.range = function range () {
        var options = this.options;
        return { min: options.min, max: options.max };
    };

    NumericAxis.prototype.getDivisions = function getDivisions (stepValue) {
        if (stepValue === 0) {
            return 1;
        }

        var options = this.options;
        var range = options.max - options.min;

        return Math.floor(round$1(range / stepValue, COORD_PRECISION)) + 1;
    };

    NumericAxis.prototype.getTickPositions = function getTickPositions (unit, skipUnit) {
        var options = this.options;
        var ref = this.lineInfo();
        var axisDir = ref.axisDir;
        var axisOrigin = ref.axisOrigin;
        var lineBox = ref.lineBox;
        var lineSize = ref.lineSize;
        var range = options.max - options.min;
        var scale = lineSize / range;
        var step = unit * scale;
        var divisions = this.getDivisions(unit);
        var positions = [];
        var pos = lineBox[axisOrigin];
        var skipStep = 0;

        if (skipUnit) {
            skipStep = skipUnit / unit;
        }

        for (var idx = 0; idx < divisions; idx++) {
            if (idx % skipStep !== 0) {
                positions.push(round$1(pos, COORD_PRECISION));
            }

            pos = pos + step * axisDir;
        }

        return positions;
    };

    NumericAxis.prototype.getMajorTickPositions = function getMajorTickPositions () {
        return this.getTickPositions(this.options.majorUnit);
    };

    NumericAxis.prototype.getMinorTickPositions = function getMinorTickPositions () {
        return this.getTickPositions(this.options.minorUnit);
    };

    NumericAxis.prototype.getSlot = function getSlot (a, b, limit) {
        if ( limit === void 0 ) limit = false;

        var options = this.options;
        var ref = this.lineInfo();
        var axis = ref.axis;
        var axisDir = ref.axisDir;
        var lineBox = ref.lineBox;
        var lineSize = ref.lineSize;
        var lineStart = ref.lineStart;
        var step = axisDir * (lineSize / (options.max - options.min));

        var start = valueOrDefault(a, b || 0);
        var end = valueOrDefault(b, a || 0);

        if (limit) {
            start = limitValue(start, options.min, options.max);
            end = limitValue(end, options.min, options.max);
        }

        var p1 = Math.min(start, end) - options.min;
        var p2 = Math.max(start, end) - options.min;

        var slotBox = new Box(lineBox.x1, lineBox.y1, lineBox.x1, lineBox.y1);
        slotBox[axis + 1] = limitCoordinate(lineStart + step * (axisDir > 0 ? p1 : p2));
        slotBox[axis + 2] = limitCoordinate(lineStart + step * (axisDir > 0 ? p2 : p1));

        return slotBox;
    };

    NumericAxis.prototype.getValue = function getValue (point) {
        var options = this.options;
        var max = Number(options.max);
        var min = Number(options.min);
        var offset = this.pointOffset(point);
        var valueOffset = offset * (max - min);

        if (offset < 0 || offset > 1) {
            return null;
        }

        var value = min + valueOffset;
        return round$1(value, DEFAULT_PRECISION);
    };

    NumericAxis.prototype.translateRange = function translateRange (delta) {
        var options = this.options;
        var vertical = options.vertical;
        var reverse = options.reverse;
        var max = options.max;
        var min = options.min;
        var ref = this.lineInfo();
        var lineSize = ref.lineSize;
        var range = max - min;
        var scale = lineSize / range;
        var offset = round$1(delta / scale, DEFAULT_PRECISION);

        if ((vertical || reverse) && !(vertical && reverse )) {
            offset = -offset;
        }

        return {
            min: min + offset,
            max: max + offset,
            offset: offset
        };
    };

    NumericAxis.prototype.labelsCount = function labelsCount () {
        return this.getDivisions(this.options.majorUnit);
    };

    NumericAxis.prototype.createAxisLabel = function createAxisLabel (index, labelOptions, labelContext) {
        var options = this.options;
        var value = round$1(options.min + (index * options.majorUnit), DEFAULT_PRECISION);
        var text = this.axisLabelText(value, labelOptions, labelContext);

        return new AxisLabel(value, text, index, null, labelOptions);
    };

    NumericAxis.prototype.shouldRenderNote = function shouldRenderNote (value) {
        var range = this.range();
        return range.min <= value && value <= range.max;
    };

    NumericAxis.prototype.pan = function pan (delta) {
        var range = this.translateRange(delta);
        return this.limitRange(range.min, range.max, this.totalMin, this.totalMax, range.offset);
    };

    NumericAxis.prototype.pointsRange = function pointsRange (start, end) {
        var startValue = this.getValue(start);
        var endValue = this.getValue(end);
        var min = Math.min(startValue, endValue);
        var max = Math.max(startValue, endValue);

        if (this.isValidRange(min, max)) {
            return {
                min: min,
                max: max
            };
        }
    };

    NumericAxis.prototype.scaleRange = function scaleRange (scale, cursor) {
        var position = Math.abs(this.pointOffset(cursor));
        var range = this.options.max - this.options.min;
        var delta = this.scaleToDelta(scale, range);
        var minDelta = position * delta;
        var maxDelta = (1 - position) * delta;
        var min = round$1(this.options.min + minDelta, DEFAULT_PRECISION);
        var max = round$1(this.options.max - maxDelta, DEFAULT_PRECISION);

        if (max - min < MIN_VALUE_RANGE$2) {
            max = min + MIN_VALUE_RANGE$2;
        }

        return {
            min: min,
            max: max
        };
    };

    NumericAxis.prototype.zoomRange = function zoomRange (scale, cursor) {
        var ref = this;
        var totalMin = ref.totalMin;
        var totalMax = ref.totalMax;
        var range = this.scaleRange(scale, cursor);

        return {
            min: limitValue(range.min, totalMin, totalMax),
            max: limitValue(range.max, totalMin, totalMax),
            narrowRange: false
        };
    };

    NumericAxis.prototype.isValidRange = function isValidRange (min, max) {
        return max - min > MIN_VALUE_RANGE$2;
    };

    return NumericAxis;
}(Axis));

function autoAxisOptions(seriesMin, seriesMax, options) {
    var narrowRange = options.narrowRange;

    var autoMin = autoAxisMin$1(seriesMin, seriesMax, narrowRange);
    var autoMax = autoAxisMax$1(seriesMin, seriesMax, narrowRange);

    var majorUnit = autoMajorUnit(autoMin, autoMax);
    var autoOptions = {
        majorUnit: majorUnit
    };

    if (options.roundToMajorUnit !== false) {
        if (autoMin < 0 && remainderClose(autoMin, majorUnit, 1 / 3)) {
            autoMin -= majorUnit;
        }

        if (autoMax > 0 && remainderClose(autoMax, majorUnit, 1 / 3)) {
            autoMax += majorUnit;
        }
    }

    autoOptions.min = floor(autoMin, majorUnit);
    autoOptions.max = ceil(autoMax, majorUnit);

    return autoOptions;
}

function totalAxisOptions(autoOptions, options) {
    return {
        min: defined(options.min) ? Math.min(autoOptions.min, options.min) : autoOptions.min,
        max: defined(options.max) ? Math.max(autoOptions.max, options.max) : autoOptions.max,
        majorUnit: autoOptions.majorUnit
    };
}

function clearNullValues(options, fields) {
    for (var idx = 0; idx < fields.length; idx++) {
        var field = fields[idx];
        if (options[field] === null) {
            options[field] = undefined;
        }
    }
}

function axisOptions(autoOptions, userOptions) {
    var options = userOptions;
    var userSetMin, userSetMax;

    if (userOptions) {
        clearNullValues(userOptions, [ 'min', 'max' ]);

        userSetMin = defined(userOptions.min);
        userSetMax = defined(userOptions.max);

        var userSetLimits = userSetMin || userSetMax;

        if (userSetLimits) {
            if (userOptions.min === userOptions.max) {
                if (userOptions.min > 0) {
                    userOptions.min = 0;
                } else {
                    userOptions.max = 1;
                }
            }
        }

        if (userOptions.majorUnit) {
            autoOptions.min = floor(autoOptions.min, userOptions.majorUnit);
            autoOptions.max = ceil(autoOptions.max, userOptions.majorUnit);
        } else if (userSetLimits) {
            options = deepExtend(autoOptions, userOptions);

            // Determine an auto major unit after min/max have been set
            autoOptions.majorUnit = autoMajorUnit(options.min, options.max);
        }
    }

    autoOptions.minorUnit = (options.majorUnit || autoOptions.majorUnit) / 5;

    var result = deepExtend(autoOptions, options);
    if (result.min >= result.max) {
        if (userSetMin && !userSetMax) {
            result.max = result.min + result.majorUnit;
        } else if (!userSetMin && userSetMax) {
            result.min = result.max - result.majorUnit;
        }
    }

    return result;
}

function remainderClose(value, divisor, ratio) {
    var remainder = round$1(Math.abs(value % divisor), DEFAULT_PRECISION);
    var threshold = divisor * (1 - ratio);

    return remainder === 0 || remainder > threshold;
}

setDefaultOptions(NumericAxis, {
    type: "numeric",
    min: 0,
    max: 1,
    vertical: true,
    majorGridLines: {
        visible: true,
        width: 1,
        color: BLACK$1
    },
    labels: {
        format: "#.####################"
    },
    zIndex: 1
});

var MIN_VALUE_RANGE$1 = 1000;

var DateValueAxis = (function (Axis) {
    function DateValueAxis(seriesMin, seriesMax, axisOptions, chartService) {
        var min = toDate(seriesMin);
        var max = toDate(seriesMax);

        var intlService = chartService.intl;
        var options = axisOptions || {};
        options = deepExtend(options || {}, {
            min: parseDate(intlService, options.min),
            max: parseDate(intlService, options.max),
            axisCrossingValue: parseDates(intlService, options.axisCrossingValues || options.axisCrossingValue),
            weekStartDay: firstDay(options, intlService)
        });
        options = applyDefaults(min, max, options);

        Axis.call(this, options, chartService);

        this.intlService = intlService;
        this.seriesMin = min;
        this.seriesMax = max;

        var weekStartDay = options.weekStartDay || 0;
        this.totalMin = toTime(floorDate(toTime(min) - 1, options.baseUnit, weekStartDay));
        this.totalMax = toTime(ceilDate(toTime(max) + 1, options.baseUnit, weekStartDay));
    }

    if ( Axis ) DateValueAxis.__proto__ = Axis;
    DateValueAxis.prototype = Object.create( Axis && Axis.prototype );
    DateValueAxis.prototype.constructor = DateValueAxis;

    DateValueAxis.prototype.clone = function clone () {
        return new DateValueAxis(this.seriesMin, this.seriesMax, Object.assign({}, this.options), this.chartService);
    };

    DateValueAxis.prototype.range = function range () {
        var options = this.options;
        return { min: options.min, max: options.max };
    };

    DateValueAxis.prototype.getDivisions = function getDivisions (stepValue) {
        var options = this.options;

        return Math.floor(
            duration(options.min, options.max, options.baseUnit) / stepValue + 1
        );
    };

    DateValueAxis.prototype.getTickPositions = function getTickPositions (step) {
        var options = this.options;
        var ref = this.lineInfo();
        var dir = ref.axisDir;
        var lineSize = ref.lineSize;
        var start = ref.lineStart;
        var divisions = this.getDivisions(step);
        var timeRange = dateDiff(options.max, options.min);
        var scale = lineSize / timeRange;
        var weekStartDay = options.weekStartDay || 0;

        var positions = [ start ];
        for (var i = 1; i < divisions; i++) {
            var date = addDuration(options.min, i * step, options.baseUnit, weekStartDay);
            var pos = start + dateDiff(date, options.min) * scale * dir;

            positions.push(round$1(pos, COORD_PRECISION));
        }

        return positions;
    };

    DateValueAxis.prototype.getMajorTickPositions = function getMajorTickPositions () {
        return this.getTickPositions(this.options.majorUnit);
    };

    DateValueAxis.prototype.getMinorTickPositions = function getMinorTickPositions () {
        return this.getTickPositions(this.options.minorUnit);
    };

    DateValueAxis.prototype.getSlot = function getSlot (a, b, limit) {
        return NumericAxis.prototype.getSlot.call(
            this, parseDate(this.intlService, a), parseDate(this.intlService, b), limit
        );
    };

    DateValueAxis.prototype.getValue = function getValue (point) {
        var value = NumericAxis.prototype.getValue.call(this, point);

        return value !== null ? toDate(value) : null;
    };

    DateValueAxis.prototype.labelsCount = function labelsCount () {
        return this.getDivisions(this.options.majorUnit);
    };

    DateValueAxis.prototype.createAxisLabel = function createAxisLabel (index, labelOptions, labelContext) {
        var options = this.options;
        var offset = index * options.majorUnit;
        var weekStartDay = options.weekStartDay || 0;
        var date = options.min;

        if (offset > 0) {
            date = addDuration(date, offset, options.baseUnit, weekStartDay);
        }

        var unitFormat = labelOptions.dateFormats[options.baseUnit];
        labelOptions.format = labelOptions.format || unitFormat;

        var text = this.axisLabelText(date, labelOptions, labelContext);
        return new AxisLabel(date, text, index, null, labelOptions);
    };

    DateValueAxis.prototype.translateRange = function translateRange (delta) {
        var options = this.options;
        var lineBox = this.lineBox();
        var vertical = options.vertical;
        var reverse = options.reverse;
        var size = vertical ? lineBox.height() : lineBox.width();
        var range = this.range();
        var scale = size / dateDiff(range.max, range.min);

        var offset = round$1(delta / scale, DEFAULT_PRECISION);
        if ((vertical || reverse) && !(vertical && reverse )) {
            offset = -offset;
        }

        var from = addTicks(options.min, offset);
        var to = addTicks(options.max, offset);

        return {
            min: from,
            max: to,
            offset: offset
        };
    };

    DateValueAxis.prototype.shouldRenderNote = function shouldRenderNote (value) {
        var range = this.range();

        return dateComparer(value, range.min) >= 0 && dateComparer(value, range.max) <= 0;
    };

    DateValueAxis.prototype.pan = function pan (delta) {
        var range = this.translateRange(delta, true);
        var limittedRange = this.limitRange(toTime(range.min), toTime(range.max), this.totalMin, this.totalMax, range.offset);

        if (limittedRange) {
            return {
                min: toDate(limittedRange.min),
                max: toDate(limittedRange.max)
            };
        }
    };

    DateValueAxis.prototype.pointsRange = function pointsRange (start, end) {
        var startValue = this.getValue(start);
        var endValue = this.getValue(end);
        var min = Math.min(startValue, endValue);
        var max = Math.max(startValue, endValue);

        return {
            min: toDate(min),
            max: toDate(max)
        };
    };

    DateValueAxis.prototype.scaleRange = function scaleRange (scale, cursor) {
        var position = Math.abs(this.pointOffset(cursor));
        var range = this.options.max - this.options.min;
        var delta = this.scaleToDelta(scale, range);
        var minDelta = position * delta;
        var maxDelta = (1 - position) * delta;
        var min = toDate(toTime(this.options.min) + minDelta);
        var max = toDate(toTime(this.options.max) - maxDelta);

        if (max - min < MIN_VALUE_RANGE$1) {
            max = toDate(toTime(min) + MIN_VALUE_RANGE$1);
        }

        return {
            min: min,
            max: max
        };
    };

    DateValueAxis.prototype.zoomRange = function zoomRange (scale, cursor) {
        var range = this.scaleRange(scale, cursor);
        var min = toDate(limitValue(toTime(range.min), this.totalMin, this.totalMax));
        var max = toDate(limitValue(toTime(range.max), this.totalMin, this.totalMax));

        return {
            min: min,
            max: max
        };
    };

    return DateValueAxis;
}(Axis));

function timeUnits(delta) {
    var unit = HOURS;

    if (delta >= TIME_PER_YEAR) {
        unit = YEARS;
    } else if (delta >= TIME_PER_MONTH) {
        unit = MONTHS;
    } else if (delta >= TIME_PER_WEEK) {
        unit = WEEKS;
    } else if (delta >= TIME_PER_DAY) {
        unit = DAYS;
    }

    return unit;
}

function applyDefaults(seriesMin, seriesMax, options) {
    var min = options.min || seriesMin;
    var max = options.max || seriesMax;
    var baseUnit = options.baseUnit || (max && min ? timeUnits(absoluteDateDiff(max, min)) : HOURS);
    var baseUnitTime = TIME_PER_UNIT[baseUnit];
    var weekStartDay = options.weekStartDay || 0;
    var autoMin = floorDate(toTime(min) - 1, baseUnit, weekStartDay) || toDate(max);
    var autoMax = ceilDate(toTime(max) + 1, baseUnit, weekStartDay);
    var userMajorUnit = options.majorUnit ? options.majorUnit : undefined;
    var majorUnit = userMajorUnit || ceil(
        autoMajorUnit(autoMin.getTime(), autoMax.getTime()),
        baseUnitTime
    ) / baseUnitTime;
    var actualUnits = duration(autoMin, autoMax, baseUnit);
    var totalUnits = ceil(actualUnits, majorUnit);
    var unitsToAdd = totalUnits - actualUnits;
    var head = Math.floor(unitsToAdd / 2);
    var tail = unitsToAdd - head;

    if (!options.baseUnit) {
        delete options.baseUnit;
    }

    options.baseUnit = options.baseUnit || baseUnit;
    options.min = options.min || addDuration(autoMin, -head, baseUnit, weekStartDay);
    options.max = options.max || addDuration(autoMax, tail, baseUnit, weekStartDay);
    options.minorUnit = options.minorUnit || majorUnit / 5;
    options.majorUnit = majorUnit;

    return options;
}

setDefaultOptions(DateValueAxis, {
    type: DATE,
    majorGridLines: {
        visible: true,
        width: 1,
        color: BLACK$1
    },
    labels: {
        dateFormats: DateLabelFormats
    }
});

var DEFAULT_MAJOR_UNIT = 10;
var MIN_VALUE_RANGE = 1e-6;

var LogarithmicAxis = (function (Axis) {
    function LogarithmicAxis(seriesMin, seriesMax, options, chartService) {

        var axisOptions = deepExtend({ majorUnit: DEFAULT_MAJOR_UNIT, min: seriesMin, max: seriesMax }, options);
        var base = axisOptions.majorUnit;
        var autoMax = autoAxisMax(seriesMax, base);
        var autoMin = autoAxisMin(seriesMin, seriesMax, axisOptions);
        var range = initRange(autoMin, autoMax, axisOptions, options);

        axisOptions.max = range.max;
        axisOptions.min = range.min;
        axisOptions.minorUnit = options.minorUnit || round$1(base - 1, DEFAULT_PRECISION);

        Axis.call(this, axisOptions, chartService);

        this.totalMin = defined(options.min) ? Math.min(autoMin, options.min) : autoMin;
        this.totalMax = defined(options.max) ? Math.max(autoMax, options.max) : autoMax;
        this.logMin = round$1(log$1(range.min, base), DEFAULT_PRECISION);
        this.logMax = round$1(log$1(range.max, base), DEFAULT_PRECISION);
        this.seriesMin = seriesMin;
        this.seriesMax = seriesMax;

        this.createLabels();
    }

    if ( Axis ) LogarithmicAxis.__proto__ = Axis;
    LogarithmicAxis.prototype = Object.create( Axis && Axis.prototype );
    LogarithmicAxis.prototype.constructor = LogarithmicAxis;

    LogarithmicAxis.prototype.clone = function clone () {
        return new LogarithmicAxis(
            this.seriesMin,
            this.seriesMax,
            Object.assign({}, this.options),
            this.chartService
        );
    };

    LogarithmicAxis.prototype.startValue = function startValue () {
        return this.options.min;
    };

    LogarithmicAxis.prototype.getSlot = function getSlot (a, b, limit) {
        var ref = this;
        var options = ref.options;
        var logMin = ref.logMin;
        var logMax = ref.logMax;
        var base = options.majorUnit;
        var min = options.min;
        var max = options.max;
        var ref$1 = this.lineInfo();
        var axis = ref$1.axis;
        var axisDir = ref$1.axisDir;
        var lineBox = ref$1.lineBox;
        var lineSize = ref$1.lineSize;
        var lineStart = ref$1.lineStart;
        var step = axisDir * (lineSize / (logMax - logMin));
        var start = valueOrDefault(a, b || 1);
        var end = valueOrDefault(b, a || 1);

        if (start <= 0 || end <= 0) {
            return null;
        }

        if (limit) {
            start = limitValue(start, min, max);
            end = limitValue(end, min, max);
        }

        start = log$1(start, base);
        end = log$1(end, base);

        var p1 = Math.min(start, end) - logMin;
        var p2 = Math.max(start, end) - logMin;

        var slotBox = new Box(lineBox.x1, lineBox.y1, lineBox.x1, lineBox.y1);
        slotBox[axis + 1] = limitCoordinate(lineStart + step * (axisDir > 0 ? p1 : p2));
        slotBox[axis + 2] = limitCoordinate(lineStart + step * (axisDir > 0 ? p2 : p1));

        return slotBox;
    };

    LogarithmicAxis.prototype.getValue = function getValue (point) {
        var ref = this;
        var options = ref.options;
        var logMin = ref.logMin;
        var logMax = ref.logMax;
        var base = options.majorUnit;
        var ref$1 = this.lineInfo();
        var axis = ref$1.axis;
        var axisDir = ref$1.axisDir;
        var lineStart = ref$1.lineStart;
        var lineSize = ref$1.lineSize;
        var step = ((logMax - logMin) / lineSize);
        var offset = axisDir * (point[axis] - lineStart);
        var valueOffset = offset * step;

        if (offset < 0 || offset > lineSize) {
            return null;
        }

        var value = logMin + valueOffset;

        return round$1(Math.pow(base, value), DEFAULT_PRECISION);
    };

    LogarithmicAxis.prototype.range = function range () {
        var options = this.options;
        return { min: options.min, max: options.max };
    };

    LogarithmicAxis.prototype.translateRange = function translateRange (delta) {
        var ref = this;
        var options = ref.options;
        var logMin = ref.logMin;
        var logMax = ref.logMax;
        var reverse = options.reverse;
        var vertical = options.vertical;
        var base = options.majorUnit;
        var lineBox = this.lineBox();
        var size = vertical ? lineBox.height() : lineBox.width();
        var scale = size / (logMax - logMin);
        var offset = round$1(delta / scale, DEFAULT_PRECISION);

        if ((vertical || reverse) && !(vertical && reverse )) {
            offset = -offset;
        }

        return {
            min: Math.pow(base, logMin + offset),
            max: Math.pow(base, logMax + offset),
            offset: offset
        };
    };

    LogarithmicAxis.prototype.labelsCount = function labelsCount () {
        var floorMax = Math.floor(this.logMax);
        var count = Math.floor(floorMax - this.logMin) + 1;

        return count;
    };

    LogarithmicAxis.prototype.getMajorTickPositions = function getMajorTickPositions () {
        var ticks = [];

        this.traverseMajorTicksPositions(function (position) {
            ticks.push(position);
        }, { step: 1, skip: 0 });

        return ticks;
    };

    LogarithmicAxis.prototype.createTicks = function createTicks (lineGroup) {
        var options = this.options;
        var majorTicks = options.majorTicks;
        var minorTicks = options.minorTicks;
        var vertical = options.vertical;
        var mirror = options.labels.mirror;
        var lineBox = this.lineBox();
        var ticks = [];
        var tickLineOptions = {
            // TODO
            // _alignLines: options._alignLines,
            vertical: vertical
        };

        function render(tickPosition, tickOptions) {
            tickLineOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
            tickLineOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
            tickLineOptions.position = tickPosition;

            lineGroup.append(createAxisTick(tickLineOptions, tickOptions));
        }

        if (majorTicks.visible) {
            this.traverseMajorTicksPositions(render, majorTicks);
        }

        if (minorTicks.visible) {
            this.traverseMinorTicksPositions(render, minorTicks);
        }

        return ticks;
    };

    LogarithmicAxis.prototype.createGridLines = function createGridLines (altAxis) {
        var options = this.options;
        var minorGridLines = options.minorGridLines;
        var majorGridLines = options.majorGridLines;
        var vertical = options.vertical;
        var lineBox = altAxis.lineBox();
        var lineOptions = {
            lineStart: lineBox[vertical ? "x1" : "y1"],
            lineEnd: lineBox[vertical ? "x2" : "y2"],
            vertical: vertical
        };
        var majorTicks = [];

        var container = this.gridLinesVisual();
        function render(tickPosition, gridLine) {
            if (!inArray(tickPosition, majorTicks)) {
                lineOptions.position = tickPosition;
                container.append(createAxisGridLine(lineOptions, gridLine));

                majorTicks.push(tickPosition);
            }
        }

        if (majorGridLines.visible) {
            this.traverseMajorTicksPositions(render, majorGridLines);
        }

        if (minorGridLines.visible) {
            this.traverseMinorTicksPositions(render, minorGridLines);
        }

        return container.children;
    };

    LogarithmicAxis.prototype.traverseMajorTicksPositions = function traverseMajorTicksPositions (callback, tickOptions) {
        var ref = this.lineInfo();
        var lineStart = ref.lineStart;
        var step = ref.step;
        var ref$1 = this;
        var logMin = ref$1.logMin;
        var logMax = ref$1.logMax;

        for (var power = Math.ceil(logMin) + tickOptions.skip; power <= logMax; power += tickOptions.step) {
            var position = round$1(lineStart + step * (power - logMin), DEFAULT_PRECISION);
            callback(position, tickOptions);
        }
    };

    LogarithmicAxis.prototype.traverseMinorTicksPositions = function traverseMinorTicksPositions (callback, tickOptions) {
        var this$1$1 = this;

        var ref = this.options;
        var min = ref.min;
        var max = ref.max;
        var minorUnit = ref.minorUnit;
        var base = ref.majorUnit;
        var ref$1 = this.lineInfo();
        var lineStart = ref$1.lineStart;
        var step = ref$1.step;
        var ref$2 = this;
        var logMin = ref$2.logMin;
        var logMax = ref$2.logMax;
        var start = Math.floor(logMin);

        for (var power = start; power < logMax; power++) {
            var minorOptions = this$1$1._minorIntervalOptions(power);
            for (var idx = tickOptions.skip; idx < minorUnit; idx += tickOptions.step) {
                var value = minorOptions.value + idx * minorOptions.minorStep;
                if (value > max) {
                    break;
                }
                if (value >= min) {
                    var position = round$1(lineStart + step * (log$1(value, base) - logMin), DEFAULT_PRECISION);
                    callback(position, tickOptions);
                }
            }
        }
    };

    LogarithmicAxis.prototype.createAxisLabel = function createAxisLabel (index, labelOptions, labelContext) {
        var power = Math.ceil(this.logMin + index);
        var value = Math.pow(this.options.majorUnit, power);
        var text = this.axisLabelText(value, labelOptions, labelContext);

        return new AxisLabel(value, text, index, null, labelOptions);
    };

    LogarithmicAxis.prototype.shouldRenderNote = function shouldRenderNote (value) {
        var range = this.range();
        return range.min <= value && value <= range.max;
    };

    LogarithmicAxis.prototype.pan = function pan (delta) {
        var range = this.translateRange(delta);
        return this.limitRange(range.min, range.max, this.totalMin, this.totalMax, range.offset);
    };

    LogarithmicAxis.prototype.pointsRange = function pointsRange (start, end) {
        var startValue = this.getValue(start);
        var endValue = this.getValue(end);
        var min = Math.min(startValue, endValue);
        var max = Math.max(startValue, endValue);

        return {
            min: min,
            max: max
        };
    };

    LogarithmicAxis.prototype.scaleRange = function scaleRange (scale, cursor) {
        var ref = this.options;
        var base = ref.majorUnit;
        var logMin = log$1(this.options.min, base);
        var logMax = log$1(this.options.max, base);
        var position = Math.abs(this.pointOffset(cursor));
        var range = logMax - logMin;
        var delta = this.scaleToDelta(scale, range);
        var min = Math.pow(base, logMin + position * delta);
        var max = Math.pow(base, logMax - (1 - position) * delta);

        if (max - min < MIN_VALUE_RANGE) {
            max = min + MIN_VALUE_RANGE;
        }

        return {
            min: min,
            max: max
        };
    };

    LogarithmicAxis.prototype.zoomRange = function zoomRange (scale, cursor) {
        var range = this.scaleRange(scale, cursor);
        var ref = this;
        var totalMin = ref.totalMin;
        var totalMax = ref.totalMax;

        return {
            min: limitValue(range.min, totalMin, totalMax),
            max: limitValue(range.max, totalMin, totalMax)
        };
    };

    LogarithmicAxis.prototype._minorIntervalOptions = function _minorIntervalOptions (power) {
        var ref = this.options;
        var minorUnit = ref.minorUnit;
        var base = ref.majorUnit;
        var value = Math.pow(base, power);
        var nextValue = Math.pow(base, power + 1);
        var difference = nextValue - value;
        var minorStep = difference / minorUnit;

        return {
            value: value,
            minorStep: minorStep
        };
    };

    LogarithmicAxis.prototype.lineInfo = function lineInfo () {
        var info = Axis.prototype.lineInfo.call(this);
        info.step = info.axisDir * (info.lineSize / (this.logMax - this.logMin));

        return info;
    };

    return LogarithmicAxis;
}(Axis));

function initRange(autoMin, autoMax, axisOptions, options) {
    var min = axisOptions.min;
    var max = axisOptions.max;

    if (defined(axisOptions.axisCrossingValue) && axisOptions.axisCrossingValue <= 0) {
        throwNegativeValuesError();
    }

    if (!defined(options.max)) {
        max = autoMax;
    } else if (options.max <= 0) {
        throwNegativeValuesError();
    }

    if (!defined(options.min)) {
        min = autoMin;
    } else if (options.min <= 0) {
        throwNegativeValuesError();
    }

    return {
        min: min,
        max: max
    };
}

function autoAxisMin(min, max, options) {
    var base = options.majorUnit;
    var autoMin = min;
    if (min <= 0) {
        autoMin = max <= 1 ? Math.pow(base, -2) : 1;
    } else if (!options.narrowRange) {
        autoMin = Math.pow(base, Math.floor(log$1(min, base)));
    }
    return autoMin;
}

function autoAxisMax(max, base) {
    var logMaxRemainder = round$1(log$1(max, base), DEFAULT_PRECISION) % 1;
    var autoMax;
    if (max <= 0) {
        autoMax = base;
    } else if (logMaxRemainder !== 0 && (logMaxRemainder < 0.3 || logMaxRemainder > 0.9)) {
        autoMax = Math.pow(base, log$1(max, base) + 0.2);
    } else {
        autoMax = Math.pow(base, Math.ceil(log$1(max, base)));
    }

    return autoMax;
}

function throwNegativeValuesError() {
    throw new Error("Non positive values cannot be used for a logarithmic axis");
}

function log$1(x, base) {
    return Math.log(x) / Math.log(base);
}

setDefaultOptions(LogarithmicAxis, {
    type: "log",
    majorUnit: DEFAULT_MAJOR_UNIT,
    minorUnit: 1,
    axisCrossingValue: 1,
    vertical: true,
    majorGridLines: {
        visible: true,
        width: 1,
        color: BLACK$1
    },
    zIndex: 1,
    _deferLabels: true
});

var GridLinesMixin = {
    createGridLines: function(altAxis) {
        var options = this.options;
        var radius = Math.abs(this.box.center().y - altAxis.lineBox().y1);
        var gridLines = [];
        var skipMajor = false;
        var majorAngles, minorAngles;

        if (options.majorGridLines.visible) {
            majorAngles = this.majorGridLineAngles(altAxis);
            skipMajor = true;

            gridLines = this.renderMajorGridLines(
                majorAngles, radius, options.majorGridLines
            );
        }

        if (options.minorGridLines.visible) {
            minorAngles = this.minorGridLineAngles(altAxis, skipMajor);

            append(gridLines, this.renderMinorGridLines(
                minorAngles, radius, options.minorGridLines, altAxis, skipMajor
            ));
        }

        return gridLines;
    },

    renderMajorGridLines: function(angles, radius, options) {
        return this.renderGridLines(angles, radius, options);
    },

    renderMinorGridLines: function(angles, radius, options, altAxis, skipMajor) {
        var radiusCallback = this.radiusCallback && this.radiusCallback(radius, altAxis, skipMajor);
        return this.renderGridLines(angles, radius, options, radiusCallback);
    },

    renderGridLines: function(angles, radius, options, radiusCallback) {
        var style = {
            stroke: {
                width: options.width,
                color: options.color,
                dashType: options.dashType
            }
        };

        var center = this.box.center();
        var circle = new Circle$2([ center.x, center.y ], radius);
        var container = this.gridLinesVisual();

        for (var i = 0; i < angles.length; i++) {
            var line = new Path$7(style);
            if (radiusCallback) {
                circle.radius = radiusCallback(angles[i]);
            }

            line.moveTo(circle.center)
                .lineTo(circle.pointAt(angles[i] + 180));

            container.append(line);
        }

        return container.children;
    },

    gridLineAngles: function(altAxis, size, skip, step, skipAngles) {
        var this$1$1 = this;

        var divs = this.intervals(size, skip, step, skipAngles);
        var options = altAxis.options;
        var altAxisVisible = options.visible && (options.line || {}).visible !== false;

        return map(divs, function (d) {
            var alpha = this$1$1.intervalAngle(d);

            if (!altAxisVisible || alpha !== 90) {
                return alpha;
            }
        });
    }
};

var RadarCategoryAxis = (function (CategoryAxis) {
    function RadarCategoryAxis () {
        CategoryAxis.apply(this, arguments);
    }

    if ( CategoryAxis ) RadarCategoryAxis.__proto__ = CategoryAxis;
    RadarCategoryAxis.prototype = Object.create( CategoryAxis && CategoryAxis.prototype );
    RadarCategoryAxis.prototype.constructor = RadarCategoryAxis;

    RadarCategoryAxis.prototype.range = function range () {
        return { min: 0, max: this.options.categories.length };
    };

    RadarCategoryAxis.prototype.reflow = function reflow (box) {
        this.box = box;
        this.reflowLabels();
    };

    RadarCategoryAxis.prototype.lineBox = function lineBox () {
        return this.box;
    };

    RadarCategoryAxis.prototype.reflowLabels = function reflowLabels () {
        var this$1$1 = this;

        var ref = this;
        var labels = ref.labels;
        var labelOptions = ref.options.labels;
        var skip = labelOptions.skip || 0;
        var step = labelOptions.step || 1;
        var measureBox = new Box();

        for (var i = 0; i < labels.length; i++) {
            labels[i].reflow(measureBox);
            var labelBox = labels[i].box;

            labels[i].reflow(this$1$1.getSlot(skip + i * step).adjacentBox(
                0, labelBox.width(), labelBox.height()
            ));
        }
    };

    RadarCategoryAxis.prototype.intervals = function intervals (size, skipOption, stepOption, skipAngles) {
        if ( skipAngles === void 0 ) skipAngles = false;

        var options = this.options;
        var categories = options.categories.length;
        var divCount = categories / size || 1;
        var divAngle = 360 / divCount;
        var skip = skipOption || 0;
        var step = stepOption || 1;
        var divs = [];
        var angle = 0;

        for (var i = skip; i < divCount; i += step) {
            if (options.reverse) {
                angle = 360 - i * divAngle;
            } else {
                angle = i * divAngle;
            }

            angle = round$1(angle, COORD_PRECISION) % 360;

            if (!(skipAngles && inArray(angle, skipAngles))) {
                divs.push(angle);
            }
        }

        return divs;
    };

    RadarCategoryAxis.prototype.majorIntervals = function majorIntervals () {
        return this.intervals(1);
    };

    RadarCategoryAxis.prototype.minorIntervals = function minorIntervals () {
        return this.intervals(0.5);
    };

    RadarCategoryAxis.prototype.intervalAngle = function intervalAngle (interval) {
        return (360 + interval + this.options.startAngle) % 360;
    };

    RadarCategoryAxis.prototype.majorAngles = function majorAngles () {
        var this$1$1 = this;

        return map(this.majorIntervals(), function (interval) { return this$1$1.intervalAngle(interval); });
    };

    RadarCategoryAxis.prototype.createLine = function createLine () {
        return [];
    };

    RadarCategoryAxis.prototype.majorGridLineAngles = function majorGridLineAngles (altAxis) {
        var majorGridLines = this.options.majorGridLines;
        return this.gridLineAngles(altAxis, 1, majorGridLines.skip, majorGridLines.step);
    };

    RadarCategoryAxis.prototype.minorGridLineAngles = function minorGridLineAngles (altAxis, skipMajor) {
        var ref = this.options;
        var minorGridLines = ref.minorGridLines;
        var majorGridLines = ref.majorGridLines;
        var majorGridLineAngles = skipMajor ? this.intervals(1, majorGridLines.skip, majorGridLines.step) : null;

        return this.gridLineAngles(altAxis, 0.5, minorGridLines.skip, minorGridLines.step, majorGridLineAngles);
    };

    RadarCategoryAxis.prototype.radiusCallback = function radiusCallback (radius, altAxis, skipMajor) {
        if (altAxis.options.type !== ARC) {
            var minorAngle = rad(360 / (this.options.categories.length * 2));
            var minorRadius = Math.cos(minorAngle) * radius;
            var majorAngles = this.majorAngles();

            var radiusCallback = function(angle) {
                if (!skipMajor && inArray(angle, majorAngles)) {
                    return radius;
                }

                return minorRadius;
            };
            return radiusCallback;
        }
    };

    RadarCategoryAxis.prototype.createPlotBands = function createPlotBands () {
        var this$1$1 = this;

        var plotBands = this.options.plotBands || [];

        var group = this._plotbandGroup = new Group$8({
            zIndex: -1
        });

        for (var i = 0; i < plotBands.length; i++) {
            var band = plotBands[i];
            var slot = this$1$1.plotBandSlot(band);
            var singleSlot = this$1$1.getSlot(band.from);

            var head = band.from - Math.floor(band.from);
            slot.startAngle += head * singleSlot.angle;

            var tail = Math.ceil(band.to) - band.to;
            slot.angle -= (tail + head) * singleSlot.angle;

            var ring = ShapeBuilder.current.createRing(slot, {
                fill: {
                    color: band.color,
                    opacity: band.opacity
                },
                stroke: {
                    opacity: band.opacity
                }
            });
            group.append(ring);
        }

        this.appendVisual(group);
    };

    RadarCategoryAxis.prototype.plotBandSlot = function plotBandSlot (band) {
        return this.getSlot(band.from, band.to - 1);
    };

    RadarCategoryAxis.prototype.getSlot = function getSlot (from, to) {
        var options = this.options;
        var justified = options.justified;
        var box = this.box;
        var divs = this.majorAngles();
        var totalDivs = divs.length;
        var slotAngle = 360 / totalDivs;
        var fromValue = from;

        if (options.reverse && !justified) {
            fromValue = (fromValue + 1) % totalDivs;
        }

        fromValue = limitValue(Math.floor(fromValue), 0, totalDivs - 1);
        var slotStart = divs[fromValue];

        if (justified) {
            slotStart = slotStart - slotAngle / 2;

            if (slotStart < 0) {
                slotStart += 360;
            }
        }

        var toValue = limitValue(Math.ceil(to || fromValue), fromValue, totalDivs - 1);
        var slots = toValue - fromValue + 1;
        var angle = slotAngle * slots;

        return new Ring(box.center(), 0, box.height() / 2, slotStart, angle);
    };

    RadarCategoryAxis.prototype.slot = function slot (from, to) {
        var slot = this.getSlot(from, to);
        var startAngle = slot.startAngle + 180;
        var endAngle = startAngle + slot.angle;

        return new Arc$1([ slot.center.x, slot.center.y ], {
            startAngle: startAngle,
            endAngle: endAngle,
            radiusX: slot.radius,
            radiusY: slot.radius
        });
    };

    RadarCategoryAxis.prototype.pointCategoryIndex = function pointCategoryIndex (point) {
        var this$1$1 = this;

        var length = this.options.categories.length;
        var index = null;

        for (var i = 0; i < length; i++) {
            var slot = this$1$1.getSlot(i);
            if (slot.containsPoint(point)) {
                index = i;
                break;
            }
        }

        return index;
    };

    return RadarCategoryAxis;
}(CategoryAxis));

setDefaultOptions(RadarCategoryAxis, {
    startAngle: 90,
    labels: {
        margin: getSpacing(10)
    },
    majorGridLines: {
        visible: true
    },
    justified: true
});
deepExtend(RadarCategoryAxis.prototype, GridLinesMixin);

var PolarAxis = (function (Axis) {
    function PolarAxis(options, chartService) {
        Axis.call(this, options, chartService);

        var instanceOptions = this.options;

        instanceOptions.minorUnit = instanceOptions.minorUnit || instanceOptions.majorUnit / 2;
    }

    if ( Axis ) PolarAxis.__proto__ = Axis;
    PolarAxis.prototype = Object.create( Axis && Axis.prototype );
    PolarAxis.prototype.constructor = PolarAxis;

    PolarAxis.prototype.getDivisions = function getDivisions (stepValue) {
        return NumericAxis.prototype.getDivisions.call(this, stepValue) - 1;
    };

    PolarAxis.prototype.reflow = function reflow (box) {
        this.box = box;
        this.reflowLabels();
    };

    PolarAxis.prototype.reflowLabels = function reflowLabels () {
        var this$1$1 = this;

        var ref = this;
        var options = ref.options;
        var labels = ref.labels;
        var labelOptions = ref.options.labels;
        var skip = labelOptions.skip || 0;
        var step = labelOptions.step || 1;

        var measureBox = new Box();
        var divs = this.intervals(options.majorUnit, skip, step);

        for (var i = 0; i < labels.length; i++) {
            labels[i].reflow(measureBox);
            var labelBox = labels[i].box;

            labels[i].reflow(this$1$1.getSlot(divs[i]).adjacentBox(0, labelBox.width(), labelBox.height()));
        }
    };

    PolarAxis.prototype.lineBox = function lineBox () {
        return this.box;
    };

    PolarAxis.prototype.intervals = function intervals (size, skipOption, stepOption, skipAngles) {
        if ( skipAngles === void 0 ) skipAngles = false;

        var min = this.options.min;
        var divisions = this.getDivisions(size);
        var divs = [];
        var skip = skipOption || 0;
        var step = stepOption || 1;

        for (var i = skip; i < divisions; i += step) {
            var current = (360 + min + i * size) % 360;
            if (!(skipAngles && inArray(current, skipAngles))) {
                divs.push(current);
            }
        }

        return divs;
    };

    PolarAxis.prototype.majorIntervals = function majorIntervals () {
        return this.intervals(this.options.majorUnit);
    };

    PolarAxis.prototype.minorIntervals = function minorIntervals () {
        return this.intervals(this.options.minorUnit);
    };

    PolarAxis.prototype.intervalAngle = function intervalAngle (i) {
        return (540 - i - this.options.startAngle) % 360;
    };

    PolarAxis.prototype.createLine = function createLine () {
        return [];
    };

    PolarAxis.prototype.majorGridLineAngles = function majorGridLineAngles (altAxis) {
        var majorGridLines = this.options.majorGridLines;
        return this.gridLineAngles(altAxis, this.options.majorUnit, majorGridLines.skip, majorGridLines.step);
    };

    PolarAxis.prototype.minorGridLineAngles = function minorGridLineAngles (altAxis, skipMajor) {
        var options = this.options;
        var minorGridLines = options.minorGridLines;
        var majorGridLines = options.majorGridLines;
        var majorGridLineAngles = skipMajor ? this.intervals(options.majorUnit, majorGridLines.skip, majorGridLines.step) : null;

        return this.gridLineAngles(altAxis, options.minorUnit, minorGridLines.skip, minorGridLines.step, majorGridLineAngles);
    };

    PolarAxis.prototype.plotBandSlot = function plotBandSlot (band) {
        return this.getSlot(band.from, band.to);
    };

    PolarAxis.prototype.getSlot = function getSlot (a, b) {
        var ref = this;
        var options = ref.options;
        var box = ref.box;
        var startAngle = options.startAngle;
        var start = limitValue(a, options.min, options.max);
        var end = limitValue(b || start, start, options.max);

        if (options.reverse) {
            start *= -1;
            end *= -1;
        }

        start = (540 - start - startAngle) % 360;
        end = (540 - end - startAngle) % 360;

        if (end < start) {
            var tmp = start;
            start = end;
            end = tmp;
        }

        return new Ring(box.center(), 0, box.height() / 2, start, end - start);
    };

    PolarAxis.prototype.slot = function slot (from, to) {
        if ( to === void 0 ) to = from;

        var options = this.options;
        var start = 360 - options.startAngle;
        var slot = this.getSlot(from, to);
        var min = Math.min(from, to);
        var max = Math.max(from, to);
        var startAngle, endAngle;

        if (options.reverse) {
            startAngle = min;
            endAngle = max;
        } else {
            startAngle = 360 - max;
            endAngle = 360 - min;
        }

        startAngle = (startAngle + start) % 360;
        endAngle = (endAngle + start) % 360;

        return new Arc$1([ slot.center.x, slot.center.y ], {
            startAngle: startAngle,
            endAngle: endAngle,
            radiusX: slot.radius,
            radiusY: slot.radius
        });
    };

    PolarAxis.prototype.getValue = function getValue (point) {
        var options = this.options;
        var center = this.box.center();
        var dx = point.x - center.x;
        var dy = point.y - center.y;
        var theta = Math.round(deg(Math.atan2(dy, dx)));
        var start = options.startAngle;

        if (!options.reverse) {
            theta *= -1;
            start *= -1;
        }

        return (theta + start + 360) % 360;
    };

    PolarAxis.prototype.valueRange = function valueRange () {
        return {
            min: 0,
            max: Math.PI * 2
        };
    };

    return PolarAxis;
}(Axis));

setDefaultOptions(PolarAxis, {
    type: "polar",
    startAngle: 0,
    reverse: false,
    majorUnit: 60,
    min: 0,
    max: 360,
    labels: {
        margin: getSpacing(10)
    },
    majorGridLines: {
        color: BLACK$1,
        visible: true,
        width: 1
    },
    minorGridLines: {
        color: "#aaa"
    }
});

deepExtend(PolarAxis.prototype, GridLinesMixin, {
    createPlotBands: RadarCategoryAxis.prototype.createPlotBands,
    majorAngles: RadarCategoryAxis.prototype.majorAngles,
    range: NumericAxis.prototype.range,
    labelsCount: NumericAxis.prototype.labelsCount,
    createAxisLabel: NumericAxis.prototype.createAxisLabel
});

var RadarNumericAxisMixin = {
    options: {
        majorGridLines: {
            visible: true
        }
    },

    createPlotBands: function() {
        var this$1$1 = this;

        var ref = this.options;
        var type = ref.majorGridLines.type;
        var plotBands = ref.plotBands; if ( plotBands === void 0 ) plotBands = [];
        var altAxis = this.plotArea.polarAxis;
        var majorAngles = altAxis.majorAngles();
        var center = altAxis.box.center();
        var group = this._plotbandGroup = new Group$8({
            zIndex: -1
        });

        for (var i = 0; i < plotBands.length; i++) {
            var band = plotBands[i];
            var bandStyle = {
                fill: {
                    color: band.color,
                    opacity: band.opacity
                },
                stroke: {
                    opacity: band.opacity
                }
            };

            var slot = this$1$1.getSlot(band.from, band.to, true);
            var ring = new Ring(center, center.y - slot.y2, center.y - slot.y1, 0, 360);

            var shape = (void 0);
            if (type === ARC) {
                shape = ShapeBuilder.current.createRing(ring, bandStyle);
            } else {
                shape = Path$7.fromPoints(this$1$1.plotBandPoints(ring, majorAngles), bandStyle).close();
            }

            group.append(shape);
        }

        this.appendVisual(group);
    },

    plotBandPoints: function(ring, angles) {
        var innerPoints = [];
        var outerPoints = [];
        var center = [ ring.center.x, ring.center.y ];
        var innerCircle = new Circle$2(center, ring.innerRadius);
        var outerCircle = new Circle$2(center, ring.radius);

        for (var i = 0; i < angles.length; i++) {
            innerPoints.push(innerCircle.pointAt(angles[i] + 180));
            outerPoints.push(outerCircle.pointAt(angles[i] + 180));
        }

        innerPoints.reverse();
        innerPoints.push(innerPoints[0]);
        outerPoints.push(outerPoints[0]);

        return outerPoints.concat(innerPoints);
    },

    createGridLines: function(altAxis) {
        var options = this.options;
        var majorTicks = this.radarMajorGridLinePositions();
        var majorAngles = altAxis.majorAngles();
        var center = altAxis.box.center();
        var gridLines = [];

        if (options.majorGridLines.visible) {
            gridLines = this.renderGridLines(
                center, majorTicks, majorAngles, options.majorGridLines
            );
        }

        if (options.minorGridLines.visible) {
            var minorTicks = this.radarMinorGridLinePositions();
            append(gridLines, this.renderGridLines(
                center, minorTicks, majorAngles, options.minorGridLines
            ));
        }

        return gridLines;
    },

    renderGridLines: function(center, ticks, angles, options) {
        var style = {
            stroke: {
                width: options.width,
                color: options.color,
                dashType: options.dashType
            }
        };
        var skip = options.skip; if ( skip === void 0 ) skip = 0;
        var step = options.step; if ( step === void 0 ) step = 0;
        var container = this.gridLinesVisual();

        for (var tickIx = skip; tickIx < ticks.length; tickIx += step) {
            var tickRadius = center.y - ticks[tickIx];
            if (tickRadius > 0) {
                var circle = new Circle$2([ center.x, center.y ], tickRadius);
                if (options.type === ARC) {
                    container.append(new Circle$1(circle, style));
                } else {
                    var line = new Path$7(style);
                    for (var angleIx = 0; angleIx < angles.length; angleIx++) {
                        line.lineTo(circle.pointAt(angles[angleIx] + 180));
                    }

                    line.close();
                    container.append(line);
                }
            }
        }

        return container.children;
    },

    getValue: function(point) {
        var lineBox = this.lineBox();
        var altAxis = this.plotArea.polarAxis;
        var majorAngles = altAxis.majorAngles();
        var center = altAxis.box.center();
        var radius = point.distanceTo(center);
        var distance = radius;

        if (this.options.majorGridLines.type !== ARC && majorAngles.length > 1) {
            var dx = point.x - center.x;
            var dy = point.y - center.y;
            var theta = (deg(Math.atan2(dy, dx)) + 540) % 360;

            majorAngles.sort(function(a, b) {
                return angularDistance(a, theta) - angularDistance(b, theta);
            });

            // Solve triangle (center, point, axis X) using one side (radius) and two angles.
            // Angles are derived from triangle (center, point, gridline X)
            var midAngle = angularDistance(majorAngles[0], majorAngles[1]) / 2;
            var alpha = angularDistance(theta, majorAngles[0]);
            var gamma = 90 - midAngle;
            var beta = 180 - alpha - gamma;

            distance = radius * (Math.sin(rad(beta)) / Math.sin(rad(gamma)));
        }

        return this.axisType().prototype.getValue.call(
            this, new Point$5(lineBox.x1, lineBox.y2 - distance)
        );
    }
};

function angularDistance(a, b) {
    return 180 - Math.abs(Math.abs(a - b) - 180);
}

var RadarNumericAxis = (function (NumericAxis) {
    function RadarNumericAxis () {
        NumericAxis.apply(this, arguments);
    }

    if ( NumericAxis ) RadarNumericAxis.__proto__ = NumericAxis;
    RadarNumericAxis.prototype = Object.create( NumericAxis && NumericAxis.prototype );
    RadarNumericAxis.prototype.constructor = RadarNumericAxis;

    RadarNumericAxis.prototype.radarMajorGridLinePositions = function radarMajorGridLinePositions () {
        return this.getTickPositions(this.options.majorUnit);
    };

    RadarNumericAxis.prototype.radarMinorGridLinePositions = function radarMinorGridLinePositions () {
        var options = this.options;
        var minorSkipStep = 0;

        if (options.majorGridLines.visible) {
            minorSkipStep = options.majorUnit;
        }
        return this.getTickPositions(options.minorUnit, minorSkipStep);
    };

    RadarNumericAxis.prototype.axisType = function axisType () {
        return NumericAxis;
    };

    return RadarNumericAxis;
}(NumericAxis));

deepExtend(RadarNumericAxis.prototype, RadarNumericAxisMixin);

var RadarLogarithmicAxis = (function (LogarithmicAxis) {
    function RadarLogarithmicAxis () {
        LogarithmicAxis.apply(this, arguments);
    }

    if ( LogarithmicAxis ) RadarLogarithmicAxis.__proto__ = LogarithmicAxis;
    RadarLogarithmicAxis.prototype = Object.create( LogarithmicAxis && LogarithmicAxis.prototype );
    RadarLogarithmicAxis.prototype.constructor = RadarLogarithmicAxis;

    RadarLogarithmicAxis.prototype.radarMajorGridLinePositions = function radarMajorGridLinePositions () {
        var positions = [];

        this.traverseMajorTicksPositions(function(position) {
            positions.push(position);
        }, this.options.majorGridLines);

        return positions;
    };

    RadarLogarithmicAxis.prototype.radarMinorGridLinePositions = function radarMinorGridLinePositions () {
        var positions = [];

        this.traverseMinorTicksPositions(function(position) {
            positions.push(position);
        }, this.options.minorGridLines);

        return positions;
    };

    RadarLogarithmicAxis.prototype.axisType = function axisType () {
        return LogarithmicAxis;
    };

    return RadarLogarithmicAxis;
}(LogarithmicAxis));

deepExtend(RadarLogarithmicAxis.prototype, RadarNumericAxisMixin);

var WEIGHT = 0.333;
var EXTREMUM_ALLOWED_DEVIATION = 0.01;

var CurveProcessor = (function (Class) {
    function CurveProcessor(closed) {
        Class.call(this);

        this.closed = closed;
    }

    if ( Class ) CurveProcessor.__proto__ = Class;
    CurveProcessor.prototype = Object.create( Class && Class.prototype );
    CurveProcessor.prototype.constructor = CurveProcessor;

    CurveProcessor.prototype.process = function process (dataPoints) {
        var this$1$1 = this;

        var points = dataPoints.slice(0);
        var segments = [];
        var closed = this.closed;
        var length = points.length;

        if (length > 2) {
            this.removeDuplicates(0, points);
            length = points.length;
        }

        if (length < 2 || (length === 2 && points[0].equals(points[1]))) {
            return segments;
        }

        var p0 = points[0];
        var p1 = points[1];
        var p2 = points[2];

        segments.push(new Segment(p0));

        while (p0.equals(points[length - 1])) {
            closed = true;
            points.pop();
            length--;
        }

        if (length === 2) {
            var tangent = this.tangent(p0,p1, X, Y);

            last(segments).controlOut(
                this.firstControlPoint(tangent, p0, p1, X, Y)
            );

            segments.push(new Segment(
                p1,
                this.secondControlPoint(tangent, p0, p1, X, Y)
            ));

            return segments;
        }

        var initialControlPoint, lastControlPoint;

        if (closed) {
            p0 = points[length - 1]; p1 = points[0]; p2 = points[1];
            var controlPoints = this.controlPoints(p0, p1, p2);
            initialControlPoint = controlPoints[1];
            lastControlPoint = controlPoints[0];
        } else {
            var tangent$1 = this.tangent(p0, p1, X,Y);
            initialControlPoint = this.firstControlPoint(tangent$1, p0, p1, X, Y);
        }

        var cp0 = initialControlPoint;
        for (var idx = 0; idx <= length - 3; idx++) {
            this$1$1.removeDuplicates(idx, points);
            length = points.length;
            if (idx + 3 <= length) {
                p0 = points[idx]; p1 = points[idx + 1]; p2 = points[idx + 2];
                var controlPoints$1 = this$1$1.controlPoints(p0,p1,p2);

                last(segments).controlOut(cp0);
                cp0 = controlPoints$1[1];

                var cp1 = controlPoints$1[0];
                segments.push(new Segment(p1, cp1));
            }
        }

        if (closed) {
            p0 = points[length - 2]; p1 = points[length - 1]; p2 = points[0];
            var controlPoints$2 = this.controlPoints(p0, p1, p2);

            last(segments).controlOut(cp0);
            segments.push(new Segment(
                p1,
                controlPoints$2[0]
            ));

            last(segments).controlOut(controlPoints$2[1]);
            segments.push(new Segment(
                p2,
                lastControlPoint
            ));
        } else {
            var tangent$2 = this.tangent(p1, p2, X, Y);

            last(segments).controlOut(cp0);
            segments.push(new Segment(
                p2,
                this.secondControlPoint(tangent$2, p1, p2, X, Y)
            ));
        }

        return segments;
    };

    CurveProcessor.prototype.removeDuplicates = function removeDuplicates (idx, points) {
        while (points[idx + 1] && (points[idx].equals(points[idx + 1]) || points[idx + 1].equals(points[idx + 2]))) {
            points.splice(idx + 1, 1);
        }
    };

    CurveProcessor.prototype.invertAxis = function invertAxis (p0, p1, p2) {
        var invertAxis = false;

        if (p0.x === p1.x) {
            invertAxis = true;
        } else if (p1.x === p2.x) {
            if ((p1.y < p2.y && p0.y <= p1.y) || (p2.y < p1.y && p1.y <= p0.y)) {
                invertAxis = true;
            }
        } else {
            var fn = this.lineFunction(p0,p1);
            var y2 = this.calculateFunction(fn, p2.x);
            if (!(p0.y <= p1.y && p2.y <= y2) &&
                !(p1.y <= p0.y && p2.y >= y2)) {
                invertAxis = true;
            }
        }

        return invertAxis;
    };

    CurveProcessor.prototype.isLine = function isLine (p0, p1, p2) {
        var fn = this.lineFunction(p0, p1);
        var y2 = this.calculateFunction(fn, p2.x);

        return (p0.x === p1.x && p1.x === p2.x) || round$1(y2, 1) === round$1(p2.y, 1);
    };

    CurveProcessor.prototype.lineFunction = function lineFunction (p1, p2) {
        var a = (p2.y - p1.y) / (p2.x - p1.x);
        var b = p1.y - a * p1.x;

        return [ b, a ];
    };

    CurveProcessor.prototype.controlPoints = function controlPoints (p0, p1, p2) {
        var xField = X;
        var yField = Y;
        var restrict = false;
        var switchOrientation = false;
        var tangent;

        if (this.isLine(p0, p1, p2)) {
            tangent = this.tangent(p0, p1, X, Y);
        } else {
            var monotonic = {
                x: this.isMonotonicByField(p0, p1, p2, X),
                y: this.isMonotonicByField(p0, p1, p2, Y)
            };

            if (monotonic.x && monotonic.y) {
                tangent = this.tangent(p0, p2, X, Y);
                restrict = true;
            } else {
                if (this.invertAxis(p0, p1, p2)) {
                    xField = Y;
                    yField = X;
                }

                if (monotonic[xField]) {
                    tangent = 0;
                } else {
                    var sign;
                    if ((p2[yField] < p0[yField] && p0[yField] <= p1[yField]) ||
                        (p0[yField] < p2[yField] && p1[yField] <= p0[yField])) {
                        sign = numberSign((p2[yField] - p0[yField]) * (p1[xField] - p0[xField]));
                    } else {
                        sign = -numberSign((p2[xField] - p0[xField]) * (p1[yField] - p0[yField]));
                    }

                    tangent = EXTREMUM_ALLOWED_DEVIATION * sign;
                    switchOrientation = true;
                }
            }
        }

        var secondControlPoint = this.secondControlPoint(tangent, p0, p1, xField, yField);

        if (switchOrientation) {
            var oldXField = xField;
            xField = yField;
            yField = oldXField;
        }

        var firstControlPoint = this.firstControlPoint(tangent, p1, p2, xField, yField);

        if (restrict) {
            this.restrictControlPoint(p0, p1, secondControlPoint, tangent);
            this.restrictControlPoint(p1, p2, firstControlPoint, tangent);
        }

        return [ secondControlPoint, firstControlPoint ];
    };

    CurveProcessor.prototype.restrictControlPoint = function restrictControlPoint (p1, p2, cp, tangent) {
        if (p1.y < p2.y) {
            if (p2.y < cp.y) {
                cp.x = p1.x + (p2.y - p1.y) / tangent;
                cp.y = p2.y;
            } else if (cp.y < p1.y) {
                cp.x = p2.x - (p2.y - p1.y) / tangent;
                cp.y = p1.y;
            }
        } else {
            if (cp.y < p2.y) {
                cp.x = p1.x - (p1.y - p2.y) / tangent;
                cp.y = p2.y;
            } else if (p1.y < cp.y) {
                cp.x = p2.x + (p1.y - p2.y) / tangent;
                cp.y = p1.y;
            }
        }
    };

    CurveProcessor.prototype.tangent = function tangent (p0, p1, xField, yField) {
        var x = p1[xField] - p0[xField];
        var y = p1[yField] - p0[yField];
        var tangent;

        if (x === 0) {
            tangent = 0;
        } else {
            tangent = y / x;
        }

        return tangent;
    };

    CurveProcessor.prototype.isMonotonicByField = function isMonotonicByField (p0, p1, p2, field) {
        return (p2[field] > p1[field] && p1[field] > p0[field]) ||
                    (p2[field] < p1[field] && p1[field] < p0[field]);
    };

    CurveProcessor.prototype.firstControlPoint = function firstControlPoint (tangent, p0, p3, xField, yField) {
        var t1 = p0[xField];
        var t2 = p3[xField];
        var distance = (t2 - t1) * WEIGHT;

        return this.point(t1 + distance, p0[yField] + distance * tangent, xField, yField);
    };

    CurveProcessor.prototype.secondControlPoint = function secondControlPoint (tangent, p0, p3, xField, yField) {
        var t1 = p0[xField];
        var t2 = p3[xField];
        var distance = (t2 - t1) * WEIGHT;

        return this.point(t2 - distance, p3[yField] - distance * tangent, xField, yField);
    };

    CurveProcessor.prototype.point = function point (xValue, yValue, xField, yField) {
        var controlPoint = new Point$6();
        controlPoint[xField] = xValue;
        controlPoint[yField] = yValue;

        return controlPoint;
    };

    CurveProcessor.prototype.calculateFunction = function calculateFunction (fn, x) {
        var length = fn.length;
        var result = 0;

        for (var i = 0; i < length; i++) {
            result += Math.pow(x,i) * fn[i];
        }
        return result;
    };

    return CurveProcessor;
}(Class));

function numberSign(value) {
    return value <= 0 ? -1 : 1;
}

var coreExport = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Axis: Axis,
    AxisLabel: AxisLabel,
    Box: Box,
    BoxElement: BoxElement,
    CategoryAxis: CategoryAxis,
    ChartElement: ChartElement,
    Class: Class,
    CurveProcessor: CurveProcessor,
    DateCategoryAxis: DateCategoryAxis,
    DateValueAxis: DateValueAxis,
    FloatElement: FloatElement,
    FontLoader: FontLoader,
    Gradients: GRADIENTS,
    HashMap: HashMap,
    InstanceObserver: InstanceObserver,
    LogarithmicAxis: LogarithmicAxis,
    Matrix: Matrix,
    Note: Note,
    NumericAxis: NumericAxis,
    Observable: Observable,
    Point: Point$5,
    PolarAxis: PolarAxis,
    RadarCategoryAxis: RadarCategoryAxis,
    RadarLogarithmicAxis: RadarLogarithmicAxis,
    RadarNumericAxis: RadarNumericAxis,
    Ring: Ring,
    RootElement: RootElement,
    Sector: Sector,
    ShapeBuilder: ShapeBuilder,
    ShapeElement: ShapeElement,
    Text: Text$1,
    TextBox: TextBox,
    Title: Title$1,
    UserEvents: UserEvents,
    absoluteDateDiff: absoluteDateDiff,
    addClass: addClass,
    addDuration: addDuration,
    addTicks: addTicks,
    alignPathToPixel: alignPathToPixel,
    append: append,
    applyEventMap: applyEventMap,
    autoMajorUnit: autoMajorUnit,
    autoTextColor: autoTextColor,
    bindEvents: bindEvents,
    ceilDate: ceilDate,
    clockwise: clockwise,
    constants: constants$2,
    convertableToNumber: convertableToNumber,
    createHashSet: createHashSet,
    createPatternFill: createPatternFill,
    cycleDown: cycleDown,
    cycleIndex: cycleIndex,
    cycleUp: cycleUp,
    dateComparer: dateComparer,
    dateDiff: dateDiff,
    dateEquals: dateEquals,
    dateIndex: dateIndex,
    deepExtend: deepExtend,
    defaultErrorHandler: defaultErrorHandler,
    defined: defined,
    deg: deg,
    duration: duration,
    elementOffset: elementOffset,
    elementScale: elementScale,
    elementSize: elementSize,
    elementStyles: elementStyles$1,
    eventCoordinates: eventCoordinates,
    eventElement: eventElement,
    eventMap: eventMap,
    find: find,
    firstDay: firstDay,
    floorDate: floorDate,
    getAriaTemplate: getTemplate,
    getSpacing: getSpacing,
    getSupportedFeatures: getSupportedFeatures,
    getTemplate: getTemplate$1,
    getter: getter,
    grep: grep,
    hasClasses: hasClasses,
    hasOwnProperty: hasOwnProperty,
    hashKey: hashKey,
    inArray: inArray,
    interpolateValue: interpolateValue,
    isArray: isArray,
    isFunction: isFunction,
    isNumber: isNumber,
    isObject: isObject,
    isPlainObject: isPlainObject,
    isString: isString$1,
    keys: keys,
    last: last,
    limitValue: limitValue,
    logToConsole: logToConsole,
    lteDateIndex: lteDateIndex,
    map: map,
    mousewheelDelta: mousewheelDelta,
    noop: noop,
    now: now,
    objectKey: objectKey,
    off: off,
    on: on,
    parseDate: parseDate,
    parseDates: parseDates,
    rad: rad,
    rectToBox: rectToBox,
    removeClass: removeClass,
    renderIcon: renderIcon,
    round: round$1,
    services: services,
    setDefaultOptions: setDefaultOptions,
    sparseArrayLimits: sparseArrayLimits,
    startOfWeek: startOfWeek,
    styleValue: styleValue,
    toDate: toDate,
    toTime: toTime,
    unbindEvents: unbindEvents,
    valueOrDefault: valueOrDefault
});

var ChartAxis = (function (Class) {
    function ChartAxis(axis) {
        Class.call(this);

        this._axis = axis;
        this.options = axis.options;
    }

    if ( Class ) ChartAxis.__proto__ = Class;
    ChartAxis.prototype = Object.create( Class && Class.prototype );
    ChartAxis.prototype.constructor = ChartAxis;

    ChartAxis.prototype.value = function value (point) {
        var axis = this._axis;
        var value = axis.getCategory ? axis.getCategory(point) : axis.getValue(point);

        return value;
    };

    ChartAxis.prototype.slot = function slot (from, to, limit) {
        if ( limit === void 0 ) limit = true;

        return this._axis.slot(from, to, limit);
    };

    ChartAxis.prototype.range = function range () {
        return this._axis.range();
    };

    ChartAxis.prototype.valueRange = function valueRange () {
        return this._axis.valueRange();
    };

    return ChartAxis;
}(Class));

function findAxisByName(name, axes) {
    for (var idx = 0; idx < axes.length; idx++) {
        if (axes[idx].options.name === name) {
            axes[idx].prepareUserOptions();
            return new ChartAxis(axes[idx]);
        }
    }
}

var ChartPane = function ChartPane(pane) {
    this.visual = pane.visual;
    this.chartsVisual = pane.chartContainer.visual;
    this._pane = pane;
};

ChartPane.prototype.findAxisByName = function findAxisByName$1 (name) {
    return findAxisByName(name, this._pane.axes);
};

var ChartPlotArea = (function (Class) {
    function ChartPlotArea(plotArea) {
        Class.call(this);

        this._plotArea = plotArea;
        this.visual = plotArea.visual;
        this.backgroundVisual = plotArea._bgVisual;
    }

    if ( Class ) ChartPlotArea.__proto__ = Class;
    ChartPlotArea.prototype = Object.create( Class && Class.prototype );
    ChartPlotArea.prototype.constructor = ChartPlotArea;

    return ChartPlotArea;
}(Class));

function countNumbers(values) {
    var length = values.length;
    var count = 0;

    for (var i = 0; i < length; i++) {
        var num = values[i];
        if (isNumber(num)) {
            count++;
        }
    }

    return count;
}

var Aggregates = {
    min: function(values) {
        var length = values.length;
        var min = MAX_VALUE;

        for (var i = 0; i < length; i++) {
            var value = values[i];
            if (isNumber(value)) {
                min = Math.min(min, value);
            }
        }

        return min === MAX_VALUE ? values[0] : min;
    },

    max: function(values) {
        var length = values.length;
        var max = MIN_VALUE;

        for (var i = 0; i < length; i++) {
            var value = values[i];
            if (isNumber(value)) {
                max = Math.max(max, value);
            }
        }

        return max === MIN_VALUE ? values[0] : max;
    },

    sum: function(values) {
        var length = values.length;
        var sum = 0;

        for (var i = 0; i < length; i++) {
            var value = values[i];
            if (isNumber(value)) {
                sum += value;
            }
        }

        return sum;
    },

    sumOrNull: function(values) {
        var result = null;

        if (countNumbers(values)) {
            result = Aggregates.sum(values);
        }

        return result;
    },

    count: function(values) {
        var length = values.length;
        var count = 0;

        for (var i = 0; i < length; i++) {
            var value = values[i];
            if (value !== null && defined(value)) {
                count++;
            }
        }

        return count;
    },

    avg: function(values) {
        var count = countNumbers(values);
        var result = values[0];

        if (count > 0) {
            result = Aggregates.sum(values) / count;
        }

        return result;
    },

    first: function(values) {
        var length = values.length;

        for (var i = 0; i < length; i++) {
            var value = values[i];
            if (value !== null && defined(value)) {
                return value;
            }
        }

        return values[0];
    }
};

function getField(field, row) {
    if (row === null) {
        return row;
    }

    var get = getter(field, true);
    return get(row);
}

var SeriesBinder = (function (Class) {
    function SeriesBinder() {
        Class.call(this);

        this._valueFields = {};
        this._otherFields = {};
        this._nullValue = {};
        this._undefinedValue = {};
    }

    if ( Class ) SeriesBinder.__proto__ = Class;
    SeriesBinder.prototype = Object.create( Class && Class.prototype );
    SeriesBinder.prototype.constructor = SeriesBinder;

    SeriesBinder.prototype.register = function register (seriesTypes, valueFields, otherFields) {
        var this$1$1 = this;
        if ( valueFields === void 0 ) valueFields = [ VALUE ];
        if ( otherFields === void 0 ) otherFields = {};


        for (var i = 0; i < seriesTypes.length; i++) {
            var type = seriesTypes[i];

            this$1$1._valueFields[type] = valueFields;
            this$1$1._otherFields[type] = otherFields;
            this$1$1._nullValue[type] = this$1$1._makeValue(valueFields, null);
            this$1$1._undefinedValue[type] = this$1$1._makeValue(valueFields, undefined);
        }
    };

    SeriesBinder.prototype.canonicalFields = function canonicalFields (series) {
        return this.valueFields(series).concat(this.otherFields(series));
    };

    SeriesBinder.prototype.valueFields = function valueFields (series) {
        return this._valueFields[series.type] || [ VALUE ];
    };

    SeriesBinder.prototype.otherFields = function otherFields (series) {
        return this._otherFields[series.type] || [ VALUE ];
    };

    SeriesBinder.prototype.bindPoint = function bindPoint (series, pointIx, item) {
        var data = series.data;
        var pointData = defined(item) ? item : data[pointIx];
        var result = { valueFields: { value: pointData } };
        var valueFields = this.valueFields(series);
        var otherFields = this._otherFields[series.type];
        var fields, value;

        if (pointData === null) {
            value = this._nullValue[series.type];
        } else if (!defined(pointData)) {
            value = this._undefinedValue[series.type];
        } else if (Array.isArray(pointData)) {
            var fieldData = pointData.slice(valueFields.length);
            value = this._bindFromArray(pointData, valueFields);
            fields = this._bindFromArray(fieldData, otherFields);
        } else if (typeof pointData === "object") {
            var srcValueFields = this.sourceFields(series, valueFields);
            var srcPointFields = this.sourceFields(series, otherFields);

            value = this._bindFromObject(pointData, valueFields, srcValueFields);
            fields = this._bindFromObject(pointData, otherFields, srcPointFields);
        }

        if (defined(value)) {
            if (valueFields.length === 1) {
                result.valueFields.value = value[valueFields[0]];
            } else {
                result.valueFields = value;
            }
        }

        result.fields = fields || {};

        return result;
    };

    SeriesBinder.prototype._makeValue = function _makeValue (fields, initialValue) {
        var value = {};
        var length = fields.length;

        for (var i = 0; i < length; i++) {
            var fieldName = fields[i];
            value[fieldName] = initialValue;
        }

        return value;
    };

    SeriesBinder.prototype._bindFromArray = function _bindFromArray (array, fields) {
        var value = {};

        if (fields) {
            var length = Math.min(fields.length, array.length);

            for (var i = 0; i < length; i++) {
                value[fields[i]] = array[i];
            }
        }

        return value;
    };

    SeriesBinder.prototype._bindFromObject = function _bindFromObject (object, fields, srcFields) {
        if ( srcFields === void 0 ) srcFields = fields;

        var value = {};

        if (fields) {
            var length = fields.length;

            for (var i = 0; i < length; i++) {
                var fieldName = fields[i];
                var srcFieldName = srcFields[i];
                if (srcFieldName !== null) {
                    value[fieldName] = getField(srcFieldName, object);
                }
            }
        }

        return value;
    };

    SeriesBinder.prototype.sourceFields = function sourceFields (series, canonicalFields) {
        var sourceFields = [];

        if (canonicalFields) {
            var length = canonicalFields.length;

            for (var i = 0; i < length; i++) {
                var fieldName = canonicalFields[i];
                var sourceFieldName = fieldName === VALUE ? "field" : fieldName + "Field";

                sourceFields.push(series[sourceFieldName] !== null ? (series[sourceFieldName] || fieldName) : null);
            }
        }

        return sourceFields;
    };

    return SeriesBinder;
}(Class));

SeriesBinder.current = new SeriesBinder();

var STD_ERR = "stderr";
var STD_DEV = "stddev";
var percentRegex = /percent(?:\w*)\((\d+)\)/;
var standardDeviationRegex = new RegExp("^" + STD_DEV + "(?:\\((\\d+(?:\\.\\d+)?)\\))?$");

var ErrorRangeCalculator = (function (Class) {
    function ErrorRangeCalculator(errorValue, series, field) {
        Class.call(this);

        this.initGlobalRanges(errorValue, series, field);
    }

    if ( Class ) ErrorRangeCalculator.__proto__ = Class;
    ErrorRangeCalculator.prototype = Object.create( Class && Class.prototype );
    ErrorRangeCalculator.prototype.constructor = ErrorRangeCalculator;

    ErrorRangeCalculator.prototype.initGlobalRanges = function initGlobalRanges (errorValue, series, field) {
        var data = series.data;
        var deviationMatch = standardDeviationRegex.exec(errorValue);

        if (deviationMatch) {
            this.valueGetter = this.createValueGetter(series, field);

            var average = this.getAverage(data);
            var deviation = this.getStandardDeviation(data, average, false);
            var multiple = deviationMatch[1] ? parseFloat(deviationMatch[1]) : 1;
            var errorRange = { low: average.value - deviation * multiple, high: average.value + deviation * multiple };

            this.globalRange = function() {
                return errorRange;
            };
        } else if (errorValue.indexOf && errorValue.indexOf(STD_ERR) >= 0) {
            this.valueGetter = this.createValueGetter(series, field);
            var standardError = this.getStandardError(data, this.getAverage(data));

            this.globalRange = function(value) {
                return { low: value - standardError, high: value + standardError };
            };
        }
    };

    ErrorRangeCalculator.prototype.createValueGetter = function createValueGetter (series, field) {
        var data = series.data;
        var binder = SeriesBinder.current;
        var valueFields = binder.valueFields(series);
        var item = defined(data[0]) ? data[0] : {};
        var valueGetter;

        if (isArray(item)) {
            var index = field ? valueFields.indexOf(field) : 0;
            valueGetter = getter("[" + index + "]");
        } else if (isNumber(item)) {
            valueGetter = getter();
        } else if (typeof item === OBJECT$1) {
            var srcValueFields = binder.sourceFields(series, valueFields);
            valueGetter = getter(srcValueFields[valueFields.indexOf(field)]);
        }

        return valueGetter;
    };

    ErrorRangeCalculator.prototype.getErrorRange = function getErrorRange (pointValue, errorValue) {
        var low, high, value;

        if (!defined(errorValue)) {
            return null;
        }

        if (this.globalRange) {
            return this.globalRange(pointValue);
        }

        if (isArray(errorValue)) {
            low = pointValue - errorValue[0];
            high = pointValue + errorValue[1];
        } else if (isNumber(value = parseFloat(errorValue))) {
            low = pointValue - value;
            high = pointValue + value;
        } else if ((value = percentRegex.exec(errorValue))) {
            var percentValue = pointValue * (parseFloat(value[1]) / 100);
            low = pointValue - Math.abs(percentValue);
            high = pointValue + Math.abs(percentValue);
        } else {
            throw new Error("Invalid ErrorBar value: " + errorValue);
        }

        return { low: low, high: high };
    };

    ErrorRangeCalculator.prototype.getStandardError = function getStandardError (data, average) {
        return this.getStandardDeviation(data, average, true) / Math.sqrt(average.count);
    };

    ErrorRangeCalculator.prototype.getStandardDeviation = function getStandardDeviation (data, average, isSample) {
        var this$1$1 = this;

        var length = data.length;
        var total = isSample ? average.count - 1 : average.count;
        var squareDifferenceSum = 0;

        for (var idx = 0; idx < length; idx++) {
            var value = this$1$1.valueGetter(data[idx]);
            if (isNumber(value)) {
                squareDifferenceSum += Math.pow(value - average.value, 2);
            }
        }

        return Math.sqrt(squareDifferenceSum / total);
    };

    ErrorRangeCalculator.prototype.getAverage = function getAverage (data) {
        var this$1$1 = this;

        var length = data.length;
        var sum = 0;
        var count = 0;

        for (var idx = 0; idx < length; idx++) {
            var value = this$1$1.valueGetter(data[idx]);
            if (isNumber(value)) {
                sum += value;
                count++;
            }
        }

        return {
            value: sum / count,
            count: count
        };
    };

    return ErrorRangeCalculator;
}(Class));

var browser = support.browser || {};

var INITIAL_ANIMATION_DURATION = 600;
var FADEIN = "fadeIn";

var GLASS = "glass";
var BORDER_BRIGHTNESS = 0.8;
var TOOLTIP_OFFSET = 5;
var START_SCALE = browser.msie ? 0.001 : 0;
var ERROR_LOW_FIELD = "errorLow";
var ERROR_HIGH_FIELD = "errorHigh";
var X_ERROR_LOW_FIELD = "xErrorLow";
var X_ERROR_HIGH_FIELD = "xErrorHigh";
var Y_ERROR_LOW_FIELD = "yErrorLow";
var Y_ERROR_HIGH_FIELD = "yErrorHigh";
var LINE_MARKER_SIZE = 8;
var ZERO = "zero";
var INTERPOLATE = "interpolate";
var GAP = "gap";
var ABOVE = "above";
var BELOW = "below";
var BOTTOM = "bottom";

var SMOOTH = "smooth";
var STEP = "step";

var AREA = "area";
var BAR = "bar";
var BOX_PLOT = "boxPlot";
var BUBBLE = "bubble";
var BULLET = "bullet";
var CANDLESTICK = "candlestick";
var COLUMN = "column";
var DONUT = "donut";
var FUNNEL = "funnel";
var PYRAMID = "pyramid";
var HEATMAP = "heatmap";
var HORIZONTAL_WATERFALL = "horizontalWaterfall";
var LINE = "line";
var OHLC = "ohlc";
var PIE = "pie";
var POLAR_AREA = "polarArea";
var POLAR_LINE = "polarLine";
var POLAR_SCATTER = "polarScatter";
var RADAR_AREA = "radarArea";
var RADAR_COLUMN = "radarColumn";
var RADAR_LINE = "radarLine";
var RANGE_AREA = "rangeArea";
var RANGE_BAR = "rangeBar";
var RANGE_COLUMN = "rangeColumn";
var SCATTER = "scatter";
var SCATTER_LINE = "scatterLine";
var VERTICAL_AREA = "verticalArea";
var VERTICAL_BOX_PLOT = "verticalBoxPlot";
var VERTICAL_BULLET = "verticalBullet";
var VERTICAL_LINE = "verticalLine";
var VERTICAL_RANGE_AREA = "verticalRangeArea";
var WATERFALL = "waterfall";
var EQUALLY_SPACED_SERIES = [
    BAR, COLUMN, OHLC, CANDLESTICK, BOX_PLOT, VERTICAL_BOX_PLOT,
    BULLET, RANGE_COLUMN, RANGE_BAR, WATERFALL, HORIZONTAL_WATERFALL
];

var TRENDLINE_EXPONENTIAL = 'exponentialTrendline';
var TRENDLINE_LINEAR = 'linearTrendline';
var TRENDLINE_LOGARITHMIC = 'logarithmicTrendline';
var TRENDLINE_MOVING_AVERAGE = 'movingAverageTrendline';
var TRENDLINE_POLYNOMIAL = 'polynomialTrendline';
var TRENDLINE_POWER = 'powerTrendline';
var TRENDLINE_SERIES = [
    TRENDLINE_EXPONENTIAL,
    TRENDLINE_LINEAR,
    TRENDLINE_LOGARITHMIC,
    TRENDLINE_MOVING_AVERAGE,
    TRENDLINE_POLYNOMIAL,
    TRENDLINE_POWER
];

var LEGEND_ITEM_CLICK = "legendItemClick";
var LEGEND_ITEM_HOVER = "legendItemHover";
var LEGEND_ITEM_LEAVE = "legendItemLeave";
var SERIES_CLICK = "seriesClick";
var SERIES_HOVER = "seriesHover";
var SERIES_OVER = "seriesOver";
var SERIES_LEAVE = "seriesLeave";
var PLOT_AREA_CLICK = "plotAreaClick";
var PLOT_AREA_HOVER = "plotAreaHover";
var PLOT_AREA_LEAVE = "plotAreaLeave";
var DRAG = "drag";
var DRAG_END = "dragEnd";
var DRAG_START = "dragStart";
var ZOOM_START = "zoomStart";
var ZOOM = "zoom";
var ZOOM_END = "zoomEnd";
var SELECT_START = "selectStart";
var SELECT = "select";
var SELECT_END = "selectEnd";
var RENDER = "render";
var SHOW_TOOLTIP$1 = "showTooltip";
var HIDE_TOOLTIP$1 = "hideTooltip";
var PANE_RENDER = "paneRender";


var CHART_POINT_ROLE = "graphics-symbol";
var CHART_POINT_CLASSNAME = "k-chart-point";
var CHART_POINT_ROLE_DESCRIPTION = "Point";
var LEGEND_ITEM_ROLE = "checkbox";
var LEGEND_ITEM_CLASSNAME = "k-chart-legend-item";
var LEGEND_ITEM_ARIA_ROLE_DESCRIPTION = "Legend item";

var LOGARITHMIC = "log";
var CATEGORY = "category";

var INSIDE_END = "insideEnd";
var INSIDE_BASE = "insideBase";
var OUTSIDE_END = "outsideEnd";

var MOUSEWHEEL$1 = "wheel";
var MOUSEWHEEL_DELAY = 150;
var MOUSEWHEEL_ZOOM_RATE = 0.3;

var DRILLDOWN = "drilldown";
var DRILLDOWN_FIELD = "drilldown";
var PATTERN_FIELD = "pattern";

var MIN_MOVING_AVERAGE_PERIOD = 2;

var constants$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ABOVE: ABOVE,
    AREA: AREA,
    BAR: BAR,
    BELOW: BELOW,
    BORDER_BRIGHTNESS: BORDER_BRIGHTNESS,
    BOTTOM: BOTTOM,
    BOX_PLOT: BOX_PLOT,
    BUBBLE: BUBBLE,
    BULLET: BULLET,
    CANDLESTICK: CANDLESTICK,
    CATEGORY: CATEGORY,
    CHART_POINT_CLASSNAME: CHART_POINT_CLASSNAME,
    CHART_POINT_ROLE: CHART_POINT_ROLE,
    CHART_POINT_ROLE_DESCRIPTION: CHART_POINT_ROLE_DESCRIPTION,
    COLUMN: COLUMN,
    DONUT: DONUT,
    DRAG: DRAG,
    DRAG_END: DRAG_END,
    DRAG_START: DRAG_START,
    DRILLDOWN: DRILLDOWN,
    DRILLDOWN_FIELD: DRILLDOWN_FIELD,
    EQUALLY_SPACED_SERIES: EQUALLY_SPACED_SERIES,
    ERROR_HIGH_FIELD: ERROR_HIGH_FIELD,
    ERROR_LOW_FIELD: ERROR_LOW_FIELD,
    FADEIN: FADEIN,
    FUNNEL: FUNNEL,
    GAP: GAP,
    GLASS: GLASS,
    HEATMAP: HEATMAP,
    HIDE_TOOLTIP: HIDE_TOOLTIP$1,
    HORIZONTAL_WATERFALL: HORIZONTAL_WATERFALL,
    INITIAL_ANIMATION_DURATION: INITIAL_ANIMATION_DURATION,
    INSIDE_BASE: INSIDE_BASE,
    INSIDE_END: INSIDE_END,
    INTERPOLATE: INTERPOLATE,
    LEGEND_ITEM_ARIA_ROLE_DESCRIPTION: LEGEND_ITEM_ARIA_ROLE_DESCRIPTION,
    LEGEND_ITEM_CLASSNAME: LEGEND_ITEM_CLASSNAME,
    LEGEND_ITEM_CLICK: LEGEND_ITEM_CLICK,
    LEGEND_ITEM_HOVER: LEGEND_ITEM_HOVER,
    LEGEND_ITEM_LEAVE: LEGEND_ITEM_LEAVE,
    LEGEND_ITEM_ROLE: LEGEND_ITEM_ROLE,
    LINE: LINE,
    LINE_MARKER_SIZE: LINE_MARKER_SIZE,
    LOGARITHMIC: LOGARITHMIC,
    MIN_MOVING_AVERAGE_PERIOD: MIN_MOVING_AVERAGE_PERIOD,
    MOUSEWHEEL: MOUSEWHEEL$1,
    MOUSEWHEEL_DELAY: MOUSEWHEEL_DELAY,
    MOUSEWHEEL_ZOOM_RATE: MOUSEWHEEL_ZOOM_RATE,
    OHLC: OHLC,
    OUTSIDE_END: OUTSIDE_END,
    PANE_RENDER: PANE_RENDER,
    PATTERN_FIELD: PATTERN_FIELD,
    PIE: PIE,
    PLOT_AREA_CLICK: PLOT_AREA_CLICK,
    PLOT_AREA_HOVER: PLOT_AREA_HOVER,
    PLOT_AREA_LEAVE: PLOT_AREA_LEAVE,
    POLAR_AREA: POLAR_AREA,
    POLAR_LINE: POLAR_LINE,
    POLAR_SCATTER: POLAR_SCATTER,
    PYRAMID: PYRAMID,
    RADAR_AREA: RADAR_AREA,
    RADAR_COLUMN: RADAR_COLUMN,
    RADAR_LINE: RADAR_LINE,
    RANGE_AREA: RANGE_AREA,
    RANGE_BAR: RANGE_BAR,
    RANGE_COLUMN: RANGE_COLUMN,
    RENDER: RENDER,
    SCATTER: SCATTER,
    SCATTER_LINE: SCATTER_LINE,
    SELECT: SELECT,
    SELECT_END: SELECT_END,
    SELECT_START: SELECT_START,
    SERIES_CLICK: SERIES_CLICK,
    SERIES_HOVER: SERIES_HOVER,
    SERIES_LEAVE: SERIES_LEAVE,
    SERIES_OVER: SERIES_OVER,
    SHOW_TOOLTIP: SHOW_TOOLTIP$1,
    SMOOTH: SMOOTH,
    START_SCALE: START_SCALE,
    STEP: STEP,
    TOOLTIP_OFFSET: TOOLTIP_OFFSET,
    TRENDLINE_EXPONENTIAL: TRENDLINE_EXPONENTIAL,
    TRENDLINE_LINEAR: TRENDLINE_LINEAR,
    TRENDLINE_LOGARITHMIC: TRENDLINE_LOGARITHMIC,
    TRENDLINE_MOVING_AVERAGE: TRENDLINE_MOVING_AVERAGE,
    TRENDLINE_POLYNOMIAL: TRENDLINE_POLYNOMIAL,
    TRENDLINE_POWER: TRENDLINE_POWER,
    TRENDLINE_SERIES: TRENDLINE_SERIES,
    VERTICAL_AREA: VERTICAL_AREA,
    VERTICAL_BOX_PLOT: VERTICAL_BOX_PLOT,
    VERTICAL_BULLET: VERTICAL_BULLET,
    VERTICAL_LINE: VERTICAL_LINE,
    VERTICAL_RANGE_AREA: VERTICAL_RANGE_AREA,
    WATERFALL: WATERFALL,
    X_ERROR_HIGH_FIELD: X_ERROR_HIGH_FIELD,
    X_ERROR_LOW_FIELD: X_ERROR_LOW_FIELD,
    Y_ERROR_HIGH_FIELD: Y_ERROR_HIGH_FIELD,
    Y_ERROR_LOW_FIELD: Y_ERROR_LOW_FIELD,
    ZERO: ZERO,
    ZOOM: ZOOM,
    ZOOM_END: ZOOM_END,
    ZOOM_START: ZOOM_START
});

var DEFAULT_ERROR_BAR_WIDTH = 4;

var ErrorBarBase = (function (ChartElement) {
    function ErrorBarBase(low, high, isVertical, chart, series, options) {
        ChartElement.call(this, options);

        this.low = low;
        this.high = high;
        this.isVertical = isVertical;
        this.chart = chart;
        this.series = series;
    }

    if ( ChartElement ) ErrorBarBase.__proto__ = ChartElement;
    ErrorBarBase.prototype = Object.create( ChartElement && ChartElement.prototype );
    ErrorBarBase.prototype.constructor = ErrorBarBase;

    ErrorBarBase.prototype.reflow = function reflow (targetBox) {
        var endCaps = this.options.endCaps;
        var isVertical = this.isVertical;
        var axis = this.getAxis();
        var valueBox = axis.getSlot(this.low, this.high);
        var centerBox = targetBox.center();
        var capsWidth = this.getCapsWidth(targetBox, isVertical);
        var capValue = isVertical ? centerBox.x : centerBox.y;
        var capStart = capValue - capsWidth;
        var capEnd = capValue + capsWidth;
        var linePoints;

        if (isVertical) {
            linePoints = [
                new Point$5(centerBox.x, valueBox.y1),
                new Point$5(centerBox.x, valueBox.y2)
            ];
            if (endCaps) {
                linePoints.push(new Point$5(capStart, valueBox.y1),
                    new Point$5(capEnd, valueBox.y1),
                    new Point$5(capStart, valueBox.y2),
                    new Point$5(capEnd, valueBox.y2));
            }
            this.box = new Box(capStart, valueBox.y1, capEnd, valueBox.y2);
        } else {
            linePoints = [
                new Point$5(valueBox.x1, centerBox.y),
                new Point$5(valueBox.x2, centerBox.y)
            ];
            if (endCaps) {
                linePoints.push(new Point$5(valueBox.x1, capStart),
                    new Point$5(valueBox.x1, capEnd),
                    new Point$5(valueBox.x2, capStart),
                    new Point$5(valueBox.x2, capEnd));
            }
            this.box = new Box(valueBox.x1, capStart, valueBox.x2, capEnd);
        }

        this.linePoints = linePoints;
    };

    ErrorBarBase.prototype.getCapsWidth = function getCapsWidth (box, isVertical) {
        var boxSize = isVertical ? box.width() : box.height();
        var capsWidth = Math.min(Math.floor(boxSize / 2), DEFAULT_ERROR_BAR_WIDTH) || DEFAULT_ERROR_BAR_WIDTH;

        return capsWidth;
    };

    ErrorBarBase.prototype.createVisual = function createVisual () {
        var this$1$1 = this;

        var options = this.options;
        var visual = options.visual;

        if (visual) {
            this.visual = visual({
                low: this.low,
                high: this.high,
                rect: this.box.toRect(),
                sender: this.getSender(),
                options: {
                    endCaps: options.endCaps,
                    color: options.color,
                    line: options.line
                },
                createVisual: function () {
                    this$1$1.createDefaultVisual();
                    var defaultVisual = this$1$1.visual;
                    delete this$1$1.visual;
                    return defaultVisual;
                }
            });
        } else {
            this.createDefaultVisual();
        }
    };

    ErrorBarBase.prototype.createDefaultVisual = function createDefaultVisual () {
        var this$1$1 = this;

        var ref = this;
        var options = ref.options;
        var linePoints = ref.linePoints;
        var lineOptions = {
            stroke: {
                color: options.color,
                width: options.line.width,
                dashType: options.line.dashType
            }
        };

        ChartElement.prototype.createVisual.call(this);

        for (var idx = 0; idx < linePoints.length; idx += 2) {
            var line = new Path$7(lineOptions)
                .moveTo(linePoints[idx].x, linePoints[idx].y)
                .lineTo(linePoints[idx + 1].x, linePoints[idx + 1].y);

            alignPathToPixel(line);
            this$1$1.visual.append(line);
        }
    };

    return ErrorBarBase;
}(ChartElement));

setDefaultOptions(ErrorBarBase, {
    animation: {
        type: FADEIN,
        delay: INITIAL_ANIMATION_DURATION
    },
    endCaps: true,
    line: {
        width: 2
    },
    zIndex: 1
});

var CategoricalErrorBar = (function (ErrorBarBase) {
    function CategoricalErrorBar () {
        ErrorBarBase.apply(this, arguments);
    }

    if ( ErrorBarBase ) CategoricalErrorBar.__proto__ = ErrorBarBase;
    CategoricalErrorBar.prototype = Object.create( ErrorBarBase && ErrorBarBase.prototype );
    CategoricalErrorBar.prototype.constructor = CategoricalErrorBar;

    CategoricalErrorBar.prototype.getAxis = function getAxis () {
        var axis = this.chart.seriesValueAxis(this.series);

        return axis;
    };

    return CategoricalErrorBar;
}(ErrorBarBase));

function anyHasZIndex(elements) {
    for (var idx = 0; idx < elements.length; idx++) {
        if (defined(elements[idx].zIndex)) {
            return true;
        }
    }
}

function appendIfNotNull(array, element) {
    if (element !== null) {
        array.push(element);
    }
}

function areNumbers(values) {
    return countNumbers(values) === values.length;
}

function segmentVisible(series, fields, index) {
    var visible = fields.visible;
    if (defined(visible)) {
        return visible;
    }

    var pointVisibility = series.pointVisibility;
    if (pointVisibility) {
        return pointVisibility[index];
    }
}

function bindSegments(series) {
    var data = series.data;
    var points = [];
    var sum = 0;
    var count = 0;

    for (var idx = 0; idx < data.length; idx++) {
        var pointData = SeriesBinder.current.bindPoint(series, idx);
        var value = pointData.valueFields.value;


        if (isString$1(value)) {
            value = parseFloat(value);
        }

        if (isNumber(value)) {
            pointData.visible = segmentVisible(series, pointData.fields, idx) !== false;

            pointData.value = Math.abs(value);
            points.push(pointData);

            if (pointData.visible) {
                sum += pointData.value;
            }

            if (value !== 0) {
                count++;
            }
        } else {
            points.push(null);
        }
    }

    return {
        total: sum,
        points: points,
        count: count
    };
}

function categoriesCount(series) {
    var seriesCount = series.length;
    var categories = 0;

    for (var i = 0; i < seriesCount; i++) {
        categories = Math.max(categories, series[i].data.length);
    }

    return categories;
}

function equalsIgnoreCase(a, b) {
    if (a && b) {
        return a.toLowerCase() === b.toLowerCase();
    }

    return a === b;
}

var MAX_EXPAND_DEPTH = 5;

function evalOptions(options, context, state, dryRun) {
    if ( state === void 0 ) state = {};
    if ( dryRun === void 0 ) dryRun = false;

    var defaults = state.defaults = state.defaults || {};
    var depth = state.depth = state.depth || 0;
    var needsEval = false;

    state.excluded = state.excluded || [];

    if (depth > MAX_EXPAND_DEPTH) {
        return null;
    }

    for (var property in options) {
        if (!inArray(property, state.excluded) && hasOwnProperty(options, property)) {
            var propValue = options[property];
            if (isFunction(propValue)) {
                needsEval = true;
                if (!dryRun) {
                    options[property] = valueOrDefault(propValue(context), defaults[property]);
                }
            } else if (isObject(propValue)) {
                if (!dryRun) {
                    state.defaults = defaults[property];
                }
                state.depth++;
                needsEval = evalOptions(propValue, context, state, dryRun) || needsEval;
                state.depth--;
            }
        }
    }

    return needsEval;
}

function filterSeriesByType(series, types) {
    var result = [];

    var seriesTypes = [].concat(types);
    for (var idx = 0; idx < series.length; idx++) {
        var currentSeries = series[idx];
        if (inArray(currentSeries.type, seriesTypes)) {
            result.push(currentSeries);
        }
    }

    return result;
}

var dateCache = new WeakMap();

function parseDateCategory(category, row, intlService) {
    if (row === null || typeof row !== 'object') {
        return parseDate(intlService, category);
    }

    var date = dateCache.get(row);
    if (!date) {
        date = parseDate(intlService, category);
        dateCache.set(row, date);
    }

    return date;
}

function hasGradientOverlay(options) {
    var overlay = options.overlay;

    return overlay && overlay.gradient && overlay.gradient !== "none";
}

function hasValue$2(value) {
    return defined(value) && value !== null;
}

function isDateAxis(axisOptions, sampleCategory) {
    var type = axisOptions.type;
    var dateCategory = sampleCategory instanceof Date;

    return (!type && dateCategory) || equalsIgnoreCase(type, DATE);
}

function singleItemOrArray(array) {
    return array.length === 1 ? array[0] : array;
}

var AREA_REGEX = /area/i;

function seriesMissingValues(series) {
    if (series.missingValues) {
        return series.missingValues;
    }

    return AREA_REGEX.test(series.type) || series.stack ? ZERO : INTERPOLATE;
}

function hasValue$1(series, item) {
    var fields = SeriesBinder.current.bindPoint(series, null, item);
    var valueFields = fields.valueFields;

    for (var field in valueFields) {
        if (convertableToNumber(valueFields[field])) {
            return true;
        }
    }
}

function findNext(ref) {
    var start = ref.start;
    var dir = ref.dir;
    var min = ref.min;
    var max = ref.max;
    var getter = ref.getter;
    var hasItem = ref.hasItem;
    var series = ref.series;

    var pointHasValue, outPoint;
    var idx = start;
    do {
        idx += dir;
        //aggregating and binding the item takes too much time for large number of categories
        //will assume that if the aggregation does not create value for a missing item for one it will not create for others
        if (hasItem(idx)) {
            outPoint = getter(idx);
            pointHasValue = hasValue$1(series, outPoint.item);
        }
    } while (min <= idx && idx <= max && !pointHasValue);

    if (pointHasValue) {
        return outPoint;
    }
}

function createOutOfRangePoints(series, range, count, getter, hasItem) {
    var min = range.min;
    var max = range.max;
    var hasMinPoint = min > 0 && min < count;
    var hasMaxPoint = max + 1 < count;

    if (hasMinPoint || hasMaxPoint) {
        var missingValues = seriesMissingValues(series);
        var minPoint, maxPoint;
        if (missingValues !== INTERPOLATE) {
            if (hasMinPoint) {
                minPoint = getter(min - 1);
            }

            if (hasMaxPoint) {
                maxPoint = getter(max + 1);
            }
        } else {
            var outPoint, pointHasValue;
            if (hasMinPoint) {
                outPoint = getter(min - 1);
                pointHasValue = hasValue$1(series, outPoint.item);
                if (!pointHasValue) {
                    minPoint = findNext({
                        start: min,
                        dir: -1,
                        min: 0,
                        max: count - 1,
                        getter: getter,
                        hasItem: hasItem,
                        series: series
                    });
                } else {
                    minPoint = outPoint;
                }
            }

            if (hasMaxPoint) {
                outPoint = getter(max + 1);
                pointHasValue = hasValue$1(series, outPoint.item);
                if (!pointHasValue) {
                    maxPoint = findNext({
                        start: max,
                        dir: 1,
                        min: 0,
                        max: count - 1,
                        getter: getter,
                        hasItem: hasItem,
                        series: series
                    });
                } else {
                    maxPoint = outPoint;
                }
            }
        }

        if (minPoint) {
            series._outOfRangeMinPoint = minPoint;
        }

        if (maxPoint) {
            series._outOfRangeMaxPoint = maxPoint;
        }
    }
}

var CategoricalChart = (function (ChartElement) {
    function CategoricalChart(plotArea, options) {
        ChartElement.call(this, options);

        this.plotArea = plotArea;
        this.chartService = plotArea.chartService;
        this.categoryAxis = plotArea.seriesCategoryAxis(options.series[0]);

        // Value axis ranges grouped by axis name, e.g.:
        // primary: { min: 0, max: 1 }
        this.valueAxisRanges = {};

        this.points = [];
        this.categoryPoints = [];
        this.seriesPoints = [];
        this.seriesOptions = [];
        this._evalSeries = [];

        this.render();
    }

    if ( ChartElement ) CategoricalChart.__proto__ = ChartElement;
    CategoricalChart.prototype = Object.create( ChartElement && ChartElement.prototype );
    CategoricalChart.prototype.constructor = CategoricalChart;

    CategoricalChart.prototype.render = function render () {
        this.traverseDataPoints(this.addValue.bind(this));
    };

    CategoricalChart.prototype.pointOptions = function pointOptions (series, seriesIx) {
        var options = this.seriesOptions[seriesIx];
        if (!options) {
            var defaults = this.pointType().prototype.defaults;
            this.seriesOptions[seriesIx] = options = deepExtend({ }, defaults, {
                vertical: !this.options.invertAxes
            }, series);
        }

        return options;
    };

    CategoricalChart.prototype.plotValue = function plotValue (point) {
        if (!point) {
            return 0;
        }

        if (this.options.isStacked100 && isNumber(point.value)) {
            var categoryIx = point.categoryIx;
            var categoryPoints = this.categoryPoints[categoryIx];
            var otherValues = [];
            var categorySum = 0;

            for (var i = 0; i < categoryPoints.length; i++) {
                var other = categoryPoints[i];
                if (other) {
                    var stack = point.series.stack;
                    var otherStack = other.series.stack;

                    if ((stack && otherStack) && stack.group !== otherStack.group) {
                        continue;
                    }

                    if (isNumber(other.value)) {
                        categorySum += Math.abs(other.value);
                        otherValues.push(Math.abs(other.value));
                    }
                }
            }

            if (categorySum > 0) {
                return point.value / categorySum;
            }
        }

        return point.value;
    };

    CategoricalChart.prototype.plotRange = function plotRange (point, startValue) {
        var this$1$1 = this;
        if ( startValue === void 0 ) startValue = 0;

        var categoryPoints = this.categoryPoints[point.categoryIx];

        if (this.options.isStacked) {
            var plotValue = this.plotValue(point);
            var positive = plotValue >= 0;
            var prevValue = startValue;
            var isStackedBar = false;
            var stack = defined(point.series.stack) ? point.series.stack : this.options.defaultStack;
            var isNonGroupStack = function (stack) { return stack === true || typeof stack === OBJECT$1 && !stack.group; };

            if (stack) {
                for (var i = 0; i < categoryPoints.length; i++) {
                    var other = categoryPoints[i];

                    if (point === other) {
                        break;
                    }

                    var otherStack = defined(other.series.stack) ? other.series.stack : this$1$1.options.defaultStack;

                    if (!otherStack) {
                        continue;
                    }

                    if (typeof stack === STRING$1 && stack !== otherStack) {
                        continue;
                    }

                    if (isNonGroupStack(stack) && !isNonGroupStack(otherStack)) {
                        continue;
                    }

                    if (stack.group && stack.group !== otherStack.group) {
                        continue;
                    }

                    var otherValue = this$1$1.plotValue(other);
                    if ((otherValue >= 0 && positive) ||
                        (otherValue < 0 && !positive)) {
                        // zero values should be skipped for log axis (startValue !== 0)
                        if (startValue === 0 || otherValue !== 0) {
                            prevValue += otherValue;
                            plotValue += otherValue;
                            isStackedBar = true;

                            if (this$1$1.options.isStacked100) {
                                plotValue = Math.min(plotValue, 1);
                            }
                        }
                    }
                }
            }

            if (isStackedBar) {
                prevValue -= startValue;
            }

            return [ prevValue, plotValue ];
        }

        var series = point.series;
        var valueAxis = this.seriesValueAxis(series);
        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);

        return [ axisCrossingValue, convertableToNumber(point.value) ? point.value : axisCrossingValue ];
    };

    CategoricalChart.prototype.stackLimits = function stackLimits (axisName, stackName) {
        var this$1$1 = this;

        var min = MAX_VALUE;
        var max = MIN_VALUE;

        for (var i = 0; i < this.categoryPoints.length; i++) {
            var categoryPoints = this$1$1.categoryPoints[i];
            if (!categoryPoints) {
                continue;
            }

            for (var pIx = 0; pIx < categoryPoints.length; pIx++) {
                var point = categoryPoints[pIx];
                if (point) {
                    if (point.series.stack === stackName || point.series.axis === axisName) {
                        var to = this$1$1.plotRange(point, 0)[1];
                        if (defined(to) && isFinite(to)) {
                            max = Math.max(max, to);
                            min = Math.min(min, to);
                        }
                    }
                }
            }
        }

        return { min: min, max: max };
    };

    CategoricalChart.prototype.updateStackRange = function updateStackRange () {
        var this$1$1 = this;

        var ref = this.options;
        var isStacked = ref.isStacked;
        var chartSeries = ref.series;
        var limitsCache = {};

        if (isStacked) {
            for (var i = 0; i < chartSeries.length; i++) {
                var series = chartSeries[i];
                var axisName = series.axis;
                var key = axisName + series.stack;

                var limits = limitsCache[key];
                if (!limits) {
                    limits = this$1$1.stackLimits(axisName, series.stack);

                    var errorTotals = this$1$1.errorTotals;
                    if (errorTotals) {
                        if (errorTotals.negative.length) {
                            limits.min = Math.min(limits.min, sparseArrayLimits(errorTotals.negative).min);
                        }
                        if (errorTotals.positive.length) {
                            limits.max = Math.max(limits.max, sparseArrayLimits(errorTotals.positive).max);
                        }
                    }

                    if (limits.min !== MAX_VALUE || limits.max !== MIN_VALUE) {
                        limitsCache[key] = limits;
                    } else {
                        limits = null;
                    }
                }

                if (limits) {
                    this$1$1.valueAxisRanges[axisName] = limits;
                }
            }
        }
    };

    CategoricalChart.prototype.addErrorBar = function addErrorBar (point, data, categoryIx) {
        var value = point.value;
        var series = point.series;
        var seriesIx = point.seriesIx;
        var errorBars = point.options.errorBars;
        var lowValue = data.fields[ERROR_LOW_FIELD];
        var highValue = data.fields[ERROR_HIGH_FIELD];
        var errorRange;

        if (isNumber(lowValue) && isNumber(highValue)) {
            errorRange = { low: lowValue, high: highValue };
        } else if (errorBars && defined(errorBars.value)) {
            this.seriesErrorRanges = this.seriesErrorRanges || [];
            this.seriesErrorRanges[seriesIx] = this.seriesErrorRanges[seriesIx] ||
                new ErrorRangeCalculator(errorBars.value, series, VALUE);

            errorRange = this.seriesErrorRanges[seriesIx].getErrorRange(value, errorBars.value);
        }

        if (errorRange) {
            point.low = errorRange.low;
            point.high = errorRange.high;
            this.addPointErrorBar(point, categoryIx);
        }
    };

    CategoricalChart.prototype.addPointErrorBar = function addPointErrorBar (point, categoryIx) {
        var isVertical = !this.options.invertAxes;
        var options = point.options.errorBars;
        var series = point.series;
        var low = point.low;
        var high = point.high;

        if (this.options.isStacked) {
            var stackedErrorRange = this.stackedErrorRange(point, categoryIx);
            low = stackedErrorRange.low;
            high = stackedErrorRange.high;
        } else {
            var fields = { categoryIx: categoryIx, series: series };
            this.updateRange({ value: low }, fields);
            this.updateRange({ value: high }, fields);
        }

        var errorBar = new CategoricalErrorBar(low, high, isVertical, this, series, options);
        point.errorBars = [ errorBar ];
        point.append(errorBar);
    };

    CategoricalChart.prototype.stackedErrorRange = function stackedErrorRange (point, categoryIx) {
        var plotValue = this.plotRange(point, 0)[1] - point.value;
        var low = point.low + plotValue;
        var high = point.high + plotValue;

        this.errorTotals = this.errorTotals || { positive: [], negative: [] };

        if (low < 0) {
            this.errorTotals.negative[categoryIx] = Math.min(this.errorTotals.negative[categoryIx] || 0, low);
        }

        if (high > 0) {
            this.errorTotals.positive[categoryIx] = Math.max(this.errorTotals.positive[categoryIx] || 0, high);
        }

        return { low: low, high: high };
    };

    CategoricalChart.prototype.addValue = function addValue (data, fields) {
        var categoryIx = fields.categoryIx;
        var series = fields.series;
        var seriesIx = fields.seriesIx;

        var categoryPoints = this.categoryPoints[categoryIx];
        if (!categoryPoints) {
            this.categoryPoints[categoryIx] = categoryPoints = [];
        }

        var seriesPoints = this.seriesPoints[seriesIx];
        if (!seriesPoints) {
            this.seriesPoints[seriesIx] = seriesPoints = [];
        }

        var point = this.createPoint(data, fields);
        if (point) {
            Object.assign(point, fields);

            point.owner = this;
            point.noteText = data.fields.noteText;
            if (!defined(point.dataItem)) {
                point.dataItem = series.data[categoryIx];
            }
            this.addErrorBar(point, data, categoryIx);
        }

        this.points.push(point);
        seriesPoints.push(point);
        categoryPoints.push(point);

        this.updateRange(data.valueFields, fields);
    };

    CategoricalChart.prototype.evalPointOptions = function evalPointOptions (options, value, fields) {
        var categoryIx = fields.categoryIx;
        var category = fields.category;
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var state = {
            defaults: series._defaults,
            excluded: [
                "data", "aggregate", "_events", "tooltip", "content", "template",
                "visual", "toggle", "_outOfRangeMinPoint", "_outOfRangeMaxPoint",
                "drilldownSeriesFactory", "ariaTemplate", "ariaContent"
            ]
        };

        var doEval = this._evalSeries[seriesIx];
        if (!defined(doEval)) {
            this._evalSeries[seriesIx] = doEval = evalOptions(options, {}, state, true);
        }

        var pointOptions = options;
        if (doEval) {
            pointOptions = deepExtend({}, pointOptions);
            evalOptions(pointOptions, {
                value: value,
                category: category,
                index: categoryIx,
                series: series,
                dataItem: series.data[categoryIx]
            }, state);
        }

        return pointOptions;
    };

    CategoricalChart.prototype.updateRange = function updateRange (data, fields) {
        var axisName = fields.series.axis;
        var value = data.value;
        var axisRange = this.valueAxisRanges[axisName];

        if (isFinite(value) && value !== null) {
            axisRange = this.valueAxisRanges[axisName] =
                axisRange || { min: MAX_VALUE, max: MIN_VALUE };

            axisRange.min = Math.min(axisRange.min, value);
            axisRange.max = Math.max(axisRange.max, value);
        }
    };

    CategoricalChart.prototype.seriesValueAxis = function seriesValueAxis (series) {
        var plotArea = this.plotArea;
        var axisName = series.axis;
        var axis = axisName ? plotArea.namedValueAxes[axisName] : plotArea.valueAxis;

        if (!axis) {
            throw new Error("Unable to locate value axis with name " + axisName);
        }

        return axis;
    };

    CategoricalChart.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        var categorySlots = this.categorySlots = [];
        var chartPoints = this.points;
        var categoryAxis = this.categoryAxis;
        var pointIx = 0;

        this.traverseDataPoints(function (data, fields) {
            var categoryIx = fields.categoryIx;
            var currentSeries = fields.series;

            var valueAxis = this$1$1.seriesValueAxis(currentSeries);
            var point = chartPoints[pointIx++];

            var categorySlot = categorySlots[categoryIx];
            if (!categorySlot) {
                categorySlots[categoryIx] = categorySlot =
                    this$1$1.categorySlot(categoryAxis, categoryIx, valueAxis);
            }

            if (point) {
                var plotRange = this$1$1.plotRange(point, valueAxis.startValue());
                var valueSlot = this$1$1.valueSlot(valueAxis, plotRange);
                if (valueSlot) {
                    var pointSlot = this$1$1.pointSlot(categorySlot, valueSlot);

                    point.aboveAxis = this$1$1.aboveAxis(point, valueAxis);
                    point.stackValue = plotRange[1];

                    if (this$1$1.options.isStacked100) {
                        point.percentage = this$1$1.plotValue(point);
                    }

                    this$1$1.reflowPoint(point, pointSlot);
                } else {
                    point.visible = false;
                }
            }
        });

        this.reflowCategories(categorySlots);
        if (!this.options.clip && this.options.limitPoints && this.points.length) {
            this.limitPoints();
        }

        this.box = targetBox;
    };

    CategoricalChart.prototype.valueSlot = function valueSlot (valueAxis, plotRange) {
        return valueAxis.getSlot(plotRange[0], plotRange[1], !this.options.clip);
    };

    CategoricalChart.prototype.limitPoints = function limitPoints () {
        var this$1$1 = this;

        var categoryPoints = this.categoryPoints;
        var points = categoryPoints[0].concat(last(categoryPoints));
        for (var idx = 0; idx < points.length; idx++) {
            if (points[idx]) {
                this$1$1.limitPoint(points[idx]);
            }
        }
    };

    CategoricalChart.prototype.limitPoint = function limitPoint (point) {
        var limitedSlot = this.categoryAxis.limitSlot(point.box);
        if (!limitedSlot.equals(point.box)) {
            point.reflow(limitedSlot);
        }
    };

    CategoricalChart.prototype.aboveAxis = function aboveAxis (point, valueAxis) {
        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);
        var value = point.value;

        return valueAxis.options.reverse ?
            value < axisCrossingValue : value >= axisCrossingValue;
    };

    CategoricalChart.prototype.categoryAxisCrossingValue = function categoryAxisCrossingValue (valueAxis) {
        var categoryAxis = this.categoryAxis;
        var options = valueAxis.options;
        var crossingValues = [].concat(
            options.axisCrossingValues || options.axisCrossingValue
        );

        return crossingValues[categoryAxis.axisIndex || 0] || 0;
    };

    CategoricalChart.prototype.reflowPoint = function reflowPoint (point, pointSlot) {
        point.reflow(pointSlot);
    };

    CategoricalChart.prototype.reflowCategories = function reflowCategories () { };

    CategoricalChart.prototype.pointSlot = function pointSlot (categorySlot, valueSlot) {
        var options = this.options;
        var invertAxes = options.invertAxes;
        var slotX = invertAxes ? valueSlot : categorySlot;
        var slotY = invertAxes ? categorySlot : valueSlot;

        return new Box(slotX.x1, slotY.y1, slotX.x2, slotY.y2);
    };

    CategoricalChart.prototype.categorySlot = function categorySlot (categoryAxis, categoryIx) {
        return categoryAxis.getSlot(categoryIx);
    };

    CategoricalChart.prototype.traverseDataPoints = function traverseDataPoints (callback) {
        var this$1$1 = this;

        var series = this.options.series;
        var count = categoriesCount(series);
        var seriesCount = series.length;

        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
            this$1$1._outOfRangeCallback(series[seriesIx], "_outOfRangeMinPoint", seriesIx, callback);
        }

        for (var categoryIx = 0; categoryIx < count; categoryIx++) {
            for (var seriesIx$1 = 0; seriesIx$1 < seriesCount; seriesIx$1++) {
                var currentSeries = series[seriesIx$1];
                var currentCategory = this$1$1.categoryAxis.categoryAt(categoryIx);
                var pointData = this$1$1.plotArea.bindPoint(currentSeries, categoryIx);

                callback(pointData, {
                    category: currentCategory,
                    categoryIx: categoryIx,
                    categoriesCount: count,
                    series: currentSeries,
                    seriesIx: seriesIx$1
                });
            }
        }

        for (var seriesIx$2 = 0; seriesIx$2 < seriesCount; seriesIx$2++) {
            this$1$1._outOfRangeCallback(series[seriesIx$2], "_outOfRangeMaxPoint", seriesIx$2, callback);
        }
    };

    CategoricalChart.prototype._outOfRangeCallback = function _outOfRangeCallback (series, field, seriesIx, callback) {
        var outOfRangePoint = series[field];
        if (outOfRangePoint) {
            var categoryIx = outOfRangePoint.categoryIx;
            var pointData = this.plotArea.bindPoint(series, categoryIx, outOfRangePoint.item);

            callback(pointData, {
                category: outOfRangePoint.category,
                categoryIx: categoryIx,
                series: series,
                seriesIx: seriesIx,
                dataItem: outOfRangePoint.item
            });
        }
    };

    CategoricalChart.prototype.formatPointValue = function formatPointValue (point, format) {
        if (point.value === null) {
            return "";
        }

        return this.chartService.format.auto(format, point.value);
    };

    CategoricalChart.prototype.pointValue = function pointValue (data) {
        return data.valueFields.value;
    };

    return CategoricalChart;
}(ChartElement));

setDefaultOptions(CategoricalChart, {
    series: [],
    invertAxes: false,
    isStacked: false,
    clip: true,
    limitPoints: true
});

var PointEventsMixin = {
    click: function(chart, e) {
        return chart.trigger(
            SERIES_CLICK,
            this.eventArgs(e)
        );
    },

    hover: function(chart, e) {
        return chart.trigger(
            SERIES_HOVER,
            this.eventArgs(e)
        );
    },

    over: function(chart, e) {
        return chart.trigger(
            SERIES_OVER,
            this.eventArgs(e)
        );
    },

    out: function(chart, e) {
        return chart.trigger(
            SERIES_LEAVE,
            this.eventArgs(e)
        );
    },

    eventArgs: function(e) {
        return {
            value: this.value,
            percentage: this.percentage,
            stackValue: this.stackValue,
            category: this.category,
            series: this.series,
            dataItem: this.dataItem,
            runningTotal: this.runningTotal,
            total: this.total,
            element: eventElement(e),
            originalEvent: e,
            point: this
        };
    }
};

var NoteMixin = {
    createNote: function() {
        var options = this.options.notes;
        var text = this.noteText || options.label.text;

        if (options.visible !== false && defined(text) && text !== null) {
            this.note = new Note({
                value: this.value,
                text: text,
                dataItem: this.dataItem,
                category: this.category,
                series: this.series
            }, this.options.notes, this.owner.chartService);

            this.append(this.note);
        }
    }
};

var LinePoint = (function (ChartElement) {
    function LinePoint(value, options) {
        ChartElement.call(this);

        this.value = value;
        this.options = options;
        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
        this.tooltipTracking = true;
        this._id = guid();
    }

    if ( ChartElement ) LinePoint.__proto__ = ChartElement;
    LinePoint.prototype = Object.create( ChartElement && ChartElement.prototype );
    LinePoint.prototype.constructor = LinePoint;

    LinePoint.prototype.render = function render () {
        var ref = this.options;
        var markers = ref.markers;

        if (this._rendered) {
            return;
        }

        this._rendered = true;

        if (markers.visible && markers.size) {
            this.marker = this.createMarker();
            this.append(this.marker);
        }

        this.createLabel();
        this.createNote();

        if (this.errorBar) {
            this.append(this.errorBar);
        }
    };

    LinePoint.prototype.createLabel = function createLabel () {
        var options = this.options;
        var labels = options.labels;

        if (labels.visible) {
            this.label = this.createLabelElement(labels);
            this.append(this.label);
        }
    };

    LinePoint.prototype.createLabelElement = function createLabelElement (options) {
        return new TextBox(this.getLabelText(options),
            deepExtend({
                align: CENTER,
                vAlign: CENTER,
                margin: {
                    left: 5,
                    right: 5
                },
                zIndex: valueOrDefault(options.zIndex, this.series.zIndex)
            }, options),
            this.pointData()
        );
    };

    LinePoint.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = getTemplate$1(options);

        if (labelTemplate) {
            return labelTemplate(this.pointData());
        } else if (options.format) {
            return this.formatValue(options.format);
        }

        return this.value;
    };

    LinePoint.prototype.getAriaLabelText = function getAriaLabelText () {
        var labels = this.options.labels;
        var ariaTemplate = getTemplate(labels);

        if (ariaTemplate) {
            return ariaTemplate(this.pointData());
        }

        return this.getLabelText(labels);
    };

    LinePoint.prototype.markerBorder = function markerBorder () {
        var options = this.options.markers;
        var background = options.background;
        var border = deepExtend({ color: this.color }, options.border);

        if (!defined(border.color)) {
            border.color = new Color(background).brightness(BORDER_BRIGHTNESS).toHex();
        }

        return border;
    };

    LinePoint.prototype.createVisual = function createVisual () {};

    LinePoint.prototype.createMarker = function createMarker () {
        var options = this.options.markers;
        var marker = new ShapeElement({
            type: options.type,
            width: options.size,
            height: options.size,
            rotation: options.rotation,
            background: options.background,
            border: this.markerBorder(),
            opacity: options.opacity,
            pattern: this.options.pattern,
            zIndex: valueOrDefault(options.zIndex, this.series.zIndex),
            animation: options.animation,
            visual: options.visual,
            accessibilityOptions: deepExtend({
                ariaLabel: this.getAriaLabelText(this.options.labels)
            }, this.options.accessibility)
        }, {
            dataItem: this.dataItem,
            value: this.value,
            series: this.series,
            category: this.category
        });

        return marker;
    };

    LinePoint.prototype.markerBox = function markerBox () {
        if (!this.marker) {
            this.marker = this.createMarker();
            this.marker.reflow(this._childBox);
        }

        return this.marker.box;
    };

    LinePoint.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        var ref = this;
        var options = ref.options;
        var aboveAxis = ref.aboveAxis;
        var vertical = options.vertical;

        this.render();

        this.box = targetBox;
        var childBox = targetBox.clone();

        if (vertical) {
            if (aboveAxis) {
                childBox.y1 -= childBox.height();
            } else {
                childBox.y2 += childBox.height();
            }
        } else {
            if (aboveAxis) {
                childBox.x1 += childBox.width();
            } else {
                childBox.x2 -= childBox.width();
            }
        }

        this._childBox = childBox;
        if (this.marker) {
            this.marker.reflow(childBox);
        }

        this.reflowLabel(childBox);

        if (this.errorBars) {
            for (var i = 0; i < this.errorBars.length; i++) {
                this$1$1.errorBars[i].reflow(childBox);
            }
        }

        if (this.note) {
            var noteTargetBox = this.markerBox();

            if (!(options.markers.visible && options.markers.size)) {
                var center = noteTargetBox.center();
                noteTargetBox = new Box(center.x, center.y, center.x, center.y);
            }

            this.note.reflow(noteTargetBox);
        }
    };

    LinePoint.prototype.reflowLabel = function reflowLabel (box) {
        var ref = this;
        var options = ref.options;
        var label = ref.label;
        var anchor = options.labels.position;

        if (label) {
            anchor = anchor === ABOVE ? TOP : anchor;
            anchor = anchor === BELOW ? BOTTOM$1 : anchor;

            label.reflow(box);
            label.box.alignTo(this.markerBox(), anchor);
            label.reflow(label.box);
        }
    };

    LinePoint.prototype.createHighlight = function createHighlight () {
        var markers = this.options.highlight.markers;
        var defaultColor = this.markerBorder().color;
        var options = this.options.markers;
        var size = options.size + (options.border.width || 0) + (markers.border.width || 0);

        var shadow = new ShapeElement({
            type: options.type,
            width: size,
            height: size,
            rotation: options.rotation,
            background: markers.color || defaultColor,
            border: {
                color: markers.border.color,
                width: markers.border.width,
                opacity: valueOrDefault(markers.border.opacity, 1)
            },
            opacity: valueOrDefault(markers.opacity, 1)
        });
        shadow.reflow(this._childBox);

        return shadow.getElement();
    };

    LinePoint.prototype.highlightVisual = function highlightVisual () {
        return (this.marker || {}).visual;
    };

    LinePoint.prototype.highlightVisualArgs = function highlightVisualArgs () {
        var marker = this.marker;
        var visual, rect;

        if (marker) {
            rect = marker.paddingBox.toRect();
            visual = marker.visual;
        } else {
            var size = this.options.markers.size;
            var halfSize = size / 2;
            var center = this.box.center();
            rect = new Rect([ center.x - halfSize, center.y - halfSize ], [ size, size ]);
        }

        return {
            options: this.options,
            rect: rect,
            visual: visual
        };
    };

    LinePoint.prototype.createFocusHighlight = function createFocusHighlight () {
        var markerOptions = this.options.markers;
        var highlightOptions = this.options.focusHighlight;
        var size = markerOptions.size + (markerOptions.border.width || 0);

        var highlight = new ShapeElement({
            type: markerOptions.type,
            width: size,
            height: size,
            rotation: markerOptions.rotation,
            background: highlightOptions.color,
            border: highlightOptions.border,
            opacity: highlightOptions.opacity,
            padding: highlightOptions.border.width / 2,
            zIndex: highlightOptions.zIndex
        });

        highlight.reflow(this._childBox);

        return highlight.getElement();
    };

    LinePoint.prototype.tooltipAnchor = function tooltipAnchor () {
        var markerBox = this.markerBox();
        var clipBox = this.owner.pane.clipBox();
        var showTooltip = !clipBox || clipBox.overlaps(markerBox);

        if (showTooltip) {
            var x = markerBox.x2 + TOOLTIP_OFFSET;
            var horizontalAlign = LEFT;
            var y, verticalAlign;

            if (this.aboveAxis) {
                y = markerBox.y1;
                verticalAlign = BOTTOM$1;
            } else {
                y = markerBox.y2;
                verticalAlign = TOP;
            }

            return {
                point: new Point$5(x, y),
                align: {
                    horizontal: horizontalAlign,
                    vertical: verticalAlign
                }
            };
        }
    };

    LinePoint.prototype.formatValue = function formatValue (format) {
        return this.owner.formatPointValue(this, format);
    };

    LinePoint.prototype.overlapsBox = function overlapsBox (box) {
        var markerBox = this.markerBox();
        return markerBox.overlaps(box);
    };

    LinePoint.prototype.unclipElements = function unclipElements () {
        if (this.label) {
            this.label.options.noclip = true;
        }

        if (this.note) {
            this.note.options.noclip = true;
        }
    };

    LinePoint.prototype.pointData = function pointData () {
        return {
            dataItem: this.dataItem,
            category: this.category,
            value: this.value,
            percentage: this.percentage,
            stackValue: this.stackValue,
            series: this.series
        };
    };

    LinePoint.prototype.focusVisual = function focusVisual () {
        if (this.marker) {
            if (this.marker.visual) {
                this.marker.visual.options.set("id", this._id);
            }

            this.toggleFocusHighlight(true);
        }
    };

    LinePoint.prototype.clearFocusFromVisual = function clearFocusFromVisual () {
        if (this.marker) {
            if (this.marker.visual) {
                this.marker.visual.options.set("id", "");
            }

            this.toggleFocusHighlight(false);
        }
    };

    LinePoint.prototype.getIndex = function getIndex () {
        return defined(this.categoryIx) ? this.categoryIx : this.pointIx;
    };

    return LinePoint;
}(ChartElement));

LinePoint.prototype.defaults = {
    vertical: true,
    markers: {
        visible: true,
        background: WHITE$1,
        size: LINE_MARKER_SIZE,
        type: CIRCLE,
        border: {
            width: 2
        },
        opacity: 1
    },
    labels: {
        visible: false,
        position: ABOVE,
        margin: getSpacing(3),
        padding: getSpacing(4),
        animation: {
            type: FADEIN,
            delay: INITIAL_ANIMATION_DURATION
        }
    },
    notes: {
        label: {}
    },
    highlight: {
        markers: {
            border: {
                color: "#fff",
                width: 2
            }
        },
        zIndex: HIGHLIGHT_ZINDEX
    },
    errorBars: {
        line: {
            width: 1
        }
    },
    accessibility: {
        tabIndex: 0,
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
};

deepExtend(LinePoint.prototype, PointEventsMixin);
deepExtend(LinePoint.prototype, NoteMixin);

var LineSegment = (function (ChartElement) {
    function LineSegment(linePoints, series, seriesIx) {
        ChartElement.call(this);

        this.linePoints = linePoints;
        this.series = series;
        this.seriesIx = seriesIx;
    }

    if ( ChartElement ) LineSegment.__proto__ = ChartElement;
    LineSegment.prototype = Object.create( ChartElement && ChartElement.prototype );
    LineSegment.prototype.constructor = LineSegment;

    LineSegment.prototype.points = function points () {
        return this.toGeometryPoints(this.linePoints);
    };

    LineSegment.prototype.toGeometryPoints = function toGeometryPoints (points) {
        var result = [];
        for (var i = 0, length = points.length; i < length; i++) {
            if (points[i] && points[i].visible !== false) {
                result.push(points[i]._childBox.toRect().center());
            }
        }

        return result;
    };

    LineSegment.prototype.createVisual = function createVisual () {
        var this$1$1 = this;

        var customVisual = this.series.visual;
        if (customVisual) {
            this.visual = customVisual({
                points: this.toGeometryPoints(this.linePoints),
                series: this.series,
                sender: this.getSender(),
                createVisual: function () {
                    this$1$1.segmentVisual();

                    return this$1$1.visual;
                }
            });
            if (this.visual && !defined(this.visual.options.zIndex)) {
                this.visual.options.zIndex = this.series.zIndex;
            }
        } else {
            this.segmentVisual();
        }
    };

    LineSegment.prototype.segmentVisual = function segmentVisual () {
        var ref = this;
        var options = ref.options;
        var series = ref.series;
        var color = series.color;
        var defaults = series._defaults;

        if (isFunction(color) && defaults) {
            color = defaults.color;
        }

        var line = Path$7.fromPoints(this.points(), {
            stroke: {
                color: color,
                width: series.width,
                opacity: series.opacity,
                dashType: series.dashType
            },
            zIndex: series.zIndex
        });

        if (options.closed) {
            line.close();
        }

        this.visual = line;
    };

    LineSegment.prototype.aliasFor = function aliasFor (e, coords) {
        return this.parent.getNearestPoint(coords.x, coords.y, this.seriesIx);
    };

    return LineSegment;
}(ChartElement));

setDefaultOptions(LineSegment, {
    closed: false
});

var StepLineMixin = {
    calculateStepPoints: function(points) {
        var categoryAxis = this.parent.plotArea.seriesCategoryAxis(this.series);
        var ref = categoryAxis.options;
        var justified = ref.justified;
        var vertical = ref.vertical;
        var reverse = ref.reverse;

        var stepAxis = vertical ? X : Y;
        var axis = vertical ? Y : X;
        var stepDir = reverse ? 2 : 1;
        var dir = stepDir;

        var previousPoint = toGeometryPoint(points[0], stepAxis, stepDir, axis, dir);
        var result = [ previousPoint ];

        for (var idx = 1; idx < points.length; idx++) {
            var point = toGeometryPoint(points[idx], stepAxis, stepDir, axis, dir);

            if (previousPoint[stepAxis] !== point[stepAxis]) {
                var stepPoint = new Point$6();
                stepPoint[stepAxis] = previousPoint[stepAxis];
                stepPoint[axis] = point[axis];

                result.push(stepPoint, point);
            }

            previousPoint = point;
        }

        if (!justified) {
            result.push(toGeometryPoint(last(points), stepAxis, stepDir, axis, reverse ? 1 : 2));
        } else if (previousPoint !== last(result)) {
            result.push(previousPoint);
        }

        return result;

    }
};

function toGeometryPoint(lintPoint, stepAxis, stepDir, axis, dir) {
    var box = lintPoint.box;
    var result = new Point$6();

    result[stepAxis] = box[stepAxis + stepDir];
    result[axis] = box[axis + dir];

    return result;
}

var StepLineSegment = (function (LineSegment) {
    function StepLineSegment () {
        LineSegment.apply(this, arguments);
    }

    if ( LineSegment ) StepLineSegment.__proto__ = LineSegment;
    StepLineSegment.prototype = Object.create( LineSegment && LineSegment.prototype );
    StepLineSegment.prototype.constructor = StepLineSegment;

    StepLineSegment.prototype.points = function points () {
        return this.calculateStepPoints(this.linePoints);
    };

    return StepLineSegment;
}(LineSegment));

deepExtend(StepLineSegment.prototype, StepLineMixin);

var SplineSegment = (function (LineSegment) {
    function SplineSegment () {
        LineSegment.apply(this, arguments);
    }

    if ( LineSegment ) SplineSegment.__proto__ = LineSegment;
    SplineSegment.prototype = Object.create( LineSegment && LineSegment.prototype );
    SplineSegment.prototype.constructor = SplineSegment;

    SplineSegment.prototype.segmentVisual = function segmentVisual () {
        var series = this.series;
        var defaults = series._defaults;
        var color = series.color;

        if (isFunction(color) && defaults) {
            color = defaults.color;
        }

        var curveProcessor = new CurveProcessor(this.options.closed);
        var segments = curveProcessor.process(this.points());
        var curve = new Path$7({
            stroke: {
                color: color,
                width: series.width,
                opacity: series.opacity,
                dashType: series.dashType
            },
            zIndex: series.zIndex
        });

        curve.segments.push.apply(curve.segments, segments);

        this.visual = curve;
    };

    return SplineSegment;
}(LineSegment));

var LineChartMixin = {
    renderSegments: function() {
        var this$1$1 = this;

        var ref = this;
        var options = ref.options;
        var seriesPoints = ref.seriesPoints;
        var series = options.series;
        var seriesCount = seriesPoints.length;
        var lastSegment;

        this._segments = [];

        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
            var currentSeries = series[seriesIx];
            var sortedPoints = this$1$1.sortPoints(seriesPoints[seriesIx]);
            var pointCount = sortedPoints.length;
            var linePoints = [];

            for (var pointIx = 0; pointIx < pointCount; pointIx++) {
                var point = sortedPoints[pointIx];
                if (point) {
                    linePoints.push(point);
                } else if (this$1$1.seriesMissingValues(currentSeries) !== INTERPOLATE) {
                    if (linePoints.length > 1) {
                        lastSegment = this$1$1.createSegment(
                            linePoints, currentSeries, seriesIx, lastSegment
                        );
                        this$1$1._addSegment(lastSegment);
                    }
                    linePoints = [];
                }
            }

            if (linePoints.length > 1) {
                lastSegment = this$1$1.createSegment(
                    linePoints, currentSeries, seriesIx, lastSegment
                );
                this$1$1._addSegment(lastSegment);
            }
        }

        this.children.unshift.apply(this.children, this._segments);
    },

    _addSegment: function(segment) {
        this._segments.push(segment);
        segment.parent = this;
    },

    sortPoints: function(points) {
        return points;
    },

    seriesMissingValues: function(series) {
        var missingValues = series.missingValues;
        var assumeZero = !missingValues && this.options.isStacked;

        return assumeZero ? ZERO : missingValues || INTERPOLATE;
    },

    getNearestPoint: function(x, y, seriesIx) {
        var target = new Point$5(x, y);
        var allPoints = this.seriesPoints[seriesIx];
        var nearestPointDistance = MAX_VALUE;
        var nearestPoint;

        for (var i = 0; i < allPoints.length; i++) {
            var point = allPoints[i];

            if (point && defined(point.value) && point.value !== null && point.visible !== false) {
                var pointBox = point.box;
                var pointDistance = pointBox.center().distanceTo(target);

                if (pointDistance < nearestPointDistance) {
                    nearestPoint = point;
                    nearestPointDistance = pointDistance;
                }
            }
        }

        return nearestPoint;
    }
};

var ClipAnimation = (function (superclass) {
    function ClipAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) ClipAnimation.__proto__ = superclass;
    ClipAnimation.prototype = Object.create( superclass && superclass.prototype );
    ClipAnimation.prototype.constructor = ClipAnimation;

    ClipAnimation.prototype.setup = function setup () {
        this._setEnd(this.options.box.x1);
    };

    ClipAnimation.prototype.step = function step (pos) {
        var box = this.options.box;
        this._setEnd(interpolateValue(box.x1, box.x2, pos));
    };

    ClipAnimation.prototype._setEnd = function _setEnd (x) {
        var element = this.element;
        var segments = element.segments;
        var topRight = segments[1].anchor();
        var bottomRight = segments[2].anchor();

        element.suspend();
        topRight.setX(x);
        element.resume();
        bottomRight.setX(x);
    };

    return ClipAnimation;
}(Animation$1));

setDefaultOptions(ClipAnimation, {
    duration: INITIAL_ANIMATION_DURATION
});

AnimationFactory.current.register("clip", ClipAnimation);

var ClipAnimationMixin = {
    createAnimation: function() {
        var root = this.getRoot();
        if (root && (root.options || {}).transitions !== false) {
            var box = root.size();
            var clipPath = Path$7.fromRect(box.toRect());
            this.visual.clip(clipPath);
            this.animation = new ClipAnimation(clipPath, {
                box: box
            });
            if (anyHasZIndex(this.options.series)) {
                this._setChildrenAnimation(clipPath);
            }
        }
    },

    _setChildrenAnimation: function(clipPath) {
        var points = this.animationPoints();

        for (var idx = 0; idx < points.length; idx++) {
            var point = points[idx];
            if (point && point.visual && defined(point.visual.options.zIndex)) {
                point.visual.clip(clipPath);
            }
        }
    }
};

var LineChart = (function (CategoricalChart) {
    function LineChart () {
        CategoricalChart.apply(this, arguments);
    }

    if ( CategoricalChart ) LineChart.__proto__ = CategoricalChart;
    LineChart.prototype = Object.create( CategoricalChart && CategoricalChart.prototype );
    LineChart.prototype.constructor = LineChart;

    LineChart.prototype.render = function render () {

        CategoricalChart.prototype.render.call(this);

        this.updateStackRange();
        this.renderSegments();
    };

    LineChart.prototype.pointType = function pointType () {
        return LinePoint;
    };

    LineChart.prototype.createPoint = function createPoint (data, fields) {
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var missingValues = this.seriesMissingValues(series);
        var value = data.valueFields.value;

        if (!defined(value) || value === null) {
            if (missingValues === ZERO) {
                value = 0;
            } else {
                return null;
            }
        }

        var pointOptions = this.pointOptions(series, seriesIx);
        pointOptions = this.evalPointOptions(pointOptions, value, fields);

        var color = data.fields.color || series.color;
        if (isFunction(series.color)) {
            color = pointOptions.color;
        }

        var point = new LinePoint(value, pointOptions);
        point.color = color;

        this.append(point);

        return point;
    };

    LineChart.prototype.plotRange = function plotRange (point) {
        var this$1$1 = this;

        var plotValue = this.plotValue(point);

        if (this.options.isStacked) {
            var categoryIx = point.categoryIx;
            var categoryPoints = this.categoryPoints[categoryIx];

            for (var i = 0; i < categoryPoints.length; i++) {
                var other = categoryPoints[i];

                if (point === other) {
                    break;
                }

                plotValue += this$1$1.plotValue(other);

                if (this$1$1.options.isStacked100) {
                    plotValue = Math.min(plotValue, 1);
                }
            }

        }

        return [ plotValue, plotValue ];
    };

    LineChart.prototype.createSegment = function createSegment (linePoints, currentSeries, seriesIx) {
        var style = currentSeries.style;
        var pointType;

        if (style === STEP) {
            pointType = StepLineSegment;
        } else if (style === SMOOTH) {
            pointType = SplineSegment;
        } else {
            pointType = LineSegment;
        }

        return new pointType(linePoints, currentSeries, seriesIx);
    };

    LineChart.prototype.animationPoints = function animationPoints () {
        var points = this.points;
        var result = [];
        for (var idx = 0; idx < points.length; idx++) {
            result.push((points[idx] || {}).marker);
        }
        return result.concat(this._segments);
    };

    LineChart.prototype.supportsPointInactiveOpacity = function supportsPointInactiveOpacity () {
        return false;
    };

    return LineChart;
}(CategoricalChart));

deepExtend(LineChart.prototype, LineChartMixin, ClipAnimationMixin);

var AreaSegment = (function (LineSegment) {
    function AreaSegment(linePoints, currentSeries, seriesIx, prevSegment, stackPoints) {
        LineSegment.call(this, linePoints, currentSeries, seriesIx);

        this.prevSegment = prevSegment;
        this.stackPoints = stackPoints;
    }

    if ( LineSegment ) AreaSegment.__proto__ = LineSegment;
    AreaSegment.prototype = Object.create( LineSegment && LineSegment.prototype );
    AreaSegment.prototype.constructor = AreaSegment;

    AreaSegment.prototype.createVisual = function createVisual () {
        var series = this.series;
        var defaults = series._defaults;
        var lineOptions = series.line || {};
        var color = series.color;

        if (isFunction(color) && defaults) {
            color = defaults.color;
        }

        this.visual = new Group$8({
            zIndex: series.zIndex
        });

        this.createFill({
            fill: createPatternFill(series.pattern, {
                color: color,
                opacity: series.opacity
            }),
            stroke: null
        });

        if (lineOptions.width > 0 && lineOptions.visible !== false) {
            this.createStroke({
                stroke: deepExtend({
                    color: color,
                    opacity: series.opacity,
                    lineCap: "butt"
                }, lineOptions)
            });
        }
    };

    AreaSegment.prototype.strokeSegments = function strokeSegments () {
        var segments = this._strokeSegments;

        if (!segments) {
            segments = this._strokeSegments = this.createStrokeSegments();
        }

        return segments;
    };

    AreaSegment.prototype.createStrokeSegments = function createStrokeSegments () {
        return this.segmentsFromPoints(this.points());
    };

    AreaSegment.prototype.stackSegments = function stackSegments () {
        if (this.prevSegment) {
            return this.prevSegment.createStackSegments(this.stackPoints);
        }

        return this.createStackSegments(this.stackPoints);
    };

    AreaSegment.prototype.createStackSegments = function createStackSegments (stackPoints) {
        return this.segmentsFromPoints(this.toGeometryPoints(stackPoints)).reverse();
    };

    AreaSegment.prototype.segmentsFromPoints = function segmentsFromPoints (points) {
        return points.map(function (point) { return new Segment(point); });
    };

    AreaSegment.prototype.createStroke = function createStroke (style) {
        var stroke = new Path$7(style);
        stroke.segments.push.apply(stroke.segments, this.strokeSegments());

        this.visual.append(stroke);
    };

    AreaSegment.prototype.hasStackSegment = function hasStackSegment () {
        return this.prevSegment || (this.stackPoints && this.stackPoints.length);
    };

    AreaSegment.prototype.createFill = function createFill (style) {
        var strokeSegments = this.strokeSegments();
        var fillSegments = strokeSegments.slice(0);
        var hasStackSegments = this.hasStackSegment();

        if (hasStackSegments) {
            var stackSegments = this.stackSegments();

            append(fillSegments, stackSegments);
        }

        var fill = new Path$7(style);
        fill.segments.push.apply(fill.segments, fillSegments);

        if (!hasStackSegments && strokeSegments.length > 1) {
            this.fillToAxes(fill);
        }

        this.visual.append(fill);
    };

    AreaSegment.prototype.fillToAxes = function fillToAxes (fillPath) {
        var chart = this.parent;
        var invertAxes = chart.options.invertAxes;
        var valueAxis = chart.seriesValueAxis(this.series);
        var crossingValue = chart.categoryAxisCrossingValue(valueAxis);
        var endSlot = valueAxis.getSlot(crossingValue, crossingValue, true);
        var segments = this.strokeSegments();
        var firstPoint = segments[0].anchor();
        var lastPoint = last(segments).anchor();
        var end = invertAxes ? endSlot.x1 : endSlot.y1;

        if (invertAxes) {
            fillPath.lineTo(end, lastPoint.y)
                .lineTo(end, firstPoint.y);
        } else {
            fillPath.lineTo(lastPoint.x, end)
                .lineTo(firstPoint.x, end);
        }
    };

    return AreaSegment;
}(LineSegment));

var StepAreaSegment = (function (AreaSegment) {
    function StepAreaSegment () {
        AreaSegment.apply(this, arguments);
    }

    if ( AreaSegment ) StepAreaSegment.__proto__ = AreaSegment;
    StepAreaSegment.prototype = Object.create( AreaSegment && AreaSegment.prototype );
    StepAreaSegment.prototype.constructor = StepAreaSegment;

    StepAreaSegment.prototype.createStrokeSegments = function createStrokeSegments () {
        return this.segmentsFromPoints(this.calculateStepPoints(this.linePoints));
    };

    StepAreaSegment.prototype.createStackSegments = function createStackSegments (stackPoints) {
        return this.segmentsFromPoints(this.calculateStepPoints(stackPoints)).reverse();
    };

    return StepAreaSegment;
}(AreaSegment));

deepExtend(StepAreaSegment.prototype, StepLineMixin);

var SplineAreaSegment = (function (AreaSegment) {
    function SplineAreaSegment () {
        AreaSegment.apply(this, arguments);
    }

    if ( AreaSegment ) SplineAreaSegment.__proto__ = AreaSegment;
    SplineAreaSegment.prototype = Object.create( AreaSegment && AreaSegment.prototype );
    SplineAreaSegment.prototype.constructor = SplineAreaSegment;

    SplineAreaSegment.prototype.createStrokeSegments = function createStrokeSegments () {
        var curveProcessor = new CurveProcessor(this.options.closed);
        var linePoints = this.points();

        return curveProcessor.process(linePoints);
    };

    SplineAreaSegment.prototype.createStackSegments = function createStackSegments () {
        var strokeSegments = this.strokeSegments();
        var stackSegments = [];
        for (var idx = strokeSegments.length - 1; idx >= 0; idx--) {
            var segment = strokeSegments[idx];
            stackSegments.push(new Segment(
                segment.anchor(),
                segment.controlOut(),
                segment.controlIn()
            ));
        }

        return stackSegments;
    };

    return SplineAreaSegment;
}(AreaSegment));

var AreaChart = (function (LineChart) {
    function AreaChart () {
        LineChart.apply(this, arguments);
    }

    if ( LineChart ) AreaChart.__proto__ = LineChart;
    AreaChart.prototype = Object.create( LineChart && LineChart.prototype );
    AreaChart.prototype.constructor = AreaChart;

    AreaChart.prototype.createSegment = function createSegment (linePoints, currentSeries, seriesIx, prevSegment) {
        var isStacked = this.options.isStacked;
        var style = (currentSeries.line || {}).style;
        var previousSegment;

        var stackPoints;
        if (isStacked && seriesIx > 0 && prevSegment) {
            var missingValues = this.seriesMissingValues(currentSeries);
            if (missingValues !== "gap") {
                stackPoints = prevSegment.linePoints;
                previousSegment = prevSegment;
            } else {
                stackPoints = this._gapStackPoints(linePoints, seriesIx, style);
            }
        }

        var pointType;
        if (style === STEP) {
            pointType = StepAreaSegment;
        } else if (style === SMOOTH) {
            pointType = SplineAreaSegment;
        } else {
            pointType = AreaSegment;
        }

        return new pointType(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
    };

    AreaChart.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        LineChart.prototype.reflow.call(this, targetBox);

        var stackPoints = this._stackPoints;
        if (stackPoints) {
            for (var idx = 0; idx < stackPoints.length; idx++) {
                var stackPoint = stackPoints[idx];
                var pointSlot = this$1$1.categoryAxis.getSlot(stackPoint.categoryIx);
                stackPoint.reflow(pointSlot);
            }
        }
    };

    AreaChart.prototype._gapStackPoints = function _gapStackPoints (linePoints, seriesIx, style) {
        var this$1$1 = this;

        var seriesPoints = this.seriesPoints;
        var startIdx = linePoints[0].categoryIx;
        var length = linePoints.length;
        if (startIdx < 0) {
            startIdx = 0;
            length--;
        }

        var endIdx = startIdx + length;
        var pointOffset = this.seriesOptions[0]._outOfRangeMinPoint ? 1 : 0;
        var stackPoints = [];

        this._stackPoints = this._stackPoints || [];
        for (var categoryIx = startIdx; categoryIx < endIdx; categoryIx++) {
            var pointIx = categoryIx + pointOffset;
            var currentSeriesIx = seriesIx;
            var point = (void 0);

            do {
                currentSeriesIx--;
                point = seriesPoints[currentSeriesIx][pointIx];
            } while (currentSeriesIx > 0 && !point);

            if (point) {
                if (style !== STEP && categoryIx > startIdx && !seriesPoints[currentSeriesIx][pointIx - 1]) {
                    stackPoints.push(this$1$1._previousSegmentPoint(categoryIx, pointIx, pointIx - 1, currentSeriesIx));
                }

                stackPoints.push(point);

                if (style !== STEP && categoryIx + 1 < endIdx && !seriesPoints[currentSeriesIx][pointIx + 1]) {
                    stackPoints.push(this$1$1._previousSegmentPoint(categoryIx, pointIx, pointIx + 1, currentSeriesIx));
                }
            } else {
                var gapStackPoint = this$1$1._createGapStackPoint(categoryIx);
                this$1$1._stackPoints.push(gapStackPoint);
                stackPoints.push(gapStackPoint);
            }
        }

        return stackPoints;
    };

    AreaChart.prototype._previousSegmentPoint = function _previousSegmentPoint (categoryIx, pointIx, segmentIx, seriesIdx) {
        var seriesPoints = this.seriesPoints;
        var index = seriesIdx;
        var point;

        while (index > 0 && !point) {
            index--;
            point = seriesPoints[index][segmentIx];
        }

        if (!point) {
            point = this._createGapStackPoint(categoryIx);
            this._stackPoints.push(point);
        } else {
            point = seriesPoints[index][pointIx];
        }

        return point;
    };

    AreaChart.prototype._createGapStackPoint = function _createGapStackPoint (categoryIx) {
        var options = this.pointOptions({}, 0);
        var point = new LinePoint(0, options);
        point.categoryIx = categoryIx;
        point.series = {};

        return point;
    };

    AreaChart.prototype.seriesMissingValues = function seriesMissingValues (series) {
        return series.missingValues || ZERO;
    };

    AreaChart.prototype.supportsPointInactiveOpacity = function supportsPointInactiveOpacity () {
        return false;
    };

    return AreaChart;
}(LineChart));

var AxisGroupRangeTracker = (function (Class) {
    function AxisGroupRangeTracker() {
        Class.call(this);

        this.axisRanges = {};
    }

    if ( Class ) AxisGroupRangeTracker.__proto__ = Class;
    AxisGroupRangeTracker.prototype = Object.create( Class && Class.prototype );
    AxisGroupRangeTracker.prototype.constructor = AxisGroupRangeTracker;

    AxisGroupRangeTracker.prototype.update = function update (chartAxisRanges) {
        var axisRanges = this.axisRanges;

        for (var axisName in chartAxisRanges) {
            var chartRange = chartAxisRanges[axisName];
            var range = axisRanges[axisName];
            axisRanges[axisName] = range = range || { min: MAX_VALUE, max: MIN_VALUE };

            range.min = Math.min(range.min, chartRange.min);
            range.max = Math.max(range.max, chartRange.max);
        }
    };

    AxisGroupRangeTracker.prototype.reset = function reset (axisName) {
        this.axisRanges[axisName] = undefined;
    };

    AxisGroupRangeTracker.prototype.query = function query (axisName) {
        return this.axisRanges[axisName];
    };

    return AxisGroupRangeTracker;
}(Class));

var BarLabel = (function (ChartElement) {
    function BarLabel(content, options, pointData) {
        ChartElement.call(this, options);

        this.textBox = new TextBox(content, this.options, pointData);
        this.append(this.textBox);
    }

    if ( ChartElement ) BarLabel.__proto__ = ChartElement;
    BarLabel.prototype = Object.create( ChartElement && ChartElement.prototype );
    BarLabel.prototype.constructor = BarLabel;

    BarLabel.prototype.createVisual = function createVisual () {
        this.textBox.options.noclip = this.options.noclip;
    };

    BarLabel.prototype.reflow = function reflow (targetBox) {
        var options = this.options;
        var vertical = options.vertical;
        var aboveAxis = options.aboveAxis;
        var text = this.children[0];
        var textOptions = text.options;
        var box = text.box;
        var padding = text.options.padding;
        var labelBox = targetBox;

        textOptions.align = vertical ? CENTER : LEFT;
        textOptions.vAlign = vertical ? TOP : CENTER;

        if (options.position === INSIDE_END) {
            if (vertical) {
                textOptions.vAlign = TOP;

                if (!aboveAxis && box.height() < targetBox.height()) {
                    textOptions.vAlign = BOTTOM$1;
                }
            } else {
                textOptions.align = aboveAxis ? RIGHT : LEFT;
            }
        } else if (options.position === CENTER) {
            textOptions.vAlign = CENTER;
            textOptions.align = CENTER;
        } else if (options.position === INSIDE_BASE) {
            if (vertical) {
                textOptions.vAlign = aboveAxis ? BOTTOM$1 : TOP;
            } else {
                textOptions.align = aboveAxis ? LEFT : RIGHT;
            }
        } else if (options.position === OUTSIDE_END) {
            if (vertical) {
                if (aboveAxis) {
                    var boxesDiff = (box.width() - targetBox.width() - padding.left - padding.right) / 2;
                    labelBox = new Box(
                        targetBox.x1 - boxesDiff, targetBox.y1 - box.height(),
                        targetBox.x2 + boxesDiff, targetBox.y1
                    );
                } else {
                    labelBox = new Box(
                        targetBox.x1, targetBox.y2,
                        targetBox.x2, targetBox.y2 + box.height()
                    );
                }
            } else {
                textOptions.align = CENTER;
                if (aboveAxis) {
                    labelBox = new Box(
                        targetBox.x2, targetBox.y1,
                        targetBox.x2 + box.width(), targetBox.y2
                    );
                } else {
                    labelBox = new Box(
                        targetBox.x1 - box.width(), targetBox.y1,
                        targetBox.x1, targetBox.y2
                    );
                }
            }
        }

        if (!options.rotation) {
            if (vertical) {
                padding.left = padding.right =
                    (labelBox.width() - text.contentBox.width()) / 2;
            } else {
                padding.top = padding.bottom =
                    (labelBox.height() - text.contentBox.height()) / 2;
            }
        }

        text.reflow(labelBox);
    };

    BarLabel.prototype.alignToClipBox = function alignToClipBox (clipBox) {
        var vertical = this.options.vertical;
        var field = vertical ? Y : X;
        var start = field + "1";
        var end = field + "2";
        var text = this.children[0];
        var parentBox = this.parent.box;

        if (parentBox[start] < clipBox[start] || clipBox[end] < parentBox[end]) {
            var targetBox = text.paddingBox.clone();
            targetBox[start] = Math.max(parentBox[start], clipBox[start]);
            targetBox[end] = Math.min(parentBox[end], clipBox[end]);

            this.reflow(targetBox);
        }
    };

    return BarLabel;
}(ChartElement));

setDefaultOptions(BarLabel, {
    position: OUTSIDE_END,
    margin: getSpacing(3),
    padding: getSpacing(4),
    color: BLACK$1,
    background: "",
    border: {
        width: 1,
        color: ""
    },
    aboveAxis: true,
    vertical: false,
    animation: {
        type: FADEIN,
        delay: INITIAL_ANIMATION_DURATION
    },
    zIndex: 2
});

var AccessibilityAttributesMixin = {
    addAccessibilityAttributesToVisual: function() {
        this._id = this._id || guid();

        var accessibilityOptions = deepExtend({
            ariaLabel: this.getAriaLabelText()
        }, this.options.accessibility);

        addAccessibilityAttributesToVisual(this.visual, accessibilityOptions);
    },

    getAriaLabelText: function getAriaLabelText() {
        var labels = this.options.labels;
        var ariaTemplate = getTemplate(labels);

        if (ariaTemplate) {
            return ariaTemplate(this.pointData());
        }

        return this.getLabelText(labels);
    },

    focusVisual: function focusVisual() {
        this.visual.options.set("id", this._id);
        this.toggleFocusHighlight(true);
    },

    clearFocusFromVisual: function clearFocusFromVisual() {
        this.visual.options.set("id", "");
        this.toggleFocusHighlight(false);
    }
};

var BAR_ALIGN_MIN_WIDTH = 6;

var Bar = (function (ChartElement) {
    function Bar(value, options) {
        ChartElement.call(this);

        this.options = options;
        this.color = options.color || WHITE$1;
        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
        this.value = value;
    }

    if ( ChartElement ) Bar.__proto__ = ChartElement;
    Bar.prototype = Object.create( ChartElement && ChartElement.prototype );
    Bar.prototype.constructor = Bar;

    Bar.prototype.render = function render () {
        if (this._rendered) {
            return;
        }

        this._rendered = true;

        this.createLabel();
        this.createNote();

        if (this.errorBar) {
            this.append(this.errorBar);
        }
    };

    Bar.prototype.createLabel = function createLabel () {
        var options = this.options;
        var labels = options.labels;

        if (labels.visible) {
            this.label = this.createLabelElement(labels);
            this.append(this.label);
        }
    };

    Bar.prototype.createLabelElement = function createLabelElement (options) {
        return new BarLabel(this.getLabelText(options),
            deepExtend({
                vertical: this.options.vertical
            },
            options
            ), this.pointData());
    };

    Bar.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = getTemplate$1(options);

        if (labelTemplate) {
            return labelTemplate(this.pointData());
        }

        return this.formatValue(options.format);
    };

    Bar.prototype.formatValue = function formatValue (format) {
        return this.owner.formatPointValue(this, format);
    };

    Bar.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        this.render();

        var label = this.label;

        this.box = targetBox;

        if (label) {
            label.options.aboveAxis = this.aboveAxis;
            label.reflow(targetBox);
        }

        if (this.note) {
            this.note.reflow(targetBox);
        }

        if (this.errorBars) {
            for (var i = 0; i < this.errorBars.length; i++) {
                this$1$1.errorBars[i].reflow(targetBox);
            }
        }
    };

    Bar.prototype.createVisual = function createVisual () {
        var this$1$1 = this;

        var ref = this;
        var box = ref.box;
        var options = ref.options;
        var customVisual = options.visual;

        if (this.visible !== false) {
            ChartElement.prototype.createVisual.call(this);

            this.addAccessibilityAttributesToVisual();

            if (customVisual) {
                var visual = this.rectVisual = customVisual({
                    category: this.category,
                    dataItem: this.dataItem,
                    value: this.value,
                    sender: this.getSender(),
                    series: this.series,
                    percentage: this.percentage,
                    stackValue: this.stackValue,
                    runningTotal: this.runningTotal,
                    total: this.total,
                    rect: box.toRect(),
                    createVisual: function () {
                        var group = new Group$8();
                        this$1$1.createRect(group);
                        return group;
                    },
                    options: options
                });

                if (visual) {
                    this.visual.append(visual);
                }
            } else if (box.width() > 0 && box.height() > 0) {
                this.createRect(this.visual);
            }
        }
    };

    Bar.prototype.createRect = function createRect (visual) {
        var options = this.options;
        var border = options.border;
        var strokeOpacity = defined(border.opacity) ? border.opacity : options.opacity;
        var rect = this.box.toRect();

        rect.size.width = Math.round(rect.size.width);

        var path = this.rectVisual = Path$7.fromRect(rect, {
            fill: createPatternFill(options.pattern, {
                color: this.color,
                opacity: options.opacity
            }),
            stroke: {
                color: this.getBorderColor(),
                width: border.width,
                opacity: strokeOpacity,
                dashType: border.dashType
            }
        });

        var width = this.box.width();
        var height = this.box.height();

        var size = options.vertical ? width : height;

        if (size > BAR_ALIGN_MIN_WIDTH) {
            alignPathToPixel(path);

            // Fixes lineJoin issue in firefox when the joined lines are parallel
            if (width < 1 || height < 1) {
                path.options.stroke.lineJoin = "round";
            }
        }

        visual.append(path);

        if (hasGradientOverlay(options)) {
            var overlay = this.createGradientOverlay(path, { baseColor: this.color }, deepExtend({
                end: !options.vertical ? [ 0, 1 ] : undefined
            }, options.overlay));

            visual.append(overlay);
        }
    };

    Bar.prototype.createHighlight = function createHighlight (style) {
        var highlight = Path$7.fromRect(this.box.toRect(), style);

        return alignPathToPixel(highlight);
    };

    Bar.prototype.highlightVisual = function highlightVisual () {
        return this.rectVisual;
    };

    Bar.prototype.highlightVisualArgs = function highlightVisualArgs () {
        return {
            options: this.options,
            rect: this.box.toRect(),
            visual: this.rectVisual
        };
    };

    Bar.prototype.createFocusHighlight = function createFocusHighlight (style) {
        var borderWidth = this.options.focusHighlight.border.width;
        var highlight = Path$7.fromRect(this.box.pad(borderWidth / 2).toRect(), style);

        return alignPathToPixel(highlight);
    };

    Bar.prototype.getBorderColor = function getBorderColor () {
        var color = this.color;
        var border = this.options.border;
        var brightness = border._brightness || BORDER_BRIGHTNESS;
        var borderColor = border.color;

        if (!defined(borderColor)) {
            borderColor = new Color(color).brightness(brightness).toHex();
        }

        return borderColor;
    };

    Bar.prototype.tooltipAnchor = function tooltipAnchor () {
        var ref = this;
        var options = ref.options;
        var box = ref.box;
        var aboveAxis = ref.aboveAxis;
        var clipBox = this.owner.pane.clipBox() || box;
        var horizontalAlign = LEFT;
        var verticalAlign = TOP;
        var x, y;

        if (options.vertical) {
            x = Math.min(box.x2, clipBox.x2) + TOOLTIP_OFFSET;
            if (aboveAxis) {
                y = Math.max(box.y1, clipBox.y1);
            } else {
                y = Math.min(box.y2, clipBox.y2);
                verticalAlign = BOTTOM$1;
            }
        } else {
            var x1 = Math.max(box.x1, clipBox.x1);
            var x2 = Math.min(box.x2, clipBox.x2);

            if (options.isStacked) {
                verticalAlign = BOTTOM$1;
                if (aboveAxis) {
                    horizontalAlign = RIGHT;
                    x = x2;
                } else {
                    x = x1;
                }
                y = Math.max(box.y1, clipBox.y1) - TOOLTIP_OFFSET;
            } else {
                if (aboveAxis) {
                    x = x2 + TOOLTIP_OFFSET;
                } else {
                    x = x1 - TOOLTIP_OFFSET;
                    horizontalAlign = RIGHT;
                }
                y = Math.max(box.y1, clipBox.y1);
            }
        }

        return {
            point: new Point$5(x, y),
            align: {
                horizontal: horizontalAlign,
                vertical: verticalAlign
            }
        };
    };

    Bar.prototype.overlapsBox = function overlapsBox (box) {
        return this.box.overlaps(box);
    };

    Bar.prototype.pointData = function pointData () {
        return {
            dataItem: this.dataItem,
            category: this.category,
            value: this.value,
            percentage: this.percentage,
            stackValue: this.stackValue,
            runningTotal: this.runningTotal,
            total: this.total,
            series: this.series
        };
    };

    Bar.prototype.getIndex = function getIndex () {
        return this.categoryIx;
    };

    return Bar;
}(ChartElement));

deepExtend(Bar.prototype, PointEventsMixin);
deepExtend(Bar.prototype, NoteMixin);
deepExtend(Bar.prototype, AccessibilityAttributesMixin);

Bar.prototype.defaults = {
    border: {
        width: 1
    },
    vertical: true,
    overlay: {
        gradient: "glass"
    },
    labels: {
        visible: false,
        format: "{0}"
    },
    opacity: 1,
    notes: {
        label: {}
    },
    accessibility: {
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
};

function forEach(elements, callback) {
    elements.forEach(callback);
}

function forEachReverse(elements, callback) {
    var length = elements.length;

    for (var idx = length - 1; idx >= 0; idx--) {
        callback(elements[idx], idx - length - 1);
    }
}

var ClusterLayout = (function (ChartElement) {
    function ClusterLayout(options) {
        ChartElement.call(this, options);

        this.forEach = options.rtl ? forEachReverse : forEach;
    }

    if ( ChartElement ) ClusterLayout.__proto__ = ChartElement;
    ClusterLayout.prototype = Object.create( ChartElement && ChartElement.prototype );
    ClusterLayout.prototype.constructor = ClusterLayout;

    ClusterLayout.prototype.reflow = function reflow (box) {
        var ref = this.options;
        var vertical = ref.vertical;
        var gap = ref.gap;
        var spacing = ref.spacing;
        var children = this.children;
        var count = children.length;
        var axis = vertical ? Y : X;
        var slots = count + gap + (spacing * (count - 1));
        var slotSize = (vertical ? box.height() : box.width()) / slots;
        var position = box[axis + 1] + slotSize * (gap / 2);

        this.forEach(children, function (child, idx) {
            var childBox = (child.box || box).clone();

            childBox[axis + 1] = position;
            childBox[axis + 2] = position + slotSize;

            child.reflow(childBox);
            if (idx < count - 1) {
                position += (slotSize * spacing);
            }

            position += slotSize;
        });
    };

    return ClusterLayout;
}(ChartElement));

setDefaultOptions(ClusterLayout, {
    vertical: false,
    gap: 0,
    spacing: 0
});

var StackWrap = (function (ChartElement) {
    function StackWrap () {
        ChartElement.apply(this, arguments);
    }

    if ( ChartElement ) StackWrap.__proto__ = ChartElement;
    StackWrap.prototype = Object.create( ChartElement && ChartElement.prototype );
    StackWrap.prototype.constructor = StackWrap;

    StackWrap.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        var positionAxis = this.options.vertical ? X : Y;
        var children = this.children;
        var childrenCount = children.length;
        var box = this.box = new Box();

        for (var i = 0; i < childrenCount; i++) {
            var currentChild = children[i];

            if (currentChild.visible !== false) {
                var childBox = currentChild.box.clone();
                childBox.snapTo(targetBox, positionAxis);

                if (i === 0) {
                    box = this$1$1.box = childBox.clone();
                }

                currentChild.reflow(childBox);
                box.wrap(childBox);
            }
        }
    };

    return StackWrap;
}(ChartElement));

setDefaultOptions(StackWrap, {
    vertical: true
});

var BarChart = (function (CategoricalChart) {
    function BarChart () {
        CategoricalChart.apply(this, arguments);
    }

    if ( CategoricalChart ) BarChart.__proto__ = CategoricalChart;
    BarChart.prototype = Object.create( CategoricalChart && CategoricalChart.prototype );
    BarChart.prototype.constructor = BarChart;

    BarChart.prototype.render = function render () {
        CategoricalChart.prototype.render.call(this);
        this.updateStackRange();
    };

    BarChart.prototype.pointType = function pointType () {
        return Bar;
    };

    BarChart.prototype.clusterType = function clusterType () {
        return ClusterLayout;
    };

    BarChart.prototype.stackType = function stackType () {
        return StackWrap;
    };

    BarChart.prototype.stackLimits = function stackLimits (axisName, stackName) {
        var limits = CategoricalChart.prototype.stackLimits.call(this, axisName, stackName);

        return limits;
    };

    BarChart.prototype.createPoint = function createPoint (data, fields) {
        var categoryIx = fields.categoryIx;
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var ref = this;
        var options = ref.options;
        var children = ref.children;
        var stackOrDefault = defined(series.stack) ? series.stack : options.defaultStack;
        var value = this.pointValue(data);
        var pointOptions = this.pointOptions(series, seriesIx);

        var labelOptions = pointOptions.labels;
        if (stackOrDefault) {
            if (labelOptions.position === OUTSIDE_END) {
                labelOptions.position = INSIDE_END;
            }
        }

        pointOptions.isStacked = stackOrDefault;

        var color = data.fields.color || series.color;
        if (value < 0 && pointOptions.negativeColor) {
            color = pointOptions.negativeColor;
        }

        pointOptions = this.evalPointOptions(pointOptions, value, fields);
        if (isFunction(series.color)) {
            color = pointOptions.color;
        }

        var pointType = this.pointType();
        var point = new pointType(value, pointOptions);
        point.color = color;

        var cluster = children[categoryIx];
        if (!cluster) {
            var clusterType = this.clusterType();
            cluster = new clusterType({
                vertical: options.invertAxes,
                gap: options.gap,
                spacing: options.spacing,
                rtl: !options.invertAxes && (this.chartService || {}).rtl
            });
            this.append(cluster);
        }

        if (options.isStacked) {
            var stackWrap = this.getStackWrap(stackOrDefault, cluster);
            stackWrap.append(point);
        } else {
            cluster.append(point);
        }

        return point;
    };

    BarChart.prototype.getStackWrap = function getStackWrap (stack, cluster) {
        var stackGroup = (typeof stack === OBJECT$1) ? (stack.group || true) : stack;
        var wraps = cluster.children;
        var stackWrap;

        if (typeof stackGroup === STRING$1 || stackGroup === true) {
            for (var i = 0; i < wraps.length; i++) {
                if (wraps[i]._stackGroup === stackGroup) {
                    stackWrap = wraps[i];
                    break;
                }
            }
        }

        if (!stackWrap) {
            var stackType = this.stackType();
            stackWrap = new stackType({
                vertical: !this.options.invertAxes
            });
            stackWrap._stackGroup = stackGroup;
            cluster.append(stackWrap);
        }

        return stackWrap;
    };

    BarChart.prototype.categorySlot = function categorySlot (categoryAxis, categoryIx, valueAxis) {
        var options = this.options;
        var categorySlot = categoryAxis.getSlot(categoryIx);
        var startValue = valueAxis.startValue();

        if (options.isStacked) {
            var zeroSlot = valueAxis.getSlot(startValue, startValue, true);
            var stackAxis = options.invertAxes ? X : Y;
            categorySlot[stackAxis + 1] = categorySlot[stackAxis + 2] = zeroSlot[stackAxis + 1];
        }

        return categorySlot;
    };

    BarChart.prototype.reflowCategories = function reflowCategories (categorySlots) {
        var children = this.children;
        var childrenLength = children.length;

        for (var i = 0; i < childrenLength; i++) {
            children[i].reflow(categorySlots[i]);
        }
    };

    BarChart.prototype.createAnimation = function createAnimation () {
        this._setAnimationOptions();
        CategoricalChart.prototype.createAnimation.call(this);

        if (anyHasZIndex(this.options.series)) {
            this._setChildrenAnimation();
        }
    };

    BarChart.prototype._setChildrenAnimation = function _setChildrenAnimation () {
        var this$1$1 = this;

        var points = this.points;

        for (var idx = 0; idx < points.length; idx++) {
            var point = points[idx];
            var pointVisual = point.visual;
            if (pointVisual && defined(pointVisual.options.zIndex)) {
                point.options.animation = this$1$1.options.animation;
                point.createAnimation();
            }
        }
    };

    BarChart.prototype._setAnimationOptions = function _setAnimationOptions () {
        var options = this.options;
        var animation = options.animation || {};
        var origin;

        if (options.isStacked) {
            var valueAxis = this.seriesValueAxis(options.series[0]);
            origin = valueAxis.getSlot(valueAxis.startValue());
        } else {
            origin = this.categoryAxis.getSlot(0);
        }

        animation.origin = new Point$6(origin.x1, origin.y1);
        animation.vertical = !options.invertAxes;
    };

    return BarChart;
}(CategoricalChart));

setDefaultOptions(BarChart, {
    animation: {
        type: BAR
    }
});

var Candlestick = (function (ChartElement) {
    function Candlestick(value, options) {
        ChartElement.call(this, options);
        this.value = value;
    }

    if ( ChartElement ) Candlestick.__proto__ = ChartElement;
    Candlestick.prototype = Object.create( ChartElement && ChartElement.prototype );
    Candlestick.prototype.constructor = Candlestick;

    Candlestick.prototype.getLabelText = function getLabelText (options) {
        return this.formatValue(options.format);
    };

    Candlestick.prototype.reflow = function reflow (box) {
        var ref = this;
        var options = ref.options;
        var value = ref.value;
        var chart = ref.owner;
        var valueAxis = chart.seriesValueAxis(options);
        var ocSlot = valueAxis.getSlot(value.open, value.close);
        var lhSlot = valueAxis.getSlot(value.low, value.high);

        ocSlot.x1 = lhSlot.x1 = box.x1;
        ocSlot.x2 = lhSlot.x2 = box.x2;

        this.realBody = ocSlot;

        var mid = lhSlot.center().x;
        var points = [];

        points.push([ [ mid, lhSlot.y1 ], [ mid, ocSlot.y1 ] ]);
        points.push([ [ mid, ocSlot.y2 ], [ mid, lhSlot.y2 ] ]);

        this.lines = points;

        this.box = lhSlot.clone().wrap(ocSlot);

        if (!this._rendered) {
            this._rendered = true;
            this.createNote();
        }

        this.reflowNote();
    };

    Candlestick.prototype.reflowNote = function reflowNote () {
        if (this.note) {
            this.note.reflow(this.box);
        }
    };

    Candlestick.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        this.addAccessibilityAttributesToVisual();

        this._mainVisual = this.mainVisual(this.options);
        this.visual.append(
            this._mainVisual
        );

        this.createOverlay();
    };

    Candlestick.prototype.mainVisual = function mainVisual (options) {
        var group = new Group$8();

        this.createBody(group, options);
        this.createLines(group, options);

        return group;
    };

    Candlestick.prototype.createBody = function createBody (container, options) {
        var body = Path$7.fromRect(this.realBody.toRect(), {
            fill: createPatternFill(options.pattern, {
                color: this.color,
                opacity: options.opacity
            }),
            stroke: null
        });

        if (options.border.width > 0) {
            body.options.set("stroke", {
                color: this.getBorderColor(),
                width: options.border.width,
                dashType: options.border.dashType,
                opacity: valueOrDefault(options.border.opacity, options.opacity)
            });
        }

        alignPathToPixel(body);
        container.append(body);

        if (hasGradientOverlay(options)) {
            container.append(this.createGradientOverlay(body, { baseColor: this.color }, deepExtend({
                end: !options.vertical ? [ 0, 1 ] : undefined
            }, options.overlay)));
        }
    };

    Candlestick.prototype.createLines = function createLines (container, options) {
        this.drawLines(container, options, this.lines, options.line);
    };

    Candlestick.prototype.drawLines = function drawLines (container, options, lines, lineOptions) {
        if (!lines) {
            return;
        }

        var lineStyle = {
            stroke: {
                color: lineOptions.color || this.color,
                opacity: valueOrDefault(lineOptions.opacity, options.opacity),
                width: lineOptions.width,
                dashType: lineOptions.dashType,
                lineCap: "butt"
            }
        };

        for (var i = 0; i < lines.length; i++) {
            var line = Path$7.fromPoints(lines[i], lineStyle);
            alignPathToPixel(line);
            container.append(line);
        }
    };

    Candlestick.prototype.getBorderColor = function getBorderColor () {
        var border = this.options.border;
        var borderColor = border.color;

        if (!defined(borderColor)) {
            borderColor = new Color(this.color).brightness(border._brightness).toHex();
        }

        return borderColor;
    };

    Candlestick.prototype.createOverlay = function createOverlay () {
        var overlay = Path$7.fromRect(this.box.toRect(), {
            fill: {
                color: WHITE$1,
                opacity: 0
            },
            stroke: null
        });

        this.visual.append(overlay);
    };

    Candlestick.prototype.createHighlight = function createHighlight () {
        var highlight = this.options.highlight;
        var normalColor = this.color;

        this.color = highlight.color || this.color;
        var overlay = this.mainVisual(
            deepExtend({}, this.options, {
                line: {
                    color: this.getBorderColor()
                }
            }, highlight)
        );
        this.color = normalColor;

        return overlay;
    };

    Candlestick.prototype.highlightVisual = function highlightVisual () {
        return this._mainVisual;
    };

    Candlestick.prototype.highlightVisualArgs = function highlightVisualArgs () {
        return {
            options: this.options,
            rect: this.box.toRect(),
            visual: this._mainVisual
        };
    };

    Candlestick.prototype.tooltipAnchor = function tooltipAnchor () {
        var box = this.box;
        var clipBox = this.owner.pane.clipBox() || box;

        return {
            point: new Point$5(box.x2 + TOOLTIP_OFFSET, Math.max(box.y1, clipBox.y1) + TOOLTIP_OFFSET),
            align: {
                horizontal: LEFT,
                vertical: TOP
            }
        };
    };

    Candlestick.prototype.formatValue = function formatValue (format) {
        return this.owner.formatPointValue(this, format);
    };

    Candlestick.prototype.overlapsBox = function overlapsBox (box) {
        return this.box.overlaps(box);
    };

    Candlestick.prototype.pointData = function pointData () {
        return {
            dataItem: this.dataItem,
            value: this.value,
            meanPoints: this.meanPoints,
            medianPoints: this.medianPoints,
            whiskerPoints: this.whiskerPoints,
            stackValue: this.stackValue,
            series: this.series
        };
    };

    Candlestick.prototype.getIndex = function getIndex () {
        return this.categoryIx;
    };

    return Candlestick;
}(ChartElement));

Candlestick.prototype.createFocusHighlight = Bar.prototype.createFocusHighlight;

setDefaultOptions(Candlestick, {
    vertical: true,
    border: {
        _brightness: 0.8
    },
    line: {
        width: 2
    },
    overlay: {
        gradient: "glass"
    },
    tooltip: {
        format: "<table>" +
                    "<tr><th colspan='2'>{4:d}</th></tr>" +
                    "<tr><td>Open:</td><td>{0:C}</td></tr>" +
                    "<tr><td>High:</td><td>{1:C}</td></tr>" +
                    "<tr><td>Low:</td><td>{2:C}</td></tr>" +
                    "<tr><td>Close:</td><td>{3:C}</td></tr>" +
                "</table>"
    },
    labels: {
        format: ""
    },
    highlight: {
        opacity: 1,
        border: {
            width: 1,
            opacity: 1
        },
        line: {
            width: 1,
            opacity: 1
        }
    },
    notes: {
        visible: true,
        label: {}
    },
    accessibility: {
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
});

deepExtend(Candlestick.prototype, PointEventsMixin);
deepExtend(Candlestick.prototype, NoteMixin);
deepExtend(Candlestick.prototype, AccessibilityAttributesMixin);

var CandlestickChart = (function (CategoricalChart) {
    function CandlestickChart () {
        CategoricalChart.apply(this, arguments);
    }

    if ( CategoricalChart ) CandlestickChart.__proto__ = CategoricalChart;
    CandlestickChart.prototype = Object.create( CategoricalChart && CategoricalChart.prototype );
    CandlestickChart.prototype.constructor = CandlestickChart;

    CandlestickChart.prototype.reflowCategories = function reflowCategories (categorySlots) {
        var children = this.children;
        var childrenLength = children.length;

        for (var i = 0; i < childrenLength; i++) {
            children[i].reflow(categorySlots[i]);
        }
    };

    CandlestickChart.prototype.addValue = function addValue (data, fields) {
        var categoryIx = fields.categoryIx;
        var category = fields.category;
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var ref = this;
        var children = ref.children;
        var options = ref.options;
        var value = data.valueFields;
        var valueParts = this.splitValue(value);
        var hasValue = areNumbers(valueParts);
        var dataItem = series.data[categoryIx];
        var categoryPoints = this.categoryPoints[categoryIx];
        var point;

        if (!categoryPoints) {
            this.categoryPoints[categoryIx] = categoryPoints = [];
        }

        if (hasValue) {
            point = this.createPoint(data, fields);
        }

        var cluster = children[categoryIx];
        if (!cluster) {
            cluster = new ClusterLayout({
                vertical: options.invertAxes,
                gap: options.gap,
                spacing: options.spacing,
                rtl: !options.invertAxes && (this.chartService || {}).rtl
            });
            this.append(cluster);
        }

        if (point) {
            this.updateRange(value, fields);

            cluster.append(point);

            point.categoryIx = categoryIx;
            point.category = category;
            point.series = series;
            point.seriesIx = seriesIx;
            point.owner = this;
            point.dataItem = dataItem;
            point.noteText = data.fields.noteText;
        }

        this.points.push(point);
        categoryPoints.push(point);
    };

    CandlestickChart.prototype.pointType = function pointType () {
        return Candlestick;
    };

    CandlestickChart.prototype.createPoint = function createPoint (data, fields) {
        var series = fields.series;
        var pointType = this.pointType();
        var value = data.valueFields;
        var pointOptions = deepExtend({}, series);
        var color = data.fields.color || series.color;

        pointOptions = this.evalPointOptions(pointOptions, value, fields);

        if (series.type === CANDLESTICK || series.type === OHLC) {
            if (value.open > value.close) {
                color = data.fields.downColor || series.downColor || series.color;
            }
        }

        if (isFunction(series.color)) {
            color = pointOptions.color;
        }

        pointOptions.vertical = !this.options.invertAxes;

        var point = new pointType(value, pointOptions);
        point.color = color;

        return point;
    };

    CandlestickChart.prototype.splitValue = function splitValue (value) {
        return [ value.low, value.open, value.close, value.high ];
    };

    CandlestickChart.prototype.updateRange = function updateRange (value, fields) {
        var axisName = fields.series.axis;
        var parts = this.splitValue(value);
        var axisRange = this.valueAxisRanges[axisName] || { min: MAX_VALUE, max: MIN_VALUE };

        this.valueAxisRanges[axisName] = {
            min: Math.min.apply(Math, parts.concat([ axisRange.min ])),
            max: Math.max.apply(Math, parts.concat([ axisRange.max ]))
        };
    };

    CandlestickChart.prototype.formatPointValue = function formatPointValue (point, format) {
        var value = point.value;

        return this.chartService.format.auto(format,
            value.open, value.high,
            value.low, value.close, point.category
        );
    };

    CandlestickChart.prototype.animationPoints = function animationPoints () {
        return this.points;
    };

    return CandlestickChart;
}(CategoricalChart));

deepExtend(CandlestickChart.prototype, ClipAnimationMixin);

var BoxPlot = (function (Candlestick) {
    function BoxPlot(value, options) {
        Candlestick.call(this, value, options);

        this.createNote();
    }

    if ( Candlestick ) BoxPlot.__proto__ = Candlestick;
    BoxPlot.prototype = Object.create( Candlestick && Candlestick.prototype );
    BoxPlot.prototype.constructor = BoxPlot;

    BoxPlot.prototype.reflow = function reflow (box) {
        var ref = this;
        var options = ref.options;
        var value = ref.value;
        var chart = ref.owner;
        var valueAxis = chart.seriesValueAxis(options);
        var whiskerSlot, boxSlot;

        this.boxSlot = boxSlot = valueAxis.getSlot(value.q1, value.q3);
        this.realBody = boxSlot;
        this.reflowBoxSlot(box);

        this.whiskerSlot = whiskerSlot = valueAxis.getSlot(value.lower, value.upper);
        this.reflowWhiskerSlot(box);

        var medianSlot = valueAxis.getSlot(value.median);

        if (value.mean) {
            var meanSlot = valueAxis.getSlot(value.mean);
            this.meanPoints = this.calcMeanPoints(box, meanSlot);
        }

        this.whiskerPoints = this.calcWhiskerPoints(boxSlot, whiskerSlot);
        this.medianPoints = this.calcMedianPoints(box, medianSlot);

        this.box = whiskerSlot.clone().wrap(boxSlot);
        this.reflowNote();
    };

    BoxPlot.prototype.reflowBoxSlot = function reflowBoxSlot (box) {
        this.boxSlot.x1 = box.x1;
        this.boxSlot.x2 = box.x2;
    };

    BoxPlot.prototype.reflowWhiskerSlot = function reflowWhiskerSlot (box) {
        this.whiskerSlot.x1 = box.x1;
        this.whiskerSlot.x2 = box.x2;
    };

    BoxPlot.prototype.calcMeanPoints = function calcMeanPoints (box, meanSlot) {
        return [
            [ [ box.x1, meanSlot.y1 ], [ box.x2, meanSlot.y1 ] ]
        ];
    };

    BoxPlot.prototype.calcWhiskerPoints = function calcWhiskerPoints (boxSlot, whiskerSlot) {
        var mid = whiskerSlot.center().x;
        return [ [
            [ mid - 5, whiskerSlot.y1 ], [ mid + 5, whiskerSlot.y1 ],
            [ mid, whiskerSlot.y1 ], [ mid, boxSlot.y1 ]
        ], [
            [ mid - 5, whiskerSlot.y2 ], [ mid + 5, whiskerSlot.y2 ],
            [ mid, whiskerSlot.y2 ], [ mid, boxSlot.y2 ]
        ] ];
    };

    BoxPlot.prototype.calcMedianPoints = function calcMedianPoints (box, medianSlot) {
        return [
            [ [ box.x1, medianSlot.y1 ], [ box.x2, medianSlot.y1 ] ]
        ];
    };

    BoxPlot.prototype.renderOutliers = function renderOutliers (options) {
        var this$1$1 = this;

        var value = this.value;
        var outliers = value.outliers || [];
        var outerFence = Math.abs(value.q3 - value.q1) * 3;
        var elements = [];
        var markers = options.markers || {};

        for (var i = 0; i < outliers.length; i++) {
            var outlierValue = outliers[i];
            if (outlierValue < value.q3 + outerFence && outlierValue > value.q1 - outerFence) {
                markers = options.outliers;
            } else {
                markers = options.extremes;
            }
            var markersBorder = deepExtend({}, markers.border);

            if (!defined(markersBorder.color)) {
                if (defined(this$1$1.color)) {
                    markersBorder.color = this$1$1.color;
                } else {
                    markersBorder.color =
                        new Color(markers.background).brightness(BORDER_BRIGHTNESS).toHex();
                }
            }

            var shape = new ShapeElement({
                type: markers.type,
                width: markers.size,
                height: markers.size,
                rotation: markers.rotation,
                background: markers.background,
                border: markersBorder,
                opacity: markers.opacity
            });

            shape.value = outlierValue;

            elements.push(shape);
        }

        this.reflowOutliers(elements);
        return elements;
    };

    BoxPlot.prototype.reflowOutliers = function reflowOutliers (outliers) {
        var this$1$1 = this;

        var valueAxis = this.owner.seriesValueAxis(this.options);
        var center = this.box.center();

        for (var i = 0; i < outliers.length; i++) {
            var outlierValue = outliers[i].value;
            var markerBox = valueAxis.getSlot(outlierValue);

            if (this$1$1.options.vertical) {
                markerBox.move(center.x);
            } else {
                markerBox.move(undefined, center.y);
            }

            this$1$1.box = this$1$1.box.wrap(markerBox);
            outliers[i].reflow(markerBox);
        }
    };

    BoxPlot.prototype.mainVisual = function mainVisual (options) {
        var group = Candlestick.prototype.mainVisual.call(this, options);
        var outliers = this.renderOutliers(options);

        for (var i = 0; i < outliers.length; i++) {
            var element = outliers[i].getElement();
            if (element) {
                group.append(element);
            }
        }

        return group;
    };

    BoxPlot.prototype.createLines = function createLines (container, options) {
        this.drawLines(container, options, this.whiskerPoints, options.whiskers);
        this.drawLines(container, options, this.medianPoints, options.median);
        this.drawLines(container, options, this.meanPoints, options.mean);
    };

    BoxPlot.prototype.getBorderColor = function getBorderColor () {
        if ((this.options.border || {}).color) {
            return this.options.border.color;
        }

        if (this.color) {
            return this.color;
        }

        return Candlestick.prototype.getBorderColor.call(this);
    };

    return BoxPlot;
}(Candlestick));

setDefaultOptions(BoxPlot, {
    border: {
        _brightness: 0.8
    },
    line: {
        width: 2
    },
    median: {
        color: "#f6f6f6"
    },
    mean: {
        width: 2,
        dashType: "dash",
        color: "#f6f6f6"
    },
    overlay: {
        gradient: "glass"
    },
    tooltip: {
        format: "<table>" +
                    "<tr><th colspan='2'>{6:d}</th></tr>" +
                    "<tr><td>Lower:</td><td>{0:C}</td></tr>" +
                    "<tr><td>Q1:</td><td>{1:C}</td></tr>" +
                    "<tr><td>Median:</td><td>{2:C}</td></tr>" +
                    "<tr><td>Mean:</td><td>{5:C}</td></tr>" +
                    "<tr><td>Q3:</td><td>{3:C}</td></tr>" +
                    "<tr><td>Upper:</td><td>{4:C}</td></tr>" +
                "</table>"
    },
    highlight: {
        opacity: 1,
        border: {
            width: 1,
            opacity: 1
        },
        line: {
            width: 1,
            opacity: 1
        }
    },
    notes: {
        visible: true,
        label: {}
    },
    outliers: {
        visible: true,
        size: LINE_MARKER_SIZE,
        type: CROSS,
        background: WHITE$1,
        border: {
            width: 2,
            opacity: 1
        },
        opacity: 0
    },
    extremes: {
        visible: true,
        size: LINE_MARKER_SIZE,
        type: CIRCLE,
        background: WHITE$1,
        border: {
            width: 2,
            opacity: 1
        },
        opacity: 0
    }
});

deepExtend(BoxPlot.prototype, PointEventsMixin);

var VerticalBoxPlot = (function (BoxPlot) {
    function VerticalBoxPlot () {
        BoxPlot.apply(this, arguments);
    }

    if ( BoxPlot ) VerticalBoxPlot.__proto__ = BoxPlot;
    VerticalBoxPlot.prototype = Object.create( BoxPlot && BoxPlot.prototype );
    VerticalBoxPlot.prototype.constructor = VerticalBoxPlot;

    VerticalBoxPlot.prototype.reflowBoxSlot = function reflowBoxSlot (box) {
        this.boxSlot.y1 = box.y1;
        this.boxSlot.y2 = box.y2;
    };

    VerticalBoxPlot.prototype.reflowWhiskerSlot = function reflowWhiskerSlot (box) {
        this.whiskerSlot.y1 = box.y1;
        this.whiskerSlot.y2 = box.y2;
    };

    VerticalBoxPlot.prototype.calcMeanPoints = function calcMeanPoints (box, meanSlot) {
        return [
            [ [ meanSlot.x1, box.y1 ], [ meanSlot.x1, box.y2 ] ]
        ];
    };

    VerticalBoxPlot.prototype.calcWhiskerPoints = function calcWhiskerPoints (boxSlot, whiskerSlot) {
        var mid = whiskerSlot.center().y;
        return [ [
            [ whiskerSlot.x1, mid - 5 ], [ whiskerSlot.x1, mid + 5 ],
            [ whiskerSlot.x1, mid ], [ boxSlot.x1, mid ]
        ], [
            [ whiskerSlot.x2, mid - 5 ], [ whiskerSlot.x2, mid + 5 ],
            [ whiskerSlot.x2, mid ], [ boxSlot.x2, mid ]
        ] ];
    };

    VerticalBoxPlot.prototype.calcMedianPoints = function calcMedianPoints (box, medianSlot) {
        return [
            [ [ medianSlot.x1, box.y1 ], [ medianSlot.x1, box.y2 ] ]
        ];
    };

    return VerticalBoxPlot;
}(BoxPlot));

var BoxPlotChart = (function (CandlestickChart) {
    function BoxPlotChart () {
        CandlestickChart.apply(this, arguments);
    }

    if ( CandlestickChart ) BoxPlotChart.__proto__ = CandlestickChart;
    BoxPlotChart.prototype = Object.create( CandlestickChart && CandlestickChart.prototype );
    BoxPlotChart.prototype.constructor = BoxPlotChart;

    BoxPlotChart.prototype.addValue = function addValue (data, fields) {
        var categoryIx = fields.categoryIx;
        var category = fields.category;
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var ref = this;
        var children = ref.children;
        var options = ref.options;
        var value = data.valueFields;
        var valueParts = this.splitValue(value);
        var hasValue = areNumbers(valueParts);
        var dataItem = series.data[categoryIx];
        var categoryPoints = this.categoryPoints[categoryIx];
        var point;

        if (!categoryPoints) {
            this.categoryPoints[categoryIx] = categoryPoints = [];
        }

        if (hasValue) {
            point = this.createPoint(data, fields);
        }

        var cluster = children[categoryIx];
        if (!cluster) {
            cluster = new ClusterLayout({
                vertical: options.invertAxes,
                gap: options.gap,
                spacing: options.spacing,
                rtl: !options.invertAxes && (this.chartService || {}).rtl
            });
            this.append(cluster);
        }

        if (point) {
            this.updateRange(value, fields);

            cluster.append(point);

            point.categoryIx = categoryIx;
            point.category = category;
            point.series = series;
            point.seriesIx = seriesIx;
            point.owner = this;
            point.dataItem = dataItem;
        }

        this.points.push(point);
        categoryPoints.push(point);
    };

    BoxPlotChart.prototype.pointType = function pointType () {
        if (this.options.invertAxes) {
            return VerticalBoxPlot;
        }

        return BoxPlot;
    };

    BoxPlotChart.prototype.splitValue = function splitValue (value) {
        return [
            value.lower, value.q1, value.median,
            value.q3, value.upper
        ];
    };

    BoxPlotChart.prototype.updateRange = function updateRange (value, fields) {
        var axisName = fields.series.axis;
        var parts = this.splitValue(value).concat(this.filterOutliers(value.outliers));

        if (defined(value.mean)) {
            parts = parts.concat(value.mean);
        }

        var axisRange = this.valueAxisRanges[axisName] || { min: MAX_VALUE, max: MIN_VALUE };

        this.valueAxisRanges[axisName] = {
            min: Math.min.apply(Math, parts.concat([ axisRange.min ])),
            max: Math.max.apply(Math, parts.concat([ axisRange.max ]))
        };
    };

    BoxPlotChart.prototype.formatPointValue = function formatPointValue (point, format) {
        var value = point.value;

        return this.chartService.format.auto(format,
            value.lower, value.q1, value.median,
            value.q3, value.upper, value.mean, point.category
        );
    };

    BoxPlotChart.prototype.filterOutliers = function filterOutliers (items) {
        var length = (items || []).length;
        var result = [];

        for (var i = 0; i < length; i++) {
            var item = items[i];
            if (defined(item) && item !== null) {
                result.push(item);
            }
        }

        return result;
    };

    BoxPlotChart.prototype.supportsPointInactiveOpacity = function supportsPointInactiveOpacity () {
        return false;
    };

    return BoxPlotChart;
}(CandlestickChart));

var ScatterErrorBar = (function (ErrorBarBase) {
    function ScatterErrorBar () {
        ErrorBarBase.apply(this, arguments);
    }

    if ( ErrorBarBase ) ScatterErrorBar.__proto__ = ErrorBarBase;
    ScatterErrorBar.prototype = Object.create( ErrorBarBase && ErrorBarBase.prototype );
    ScatterErrorBar.prototype.constructor = ScatterErrorBar;

    ScatterErrorBar.prototype.getAxis = function getAxis () {
        var axes = this.chart.seriesAxes(this.series);
        var axis = this.isVertical ? axes.y : axes.x;

        return axis;
    };

    return ScatterErrorBar;
}(ErrorBarBase));

var ScatterChart = (function (ChartElement) {
    function ScatterChart(plotArea, options) {

        ChartElement.call(this, options);

        this.plotArea = plotArea;
        this.chartService = plotArea.chartService;
        this._initFields();

        this.render();
    }

    if ( ChartElement ) ScatterChart.__proto__ = ChartElement;
    ScatterChart.prototype = Object.create( ChartElement && ChartElement.prototype );
    ScatterChart.prototype.constructor = ScatterChart;

    ScatterChart.prototype._initFields = function _initFields () {
        // X and Y axis ranges grouped by name, e.g.:
        // primary: { min: 0, max: 1 }
        this.xAxisRanges = {};
        this.yAxisRanges = {};

        this.points = [];
        this.seriesPoints = [];
        this.seriesOptions = [];
        this._evalSeries = [];
    };

    ScatterChart.prototype.render = function render () {
        this.traverseDataPoints(this.addValue.bind(this));
    };

    ScatterChart.prototype.addErrorBar = function addErrorBar (point, field, fields) {
        var value = point.value[field];
        var valueErrorField = field + "Value";
        var lowField = field + "ErrorLow";
        var highField = field + "ErrorHigh";
        var seriesIx = fields.seriesIx;
        var series = fields.series;
        var errorBars = point.options.errorBars;
        var lowValue = fields[lowField];
        var highValue = fields[highField];

        if (isNumber(value)) {
            var errorRange;
            if (isNumber(lowValue) && isNumber(highValue)) {
                errorRange = { low: lowValue, high: highValue };
            }

            if (errorBars && defined(errorBars[valueErrorField])) {
                this.seriesErrorRanges = this.seriesErrorRanges || { x: [], y: [] };
                this.seriesErrorRanges[field][seriesIx] = this.seriesErrorRanges[field][seriesIx] ||
                    new ErrorRangeCalculator(errorBars[valueErrorField], series, field);

                errorRange = this.seriesErrorRanges[field][seriesIx].getErrorRange(value, errorBars[valueErrorField]);
            }

            if (errorRange) {
                this.addPointErrorBar(errorRange, point, field);
            }
        }
    };

    ScatterChart.prototype.addPointErrorBar = function addPointErrorBar (errorRange, point, field) {
        var low = errorRange.low;
        var high = errorRange.high;
        var series = point.series;
        var options = point.options.errorBars;
        var isVertical = field === Y;
        var item = {};

        point[field + "Low"] = low;
        point[field + "High"] = high;

        point.errorBars = point.errorBars || [];
        var errorBar = new ScatterErrorBar(low, high, isVertical, this, series, options);
        point.errorBars.push(errorBar);
        point.append(errorBar);

        item[field] = low;
        this.updateRange(item, series);
        item[field] = high;
        this.updateRange(item, series);
    };

    ScatterChart.prototype.addValue = function addValue (value, fields) {
        var x = value.x;
        var y = value.y;
        var seriesIx = fields.seriesIx;
        var series = this.options.series[seriesIx];
        var missingValues = this.seriesMissingValues(series);
        var seriesPoints = this.seriesPoints[seriesIx];

        var pointValue = value;
        if (!(hasValue$2(x) && hasValue$2(y))) {
            pointValue = this.createMissingValue(pointValue, missingValues);
        }

        var point;
        if (pointValue) {
            point = this.createPoint(pointValue, fields);
            if (point) {
                Object.assign(point, fields);
                this.addErrorBar(point, X, fields);
                this.addErrorBar(point, Y, fields);
            }
            this.updateRange(pointValue, fields.series);
        }

        this.points.push(point);
        seriesPoints.push(point);
    };

    ScatterChart.prototype.seriesMissingValues = function seriesMissingValues (series) {
        return series.missingValues;
    };

    ScatterChart.prototype.createMissingValue = function createMissingValue () {};

    ScatterChart.prototype.updateRange = function updateRange (value, series) {
        var intlService = this.chartService.intl;
        var xAxisName = series.xAxis;
        var yAxisName = series.yAxis;
        var x = value.x;
        var y = value.y;
        var xAxisRange = this.xAxisRanges[xAxisName];
        var yAxisRange = this.yAxisRanges[yAxisName];

        if (hasValue$2(x)) {
            xAxisRange = this.xAxisRanges[xAxisName] =
                xAxisRange || { min: MAX_VALUE, max: MIN_VALUE };

            if (isString$1(x)) {
                x = parseDate(intlService, x);
            }

            xAxisRange.min = Math.min(xAxisRange.min, x);
            xAxisRange.max = Math.max(xAxisRange.max, x);
        }

        if (hasValue$2(y)) {
            yAxisRange = this.yAxisRanges[yAxisName] =
                yAxisRange || { min: MAX_VALUE, max: MIN_VALUE };

            if (isString$1(y)) {
                y = parseDate(intlService, y);
            }

            yAxisRange.min = Math.min(yAxisRange.min, y);
            yAxisRange.max = Math.max(yAxisRange.max, y);
        }
    };

    ScatterChart.prototype.evalPointOptions = function evalPointOptions (options, value, fields) {
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var state = {
            defaults: series._defaults,
            excluded: [
                "data", "tooltip", "content", "template", "visual", "toggle",
                "_outOfRangeMinPoint", "_outOfRangeMaxPoint",
                "drilldownSeriesFactory", "ariaTemplate", "ariaContent"
            ]
        };

        var doEval = this._evalSeries[seriesIx];
        if (!defined(doEval)) {
            this._evalSeries[seriesIx] = doEval = evalOptions(options, {}, state, true);
        }

        var pointOptions = options;
        if (doEval) {
            pointOptions = deepExtend({}, options);
            evalOptions(pointOptions, {
                value: value,
                series: series,
                dataItem: fields.dataItem
            }, state);
        }

        return pointOptions;
    };

    ScatterChart.prototype.pointType = function pointType () {
        return LinePoint;
    };

    ScatterChart.prototype.pointOptions = function pointOptions (series, seriesIx) {
        var options = this.seriesOptions[seriesIx];
        if (!options) {
            var defaults = this.pointType().prototype.defaults;
            this.seriesOptions[seriesIx] = options = deepExtend({}, defaults, {
                markers: {
                    opacity: series.opacity
                },
                tooltip: {
                    format: this.options.tooltip.format
                },
                labels: {
                    format: this.options.labels.format
                }
            }, series);
        }

        return options;
    };

    ScatterChart.prototype.createPoint = function createPoint (value, fields) {
        var series = fields.series;
        var pointOptions = this.pointOptions(series, fields.seriesIx);
        var color = fields.color || series.color;

        pointOptions = this.evalPointOptions(pointOptions, value, fields);

        if (isFunction(series.color)) {
            color = pointOptions.color;
        }

        var point = new LinePoint(value, pointOptions);
        point.color = color;

        this.append(point);

        return point;
    };

    ScatterChart.prototype.seriesAxes = function seriesAxes (series) {
        var xAxisName = series.xAxis;
        var yAxisName = series.yAxis;
        var plotArea = this.plotArea;
        var xAxis = xAxisName ? plotArea.namedXAxes[xAxisName] : plotArea.axisX;
        var yAxis = yAxisName ? plotArea.namedYAxes[yAxisName] : plotArea.axisY;

        if (!xAxis) {
            throw new Error("Unable to locate X axis with name " + xAxisName);
        }

        if (!yAxis) {
            throw new Error("Unable to locate Y axis with name " + yAxisName);
        }

        return {
            x: xAxis,
            y: yAxis
        };
    };

    ScatterChart.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        var chartPoints = this.points;
        var limit = !this.options.clip;
        var pointIx = 0;


        this.traverseDataPoints(function (value, fields) {
            var point = chartPoints[pointIx++];
            var seriesAxes = this$1$1.seriesAxes(fields.series);
            var slotX = seriesAxes.x.getSlot(value.x, value.x, limit);
            var slotY = seriesAxes.y.getSlot(value.y, value.y, limit);

            if (point) {
                if (slotX && slotY) {
                    var pointSlot = this$1$1.pointSlot(slotX, slotY);
                    point.reflow(pointSlot);
                } else {
                    point.visible = false;
                }
            }
        });

        this.box = targetBox;
    };

    ScatterChart.prototype.pointSlot = function pointSlot (slotX, slotY) {
        return new Box(slotX.x1, slotY.y1, slotX.x2, slotY.y2);
    };

    ScatterChart.prototype.traverseDataPoints = function traverseDataPoints (callback) {
        var this$1$1 = this;

        var ref = this;
        var series = ref.options.series;
        var seriesPoints = ref.seriesPoints;

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];
            var currentSeriesPoints = seriesPoints[seriesIx];
            if (!currentSeriesPoints) {
                seriesPoints[seriesIx] = [];
            }

            for (var pointIx = 0; pointIx < currentSeries.data.length; pointIx++) {
                var ref$1 = this$1$1.plotArea.bindPoint(currentSeries, pointIx);
                var value = ref$1.valueFields;
                var fields = ref$1.fields;

                callback(value, deepExtend({
                    pointIx: pointIx,
                    series: currentSeries,
                    seriesIx: seriesIx,
                    dataItem: currentSeries.data[pointIx],
                    owner: this$1$1
                }, fields));
            }
        }
    };

    ScatterChart.prototype.formatPointValue = function formatPointValue (point, format) {
        var value = point.value;
        return this.chartService.format.auto(format, value.x, value.y);
    };

    ScatterChart.prototype.animationPoints = function animationPoints () {
        var points = this.points;
        var result = [];
        for (var idx = 0; idx < points.length; idx++) {
            result.push((points[idx] || {}).marker);
        }
        return result;
    };

    return ScatterChart;
}(ChartElement));
setDefaultOptions(ScatterChart, {
    series: [],
    tooltip: {
        format: "{0}, {1}"
    },
    labels: {
        format: "{0}, {1}"
    },
    clip: true
});
deepExtend(ScatterChart.prototype, ClipAnimationMixin);

var Bubble = (function (LinePoint) {
    function Bubble(value, options) {
        LinePoint.call(this, value, options);

        this.category = value.category;
    }

    if ( LinePoint ) Bubble.__proto__ = LinePoint;
    Bubble.prototype = Object.create( LinePoint && LinePoint.prototype );
    Bubble.prototype.constructor = Bubble;

    Bubble.prototype.createHighlight = function createHighlight () {
        var highlight = this.options.highlight;
        var border = highlight.border;
        var markers = this.options.markers;
        var center = this.box.center();
        var radius = (markers.size + markers.border.width + border.width) / 2;
        var highlightGroup = new Group$8();
        var shadow = new Circle$1(new Circle$2([ center.x, center.y + radius / 5 + border.width / 2 ], radius + border.width / 2), {
            stroke: {
                color: 'none'
            },
            fill: this.createGradient({
                gradient: 'bubbleShadow',
                color: markers.background,
                stops: [ {
                    offset: 0,
                    color: markers.background,
                    opacity: 0.3
                }, {
                    offset: 1,
                    color: markers.background,
                    opacity: 0
                } ]
            })
        });
        var overlay = new Circle$1(new Circle$2([ center.x, center.y ], radius), {
            stroke: {
                color: border.color ||
                    new Color(markers.background).brightness(BORDER_BRIGHTNESS).toHex(),
                width: border.width,
                opacity: border.opacity
            },
            fill: createPatternFill(this.options.pattern, {
                color: markers.background,
                opacity: highlight.opacity
            })
        });

        highlightGroup.append(shadow, overlay);

        return highlightGroup;
    };

    Bubble.prototype.createFocusHighlight = function createFocusHighlight (style) {
        var highlightOptions = this.options.focusHighlight;
        var markers = this.options.markers;
        var center = this.box.center();
        var radius = (markers.size + markers.border.width) / 2 + highlightOptions.border.width / 2;
        var highlight = new Circle$1(new Circle$2([ center.x, center.y ], radius), style);

        return highlight;
    };

    return Bubble;
}(LinePoint));

Bubble.prototype.defaults = deepExtend({}, Bubble.prototype.defaults, {
    labels: {
        position: CENTER
    },
    highlight: {
        opacity: 1,
        border: {
            color: "#fff",
            width: 2,
            opacity: 1
        }
    }
});

Bubble.prototype.defaults.highlight.zIndex = undefined;

var BubbleChart = (function (ScatterChart) {
    function BubbleChart () {
        ScatterChart.apply(this, arguments);
    }

    if ( ScatterChart ) BubbleChart.__proto__ = ScatterChart;
    BubbleChart.prototype = Object.create( ScatterChart && ScatterChart.prototype );
    BubbleChart.prototype.constructor = BubbleChart;

    BubbleChart.prototype._initFields = function _initFields () {
        this._maxSize = MIN_VALUE;
        ScatterChart.prototype._initFields.call(this);
    };

    BubbleChart.prototype.addValue = function addValue (value, fields) {
        if (value.size !== null && (value.size > 0 || (value.size < 0 && fields.series.negativeValues.visible))) {
            this._maxSize = Math.max(this._maxSize, Math.abs(value.size));
            ScatterChart.prototype.addValue.call(this, value, fields);
        } else {
            this.points.push(null);
            this.seriesPoints[fields.seriesIx].push(null);
        }
    };

    BubbleChart.prototype.reflow = function reflow (box) {
        this.updateBubblesSize(box);
        ScatterChart.prototype.reflow.call(this, box);
    };

    BubbleChart.prototype.pointType = function pointType () {
        return Bubble;
    };

    BubbleChart.prototype.createPoint = function createPoint (value, fields) {
        var series = fields.series;
        var pointsCount = series.data.length;
        var delay = fields.pointIx * (INITIAL_ANIMATION_DURATION / pointsCount);
        var animationOptions = {
            delay: delay,
            duration: INITIAL_ANIMATION_DURATION - delay,
            type: BUBBLE
        };

        var color = fields.color || series.color;
        if (value.size < 0 && series.negativeValues.visible) {
            color = valueOrDefault(
                series.negativeValues.color, color
            );
        }

        var pointOptions = deepExtend({
            labels: {
                animation: {
                    delay: delay,
                    duration: INITIAL_ANIMATION_DURATION - delay
                }
            }
        }, this.pointOptions(series, fields.seriesIx), {
            markers: {
                type: CIRCLE,
                border: series.border,
                opacity: series.opacity,
                animation: animationOptions
            }
        });

        pointOptions = this.evalPointOptions(pointOptions, value, fields);
        if (isFunction(series.color)) {
            color = pointOptions.color;
        }

        pointOptions.markers.background = color;

        var point = new Bubble(value, pointOptions);
        point.color = color;

        this.append(point);

        return point;
    };

    BubbleChart.prototype.updateBubblesSize = function updateBubblesSize (box) {
        var this$1$1 = this;

        var ref = this;
        var series = ref.options.series;
        var boxSize = Math.min(box.width(), box.height());

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];
            var seriesPoints = this$1$1.seriesPoints[seriesIx];
            var minSize = currentSeries.minSize || Math.max(boxSize * 0.02, 10);
            var maxSize = currentSeries.maxSize || boxSize * 0.2;
            var minR = minSize / 2;
            var maxR = maxSize / 2;
            var minArea = Math.PI * minR * minR;
            var maxArea = Math.PI * maxR * maxR;
            var areaRange = maxArea - minArea;
            var areaRatio = areaRange / this$1$1._maxSize;

            for (var pointIx = 0; pointIx < seriesPoints.length; pointIx++) {
                var point = seriesPoints[pointIx];
                if (point) {
                    var area = Math.abs(point.value.size) * areaRatio;
                    var radius = Math.sqrt((minArea + area) / Math.PI);
                    var baseZIndex = valueOrDefault(point.options.zIndex, 0);
                    var zIndex = baseZIndex + (1 - radius / maxR);

                    deepExtend(point.options, {
                        zIndex: zIndex,
                        markers: {
                            size: radius * 2,
                            zIndex: zIndex
                        },
                        labels: {
                            zIndex: zIndex + 1
                        }
                    });
                }
            }
        }
    };

    BubbleChart.prototype.formatPointValue = function formatPointValue (point, format) {
        var value = point.value;
        return this.chartService.format.auto(format, value.x, value.y, value.size, point.category);
    };

    BubbleChart.prototype.createAnimation = function createAnimation () {};
    BubbleChart.prototype.createVisual = function createVisual () {};

    return BubbleChart;
}(ScatterChart));

setDefaultOptions(BubbleChart, {
    tooltip: {
        format: "{3}"
    },
    labels: {
        format: "{3}"
    }
});

var Target = (function (ShapeElement) {
	function Target () {
		ShapeElement.apply(this, arguments);
	}if ( ShapeElement ) Target.__proto__ = ShapeElement;
	Target.prototype = Object.create( ShapeElement && ShapeElement.prototype );
	Target.prototype.constructor = Target;

	

	return Target;
}(ShapeElement));

deepExtend(Target.prototype, PointEventsMixin);

var Bullet = (function (ChartElement) {
    function Bullet(value, options) {
        ChartElement.call(this, options);

        this.aboveAxis = this.options.aboveAxis;
        this.color = options.color || WHITE$1;
        this.value = value;
    }

    if ( ChartElement ) Bullet.__proto__ = ChartElement;
    Bullet.prototype = Object.create( ChartElement && ChartElement.prototype );
    Bullet.prototype.constructor = Bullet;

    Bullet.prototype.render = function render () {
        var options = this.options;

        if (!this._rendered) {
            this._rendered = true;

            if (defined(this.value.target)) {
                this.target = new Target({
                    type: options.target.shape,
                    background: options.target.color || this.color,
                    opacity: options.opacity,
                    zIndex: options.zIndex,
                    border: options.target.border,
                    vAlign: TOP,
                    align: RIGHT
                });

                this.target.value = this.value;
                this.target.dataItem = this.dataItem;
                this.target.series = this.series;

                this.append(this.target);
            }

            this.createLabel();
            this.createNote();
        }
    };

    Bullet.prototype.createLabel = function createLabel () {
        var options = this.options;
        var labels = options.labels;

        if (labels.visible) {
            this.label = this.createLabelElement(labels);
            this.append(this.label);
        }
    };

    Bullet.prototype.createLabelElement = function createLabelElement (options) {
        return new BarLabel(this.getLabelText(options),
            options,
            this.pointData());
    };

    Bullet.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = getTemplate$1(options);

        if (labelTemplate) {
            return labelTemplate(this.pointData());
        }

        return this.formatValue(options.format);
    };

    Bullet.prototype.reflow = function reflow (box) {
        this.render();

        var ref = this;
        var options = ref.options;
        var target = ref.target;
        var chart = ref.owner;
        var invertAxes = options.invertAxes;
        var valueAxis = chart.seriesValueAxis(this.options);
        var categorySlot = chart.categorySlot(chart.categoryAxis, options.categoryIx, valueAxis);
        var targetValueSlot = valueAxis.getSlot(this.value.target);
        var targetSlotX = invertAxes ? targetValueSlot : categorySlot;
        var targetSlotY = invertAxes ? categorySlot : targetValueSlot;

        if (target) {
            var targetSlot = new Box(
                targetSlotX.x1, targetSlotY.y1,
                targetSlotX.x2, targetSlotY.y2
            );
            target.options.height = invertAxes ? targetSlot.height() : options.target.line.width;
            target.options.width = invertAxes ? options.target.line.width : targetSlot.width();
            target.reflow(targetSlot);
        }

        var label = this.label;
        if (label) {
            label.options.aboveAxis = this.aboveAxis;
            label.reflow(box);
        }

        if (this.note) {
            this.note.reflow(box);
        }

        this.box = box;
    };

    Bullet.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        this.addAccessibilityAttributesToVisual();

        var options = this.options;
        var body = Path$7.fromRect(this.box.toRect(), {
            fill: createPatternFill(options.pattern, {
                color: this.color,
                opacity: options.opacity
            }),
            stroke: null
        });

        if (options.border.width > 0) {
            body.options.set("stroke", {
                color: options.border.color || this.color,
                width: options.border.width,
                dashType: options.border.dashType,
                opacity: valueOrDefault(options.border.opacity, options.opacity)
            });
        }

        this.bodyVisual = body;

        alignPathToPixel(body);
        this.visual.append(body);
    };

    Bullet.prototype.createAnimation = function createAnimation () {
        if (this.bodyVisual) {
            this.animation = Animation$1.create(
                this.bodyVisual, this.options.animation
            );
        }
    };

    Bullet.prototype.createHighlight = function createHighlight (style) {
        return Path$7.fromRect(this.box.toRect(), style);
    };

    Bullet.prototype.highlightVisual = function highlightVisual () {
        return this.bodyVisual;
    };

    Bullet.prototype.highlightVisualArgs = function highlightVisualArgs () {
        return {
            rect: this.box.toRect(),
            visual: this.bodyVisual,
            options: this.options
        };
    };

    Bullet.prototype.formatValue = function formatValue (format) {
        return this.owner.formatPointValue(this, format);
    };

    Bullet.prototype.pointData = function pointData () {
        return {
            dataItem: this.dataItem,
            category: this.category,
            value: this.value,
            series: this.series
        };
    };

    Bullet.prototype.overlapsBox = function overlapsBox (box) {
        return this.box.overlaps(box);
    };

    Bullet.prototype.getIndex = function getIndex () {
        return this.categoryIx;
    };

    return Bullet;
}(ChartElement));

Bullet.prototype.tooltipAnchor = Bar.prototype.tooltipAnchor;
Bullet.prototype.createFocusHighlight = Bar.prototype.createFocusHighlight;

setDefaultOptions(Bullet, {
    border: {
        width: 1
    },
    vertical: false,
    opacity: 1,
    target: {
        shape: "",
        border: {
            width: 0,
            color: "green"
        },
        line: {
            width: 2
        }
    },
    labels: {
        visible: false
    },
    tooltip: {
        format: "Current: {0}<br />Target: {1}"
    },
    notes: {
        label: {}
    },
    accessibility: {
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
});

deepExtend(Bullet.prototype, PointEventsMixin);
deepExtend(Bullet.prototype, NoteMixin);
deepExtend(Bullet.prototype, AccessibilityAttributesMixin);

var BulletChart = (function (CategoricalChart) {
    function BulletChart(plotArea, options) {

        wrapData(options);

        CategoricalChart.call(this, plotArea, options);
    }

    if ( CategoricalChart ) BulletChart.__proto__ = CategoricalChart;
    BulletChart.prototype = Object.create( CategoricalChart && CategoricalChart.prototype );
    BulletChart.prototype.constructor = BulletChart;

    BulletChart.prototype.reflowCategories = function reflowCategories (categorySlots) {
        var children = this.children;
        var childrenLength = children.length;

        for (var i = 0; i < childrenLength; i++) {
            children[i].reflow(categorySlots[i]);
        }
    };

    BulletChart.prototype.plotRange = function plotRange (point) {
        var series = point.series;
        var valueAxis = this.seriesValueAxis(series);
        var axisCrossingValue = this.categoryAxisCrossingValue(valueAxis);

        return [ axisCrossingValue, point.value.current || axisCrossingValue ];
    };

    BulletChart.prototype.createPoint = function createPoint (data, fields) {
        var categoryIx = fields.categoryIx;
        var series = fields.series;
        var ref = this;
        var options = ref.options;
        var children = ref.children;
        var value = data.valueFields;

        var bulletOptions = deepExtend({
            vertical: !options.invertAxes,
            overlay: series.overlay,
            categoryIx: categoryIx,
            invertAxes: options.invertAxes
        }, series);

        var color = data.fields.color || series.color;
        bulletOptions = this.evalPointOptions(bulletOptions, value, fields);
        if (isFunction(series.color)) {
            color = bulletOptions.color;
        }

        var bullet = new Bullet(value, bulletOptions);
        bullet.color = color;

        var cluster = children[categoryIx];
        if (!cluster) {
            cluster = new ClusterLayout({
                vertical: options.invertAxes,
                gap: options.gap,
                spacing: options.spacing,
                rtl: !options.invertAxes && (this.chartService || {}).rtl
            });
            this.append(cluster);
        }

        cluster.append(bullet);

        return bullet;
    };

    BulletChart.prototype.updateRange = function updateRange (value, fields) {
        var current = value.current;
        var target = value.target;
        var axisName = fields.series.axis;
        var axisRange = this.valueAxisRanges[axisName];

        if (defined(current) && !isNaN(current) && defined(target && !isNaN(target))) {
            axisRange = this.valueAxisRanges[axisName] =
                axisRange || { min: MAX_VALUE, max: MIN_VALUE };

            axisRange.min = Math.min(axisRange.min, current, target);
            axisRange.max = Math.max(axisRange.max, current, target);
        }
    };

    BulletChart.prototype.formatPointValue = function formatPointValue (point, format) {
        return this.chartService.format.auto(format, point.value.current, point.value.target);
    };

    BulletChart.prototype.pointValue = function pointValue (data) {
        return data.valueFields.current;
    };

    BulletChart.prototype.aboveAxis = function aboveAxis (point) {
        var value = point.value.current;

        return value > 0;
    };

    BulletChart.prototype.createAnimation = function createAnimation () {
        var this$1$1 = this;

        var points = this.points;

        this._setAnimationOptions();

        for (var idx = 0; idx < points.length; idx++) {
            var point = points[idx];
            point.options.animation = this$1$1.options.animation;
            point.createAnimation();
        }
    };

    return BulletChart;
}(CategoricalChart));

BulletChart.prototype._setAnimationOptions = BarChart.prototype._setAnimationOptions;

setDefaultOptions(BulletChart, {
    animation: {
        type: BAR
    }
});

function wrapData(options) {
    var series = options.series;

    for (var i = 0; i < series.length; i++) {
        var seriesItem = series[i];
        var data = seriesItem.data;
        if (data && !isArray(data[0]) && !isObject(data[0])) {
            seriesItem.data = [ data ];
        }
    }
}

var BaseTooltip = (function (Class) {
    function BaseTooltip(chartService, options) {
        Class.call(this);

        this.chartService = chartService;
        this.options = deepExtend({}, this.options, options);
    }

    if ( Class ) BaseTooltip.__proto__ = Class;
    BaseTooltip.prototype = Object.create( Class && Class.prototype );
    BaseTooltip.prototype.constructor = BaseTooltip;

    BaseTooltip.prototype.getStyle = function getStyle (options, point) {
        var background = options.background;
        var border = options.border.color;

        if (point) {
            var pointColor = point.color || point.options.color;
            background = valueOrDefault(background, pointColor);
            border = valueOrDefault(border, pointColor);
        }

        var padding = options.padding !== undefined ? getSpacing(options.padding) : {};

        if (typeof options.padding === "object") {
            padding.top = options.padding.top !== undefined ? padding.top : undefined;
            padding.right = options.padding.right !== undefined ? padding.right : undefined;
            padding.bottom = options.padding.bottom !== undefined ? padding.bottom : undefined;
            padding.left = options.padding.left !== undefined ? padding.left : undefined;
        }

        return {
            backgroundColor: background,
            borderColor: border,
            font: options.font,
            color: options.color,
            opacity: options.opacity,
            borderWidth: styleValue(options.border.width),
            paddingTop: styleValue(padding.top),
            paddingBottom: styleValue(padding.bottom),
            paddingLeft: styleValue(padding.left),
            paddingRight: styleValue(padding.right)
        };
    };

    BaseTooltip.prototype.show = function show (options, tooltipOptions, point) {
        if (!this.chartService) {
            return;
        }
        options.format = tooltipOptions.format;

        var style = this.getStyle(tooltipOptions, point);
        options.style = style;

        var background = new Color(style.backgroundColor);
        if (!defined(tooltipOptions.color) && !background.isDark()) {
            options.className = "k-chart-tooltip-inverse";
        }

        this.chartService.notify(SHOW_TOOLTIP$1, options);

        this.visible = true;
    };

    BaseTooltip.prototype.hide = function hide () {
        if (this.chartService) {
            this.chartService.notify(HIDE_TOOLTIP$1);
        }

        this.visible = false;
    };

    BaseTooltip.prototype.destroy = function destroy () {
        delete this.chartService;
    };

    return BaseTooltip;
}(Class));

setDefaultOptions(BaseTooltip, {
    border: {
        width: 1
    },
    opacity: 1
});

var CrosshairTooltip = (function (BaseTooltip) {
    function CrosshairTooltip(chartService, crosshair, options) {
        BaseTooltip.call(this, chartService, options);

        this.crosshair = crosshair;
        this.formatService = chartService.format;
        this.initAxisName();
    }

    if ( BaseTooltip ) CrosshairTooltip.__proto__ = BaseTooltip;
    CrosshairTooltip.prototype = Object.create( BaseTooltip && BaseTooltip.prototype );
    CrosshairTooltip.prototype.constructor = CrosshairTooltip;

    CrosshairTooltip.prototype.initAxisName = function initAxisName () {
        var axis = this.crosshair.axis;
        var plotArea = axis.plotArea;
        var name;
        if (plotArea.categoryAxis) {
            name = axis.getCategory ? "categoryAxis" : "valueAxis";
        } else {
            name = axis.options.vertical ? "yAxis" : "xAxis";
        }
        this.axisName = name;
    };

    CrosshairTooltip.prototype.showAt = function showAt (point) {
        var ref = this;
        var axis = ref.crosshair.axis;
        var options = ref.options;
        var value = axis[options.stickyMode ? "getCategory" : "getValue"](point);
        var formattedValue = value;

        if (options.format) {
            formattedValue = this.formatService.auto(options.format, value);
        } else if (axis.options.type === DATE) {
            formattedValue = this.formatService.auto(axis.options.labels.dateFormats[axis.options.baseUnit], value);
        }

        this.show({
            point: point,
            anchor: this.getAnchor(),
            crosshair: this.crosshair,
            value: formattedValue,
            axisName: this.axisName,
            axisIndex: this.crosshair.axis.axisIndex
        }, this.options);
    };

    CrosshairTooltip.prototype.hide = function hide () {
        this.chartService.notify(HIDE_TOOLTIP$1, {
            crosshair: this.crosshair,
            axisName: this.axisName,
            axisIndex: this.crosshair.axis.axisIndex
        });
    };

    CrosshairTooltip.prototype.getAnchor = function getAnchor () {
        var ref = this;
        var crosshair = ref.crosshair;
        var ref_options = ref.options;
        var position = ref_options.position;
        var padding = ref_options.padding;
        var vertical = !crosshair.axis.options.vertical;
        var lineBox = crosshair.line.bbox();
        var horizontalAlign, verticalAlign, point;

        if (vertical) {
            horizontalAlign = CENTER;
            if (position === BOTTOM$1) {
                verticalAlign = TOP;
                point = lineBox.bottomLeft().translate(0, padding);
            } else {
                verticalAlign = BOTTOM$1;
                point = lineBox.topLeft().translate(0, -padding);
            }
        } else {
            verticalAlign = CENTER;
            if (position === LEFT) {
                horizontalAlign = RIGHT;
                point = lineBox.topLeft().translate(-padding, 0);
            } else {
                horizontalAlign = LEFT;
                point = lineBox.topRight().translate(padding, 0);
            }
        }

        return {
            point: point,
            align: {
                horizontal: horizontalAlign,
                vertical: verticalAlign
            }
        };
    };

    return CrosshairTooltip;
}(BaseTooltip));

setDefaultOptions(CrosshairTooltip, {
    padding: 10
});

var Crosshair = (function (ChartElement) {
    function Crosshair(chartService, axis, options) {
        ChartElement.call(this, options);

        this.axis = axis;
        this.stickyMode = axis instanceof CategoryAxis;

        var tooltipOptions = this.options.tooltip;

        if (tooltipOptions.visible) {
            this.tooltip = new CrosshairTooltip(chartService, this,
                deepExtend({}, tooltipOptions, { stickyMode: this.stickyMode })
            );
        }
    }

    if ( ChartElement ) Crosshair.__proto__ = ChartElement;
    Crosshair.prototype = Object.create( ChartElement && ChartElement.prototype );
    Crosshair.prototype.constructor = Crosshair;

    Crosshair.prototype.showAt = function showAt (point) {
        this.point = point;
        this.moveLine();
        this.line.visible(true);

        if (this.tooltip) {
            this.tooltip.showAt(point);
        }
    };

    Crosshair.prototype.hide = function hide () {
        this.line.visible(false);

        if (this.tooltip) {
            this.tooltip.hide();
        }
    };

    Crosshair.prototype.moveLine = function moveLine () {
        var ref = this;
        var axis = ref.axis;
        var point = ref.point;
        var vertical = axis.options.vertical;
        var box = this.getBox();
        var dim = vertical ? Y : X;
        var lineStart = new Point$6(box.x1, box.y1);
        var lineEnd;

        if (vertical) {
            lineEnd = new Point$6(box.x2, box.y1);
        } else {
            lineEnd = new Point$6(box.x1, box.y2);
        }

        if (point) {
            if (this.stickyMode) {
                var slot = axis.getSlot(axis.pointCategoryIndex(point));
                lineStart[dim] = lineEnd[dim] = slot.center()[dim];
            } else {
                lineStart[dim] = lineEnd[dim] = point[dim];
            }
        }

        this.box = box;

        this.line.moveTo(lineStart).lineTo(lineEnd);
    };

    Crosshair.prototype.getBox = function getBox () {
        var axis = this.axis;
        var axes = axis.pane.axes;
        var length = axes.length;
        var vertical = axis.options.vertical;
        var box = axis.lineBox().clone();
        var dim = vertical ? X : Y;
        var axisLineBox;

        for (var i = 0; i < length; i++) {
            var currentAxis = axes[i];
            if (currentAxis.options.vertical !== vertical) {
                if (!axisLineBox) {
                    axisLineBox = currentAxis.lineBox().clone();
                } else {
                    axisLineBox.wrap(currentAxis.lineBox());
                }
            }
        }

        box[dim + 1] = axisLineBox[dim + 1];
        box[dim + 2] = axisLineBox[dim + 2];

        return box;
    };

    Crosshair.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        var options = this.options;
        this.line = new Path$7({
            stroke: {
                color: options.color,
                width: options.width,
                opacity: options.opacity,
                dashType: options.dashType
            },
            visible: false
        });

        this.moveLine();
        this.visual.append(this.line);
    };

    Crosshair.prototype.destroy = function destroy () {
        if (this.tooltip) {
            this.tooltip.destroy();
        }

        ChartElement.prototype.destroy.call(this);
    };

    return Crosshair;
}(ChartElement));

setDefaultOptions(Crosshair, {
    color: BLACK$1,
    width: 2,
    zIndex: -1,
    tooltip: {
        visible: false
    }
});

var ChartContainer = (function (ChartElement) {
    function ChartContainer(options, pane) {
        ChartElement.call(this, options);
        this.pane = pane;
    }

    if ( ChartElement ) ChartContainer.__proto__ = ChartElement;
    ChartContainer.prototype = Object.create( ChartElement && ChartElement.prototype );
    ChartContainer.prototype.constructor = ChartContainer;

    ChartContainer.prototype.shouldClip = function shouldClip () {
        var children = this.children;
        var length = children.length;

        for (var i = 0; i < length; i++) {
            if (children[i].options.clip === true) {
                return true;
            }
        }
        return false;
    };

    ChartContainer.prototype._clipBox = function _clipBox () {
        return this.pane.chartsBox();
    };

    ChartContainer.prototype.createVisual = function createVisual () {
        this.visual = new Group$8({
            zIndex: 0
        });

        if (this.shouldClip()) {
            var clipBox = this.clipBox = this._clipBox();
            var clipRect = clipBox.toRect();
            var clipPath = Path$7.fromRect(clipRect);
            alignPathToPixel(clipPath);

            this.visual.clip(clipPath);
            this.unclipLabels();
        }
    };

    ChartContainer.prototype.stackRoot = function stackRoot () {
        return this;
    };

    ChartContainer.prototype.unclipLabels = function unclipLabels () {
        var ref = this;
        var charts = ref.children;
        var clipBox = ref.clipBox;

        for (var i = 0; i < charts.length; i++) {
            var points = charts[i].points || {};
            var length = points.length;

            for (var j = 0; j < length; j++) {
                var point = points[j];
                if (point && point.visible !== false && point.overlapsBox && point.overlapsBox(clipBox)) {
                    if (point.unclipElements) {
                        point.unclipElements();
                    } else {
                        var label = point.label;
                        var note = point.note;

                        if (label && label.options.visible) {
                            if (label.alignToClipBox) {
                                label.alignToClipBox(clipBox);
                            }
                            label.options.noclip = true;
                        }

                        if (note && note.options.visible) {
                            note.options.noclip = true;
                        }
                    }
                }
            }
        }
    };

    ChartContainer.prototype.destroy = function destroy () {
        ChartElement.prototype.destroy.call(this);

        delete this.parent;
    };

    return ChartContainer;
}(ChartElement));

ChartContainer.prototype.isStackRoot = true;

var Pane$1 = (function (BoxElement) {
    function Pane(options) {
        BoxElement.call(this, options);

        this.id = paneID();

        this.createTitle();

        this.content = new ChartElement();

        this.chartContainer = new ChartContainer({}, this);
        this.append(this.content);

        this.axes = [];
        this.charts = [];
    }

    if ( BoxElement ) Pane.__proto__ = BoxElement;
    Pane.prototype = Object.create( BoxElement && BoxElement.prototype );
    Pane.prototype.constructor = Pane;

    Pane.prototype.createTitle = function createTitle () {
        var titleOptions = this.options.title;
        if (isObject(titleOptions)) {
            titleOptions = deepExtend({}, titleOptions, {
                align: titleOptions.position,
                position: TOP
            });
        }

        this.title = Title$1.buildTitle(titleOptions, Pane.prototype.options.title);
        if (this.title) {
            this.append(this.title);
        }
    };

    Pane.prototype.appendAxis = function appendAxis (axis) {
        this.content.append(axis);
        this.axes.push(axis);
        axis.pane = this;
    };

    Pane.prototype.appendAxisAt = function appendAxisAt (axis, pos) {
        this.content.append(axis);
        this.axes.splice(pos, 0, axis);
        axis.pane = this;
    };

    Pane.prototype.appendChart = function appendChart (chart) {
        if (this.chartContainer.parent !== this.content) {
            this.content.append(this.chartContainer);
        }

        this.charts.push(chart);
        this.chartContainer.append(chart);
        chart.pane = this;
    };

    Pane.prototype.empty = function empty () {
        var this$1$1 = this;

        var plotArea = this.parent;

        if (plotArea) {
            for (var i = 0; i < this.axes.length; i++) {
                plotArea.removeAxis(this$1$1.axes[i]);
            }

            for (var i$1 = 0; i$1 < this.charts.length; i$1++) {
                plotArea.removeChart(this$1$1.charts[i$1]);
            }
        }

        this.axes = [];
        this.charts = [];

        this.content.destroy();
        this.content.children = [];
        this.chartContainer.children = [];
    };

    Pane.prototype.reflow = function reflow (targetBox) {
        // Content (such as charts) is rendered, but excluded from reflows
        var content;
        if (last(this.children) === this.content) {
            content = this.children.pop();
        }

        BoxElement.prototype.reflow.call(this, targetBox);

        if (content) {
            this.children.push(content);
        }

        if (this.title) {
            this.contentBox.y1 += this.title.box.height();
        }
    };

    Pane.prototype.visualStyle = function visualStyle () {
        var style = BoxElement.prototype.visualStyle.call(this);
        style.zIndex = -10;

        return style;
    };

    Pane.prototype.renderComplete = function renderComplete () {
        if (this.options.visible) {
            this.createGridLines();
        }
    };

    Pane.prototype.stackRoot = function stackRoot () {
        return this;
    };

    Pane.prototype.clipRoot = function clipRoot () {
        return this;
    };

    Pane.prototype.createGridLines = function createGridLines () {
        var axes = this.axes;
        var allAxes = axes.concat(this.parent.axes);
        var vGridLines = [];
        var hGridLines = [];

        // TODO
        // Is full combination really necessary?
        for (var i = 0; i < axes.length; i++) {
            var axis = axes[i];
            var vertical = axis.options.vertical;
            var gridLines = vertical ? vGridLines : hGridLines;
            for (var j = 0; j < allAxes.length; j++) {
                if (gridLines.length === 0) {
                    var altAxis = allAxes[j];
                    if (vertical !== altAxis.options.vertical) {
                        append(gridLines, axis.createGridLines(altAxis));
                    }
                }
            }
        }
    };

    Pane.prototype.refresh = function refresh () {
        this.visual.clear();

        this.content.parent = null;
        this.content.createGradient = this.createGradient.bind(this);
        this.content.renderVisual();
        this.content.parent = this;

        if (this.title) {
            this.visual.append(this.title.visual);
        }

        this.visual.append(this.content.visual);

        this.renderComplete();
        this.notifyRender();
    };

    Pane.prototype.chartsBox = function chartsBox () {
        var axes = this.axes;
        var length = axes.length;
        var chartsBox = new Box();

        for (var idx = 0; idx < length; idx++) {
            var axis = axes[idx];
            var axisValueField = axis.options.vertical ? Y : X;
            var lineBox = axis.lineBox();
            chartsBox[axisValueField + 1] = lineBox[axisValueField + 1];
            chartsBox[axisValueField + 2] = lineBox[axisValueField + 2];
        }

        if (chartsBox.x2 === 0) {
            var allAxes = this.parent.axes;
            var length$1 = allAxes.length;

            for (var idx$1 = 0; idx$1 < length$1; idx$1++) {
                var axis$1 = allAxes[idx$1];
                if (!axis$1.options.vertical) {
                    var lineBox$1 = axis$1.lineBox();
                    chartsBox.x1 = lineBox$1.x1;
                    chartsBox.x2 = lineBox$1.x2;
                }
            }
        }
        return chartsBox;
    };

    Pane.prototype.clipBox = function clipBox () {
        return this.chartContainer.clipBox;
    };

    Pane.prototype.notifyRender = function notifyRender () {
        var service = this.getService();
        if (service) {
            service.notify(PANE_RENDER, {
                pane: new ChartPane(this),
                index: this.paneIndex,
                name: this.options.name
            });
        }
    };

    return Pane;
}(BoxElement));

var ID = 1;

function paneID() {
    return "pane" + ID++;
}

Pane$1.prototype.isStackRoot = true;

setDefaultOptions(Pane$1, {
    zIndex: -1,
    shrinkToFit: true,
    title: {
        align: LEFT
    },
    visible: true
});

var visiblePoint = function (point) { return point.options.visible !== false; };

var PlotAreaBase = (function (ChartElement) {
    function PlotAreaBase(series, options, chartService) {
        ChartElement.call(this, options);

        this.initFields(series, options);
        this.series = series;
        this.initSeries();
        this.charts = [];
        this.options.legend = this.options.legend || {};
        this.options.legend.data = [];
        this.axes = [];
        this.crosshairs = [];
        this.chartService = chartService;
        this.originalOptions = options;
        this.originalSeries = series;
        this._bindCache = new WeakMap();

        this.createPanes();
        this.render();
        this.createCrosshairs();
    }

    if ( ChartElement ) PlotAreaBase.__proto__ = ChartElement;
    PlotAreaBase.prototype = Object.create( ChartElement && ChartElement.prototype );
    PlotAreaBase.prototype.constructor = PlotAreaBase;

    PlotAreaBase.prototype.initFields = function initFields () { };

    PlotAreaBase.prototype.initSeries = function initSeries () {
        var series = this.series;

        for (var i = 0; i < series.length; i++) {
            series[i].index = i;
        }
    };

    PlotAreaBase.prototype.bindPoint = function bindPoint (series, pointIx, item) {
        var cached = this._bindCache.get(series);
        if (!cached) {
            cached = [];
            this._bindCache.set(series, cached);
        }

        var data = cached[pointIx];
        if (!data) {
            data = cached[pointIx] = SeriesBinder.current.bindPoint(series, pointIx, item);
        }

        return data;
    };

    PlotAreaBase.prototype.createPanes = function createPanes () {
        var this$1$1 = this;

        var titleOptions = this.options.title || {};
        var paneDefaults = this.options.paneDefaults;
        var paneOptions = this.options.panes || [];
        var panesLength = Math.max(paneOptions.length, 1);
        var panes = [];

        var defaults = deepExtend({
            title: {
                color: titleOptions.color
            }
        }, paneDefaults);

        for (var i = 0; i < panesLength; i++) {
            var options = deepExtend({}, defaults, paneOptions[i]);
            if (isString$1(options.title)) {
                options.title = deepExtend({ text: options.title }, defaults.title);
            }

            var currentPane = new Pane$1(options);
            currentPane.paneIndex = i;

            panes.push(currentPane);
            this$1$1.append(currentPane);
        }

        this.panes = panes;
    };

    PlotAreaBase.prototype.crosshairOptions = function crosshairOptions (axis) {
        return axis.options.crosshair;
    };

    PlotAreaBase.prototype.createCrosshairs = function createCrosshairs (panes) {
        var this$1$1 = this;
        if ( panes === void 0 ) panes = this.panes;

        for (var i = 0; i < panes.length; i++) {
            var pane = panes[i];
            for (var j = 0; j < pane.axes.length; j++) {
                var axis = pane.axes[j];
                var options = this$1$1.crosshairOptions(axis);
                if (options && options.visible) {
                    var currentCrosshair = new Crosshair(this$1$1.chartService, axis, options);

                    this$1$1.crosshairs.push(currentCrosshair);
                    pane.content.append(currentCrosshair);
                }
            }
        }
    };

    PlotAreaBase.prototype.removeCrosshairs = function removeCrosshairs (pane) {
        var crosshairs = this.crosshairs;
        var axes = pane.axes;

        for (var i = crosshairs.length - 1; i >= 0; i--) {
            for (var j = 0; j < axes.length; j++) {
                if (crosshairs[i].axis === axes[j]) {
                    crosshairs.splice(i, 1);
                    break;
                }
            }
        }
    };

    PlotAreaBase.prototype.hideCrosshairs = function hideCrosshairs () {
        var crosshairs = this.crosshairs;
        for (var idx = 0; idx < crosshairs.length; idx++) {
            crosshairs[idx].hide();
        }
    };

    PlotAreaBase.prototype.findPane = function findPane (name) {
        var panes = this.panes;
        var matchingPane;

        for (var i = 0; i < panes.length; i++) {
            if (panes[i].options.name === name) {
                matchingPane = panes[i];
                break;
            }
        }

        return matchingPane || panes[0];
    };

    PlotAreaBase.prototype.findPointPane = function findPointPane (point) {
        var panes = this.panes;
        var matchingPane;

        for (var i = 0; i < panes.length; i++) {
            if (panes[i].box.containsPoint(point)) {
                matchingPane = panes[i];
                break;
            }
        }

        return matchingPane;
    };

    PlotAreaBase.prototype.appendAxis = function appendAxis (axis) {
        var pane = this.findPane(axis.options.pane);

        pane.appendAxis(axis);
        this.axes.push(axis);
        axis.plotArea = this;
    };

    PlotAreaBase.prototype.removeAxis = function removeAxis (axisToRemove) {
        var this$1$1 = this;

        var filteredAxes = [];

        for (var i = 0; i < this.axes.length; i++) {
            var axis = this$1$1.axes[i];
            if (axisToRemove !== axis) {
                filteredAxes.push(axis);
            } else {
                axis.destroy();
            }
        }

        this.axes = filteredAxes;
    };

    PlotAreaBase.prototype.appendChart = function appendChart (chart, pane) {
        this.charts.push(chart);
        if (pane) {
            pane.appendChart(chart);
        } else {
            this.append(chart);
        }
    };

    PlotAreaBase.prototype.removeChart = function removeChart (chartToRemove) {
        var this$1$1 = this;

        var filteredCharts = [];

        for (var i = 0; i < this.charts.length; i++) {
            var chart = this$1$1.charts[i];
            if (chart !== chartToRemove) {
                filteredCharts.push(chart);
            } else {
                chart.destroy();
            }
        }

        this.charts = filteredCharts;
    };

    PlotAreaBase.prototype.addToLegend = function addToLegend (series) {
        var count = series.length;
        var legend = this.options.legend;
        var labels = legend.labels || {};
        var inactiveItems = legend.inactiveItems || {};
        var inactiveItemsLabels = inactiveItems.labels || {};
        var data = [];

        for (var i = 0; i < count; i++) {
            var currentSeries = series[i];
            var seriesVisible = currentSeries.visible !== false;
            if (currentSeries.visibleInLegend === false) {
                continue;
            }

            var text = currentSeries.name;
            var labelTemplate = seriesVisible ? getTemplate$1(labels) : getTemplate$1(inactiveItemsLabels) || getTemplate$1(labels);
            if (labelTemplate) {
                text = labelTemplate({
                    text: hasValue$2(text) ? text : "",
                    series: currentSeries
                });
            }

            var defaults = currentSeries._defaults;
            var color = currentSeries.color;
            if (isFunction(color) && defaults) {
                color = defaults.color;
            }

            var itemLabelOptions = (void 0), markerColor = (void 0);
            if (seriesVisible) {
                itemLabelOptions = {};
                markerColor = color;
            } else {
                itemLabelOptions = {
                    color: inactiveItemsLabels.color,
                    font: inactiveItemsLabels.font
                };
                markerColor = inactiveItems.markers.color;
            }

            if (hasValue$2(text) && text !== "") {
                data.push({
                    text: text,
                    labels: itemLabelOptions,
                    markerColor: markerColor,
                    series: currentSeries,
                    active: seriesVisible
                });
            }
        }

        append(legend.data, data);
    };

    PlotAreaBase.prototype.groupAxes = function groupAxes (panes) {
        var xAxes = [];
        var yAxes = [];

        for (var paneIx = 0; paneIx < panes.length; paneIx++) {
            var paneAxes = panes[paneIx].axes;
            for (var axisIx = 0; axisIx < paneAxes.length; axisIx++) {
                var axis = paneAxes[axisIx];
                if (axis.options.vertical) {
                    yAxes.push(axis);
                } else {
                    xAxes.push(axis);
                }
            }
        }

        return { x: xAxes, y: yAxes, any: xAxes.concat(yAxes) };
    };

    PlotAreaBase.prototype.groupSeriesByPane = function groupSeriesByPane () {
        var this$1$1 = this;

        var series = this.series;
        var seriesByPane = {};

        for (var i = 0; i < series.length; i++) {
            var currentSeries = series[i];
            var pane = this$1$1.seriesPaneName(currentSeries);

            if (seriesByPane[pane]) {
                seriesByPane[pane].push(currentSeries);
            } else {
                seriesByPane[pane] = [ currentSeries ];
            }
        }

        return seriesByPane;
    };

    PlotAreaBase.prototype.filterVisibleSeries = function filterVisibleSeries (series) {
        var result = [];

        for (var i = 0; i < series.length; i++) {
            var currentSeries = series[i];
            if (currentSeries.visible !== false) {
                result.push(currentSeries);
            }
        }

        return result;
    };

    PlotAreaBase.prototype.reflow = function reflow (targetBox) {
        var options = this.options.plotArea;
        var panes = this.panes;
        var margin = getSpacing(options.margin);

        this.box = targetBox.clone().unpad(margin);
        this.reflowPanes();

        this.detachLabels();
        this.reflowAxes(panes);
        this.reflowCharts(panes);
    };

    PlotAreaBase.prototype.redraw = function redraw (panes) {
        var this$1$1 = this;

        var panesArray = [].concat(panes);
        this.initSeries();

        //prevents leak during partial redraws. the cached gradients observers retain reference to the destroyed elements.
        var root = this.getRoot();
        if (root) {
            root.cleanGradients();
        }

        for (var i = 0; i < panesArray.length; i++) {
            this$1$1.removeCrosshairs(panesArray[i]);
            panesArray[i].empty();
        }

        this._bindCache = new WeakMap();

        this.render(panesArray);
        this.detachLabels();
        this.reflowAxes(this.panes);
        this.reflowCharts(panesArray);

        this.createCrosshairs(panesArray);

        for (var i$1 = 0; i$1 < panesArray.length; i$1++) {
            panesArray[i$1].refresh();
        }
    };

    PlotAreaBase.prototype.axisCrossingValues = function axisCrossingValues (axis, crossingAxes) {
        var options = axis.options;
        var crossingValues = [].concat(
            options.axisCrossingValues || options.axisCrossingValue
        );
        var valuesToAdd = crossingAxes.length - crossingValues.length;
        var defaultValue = crossingValues[0] || 0;

        for (var i = 0; i < valuesToAdd; i++) {
            crossingValues.push(defaultValue);
        }

        return crossingValues;
    };

    PlotAreaBase.prototype.alignAxisTo = function alignAxisTo (axis, targetAxis, crossingValue, targetCrossingValue) {
        var slot = axis.getSlot(crossingValue, crossingValue, true);
        var slotEdge = axis.options.reverse ? 2 : 1;
        var targetSlot = targetAxis.getSlot(targetCrossingValue, targetCrossingValue, true);
        var targetEdge = targetAxis.options.reverse ? 2 : 1;
        var axisBox = axis.box.translate(
            targetSlot[X + targetEdge] - slot[X + slotEdge],
            targetSlot[Y + targetEdge] - slot[Y + slotEdge]
        );

        if (axis.pane !== targetAxis.pane) {
            axisBox.translate(0, axis.pane.box.y1 - targetAxis.pane.box.y1);
        }

        axis.reflow(axisBox);
    };

    PlotAreaBase.prototype.alignAxes = function alignAxes (xAxes, yAxes) {
        var this$1$1 = this;

        var xAnchor = xAxes[0];
        var yAnchor = yAxes[0];
        var xAnchorCrossings = this.axisCrossingValues(xAnchor, yAxes);
        var yAnchorCrossings = this.axisCrossingValues(yAnchor, xAxes);
        var leftAnchors = {};
        var rightAnchors = {};
        var topAnchors = {};
        var bottomAnchors = {};

        for (var i = 0; i < yAxes.length; i++) {
            var axis = yAxes[i];
            var pane = axis.pane;
            var paneId = pane.id;
            var visible = axis.options.visible !== false;

            // Locate pane anchor, if any, and use its axisCrossingValues
            var anchor = paneAnchor(xAxes, pane) || xAnchor;
            var anchorCrossings = xAnchorCrossings;

            if (anchor !== xAnchor) {
                anchorCrossings = this$1$1.axisCrossingValues(anchor, yAxes);
            }

            this$1$1.alignAxisTo(axis, anchor, yAnchorCrossings[i], anchorCrossings[i]);

            if (axis.options._overlap) {
                continue;
            }

            if (round$1(axis.lineBox().x1) === round$1(anchor.lineBox().x1)) {
                // Push the axis to the left the previous y-axis so they don't overlap
                if (leftAnchors[paneId]) {
                    axis.reflow(axis.box
                        .alignTo(leftAnchors[paneId].box, LEFT)
                        .translate(-axis.options.margin, 0)
                    );
                }

                if (visible) {
                    leftAnchors[paneId] = axis;
                }
            }

            if (round$1(axis.lineBox().x2) === round$1(anchor.lineBox().x2)) {
                // Flip the labels on the right if we're at the right end of the pane
                if (!axis._mirrored) {
                    axis.options.labels.mirror = !axis.options.labels.mirror;
                    axis._mirrored = true;
                }

                this$1$1.alignAxisTo(axis, anchor, yAnchorCrossings[i], anchorCrossings[i]);

                // Push the axis to the right the previous y-axis so they don't overlap
                if (rightAnchors[paneId]) {
                    axis.reflow(axis.box
                        .alignTo(rightAnchors[paneId].box, RIGHT)
                        .translate(axis.options.margin, 0)
                    );
                }

                if (visible) {
                    rightAnchors[paneId] = axis;
                }
            }

            // Locate pane anchor, if any, and align the axis to it
            var paneYAnchor = paneAnchor(yAxes, pane) || yAnchor;
            if (paneYAnchor !== axis) {
                axis.alignTo(paneYAnchor);
                axis.reflow(axis.box);
            }
        }

        for (var i$1 = 0; i$1 < xAxes.length; i$1++) {
            var axis$1 = xAxes[i$1];
            var pane$1 = axis$1.pane;
            var paneId$1 = pane$1.id;
            var visible$1 = axis$1.options.visible !== false;

            // Locate pane anchor and use its axisCrossingValues
            var anchor$1 = paneAnchor(yAxes, pane$1) || yAnchor;
            var anchorCrossings$1 = yAnchorCrossings;
            if (anchor$1 !== yAnchor) {
                anchorCrossings$1 = this$1$1.axisCrossingValues(anchor$1, xAxes);
            }

            this$1$1.alignAxisTo(axis$1, anchor$1, xAnchorCrossings[i$1], anchorCrossings$1[i$1]);

            if (axis$1.options._overlap) {
                continue;
            }

            if (round$1(axis$1.lineBox().y1) === round$1(anchor$1.lineBox().y1)) {
                // Flip the labels on top if we're at the top of the pane
                if (!axis$1._mirrored) {
                    axis$1.options.labels.mirror = !axis$1.options.labels.mirror;
                    axis$1._mirrored = true;
                }
                this$1$1.alignAxisTo(axis$1, anchor$1, xAnchorCrossings[i$1], anchorCrossings$1[i$1]);

                // Push the axis above the previous x-axis so they don't overlap
                if (topAnchors[paneId$1]) {
                    axis$1.reflow(axis$1.box
                        .alignTo(topAnchors[paneId$1].box, TOP)
                        .translate(0, -axis$1.options.margin)
                    );
                }

                if (visible$1) {
                    topAnchors[paneId$1] = axis$1;
                }
            }

            if (round$1(axis$1.lineBox().y2, COORD_PRECISION) === round$1(anchor$1.lineBox().y2, COORD_PRECISION)) {
                // Push the axis below the previous x-axis so they don't overlap
                if (bottomAnchors[paneId$1]) {
                    axis$1.reflow(axis$1.box
                        .alignTo(bottomAnchors[paneId$1].box, BOTTOM$1)
                        .translate(0, axis$1.options.margin)
                    );
                }

                if (visible$1) {
                    bottomAnchors[paneId$1] = axis$1;
                }
            }

            if (i$1 !== 0) {
                axis$1.alignTo(xAnchor);
                axis$1.reflow(axis$1.box);
            }
        }
    };

    PlotAreaBase.prototype.shrinkAxisWidth = function shrinkAxisWidth (panes) {
        var axes = this.groupAxes(panes).any;
        var axisBox = axisGroupBox(axes);
        var overflowX = 0;

        for (var i = 0; i < panes.length; i++) {
            var currentPane = panes[i];

            if (currentPane.axes.length > 0) {
                overflowX = Math.max(
                    overflowX,
                    axisBox.width() - currentPane.contentBox.width()
                );
            }
        }

        if (overflowX !== 0) {
            for (var i$1 = 0; i$1 < axes.length; i$1++) {
                var currentAxis = axes[i$1];

                if (!currentAxis.options.vertical) {
                    currentAxis.reflow(currentAxis.box.shrink(overflowX, 0));
                }
            }
        }
    };

    PlotAreaBase.prototype.shrinkAxisHeight = function shrinkAxisHeight (panes) {
        var shrinked;

        for (var i = 0; i < panes.length; i++) {
            var currentPane = panes[i];
            var axes = currentPane.axes;
            var overflowY = Math.max(0, axisGroupBox(axes).height() - currentPane.contentBox.height());

            if (overflowY !== 0) {
                for (var j = 0; j < axes.length; j++) {
                    var currentAxis = axes[j];

                    if (currentAxis.options.vertical) {
                        currentAxis.reflow(
                            currentAxis.box.shrink(0, overflowY)
                        );
                    }
                }
                shrinked = true;
            }
        }

        return shrinked;
    };

    PlotAreaBase.prototype.fitAxes = function fitAxes (panes) {
        var axes = this.groupAxes(panes).any;
        var offsetX = 0;

        for (var i = 0; i < panes.length; i++) {
            var currentPane = panes[i];
            var paneAxes = currentPane.axes;
            var paneBox = currentPane.contentBox;

            if (paneAxes.length > 0) {
                var axisBox = axisGroupBox(paneAxes);
                // OffsetY is calculated and applied per pane
                var offsetY = Math.max(paneBox.y1 - axisBox.y1, paneBox.y2 - axisBox.y2);

                // OffsetX is calculated and applied globally
                offsetX = Math.max(offsetX, paneBox.x1 - axisBox.x1);


                for (var j = 0; j < paneAxes.length; j++) {
                    var currentAxis = paneAxes[j];

                    currentAxis.reflow(
                        currentAxis.box.translate(0, offsetY)
                    );
                }
            }
        }

        for (var i$1 = 0; i$1 < axes.length; i$1++) {
            var currentAxis$1 = axes[i$1];

            currentAxis$1.reflow(
                currentAxis$1.box.translate(offsetX, 0)
            );
        }
    };

    PlotAreaBase.prototype.reflowAxes = function reflowAxes (panes) {
        var this$1$1 = this;

        var axes = this.groupAxes(panes);

        for (var i = 0; i < panes.length; i++) {
            this$1$1.reflowPaneAxes(panes[i]);
        }

        if (axes.x.length > 0 && axes.y.length > 0) {
            this.alignAxes(axes.x, axes.y);
            this.shrinkAxisWidth(panes);

            this.autoRotateAxisLabels(axes);

            this.alignAxes(axes.x, axes.y);
            if (this.shrinkAxisWidth(panes)) {
                this.alignAxes(axes.x, axes.y);
            }

            this.shrinkAxisHeight(panes);
            this.alignAxes(axes.x, axes.y);

            if (this.shrinkAxisHeight(panes)) {
                this.alignAxes(axes.x, axes.y);
            }

            this.fitAxes(panes);
        }
    };

    PlotAreaBase.prototype.autoRotateAxisLabels = function autoRotateAxisLabels (groupedAxes) {
        var this$1$1 = this;

        var ref = this;
        var panes = ref.panes;
        var axes = allPaneAxes(panes);
        var rotated;

        for (var idx = 0; idx < axes.length; idx++) {
            var axis = axes[idx];
            if (axis.autoRotateLabels()) {
                rotated = true;
            }
        }

        if (rotated) {
            for (var idx$1 = 0; idx$1 < panes.length; idx$1++) {
                this$1$1.reflowPaneAxes(panes[idx$1]);
            }

            if (groupedAxes.x.length > 0 && groupedAxes.y.length > 0) {
                this.alignAxes(groupedAxes.x, groupedAxes.y);
                this.shrinkAxisWidth(panes);
            }
        }
    };

    PlotAreaBase.prototype.reflowPaneAxes = function reflowPaneAxes (pane) {
        var axes = pane.axes;
        var length = axes.length;

        if (length > 0) {
            for (var i = 0; i < length; i++) {
                axes[i].reflow(pane.contentBox);
            }
        }
    };

    PlotAreaBase.prototype.reflowCharts = function reflowCharts (panes) {
        var charts = this.charts;
        var count = charts.length;
        var box = this.box;

        for (var i = 0; i < count; i++) {
            var chartPane = charts[i].pane;
            if (!chartPane || inArray(chartPane, panes)) {
                charts[i].reflow(box);
            }
        }
    };

    PlotAreaBase.prototype.reflowPanes = function reflowPanes () {
        var ref = this;
        var box = ref.box;
        var panes = ref.panes;
        var panesLength = panes.length;
        var remainingHeight = box.height();
        var autoHeightPanes = 0;
        var top = box.y1;

        for (var i = 0; i < panesLength; i++) {
            var currentPane = panes[i];
            var height = currentPane.options.height;

            currentPane.options.width = box.width();

            if (!currentPane.options.height) {
                autoHeightPanes++;
            } else {
                if (height.indexOf && height.indexOf("%")) {
                    var percents = parseInt(height, 10) / 100;
                    currentPane.options.height = percents * box.height();
                }

                currentPane.reflow(box.clone());

                remainingHeight -= currentPane.options.height;
            }
        }

        for (var i$1 = 0; i$1 < panesLength; i$1++) {
            var currentPane$1 = panes[i$1];

            if (!currentPane$1.options.height) {
                currentPane$1.options.height = remainingHeight / autoHeightPanes;
            }
        }

        for (var i$2 = 0; i$2 < panesLength; i$2++) {
            var currentPane$2 = panes[i$2];
            var paneBox = box
                .clone()
                .move(box.x1, top);

            currentPane$2.reflow(paneBox);

            top += currentPane$2.options.height;
        }
    };

    PlotAreaBase.prototype.backgroundBox = function backgroundBox () {
        var axes = this.axes;
        var axesCount = axes.length;
        var box;

        for (var i = 0; i < axesCount; i++) {
            var axisA = axes[i];

            for (var j = 0; j < axesCount; j++) {
                var axisB = axes[j];

                if (axisA.options.vertical !== axisB.options.vertical) {
                    var lineBox = axisA.lineBox().clone().wrap(axisB.lineBox());

                    if (!box) {
                        box = lineBox;
                    } else {
                        box = box.wrap(lineBox);
                    }
                }
            }
        }

        return box || this.box;
    };

    PlotAreaBase.prototype.chartsBoxes = function chartsBoxes () {
        var panes = this.panes;
        var boxes = [];

        for (var idx = 0; idx < panes.length; idx++) {
            boxes.push(panes[idx].chartsBox());
        }

        return boxes;
    };

    PlotAreaBase.prototype.addBackgroundPaths = function addBackgroundPaths (multipath) {
        var boxes = this.chartsBoxes();
        for (var idx = 0; idx < boxes.length; idx++) {
            multipath.paths.push(Path$7.fromRect(boxes[idx].toRect()));
        }
    };

    PlotAreaBase.prototype.backgroundContainsPoint = function backgroundContainsPoint (point) {
        var boxes = this.chartsBoxes();
        for (var idx = 0; idx < boxes.length; idx++) {
            if (boxes[idx].containsPoint(point)) {
                return true;
            }
        }
    };

    PlotAreaBase.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        var options = this.options.plotArea;
        var opacity = options.opacity;
        var background = options.background;
        var border = options.border; if ( border === void 0 ) border = {};
        if (isTransparent(background)) {
            background = WHITE$1;
            opacity = 0;
        }

        var bg = this._bgVisual = new MultiPath({
            fill: {
                color: background,
                opacity: opacity
            },
            stroke: {
                color: border.width ? border.color : "",
                width: border.width,
                dashType: border.dashType
            },
            zIndex: -1
        });

        this.addBackgroundPaths(bg);

        this.appendVisual(bg);
    };

    PlotAreaBase.prototype.pointsByCategoryIndex = function pointsByCategoryIndex (categoryIndex) {
        var charts = this.charts;
        var result = [];

        if (categoryIndex !== null) {
            for (var i = 0; i < charts.length; i++) {
                var chart = charts[i];

                if (chart.pane.options.name === "_navigator") {
                    continue;
                }

                var points = charts[i].categoryPoints[categoryIndex];
                if (points && points.length) {
                    for (var j = 0; j < points.length; j++) {
                        var point = points[j];
                        if (point && defined(point.value) && point.value !== null) {
                            result.push(point);
                        }
                    }
                }
            }
        }

        return result;
    };

    PlotAreaBase.prototype.pointsBySeriesIndex = function pointsBySeriesIndex (seriesIndex) {
        return this.filterPoints(function(point) {
            return point.series.index === seriesIndex;
        });
    };

    PlotAreaBase.prototype.pointsByPointIndex = function pointsByPointIndex (pointIndex) {
        return this.filterPoints(function(point) {
            return point.getIndex() === pointIndex;
        });
    };

    PlotAreaBase.prototype.pointsBySeriesName = function pointsBySeriesName (name) {
        return this.filterPoints(function(point) {
            return point.series.name === name;
        });
    };

    PlotAreaBase.prototype.filterPoints = function filterPoints (callback) {
        var charts = this.charts;
        var result = [];

        for (var i = 0; i < charts.length; i++) {
            var chart = charts[i];
            var points = chart.points;
            for (var j = 0; j < points.length; j++) {
                var point = points[j];
                if (point && point.visible !== false && callback(point)) {
                    result.push(point);
                }
            }
        }

        return result;
    };

    PlotAreaBase.prototype.findPoint = function findPoint (callback) {
        var charts = this.charts;

        for (var i = 0; i < charts.length; i++) {
            var chart = charts[i];
            var points = chart.points;
            for (var j = 0; j < points.length; j++) {
                var point = points[j];
                if (point && point.visible !== false && callback(point)) {
                    return point;
                }
            }
        }
    };

    PlotAreaBase.prototype.paneByPoint = function paneByPoint (point) {
        var panes = this.panes;

        for (var i = 0; i < panes.length; i++) {
            var pane = panes[i];
            if (pane.box.containsPoint(point)) {
                return pane;
            }
        }
    };

    PlotAreaBase.prototype.detachLabels = function detachLabels () {
        var axes = this.groupAxes(this.panes);
        var xAxes = axes.x;
        var yAxes = axes.y;

        this.detachAxisGroupLabels(yAxes, xAxes);
        this.detachAxisGroupLabels(xAxes, yAxes);
    };

    PlotAreaBase.prototype.detachAxisGroupLabels = function detachAxisGroupLabels (axes, crossingAxes) {
        var this$1$1 = this;

        var labelAxisCount = 0;

        for (var i = 0; i < axes.length; i++) {
            var axis = axes[i];
            var pane = axis.pane;
            var anchor = paneAnchor(crossingAxes, pane) || crossingAxes[0];
            var axisIndex = i + labelAxisCount;
            var labelAxis = this$1$1.createLabelAxis(axis, axisIndex, anchor);

            if (labelAxis) {
                labelAxisCount++;

                var pos = pane.axes.indexOf(axis) + labelAxisCount;
                pane.appendAxisAt(labelAxis, pos);
            }
        }
    };

    PlotAreaBase.prototype.createLabelAxis = function createLabelAxis (axis, axisIndex, anchor) {
        var labelOptions = axis.options.labels;
        var position = labelOptions.position;
        var onAxis = position !== END$1 && position !== START$1;
        var visible = labelOptions.visible;

        if (onAxis || visible === false) {
            return null;
        }

        var allAxes = this.groupAxes(this.panes);
        var crossingAxes = anchor.options.vertical ? allAxes.x : allAxes.y;
        var anchorCrossings = this.axisCrossingValues(anchor, crossingAxes);
        var end = position === END$1;
        var range = anchor.range();
        var edge = end ? range.max : range.min;
        var crossingValue = limitValue(anchorCrossings[axisIndex], range.min, range.max);

        if (crossingValue - edge === 0) {
            return null;
        }

        anchorCrossings.splice(axisIndex + 1, 0, edge);
        anchor.options.axisCrossingValues = anchorCrossings;

        var labelAxis = axis.clone();
        axis.clear();

        labelAxis.options.name = undefined;
        labelAxis.options.line.visible = false;

        labelAxis.options.crosshair = undefined;
        labelAxis.options.notes = undefined;
        labelAxis.options.plotBands = undefined;

        return labelAxis;
    };

    PlotAreaBase.prototype.isTrendline = function isTrendline (series) {
        return series && inArray(series.type, TRENDLINE_SERIES);
    };

    PlotAreaBase.prototype.trendlineFactory = function trendlineFactory () { /* abstract */ };

    PlotAreaBase.prototype.createTrendlineSeries = function createTrendlineSeries () {
        var this$1$1 = this;

        var modifiedSeries = [];

        this.series = this.series.map(function (series) {
            if (!this$1$1.isTrendline(series)) {
                return series;
            }

            var forSeries = this$1$1.seriesByName(series.for);
            if (!forSeries) {
                throw new Error('Invalid Configuration: Unable to locate linked series ' +
                    "\"" + (series.for) + "\" for trendline \"" + (series.name) + "\".");
            }

            var valueFields = SeriesBinder.current.valueFields(forSeries);
            var field = last(valueFields); // Use the last field for multi-field series

            var trendlineSeries = this$1$1.trendlineFactory(Object.assign({}, {field: field}, series), forSeries);
            if (trendlineSeries) {
                if (forSeries.visible === false) {
                    trendlineSeries.visible = false;
                }

                if (trendlineSeries.color === INHERIT) {
                    trendlineSeries.color = forSeries.color;
                }

                modifiedSeries.push(trendlineSeries);
            }

            return trendlineSeries;
        }).filter(function (series) { return series !== null; });

        return modifiedSeries;
    };

    PlotAreaBase.prototype.seriesByName = function seriesByName (name) {
        return this.series.find(function (series) { return series.name === name; });
    };

    PlotAreaBase.prototype.getFirstPoint = function getFirstPoint () {
        var this$1$1 = this;

        for (var i = 0; i < this.series.length; i++) {
            var points = this$1$1.pointsBySeriesIndex(i);
            var point = points.find(visiblePoint);
            if (point) {
                return point;
            }
        }
    };

    PlotAreaBase.prototype.getPointBelow = function getPointBelow (point) {
        return this._getNextPoint(point, this._pointsByVertical, 1);
    };

    PlotAreaBase.prototype.getPointAbove = function getPointAbove (point) {
        return this._getNextPoint(point, this._pointsByVertical, -1);
    };

    PlotAreaBase.prototype.getPointToTheRight = function getPointToTheRight (point) {
        return this._getNextPoint(point, this._pointsByHorizontal, 1);
    };

    PlotAreaBase.prototype.getPointToTheLeft = function getPointToTheLeft (point) {
        return this._getNextPoint(point, this._pointsByHorizontal, -1);
    };

    PlotAreaBase.prototype._getNextPoint = function _getNextPoint (point, getPointsFunc, increment) {
        var this$1$1 = this;

        var points = getPointsFunc.call(this, point).filter(visiblePoint);
        var pointIndex = points.indexOf(point);
        var nextIndex = pointIndex + increment;
        var loopPoints = function (direction) {
            // loop over to last non-empty collection
            var result;
            var offset = 0;
            do {
                offset += direction;
                result = getPointsFunc.call(this$1$1, point, offset).filter(visiblePoint);
            } while (result.length === 0);

            return result;
        };

        if (nextIndex < 0) {
            points = loopPoints(-1);

            return points.at(-1);
        } else if (nextIndex >= points.length) {
            points = loopPoints(1);

            return points.at(0);
        }

        return points[nextIndex];
    };

    PlotAreaBase.prototype._pointsByVertical = function _pointsByVertical (basePoint) {
        return this.pointsByPointIndex(basePoint.getIndex());
    };

    PlotAreaBase.prototype._pointsByHorizontal = function _pointsByHorizontal (basePoint, offset) {
        if ( offset === void 0 ) offset = 0;

        var index = cycleIndex(basePoint.series.index + offset, this.series.length);
        return this.pointsBySeriesIndex(index);
    };

    return PlotAreaBase;
}(ChartElement));

function isSingleAxis(axis) {
    return !axis.pane.axes.some(function (a) { return a.options.vertical === axis.options.vertical && a !== axis && a.options.visible !== false; }
    );
}

function axisGroupBox(axes) {
    var length = axes.length;
    var box;

    for (var i = 0; i < length; i++) {
        var axis = axes[i];
        var visible = axis.options.visible !== false;
        if (visible || isSingleAxis(axis)) {
            var axisBox = visible ? axis.contentBox() : axis.lineBox();

            if (!box) {
                box = axisBox.clone();
            } else {
                box.wrap(axisBox);
            }
        }
    }

    return box || new Box();
}

function paneAnchor(axes, pane) {
    for (var i = 0; i < axes.length; i++) {
        var anchor = axes[i];
        if (anchor && anchor.pane === pane) {
            return anchor;
        }
    }
}

function isTransparent(color) {
    return color === "" || color === null || color === "none" || color === "transparent" || !defined(color);
}

var allPaneAxes = function (panes) { return panes.reduce(function (acc, pane) { return acc.concat(pane.axes); }, []); };

setDefaultOptions(PlotAreaBase, {
    series: [],
    plotArea: {
        margin: {}
    },
    background: "",
    border: {
        color: BLACK$1,
        width: 0
    },
    paneDefaults: {
        title: {}
    },
    legend: {
        inactiveItems: {
            labels: {
                color: "#919191"
            },
            markers: {
                color: "#919191"
            }
        }
    }
});

var PlotAreaEventsMixin = {
    hover: function(chart, e) {
        this._dispatchEvent(chart, e, PLOT_AREA_HOVER);
    },

    click: function(chart, e) {
        this._dispatchEvent(chart, e, PLOT_AREA_CLICK);
    }
};

var SeriesAggregator = (function (Class) {
    function SeriesAggregator(series, binder, defaultAggregates) {
        Class.call(this);

        var canonicalFields = binder.canonicalFields(series);
        var valueFields = binder.valueFields(series);
        var sourceFields = binder.sourceFields(series, canonicalFields);
        var seriesFields = this._seriesFields = [];
        var defaults = defaultAggregates.query(series.type);
        var rootAggregate = series.aggregate || defaults;

        this._series = series;
        this._binder = binder;

        for (var i = 0; i < canonicalFields.length; i++) {
            var field = canonicalFields[i];
            var fieldAggregate = (void 0);

            if (isObject(rootAggregate)) {
                fieldAggregate = rootAggregate[field];
            } else if (i === 0 || inArray(field, valueFields)) {
                fieldAggregate = rootAggregate;
            } else {
                break;
            }

            if (fieldAggregate) {
                seriesFields.push({
                    canonicalName: field,
                    name: sourceFields[i],
                    transform: isFunction(fieldAggregate) ? fieldAggregate : Aggregates[fieldAggregate]
                });
            }
        }
    }

    if ( Class ) SeriesAggregator.__proto__ = Class;
    SeriesAggregator.prototype = Object.create( Class && Class.prototype );
    SeriesAggregator.prototype.constructor = SeriesAggregator;

    SeriesAggregator.prototype.aggregatePoints = function aggregatePoints (srcPoints, group) {
        var this$1$1 = this;

        var ref = this;
        var series = ref._series;
        var seriesFields = ref._seriesFields;
        var data = this._bindPoints(srcPoints || []);
        var firstDataItem = data.dataItems[0];
        var result = {};

        if (firstDataItem && !isNumber(firstDataItem) && !isArray(firstDataItem)) {
            var fn = function() {};
            fn.prototype = firstDataItem;
            result = new fn();
        }

        for (var i = 0; i < seriesFields.length; i++) {
            var field = seriesFields[i];
            var srcValues = this$1$1._bindField(data.values, field.canonicalName);
            var value = field.transform(srcValues, series, data.dataItems, group);

            if (value !== null && isObject(value) && !defined(value.length) && !(value instanceof Date)) {
                result = value;
                break;
            } else {
                if (defined(value)) {
                    setValue(field.name, result, value);
                }
            }
        }

        return result;
    };

    SeriesAggregator.prototype._bindPoints = function _bindPoints (points) {
        var ref = this;
        var binder = ref._binder;
        var series = ref._series;
        var values = [];
        var dataItems = [];

        for (var i = 0; i < points.length; i++) {
            var pointIx = points[i];

            values.push(binder.bindPoint(series, pointIx));
            dataItems.push(series.data[pointIx]);
        }

        return {
            values: values,
            dataItems: dataItems
        };
    };

    SeriesAggregator.prototype._bindField = function _bindField (data, field) {
        var values = [];
        var count = data.length;

        for (var i = 0; i < count; i++) {
            var item = data[i];
            var valueFields = item.valueFields;
            var value = (void 0);

            if (defined(valueFields[field])) {
                value = valueFields[field];
            } else {
                value = item.fields[field];
            }

            values.push(value);
        }

        return values;
    };

    return SeriesAggregator;
}(Class));

function setValue(fieldName, target, value) {
    var parentObj = target;
    var field = fieldName;

    if (fieldName.indexOf(".") > -1) {
        var parts = fieldName.split(".");

        while (parts.length > 1) {
            field = parts.shift();
            if (!defined(parentObj[field])) {
                parentObj[field] = {};
            }
            parentObj = parentObj[field];
        }
        field = parts.shift();
    }

    parentObj[field] = value;
}

var DefaultAggregates = (function (Class) {
    function DefaultAggregates() {
        Class.call(this);

        this._defaults = {};
    }

    if ( Class ) DefaultAggregates.__proto__ = Class;
    DefaultAggregates.prototype = Object.create( Class && Class.prototype );
    DefaultAggregates.prototype.constructor = DefaultAggregates;

    DefaultAggregates.prototype.register = function register (seriesTypes, aggregates) {
        var this$1$1 = this;

        for (var i = 0; i < seriesTypes.length; i++) {
            this$1$1._defaults[seriesTypes[i]] = aggregates;
        }
    };

    DefaultAggregates.prototype.query = function query (seriesType) {
        return this._defaults[seriesType];
    };

    return DefaultAggregates;
}(Class));

DefaultAggregates.current = new DefaultAggregates();

var RangeBar = (function (Bar) {
    function RangeBar () {
        Bar.apply(this, arguments);
    }

    if ( Bar ) RangeBar.__proto__ = Bar;
    RangeBar.prototype = Object.create( Bar && Bar.prototype );
    RangeBar.prototype.constructor = RangeBar;

    RangeBar.prototype.createLabel = function createLabel () {
        var labels = this.options.labels;
        var fromOptions = deepExtend({}, labels, labels.from);
        var toOptions = deepExtend({}, labels, labels.to);

        if (fromOptions.visible) {
            this.labelFrom = this.createLabelElement(fromOptions);
            this.append(this.labelFrom);
        }

        if (toOptions.visible) {
            this.labelTo = this.createLabelElement(toOptions);
            this.append(this.labelTo);
        }
    };

    RangeBar.prototype.reflow = function reflow (targetBox) {
        this.render();

        var ref = this;
        var labelFrom = ref.labelFrom;
        var labelTo = ref.labelTo;
        var value = ref.value;

        this.box = targetBox;

        if (labelFrom) {
            labelFrom.options.aboveAxis = value.from > value.to;
            labelFrom.reflow(targetBox);
        }

        if (labelTo) {
            labelTo.options.aboveAxis = value.to > value.from;
            labelTo.reflow(targetBox);
        }

        if (this.note) {
            this.note.reflow(targetBox);
        }
    };

    return RangeBar;
}(Bar));

RangeBar.prototype.defaults = deepExtend({}, RangeBar.prototype.defaults, {
    labels: {
        format: "{0} - {1}"
    },
    tooltip: {
        format: "{1}"
    }
});

var RangeBarChart = (function (BarChart) {
    function RangeBarChart () {
        BarChart.apply(this, arguments);
    }

    if ( BarChart ) RangeBarChart.__proto__ = BarChart;
    RangeBarChart.prototype = Object.create( BarChart && BarChart.prototype );
    RangeBarChart.prototype.constructor = RangeBarChart;

    RangeBarChart.prototype.pointType = function pointType () {
        return RangeBar;
    };

    RangeBarChart.prototype.pointValue = function pointValue (data) {
        return data.valueFields;
    };

    RangeBarChart.prototype.formatPointValue = function formatPointValue (point, format) {
        if (point.value.from === null && point.value.to === null) {
            return "";
        }

        return this.chartService.format.auto(format, point.value.from, point.value.to);
    };

    RangeBarChart.prototype.plotRange = function plotRange (point) {
        if (!point) {
            return 0;
        }

        return [ point.value.from, point.value.to ];
    };

    RangeBarChart.prototype.updateRange = function updateRange (value, fields) {
        var axisName = fields.series.axis;
        var from = value.from;
        var to = value.to;
        var axisRange = this.valueAxisRanges[axisName];

        if (value !== null && isNumber(from) && isNumber(to)) {
            axisRange = this.valueAxisRanges[axisName] = axisRange || { min: MAX_VALUE, max: MIN_VALUE };

            axisRange.min = Math.min(axisRange.min, from);
            axisRange.max = Math.max(axisRange.max, from);

            axisRange.min = Math.min(axisRange.min, to);
            axisRange.max = Math.max(axisRange.max, to);
        }
    };

    RangeBarChart.prototype.aboveAxis = function aboveAxis (point) {
        var value = point.value;
        return value.from < value.to;
    };

    return RangeBarChart;
}(BarChart));

RangeBarChart.prototype.plotLimits = CategoricalChart.prototype.plotLimits;

var RangeLinePoint = (function (LinePoint) {
    function RangeLinePoint () {
        LinePoint.apply(this, arguments);
    }

    if ( LinePoint ) RangeLinePoint.__proto__ = LinePoint;
    RangeLinePoint.prototype = Object.create( LinePoint && LinePoint.prototype );
    RangeLinePoint.prototype.constructor = RangeLinePoint;

    RangeLinePoint.prototype.aliasFor = function aliasFor () {
        return this.parent;
    };

    return RangeLinePoint;
}(LinePoint));

var AUTO = 'auto';
var DEFAULT_FROM_FORMAT = '{0}';
var DEFAULT_TO_FORMAT = '{1}';

var RangeAreaPoint = (function (ChartElement) {
    function RangeAreaPoint(value, options) {
        ChartElement.call(this);

        this.value = value;
        this.options = options;
        this.aboveAxis = valueOrDefault(this.options.aboveAxis, true);
        this.tooltipTracking = true;
        this._id = guid();
        this.initLabelsFormat();
    }

    if ( ChartElement ) RangeAreaPoint.__proto__ = ChartElement;
    RangeAreaPoint.prototype = Object.create( ChartElement && ChartElement.prototype );
    RangeAreaPoint.prototype.constructor = RangeAreaPoint;

    RangeAreaPoint.prototype.render = function render () {
        if (this._rendered) {
            return;
        }

        this._rendered = true;

        var ref = this.options;
        var markers = ref.markers;
        var labels = ref.labels;
        var value = this.value;

        var fromPoint = this.fromPoint = new RangeLinePoint(value, deepExtend({}, this.options, {
            labels: labels.from,
            markers: markers.from
        }));

        var toPoint = this.toPoint = new RangeLinePoint(value, deepExtend({}, this.options, {
            labels: labels.to,
            markers: markers.to
        }));

        this.copyFields(fromPoint);
        this.copyFields(toPoint);

        this.append(fromPoint);
        this.append(toPoint);
    };

    RangeAreaPoint.prototype.reflow = function reflow (targetBox) {
        this.render();

        var fromBox = targetBox.from;
        var toBox = targetBox.to;

        this.positionLabels(fromBox, toBox);

        this.fromPoint.reflow(fromBox);
        this.toPoint.reflow(toBox);

        this.box = this.fromPoint.markerBox().clone().wrap(this.toPoint.markerBox());
    };

    RangeAreaPoint.prototype.createHighlight = function createHighlight () {
        var group = new Group$8();
        group.append(this.fromPoint.createHighlight());
        group.append(this.toPoint.createHighlight());

        return group;
    };

    RangeAreaPoint.prototype.highlightVisual = function highlightVisual () {
        return this.visual;
    };

    RangeAreaPoint.prototype.highlightVisualArgs = function highlightVisualArgs () {
        return {
            options: this.options,
            from: this.fromPoint.highlightVisualArgs(),
            to: this.toPoint.highlightVisualArgs()
        };
    };

    RangeAreaPoint.prototype.createFocusHighlight = function createFocusHighlight () {
        var group = new Group$8();
        group.append(this.fromPoint.createFocusHighlight());
        group.append(this.toPoint.createFocusHighlight());

        return group;
    };

    RangeAreaPoint.prototype.tooltipAnchor = function tooltipAnchor () {
        var clipBox = this.owner.pane.clipBox();
        var showTooltip = !clipBox || clipBox.overlaps(this.box);

        if (showTooltip) {
            var box = this.box;
            var center = box.center();
            var horizontalAlign = LEFT;
            var x, y, verticalAlign;

            if (this.options.vertical) {
                x = center.x;
                y = box.y1 - TOOLTIP_OFFSET;
                verticalAlign = BOTTOM$1;
            } else {
                x = box.x2 + TOOLTIP_OFFSET;
                y = center.y;
                verticalAlign = CENTER;
            }

            return {
                point: new Point$5(x, y),
                align: {
                    horizontal: horizontalAlign,
                    vertical: verticalAlign
                }
            };
        }
    };

    RangeAreaPoint.prototype.formatValue = function formatValue (format) {
        return this.owner.formatPointValue(this, format);
    };

    RangeAreaPoint.prototype.overlapsBox = function overlapsBox (box) {
        return this.box.overlaps(box);
    };

    RangeAreaPoint.prototype.unclipElements = function unclipElements () {
        this.fromPoint.unclipElements();
        this.toPoint.unclipElements();
    };

    RangeAreaPoint.prototype.initLabelsFormat = function initLabelsFormat () {
        var labels = this.options.labels;
        if (!labels.format) {
            if (!labels.from || !labels.from.format) {
                labels.from = Object.assign({}, labels.from, {
                    format: DEFAULT_FROM_FORMAT
                });
            }

            if (!labels.to || !labels.to.format) {
                labels.to = Object.assign({}, labels.to, {
                    format: DEFAULT_TO_FORMAT
                });
            }
        }
    };

    RangeAreaPoint.prototype.positionLabels = function positionLabels (fromBox, toBox) {
        var ref = this.options;
        var labels = ref.labels;
        var vertical = ref.vertical;

        if (labels.position === AUTO) {
            var fromLabelPosition, toLabelPosition;
            if (vertical) {
                if (toBox.y1 <= fromBox.y1) {
                    toLabelPosition = ABOVE;
                    fromLabelPosition = BELOW;
                } else {
                    toLabelPosition = BELOW;
                    fromLabelPosition = ABOVE;
                }
            } else {
                if (toBox.x1 <= fromBox.x1) {
                    toLabelPosition = LEFT;
                    fromLabelPosition = RIGHT;
                } else {
                    toLabelPosition = RIGHT;
                    fromLabelPosition = LEFT;
                }
            }

            if (!labels.from || !labels.from.position) {
                this.fromPoint.options.labels.position = fromLabelPosition;
            }

            if (!labels.to || !labels.to.position) {
                this.toPoint.options.labels.position = toLabelPosition;
            }
        }
    };

    RangeAreaPoint.prototype.copyFields = function copyFields (point) {
        point.dataItem = this.dataItem;
        point.category = this.category;
        point.series = this.series;
        point.color = this.color;
        point.owner = this.owner;
    };

    RangeAreaPoint.prototype.focusVisual = function focusVisual () {
        this.fromPoint.focusVisual();
    };

    RangeAreaPoint.prototype.clearFocusFromVisual = function clearFocusFromVisual () {
        this.toPoint.clearFocusFromVisual();
    };

    RangeAreaPoint.prototype.getIndex = function getIndex () {
        return this.categoryIx;
    };

    return RangeAreaPoint;
}(ChartElement));

deepExtend(RangeAreaPoint.prototype, PointEventsMixin);
deepExtend(RangeAreaPoint.prototype, NoteMixin);

RangeAreaPoint.prototype.defaults = {
    markers: {
        visible: false,
        background: WHITE$1,
        size: LINE_MARKER_SIZE,
        type: CIRCLE,
        border: {
            width: 2
        },
        opacity: 1
    },
    labels: {
        visible: false,
        margin: getSpacing(3),
        padding: getSpacing(4),
        animation: {
            type: FADEIN,
            delay: INITIAL_ANIMATION_DURATION
        },
        position: AUTO
    },
    notes: {
        label: {}
    },
    highlight: {
        markers: {
            border: {
                color: WHITE$1,
                width: 2
            }
        },
        zIndex: HIGHLIGHT_ZINDEX
    },
    tooltip: {
        format: '{0} - {1}'
    },
    accessibility: {
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
};

var RangeAreaSegment = (function (AreaSegment) {
    function RangeAreaSegment () {
        AreaSegment.apply(this, arguments);
    }

    if ( AreaSegment ) RangeAreaSegment.__proto__ = AreaSegment;
    RangeAreaSegment.prototype = Object.create( AreaSegment && AreaSegment.prototype );
    RangeAreaSegment.prototype.constructor = RangeAreaSegment;

    RangeAreaSegment.prototype.createStrokeSegments = function createStrokeSegments () {
        return this.segmentsFromPoints(this.toGeometryPoints(this.toPoints()));
    };

    RangeAreaSegment.prototype.stackSegments = function stackSegments () {
        var fromSegments = this.fromSegments;
        if (!this.fromSegments) {
            fromSegments = this.fromSegments = this.segmentsFromPoints(this.toGeometryPoints(this.fromPoints().reverse()));
        }

        return fromSegments;
    };

    RangeAreaSegment.prototype.createStroke = function createStroke (style) {
        var toPath = new Path$7(style);
        var fromPath = new Path$7(style);

        toPath.segments.push.apply(toPath.segments, this.strokeSegments());
        fromPath.segments.push.apply(fromPath.segments, this.stackSegments());

        this.visual.append(toPath);
        this.visual.append(fromPath);
    };

    RangeAreaSegment.prototype.hasStackSegment = function hasStackSegment () {
        return true;
    };

    RangeAreaSegment.prototype.fromPoints = function fromPoints () {
        return this.linePoints.map(function (point) { return point.fromPoint; });
    };

    RangeAreaSegment.prototype.toPoints = function toPoints () {
        return this.linePoints.map(function (point) { return point.toPoint; });
    };

    return RangeAreaSegment;
}(AreaSegment));

var SplineRangeAreaSegment = (function (RangeAreaSegment) {
    function SplineRangeAreaSegment () {
        RangeAreaSegment.apply(this, arguments);
    }

    if ( RangeAreaSegment ) SplineRangeAreaSegment.__proto__ = RangeAreaSegment;
    SplineRangeAreaSegment.prototype = Object.create( RangeAreaSegment && RangeAreaSegment.prototype );
    SplineRangeAreaSegment.prototype.constructor = SplineRangeAreaSegment;

    SplineRangeAreaSegment.prototype.createStrokeSegments = function createStrokeSegments () {
        return this.createCurveSegments(this.toPoints());
    };

    SplineRangeAreaSegment.prototype.stackSegments = function stackSegments () {
        var fromSegments = this.fromSegments;
        if (!this.fromSegments) {
            fromSegments = this.fromSegments = this.createCurveSegments(this.fromPoints().reverse());
        }

        return fromSegments;
    };

    SplineRangeAreaSegment.prototype.createCurveSegments = function createCurveSegments (points) {
        var curveProcessor = new CurveProcessor();

        return curveProcessor.process(this.toGeometryPoints(points));
    };

    return SplineRangeAreaSegment;
}(RangeAreaSegment));

var StepRangeAreaSegment = (function (RangeAreaSegment) {
    function StepRangeAreaSegment () {
        RangeAreaSegment.apply(this, arguments);
    }

    if ( RangeAreaSegment ) StepRangeAreaSegment.__proto__ = RangeAreaSegment;
    StepRangeAreaSegment.prototype = Object.create( RangeAreaSegment && RangeAreaSegment.prototype );
    StepRangeAreaSegment.prototype.constructor = StepRangeAreaSegment;

    StepRangeAreaSegment.prototype.createStrokeSegments = function createStrokeSegments () {
        return this.segmentsFromPoints(this.calculateStepPoints(this.toPoints()));
    };

    StepRangeAreaSegment.prototype.stackSegments = function stackSegments () {
        var fromSegments = this.fromSegments;
        if (!this.fromSegments) {
            fromSegments = this.fromSegments = this.segmentsFromPoints(this.calculateStepPoints(this.fromPoints()));
            fromSegments.reverse();
        }

        return fromSegments;
    };

    return StepRangeAreaSegment;
}(RangeAreaSegment));

deepExtend(StepRangeAreaSegment.prototype, StepLineMixin);

var RangeAreaChart = (function (CategoricalChart) {
    function RangeAreaChart () {
        CategoricalChart.apply(this, arguments);
    }

    if ( CategoricalChart ) RangeAreaChart.__proto__ = CategoricalChart;
    RangeAreaChart.prototype = Object.create( CategoricalChart && CategoricalChart.prototype );
    RangeAreaChart.prototype.constructor = RangeAreaChart;

    RangeAreaChart.prototype.render = function render () {
        CategoricalChart.prototype.render.call(this);

        this.renderSegments();
    };

    RangeAreaChart.prototype.pointType = function pointType () {
        return RangeAreaPoint;
    };

    RangeAreaChart.prototype.createPoint = function createPoint (data, fields) {
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var value = data.valueFields;

        if (!hasValue$2(value.from) && !hasValue$2(value.to)) {
            if (this.seriesMissingValues(series) === ZERO) {
                value = {
                    from: 0,
                    to: 0
                };
            } else {
                return null;
            }
        }

        var pointOptions = this.pointOptions(series, seriesIx);
        pointOptions = this.evalPointOptions(pointOptions, value, fields);

        var color = data.fields.color || series.color;
        if (isFunction(series.color)) {
            color = pointOptions.color;
        }

        var point = new RangeAreaPoint(value, pointOptions);
        point.color = color;

        this.append(point);

        return point;
    };

    RangeAreaChart.prototype.createSegment = function createSegment (linePoints, currentSeries, seriesIx) {
        var style = (currentSeries.line || {}).style;
        var segmentType;
        if (style === "smooth") {
            segmentType = SplineRangeAreaSegment;
        } else if (style === "step") {
            segmentType = StepRangeAreaSegment;
        } else {
            segmentType = RangeAreaSegment;
        }

        return new segmentType(linePoints, currentSeries, seriesIx);
    };

    RangeAreaChart.prototype.plotRange = function plotRange (point, startValue) {
        if (!point) {
            return [ startValue, startValue ];
        }

        return [ point.value.from, point.value.to ];
    };

    RangeAreaChart.prototype.valueSlot = function valueSlot (valueAxis, plotRange) {
        var fromSlot = valueAxis.getSlot(plotRange[0], plotRange[0], !this.options.clip);
        var toSlot = valueAxis.getSlot(plotRange[1], plotRange[1], !this.options.clip);
        if (fromSlot && toSlot) {
            return {
                from: fromSlot,
                to: toSlot
            };
        }
    };

    RangeAreaChart.prototype.pointSlot = function pointSlot (categorySlot, valueSlot) {
        var from = valueSlot.from;
        var to = valueSlot.to;
        var fromSlot, toSlot;

        if (this.options.invertAxes) {
            fromSlot = new Box(from.x1, categorySlot.y1, from.x2, categorySlot.y2);
            toSlot = new Box(to.x1, categorySlot.y1, to.x2, categorySlot.y2);
        } else {
            fromSlot = new Box(categorySlot.x1, from.y1, categorySlot.x2, from.y2);
            toSlot = new Box(categorySlot.x1, to.y1, categorySlot.x2, to.y2);
        }

        return {
            from: fromSlot,
            to: toSlot
        };
    };

    RangeAreaChart.prototype.addValue = function addValue (data, fields) {
        var valueFields = data.valueFields;
        if (!isNumber(valueFields.from)) {
            valueFields.from = valueFields.to;
        }

        if (!isNumber(valueFields.to)) {
            valueFields.to = valueFields.from;
        }

        CategoricalChart.prototype.addValue.call(this, data, fields);
    };

    RangeAreaChart.prototype.updateRange = function updateRange (value, fields) {
        if (value !== null && isNumber(value.from) && isNumber(value.to)) {
            var axisName = fields.series.axis;
            var axisRange = this.valueAxisRanges[axisName] = this.valueAxisRanges[axisName] || { min: MAX_VALUE, max: MIN_VALUE };
            var from = value.from;
            var to = value.to;

            axisRange.min = Math.min(axisRange.min, from, to);
            axisRange.max = Math.max(axisRange.max, from, to);
        }
    };

    RangeAreaChart.prototype.formatPointValue = function formatPointValue (point, format) {
        var value = point.value;

        return this.chartService.format.auto(format, value.from, value.to);
    };

    RangeAreaChart.prototype.animationPoints = function animationPoints () {
        var points = this.points;
        var result = [];
        for (var idx = 0; idx < points.length; idx++) {
            var point = points[idx];
            if (point) {
                result.push((point.fromPoint || {}).marker);
                result.push((point.toPoint || {}).marker);
            }
        }

        return result.concat(this._segments);
    };

    return RangeAreaChart;
}(CategoricalChart));

deepExtend(RangeAreaChart.prototype, LineChartMixin, ClipAnimationMixin);

var OHLCPoint = (function (Candlestick) {
    function OHLCPoint () {
        Candlestick.apply(this, arguments);
    }

    if ( Candlestick ) OHLCPoint.__proto__ = Candlestick;
    OHLCPoint.prototype = Object.create( Candlestick && Candlestick.prototype );
    OHLCPoint.prototype.constructor = OHLCPoint;

    OHLCPoint.prototype.reflow = function reflow (box) {
        var ref = this;
        var options = ref.options;
        var value = ref.value;
        var chart = ref.owner;
        var valueAxis = chart.seriesValueAxis(options);
        var oPoints = [];
        var cPoints = [];
        var lhPoints = [];

        var lhSlot = valueAxis.getSlot(value.low, value.high);
        var oSlot = valueAxis.getSlot(value.open, value.open);
        var cSlot = valueAxis.getSlot(value.close, value.close);

        oSlot.x1 = cSlot.x1 = lhSlot.x1 = box.x1;
        oSlot.x2 = cSlot.x2 = lhSlot.x2 = box.x2;

        var mid = lhSlot.center().x;

        oPoints.push([ oSlot.x1, oSlot.y1 ]);
        oPoints.push([ mid, oSlot.y1 ]);
        cPoints.push([ mid, cSlot.y1 ]);
        cPoints.push([ cSlot.x2, cSlot.y1 ]);
        lhPoints.push([ mid, lhSlot.y1 ]);
        lhPoints.push([ mid, lhSlot.y2 ]);

        this.lines = [
            oPoints, cPoints, lhPoints
        ];

        this.box = lhSlot.clone().wrap(oSlot.clone().wrap(cSlot));

        this.reflowNote();
    };

    OHLCPoint.prototype.createBody = function createBody () {};

    return OHLCPoint;
}(Candlestick));

var OHLCChart = (function (CandlestickChart) {
    function OHLCChart () {
        CandlestickChart.apply(this, arguments);
    }

    if ( CandlestickChart ) OHLCChart.__proto__ = CandlestickChart;
    OHLCChart.prototype = Object.create( CandlestickChart && CandlestickChart.prototype );
    OHLCChart.prototype.constructor = OHLCChart;

    OHLCChart.prototype.pointType = function pointType () {
        return OHLCPoint;
    };

    return OHLCChart;
}(CandlestickChart));

var WaterfallSegment = (function (ChartElement) {
    function WaterfallSegment(from, to, series) {
        ChartElement.call(this);

        this.from = from;
        this.to = to;
        this.series = series;
    }

    if ( ChartElement ) WaterfallSegment.__proto__ = ChartElement;
    WaterfallSegment.prototype = Object.create( ChartElement && ChartElement.prototype );
    WaterfallSegment.prototype.constructor = WaterfallSegment;

    WaterfallSegment.prototype.linePoints = function linePoints () {
        var from = this.from;
        var ref = this;
        var fromBox = ref.from.box;
        var toBox = ref.to.box;
        var points = [];

        if (from.isVertical) {
            var y = from.aboveAxis ? fromBox.y1 : fromBox.y2;
            points.push(
                [ fromBox.x1, y ],
                [ toBox.x2, y ]
            );
        } else {
            var x = from.aboveAxis ? fromBox.x2 : fromBox.x1;
            points.push(
                [ x, fromBox.y1 ],
                [ x, toBox.y2 ]
            );
        }

        return points;
    };

    WaterfallSegment.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        var line = this.series.line || {};

        var path = Path$7.fromPoints(this.linePoints(), {
            stroke: {
                color: line.color,
                width: line.width,
                opacity: line.opacity,
                dashType: line.dashType
            }
        });

        alignPathToPixel(path);
        this.visual.append(path);
    };

    return WaterfallSegment;
}(ChartElement));

setDefaultOptions(WaterfallSegment, {
    animation: {
        type: FADEIN,
        delay: INITIAL_ANIMATION_DURATION
    }
});

var WaterfallChart = (function (BarChart) {
    function WaterfallChart () {
        BarChart.apply(this, arguments);
    }

    if ( BarChart ) WaterfallChart.__proto__ = BarChart;
    WaterfallChart.prototype = Object.create( BarChart && BarChart.prototype );
    WaterfallChart.prototype.constructor = WaterfallChart;

    WaterfallChart.prototype.render = function render () {
        BarChart.prototype.render.call(this);
        this.createSegments();
    };

    WaterfallChart.prototype.traverseDataPoints = function traverseDataPoints (callback) {
        var this$1$1 = this;

        var series = this.options.series;
        var totalCategories = categoriesCount(series);
        var isVertical = !this.options.invertAxes;

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];
            var total = 0;
            var runningTotal = 0;

            for (var categoryIx = 0; categoryIx < totalCategories; categoryIx++) {
                var data = SeriesBinder.current.bindPoint(currentSeries, categoryIx);
                var value = data.valueFields.value;
                var summary = data.fields.summary;
                var from = total;
                var to = (void 0);

                if (summary) {
                    if (summary.toLowerCase() === "total") {
                        data.valueFields.value = total;
                        from = 0;
                        to = total;
                    } else {
                        data.valueFields.value = runningTotal;
                        to = from - runningTotal;
                        runningTotal = 0;
                    }
                } else if (isNumber(value)) {
                    runningTotal += value;
                    total += value;
                    to = total;
                }

                callback(data, {
                    category: this$1$1.categoryAxis.categoryAt(categoryIx),
                    categoryIx: categoryIx,
                    series: currentSeries,
                    seriesIx: seriesIx,
                    total: total,
                    runningTotal: runningTotal,
                    from: from,
                    to: to,
                    isVertical: isVertical
                });
            }
        }
    };

    WaterfallChart.prototype.updateRange = function updateRange (value, fields) {
        BarChart.prototype.updateRange.call(this, { value: fields.to }, fields);
    };

    WaterfallChart.prototype.aboveAxis = function aboveAxis (point) {
        return point.value >= 0;
    };

    WaterfallChart.prototype.plotRange = function plotRange (point) {
        return [ point.from, point.to ];
    };

    WaterfallChart.prototype.createSegments = function createSegments () {
        var this$1$1 = this;

        var series = this.options.series;
        var seriesPoints = this.seriesPoints;
        var segments = this.segments = [];

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];
            var points = seriesPoints[seriesIx];

            if (points) {
                var prevPoint = (void 0);
                for (var pointIx = 0; pointIx < points.length; pointIx++) {
                    var point = points[pointIx];

                    if (point && prevPoint) {
                        var segment = new WaterfallSegment(prevPoint, point, currentSeries);
                        segments.push(segment);
                        this$1$1.append(segment);
                    }

                    prevPoint = point;
                }
            }
        }
    };

    return WaterfallChart;
}(BarChart));

function trendlineFactory(registry, type, context) {
    var impl = registry[String(type)];
    if (impl) {
        return impl(context);
    }

    return null;
}

// Optimized version of calculatePolynomial for order = 1
function calculateSlope(sourceValues, valueGetter) {
    var x = 0;
    var y = 0;
    var x2 = 0;
    var xy = 0;
    var count = 0;
    var slope, intercept;
    var xMin = Number.MAX_VALUE;
    var xMax = Number.MIN_VALUE;

    for (var i = 0; i < sourceValues.length; i++) {
        var value = sourceValues[i];
        var ref = valueGetter(value);
        var xValue = ref.xValue;
        var yValue = ref.yValue;

        if (isFinite(xValue) && xValue !== null && isFinite(yValue) && yValue !== null) {
            xMin = Math.min(xValue, xMin);
            xMax = Math.max(xValue, xMax);

            count++;
            x += xValue;
            y += yValue;
            x2 += Math.pow(xValue, 2);
            xy += xValue * yValue;
        }
    }

    if (count > 0) {
        slope = (count * xy - x * y) / (count * x2 - Math.pow(x, 2));
        intercept = (y - slope * x) / count;
    }

    return { slope: slope, intercept: intercept, count: count, xMin: xMin, xMax: xMax };
}

var checkAllPositive = function (sourceValues, fieldName) { return sourceValues.every(function (ref) {
        var valueFields = ref.valueFields;

        return !hasValue$2(valueFields[fieldName]) || valueFields[fieldName] > 0;
        }); };

function getTrendlineData(valueMapper, categoryAxis) {
    var data = [];
    var totalRange = categoryAxis.totalRangeIndices();
    var currentRange = categoryAxis.currentRangeIndices();
    var range = {
        min: Math.floor(Math.max(currentRange.min - 1, totalRange.min)),
        max: Math.ceil(Math.min(currentRange.max + 2, totalRange.max))
    };

    for (var i = range.min; i < range.max; i++) {
        var x = (i + 1);
        data[i] = {
            category: categoryAxis.categoryAt(i, true),
            value: valueMapper(x)
        };
    }

    return data;
}

function exponentialTrendline(context) {
    var options = context.options;
    var categoryAxis = context.categoryAxis;
    var seriesValues = context.seriesValues;

    var data = getData$b({ seriesValues: seriesValues, categoryAxis: categoryAxis, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'line',
            data: data,
            categoryField: 'category',
            field: 'value'});
    }

    return null;
}

var valueGetter$8 = function (fieldName) { return function (ref) {
        var categoryIx = ref.categoryIx;
        var valueFields = ref.valueFields;

        return ({ xValue: categoryIx + 1, yValue: Math.log(valueFields[fieldName]) });
; }    };

function getData$b(ref) {
    var seriesValues = ref.seriesValues;
    var categoryAxis = ref.categoryAxis;
    var options = ref.options;

    var sourceValues = seriesValues();
    if (!checkAllPositive(sourceValues, options.field)) {
        return null;
    }

    var ref$1 = calculateSlope(sourceValues, valueGetter$8(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;
    if (count > 0) {
        // Exponential trendline equation:
        // y = a * e ^ (b * x)
        var a = Math.exp(intercept);
        var b = slope;

        return getTrendlineData(function (x) { return a * Math.exp(b * x); }, categoryAxis);
    }

    return null;
}

function linearTrendline(context) {
    var options = context.options;
    var categoryAxis = context.categoryAxis;
    var seriesValues = context.seriesValues;

    var data = getData$a({ seriesValues: seriesValues, categoryAxis: categoryAxis, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'line',
            data: data,
            categoryField: 'category',
            field: 'value'});
    }

    return null;
}

var valueGetter$7 = function (fieldName) { return function (ref) {
        var categoryIx = ref.categoryIx;
        var valueFields = ref.valueFields;

        return ({ xValue: categoryIx + 1, yValue: valueFields[fieldName] });
; }    };

function getData$a(ref) {
    var seriesValues = ref.seriesValues;
    var categoryAxis = ref.categoryAxis;
    var options = ref.options;

    var ref$1 = calculateSlope(seriesValues(), valueGetter$7(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;

    if (count > 0) {
        return getTrendlineData(function (x) { return slope * x + intercept; }, categoryAxis);
    }

    return null;
}

function logarithmicTrendline(context) {
    var options = context.options;
    var categoryAxis = context.categoryAxis;
    var seriesValues = context.seriesValues;

    var data = getData$9({ seriesValues: seriesValues, categoryAxis: categoryAxis, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'line',
            data: data,
            categoryField: 'category',
            field: 'value'});
    }

    return null;
}

var valueGetter$6 = function (fieldName) { return function (ref) {
        var categoryIx = ref.categoryIx;
        var valueFields = ref.valueFields;

        return ({ xValue: Math.log(categoryIx + 1), yValue: valueFields[fieldName] });
; }    };

function getData$9(ref) {
    var seriesValues = ref.seriesValues;
    var categoryAxis = ref.categoryAxis;
    var options = ref.options;

    var ref$1 = calculateSlope(seriesValues(), valueGetter$6(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;
    if (count > 0) {
        // Logarithmic trendline equation:
        // y = a * ln (x) + b
        var a = slope;
        var b = intercept;
        return getTrendlineData(function (x) { return a * Math.log(x) + b; }, categoryAxis);
    }

    return null;
}

function calculateMovingAverage(sourceValues, valueGetter, period) {
    var averagePoints = [];
    var values = [];
    var start = Math.max(MIN_MOVING_AVERAGE_PERIOD, period) - 1;

    var end = 0;
    var sum = 0;

    for (var i = 0; i < sourceValues.length; i++) {
        var value = sourceValues[i];
        var ref = valueGetter(value);
        var xValue = ref.xValue;
        var yValue = ref.yValue;

        if (isFinite(yValue) && yValue !== null) {
            values.push(yValue);
            sum += yValue;
            end = Math.max(i, end);
        } else {
            values.push(null);
        }

        if (i >= start) {
            var count = values.filter(function (value) { return value !== null; }).length;
            var lastValue = values.shift() || 0;

            if (count > 0) {
                var average = sum / count;
                averagePoints.push([xValue, average]);

                sum -= lastValue;
                continue;
            }
        }

        averagePoints.push([xValue, null]);
    }

    return averagePoints.slice(0, end + 1);
}

function movingAverageTrendline(context) {
    var options = context.options;

    var data = getData$8(context);
    if (data) {
        return Object.assign({}, options,

            {type: 'line',
            data: data,
            categoryField: 'category',
            field: 'value'});
    }

    return null;
}

var valueGetter$5 = function (fieldName) { return function (ref) {
        var categoryIx = ref.categoryIx;
        var valueFields = ref.valueFields;

        return ({ xValue: categoryIx, yValue: valueFields[fieldName] });
; }    };

function calculatePoints(ref) {
    var options = ref.options;
    var categoryAxis = ref.categoryAxis;
    var seriesValues = ref.seriesValues;

    var period = (options.trendline || {}).period || MIN_MOVING_AVERAGE_PERIOD;
    var totalRange = categoryAxis.totalRangeIndices();
    var currentRange = categoryAxis.currentRangeIndices();
    var range = {
        min: Math.floor(Math.max(currentRange.min - period, totalRange.min)),
        max: Math.ceil(Math.min(currentRange.max + period + 2, totalRange.max))
    };

    return calculateMovingAverage(seriesValues(range), valueGetter$5(options.field), period);
}

function getData$8(context) {
    var categoryAxis = context.categoryAxis;
    var points = calculatePoints(context);
    var data = [];
    points.forEach(function (ref) {
        var categoryIx = ref[0];
        var value = ref[1];

        data[categoryIx] = {
            category: categoryAxis.categoryAt(categoryIx, true),
            value: value
        };
    });

    if (data.length > 0) {
        return data;
    }

    return null;
}

var MIN_ORDER = 1;
var MAX_ORDER = 6;

function calculatePolynomial(sourceValues, valueGetter, order) {
    var k = Math.min(Math.max(order || MIN_ORDER, MIN_ORDER), MAX_ORDER) + 1;
    var X = new Matrix();
    var Y = new Matrix();
    var count = 0;
    var xMin = Number.MAX_VALUE;
    var xMax = Number.MIN_VALUE;
    var valueMapper = function (x) { return x; };
    var coefficients = [];

    for (var i = 0; i < sourceValues.length; i++) {
        var value = sourceValues[i];
        var ref = valueGetter(value);
        var xValue = ref.xValue;
        var yValue = ref.yValue;

        if (isFinite(xValue) && xValue !== null && isFinite(yValue) && yValue !== null) {
            xMin = Math.min(xValue, xMin);
            xMax = Math.max(xValue, xMax);
            count++;

            // Set Y value in matrix
            Y.set(i, 0, yValue);

            // Set indicator column to 1 for valid values
            X.set(i, 0, 1);
            X.set(i, 1, xValue);
            for (var pow = 2; pow <= k; pow++) {
                X.set(i, pow, Math.pow(X.get(i, 1), pow));
            }
        } else {
            // Set indicator column to 0 for missing values
            X.set(i, 0, 0);
        }
    }

    // Limit order to number of values.
    X.width = Math.min(k, count);

    if (count > 0) {
        // Polynomial trendline equation:
        // y = aN * x^N + ... + a2 * x^2 + a1 * x + a0
        coefficients = linearRegression(X, Y);
        valueMapper = function (x) { return coefficients.reduce(function (y, a, n) { return y + a * Math.pow(x, n); }, 0); };
    }

    return {
        coefficients: coefficients,
        count: count,
        valueMapper: valueMapper,
        xMin: xMin,
        xMax: xMax
    };
}

function linearRegression(X, Y) {
    var Xt = X.transpose();
    var B = Xt.multiply(X).inverse().multiply(Xt).multiply(Y); // the last square estimate of the coefficients

    var coefficients = [];
    for (var i = 0; i < B.height; i++) {
        coefficients.push(B.get(i, 0));
    }

    // y_intercept and regression coefficients ('slopes')
    return coefficients;

    // It's possible to calculate statistics for the regression based on
    // the LINEST function implementation in kendo-spreadsheet-common/src/calc.js
    //
    // * The standard errors (of coefficients and y-intercept)
    // * The coefficient of determination (R^2)
    // * The standard error for the y estimate
    // * The F statistic
    // * The degrees of freedom
    // * The regression sum of squares (SSR)
    // * The residual sum of squares (SSE)
}

function polynomialTrendline(context) {
    var options = context.options;
    var categoryAxis = context.categoryAxis;
    var seriesValues = context.seriesValues;

    var data = getData$7({ seriesValues: seriesValues, categoryAxis: categoryAxis, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'line',
            data: data,
            categoryField: 'category',
            field: 'value'});
    }

    return null;
}

var valueGetter$4 = function (fieldName) { return function (ref) {
        var categoryIx = ref.categoryIx;
        var valueFields = ref.valueFields;

        return ({ xValue: categoryIx + 1, yValue: valueFields[fieldName] });
; }    };

function getData$7(ref) {
    var seriesValues = ref.seriesValues;
    var categoryAxis = ref.categoryAxis;
    var options = ref.options;

    var order = (options.trendline || {}).order;
    var ref$1 = calculatePolynomial(seriesValues(), valueGetter$4(options.field), order);
    var count = ref$1.count;
    var valueMapper = ref$1.valueMapper;

    if (count > 0) {
        // Polynomial trendline equation:
        // y = aN * x^N + ... + a2 * x^2 + a1 * x + a0

        return getTrendlineData(function (x) { return valueMapper(x); }, categoryAxis);
    }

    return null;
}

function powerTrendline(context) {
    var options = context.options;
    var categoryAxis = context.categoryAxis;
    var seriesValues = context.seriesValues;

    var data = getData$6({ seriesValues: seriesValues, categoryAxis: categoryAxis, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'line',
            data: data,
            categoryField: 'category',
            field: 'value'});
    }

    return null;
}

var valueGetter$3 = function (fieldName) { return function (ref) {
        var categoryIx = ref.categoryIx;
        var valueFields = ref.valueFields;

        return ({ xValue: Math.log(categoryIx + 1), yValue: Math.log(valueFields[fieldName]) });
; }    };

function getData$6(ref) {
    var seriesValues = ref.seriesValues;
    var categoryAxis = ref.categoryAxis;
    var options = ref.options;

    var sourceValues = seriesValues();
    if (!checkAllPositive(sourceValues, options.field)) {
        return null;
    }

    var ref$1 = calculateSlope(sourceValues, valueGetter$3(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;
    if (count > 0) {
        // Power trendline equation:
        // y = a * x ^ b
        var a = Math.exp(intercept);
        var b = slope;

        return getTrendlineData(function (x) { return a * Math.pow(x, b); }, categoryAxis);
    }

    return null;
}

var registry = {};
registry[TRENDLINE_EXPONENTIAL] = exponentialTrendline;
registry[TRENDLINE_LINEAR] = linearTrendline;
registry[TRENDLINE_LOGARITHMIC] = logarithmicTrendline;
registry[TRENDLINE_MOVING_AVERAGE] = movingAverageTrendline;
registry[TRENDLINE_POLYNOMIAL] = polynomialTrendline;
registry[TRENDLINE_POWER] = powerTrendline;

var AREA_SERIES = [ AREA, VERTICAL_AREA, RANGE_AREA, VERTICAL_RANGE_AREA ];
var OUT_OF_RANGE_SERIES = [ LINE, VERTICAL_LINE ].concat(AREA_SERIES);

var CategoricalPlotArea = (function (PlotAreaBase) {
    function CategoricalPlotArea () {
        PlotAreaBase.apply(this, arguments);
    }

    if ( PlotAreaBase ) CategoricalPlotArea.__proto__ = PlotAreaBase;
    CategoricalPlotArea.prototype = Object.create( PlotAreaBase && PlotAreaBase.prototype );
    CategoricalPlotArea.prototype.constructor = CategoricalPlotArea;

    CategoricalPlotArea.prototype.initFields = function initFields (series) {
        var this$1$1 = this;

        this.namedCategoryAxes = {};
        this.namedValueAxes = {};
        this.valueAxisRangeTracker = new AxisGroupRangeTracker();
        this._seriesPointsCache = {};
        this._currentPointsCache = {};

        if (series.length > 0) {
            this.invertAxes = inArray(
                series[0].type, [ BAR, BULLET, VERTICAL_LINE, VERTICAL_AREA, VERTICAL_RANGE_AREA,
                    RANGE_BAR, HORIZONTAL_WATERFALL, VERTICAL_BOX_PLOT ]
            );

            for (var i = 0; i < series.length; i++) {
                var stack = series[i].stack;
                if (stack && stack.type === "100%") {
                    this$1$1.stack100 = true;
                    break;
                }
            }
        }
    };

    CategoricalPlotArea.prototype.render = function render (panes) {
        if ( panes === void 0 ) panes = this.panes;

        this.series = [].concat( this.originalSeries );
        this.createCategoryAxes(panes);

        this.aggregateCategories(panes);
        this.createTrendlineSeries(panes);

        this.createCategoryAxesLabels(panes);
        this.createCharts(panes);
        this.createValueAxes(panes);
    };

    CategoricalPlotArea.prototype.removeAxis = function removeAxis (axis) {
        var axisName = axis.options.name;

        PlotAreaBase.prototype.removeAxis.call(this, axis);

        if (axis instanceof CategoryAxis) {
            delete this.namedCategoryAxes[axisName];
        } else {
            this.valueAxisRangeTracker.reset(axisName);
            delete this.namedValueAxes[axisName];
        }

        if (axis === this.categoryAxis) {
            delete this.categoryAxis;
        }

        if (axis === this.valueAxis) {
            delete this.valueAxis;
        }
    };

    CategoricalPlotArea.prototype.trendlineFactory = function trendlineFactory$1 (options, series) {
        var categoryAxis = this.seriesCategoryAxis(options);
        var seriesValues = this.seriesValues.bind(this, series.index);

        var trendline = trendlineFactory(registry, options.type, {
            options: options,
            categoryAxis: categoryAxis,
            seriesValues: seriesValues
        });

        if (trendline) {
            // Inherit settings
            trendline.categoryAxis = series.categoryAxis;
            trendline.valueAxis = series.valueAxis;

            return this.filterSeries(trendline, categoryAxis);
        }

        return trendline;
    };

    CategoricalPlotArea.prototype.trendlineAggregateForecast = function trendlineAggregateForecast () {
        return this.series
            .map(function (series) { return (series.trendline || {}).forecast; })
            .filter(function (forecast) { return forecast !== undefined; })
            .reduce(function (result, forecast) { return ({
                before: Math.max(result.before, forecast.before || 0),
                after: Math.max(result.after, forecast.after || 0)
            }); }, { before: 0, after: 0 });
    };

    CategoricalPlotArea.prototype.seriesValues = function seriesValues (seriesIx, range) {
        var this$1$1 = this;

        var result = [];

        var series = this.srcSeries[seriesIx];
        var categoryAxis = this.seriesCategoryAxis(series);
        var dateAxis = equalsIgnoreCase(categoryAxis.options.type, DATE);
        if (dateAxis) {
            this._seriesPointsCache = {};
            this._currentPointsCache = {};
            categoryAxis.options.dataItems = [];
            series = this.aggregateSeries(series, categoryAxis, categoryAxis.totalRangeIndices());
        }

        var min = range ? range.min : 0;
        var max = range ? range.max : series.data.length;
        for (var categoryIx = min; categoryIx < max; categoryIx++) {
            var data = this$1$1.bindPoint(series, categoryIx);
            result.push({ categoryIx: categoryIx, category: data.fields.category, valueFields: data.valueFields });
        }

        return result;
    };

    CategoricalPlotArea.prototype.createCharts = function createCharts (panes) {
        var this$1$1 = this;

        var seriesByPane = this.groupSeriesByPane();

        for (var i = 0; i < panes.length; i++) {
            var pane = panes[i];
            var paneSeries = seriesByPane[pane.options.name || "default"] || [];
            this$1$1.addToLegend(paneSeries);

            var visibleSeries = this$1$1.filterVisibleSeries(paneSeries);
            if (!visibleSeries) {
                continue;
            }

            var groups = this$1$1.groupSeriesByCategoryAxis(visibleSeries);
            for (var groupIx = 0; groupIx < groups.length; groupIx++) {
                this$1$1.createChartGroup(groups[groupIx], pane);
            }
        }
    };

    CategoricalPlotArea.prototype.createChartGroup = function createChartGroup (series, pane) {
        this.createAreaChart(
            filterSeriesByType(series, [ AREA, VERTICAL_AREA ]), pane
        );

        this.createRangeAreaChart(
            filterSeriesByType(series, [ RANGE_AREA, VERTICAL_RANGE_AREA ]), pane
        );

        this.createBarChart(
            filterSeriesByType(series, [ COLUMN, BAR ]), pane
        );

        this.createRangeBarChart(
            filterSeriesByType(series, [ RANGE_COLUMN, RANGE_BAR ]), pane
        );

        this.createBulletChart(
            filterSeriesByType(series, [ BULLET, VERTICAL_BULLET ]), pane
        );

        this.createCandlestickChart(
            filterSeriesByType(series, CANDLESTICK), pane
        );

        this.createBoxPlotChart(
            filterSeriesByType(series, [ BOX_PLOT, VERTICAL_BOX_PLOT ]), pane
        );

        this.createOHLCChart(
            filterSeriesByType(series, OHLC), pane
        );

        this.createWaterfallChart(
            filterSeriesByType(series, [ WATERFALL, HORIZONTAL_WATERFALL ]), pane
        );

        this.createLineChart(
            filterSeriesByType(series, [ LINE, VERTICAL_LINE ]), pane
        );
    };

    CategoricalPlotArea.prototype.aggregateCategories = function aggregateCategories (panes) {
        var this$1$1 = this;

        var series = [].concat( this.series );
        var processedSeries = [];
        this._currentPointsCache = {};
        this._seriesPointsCache = this._seriesPointsCache || {};

        for (var i = 0; i < series.length; i++) {
            var currentSeries = series[i];

            if (!this$1$1.isTrendline(currentSeries)) {
                var categoryAxis = this$1$1.seriesCategoryAxis(currentSeries);
                var axisPane = this$1$1.findPane(categoryAxis.options.pane);
                var dateAxis = equalsIgnoreCase(categoryAxis.options.type, DATE);

                if ((dateAxis || currentSeries.categoryField) && inArray(axisPane, panes)) {
                    currentSeries = this$1$1.aggregateSeries(currentSeries, categoryAxis, categoryAxis.currentRangeIndices());
                } else {
                    currentSeries = this$1$1.filterSeries(currentSeries, categoryAxis);
                }
            }

            processedSeries.push(currentSeries);
        }

        this._seriesPointsCache = this._currentPointsCache;
        this._currentPointsCache = null;

        this.srcSeries = series;
        this.series = processedSeries;
    };

    CategoricalPlotArea.prototype.filterSeries = function filterSeries (series, categoryAxis) {
        var dataLength = (series.data || {}).length;
        categoryAxis._seriesMax = Math.max(categoryAxis._seriesMax || 0, dataLength);

        if (!(defined(categoryAxis.options.min) || defined(categoryAxis.options.max))) {
            return series;
        }

        var range = categoryAxis.currentRangeIndices();
        var outOfRangePoints = inArray(series.type, OUT_OF_RANGE_SERIES);
        var currentSeries = deepExtend({}, series);

        currentSeries.data = (currentSeries.data || []).slice(range.min, range.max + 1);

        if (outOfRangePoints) {
            createOutOfRangePoints(currentSeries, range, dataLength, function (idx) { return ({
                item: series.data[idx],
                category: categoryAxis.categoryAt(idx, true),
                categoryIx: idx - range.min
            }); }, function (idx) { return defined(series.data[idx]); });
        }

        return currentSeries;
    };

    CategoricalPlotArea.prototype.clearSeriesPointsCache = function clearSeriesPointsCache () {
        this._seriesPointsCache = {};
    };

    CategoricalPlotArea.prototype.seriesSourcePoints = function seriesSourcePoints (series, categoryAxis) {
        var this$1$1 = this;

        var key = (series.index) + ";" + (categoryAxis.categoriesHash());
        if (this._seriesPointsCache && this._seriesPointsCache[key]) {
            this._currentPointsCache[key] = this._seriesPointsCache[key];
            return this._seriesPointsCache[key];
        }

        var axisOptions = categoryAxis.options;
        var srcCategories = axisOptions.srcCategories;
        var dateAxis = equalsIgnoreCase(axisOptions.type, DATE);
        var srcData = series.data;
        var result = [];
        if (!dateAxis) {
            categoryAxis.indexCategories();
        }

        for (var idx = 0; idx < srcData.length; idx++) {
            var category = SeriesBinder.current.bindPoint(series, idx).fields.category;
            if (dateAxis) {
                category = parseDateCategory(category, srcData[idx], this$1$1.chartService.intl);
            }

            if (!defined(category)) {
                category = srcCategories[idx];
            }

            if (defined(category) && category !== null) {
                var categoryIx = categoryAxis.totalIndex(category);
                result[categoryIx] = result[categoryIx] || { items: [], category: category };
                result[categoryIx].items.push(idx);
            }
        }

        this._currentPointsCache[key] = result;

        return result;
    };

    CategoricalPlotArea.prototype.aggregateSeries = function aggregateSeries (series, categoryAxis, range) {
        var srcData = series.data;
        if (!srcData.length) {
            return series;
        }

        var srcPoints = this.seriesSourcePoints(series, categoryAxis);
        var result = deepExtend({}, series);
        var aggregator = new SeriesAggregator(deepExtend({}, series), SeriesBinder.current, DefaultAggregates.current);
        var data = result.data = [];

        var dataItems = categoryAxis.options.dataItems || [];

        var categoryItem = function (idx) {
            var categoryIdx = idx - range.min;
            var point = srcPoints[idx];
            if (!point) {
                point = srcPoints[idx] = {};
            }

            point.categoryIx = categoryIdx;

            if (!point.item) {
                var category = categoryAxis.categoryAt(idx, true);
                point.category = category;
                point.item = aggregator.aggregatePoints(point.items, category);
            }

            return point;
        };

        for (var idx = range.min; idx <= range.max; idx++) {
            var point = categoryItem(idx);
            data[point.categoryIx] = point.item;

            if (point.items && point.items.length) {
                dataItems[point.categoryIx] = point.item;
            }
        }

        if (inArray(result.type, OUT_OF_RANGE_SERIES)) {
            createOutOfRangePoints(result, range, categoryAxis.totalCount(), categoryItem, function (idx) { return srcPoints[idx]; });
        }

        categoryAxis.options.dataItems = dataItems;

        return result;
    };

    CategoricalPlotArea.prototype.appendChart = function appendChart (chart, pane) {
        var series = chart.options.series;
        var categoryAxis = this.seriesCategoryAxis(series[0]);
        var categories = categoryAxis.options.categories;
        var categoriesToAdd = Math.max(0, categoriesCount(series) - categories.length);

        if (categoriesToAdd > 0) {//consider setting an option to axis instead of adding fake categories
            categories = categoryAxis.options.categories = categoryAxis.options.categories.slice(0);
            while (categoriesToAdd--) {
                categories.push("");
            }
        }

        this.valueAxisRangeTracker.update(chart.valueAxisRanges);

        PlotAreaBase.prototype.appendChart.call(this, chart, pane);
    };

    // TODO: Refactor, optionally use series.pane option
    CategoricalPlotArea.prototype.seriesPaneName = function seriesPaneName (series) {
        var options = this.options;
        var axisName = series.axis;
        var axisOptions = [].concat(options.valueAxis);
        var axis = grep(axisOptions, function(a) { return a.name === axisName; })[0];
        var panes = options.panes || [ {} ];
        var defaultPaneName = (panes[0] || {}).name || "default";
        var paneName = (axis || {}).pane || defaultPaneName;

        return paneName;
    };

    CategoricalPlotArea.prototype.seriesCategoryAxis = function seriesCategoryAxis (series) {
        var axisName = series.categoryAxis;
        var axis = axisName ? this.namedCategoryAxes[axisName] : this.categoryAxis;

        if (!axis) {
            throw new Error("Unable to locate category axis with name " + axisName);
        }

        return axis;
    };

    CategoricalPlotArea.prototype.stackableChartOptions = function stackableChartOptions (series, pane) {
        var anyStackedSeries = series.some(function (s) { return s.stack; });
        var isStacked100 = series.some(function (s) { return s.stack && s.stack.type === "100%"; });
        var clip = pane.options.clip;

        return {
            defaultStack: series[0].stack,
            isStacked: anyStackedSeries,
            isStacked100: isStacked100,
            clip: clip
        };
    };

    CategoricalPlotArea.prototype.groupSeriesByCategoryAxis = function groupSeriesByCategoryAxis (series) {
        var categoryAxes = [];
        var unique = {};
        for (var idx = 0; idx < series.length; idx++) {
            var name = series[idx].categoryAxis || "$$default$$";
            if (!hasOwnProperty(unique, name)) {
                unique[name] = true;
                categoryAxes.push(name);
            }
        }

        var groups = [];
        for (var axisIx = 0; axisIx < categoryAxes.length; axisIx++) {
            var axis = categoryAxes[axisIx];
            var axisSeries = groupSeries(series, axis, axisIx);
            if (axisSeries.length === 0) {
                continue;
            }

            groups.push(axisSeries);
        }

        return groups;
    };

    CategoricalPlotArea.prototype.createBarChart = function createBarChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var barChart = new BarChart(this, Object.assign({
            series: series,
            invertAxes: this.invertAxes,
            gap: firstSeries.gap,
            spacing: firstSeries.spacing
        }, this.stackableChartOptions(series, pane)));

        this.appendChart(barChart, pane);
    };

    CategoricalPlotArea.prototype.createRangeBarChart = function createRangeBarChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var rangeColumnChart = new RangeBarChart(this, {
            series: series,
            invertAxes: this.invertAxes,
            gap: firstSeries.gap,
            spacing: firstSeries.spacing
        });

        this.appendChart(rangeColumnChart, pane);
    };

    CategoricalPlotArea.prototype.createBulletChart = function createBulletChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var bulletChart = new BulletChart(this, {
            series: series,
            invertAxes: this.invertAxes,
            gap: firstSeries.gap,
            spacing: firstSeries.spacing,
            clip: pane.options.clip
        });

        this.appendChart(bulletChart, pane);
    };

    CategoricalPlotArea.prototype.createLineChart = function createLineChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var lineChart = new LineChart(this, Object.assign({
            invertAxes: this.invertAxes,
            series: series
        }, this.stackableChartOptions(series, pane)));

        this.appendChart(lineChart, pane);
    };

    CategoricalPlotArea.prototype.createAreaChart = function createAreaChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var areaChart = new AreaChart(this, Object.assign({
            invertAxes: this.invertAxes,
            series: series
        }, this.stackableChartOptions(series, pane)));

        this.appendChart(areaChart, pane);
    };

    CategoricalPlotArea.prototype.createRangeAreaChart = function createRangeAreaChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var rangeAreaChart = new RangeAreaChart(this, {
            invertAxes: this.invertAxes,
            series: series,
            clip: pane.options.clip
        });

        this.appendChart(rangeAreaChart, pane);
    };

    CategoricalPlotArea.prototype.createOHLCChart = function createOHLCChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var chart = new OHLCChart(this, {
            invertAxes: this.invertAxes,
            gap: firstSeries.gap,
            series: series,
            spacing: firstSeries.spacing,
            clip: pane.options.clip
        });

        this.appendChart(chart, pane);
    };

    CategoricalPlotArea.prototype.createCandlestickChart = function createCandlestickChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var chart = new CandlestickChart(this, {
            invertAxes: this.invertAxes,
            gap: firstSeries.gap,
            series: series,
            spacing: firstSeries.spacing,
            clip: pane.options.clip
        });

        this.appendChart(chart, pane);
    };

    CategoricalPlotArea.prototype.createBoxPlotChart = function createBoxPlotChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var chart = new BoxPlotChart(this, {
            invertAxes: this.invertAxes,
            gap: firstSeries.gap,
            series: series,
            spacing: firstSeries.spacing,
            clip: pane.options.clip
        });

        this.appendChart(chart, pane);
    };

    CategoricalPlotArea.prototype.createWaterfallChart = function createWaterfallChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var waterfallChart = new WaterfallChart(this, {
            series: series,
            invertAxes: this.invertAxes,
            gap: firstSeries.gap,
            spacing: firstSeries.spacing
        });

        this.appendChart(waterfallChart, pane);
    };

    CategoricalPlotArea.prototype.axisRequiresRounding = function axisRequiresRounding (categoryAxisName, categoryAxisIndex) {
        var this$1$1 = this;

        var centeredSeries = filterSeriesByType(this.series, EQUALLY_SPACED_SERIES);

        for (var seriesIx = 0; seriesIx < this.series.length; seriesIx++) {
            var currentSeries = this$1$1.series[seriesIx];
            if (inArray(currentSeries.type, AREA_SERIES)) {
                var line = currentSeries.line;
                if (line && line.style === STEP) {
                    centeredSeries.push(currentSeries);
                }
            }
        }

        for (var seriesIx$1 = 0; seriesIx$1 < centeredSeries.length; seriesIx$1++) {
            var seriesAxis = centeredSeries[seriesIx$1].categoryAxis || "";
            if (seriesAxis === categoryAxisName || (!seriesAxis && categoryAxisIndex === 0)) {
                return true;
            }
        }
    };

    CategoricalPlotArea.prototype.aggregatedAxis = function aggregatedAxis (categoryAxisName, categoryAxisIndex) {
        var series = this.series;

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var seriesAxis = series[seriesIx].categoryAxis || "";
            if ((seriesAxis === categoryAxisName || (!seriesAxis && categoryAxisIndex === 0)) && series[seriesIx].categoryField) {
                return true;
            }
        }
    };

    CategoricalPlotArea.prototype.createCategoryAxesLabels = function createCategoryAxesLabels () {
        var axes = this.axes;
        for (var i = 0; i < axes.length; i++) {
            if (axes[i] instanceof CategoryAxis) {
                axes[i].createLabels();
            }
        }
    };

    CategoricalPlotArea.prototype.createCategoryAxes = function createCategoryAxes (panes) {
        var this$1$1 = this;

        var invertAxes = this.invertAxes;
        var definitions = [].concat(this.options.categoryAxis);
        var axes = [];

        for (var i = 0; i < definitions.length; i++) {
            var axisOptions = definitions[i];
            var axisPane = this$1$1.findPane(axisOptions.pane);

            if (inArray(axisPane, panes)) {
                var name = axisOptions.name;
                var categories = axisOptions.categories; if ( categories === void 0 ) categories = [];
                axisOptions = deepExtend({
                    vertical: invertAxes,
                    reverse: !invertAxes && this$1$1.chartService.rtl,
                    axisCrossingValue: invertAxes ? MAX_VALUE : 0
                }, axisOptions);

                if (!defined(axisOptions.justified)) {
                    axisOptions.justified = this$1$1.isJustified();
                }

                if (this$1$1.axisRequiresRounding(name, i)) {
                    axisOptions.justified = false;
                }

                var categoryAxis = (void 0);

                if (isDateAxis(axisOptions, categories[0])) {
                    axisOptions._forecast = this$1$1.trendlineAggregateForecast();
                    categoryAxis = new DateCategoryAxis(axisOptions, this$1$1.chartService);
                } else {
                    categoryAxis = new CategoryAxis(axisOptions, this$1$1.chartService);
                }

                definitions[i].categories = categoryAxis.options.srcCategories;

                if (name) {
                    if (this$1$1.namedCategoryAxes[name]) {
                        throw new Error(("Category axis with name " + name + " is already defined"));
                    }
                    this$1$1.namedCategoryAxes[name] = categoryAxis;
                }

                categoryAxis.axisIndex = i;
                axes.push(categoryAxis);
                this$1$1.appendAxis(categoryAxis);
            }
        }

        var primaryAxis = this.categoryAxis || axes[0];
        this.categoryAxis = primaryAxis;

        if (invertAxes) {
            this.axisY = primaryAxis;
        } else {
            this.axisX = primaryAxis;
        }
    };

    CategoricalPlotArea.prototype.isJustified = function isJustified () {
        var series = this.series;

        for (var i = 0; i < series.length; i++) {
            var currentSeries = series[i];
            if (!inArray(currentSeries.type, AREA_SERIES)) {
                return false;
            }
        }

        return true;
    };

    CategoricalPlotArea.prototype.createValueAxes = function createValueAxes (panes) {
        var this$1$1 = this;

        var tracker = this.valueAxisRangeTracker;
        var defaultRange = tracker.query();
        var definitions = [].concat(this.options.valueAxis);
        var invertAxes = this.invertAxes;
        var baseOptions = { vertical: !invertAxes, reverse: invertAxes && this.chartService.rtl };
        var axes = [];

        if (this.stack100) {
            baseOptions.roundToMajorUnit = false;
            baseOptions.labels = { format: "P0" };
        }

        for (var i = 0; i < definitions.length; i++) {
            var axisOptions = definitions[i];
            var axisPane = this$1$1.findPane(axisOptions.pane);

            if (inArray(axisPane, panes)) {
                var name = axisOptions.name;
                var defaultAxisRange = equalsIgnoreCase(axisOptions.type, LOGARITHMIC) ? { min: 0.1, max: 1 } : { min: 0, max: 1 };
                var range = tracker.query(name) || defaultRange || defaultAxisRange;

                if (i === 0 && range && defaultRange) {
                    range.min = Math.min(range.min, defaultRange.min);
                    range.max = Math.max(range.max, defaultRange.max);
                }

                var axisType = (void 0);
                if (equalsIgnoreCase(axisOptions.type, LOGARITHMIC)) {
                    axisType = LogarithmicAxis;
                } else {
                    axisType = NumericAxis;
                }

                var valueAxis = new axisType(range.min, range.max,
                    deepExtend({}, baseOptions, axisOptions),
                    this$1$1.chartService
                );

                if (name) {
                    if (this$1$1.namedValueAxes[name]) {
                        throw new Error(("Value axis with name " + name + " is already defined"));
                    }
                    this$1$1.namedValueAxes[name] = valueAxis;
                }
                valueAxis.axisIndex = i;

                axes.push(valueAxis);
                this$1$1.appendAxis(valueAxis);
            }
        }

        var primaryAxis = this.valueAxis || axes[0];
        this.valueAxis = primaryAxis;

        if (invertAxes) {
            this.axisX = primaryAxis;
        } else {
            this.axisY = primaryAxis;
        }
    };

    CategoricalPlotArea.prototype._dispatchEvent = function _dispatchEvent (chart, e, eventType) {
        var coords = chart._eventCoordinates(e);
        var point = new Point$5(coords.x, coords.y);
        var pane = this.pointPane(point);
        var categories = [];
        var values = [];

        if (!pane) {
            return;
        }

        var allAxes = pane.axes;
        for (var i = 0; i < allAxes.length; i++) {
            var axis = allAxes[i];
            if (axis.getValue) {
                appendIfNotNull(values, axis.getValue(point));
            } else {
                appendIfNotNull(categories, axis.getCategory(point));
            }
        }

        if (categories.length === 0) {
            appendIfNotNull(categories, this.categoryAxis.getCategory(point));
        }

        if (categories.length > 0 && values.length > 0) {
            chart.trigger(eventType, {
                element: eventElement(e),
                originalEvent: e,
                category: singleItemOrArray(categories),
                value: singleItemOrArray(values)
            });
        }
    };

    CategoricalPlotArea.prototype.pointPane = function pointPane (point) {
        var panes = this.panes;

        for (var i = 0; i < panes.length; i++) {
            var currentPane = panes[i];
            if (currentPane.contentBox.containsPoint(point)) {
                return currentPane;
            }
        }
    };

    CategoricalPlotArea.prototype.updateAxisOptions = function updateAxisOptions$1 (axis, options) {
        updateAxisOptions$2(this.options, axis, options);
        updateAxisOptions$2(this.originalOptions, axis, options);
    };

    CategoricalPlotArea.prototype._pointsByVertical = function _pointsByVertical (basePoint, offset) {
        if ( offset === void 0 ) offset = 0;

        if (this.invertAxes) {
            return this._siblingsBySeriesIndex(basePoint.series.index, offset);
        }

        return this._siblingsByPointIndex(basePoint.getIndex());
    };

    CategoricalPlotArea.prototype._pointsByHorizontal = function _pointsByHorizontal (basePoint, offset) {
        if ( offset === void 0 ) offset = 0;

        if (this.invertAxes) {
            return this._siblingsByPointIndex(basePoint.getIndex());
        }

        var siblings = this._siblingsBySeriesIndex(basePoint.series.index, offset);

        if (this.chartService.rtl) {
            return siblings.reverse();
        }

        return siblings;
    };

    CategoricalPlotArea.prototype._siblingsByPointIndex = function _siblingsByPointIndex (pointIndex) {
        var this$1$1 = this;

        var charts = this.charts;
        var result = [];

        for (var i = 0; i < charts.length; i++) {
            var chart = charts[i];

            if (chart.pane && chart.pane.options.name === "_navigator") {
                continue;
            }

            var chartPoints = chart.points
                .filter(function (point) { return point && point.visible !== false && point.getIndex() === pointIndex; }
                );

            result.push.apply(result, chartPoints.sort(this$1$1._getSeriesCompareFn(chartPoints[0])));
        }

        return result;
    };

    CategoricalPlotArea.prototype._siblingsBySeriesIndex = function _siblingsBySeriesIndex (seriesIndex, offset) {
        var index = cycleIndex(seriesIndex + offset, this.series.length);

        return this.pointsBySeriesIndex(index);
    };

    CategoricalPlotArea.prototype._getSeriesCompareFn = function _getSeriesCompareFn (point) {
        var isStacked = this._isInStackedSeries(point);

        if (isStacked && this.invertAxes || !isStacked && !this.invertAxes) {
            return function (a, b) { return a.box.center().x - b.box.center().x; };
        }

        return function (a, b) { return a.box.center().y - b.box.center().y; };
    };

    CategoricalPlotArea.prototype._isInStackedSeries = function _isInStackedSeries (point) {
        var sortableSeries = inArray(point.series.type,
            [ AREA, VERTICAL_AREA, RANGE_AREA, VERTICAL_RANGE_AREA, LINE, VERTICAL_LINE, RADAR_LINE, RADAR_AREA]);

        var stackableSeries = inArray(point.series.type, [ COLUMN, BAR]);

        return sortableSeries || stackableSeries && point.options.isStacked;
    };

    return CategoricalPlotArea;
}(PlotAreaBase));

function updateAxisOptions$2(targetOptions, axis, options) {
    var axesOptions = axis instanceof CategoryAxis ? [].concat(targetOptions.categoryAxis) : [].concat(targetOptions.valueAxis);
    deepExtend(axesOptions[axis.axisIndex], options);
}

function groupSeries(series, axis, axisIx) {
    return grep(series, function(s) {
        return (axisIx === 0 && !s.categoryAxis) || (s.categoryAxis === axis);
    });
}

setDefaultOptions(CategoricalPlotArea, {
    categoryAxis: {},
    valueAxis: {}
});

deepExtend(CategoricalPlotArea.prototype, PlotAreaEventsMixin);

var Highlight = (function (Class) {
    function Highlight() {
        Class.call(this);

        this._points = [];
    }

    if ( Class ) Highlight.__proto__ = Class;
    Highlight.prototype = Object.create( Class && Class.prototype );
    Highlight.prototype.constructor = Highlight;

    Highlight.prototype.destroy = function destroy () {
        this._points = [];
    };

    Highlight.prototype.show = function show (points, opacity) {
        var this$1$1 = this;

        var arrayPoints = [].concat(points);
        this.hide();

        for (var i = 0; i < arrayPoints.length; i++) {
            var point = arrayPoints[i];
            if (point && point.toggleHighlight && point.hasHighlight()) {
                this$1$1.togglePointHighlight(point, true, opacity);
                this$1$1._points.push(point);
            }
        }
    };

    Highlight.prototype.togglePointHighlight = function togglePointHighlight (point, show, opacity) {
        var toggleHandler = (point.options.highlight || {}).toggle;
        if (toggleHandler) {
            var eventArgs = {
                category: point.category,
                series: point.series,
                dataItem: point.dataItem,
                value: point.value,
                stackValue: point.stackValue,
                preventDefault: preventDefault,
                visual: point.highlightVisual(),
                show: show
            };
            toggleHandler(eventArgs);
            if (!eventArgs._defaultPrevented) {
                point.toggleHighlight(show, opacity);
            }
        } else {
            point.toggleHighlight(show, opacity);
        }
    };

    Highlight.prototype.hide = function hide () {
        var this$1$1 = this;

        var points = this._points;
        while (points.length) {
            this$1$1.togglePointHighlight(points.pop(), false);
        }
    };

    Highlight.prototype.isHighlighted = function isHighlighted (element) {
        var points = this._points;

        for (var i = 0; i < points.length; i++) {
            var point = points[i];
            if (element === point) {
                return true;
            }
        }

        return false;
    };

    return Highlight;
}(Class));

function preventDefault() {
    this._defaultPrevented = true;
}

function acceptKey(e, mouseKey) {
    var key = (mouseKey || "").toLowerCase();
    var event = e.event;
    var accept = (key === "none" && !(event.ctrlKey || event.shiftKey || event.altKey)) || event[key + "Key"];

    return accept;
}

function toChartAxisRanges(axisRanges) {
    var ranges = {};
    for (var idx = 0; idx < axisRanges.length; idx++) {
        var axisRange = axisRanges[idx];
        if (axisRange.axis.options.name) {
            ranges[axisRange.axis.options.name] = {
                min: axisRange.range.min,
                max: axisRange.range.max
            };
        }
    }
    return ranges;
}

var Pannable = (function (Class) {
    function Pannable(plotArea, options) {
        Class.call(this);

        this.plotArea = plotArea;
        this.options = deepExtend({}, this.options, options);
    }

    if ( Class ) Pannable.__proto__ = Class;
    Pannable.prototype = Object.create( Class && Class.prototype );
    Pannable.prototype.constructor = Pannable;

    Pannable.prototype.start = function start (e) {
        this._active = acceptKey(e, this.options.key);
        return this._active;
    };

    Pannable.prototype.move = function move (e) {
        if (this._active) {
            var axisRanges = this.axisRanges = this._panAxes(e, X).concat(this._panAxes(e, Y));
            if (axisRanges.length) {
                this.axisRanges = axisRanges;
                return toChartAxisRanges(axisRanges);
            }
        }
    };

    Pannable.prototype.end = function end () {
        var active = this._active;
        this._active = false;

        return active;
    };

    Pannable.prototype.pan = function pan () {
        var ref = this;
        var plotArea = ref.plotArea;
        var axisRanges = ref.axisRanges;
        if (axisRanges.length) {
            for (var idx = 0; idx < axisRanges.length; idx++) {
                var range = axisRanges[idx];
                plotArea.updateAxisOptions(range.axis, range.range);
            }
            plotArea.redraw(plotArea.panes);
        }
    };

    Pannable.prototype.destroy = function destroy () {
        delete this.plotArea;
    };

    Pannable.prototype._panAxes = function _panAxes (e, position) {
        var plotArea = this.plotArea;
        var delta = -e[position].delta;
        var lock = (this.options.lock || "").toLowerCase();
        var updatedAxes = [];

        if (delta !== 0 && (lock || "").toLowerCase() !== position) {
            var axes = plotArea.axes;
            for (var idx = 0; idx < axes.length; idx++) {
                var axis = axes[idx];

                if (position === X && !axis.options.vertical || position === Y && axis.options.vertical) {
                    var range = axis.pan(delta);

                    if (range) {
                        range.limitRange = true;
                        updatedAxes.push({
                            axis: axis,
                            range: range
                        });
                    }
                }
            }
        }

        return updatedAxes;
    };

    return Pannable;
}(Class));

Pannable.prototype.options = {
    key: "none",
    lock: "none"
};

var ZoomSelection = (function (Class) {
    function ZoomSelection(chart, options) {
        Class.call(this);

        this.chart = chart;
        this.options = deepExtend({}, this.options, options);
        this.createElement();
    }

    if ( Class ) ZoomSelection.__proto__ = Class;
    ZoomSelection.prototype = Object.create( Class && Class.prototype );
    ZoomSelection.prototype.constructor = ZoomSelection;

    ZoomSelection.prototype.createElement = function createElement () {
        var marquee = this._marquee = document.createElement("div");
        marquee.className = "k-marquee";
        var marqueeColor = document.createElement("div");
        marqueeColor.className = "k-marquee-color";
        marquee.appendChild(marqueeColor);
    };

    ZoomSelection.prototype.removeElement = function removeElement () {
        if (this._marquee.parentNode) {
            this._marquee.parentNode.removeChild(this._marquee);
        }
    };

    ZoomSelection.prototype.setStyles = function setStyles (styles) {
        elementStyles$1(this._marquee, styles);
    };

    ZoomSelection.prototype.start = function start (e) {
        if (acceptKey(e, this.options.key)) {
            var chart = this.chart;
            var point = chart._eventCoordinates(e);
            var zoomPane = this._zoomPane = chart._plotArea.paneByPoint(point);
            var clipBox = zoomPane ? zoomPane.chartsBox().clone() : null;

            if (zoomPane && clipBox) {
                var offset = this._elementOffset();

                clipBox.translate(offset.left, offset.top);
                this._zoomPaneClipBox = clipBox;

                document.body.appendChild(this._marquee);
                this.setStyles({
                    left: e.pageX + 1,
                    top: e.pageY + 1,
                    width: 0,
                    height: 0
                });

                return true;
            }
        }
        return false;
    };

    ZoomSelection.prototype._elementOffset = function _elementOffset () {
        var chartElement = this.chart.element;
        var ref = elementStyles$1(chartElement, [ "paddingLeft", "paddingTop" ]);
        var paddingLeft = ref.paddingLeft;
        var paddingTop = ref.paddingTop;
        var offset = elementOffset(chartElement);

        return {
            left: paddingLeft + offset.left,
            top: paddingTop + offset.top
        };
    };

    ZoomSelection.prototype.move = function move (e) {
        var zoomPane = this._zoomPane;
        if (zoomPane) {
            this.setStyles(this._selectionPosition(e));
        }
    };

    ZoomSelection.prototype.end = function end (e) {
        var zoomPane = this._zoomPane;
        if (zoomPane) {
            var elementOffset = this._elementOffset();
            var selectionPosition = this._selectionPosition(e);
            selectionPosition.left -= elementOffset.left;
            selectionPosition.top -= elementOffset.top;

            var start = { x: selectionPosition.left, y: selectionPosition.top };
            var end = { x: selectionPosition.left + selectionPosition.width, y: selectionPosition.top + selectionPosition.height };
            this._updateAxisRanges(start, end);

            this.removeElement();
            delete this._zoomPane;

            return toChartAxisRanges(this.axisRanges);
        }
    };

    ZoomSelection.prototype.zoom = function zoom () {
        var axisRanges = this.axisRanges;
        if (axisRanges && axisRanges.length) {
            var plotArea = this.chart._plotArea;
            for (var idx = 0; idx < axisRanges.length; idx++) {
                var axisRange = axisRanges[idx];
                plotArea.updateAxisOptions(axisRange.axis, axisRange.range);
            }
            plotArea.redraw(plotArea.panes);
        }
    };

    ZoomSelection.prototype.destroy = function destroy () {
        this.removeElement();
        delete this._marquee;
        delete this.chart;
    };

    ZoomSelection.prototype._updateAxisRanges = function _updateAxisRanges (start, end) {
        var lock = (this.options.lock || "").toLowerCase();
        var axisRanges = [];

        var axes = this._zoomPane.axes;
        for (var idx = 0; idx < axes.length; idx++) {
            var axis = axes[idx];
            var vertical = axis.options.vertical;
            if (!(lock === X && !vertical) && !(lock === Y && vertical) && defined(axis.axisIndex)) {
                var range = axis.pointsRange(start, end);
                if (range) {
                    axisRanges.push({
                        axis: axis,
                        range: range
                    });
                }
            }
        }

        this.axisRanges = axisRanges;
    };

    ZoomSelection.prototype._selectionPosition = function _selectionPosition (e) {
        var clipBox = this._zoomPaneClipBox;
        var startLocation = {
            x: e.x.startLocation,
            y: e.y.startLocation
        };
        var pageX = e.x.location;
        var pageY = e.y.location;
        var lock = (this.options.lock || "").toLowerCase();
        var left = Math.min(startLocation.x, pageX);
        var top = Math.min(startLocation.y, pageY);
        var width = Math.abs(startLocation.x - pageX);
        var height = Math.abs(startLocation.y - pageY);

        if (lock === X) {
            left = clipBox.x1;
            width = clipBox.width();
        }
        if (lock === Y) {
            top = clipBox.y1;
            height = clipBox.height();
        }

        if (pageX > clipBox.x2) {
            width = clipBox.x2 - startLocation.x;
        }

        if (pageX < clipBox.x1) {
            width = startLocation.x - clipBox.x1;
        }

        if (pageY > clipBox.y2) {
            height = clipBox.y2 - startLocation.y;
        }

        if (pageY < clipBox.y1) {
            height = startLocation.y - clipBox.y1;
        }

        return {
            left: Math.max(left, clipBox.x1),
            top: Math.max(top, clipBox.y1),
            width: width,
            height: height
        };
    };

    return ZoomSelection;
}(Class));

ZoomSelection.prototype.options = {
    key: "shift",
    lock: "none"
};

// Limit the zoom rate between 1% and 90% per mousewheel event.
// At zoom rates close to 100% the axis range quickly becomes 0.
var MIN_RATE = 0.01;
var MAX_RATE = 0.9;
var DEFAULT_RATE = 0.3;

var MousewheelZoom = (function (Class) {
    function MousewheelZoom(chart, options) {
        Class.call(this);

        this.chart = chart;
        this.options = deepExtend({
            rate: DEFAULT_RATE
        }, this.options, options);
    }

    if ( Class ) MousewheelZoom.__proto__ = Class;
    MousewheelZoom.prototype = Object.create( Class && Class.prototype );
    MousewheelZoom.prototype.constructor = MousewheelZoom;

    MousewheelZoom.prototype.updateRanges = function updateRanges (delta, coords) {
        var this$1$1 = this;

        var lock = (this.options.lock || "").toLowerCase();
        var axisRanges = [];
        var axes = this.chart._plotArea.axes;

        for (var idx = 0; idx < axes.length; idx++) {
            var axis = axes[idx];
            var vertical = axis.options.vertical;

            if (!(lock === X && !vertical) && !(lock === Y && vertical) && axis.zoomRange) {
                var rate = limitValue(this$1$1.options.rate, MIN_RATE, MAX_RATE);
                var range = axis.zoomRange(-delta * rate, coords);

                if (range) {
                    axisRanges.push({
                        axis: axis,
                        range: range
                    });
                }
            }
        }

        this.axisRanges = axisRanges;
        return toChartAxisRanges(axisRanges);
    };

    MousewheelZoom.prototype.zoom = function zoom () {
        var axisRanges = this.axisRanges;
        var plotArea = this.chart._plotArea;

        if (axisRanges && axisRanges.length && plotArea.updateAxisOptions) {
            for (var idx = 0; idx < axisRanges.length; idx++) {
                var axisRange = axisRanges[idx];
                plotArea.updateAxisOptions(axisRange.axis, axisRange.range);
            }
            plotArea.redraw(plotArea.panes);
        }
    };

    MousewheelZoom.prototype.destroy = function destroy () {
        delete this.chart;
    };

    return MousewheelZoom;
}(Class));

var alignItems = function (rtl) { return (rtl ? END$1 : START$1); };

var LegendLayout = (function (ChartElement) {
    function LegendLayout(options, chartService) {
        ChartElement.call(this, options);

        this.chartService = chartService;
    }

    if ( ChartElement ) LegendLayout.__proto__ = ChartElement;
    LegendLayout.prototype = Object.create( ChartElement && ChartElement.prototype );
    LegendLayout.prototype.constructor = LegendLayout;

    LegendLayout.prototype.render = function render () {
        var ref = this;
        var children = ref.children;
        var options = ref.options;
        var vertical = options.vertical;

        this.visual = new Layout(null, {
            spacing: vertical ? 0 : options.spacing,
            lineSpacing: vertical ? options.spacing : 0,
            orientation: vertical ? VERTICAL : HORIZONTAL,
            reverse: options.rtl,
            alignItems: vertical ? alignItems(options.rtl) : CENTER
        });

        for (var idx = 0; idx < children.length; idx++) {
            var legendItem = children[idx];
            legendItem.reflow(new Box());
            legendItem.renderVisual();
        }
    };

    LegendLayout.prototype.reflow = function reflow (box) {
        this.visual.rect(box.toRect());
        this.visual.reflow();
        var bbox = this.visual.clippedBBox();

        if (bbox) {
            this.box = rectToBox(bbox);
        } else {
            this.box = new Box();
        }
    };

    LegendLayout.prototype.renderVisual = function renderVisual () {
        this.addVisual();
    };

    LegendLayout.prototype.createVisual = function createVisual () {};

    return LegendLayout;
}(ChartElement));

var DEFAULT_MARKER_SIZE = 10;
var DEFAULT_MARKER_BORDER_WIDTH = 2;

var LegendItemMarker = (function (ShapeElement) {
    function LegendItemMarker () {
        ShapeElement.apply(this, arguments);
    }

    if ( ShapeElement ) LegendItemMarker.__proto__ = ShapeElement;
    LegendItemMarker.prototype = Object.create( ShapeElement && ShapeElement.prototype );
    LegendItemMarker.prototype.constructor = LegendItemMarker;

    LegendItemMarker.prototype.visualStyle = function visualStyle () {
        var options = this.markerOptions();
        var border = options.border;

        return {
            stroke: {
                width: border.width,
                color: border.color,
                opacity: valueOrDefault(border.opacity, options.opacity),
                dashType: border.dashType
            },
            fill: {
                color: options.background,
                opacity: options.opacity
            },
            cursor: options.cursor
        };
    };

    LegendItemMarker.prototype.markerOptions = function markerOptions () {
        return this.options;
    };

    LegendItemMarker.prototype.markerHighlightOptions = function markerHighlightOptions () {
        var options = this.markerOptions();
        var borderWidth = options.highlight.border.width;

        return deepExtend(
            {},
            options,
            { background: options.border.color },
            options.highlight,
            options.type === CROSS ? {
                background: options.highlight.border.color,
                border: { color: options.highlight.background, width: borderWidth / 2 },
                width: options.width,
                height: options.height,
                margin: { top: 0, left: 0 }
            } : {}
        );
    };

    LegendItemMarker.prototype.createHighlight = function createHighlight () {
        var highlight = new ShapeElement(this.markerHighlightOptions());
        var box = this.paddingBox.clone();
        highlight.reflow(box.pad(highlight.options.border.width));
        this.highlight = [ highlight.getElement() ];

        return this.highlight;
    };

    return LegendItemMarker;
}(ShapeElement));

setDefaultOptions(LegendItemMarker, {
    border: {
        width: DEFAULT_MARKER_BORDER_WIDTH
    },
    width: DEFAULT_MARKER_SIZE - DEFAULT_MARKER_BORDER_WIDTH,
    height: DEFAULT_MARKER_SIZE - DEFAULT_MARKER_BORDER_WIDTH,
    background: WHITE$1,
    margin: {
        top: -1,
        left: -1
    },
    vAlign: TOP,
    align: LEFT,
    highlight: {
        width: DEFAULT_MARKER_SIZE,
        height: DEFAULT_MARKER_SIZE,
        border: {
            color: WHITE$1,
            width: DEFAULT_MARKER_BORDER_WIDTH
        }
    }
});

var MarkerLineArea = (function (ShapeElement) {
    function MarkerLineArea () {
        ShapeElement.apply(this, arguments);
    }

    if ( ShapeElement ) MarkerLineArea.__proto__ = ShapeElement;
    MarkerLineArea.prototype = Object.create( ShapeElement && ShapeElement.prototype );
    MarkerLineArea.prototype.constructor = MarkerLineArea;

    MarkerLineArea.prototype.getElement = function getElement () {
        var group = new Group$8();
        var element = new MultiPath(this.visualStyle());
        var ref = this;
        var box = ref.paddingBox;
        var halfHeight = box.height() / 2;

        element
            .moveTo(box.x1, box.y1 + halfHeight)
            .lineTo(box.x1, box.y2)
            .lineTo(box.x2, box.y2);

        group.append(element);

        return group;
    };

    return MarkerLineArea;
}(ShapeElement));

setDefaultOptions(MarkerLineArea, {
    width: 15,
    height: 15,
    align: RIGHT,
    vAlign: BOTTOM$1,
    margin: {
        right: -2,
        bottom: 2
    }
});

var LegendItemLine = (function (ShapeElement) {
    function LegendItemLine () {
        ShapeElement.apply(this, arguments);
    }

    if ( ShapeElement ) LegendItemLine.__proto__ = ShapeElement;
    LegendItemLine.prototype = Object.create( ShapeElement && ShapeElement.prototype );
    LegendItemLine.prototype.constructor = LegendItemLine;

    LegendItemLine.prototype.getElement = function getElement () {
        var group = new Group$8();
        var element = new MultiPath({
            stroke: {
                color: this.options.border.color,
                opacity: this.options.opacity,
                width: this.options.height,
                dashType: this.options.dashType
            }
        });
        var box = this.paddingBox;
        var centerY = box.center().y;

        element
            .moveTo(box.x1, centerY)
            .lineTo(box.x2, centerY);

        group.append(element);

        return group;
    };

    LegendItemLine.prototype.createHighlight = function createHighlight () {
        this.highlight = [ this.createHighlightLine(), this.createHighlightMarker() ];
        return this.highlight;
    };

    LegendItemLine.prototype.createHighlightLine = function createHighlightLine () {
        var options = deepExtend({}, {
            border: {
                color: this.options.border.color,
                opacity: this.options.border.opacity,
                dashType: this.options.border.dashType
            }
        }, this.options.highlight);
        var highlightLine = new MarkerLineArea(options);
        highlightLine.reflow(this.parent.paddingBox.clone());

        this.highlightLine = highlightLine.getElement();

        return this.highlightLine;
    };

    LegendItemLine.prototype.createHighlightMarker = function createHighlightMarker () {
        var options = deepExtend({}, {
            background: this.options.background,
        }, this.options.highlight.markers);
        var highlightMarker = new ShapeElement(options);
        var paddingBox = this.parent.paddingBox;
        var borderWidth = options.border.width;
        var box = this.parent.box.clone();

        box.pad({
            left: borderWidth - paddingBox.x1,
            top: borderWidth - paddingBox.y1
        });

        highlightMarker.reflow(box);
        this.highlightMarker = highlightMarker.getElement();

        return this.highlightMarker;
    };

    return LegendItemLine;
}(ShapeElement));

setDefaultOptions(LegendItemLine, {
    border: {
        width: 0
    },
    type: RECT,
    align: LEFT,
    vAlign: CENTER,
    highlight: {
        border: {
            width: DEFAULT_MARKER_BORDER_WIDTH
        },
        markers: {
            type: CIRCLE,
            width: DEFAULT_MARKER_SIZE,
            height: DEFAULT_MARKER_SIZE,
            border: {
                width: DEFAULT_MARKER_BORDER_WIDTH,
                color: WHITE$1
            },
            align: LEFT,
            vAlign: TOP
        }
    }
});

var LegendItemSquare = (function (ShapeElement) {
    function LegendItemSquare () {
        ShapeElement.apply(this, arguments);
    }

    if ( ShapeElement ) LegendItemSquare.__proto__ = ShapeElement;
    LegendItemSquare.prototype = Object.create( ShapeElement && ShapeElement.prototype );
    LegendItemSquare.prototype.constructor = LegendItemSquare;

    LegendItemSquare.prototype.createHighlight = function createHighlight () {
        var options = deepExtend({}, {
            background: this.options.background,
        }, this.options.highlight.markers);
        var highlight = new ShapeElement(options);

        var box = this.paddingBox.clone();
        var targetBox = this.parent.box.clone();
        box.align(targetBox, X, LEFT);
        box.align(targetBox, Y, TOP);
        highlight.reflow(box);

        this.highlight = [ highlight.getElement() ];

        return this.highlight;
    };

    return LegendItemSquare;
}(ShapeElement));

setDefaultOptions(LegendItemSquare, {
    highlight: {
        markers: {
            type: CIRCLE,
            width: DEFAULT_MARKER_SIZE,
            height: DEFAULT_MARKER_SIZE,
            border: {
                width: DEFAULT_MARKER_BORDER_WIDTH,
                color: WHITE$1
            },
            margin: {
                top: -3,
                left: -3
            }
        }
    }
});

var LegendItem = (function (BoxElement) {
    function LegendItem(options) {
        BoxElement.call(this, options);

        this.createContainer();
        if (!options.rtl) {
            this.createMarker();
            this.createLabel();
        } else {
            this.createLabel();
            this.createMarker();
        }

        this._id = guid();
        this.options.accessibility.ariaChecked = options.active;
    }

    if ( BoxElement ) LegendItem.__proto__ = BoxElement;
    LegendItem.prototype = Object.create( BoxElement && BoxElement.prototype );
    LegendItem.prototype.constructor = LegendItem;

    LegendItem.prototype.createContainer = function createContainer () {
        this.container = new FloatElement({ vertical: false, wrap: false, align: CENTER, spacing: this.options.spacing });
        this.append(this.container);
    };

    LegendItem.prototype.createMarker = function createMarker () {
        this.markerWrap = new BoxElement({ vertical: false, shrinkToFit: true, wrap: false, margin: 1, width: 22, height: 22 });
        this.container.append(this.markerWrap);

        this.createMarkerArea();

        if (this.options.markers.visible) {
            this._marker = this._createMarker();
            this.markerWrap.append(this._marker);
        }
    };

    LegendItem.prototype.createMarkerArea = function createMarkerArea () {
        var options = this.options;
        var markerColor = options.markerColor;
        var line = options.line; if ( line === void 0 ) line = {};
        var lineOptions = {
            border: {
                color: line.color || markerColor,
                opacity: line.opacity,
                dashType: line.dashType
            }
        };
        return this._createLine(lineOptions) ||
            this._createMarkerLine(lineOptions, line) ||
            this._createSquare();
    };

    LegendItem.prototype.markerOptions = function markerOptions () {
        var options = this.options;
        var markers = options.markers; if ( markers === void 0 ) markers = {};
        var markerColor = options.markerColor;
        var border = markers.border; if ( border === void 0 ) border = {};
        markers.zIndex = undefined;

        return deepExtend({}, markers, {
            border: { color: border.color || markerColor },
            highlight: options.highlight.markers
        });
    };

    LegendItem.prototype._highlightOptions = function _highlightOptions () {
        var options = this.options;
        return deepExtend(
            { markers: { type: options.markers.type } },
            options.highlight
        );
    };

    LegendItem.prototype._createLine = function _createLine (lineOptions) {
        var options = this.options;
        if (options.type === LINE && !options.markers.visible) {
            this._line = new LegendItemLine(deepExtend({}, {
                background: options.markerColor,
                highlight: this._highlightOptions(),
            }, lineOptions, options.line));

            this.markerWrap.append(this._line);
        }
        return this._line;
    };

    LegendItem.prototype._createMarkerLine = function _createMarkerLine (lineOptions, line) {
        var options = this.options;
        if (options.type === LINE) {
            this._markerLineArea = new MarkerLineArea(deepExtend({}, {
                border: {
                    width: line.height
                }
            }, lineOptions));

            this.markerWrap.append(this._markerLineArea);
        }

        return this._markerLineArea;
    };

    LegendItem.prototype._reduceSize = function _reduceSize (object, prop, factor) {
        if ( factor === void 0 ) factor = 0.6;

        if (typeof object[prop] === 'number') {
            object[prop] = object[prop] * factor;
        }
    };

    LegendItem.prototype._createSquare = function _createSquare () {
        var options = this.options;
        if (options.type === AREA) {
            var pattern = options.pattern || (options.series || {}).pattern;
            if (pattern) {
                if (typeof pattern === 'function') {
                    pattern = pattern(options.series);
                }
                pattern = structuredClone(pattern);
                this._reduceSize(pattern, 'gap');
                this._reduceSize(pattern, 'width');
                this._reduceSize(pattern, 'radius');
            }

            this._square = new LegendItemSquare(Object.assign({}, {border: options.border,
                vAlign: options.markers.visible ? BOTTOM$1 : CENTER,
                highlight: this._highlightOptions()},
                options.area,
                {pattern: pattern,
                background: options.area.background || options.markerColor}));
            this.markerWrap.append(this._square);
        }
        return this._square;
    };

    LegendItem.prototype._createMarker = function _createMarker () {
        return new LegendItemMarker(this.markerOptions());
    };

    LegendItem.prototype._highlightMarkers = function _highlightMarkers () {
        if (this.options.active) {
            this._toggleHighlight(true);
        }
    };

    LegendItem.prototype._restoreMarkers = function _restoreMarkers () {
        this._toggleHighlight(false);
    };

    LegendItem.prototype._toggleHighlight = function _toggleHighlight (show) {
        var this$1$1 = this;

        if (!this.options.highlight.visible) {
            return;
        }

        var element = this._marker || this._square || this._line;

        if (element && element === this._line) {
            this._line.visual.visible(!show);
        }

        if (element) {
            var highlight = element.highlight;

            if (!highlight) {
                highlight = element.createHighlight();
                highlight.forEach(function (h) { return h && this$1$1.markerWrap.appendVisual(h); });
            }

            highlight.forEach(function (h) { return h && h.visible(show); });
        }
    };

    LegendItem.prototype.createLabel = function createLabel () {
        var options = this.options;
        var labelOptions = deepExtend({}, options.labels);

        this.container.append(new TextBox(options.text, labelOptions));
    };

    LegendItem.prototype.getAriaLabelText = function getAriaLabelText () {
        return this.options.text;
    };

    LegendItem.prototype.focusVisual = function focusVisual () {
        this.visual.options.set("id", this._id);
        this.toggleFocusHighlight(true);
        this._highlightMarkers();
    };

    LegendItem.prototype.clearFocusFromVisual = function clearFocusFromVisual () {
        this.visual.options.set("id", "");
        this.toggleFocusHighlight(false);
        this._restoreMarkers();
    };

    LegendItem.prototype.renderComplete = function renderComplete () {
        BoxElement.prototype.renderComplete.call(this);

        var cursor = this.options.cursor || {};
        var eventSink = this._itemOverlay = Path$7.fromRect(this.container.box.toRect(), {
            fill: {
                color: WHITE$1,
                opacity: 0
            },
            stroke: null,
            cursor: cursor.style || cursor
        });

        this.appendVisual(eventSink);
    };

    LegendItem.prototype.click = function click (widget, e) {
        var args = this.eventArgs(e);

        if (!widget.trigger(LEGEND_ITEM_CLICK, args) && e && e.type === 'contextmenu') {
            e.preventDefault();
        }
    };

    LegendItem.prototype.over = function over (widget, e) {
        var args = this.eventArgs(e);

        if (!widget.trigger(LEGEND_ITEM_HOVER, args)) {
            widget._legendItemHover(args.seriesIndex, args.pointIndex);
            this._highlightMarkers();
        }

        // Don't trigger point hover for legend items
        return true;
    };

    LegendItem.prototype.out = function out (widget, e) {
        widget._unsetActivePoint();
        this._restoreMarkers();

        widget.trigger(LEGEND_ITEM_LEAVE, this.eventArgs(e));
    };

    LegendItem.prototype.eventArgs = function eventArgs (e) {
        var options = this.options;

        return {
            element: eventElement(e),
            text: options.text,
            series: options.series,
            seriesIndex: options.series.index,
            pointIndex: options.pointIndex
        };
    };

    LegendItem.prototype.createVisual = function createVisual () {
        BoxElement.prototype.createVisual.call(this);
        var options = this.options;

        if (this.options.visible) {
            var accessibilityOptions = deepExtend({
                ariaLabel: options.accessibility.ariaLabel !== undefined ? options.accessibility.ariaLabel : options.text
            }, options.accessibility);

            addAccessibilityAttributesToVisual(this.visual, accessibilityOptions);
        }
    };

    LegendItem.prototype.renderVisual = function renderVisual () {
        var this$1$1 = this;

        var options = this.options;
        var customVisual = options.visual;

        if (customVisual) {
            this.visual = customVisual({
                active: options.active,
                series: options.series,
                sender: this.getSender(),
                pointIndex: options.pointIndex,
                options: {
                    type: options.type,
                    // Passing the markerColor as a background option for backwards compatibility.
                    // Example in jq docs - https://docs.telerik.com/kendo-ui/api/javascript/dataviz/ui/chart/configuration/legend.item#legenditemvisual
                    markers: deepExtend({ background: this.options.markerColor }, this.markerOptions()),
                    labels: options.labels
                },
                createVisual: function () {
                    this$1$1.createVisual();
                    this$1$1.renderChildren();
                    this$1$1.renderComplete();

                    var defaultVisual = this$1$1.visual;

                    delete this$1$1.visual;

                    return defaultVisual;
                }
            });
            this._marker = this._markerLineArea = this._square = this._line = null;
            this.addVisual();
        } else {
            BoxElement.prototype.renderVisual.call(this);
        }
    };

    LegendItem.prototype.createFocusHighlight = function createFocusHighlight (style) {
        var borderWidth = style.stroke.width;
        return Path$7.fromRect(this.container.box.pad(borderWidth / 2).toRect(), style);
    };

    return LegendItem;
}(BoxElement));

setDefaultOptions(LegendItem, {
    accessibility: {
        role: LEGEND_ITEM_ROLE,
        className: LEGEND_ITEM_CLASSNAME,
        ariaRoleDescription: LEGEND_ITEM_ARIA_ROLE_DESCRIPTION
    },
    markers: {},
    highlight: {
        visible: true,
        markers: {}
    }
});

var CUSTOM = "custom";

var Legend$1 = (function (ChartElement) {
    function Legend(options, chartService) {
        if ( chartService === void 0 ) chartService = {};

        ChartElement.call(this, options);

        this.chartService = chartService;

        if (!inArray(this.options.position, [ TOP, RIGHT, BOTTOM$1, LEFT, CUSTOM ])) {
            this.options.position = RIGHT;
        }

        this.createContainers();

        this.createLegendTitle(options.title);

        this.createItems();
    }

    if ( ChartElement ) Legend.__proto__ = ChartElement;
    Legend.prototype = Object.create( ChartElement && ChartElement.prototype );
    Legend.prototype.constructor = Legend;

    Legend.prototype.createContainers = function createContainers () {
        var options = this.options;
        var position = options.position;
        var userAlign = options.align;
        var align = position;
        var vAlign = CENTER;

        if (position === CUSTOM) {
            align = LEFT;
        } else if (inArray(position, [ TOP, BOTTOM$1 ])) {
            if (userAlign === START$1) {
                align = LEFT;
            } else if (userAlign === END$1) {
                align = RIGHT;
            } else {
                align = CENTER;
            }
            vAlign = position;
        } else if (userAlign) {
            if (userAlign === START$1) {
                vAlign = TOP;
            } else if (userAlign === END$1) {
                vAlign = BOTTOM$1;
            }
        }

        this.container = new BoxElement({
            margin: options.margin,
            padding: options.padding,
            background: options.background,
            border: options.border,
            vAlign: vAlign,
            align: align,
            zIndex: options.zIndex,
            shrinkToFit: true
        });

        if (this.hasTitle()) {
            this.itemsContainer = new BoxElement({
                vAlign: vAlign,
                align: align,
                zIndex: options.zIndex,
                shrinkToFit: true
            });
        } else {
            this.itemsContainer = this.container;
        }

        this.append(this.container);
    };

    Legend.prototype.createItems = function createItems () {
        var chartService = this.getService();
        var options = this.options;
        var vertical = this.isVertical();
        var innerElement = new LegendLayout({
            vertical: vertical,
            spacing: options.spacing,
            rtl: chartService.rtl
        }, chartService);
        var data = options.data;

        if (options.reverse) {
            data = data.slice(0).reverse();
        }

        var count = data.length;

        for (var i = 0; i < count; i++) {
            var dataItem = data[i];
            var ref = dataItem.series || {};
            var markers = ref.markers; if ( markers === void 0 ) markers = {};
            var dashType = ref.dashType;
            var legendItem = ref.legendItem;
            var opacity = ref.opacity;
            var markersOptions = deepExtend({ visible: markers.visible !== false, type: CIRCLE }, markers);
            delete markersOptions.size;

            var itemOptions = deepExtend({},
                {
                    markers: markersOptions,
                    labels: options.labels,
                    rtl: chartService.rtl,
                    line: Object.assign({}, {dashType: dashType},
                        options.line),
                    area: Object.assign({}, {opacity: opacity},
                        options.area),
                    opacity: opacity,
                    accessibility: options.accessibility,
                    focusHighlight: options.focusHighlight
                },
                options.item,
                legendItem,
                dataItem,
                { markers: options.markers }
            );

            innerElement.append(new LegendItem(itemOptions));
        }

        innerElement.render();
        this.itemsContainer.append(innerElement);
    };

    Legend.prototype.isVertical = function isVertical () {
        var ref = this.options;
        var orientation = ref.orientation;
        var position = ref.position;
        var vertical = (position === CUSTOM && orientation !== HORIZONTAL) ||
               (defined(orientation) ? orientation !== HORIZONTAL : inArray(position, [ LEFT, RIGHT ]));

        return vertical;
    };

    Legend.prototype.hasItems = function hasItems () {
        return this.container.children[0].children.length > 0;
    };

    Legend.prototype.getItems = function getItems () {
        return this.itemsContainer.children[0].children;
    };

    Legend.prototype.reflow = function reflow (targetBox) {
        var options = this.options;
        var legendBox = targetBox.clone();

        if (!this.hasItems()) {
            this.box = legendBox;
            return;
        }

        if (options.position === CUSTOM) {
            this.containerCustomReflow(legendBox);
            this.box = legendBox;
        } else {
            this.containerReflow(legendBox);
        }

        if (this.hasTitle()) {
            this.title.reflow(new Box(this.container.box.x1, this.title.box.y1, this.container.box.x2, this.title.box.y2));
        }
    };

    Legend.prototype.containerReflow = function containerReflow (targetBox) {
        var ref = this;
        var options = ref.options;
        var container = ref.container;
        var position = options.position;
        var width = options.width;
        var height = options.height;
        var pos = position === TOP || position === BOTTOM$1 ? X : Y;
        var vertical = this.isVertical();
        var alignTarget = targetBox.clone();
        var containerBox = targetBox.clone();

        if (position === LEFT || position === RIGHT) {
            containerBox.y1 = alignTarget.y1 = 0;
        }

        if (vertical && height) {
            containerBox.y2 = containerBox.y1 + height;
            containerBox.align(alignTarget, Y, container.options.vAlign);
        } else if (!vertical && width) {
            containerBox.x2 = containerBox.x1 + width;
            containerBox.align(alignTarget, X, container.options.align);
        }

        container.reflow(containerBox);
        containerBox = container.box;

        var box = containerBox.clone();

        if (options.offsetX || options.offsetY) {
            containerBox.translate(options.offsetX, options.offsetY);
            container.reflow(containerBox);
        }

        box[pos + 1] = targetBox[pos + 1];
        box[pos + 2] = targetBox[pos + 2];

        this.box = box;
    };

    Legend.prototype.containerCustomReflow = function containerCustomReflow (targetBox) {
        var ref = this;
        var options = ref.options;
        var container = ref.container;
        var offsetX = options.offsetX;
        var offsetY = options.offsetY;
        var width = options.width;
        var height = options.height;
        var vertical = this.isVertical();
        var containerBox = targetBox.clone();

        if (vertical && height) {
            containerBox.y2 = containerBox.y1 + height;
        } else if (!vertical && width) {
            containerBox.x2 = containerBox.x1 + width;
        }
        container.reflow(containerBox);
        containerBox = container.box;

        container.reflow(new Box(
            offsetX, offsetY,
            offsetX + containerBox.width(), offsetY + containerBox.height()
        ));
    };

    Legend.prototype.renderVisual = function renderVisual () {
        if (this.hasItems()) {
            ChartElement.prototype.renderVisual.call(this);
        }
    };

    Legend.prototype.createLegendTitle = function createLegendTitle (title) {
        var titleOptions = deepExtend({}, {
            color: BLACK$1,
            position: TOP,
            align: CENTER
        }, title);
        var text = titleOptions.text;

        if (!title || title.visible === false || !title.text) {
            return;
        }

        if (defined(titleOptions) && titleOptions.visible) {
            var labelTemplate = getTemplate$1(titleOptions);
            if (labelTemplate) {
                text = labelTemplate({ text: text });
            } else if (titleOptions.format) {
                text = this.chartService.format.auto(titleOptions.format, text);
            }
        }

        this.title = new TextBox(text, titleOptions);

        this.createTitleLayout();

        this.appendTitleLayoutContent();
    };

    Legend.prototype.createTitleLayout = function createTitleLayout () {
        this.layout = new FloatElement({
            vertical: true,
            wrap: false
        });

        this.container.append(this.layout);
    };

    Legend.prototype.hasTitle = function hasTitle () {
        return Boolean(this.options.title && this.options.title.visible !== false && this.options.title.text);
    };

    Legend.prototype.appendTitleLayoutContent = function appendTitleLayoutContent () {
        var options = this.options;

        if (options.title.position === BOTTOM$1) {
            this.layout.append(this.itemsContainer);
            this.layout.append(this.title);
        } else {
            this.layout.append(this.title);
            this.layout.append(this.itemsContainer);
        }
    };

    return Legend;
}(ChartElement));

setDefaultOptions(Legend$1, {
    position: RIGHT,
    data: [],
    offsetX: 0,
    offsetY: 0,
    margin: getSpacing(2),
    padding: getSpacing(5),
    border: {
        color: BLACK$1,
        width: 0
    },
    item: {
        cursor: POINTER,
        spacing: 6
    },
    spacing: 6,
    background: "",
    zIndex: 1,
    markers: {},
    line: {
        width: 20,
        height: 2,
        cursor: POINTER,
        opacity: 1
    },
    area: {
        type: SQUARE,
        align: RIGHT,
        width: 15,
        height: 15,
    }
});

var PlotAreaFactory = (function (Class) {
    function PlotAreaFactory() {
        Class.call(this);

        this._registry = [];
    }

    if ( Class ) PlotAreaFactory.__proto__ = Class;
    PlotAreaFactory.prototype = Object.create( Class && Class.prototype );
    PlotAreaFactory.prototype.constructor = PlotAreaFactory;

    PlotAreaFactory.prototype.register = function register (type, seriesTypes) {
        this._registry.push({
            type: type,
            seriesTypes: seriesTypes
        });
    };

    PlotAreaFactory.prototype.create = function create (srcSeries, options, chartService) {
        var registry = this._registry;
        var match = registry[0];
        var series;

        for (var idx = 0; idx < registry.length; idx++) {
            var entry = registry[idx];
            series = filterSeriesByType(srcSeries, entry.seriesTypes);
            var trendlines = filterSeriesByType(srcSeries, TRENDLINE_SERIES);

            if ((series.length - trendlines.length) > 0) {
                match = entry;
                break;
            }
        }

        return new match.type(series, options, chartService);
    };

    return PlotAreaFactory;
}(Class));

PlotAreaFactory.current = new PlotAreaFactory();

var ZOOM_ACCELERATION$1 = 3;
var SELECTOR_HEIGHT_ADJUST = 0.1;

function createDiv$1(classNames) {
    var element = document.createElement("div");
    if (classNames) {
        element.className = classNames;
    }

    return element;
}

function closestHandle(element) {
    var current = element;
    while (current && !hasClasses(current, "k-handle")) {
        current = current.parentNode;
    }

    return current;
}

var Selection = (function (Class) {
    function Selection(chart, categoryAxis, options, observer) {
        Class.call(this);

        var chartElement = chart.element;

        this.options = deepExtend({}, this.options, options);
        this.chart = chart;
        this.observer = observer;
        this.chartElement = chartElement;
        this.categoryAxis = categoryAxis;
        this._dateAxis = this.categoryAxis instanceof DateCategoryAxis;

        this.initOptions();

        this.visible = this.options.visible && chartElement.offsetHeight;

        if (this.visible) {
            this.createElements();

            this.set(this._index(this.options.from), this._index(this.options.to));

            this.bindEvents();
        }
    }

    if ( Class ) Selection.__proto__ = Class;
    Selection.prototype = Object.create( Class && Class.prototype );
    Selection.prototype.constructor = Selection;

    Selection.prototype.onPane = function onPane (pane) {
        return this.categoryAxis.pane === pane;
    };

    Selection.prototype.createElements = function createElements () {
        var options = this.options;
        var wrapper = this.wrapper = createDiv$1("k-selector k-pointer-events-none");
        elementStyles$1(wrapper, {
            top: options.offset.top,
            left: options.offset.left,
            width: options.width,
            height: options.height,
            direction: 'ltr'
        });

        var selection = this.selection = createDiv$1("k-selection k-pointer-events-none");

        this.leftMask = createDiv$1("k-mask k-pointer-events-none");
        this.rightMask = createDiv$1("k-mask k-pointer-events-none");

        wrapper.appendChild(this.leftMask);
        wrapper.appendChild(this.rightMask);
        wrapper.appendChild(selection);

        var body = this.body = createDiv$1("k-selection-bg k-pointer-events-none");
        selection.appendChild(body);

        var leftHandle = this.leftHandle = createDiv$1("k-handle k-left-handle k-pointer-events-auto");
        var rightHandle = this.rightHandle = createDiv$1("k-handle k-right-handle k-pointer-events-auto");
        leftHandle.appendChild(createDiv$1());
        rightHandle.appendChild(createDiv$1());

        selection.appendChild(leftHandle);
        selection.appendChild(rightHandle);

        this.chartElement.appendChild(wrapper);
        var selectionStyles = elementStyles$1(selection, [ "borderLeftWidth", "borderRightWidth", "height" ]);
        var leftHandleHeight = elementStyles$1(leftHandle, "height").height;
        var rightHandleHeight = elementStyles$1(rightHandle, "height").height;

        options.selection = {
            border: {
                left: selectionStyles.borderLeftWidth,
                right: selectionStyles.borderRightWidth
            }
        };

        elementStyles$1(leftHandle, {
            top: (selectionStyles.height - leftHandleHeight) / 2
        });

        elementStyles$1(rightHandle, {
            top: (selectionStyles.height - rightHandleHeight) / 2
        });

        /* eslint no-self-assign: "off" */
        wrapper.style.cssText = wrapper.style.cssText;
    };

    Selection.prototype.bindEvents = function bindEvents$1 () {
        var obj;

        if (this.options.mousewheel !== false) {
            this._mousewheelHandler = this._mousewheel.bind(this);
            bindEvents(this.chartElement, ( obj = {}, obj[ MOUSEWHEEL$1 ] = this._mousewheelHandler, obj ));
        }

        this._domEvents = DomEventsBuilder.create(this.chartElement, {
            stopPropagation: true, // applicable for the jQuery UserEvents
            start: this._start.bind(this),
            move: this._move.bind(this),
            end: this._end.bind(this),
            tap: this._tap.bind(this),
            press: this._press.bind(this),
            gesturestart: this._gesturestart.bind(this),
            gesturechange: this._gesturechange.bind(this),
            gestureend: this._gestureend.bind(this)
        });
    };

    Selection.prototype.initOptions = function initOptions () {
        var ref = this;
        var options = ref.options;
        var categoryAxis = ref.categoryAxis;
        var box = categoryAxis.pane.chartsBox();
        var intlService = this.chart.chartService.intl;

        if (this._dateAxis) {
            deepExtend(options, {
                min: parseDate(intlService, options.min),
                max: parseDate(intlService, options.max),
                from: parseDate(intlService, options.from),
                to: parseDate(intlService, options.to)
            });
        }

        var ref$1 = elementStyles$1(this.chartElement, [ "paddingLeft", "paddingTop" ]);
        var paddingLeft = ref$1.paddingLeft;
        var paddingTop = ref$1.paddingTop;

        this.options = deepExtend({}, {
            width: box.width(),
            height: box.height() + SELECTOR_HEIGHT_ADJUST, //workaround for sub-pixel hover on the paths in chrome
            padding: {
                left: paddingLeft,
                top: paddingTop
            },
            offset: {
                left: box.x1 + paddingLeft,
                top: box.y1 + paddingTop
            },
            from: options.min,
            to: options.max
        }, options);
    };

    Selection.prototype.destroy = function destroy () {
        var obj;

        if (this._domEvents) {
            this._domEvents.destroy();
            delete this._domEvents;
        }

        clearTimeout(this._mwTimeout);
        this._state = null;

        if (this.wrapper) {
            if (this._mousewheelHandler) {
                unbindEvents(this.chartElement, ( obj = {}, obj[ MOUSEWHEEL$1 ] = this._mousewheelHandler, obj ));
                this._mousewheelHandler = null;
            }

            this.chartElement.removeChild(this.wrapper);
            this.wrapper = null;
        }
    };

    Selection.prototype._rangeEventArgs = function _rangeEventArgs (range) {

        return {
            axis: this.categoryAxis.options,
            from: this._value(range.from),
            to: this._value(range.to)
        };
    };

    Selection.prototype._pointInPane = function _pointInPane (x, y) {
        var paneBox = this.categoryAxis.pane.box;
        var modelCoords = this.chart._toModelCoordinates(x, y);
        return paneBox.containsPoint(modelCoords);
    };

    Selection.prototype._start = function _start (e) {
        var options = this.options;
        var target = eventElement(e);
        if (this._state || !target) {
            return;
        }

        var coords = eventCoordinates(e);
        var inPane = this._pointInPane(coords.x, coords.y);
        if (!inPane) {
            return;
        }

        var handle = closestHandle(target);
        var bodyRect = this.body.getBoundingClientRect();
        var inBody = !handle && coords.x >= bodyRect.x && coords.x <= bodyRect.x + bodyRect.width &&
                       coords.y >= bodyRect.y && coords.y <= bodyRect.y + bodyRect.height;

        this.chart._unsetActivePoint();
        this._state = {
            moveTarget: handle,
            startLocation: e.x ? e.x.location : 0,
            inBody: inBody,
            range: {
                from: this._index(options.from),
                to: this._index(options.to)
            }
        };

        var args = this._rangeEventArgs({
            from: this._index(options.from),
            to: this._index(options.to)
        });

        if (this.trigger(SELECT_START, args)) {
            this._state = null;
        }
    };

    Selection.prototype._press = function _press (e) {
        var handle;
        if (this._state) {
            handle = this._state.moveTarget;
        } else {
            handle = closestHandle(eventElement(e));
        }
        if (handle) {
            addClass(handle, "k-handle-active");
        }
    };

    Selection.prototype._move = function _move (e) {
        if (!this._state) {
            return;
        }

        var ref = this;
        var state = ref._state;
        var options = ref.options;
        var categoryAxis = ref.categoryAxis;
        var range = state.range;
        var target = state.moveTarget;
        var reverse = categoryAxis.options.reverse;
        var from = this._index(options.from);
        var to = this._index(options.to);
        var min = this._index(options.min);
        var max = this._index(options.max);
        var delta = state.startLocation - e.x.location;
        var oldRange = { from: range.from, to: range.to };
        var span = range.to - range.from;
        var scale = elementStyles$1(this.wrapper, "width").width / (categoryAxis.categoriesCount() - 1);
        var offset = Math.round(delta / scale) * (reverse ? -1 : 1);

        if (!target && !state.inBody) {
            return;
        }

        var leftHandle = target && hasClasses(target, "k-left-handle");
        var rightHandle = target && hasClasses(target, "k-right-handle");

        if (state.inBody) {
            range.from = Math.min(
                Math.max(min, from - offset),
                max - span
            );
            range.to = Math.min(
                range.from + span,
                max
            );
        } else if ((leftHandle && !reverse) || (rightHandle && reverse)) {
            range.from = Math.min(
                Math.max(min, from - offset),
                max - 1
            );
            range.to = Math.max(range.from + 1, range.to);
        } else if ((leftHandle && reverse) || (rightHandle && !reverse)) {
            range.to = Math.min(
                Math.max(min + 1, to - offset),
                max
            );
            range.from = Math.min(range.to - 1, range.from);
        }

        if (range.from !== oldRange.from || range.to !== oldRange.to) {
            this.move(range.from, range.to);
            this.trigger(SELECT, this._rangeEventArgs(range));
        }
    };

    Selection.prototype._end = function _end () {
        if (this._state) {
            var moveTarget = this._state.moveTarget;
            if (moveTarget) {
                removeClass(moveTarget, "k-handle-active");
            }

            var range = this._state.range;
            this.set(range.from, range.to);
            this.trigger(SELECT_END, this._rangeEventArgs(range));

            delete this._state;
        }
    };

    Selection.prototype._tap = function _tap (e) {
        var ref = this;
        var options = ref.options;
        var categoryAxis = ref.categoryAxis;
        var coords = this.chart._eventCoordinates(e);
        var categoryIx = categoryAxis.pointCategoryIndex(new Point$5(coords.x, categoryAxis.box.y1));
        var from = this._index(options.from);
        var to = this._index(options.to);
        var min = this._index(options.min);
        var max = this._index(options.max);
        var span = to - from;
        var mid = from + span / 2;
        var range = {};
        var rightClick = e.event.which === 3;
        var offset = Math.round(mid - categoryIx);

        if (this._state || rightClick) {
            return;
        }


        this.chart._unsetActivePoint();

        if (!categoryAxis.options.justified) {
            offset--;
        }

        range.from = Math.min(
            Math.max(min, from - offset),
            max - span
        );

        range.to = Math.min(range.from + span, max);

        this._start(e);

        if (this._state) {
            this._state.range = range;
            this.trigger(SELECT, this._rangeEventArgs(range));
            this._end();
        }
    };

    Selection.prototype._mousewheel = function _mousewheel (e) {
        var this$1$1 = this;

        var delta = mousewheelDelta(e);

        this._start(e);

        if (this._state) {
            var range = this._state.range;

            e.preventDefault();
            e.stopPropagation();

            if (Math.abs(delta) > 1) {
                delta *= ZOOM_ACCELERATION$1;
            }

            if (this.options.mousewheel.reverse) {
                delta *= -1;
            }

            if (this.expand(delta)) {
                this.trigger(SELECT, {
                    axis: this.categoryAxis.options,
                    delta: delta,
                    originalEvent: e,
                    from: this._value(range.from),
                    to: this._value(range.to)
                });
            }

            if (this._mwTimeout) {
                clearTimeout(this._mwTimeout);
            }

            this._mwTimeout = setTimeout(function () {
                this$1$1._end();
            }, MOUSEWHEEL_DELAY);
        }
    };

    Selection.prototype._gesturestart = function _gesturestart (e) {
        var options = this.options;
        var touch = e.touches[0];
        var inPane = this._pointInPane(touch.pageX, touch.pageY);

        if (!inPane) {
            return;
        }

        this._state = {
            range: {
                from: this._index(options.from),
                to: this._index(options.to)
            }
        };
        var args = this._rangeEventArgs(this._state.range);

        if (this.trigger(SELECT_START, args)) {
            this._state = null;
        } else {
            e.preventDefault();
        }
    };

    Selection.prototype._gestureend = function _gestureend () {
        if (this._state) {
            this.trigger(SELECT_END, this._rangeEventArgs(this._state.range));
            delete this._state;
        }
    };

    Selection.prototype._gesturechange = function _gesturechange (e) {
        if (!this._state) {
            return;
        }

        var ref = this;
        var chart = ref.chart;
        var state = ref._state;
        var options = ref.options;
        var categoryAxis = ref.categoryAxis;
        var range = state.range;
        var p0 = chart._toModelCoordinates(e.touches[0].x.location).x;
        var p1 = chart._toModelCoordinates(e.touches[1].x.location).x;
        var left = Math.min(p0, p1);
        var right = Math.max(p0, p1);

        e.preventDefault();

        range.from = categoryAxis.pointCategoryIndex(new Point$5(left)) || options.min;

        range.to = categoryAxis.pointCategoryIndex(new Point$5(right)) || options.max;

        this.move(range.from, range.to);

        this.trigger(SELECT, this._rangeEventArgs(range));
    };

    Selection.prototype._index = function _index (value) {
        var index = value;

        if (value instanceof Date) {
            index = this.categoryAxis.categoryIndex(value);
        }

        return index;
    };

    Selection.prototype._value = function _value (index) {
        var value = index;
        if (this._dateAxis) {
            value = this.categoryAxis.categoryAt(index);
            if (value > this.options.max) {
                value = this.options.max;
            }
        }

        return value;
    };

    Selection.prototype._slot = function _slot (value) {
        var categoryAxis = this.categoryAxis;
        var index = this._index(value);

        return categoryAxis.getSlot(index, index, true);
    };

    Selection.prototype.move = function move (from, to) {
        var options = this.options;
        var reverse = this.categoryAxis.options.reverse;
        var offset = options.offset;
        var padding = options.padding;
        var border = options.selection.border;
        var left = reverse ? to : from;
        var right = reverse ? from : to;
        var edge = 'x' + (reverse ? 2 : 1);

        var box = this._slot(left);
        var leftMaskWidth = round$1(box[edge] - offset.left + padding.left);

        elementStyles$1(this.leftMask, {
            width: leftMaskWidth
        });
        elementStyles$1(this.selection, {
            left: leftMaskWidth
        });

        box = this._slot(right);

        var rightMaskWidth = round$1(options.width - (box[edge] - offset.left + padding.left));
        elementStyles$1(this.rightMask, {
            width: rightMaskWidth
        });

        var distance = options.width - rightMaskWidth;
        if (distance !== options.width) {
            distance += border.right;
        }

        elementStyles$1(this.rightMask, {
            left: distance
        });
        elementStyles$1(this.selection, {
            width: Math.max(options.width - (leftMaskWidth + rightMaskWidth) - border.right, 0)
        });
    };

    Selection.prototype.set = function set (from, to) {
        var options = this.options;
        var min = this._index(options.min);
        var max = this._index(options.max);
        var fromValue = limitValue(this._index(from), min, max);
        var toValue = limitValue(this._index(to), fromValue + 1, max);

        if (options.visible) {
            this.move(fromValue, toValue);
        }

        options.from = this._value(fromValue);
        options.to = this._value(toValue);
    };

    Selection.prototype.expand = function expand (delta) {
        var options = this.options;
        var min = this._index(options.min);
        var max = this._index(options.max);
        var zDir = options.mousewheel.zoom;
        var from = this._index(options.from);
        var to = this._index(options.to);
        var range = { from: from, to: to };
        var oldRange = deepExtend({}, range);

        if (this._state) {
            range = this._state.range;
        }

        if (zDir !== RIGHT) {
            range.from = limitValue(
                limitValue(from - delta, 0, to - 1),
                min, max
            );
        }

        if (zDir !== LEFT) {
            range.to = limitValue(
                limitValue(to + delta, range.from + 1, max),
                min,
                max
            );
        }

        if (range.from !== oldRange.from || range.to !== oldRange.to) {
            this.set(range.from, range.to);
            return true;
        }
    };

    Selection.prototype.zoom = function zoom (delta, coords) {
        var options = this.options;
        var min = this._index(options.min);
        var max = this._index(options.max);
        var from = this._index(options.from);
        var to = this._index(options.to);
        var range = { from: from, to: to };
        var oldRange = deepExtend({}, range);

        var ref = this.categoryAxis.options;
        var reverse = ref.reverse;
        var origin = X + (reverse ? '2' : '1');
        var lineBox = this.categoryAxis.lineBox();
        var relative = Math.abs(lineBox[origin] - coords[X]);
        var size = lineBox.width();
        var position = round$1(relative / size, 2);
        var minDelta = round$1(position * delta);
        var maxDelta = round$1((1 - position) * delta);

        if (this._state) {
            range = this._state.range;
        }

        range.from = limitValue(
            limitValue(from - minDelta, 0, to - 1),
            min, max
        );

        range.to = limitValue(
            limitValue(to + maxDelta, range.from + 1, max),
            min,
            max
        );

        if (range.from !== oldRange.from || range.to !== oldRange.to) {
            this.set(range.from, range.to);
            return true;
        }
    };

    Selection.prototype.trigger = function trigger (name, args) {
        return (this.observer || this.chart).trigger(name, args);
    };

    return Selection;
}(Class));

setDefaultOptions(Selection, {
    visible: true,
    mousewheel: {
        zoom: "both"
    },
    min: MIN_VALUE,
    max: MAX_VALUE
});

var Tooltip$1 = (function (BaseTooltip) {
    function Tooltip () {
        BaseTooltip.apply(this, arguments);
    }

    if ( BaseTooltip ) Tooltip.__proto__ = BaseTooltip;
    Tooltip.prototype = Object.create( BaseTooltip && BaseTooltip.prototype );
    Tooltip.prototype.constructor = Tooltip;

    Tooltip.prototype.show = function show (point) {
        if (!point || !point.tooltipAnchor || (this._current && this._current === point)) {
            return;
        }

        var options = deepExtend({}, this.options, point.options.tooltip);
        var anchor = point.tooltipAnchor();

        if (anchor) {
            this._current = point;
            BaseTooltip.prototype.show.call(this, {
                point: point,
                anchor: anchor
            }, options, point);
        } else {
            this.hide();
        }
    };

    Tooltip.prototype.hide = function hide () {
        delete this._current;
        BaseTooltip.prototype.hide.call(this);
    };

    return Tooltip;
}(BaseTooltip));

var SharedTooltip$1 = (function (BaseTooltip) {
    function SharedTooltip(plotArea, options) {
        BaseTooltip.call(this, plotArea.chartService, options);

        this.plotArea = plotArea;
        this.formatService = plotArea.chartService.format;
    }

    if ( BaseTooltip ) SharedTooltip.__proto__ = BaseTooltip;
    SharedTooltip.prototype = Object.create( BaseTooltip && BaseTooltip.prototype );
    SharedTooltip.prototype.constructor = SharedTooltip;

    SharedTooltip.prototype.showAt = function showAt (points, coords) {
        var tooltipPoints = grep(points, function(point) {
            var tooltip = point.series.tooltip;
            var excluded = tooltip && tooltip.visible === false;

            return !excluded;
        });

        if (tooltipPoints.length > 0) {
            var point = tooltipPoints[0];
            var slot = this.plotArea.categoryAxis.getSlot(point.categoryIx);

            var anchor = coords ? this._slotAnchor(coords, slot) : this._defaultAnchor(point, slot);

            this.show({
                anchor: anchor,
                shared: true,
                points: points,
                category: point.category,
                categoryText: this.formatService.auto(this.options.categoryFormat, point.category),
                series: this.plotArea.series
            }, this.options);
        }
    };

    SharedTooltip.prototype._slotAnchor = function _slotAnchor (point, slot) {
        var axis = this.plotArea.categoryAxis;
        var align = {
            horizontal: "left",
            vertical: "center"
        };

        if (!axis.options.vertical) {
            point.x = slot.center().x;
        }

        return {
            point: point,
            align: align
        };
    };

    SharedTooltip.prototype._defaultAnchor = function _defaultAnchor (point, slot) {
        var box = point.owner.pane.chartsBox();
        var vertical = this.plotArea.categoryAxis.options.vertical;
        var center = box.center();
        var slotCenter = slot.center();
        var align = {
            horizontal: "center",
            vertical: "center"
        };

        var centerPoint;
        if (vertical) {
            centerPoint = new Point$5(center.x, slotCenter.y);
        } else {
            centerPoint = new Point$5(slotCenter.x, center.y);
        }

        return {
            point: centerPoint,
            align: align
        };
    };

    return SharedTooltip;
}(BaseTooltip));

setDefaultOptions(SharedTooltip$1, {
    categoryFormat: '{0:d}'
});

var BarChartAnimation = (function (superclass) {
    function BarChartAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) BarChartAnimation.__proto__ = superclass;
    BarChartAnimation.prototype = Object.create( superclass && superclass.prototype );
    BarChartAnimation.prototype.constructor = BarChartAnimation;

    BarChartAnimation.prototype.setup = function setup () {
        var ref = this;
        var element = ref.element;
        var options = ref.options;
        var bbox = element.bbox();

        if (bbox) {
            this.origin = options.origin;
            var axis = options.vertical ? Y : X;

            var fromScale = this.fromScale = new Point$6(1, 1);
            fromScale[axis] = START_SCALE;

            element.transform(transform()
                .scale(fromScale.x, fromScale.y)
            );
        } else {
            this.abort();
        }
    };

    BarChartAnimation.prototype.step = function step (pos) {
        var scaleX = interpolateValue(this.fromScale.x, 1, pos);
        var scaleY = interpolateValue(this.fromScale.y, 1, pos);

        this.element.transform(transform()
            .scale(scaleX, scaleY, this.origin)
        );
    };

    BarChartAnimation.prototype.abort = function abort () {
        superclass.prototype.abort.call(this);
        this.element.transform(null);
    };

    return BarChartAnimation;
}(Animation$1));

setDefaultOptions(BarChartAnimation, {
    duration: INITIAL_ANIMATION_DURATION
});

AnimationFactory.current.register(BAR, BarChartAnimation);

var BubbleAnimation = (function (superclass) {
    function BubbleAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) BubbleAnimation.__proto__ = superclass;
    BubbleAnimation.prototype = Object.create( superclass && superclass.prototype );
    BubbleAnimation.prototype.constructor = BubbleAnimation;

    BubbleAnimation.prototype.setup = function setup () {
        var center = this.center = this.element.bbox().center();
        this.element.transform(transform()
            .scale(START_SCALE, START_SCALE, center)
        );
    };

    BubbleAnimation.prototype.step = function step (pos) {
        this.element.transform(transform()
            .scale(pos, pos, this.center)
        );
    };

    return BubbleAnimation;
}(Animation$1));

setDefaultOptions(BubbleAnimation, {
    easing: "easeOutElastic"
});

AnimationFactory.current.register(BUBBLE, BubbleAnimation);

var FadeInAnimation = (function (superclass) {
    function FadeInAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) FadeInAnimation.__proto__ = superclass;
    FadeInAnimation.prototype = Object.create( superclass && superclass.prototype );
    FadeInAnimation.prototype.constructor = FadeInAnimation;

    FadeInAnimation.prototype.setup = function setup () {
        this.fadeTo = this.element.opacity();
        this.element.opacity(0);
    };

    FadeInAnimation.prototype.step = function step (pos) {
        this.element.opacity(pos * this.fadeTo);
    };

    return FadeInAnimation;
}(Animation$1));

setDefaultOptions(FadeInAnimation, {
    duration: 200,
    easing: "linear"
});

AnimationFactory.current.register(FADEIN, FadeInAnimation);

var PieAnimation = (function (superclass) {
    function PieAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) PieAnimation.__proto__ = superclass;
    PieAnimation.prototype = Object.create( superclass && superclass.prototype );
    PieAnimation.prototype.constructor = PieAnimation;

    PieAnimation.prototype.setup = function setup () {
        this.element.transform(transform()
            .scale(START_SCALE, START_SCALE, this.options.center)
        );
    };

    PieAnimation.prototype.step = function step (pos) {
        this.element.transform(transform()
            .scale(pos, pos, this.options.center)
        );
    };

    return PieAnimation;
}(Animation$1));

setDefaultOptions(PieAnimation, {
    easing: "easeOutElastic",
    duration: INITIAL_ANIMATION_DURATION
});

AnimationFactory.current.register(PIE, PieAnimation);

var ScatterLineChart = (function (ScatterChart) {
    function ScatterLineChart () {
        ScatterChart.apply(this, arguments);
    }

    if ( ScatterChart ) ScatterLineChart.__proto__ = ScatterChart;
    ScatterLineChart.prototype = Object.create( ScatterChart && ScatterChart.prototype );
    ScatterLineChart.prototype.constructor = ScatterLineChart;

    ScatterLineChart.prototype.render = function render () {
        ScatterChart.prototype.render.call(this);

        this.renderSegments();
    };

    ScatterLineChart.prototype.createSegment = function createSegment (linePoints, currentSeries, seriesIx) {
        var style = currentSeries.style;
        var pointType;

        if (style === SMOOTH) {
            pointType = SplineSegment;
        } else {
            pointType = LineSegment;
        }

        return new pointType(linePoints, currentSeries, seriesIx);
    };

    ScatterLineChart.prototype.animationPoints = function animationPoints () {
        var points = ScatterChart.prototype.animationPoints.call(this);
        return points.concat(this._segments);
    };

    ScatterLineChart.prototype.createMissingValue = function createMissingValue (value, missingValues) {
        if (missingValues === ZERO) {
            var missingValue = {
                x: value.x,
                y: value.y
            };
            if (!hasValue$2(missingValue.x)) {
                missingValue.x = 0;
            }
            if (!hasValue$2(missingValue.y)) {
                missingValue.y = 0;
            }
            return missingValue;
        }
    };

    return ScatterLineChart;
}(ScatterChart));

deepExtend(ScatterLineChart.prototype, LineChartMixin);

function getScatterTrendlineData(valueMapper, range, options) {
    var data = [];
    var xMin = range.xMin;
    var xMax = range.xMax;

    var forecast = (options || {}).forecast;
    if (forecast) {
        if (forecast.before > 0) {
            xMin -= forecast.before;
        }

        if (forecast.after > 0) {
            xMax += forecast.after;
        }
    }

    var samplingInterval = (options || {}).samplingInterval;
    var delta = valueOrDefault(samplingInterval,  autoMajorUnit(xMin, xMax) / 10);
    if (samplingInterval <= 0) {
        delta = xMax - xMin;
    }

    for (var x = xMin; x <= xMax; x += delta) {
        data.push([
            x,
            valueMapper(x)
        ]);
    }

    return data;
}

function scatterExponentialTrendline(context) {
    var options = context.options;
    var seriesValues = context.seriesValues;

    var data = getData$5({ seriesValues: seriesValues, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'scatterLine',
            data: data});
    }

    return null;
}

var valueGetter$2 = function (fieldName) { return function (ref) {
        var valueFields = ref.valueFields;

        return ({ xValue: valueFields.x, yValue: Math.log(valueFields[fieldName]) });
; }    };

function getData$5(ref) {
    var seriesValues = ref.seriesValues;
    var options = ref.options;

    var sourceValues = seriesValues();
    if (!checkAllPositive(sourceValues, options.field)) {
        return null;
    }

    var ref$1 = calculateSlope(sourceValues, valueGetter$2(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;
    var xMin = ref$1.xMin;
    var xMax = ref$1.xMax;
    var range = { xMin: xMin, xMax: xMax };

    if (count > 0) {
        // Exponential trendline equation:
        // y = a * e ^ (b * x)
        var a = Math.exp(intercept);
        var b = slope;

        return getScatterTrendlineData(function (x) { return a * Math.exp(b * x); }, range, options.trendline);
    }

    return null;
}

var scatterValueGetter = function (fieldName) { return function (ref) {
        var valueFields = ref.valueFields;

        return ({ xValue: valueFields.x, yValue: valueFields[fieldName] });
; }    };

function scatterLinearTrendline(context) {
    var options = context.options;
    var seriesValues = context.seriesValues;

    var data = getData$4({ seriesValues: seriesValues, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'scatterLine',
            data: data});
    }

    return null;
}

function getData$4(ref) {
    var seriesValues = ref.seriesValues;
    var options = ref.options;

    var ref$1 = calculateSlope(seriesValues(), scatterValueGetter(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;
    var xMin = ref$1.xMin;
    var xMax = ref$1.xMax;
    var range = { xMin: xMin, xMax: xMax };

    if (count > 0) {
        return getScatterTrendlineData(function (x) { return slope * x + intercept; }, range, options.trendline);
    }

    return null;
}

function xValueLimits(sourceValues, valueGetter) {
    var xMin = Number.MAX_VALUE;
    var xMax = Number.MIN_VALUE;

    for (var i = 0; i < sourceValues.length; i++) {
        var value = sourceValues[i];
        var ref = valueGetter(value);
        var xValue = ref.xValue;
        var yValue = ref.yValue;

        if (isFinite(xValue) && xValue !== null && isFinite(yValue) && yValue !== null) {
            xMin = Math.min(xValue, xMin);
            xMax = Math.max(xValue, xMax);
        }
    }

    return { xMin: xMin, xMax: xMax };
}

function scatterLogarithmicTrendline(context) {
    var options = context.options;
    var seriesValues = context.seriesValues;

    var data = getData$3({ seriesValues: seriesValues, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'scatterLine',
            data: data});
    }

    return null;
}

var valueGetter$1 = function (fieldName) { return function (ref) {
        var valueFields = ref.valueFields;

        return ({ xValue: valueFields.x, yValue: valueFields[fieldName] });
; }    };

var logValueGetter = function (fieldName) { return function (ref) {
        var valueFields = ref.valueFields;

        return ({ xValue: Math.log(valueFields.x), yValue: valueFields[fieldName] });
; }    };

function getData$3(ref) {
    var seriesValues = ref.seriesValues;
    var options = ref.options;

    var sourceValues = seriesValues();
    if (!checkAllPositive(sourceValues, 'x')) {
        return null;
    }

    var ref$1 = calculateSlope(sourceValues, logValueGetter(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;
    var range = xValueLimits(sourceValues, valueGetter$1(options.field));

    if (count > 0) {
        // Logarithmic trendline equation:
        // y = a * ln (x) + b
        var a = slope;
        var b = intercept;

        return getScatterTrendlineData(function (x) { return a * Math.log(x) + b; }, range, options.trendline);
    }

    return null;
}

function scatterMovingAverageTrendline(context) {
    var options = context.options;

    var data = getData$2(context);
    if (data) {
        return Object.assign({}, options,

            {type: 'scatterLine',
            data: data});
    }

    return null;
}

function getData$2(ref) {
    var options = ref.options;
    var seriesValues = ref.seriesValues;

    var period = (options.trendline || {}).period || MIN_MOVING_AVERAGE_PERIOD;
    var range = { before: period, after: period };
    var data = calculateMovingAverage(seriesValues(range), scatterValueGetter(options.field), period);

    if (data.length > 0) {
        return data;
    }

    return null;
}

function scatterPolynomialTrendline(context) {
    var options = context.options;
    var seriesValues = context.seriesValues;

    var data = getData$1({ seriesValues: seriesValues, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'scatterLine',
            data: data});
    }

    return null;
}

function getData$1(ref) {
    var seriesValues = ref.seriesValues;
    var options = ref.options;

    var order = (options.trendline || {}).order;
    var valueGetter = scatterValueGetter(options.field);
    var ref$1 = calculatePolynomial(seriesValues(), valueGetter, order);
    var count = ref$1.count;
    var valueMapper = ref$1.valueMapper;
    var xMin = ref$1.xMin;
    var xMax = ref$1.xMax;
    var range = { xMin: xMin, xMax: xMax };

    if (count > 0) {
        // Polynomial trendline equation:
        // y = aN * x^N + ... + a2 * x^2 + a1 * x + a0
        return getScatterTrendlineData(valueMapper, range, options.trendline);
    }

    return null;
}

function scatterPowerTrendline(context) {
    var options = context.options;
    var seriesValues = context.seriesValues;

    var data = getData({ seriesValues: seriesValues, options: options });
    if (data) {
        return Object.assign({}, options,

            {type: 'scatterLine',
            data: data});
    }

    return null;
}

var valueGetter = function (fieldName) { return function (ref) {
        var valueFields = ref.valueFields;

        return ({ xValue: Math.log(valueFields.x), yValue: Math.log(valueFields[fieldName]) });
; }    };

function getData(ref) {
    var seriesValues = ref.seriesValues;
    var options = ref.options;

    var sourceValues = seriesValues();
    if (!checkAllPositive(sourceValues, 'x')) {
        return null;
    }

    var ref$1 = calculateSlope(sourceValues, valueGetter(options.field));
    var slope = ref$1.slope;
    var intercept = ref$1.intercept;
    var count = ref$1.count;
    var range = xValueLimits(sourceValues, scatterValueGetter(options.field));

    if (count > 0) {
        // Power trendline equation:
        // y = a * x ^ b
        var a = Math.exp(intercept);
        var b = slope;
        return getScatterTrendlineData(function (x) { return a * Math.pow(x, b); }, range, options.trendline);
    }

    return null;
}

var scatterRegistry = {};
scatterRegistry[TRENDLINE_EXPONENTIAL] = scatterExponentialTrendline;
scatterRegistry[TRENDLINE_LINEAR] = scatterLinearTrendline;
scatterRegistry[TRENDLINE_LOGARITHMIC] = scatterLogarithmicTrendline;
scatterRegistry[TRENDLINE_MOVING_AVERAGE] = scatterMovingAverageTrendline;
scatterRegistry[TRENDLINE_POLYNOMIAL] = scatterPolynomialTrendline;
scatterRegistry[TRENDLINE_POWER] = scatterPowerTrendline;

var XYPlotArea = (function (PlotAreaBase) {
    function XYPlotArea () {
        PlotAreaBase.apply(this, arguments);
    }

    if ( PlotAreaBase ) XYPlotArea.__proto__ = PlotAreaBase;
    XYPlotArea.prototype = Object.create( PlotAreaBase && PlotAreaBase.prototype );
    XYPlotArea.prototype.constructor = XYPlotArea;

    XYPlotArea.prototype.initFields = function initFields () {
        this.namedXAxes = {};
        this.namedYAxes = {};

        this.xAxisRangeTracker = new AxisGroupRangeTracker();
        this.yAxisRangeTracker = new AxisGroupRangeTracker();
    };

    XYPlotArea.prototype.render = function render (panes) {
        var this$1$1 = this;
        if ( panes === void 0 ) panes = this.panes;

        this.series = [].concat( this.originalSeries );
        this.createTrendlineSeries();

        var seriesByPane = this.groupSeriesByPane();
        for (var i = 0; i < panes.length; i++) {
            var pane = panes[i];
            var paneSeries = seriesByPane[pane.options.name || "default"] || [];
            this$1$1.addToLegend(paneSeries);
            var filteredSeries = this$1$1.filterVisibleSeries(paneSeries);

            if (!filteredSeries) {
                continue;
            }

            this$1$1.createScatterChart(
                filterSeriesByType(filteredSeries, SCATTER),
                pane
            );

            this$1$1.createScatterLineChart(
                filterSeriesByType(filteredSeries, SCATTER_LINE),
                pane
            );

            this$1$1.createBubbleChart(
                filterSeriesByType(filteredSeries, BUBBLE),
                pane
            );
        }

        this.createAxes(panes);
    };

    XYPlotArea.prototype.appendChart = function appendChart (chart, pane) {
        this.xAxisRangeTracker.update(chart.xAxisRanges);
        this.yAxisRangeTracker.update(chart.yAxisRanges);

        PlotAreaBase.prototype.appendChart.call(this, chart, pane);
    };

    XYPlotArea.prototype.removeAxis = function removeAxis (axis) {
        var axisName = axis.options.name;

        PlotAreaBase.prototype.removeAxis.call(this, axis);

        if (axis.options.vertical) {
            this.yAxisRangeTracker.reset(axisName);
            delete this.namedYAxes[axisName];
        } else {
            this.xAxisRangeTracker.reset(axisName);
            delete this.namedXAxes[axisName];
        }

        if (axis === this.axisX) {
            delete this.axisX;
        }

        if (axis === this.axisY) {
            delete this.axisY;
        }
    };

    // TODO: Refactor, optionally use series.pane option
    XYPlotArea.prototype.seriesPaneName = function seriesPaneName (series) {
        var options = this.options;
        var xAxisName = series.xAxis;
        var xAxisOptions = [].concat(options.xAxis);
        var xAxis = grep(xAxisOptions, function(a) { return a.name === xAxisName; })[0];
        var yAxisName = series.yAxis;
        var yAxisOptions = [].concat(options.yAxis);
        var yAxis = grep(yAxisOptions, function(a) { return a.name === yAxisName; })[0];
        var panes = options.panes || [ {} ];
        var defaultPaneName = panes[0].name || "default";
        var paneName = (xAxis || {}).pane || (yAxis || {}).pane || defaultPaneName;

        return paneName;
    };

    XYPlotArea.prototype.createScatterChart = function createScatterChart (series, pane) {
        if (series.length > 0) {
            this.appendChart(
                new ScatterChart(this, { series: series, clip: pane.options.clip }),
                pane
            );
        }
    };

    XYPlotArea.prototype.createScatterLineChart = function createScatterLineChart (series, pane) {
        if (series.length > 0) {
            this.appendChart(
                new ScatterLineChart(this, { series: series, clip: pane.options.clip }),
                pane
            );
        }
    };

    XYPlotArea.prototype.createBubbleChart = function createBubbleChart (series, pane) {
        if (series.length > 0) {
            this.appendChart(
                new BubbleChart(this, { series: series, clip: pane.options.clip }),
                pane
            );
        }
    };

    XYPlotArea.prototype.createXYAxis = function createXYAxis (options, vertical, axisIndex) {
        var axisName = options.name;
        var namedAxes = vertical ? this.namedYAxes : this.namedXAxes;
        var tracker = vertical ? this.yAxisRangeTracker : this.xAxisRangeTracker;
        var axisOptions = deepExtend({ reverse: !vertical && this.chartService.rtl }, options, { vertical: vertical });
        var isLog = equalsIgnoreCase(axisOptions.type, LOGARITHMIC);
        var defaultRange = tracker.query();
        var defaultAxisRange = isLog ? { min: 0.1, max: 1 } : { min: 0, max: 1 };
        var range = tracker.query(axisName) || defaultRange || defaultAxisRange;
        var typeSamples = [ axisOptions.min, axisOptions.max ];
        var series = this.series;

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];
            var seriesAxisName = currentSeries[vertical ? "yAxis" : "xAxis"];
            if ((seriesAxisName === axisOptions.name) || (axisIndex === 0 && !seriesAxisName)) {
                var firstPointValue = SeriesBinder.current.bindPoint(currentSeries, 0).valueFields;
                typeSamples.push(firstPointValue[vertical ? "y" : "x"]);

                break;
            }
        }

        if (axisIndex === 0 && defaultRange) {
            range.min = Math.min(range.min, defaultRange.min);
            range.max = Math.max(range.max, defaultRange.max);
        }

        var inferredDate;

        for (var i = 0; i < typeSamples.length; i++) {
            if (typeSamples[i] instanceof Date) {
                inferredDate = true;
                break;
            }
        }

        var axisType;
        if (equalsIgnoreCase(axisOptions.type, DATE) || (!axisOptions.type && inferredDate)) {
            axisType = DateValueAxis;
        } else if (isLog) {
            axisType = LogarithmicAxis;
        } else {
            axisType = NumericAxis;
        }

        var axis = new axisType(range.min, range.max, axisOptions, this.chartService);
        axis.axisIndex = axisIndex;

        if (axisName) {
            if (namedAxes[axisName]) {
                throw new Error(((vertical ? "Y" : "X") + " axis with name " + axisName + " is already defined"));
            }
            namedAxes[axisName] = axis;
        }

        this.appendAxis(axis);

        return axis;
    };

    XYPlotArea.prototype.createAxes = function createAxes (panes) {
        var this$1$1 = this;

        var options = this.options;
        var xAxesOptions = [].concat(options.xAxis);
        var xAxes = [];
        var yAxesOptions = [].concat(options.yAxis);
        var yAxes = [];

        for (var idx = 0; idx < xAxesOptions.length; idx++) {
            var axisPane = this$1$1.findPane(xAxesOptions[idx].pane);
            if (inArray(axisPane, panes)) {
                xAxes.push(this$1$1.createXYAxis(xAxesOptions[idx], false, idx));
            }
        }

        for (var idx$1 = 0; idx$1 < yAxesOptions.length; idx$1++) {
            var axisPane$1 = this$1$1.findPane(yAxesOptions[idx$1].pane);
            if (inArray(axisPane$1, panes)) {
                yAxes.push(this$1$1.createXYAxis(yAxesOptions[idx$1], true, idx$1));
            }
        }

        this.axisX = this.axisX || xAxes[0];
        this.axisY = this.axisY || yAxes[0];
    };

    XYPlotArea.prototype._dispatchEvent = function _dispatchEvent (chart, e, eventType) {
        var coords = chart._eventCoordinates(e);
        var point = new Point$5(coords.x, coords.y);
        var allAxes = this.axes;
        var length = allAxes.length;
        var xValues = [];
        var yValues = [];

        for (var i = 0; i < length; i++) {
            var axis = allAxes[i];
            var values = axis.options.vertical ? yValues : xValues;
            var currentValue = axis.getValue(point);
            if (currentValue !== null) {
                values.push(currentValue);
            }
        }

        if (xValues.length > 0 && yValues.length > 0) {
            chart.trigger(eventType, {
                element: eventElement(e),
                originalEvent: e,
                x: singleItemOrArray(xValues),
                y: singleItemOrArray(yValues)
            });
        }
    };

    XYPlotArea.prototype.updateAxisOptions = function updateAxisOptions$1$1 (axis, options) {
        var vertical = axis.options.vertical;
        var axes = this.groupAxes(this.panes);
        var index = (vertical ? axes.y : axes.x).indexOf(axis);

        updateAxisOptions$1(this.options, index, vertical, options);
        updateAxisOptions$1(this.originalOptions, index, vertical, options);
    };

    XYPlotArea.prototype.trendlineFactory = function trendlineFactory$1 (options, series) {
        var seriesValues = this.seriesValues.bind(this, series.index);

        var trendline = trendlineFactory(scatterRegistry, options.type, {
            options: options,
            seriesValues: seriesValues
        });

        if (trendline) {
            // Inherit settings
            trendline.xAxis = series.xAxis;
            trendline.yAxis = series.yAxis;
        }

        return trendline;
    };

    XYPlotArea.prototype.seriesValues = function seriesValues (seriesIx) {
        var this$1$1 = this;

        var result = [];
        var currentSeries = this.series[seriesIx];

        for (var pointIx = 0; pointIx < currentSeries.data.length; pointIx++) {
            var data = this$1$1.bindPoint(currentSeries, pointIx);
            result.push({ pointIx: pointIx, valueFields: data.valueFields });
        }

        return result;
    };

    return XYPlotArea;
}(PlotAreaBase));

function updateAxisOptions$1(targetOptions, axisIndex, vertical, options) {
    var axisOptions = ([].concat(vertical ? targetOptions.yAxis : targetOptions.xAxis))[axisIndex];
    deepExtend(axisOptions, options);
}

setDefaultOptions(XYPlotArea, {
    xAxis: {},
    yAxis: {}
});

deepExtend(XYPlotArea.prototype, PlotAreaEventsMixin);

var PieSegment = (function (ChartElement) {
    function PieSegment(value, sector, options) {
        ChartElement.call(this, options);

        this.value = value;
        this.sector = sector;
    }

    if ( ChartElement ) PieSegment.__proto__ = ChartElement;
    PieSegment.prototype = Object.create( ChartElement && ChartElement.prototype );
    PieSegment.prototype.constructor = PieSegment;

    PieSegment.prototype.render = function render () {
        if (this._rendered || this.visible === false) {
            return;
        }
        this._rendered = true;

        this.createLabel();
    };

    PieSegment.prototype.createLabel = function createLabel () {
        var labels = this.options.labels;
        var chartService = this.owner.chartService;
        var labelText = this.getLabelText(labels);

        if (labels.visible && (labelText || labelText === 0)) {
            if (labels.position === CENTER || labels.position === INSIDE_END) {
                if (!labels.color) {
                    labels.color = autoTextColor(this.options.color);
                }
                if (!labels.background) {
                    labels.background = this.options.color;
                }
            } else {
                var themeLabels = chartService.theme.seriesDefaults.labels;
                labels.color = labels.color || themeLabels.color;
                labels.background = labels.background || themeLabels.background;
            }


            this.label = new TextBox(labelText, deepExtend({}, labels, {
                align: CENTER,
                vAlign: "",
                animation: {
                    type: FADEIN,
                    delay: this.animationDelay
                }
            }), this.pointData());

            this.append(this.label);
        }
    };

    PieSegment.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = getTemplate$1(options);

        if (labelTemplate) {
            return labelTemplate(this.pointData());
        }

        return this.owner.chartService.format.auto(options.format, this.value);
    };

    PieSegment.prototype.reflow = function reflow (targetBox) {
        this.render();
        this.box = targetBox;
        this.reflowLabel();
    };

    PieSegment.prototype.reflowLabel = function reflowLabel () {
        var ref = this;
        var labelsOptions = ref.options.labels;
        var label = ref.label;
        var sector = this.sector.clone();
        var labelsDistance = labelsOptions.distance;
        var angle = sector.middle();

        if (label) {
            var labelHeight = label.box.height();
            var labelWidth = label.box.width();
            var lp;

            if (labelsOptions.position === CENTER) {
                sector.radius = Math.abs((sector.radius - labelHeight) / 2) + labelHeight;
                lp = sector.point(angle);
                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
            } else if (labelsOptions.position === INSIDE_END) {
                sector.radius = sector.radius - labelHeight / 2;
                lp = sector.point(angle);
                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
            } else {
                var x1;
                lp = sector.clone().expand(labelsDistance).point(angle);
                if (lp.x >= sector.center.x) {
                    x1 = lp.x + labelWidth;
                    label.orientation = RIGHT;
                } else {
                    x1 = lp.x - labelWidth;
                    label.orientation = LEFT;
                }
                label.reflow(new Box(x1, lp.y - labelHeight, lp.x, lp.y));
            }
        }
    };

    PieSegment.prototype.createVisual = function createVisual () {
        var this$1$1 = this;

        var ref = this;
        var sector = ref.sector;
        var options = ref.options;

        ChartElement.prototype.createVisual.call(this);

        this.addAccessibilityAttributesToVisual();

        if (this.value) {
            if (options.visual) {
                var startAngle = (sector.startAngle + 180) % 360;
                var visual = options.visual({
                    category: this.category,
                    dataItem: this.dataItem,
                    value: this.value,
                    series: this.series,
                    percentage: this.percentage,
                    center: new Point$6(sector.center.x, sector.center.y),
                    radius: sector.radius,
                    innerRadius: sector.innerRadius,
                    startAngle: startAngle,
                    endAngle: startAngle + sector.angle,
                    options: options,
                    sender: this.getSender(),
                    createVisual: function () {
                        var group = new Group$8();
                        this$1$1.createSegmentVisual(group);

                        return group;
                    }
                });

                if (visual) {
                    this.visual.append(visual);
                }
            } else {
                this.createSegmentVisual(this.visual);
            }
        }
    };

    PieSegment.prototype.createSegmentVisual = function createSegmentVisual (group) {
        var ref = this;
        var sector = ref.sector;
        var options = ref.options;
        var borderOptions = options.border || {};
        var border = borderOptions.width > 0 ? {
            stroke: {
                color: borderOptions.color,
                width: borderOptions.width,
                opacity: borderOptions.opacity,
                dashType: borderOptions.dashType
            }
        } : {};
        var color = options.color;
        var fill = createPatternFill(options.pattern, {
            color: color,
            opacity: options.opacity
        });
        var visual = this.createSegment(sector, deepExtend({
            fill: fill,
            stroke: {
                opacity: options.opacity
            },
            zIndex: options.zIndex
        }, border));

        group.append(visual);

        if (hasGradientOverlay(options)) {
            group.append(this.createGradientOverlay(visual, {
                baseColor: color,
                fallbackFill: fill
            }, deepExtend({
                center: [ sector.center.x, sector.center.y ],
                innerRadius: sector.innerRadius,
                radius: sector.radius,
                userSpace: true
            }, options.overlay)));
        }
    };

    PieSegment.prototype.createSegment = function createSegment (sector, options) {
        if (options.singleSegment) {
            return new Circle$1(new Circle$2(new Point$6(sector.center.x, sector.center.y), sector.radius), options);
        }

        return ShapeBuilder.current.createRing(sector, options);
    };

    PieSegment.prototype.createAnimation = function createAnimation () {
        var ref = this;
        var options = ref.options;
        var center = ref.sector.center;

        deepExtend(options, {
            animation: {
                center: [ center.x, center.y ],
                delay: this.animationDelay
            }
        });

        ChartElement.prototype.createAnimation.call(this);
    };

    PieSegment.prototype.createHighlight = function createHighlight (options) {
        var highlight = this.options.highlight || {};
        var border = highlight.border || {};

        return this.createSegment(this.sector, deepExtend({}, options, {
            fill: {
                color: highlight.color,
                opacity: highlight.opacity
            },
            stroke: {
                opacity: border.opacity,
                width: border.width,
                color: border.color
            }
        }));
    };

    PieSegment.prototype.highlightVisual = function highlightVisual () {
        return this.visual.children[0];
    };

    PieSegment.prototype.highlightVisualArgs = function highlightVisualArgs () {
        var sector = this.sector;

        return {
            options: this.options,
            radius: sector.radius,
            innerRadius: sector.innerRadius,
            center: new Point$6(sector.center.x, sector.center.y),
            startAngle: sector.startAngle,
            endAngle: sector.angle + sector.startAngle,
            visual: this.visual
        };
    };

    PieSegment.prototype.createFocusHighlight = function createFocusHighlight (style) {
        var borderWidth = this.options.focusHighlight.border.width;
        var result = this.createSegment(this.sector, deepExtend({}, style, {
            stroke: {
                width: borderWidth * 2
            }
        }));

        var clipPath = new MultiPath();

        clipPath.paths.push(Path$7.fromRect(result.bbox()));
        clipPath.paths.push(this.createSegment(this.sector, {}));

        result.clip(clipPath);

        return result;
    };

    PieSegment.prototype.tooltipAnchor = function tooltipAnchor () {
        var sector = this.sector.clone().expand(TOOLTIP_OFFSET);
        var midAndle = sector.middle();
        var midPoint = sector.point(midAndle);

        return {
            point: midPoint,
            align: tooltipAlignment(midAndle + 180)
        };
    };

    PieSegment.prototype.formatValue = function formatValue (format) {
        return this.owner.formatPointValue(this, format);
    };

    PieSegment.prototype.pointData = function pointData () {
        return {
            dataItem: this.dataItem,
            category: this.category,
            value: this.value,
            series: this.series,
            percentage: this.percentage
        };
    };

    PieSegment.prototype.getIndex = function getIndex () {
        return this.index;
    };

    return PieSegment;
}(ChartElement));

var RAD_30 = round$1(rad(30), DEFAULT_PRECISION);
var RAD_60 = round$1(rad(60), DEFAULT_PRECISION);

function tooltipAlignment(angle) {
    var radians = rad(angle);
    var sine = round$1(Math.sin(radians), DEFAULT_PRECISION);
    var cosine = round$1(Math.cos(radians), DEFAULT_PRECISION);


    var horizontal;
    if (Math.abs(sine) > RAD_60) {
        horizontal = CENTER;
    } else if (cosine < 0) {
        horizontal = RIGHT;
    } else {
        horizontal = LEFT;
    }

    var vertical;
    if (Math.abs(sine) < RAD_30) {
        vertical = CENTER;
    } else if (sine < 0) {
        vertical = BOTTOM$1;
    } else {
        vertical = TOP;
    }

    return {
        horizontal: horizontal,
        vertical: vertical
    };
}

setDefaultOptions(PieSegment, {
    color: WHITE$1,
    overlay: {
        gradient: "roundedBevel"
    },
    border: {
        width: 0.5
    },
    labels: {
        visible: false,
        distance: 35,
        font: DEFAULT_FONT,
        margin: getSpacing(0.5),
        align: CIRCLE,
        zIndex: 1,
        position: OUTSIDE_END
    },
    animation: {
        type: PIE
    },
    highlight: {
        visible: true,
        border: {
            width: 1
        }
    },
    visible: true,
    accessibility: {
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
});

deepExtend(PieSegment.prototype, PointEventsMixin);
deepExtend(PieSegment.prototype, AccessibilityAttributesMixin);

var PieChartMixin = {
    createLegendItem: function(value, point, options) {
        var legendOptions = this.options.legend || {};
        var labelsOptions = legendOptions.labels || {};
        var inactiveItems = legendOptions.inactiveItems || {};
        var inactiveItemsLabels = inactiveItems.labels || {};

        if (options && options.visibleInLegend !== false) {
            var pointVisible = options.visible !== false;
            var labelTemplate = pointVisible ? getTemplate$1(labelsOptions) :
                getTemplate$1(inactiveItemsLabels) || getTemplate$1(labelsOptions);
            var text = options.category;

            if (labelTemplate) {
                text = labelTemplate({
                    text: text,
                    series: options.series,
                    dataItem: options.dataItem,
                    percentage: options.percentage,
                    value: value
                });
            }

            var itemLabelOptions, markerColor;
            if (pointVisible) {
                itemLabelOptions = {};
                markerColor = point.color;
            } else {
                itemLabelOptions = {
                    color: inactiveItemsLabels.color,
                    font: inactiveItemsLabels.font
                };
                markerColor = (inactiveItems.markers || {}).color;
            }

            if (hasValue$2(text) && text !== "") {
                this.legendItems.push({
                    active: pointVisible,
                    pointIndex: options.index,
                    text: text,
                    series: options.series,
                    markerColor: markerColor,
                    pattern: point.pattern,
                    labels: itemLabelOptions
                });
            }
        }
    }
};

var PIE_SECTOR_ANIM_DELAY = 70;

var PieChart = (function (ChartElement) {
    function PieChart(plotArea, options) {
        ChartElement.call(this, options);

        this.plotArea = plotArea;
        this.chartService = plotArea.chartService;
        this.points = [];
        this.legendItems = [];
        this.render();
    }

    if ( ChartElement ) PieChart.__proto__ = ChartElement;
    PieChart.prototype = Object.create( ChartElement && ChartElement.prototype );
    PieChart.prototype.constructor = PieChart;

    PieChart.prototype.render = function render () {
        this.traverseDataPoints(this.addValue.bind(this));
    };

    PieChart.prototype.traverseDataPoints = function traverseDataPoints (callback) {
        var this$1$1 = this;

        var ref = this;
        var options = ref.options;
        var seriesColors = ref.plotArea.options.seriesColors; if ( seriesColors === void 0 ) seriesColors = [];
        var colorsCount = seriesColors.length;
        var series = options.series;
        var seriesCount = series.length;

        for (var seriesIx = 0; seriesIx < seriesCount; seriesIx++) {
            var currentSeries = series[seriesIx];
            var data = currentSeries.data;
            var ref$1 = bindSegments(currentSeries);
            var total = ref$1.total;
            var points = ref$1.points;
            var count = ref$1.count;
            var anglePerValue = 360 / total;
            var constantAngle = (void 0);
            if (!isFinite(anglePerValue)) {
                constantAngle = 360 / count;
            }
            var currentAngle = (void 0);

            if (defined(currentSeries.startAngle)) {
                currentAngle = currentSeries.startAngle;
            } else {
                currentAngle = options.startAngle;
            }

            if (seriesIx !== seriesCount - 1) {
                if (currentSeries.labels.position === OUTSIDE_END) {
                    currentSeries.labels.position = CENTER;
                }
            }

            for (var i = 0; i < points.length; i++) {
                var pointData = points[i];
                if (!pointData) {
                    continue;
                }

                var fields = pointData.fields;
                var value = pointData.value;
                var visible = pointData.visible;
                var angle = value !== 0 ? (constantAngle || (value * anglePerValue)) : 0;
                var explode = data.length !== 1 && Boolean(fields.explode);

                if (!isFunction(currentSeries.color)) {
                    currentSeries.color = fields.color || seriesColors[i % colorsCount];
                }

                callback(value, new Ring(null, 0, 0, currentAngle, angle), {
                    owner: this$1$1,
                    category: defined(fields.category) ? fields.category : "",
                    pattern: defined(fields.pattern) ? fields.pattern : currentSeries.pattern,
                    index: i,
                    series: currentSeries,
                    seriesIx: seriesIx,
                    dataItem: data[i],
                    percentage: total !== 0 ? value / total : 0,
                    explode: explode,
                    visibleInLegend: fields.visibleInLegend,
                    visible: visible,
                    zIndex: seriesCount - seriesIx,
                    animationDelay: this$1$1.animationDelay(i, seriesIx, seriesCount)
                });

                if (visible !== false) {
                    currentAngle += angle;
                }
            }
        }
    };

    PieChart.prototype.evalSegmentOptions = function evalSegmentOptions (options, value, fields) {
        var series = fields.series;

        evalOptions(options, {
            value: value,
            series: series,
            dataItem: fields.dataItem,
            category: fields.category,
            percentage: fields.percentage
        }, { defaults: series._defaults, excluded: [
            "data", "content", "template", "visual", "toggle",
            "ariaTemplate", "ariaContent"
        ] });
    };

    PieChart.prototype.addValue = function addValue (value, sector, fields) {
        var segmentOptions = deepExtend({}, fields.series, { index: fields.index });
        segmentOptions.pattern = fields.pattern || segmentOptions.pattern;
        this.evalSegmentOptions(segmentOptions, value, fields);

        this.createLegendItem(value, segmentOptions, fields);

        if (fields.visible === false) {
            return;
        }

        var segment = new PieSegment(value, sector, segmentOptions);
        Object.assign(segment, fields);
        this.append(segment);
        this.points.push(segment);
    };

    PieChart.prototype.reflow = function reflow (targetBox) {
        var ref = this;
        var options = ref.options;
        var points = ref.points;
        var seriesConfigs = ref.seriesConfigs; if ( seriesConfigs === void 0 ) seriesConfigs = [];
        var count = points.length;
        var box = targetBox.clone();
        var space = 5;
        var minWidth = Math.min(box.width(), box.height());
        var halfMinWidth = minWidth / 2;
        var defaultPadding = minWidth - minWidth * 0.85;
        var newBox = new Box(box.x1, box.y1, box.x1 + minWidth, box.y1 + minWidth);
        var newBoxCenter = newBox.center();
        var boxCenter = box.center();
        var seriesCount = options.series.length;
        var leftSideLabels = [];
        var rightSideLabels = [];
        var padding = valueOrDefault(options.padding, defaultPadding);

        this.targetBox = targetBox;

        padding = padding > halfMinWidth - space ? halfMinWidth - space : padding;
        newBox.translate(boxCenter.x - newBoxCenter.x, boxCenter.y - newBoxCenter.y);

        var radius = halfMinWidth - padding;
        var center = new Point$5(
            radius + newBox.x1 + padding,
            radius + newBox.y1 + padding
        );

        for (var i = 0; i < count; i++) {
            var segment = points[i];
            var sector = segment.sector;
            var seriesIndex = segment.seriesIx;
            sector.radius = radius;
            sector.center = center;

            if (seriesConfigs.length) {
                var seriesConfig = seriesConfigs[seriesIndex];
                sector.innerRadius = seriesConfig.innerRadius;
                sector.radius = seriesConfig.radius;
            }

            if (seriesIndex === seriesCount - 1 && segment.explode) {
                sector.center = sector.clone().setRadius(sector.radius * 0.15).point(sector.middle());
            }

            segment.reflow(newBox);

            var label = segment.label;
            if (label) {
                if (label.options.position === OUTSIDE_END) {
                    if (seriesIndex === seriesCount - 1) {
                        if (label.orientation === RIGHT) {
                            rightSideLabels.push(label);
                        } else {
                            leftSideLabels.push(label);
                        }
                    }
                }
            }
        }

        if (leftSideLabels.length > 0) {
            leftSideLabels.sort(this.labelComparator(true));
            this.leftLabelsReflow(leftSideLabels);
        }

        if (rightSideLabels.length > 0) {
            rightSideLabels.sort(this.labelComparator(false));
            this.rightLabelsReflow(rightSideLabels);
        }

        this.box = newBox;
    };

    PieChart.prototype.leftLabelsReflow = function leftLabelsReflow (labels) {
        var distances = this.distanceBetweenLabels(labels);

        this.distributeLabels(distances, labels);
    };

    PieChart.prototype.rightLabelsReflow = function rightLabelsReflow (labels) {
        var distances = this.distanceBetweenLabels(labels);

        this.distributeLabels(distances, labels);
    };

    PieChart.prototype.distanceBetweenLabels = function distanceBetweenLabels (labels) {
        var segment = last(this.points);
        var sector = segment.sector;
        var count = labels.length - 1;
        var lr = sector.radius + segment.options.labels.distance;
        var distances = [];
        var firstBox = labels[0].box;
        var distance = round$1(firstBox.y1 - (sector.center.y - lr - firstBox.height() - firstBox.height() / 2));

        distances.push(distance);

        for (var i = 0; i < count; i++) {
            var secondBox = labels[i + 1].box;

            firstBox = labels[i].box;
            distance = round$1(secondBox.y1 - firstBox.y2);
            distances.push(distance);
        }
        distance = round$1(sector.center.y + lr - labels[count].box.y2 - labels[count].box.height() / 2);
        distances.push(distance);

        return distances;
    };

    PieChart.prototype.distributeLabels = function distributeLabels (distances, labels) {
        var this$1$1 = this;

        var count = distances.length;
        var left, right, remaining;

        for (var i = 0; i < count; i++) {
            remaining = -distances[i];
            left = right = i;

            while (remaining > 0 && (left >= 0 || right < count)) {
                remaining = this$1$1._takeDistance(distances, i, --left, remaining);
                remaining = this$1$1._takeDistance(distances, i, ++right, remaining);
            }
        }

        this.reflowLabels(distances, labels);
    };

    PieChart.prototype._takeDistance = function _takeDistance (distances, anchor, position, amount) {
        var result = amount;
        if (distances[position] > 0) {
            var available = Math.min(distances[position], result);
            result -= available;
            distances[position] -= available;
            distances[anchor] += available;
        }

        return result;
    };

    PieChart.prototype.reflowLabels = function reflowLabels (distances, labels) {
        var this$1$1 = this;

        var segment = last(this.points);
        var sector = segment.sector;
        var labelOptions = segment.options.labels;
        var labelsCount = labels.length;
        var labelDistance = labelOptions.distance;
        var boxY = sector.center.y - (sector.radius + labelDistance) - labels[0].box.height();
        var boxX;

        distances[0] += 2;
        for (var i = 0; i < labelsCount; i++) {
            var label = labels[i];
            var box = label.box;

            boxY += distances[i];
            boxX = this$1$1.hAlignLabel(
                box.x2,
                sector.clone().expand(labelDistance),
                boxY,
                boxY + box.height(),
                label.orientation === RIGHT);

            if (label.orientation === RIGHT) {
                if (labelOptions.align !== CIRCLE) {
                    boxX = sector.radius + sector.center.x + labelDistance;
                }
                label.reflow(new Box(boxX + box.width(), boxY, boxX, boxY));
            } else {
                if (labelOptions.align !== CIRCLE) {
                    boxX = sector.center.x - sector.radius - labelDistance;
                }
                label.reflow(new Box(boxX - box.width(), boxY, boxX, boxY));
            }

            boxY += box.height();
        }
    };

    PieChart.prototype.createVisual = function createVisual () {
        var this$1$1 = this;

        var ref = this;
        var connectors = ref.options.connectors;
        var points = ref.points;
        var count = points.length;
        var space = 4;

        ChartElement.prototype.createVisual.call(this);

        this._connectorLines = [];

        for (var i = 0; i < count; i++) {
            var segment = points[i];
            var sector = segment.sector;
            var label = segment.label;
            var angle = sector.middle();
            var connectorsColor = (segment.options.connectors || {}).color || connectors.color;

            if (label) {
                var connectorLine = new Path$7({
                    stroke: {
                        color: connectorsColor,
                        width: connectors.width
                    },
                    animation: {
                        type: FADEIN,
                        delay: segment.animationDelay
                    }
                });

                if (label.options.position === OUTSIDE_END) {
                    var box = label.box;
                    var centerPoint = sector.center;
                    var start = sector.point(angle);
                    var middle = new Point$5(box.x1, box.center().y);
                    var sr = (void 0), end = (void 0), crossing = (void 0);

                    start = sector.clone().expand(connectors.padding).point(angle);
                    connectorLine.moveTo(start.x, start.y);
                    // TODO: Extract into a method to remove duplication
                    if (label.orientation === RIGHT) {
                        end = new Point$5(box.x1 - connectors.padding, box.center().y);
                        crossing = intersection(centerPoint, start, middle, end);
                        middle = new Point$5(end.x - space, end.y);
                        crossing = crossing || middle;
                        crossing.x = Math.min(crossing.x, middle.x);

                        if (this$1$1.pointInCircle(crossing, sector.center, sector.radius + space) ||
                            crossing.x < sector.center.x) {
                            sr = sector.center.x + sector.radius + space;
                            if (segment.options.labels.align !== COLUMN) {
                                if (sr < middle.x) {
                                    connectorLine.lineTo(sr, start.y);
                                } else {
                                    connectorLine.lineTo(start.x + space * 2, start.y);
                                }
                            } else {
                                connectorLine.lineTo(sr, start.y);
                            }
                            connectorLine.lineTo(middle.x, end.y);
                        } else {
                            crossing.y = end.y;
                            connectorLine.lineTo(crossing.x, crossing.y);
                        }
                    } else {
                        end = new Point$5(box.x2 + connectors.padding, box.center().y);
                        crossing = intersection(centerPoint, start, middle, end);
                        middle = new Point$5(end.x + space, end.y);
                        crossing = crossing || middle;
                        crossing.x = Math.max(crossing.x, middle.x);

                        if (this$1$1.pointInCircle(crossing, sector.center, sector.radius + space) ||
                            crossing.x > sector.center.x) {
                            sr = sector.center.x - sector.radius - space;
                            if (segment.options.labels.align !== COLUMN) {
                                if (sr > middle.x) {
                                    connectorLine.lineTo(sr, start.y);
                                } else {
                                    connectorLine.lineTo(start.x - space * 2, start.y);
                                }
                            } else {
                                connectorLine.lineTo(sr, start.y);
                            }
                            connectorLine.lineTo(middle.x, end.y);
                        } else {
                            crossing.y = end.y;
                            connectorLine.lineTo(crossing.x, crossing.y);
                        }
                    }

                    connectorLine.lineTo(end.x, end.y);

                    this$1$1._connectorLines.push(connectorLine);
                    this$1$1.visual.append(connectorLine);
                }
            }
        }
    };

    PieChart.prototype.renderVisual = function renderVisual () {
        ChartElement.prototype.renderVisual.call(this);

        if (find(this.options.series, function (options) { return options.autoFit; })) {
            var targetBox = this.targetBox;
            var pieCenter = this.box.center();
            var bbox = this.visual.bbox();
            if (!bbox) {
                return;
            }

            var bboxBottom = bbox.bottomRight();

            var scale = Math.min(
                (pieCenter.y - targetBox.y1) / (pieCenter.y - bbox.origin.y),
                (targetBox.y2 - pieCenter.y) / (bboxBottom.y - pieCenter.y),
                (pieCenter.x - targetBox.x1) / (pieCenter.x - bbox.origin.x),
                (targetBox.x2 - pieCenter.x) / (bboxBottom.x - pieCenter.x)
            );

            if (scale < 1) {
                this.visual.transform(transform().scale(scale, scale, [ pieCenter.x, pieCenter.y ]));
            }
        }
    };

    PieChart.prototype.labelComparator = function labelComparator (reverse) {
        var reverseValue = reverse ? -1 : 1;

        return function(a, b) {
            var first = (a.parent.sector.middle() + 270) % 360;
            var second = (b.parent.sector.middle() + 270) % 360;
            return (first - second) * reverseValue;
        };
    };

    PieChart.prototype.hAlignLabel = function hAlignLabel (originalX, sector, y1, y2, direction) {
        var radius = sector.radius;
        var sector_center = sector.center;
        var cx = sector_center.x;
        var cy = sector_center.y;
        var t = Math.min(Math.abs(cy - y1), Math.abs(cy - y2));

        if (t > radius) {
            return originalX;
        }

        return cx + Math.sqrt((radius * radius) - (t * t)) * (direction ? 1 : -1);
    };

    PieChart.prototype.pointInCircle = function pointInCircle (point, center, radius) {
        return Math.pow(center.x - point.x, 2) + Math.pow(center.y - point.y, 2) < Math.pow(radius, 2);
    };

    PieChart.prototype.formatPointValue = function formatPointValue (point, format) {
        return this.chartService.format.auto(format, point.value);
    };

    PieChart.prototype.animationDelay = function animationDelay (categoryIndex) {
        return categoryIndex * PIE_SECTOR_ANIM_DELAY;
    };

    PieChart.prototype.stackRoot = function stackRoot () {
        return this;
    };

    return PieChart;
}(ChartElement));

function intersection(a1, a2, b1, b2) {
    var uat = (b2.x - b1.x) * (a1.y - b1.y) - (b2.y - b1.y) * (a1.x - b1.x);
    var ub = (b2.y - b1.y) * (a2.x - a1.x) - (b2.x - b1.x) * (a2.y - a1.y);

    var result;
    if (ub !== 0) {
        var ua = (uat / ub);

        result = new Point$5(
            a1.x + ua * (a2.x - a1.x),
            a1.y + ua * (a2.y - a1.y)
        );
    }

    return result;
}

setDefaultOptions(PieChart, {
    startAngle: 90,
    connectors: {
        width: 2,
        color: "#939393",
        padding: 8
    },
    inactiveItems: {
        markers: {},
        labels: {}
    }
});

deepExtend(PieChart.prototype, PieChartMixin);

PieChart.prototype.isStackRoot = true;

var PiePlotArea = (function (PlotAreaBase) {
    function PiePlotArea () {
        PlotAreaBase.apply(this, arguments);
    }

    if ( PlotAreaBase ) PiePlotArea.__proto__ = PlotAreaBase;
    PiePlotArea.prototype = Object.create( PlotAreaBase && PlotAreaBase.prototype );
    PiePlotArea.prototype.constructor = PiePlotArea;

    PiePlotArea.prototype.render = function render () {
        this.createPieChart(this.series);
    };

    PiePlotArea.prototype.createPieChart = function createPieChart (series) {
        var firstSeries = series[0];
        var pieChart = new PieChart(this, {
            series: series,
            padding: firstSeries.padding,
            startAngle: firstSeries.startAngle,
            connectors: firstSeries.connectors,
            legend: this.options.legend
        });

        this.appendChart(pieChart);
    };

    PiePlotArea.prototype.appendChart = function appendChart (chart, pane) {
        PlotAreaBase.prototype.appendChart.call(this, chart, pane);
        append(this.options.legend.data, chart.legendItems);
    };

    PiePlotArea.prototype.getPointBelow = function getPointBelow (point) {
        return this.getPointToTheRight(point);
    };

    PiePlotArea.prototype.getPointAbove = function getPointAbove (point) {
        return this.getPointToTheLeft(point);
    };

    return PiePlotArea;
}(PlotAreaBase));

var DonutSegment = (function (PieSegment) {
    function DonutSegment () {
        PieSegment.apply(this, arguments);
    }

    if ( PieSegment ) DonutSegment.__proto__ = PieSegment;
    DonutSegment.prototype = Object.create( PieSegment && PieSegment.prototype );
    DonutSegment.prototype.constructor = DonutSegment;

    DonutSegment.prototype.reflowLabel = function reflowLabel () {
        var ref = this;
        var labelsOptions = ref.options.labels;
        var label = ref.label;
        var sector = this.sector.clone();
        var angle = sector.middle();

        if (label) {
            var labelHeight = label.box.height();
            if (labelsOptions.position === CENTER) {
                sector.radius -= (sector.radius - sector.innerRadius) / 2;

                var lp = sector.point(angle);

                label.reflow(new Box(lp.x, lp.y - labelHeight / 2, lp.x, lp.y));
            } else {
                PieSegment.prototype.reflowLabel.call(this);
            }
        }
    };

    DonutSegment.prototype.createSegment = function createSegment (sector, options) {
        return ShapeBuilder.current.createRing(sector, options);
    };

    return DonutSegment;
}(PieSegment));

setDefaultOptions(DonutSegment, {
    overlay: {
        gradient: "roundedGlass"
    },
    labels: {
        position: CENTER
    },
    animation: {
        type: PIE
    }
});

deepExtend(DonutSegment.prototype, PointEventsMixin);

var DONUT_SECTOR_ANIM_DELAY = 50;

var DonutChart = (function (PieChart) {
    function DonutChart () {
        PieChart.apply(this, arguments);
    }

    if ( PieChart ) DonutChart.__proto__ = PieChart;
    DonutChart.prototype = Object.create( PieChart && PieChart.prototype );
    DonutChart.prototype.constructor = DonutChart;

    DonutChart.prototype.addValue = function addValue (value, sector, fields) {
        var segmentOptions = deepExtend({}, fields.series, { index: fields.index });
        segmentOptions.pattern = fields.pattern || segmentOptions.pattern;

        this.evalSegmentOptions(segmentOptions, value, fields);

        this.createLegendItem(value, segmentOptions, fields);

        if (fields.visible === false) {
            return;
        }

        var segment = new DonutSegment(value, sector, segmentOptions);

        Object.assign(segment, fields);
        this.append(segment);
        this.points.push(segment);
    };

    DonutChart.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        var options = this.options;
        var box = targetBox.clone();
        var space = 5;
        var minWidth = Math.min(box.width(), box.height());
        var halfMinWidth = minWidth / 2;
        var defaultPadding = minWidth - minWidth * 0.85;
        var series = options.series;
        var seriesCount = series.length;

        var padding = valueOrDefault(options.padding, defaultPadding);
        padding = padding > halfMinWidth - space ? halfMinWidth - space : padding;

        var totalSize = halfMinWidth - padding;
        var seriesWithoutSize = 0;
        var holeSize;

        for (var i = 0; i < seriesCount; i++) {
            var currentSeries = series[i];
            if (i === 0) {
                if (defined(currentSeries.holeSize)) {
                    holeSize = currentSeries.holeSize;
                    totalSize -= currentSeries.holeSize;
                }
            }

            if (defined(currentSeries.size)) {
                totalSize -= currentSeries.size;
            } else {
                seriesWithoutSize++;
            }

            if (defined(currentSeries.margin) && i !== seriesCount - 1) {
                totalSize -= currentSeries.margin;
            }
        }

        if (!defined(holeSize)) {
            var currentSize = (halfMinWidth - padding) / (seriesCount + 0.75);
            holeSize = currentSize * 0.75;
            totalSize -= holeSize;
        }

        var innerRadius = holeSize;
        var margin = 0;
        var size, radius;

        this.seriesConfigs = [];

        for (var i$1 = 0; i$1 < seriesCount; i$1++) {
            var currentSeries$1 = series[i$1];
            size = valueOrDefault(currentSeries$1.size, totalSize / seriesWithoutSize);
            innerRadius += margin;
            radius = innerRadius + size;
            this$1$1.seriesConfigs.push({ innerRadius: innerRadius, radius: radius });
            margin = currentSeries$1.margin || 0;
            innerRadius = radius;
        }

        PieChart.prototype.reflow.call(this, targetBox);
    };

    DonutChart.prototype.animationDelay = function animationDelay (categoryIndex, seriesIndex, seriesCount) {
        return categoryIndex * DONUT_SECTOR_ANIM_DELAY +
            (INITIAL_ANIMATION_DURATION * (seriesIndex + 1) / (seriesCount + 1));
    };

    return DonutChart;
}(PieChart));


setDefaultOptions(DonutChart, {
    startAngle: 90,
    connectors: {
        width: 2,
        color: "#939393",
        padding: 8
    }
});

var DonutPlotArea = (function (PiePlotArea) {
    function DonutPlotArea () {
        PiePlotArea.apply(this, arguments);
    }

    if ( PiePlotArea ) DonutPlotArea.__proto__ = PiePlotArea;
    DonutPlotArea.prototype = Object.create( PiePlotArea && PiePlotArea.prototype );
    DonutPlotArea.prototype.constructor = DonutPlotArea;

    DonutPlotArea.prototype.render = function render () {
        this.createDonutChart(this.series);
    };

    DonutPlotArea.prototype.createDonutChart = function createDonutChart (series) {
        var firstSeries = series[0];
        var donutChart = new DonutChart(this, {
            series: series,
            padding: firstSeries.padding,
            connectors: firstSeries.connectors,
            legend: this.options.legend
        });

        this.appendChart(donutChart);
    };

    // These were overriden in the Pie, so revert to original behavior
    DonutPlotArea.prototype.getPointBelow = function getPointBelow (point) {
        return this._getNextPoint(point, this._pointsByVertical, -1);
    };

    DonutPlotArea.prototype.getPointAbove = function getPointAbove (point) {
        return this._getNextPoint(point, this._pointsByVertical, 1);
    };

    return DonutPlotArea;
}(PiePlotArea));

var DEFAULT_PADDING = 0.15;

var PolarPlotAreaBase = (function (PlotAreaBase) {
    function PolarPlotAreaBase () {
        PlotAreaBase.apply(this, arguments);
    }

    if ( PlotAreaBase ) PolarPlotAreaBase.__proto__ = PlotAreaBase;
    PolarPlotAreaBase.prototype = Object.create( PlotAreaBase && PlotAreaBase.prototype );
    PolarPlotAreaBase.prototype.constructor = PolarPlotAreaBase;

    PolarPlotAreaBase.prototype.initFields = function initFields () {
        this.valueAxisRangeTracker = new AxisGroupRangeTracker();
    };

    PolarPlotAreaBase.prototype.render = function render () {
        this.addToLegend(this.series);
        this.createPolarAxis();
        this.createCharts();
        this.createValueAxis();
    };

    PolarPlotAreaBase.prototype.alignAxes = function alignAxes () {
        var axis = this.valueAxis;
        var range = axis.range();
        var crossingValue = axis.options.reverse ? range.max : range.min;
        var slot = axis.getSlot(crossingValue);
        var center = this.polarAxis.getSlot(0).center;
        var axisBox = axis.box.translate(
            center.x - slot.x1,
            center.y - slot.y1
        );

        axis.reflow(axisBox);
    };

    PolarPlotAreaBase.prototype.createValueAxis = function createValueAxis () {
        var tracker = this.valueAxisRangeTracker;
        var defaultRange = tracker.query();
        var axisOptions = this.valueAxisOptions({
            roundToMajorUnit: false,
            zIndex: -1
        });
        var axisType, axisDefaultRange;

        if (axisOptions.type === LOGARITHMIC) {
            axisType = RadarLogarithmicAxis;
            axisDefaultRange = { min: 0.1, max: 1 };
        } else {
            axisType = RadarNumericAxis;
            axisDefaultRange = { min: 0, max: 1 };
        }

        var range = tracker.query(name) || defaultRange || axisDefaultRange;

        if (range && defaultRange) {
            range.min = Math.min(range.min, defaultRange.min);
            range.max = Math.max(range.max, defaultRange.max);
        }

        var valueAxis = new axisType(
            range.min, range.max,
            axisOptions,
            this.chartService
        );

        this.valueAxis = valueAxis;
        this.appendAxis(valueAxis);
    };

    PolarPlotAreaBase.prototype.reflowAxes = function reflowAxes () {
        var ref = this;
        var options = ref.options.plotArea;
        var valueAxis = ref.valueAxis;
        var polarAxis = ref.polarAxis;
        var box = ref.box;
        var defaultPadding = Math.min(box.width(), box.height()) * DEFAULT_PADDING;
        var padding = getSpacing(options.padding || {}, defaultPadding);
        var paddingBox = box.clone().unpad(padding);
        var axisBox = paddingBox.clone();

        axisBox.y2 = axisBox.y1 + Math.min(axisBox.width(), axisBox.height());
        axisBox.align(paddingBox, Y, CENTER);

        var valueAxisBox = axisBox.clone().shrink(0, axisBox.height() / 2);

        polarAxis.reflow(axisBox);
        valueAxis.reflow(valueAxisBox);
        var heightDiff = valueAxis.lineBox().height() - valueAxis.box.height();
        valueAxis.reflow(valueAxis.box.unpad({ top: heightDiff }));

        this.axisBox = axisBox;
        this.alignAxes(axisBox);
    };

    PolarPlotAreaBase.prototype.backgroundBox = function backgroundBox () {
        return this.box;
    };

    PolarPlotAreaBase.prototype.detachLabels = function detachLabels () {};

    return PolarPlotAreaBase;
}(PlotAreaBase));

var PolarScatterChart = (function (ScatterChart) {
    function PolarScatterChart () {
        ScatterChart.apply(this, arguments);
    }

    if ( ScatterChart ) PolarScatterChart.__proto__ = ScatterChart;
    PolarScatterChart.prototype = Object.create( ScatterChart && ScatterChart.prototype );
    PolarScatterChart.prototype.constructor = PolarScatterChart;

    PolarScatterChart.prototype.pointSlot = function pointSlot (slotX, slotY) {
        var valueRadius = slotX.center.y - slotY.y1;
        var slot = Point$5.onCircle(slotX.center, slotX.startAngle, valueRadius);

        return new Box(slot.x, slot.y, slot.x, slot.y);
    };

    return PolarScatterChart;
}(ScatterChart));

setDefaultOptions(PolarScatterChart, {
    clip: false
});

var PolarLineChart = (function (ScatterLineChart) {
    function PolarLineChart () {
        ScatterLineChart.apply(this, arguments);
    }if ( ScatterLineChart ) PolarLineChart.__proto__ = ScatterLineChart;
    PolarLineChart.prototype = Object.create( ScatterLineChart && ScatterLineChart.prototype );
    PolarLineChart.prototype.constructor = PolarLineChart;

    

    return PolarLineChart;
}(ScatterLineChart));

PolarLineChart.prototype.pointSlot = PolarScatterChart.prototype.pointSlot;

setDefaultOptions(PolarLineChart, {
    clip: false
});

var SplinePolarAreaSegment = (function (SplineAreaSegment) {
    function SplinePolarAreaSegment () {
        SplineAreaSegment.apply(this, arguments);
    }

    if ( SplineAreaSegment ) SplinePolarAreaSegment.__proto__ = SplineAreaSegment;
    SplinePolarAreaSegment.prototype = Object.create( SplineAreaSegment && SplineAreaSegment.prototype );
    SplinePolarAreaSegment.prototype.constructor = SplinePolarAreaSegment;

    SplinePolarAreaSegment.prototype.fillToAxes = function fillToAxes (fillPath) {
        var center = this._polarAxisCenter();
        fillPath.lineTo(center.x, center.y);
    };

    SplinePolarAreaSegment.prototype._polarAxisCenter = function _polarAxisCenter () {
        var polarAxis = this.parent.plotArea.polarAxis;
        var center = polarAxis.box.center();
        return center;
    };

    SplinePolarAreaSegment.prototype.strokeSegments = function strokeSegments () {
        var segments = this._strokeSegments;

        if (!segments) {
            var center = this._polarAxisCenter();
            var curveProcessor = new CurveProcessor(false);
            var linePoints = this.points();

            linePoints.push(center);
            segments = this._strokeSegments = curveProcessor.process(linePoints);
            segments.pop();
        }

        return segments;
    };

    return SplinePolarAreaSegment;
}(SplineAreaSegment));

var PolarAreaSegment = (function (AreaSegment) {
    function PolarAreaSegment () {
        AreaSegment.apply(this, arguments);
    }

    if ( AreaSegment ) PolarAreaSegment.__proto__ = AreaSegment;
    PolarAreaSegment.prototype = Object.create( AreaSegment && AreaSegment.prototype );
    PolarAreaSegment.prototype.constructor = PolarAreaSegment;

    PolarAreaSegment.prototype.fillToAxes = function fillToAxes (fillPath) {
        var polarAxis = this.parent.plotArea.polarAxis;
        var center = polarAxis.box.center();
        var centerSegment = new Segment([ center.x, center.y ]);

        fillPath.segments.unshift(centerSegment);
        fillPath.segments.push(centerSegment);
    };

    return PolarAreaSegment;
}(AreaSegment));

var PolarAreaChart = (function (PolarLineChart) {
    function PolarAreaChart () {
        PolarLineChart.apply(this, arguments);
    }

    if ( PolarLineChart ) PolarAreaChart.__proto__ = PolarLineChart;
    PolarAreaChart.prototype = Object.create( PolarLineChart && PolarLineChart.prototype );
    PolarAreaChart.prototype.constructor = PolarAreaChart;

    PolarAreaChart.prototype.createSegment = function createSegment (linePoints, currentSeries, seriesIx) {
        var style = (currentSeries.line || {}).style;
        var segment;

        if (style === SMOOTH) {
            segment = new SplinePolarAreaSegment(linePoints, currentSeries, seriesIx);
        } else {
            segment = new PolarAreaSegment(linePoints, currentSeries, seriesIx);
        }
        return segment;
    };

    PolarAreaChart.prototype.createMissingValue = function createMissingValue (value, missingValues) {
        var missingValue;

        if (hasValue$2(value.x) && missingValues !== INTERPOLATE) {
            missingValue = {
                x: value.x,
                y: value.y
            };
            if (missingValues === ZERO) {
                missingValue.y = 0;
            }
        }

        return missingValue;
    };

    PolarAreaChart.prototype.seriesMissingValues = function seriesMissingValues (series) {
        return series.missingValues || ZERO;
    };

    PolarAreaChart.prototype._hasMissingValuesGap = function _hasMissingValuesGap () {
        var this$1$1 = this;

        var series = this.options.series;

        for (var idx = 0; idx < series.length; idx++) {
            if (this$1$1.seriesMissingValues(series[idx]) === GAP) {
                return true;
            }
        }
    };

    PolarAreaChart.prototype.sortPoints = function sortPoints (points) {
        var this$1$1 = this;

        points.sort(xComparer);

        if (this._hasMissingValuesGap()) {
            for (var idx = 0; idx < points.length; idx++) {
                var point = points[idx];
                if (point) {
                    var value = point.value;
                    if (!hasValue$2(value.y) && this$1$1.seriesMissingValues(point.series) === GAP) {
                        delete points[idx];
                    }
                }
            }
        }

        return points;
    };

    return PolarAreaChart;
}(PolarLineChart));

function xComparer(a, b) {
    return a.value.x - b.value.x;
}

var PolarPlotArea = (function (PolarPlotAreaBase) {
    function PolarPlotArea () {
        PolarPlotAreaBase.apply(this, arguments);
    }

    if ( PolarPlotAreaBase ) PolarPlotArea.__proto__ = PolarPlotAreaBase;
    PolarPlotArea.prototype = Object.create( PolarPlotAreaBase && PolarPlotAreaBase.prototype );
    PolarPlotArea.prototype.constructor = PolarPlotArea;

    PolarPlotArea.prototype.createPolarAxis = function createPolarAxis () {
        var polarAxis = new PolarAxis(this.options.xAxis, this.chartService);

        this.polarAxis = polarAxis;
        this.axisX = polarAxis;
        this.appendAxis(polarAxis);
    };

    PolarPlotArea.prototype.render = function render () {
        this.series = [].concat( this.originalSeries );
        this.createTrendlineSeries();

        PolarPlotAreaBase.prototype.render.call(this);
    };

    PolarPlotArea.prototype.valueAxisOptions = function valueAxisOptions (defaults) {
        return deepExtend(defaults, {
            majorGridLines: { type: ARC },
            minorGridLines: { type: ARC }
        }, this.options.yAxis);
    };

    PolarPlotArea.prototype.createValueAxis = function createValueAxis () {
        PolarPlotAreaBase.prototype.createValueAxis.call(this);
        this.axisY = this.valueAxis;
    };

    PolarPlotArea.prototype.trendlineFactory = function trendlineFactory (options, series) {
        var trendline = XYPlotArea.prototype.trendlineFactory.call(this, options, series);
        if (trendline) {
            trendline.type = POLAR_LINE;
        }

        return trendline;
    };

    PolarPlotArea.prototype.appendChart = function appendChart (chart, pane) {
        this.valueAxisRangeTracker.update(chart.yAxisRanges);

        PlotAreaBase.prototype.appendChart.call(this, chart, pane);
    };

    PolarPlotArea.prototype.createCharts = function createCharts () {
        var series = this.filterVisibleSeries(this.series);
        var pane = this.panes[0];

        this.createLineChart(
            filterSeriesByType(series, [ POLAR_LINE ]),
            pane
        );

        this.createScatterChart(
            filterSeriesByType(series, [ POLAR_SCATTER ]),
            pane
        );

        this.createAreaChart(
            filterSeriesByType(series, [ POLAR_AREA ]),
            pane
        );
    };

    PolarPlotArea.prototype.createLineChart = function createLineChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var lineChart = new PolarLineChart(this, { series: series });

        this.appendChart(lineChart, pane);
    };

    PolarPlotArea.prototype.createScatterChart = function createScatterChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var scatterChart = new PolarScatterChart(this, { series: series });

        this.appendChart(scatterChart, pane);
    };

    PolarPlotArea.prototype.createAreaChart = function createAreaChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var areaChart = new PolarAreaChart(this, { series: series });

        this.appendChart(areaChart, pane);
    };

    PolarPlotArea.prototype._dispatchEvent = function _dispatchEvent (chart, e, eventType) {
        var coords = chart._eventCoordinates(e);
        var point = new Point$5(coords.x, coords.y);
        var xValue = this.axisX.getValue(point);
        var yValue = this.axisY.getValue(point);

        if (xValue !== null && yValue !== null) {
            chart.trigger(eventType, {
                element: eventElement(e),
                x: xValue,
                y: yValue
            });
        }
    };

    PolarPlotArea.prototype.createCrosshairs = function createCrosshairs () {};

    return PolarPlotArea;
}(PolarPlotAreaBase));

setDefaultOptions(PolarPlotArea, {
    xAxis: {},
    yAxis: {}
});

deepExtend(PolarPlotArea.prototype, PlotAreaEventsMixin, {
    seriesValues: XYPlotArea.prototype.seriesValues
});

function groupBySeriesIx(segments) {
    var seriesSegments = [];
    for (var idx = 0; idx < segments.length; idx++) {
        var segment = segments[idx];
        seriesSegments[segment.seriesIx] = seriesSegments[segment.seriesIx] || [];
        seriesSegments[segment.seriesIx].push(segment);
    }

    return seriesSegments;
}

var RadarLineChart = (function (LineChart) {
    function RadarLineChart () {
        LineChart.apply(this, arguments);
    }

    if ( LineChart ) RadarLineChart.__proto__ = LineChart;
    RadarLineChart.prototype = Object.create( LineChart && LineChart.prototype );
    RadarLineChart.prototype.constructor = RadarLineChart;

    RadarLineChart.prototype.pointSlot = function pointSlot (categorySlot, valueSlot) {
        var valueRadius = categorySlot.center.y - valueSlot.y1;
        var slot = Point$5.onCircle(categorySlot.center, categorySlot.middle(), valueRadius);

        return new Box(slot.x, slot.y, slot.x, slot.y);
    };

    RadarLineChart.prototype.renderSegments = function renderSegments () {
        LineChart.prototype.renderSegments.call(this);

        if (this._segments && this._segments.length > 1) {
            var seriesSegments = groupBySeriesIx(this._segments);

            for (var idx = 0; idx < seriesSegments.length; idx++) {
                var segments = seriesSegments[idx];
                if (segments && segments.length > 1) {
                    var firstPoint = segments[0].linePoints[0];
                    var lastSegment = last(segments);
                    var lastPoint = last(lastSegment.linePoints);
                    var isFirstDataPoint = firstPoint.categoryIx === 0;
                    var isLastDataPoint = lastPoint.categoryIx === lastPoint.categoriesCount - 1;
                    if (isFirstDataPoint && isLastDataPoint) {
                        last(segments).linePoints.push(firstPoint);
                    }
                }
            }
        }
    };

    RadarLineChart.prototype.createSegment = function createSegment (linePoints, currentSeries, seriesIx) {
        var style = currentSeries.style;
        var pointType;

        if (style === SMOOTH) {
            pointType = SplineSegment;
        } else {
            pointType = LineSegment;
        }

        var segment = new pointType(linePoints, currentSeries, seriesIx);
        var missingValues = this.seriesMissingValues(currentSeries);

        if (linePoints.length === currentSeries.data.length || missingValues === INTERPOLATE) {
            segment.options.closed = true;
        }

        return segment;
    };

    return RadarLineChart;
}(LineChart));

setDefaultOptions(RadarLineChart, {
    clip: false,
    limitPoints: false
});

var SplineRadarAreaSegment = (function (SplineAreaSegment) {
    function SplineRadarAreaSegment () {
        SplineAreaSegment.apply(this, arguments);
    }

    if ( SplineAreaSegment ) SplineRadarAreaSegment.__proto__ = SplineAreaSegment;
    SplineRadarAreaSegment.prototype = Object.create( SplineAreaSegment && SplineAreaSegment.prototype );
    SplineRadarAreaSegment.prototype.constructor = SplineRadarAreaSegment;

    SplineRadarAreaSegment.prototype.fillToAxes = function fillToAxes () {};

    return SplineRadarAreaSegment;
}(SplineAreaSegment));

var RadarAreaSegment = (function (AreaSegment) {
    function RadarAreaSegment () {
        AreaSegment.apply(this, arguments);
    }

    if ( AreaSegment ) RadarAreaSegment.__proto__ = AreaSegment;
    RadarAreaSegment.prototype = Object.create( AreaSegment && AreaSegment.prototype );
    RadarAreaSegment.prototype.constructor = RadarAreaSegment;

    RadarAreaSegment.prototype.fillToAxes = function fillToAxes () {};

    return RadarAreaSegment;
}(AreaSegment));

var RadarAreaChart = (function (RadarLineChart) {
    function RadarAreaChart () {
        RadarLineChart.apply(this, arguments);
    }

    if ( RadarLineChart ) RadarAreaChart.__proto__ = RadarLineChart;
    RadarAreaChart.prototype = Object.create( RadarLineChart && RadarLineChart.prototype );
    RadarAreaChart.prototype.constructor = RadarAreaChart;

    RadarAreaChart.prototype.createSegment = function createSegment (linePoints, currentSeries, seriesIx, prevSegment) {
        var isStacked = this.options.isStacked;
        var style = (currentSeries.line || {}).style;
        var previousSegment;
        var stackPoints;
        var segment;

        if (isStacked && seriesIx > 0 && prevSegment) {
            stackPoints = prevSegment.linePoints.slice(0);
            previousSegment = prevSegment;
        }

        if (style === SMOOTH) {
            segment = new SplineRadarAreaSegment(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
            segment.options.closed = true;
        } else {
            linePoints.push(linePoints[0]);
            segment = new RadarAreaSegment(linePoints, currentSeries, seriesIx, previousSegment, stackPoints);
        }

        return segment;
    };

    RadarAreaChart.prototype.seriesMissingValues = function seriesMissingValues (series) {
        return series.missingValues || ZERO;
    };

    return RadarAreaChart;
}(RadarLineChart));

var RadarSegment = (function (DonutSegment) {
    function RadarSegment(value, options) {
        DonutSegment.call(this, value, null, options);
    }

    if ( DonutSegment ) RadarSegment.__proto__ = DonutSegment;
    RadarSegment.prototype = Object.create( DonutSegment && DonutSegment.prototype );
    RadarSegment.prototype.constructor = RadarSegment;

    RadarSegment.prototype.getIndex = function getIndex () {
        return this.categoryIx;
    };

    return RadarSegment;
}(DonutSegment));

setDefaultOptions(RadarSegment, {
    overlay: {
        gradient: "none"
    },
    labels: {
        distance: 10
    }
});

var RadarClusterLayout = (function (ChartElement) {
    function RadarClusterLayout(options) {
        ChartElement.call(this, options);

        this.forEach = options.rtl ? forEachReverse : forEach;
    }

    if ( ChartElement ) RadarClusterLayout.__proto__ = ChartElement;
    RadarClusterLayout.prototype = Object.create( ChartElement && ChartElement.prototype );
    RadarClusterLayout.prototype.constructor = RadarClusterLayout;

    RadarClusterLayout.prototype.reflow = function reflow (sector) {
        var ref = this;
        var options = ref.options;
        var children = ref.children;
        var gap = options.gap;
        var spacing = options.spacing;
        var count = children.length;
        var slots = count + gap + (spacing * (count - 1));
        var slotAngle = sector.angle / slots;
        var angle = sector.startAngle + slotAngle * (gap / 2);

        this.forEach(children, function (child) {
            var slotSector = sector.clone();
            slotSector.startAngle = angle;
            slotSector.angle = slotAngle;

            if (child.sector) {
                slotSector.radius = child.sector.radius;
            }

            child.reflow(slotSector);
            child.sector = slotSector;

            angle += slotAngle + (slotAngle * spacing);
        });
    };

    return RadarClusterLayout;
}(ChartElement));

setDefaultOptions(RadarClusterLayout, {
    gap: 1,
    spacing: 0
});

var RadarStackLayout = (function (ChartElement) {
    function RadarStackLayout () {
        ChartElement.apply(this, arguments);
    }

    if ( ChartElement ) RadarStackLayout.__proto__ = ChartElement;
    RadarStackLayout.prototype = Object.create( ChartElement && ChartElement.prototype );
    RadarStackLayout.prototype.constructor = RadarStackLayout;

    RadarStackLayout.prototype.reflow = function reflow (sector) {
        var ref = this;
        var reverse = ref.options.reverse;
        var children = ref.children;
        var childrenCount = children.length;
        var first = reverse ? childrenCount - 1 : 0;
        var step = reverse ? -1 : 1;

        this.box = new Box();

        for (var i = first; i >= 0 && i < childrenCount; i += step) {
            var childSector = children[i].sector;
            childSector.startAngle = sector.startAngle;
            childSector.angle = sector.angle;
        }
    };

    return RadarStackLayout;
}(ChartElement));

var RadarBarChart = (function (BarChart) {
    function RadarBarChart () {
        BarChart.apply(this, arguments);
    }

    if ( BarChart ) RadarBarChart.__proto__ = BarChart;
    RadarBarChart.prototype = Object.create( BarChart && BarChart.prototype );
    RadarBarChart.prototype.constructor = RadarBarChart;

    RadarBarChart.prototype.pointType = function pointType () {
        return RadarSegment;
    };

    RadarBarChart.prototype.clusterType = function clusterType () {
        return RadarClusterLayout;
    };

    RadarBarChart.prototype.stackType = function stackType () {
        return RadarStackLayout;
    };

    RadarBarChart.prototype.categorySlot = function categorySlot (categoryAxis, categoryIx) {
        return categoryAxis.getSlot(categoryIx);
    };

    RadarBarChart.prototype.pointSlot = function pointSlot (categorySlot, valueSlot) {
        var slot = categorySlot.clone();
        var y = categorySlot.center.y;

        slot.radius = y - valueSlot.y1;
        slot.innerRadius = y - valueSlot.y2;

        return slot;
    };

    RadarBarChart.prototype.reflowPoint = function reflowPoint (point, pointSlot) {
        point.sector = pointSlot;
        point.reflow();
    };

    RadarBarChart.prototype.createAnimation = function createAnimation () {
        this.options.animation.center = this.box.toRect().center();
        BarChart.prototype.createAnimation.call(this);
    };

    return RadarBarChart;
}(BarChart));

RadarBarChart.prototype.reflow = CategoricalChart.prototype.reflow;

setDefaultOptions(RadarBarChart, {
    clip: false,
    limitPoints: false,
    animation: {
        type: "pie"
    }
});

var RadarPlotArea = (function (PolarPlotAreaBase) {
    function RadarPlotArea () {
        PolarPlotAreaBase.apply(this, arguments);
    }

    if ( PolarPlotAreaBase ) RadarPlotArea.__proto__ = PolarPlotAreaBase;
    RadarPlotArea.prototype = Object.create( PolarPlotAreaBase && PolarPlotAreaBase.prototype );
    RadarPlotArea.prototype.constructor = RadarPlotArea;

    RadarPlotArea.prototype.createPolarAxis = function createPolarAxis () {
        var categoryAxis = new RadarCategoryAxis(this.options.categoryAxis, this.chartService);

        this.polarAxis = categoryAxis;
        this.categoryAxis = categoryAxis;
        this.appendAxis(categoryAxis);
        this.aggregateCategories();
        this.createTrendlineSeries();
        this.createCategoryAxesLabels();
    };

    RadarPlotArea.prototype.valueAxisOptions = function valueAxisOptions (defaults) {
        if (this._hasBarCharts) {
            deepExtend(defaults, {
                majorGridLines: { type: ARC },
                minorGridLines: { type: ARC }
            });
        }

        if (this._isStacked100) {
            deepExtend(defaults, {
                roundToMajorUnit: false,
                labels: { format: "P0" }
            });
        }

        return deepExtend(defaults, this.options.valueAxis);
    };

    RadarPlotArea.prototype.aggregateCategories = function aggregateCategories () {
        // No separate panes in radar charts
        CategoricalPlotArea.prototype.aggregateCategories.call(this, this.panes);
    };

    RadarPlotArea.prototype.createCategoryAxesLabels = function createCategoryAxesLabels () {
        CategoricalPlotArea.prototype.createCategoryAxesLabels.call(this, this.panes);
    };

    RadarPlotArea.prototype.filterSeries = function filterSeries (currentSeries) {
        // Not supported for radar charts
        return currentSeries;
    };

    RadarPlotArea.prototype.trendlineFactory = function trendlineFactory (options, series) {
        var trendline = CategoricalPlotArea.prototype.trendlineFactory.call(this, options, series);
        if (trendline) {
            trendline.type = RADAR_LINE;
        }

        return trendline;
    };

    RadarPlotArea.prototype.createCharts = function createCharts () {
        var series = this.filterVisibleSeries(this.series);
        var pane = this.panes[0];

        this.createAreaChart(
            filterSeriesByType(series, [ RADAR_AREA ]),
            pane
        );

        this.createLineChart(
            filterSeriesByType(series, [ RADAR_LINE ]),
            pane
        );

        this.createBarChart(
            filterSeriesByType(series, [ RADAR_COLUMN ]),
            pane
        );
    };

    RadarPlotArea.prototype.chartOptions = function chartOptions (series) {
        var options = { series: series };
        var firstSeries = series[0];
        if (firstSeries) {
            var filteredSeries = this.filterVisibleSeries(series);
            var stack = firstSeries.stack;
            options.isStacked = stack && filteredSeries.length > 1;
            options.isStacked100 = stack && stack.type === "100%" && filteredSeries.length > 1;

            if (options.isStacked100) {
                this._isStacked100 = true;
            }
        }

        return options;
    };

    RadarPlotArea.prototype.createAreaChart = function createAreaChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var areaChart = new RadarAreaChart(this, this.chartOptions(series));
        this.appendChart(areaChart, pane);
    };

    RadarPlotArea.prototype.createLineChart = function createLineChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var lineChart = new RadarLineChart(this, this.chartOptions(series));
        this.appendChart(lineChart, pane);
    };

    RadarPlotArea.prototype.createBarChart = function createBarChart (series, pane) {
        if (series.length === 0) {
            return;
        }

        var firstSeries = series[0];
        var options = this.chartOptions(series);
        var filteredSeries = this.filterVisibleSeries(series);
        var anyStackedSeries = filteredSeries.some(function (s) { return s.stack; });
        var isStacked100 = filteredSeries.some(function (s) { return s.stack && s.stack.type === "100%"; });
        options.gap = firstSeries.gap;
        options.spacing = firstSeries.spacing;
        options.defaultStack = firstSeries.stack && filteredSeries.length > 1;
        options.isStacked = anyStackedSeries && filteredSeries.length > 1;
        options.isStacked100 = isStacked100 && filteredSeries.length > 1;

        var barChart = new RadarBarChart(this, options);
        this.appendChart(barChart, pane);

        this._hasBarCharts = true;
    };

    RadarPlotArea.prototype.seriesCategoryAxis = function seriesCategoryAxis () {
        return this.categoryAxis;
    };

    RadarPlotArea.prototype._dispatchEvent = function _dispatchEvent (chart, e, eventType) {
        var coords = chart._eventCoordinates(e);
        var point = new Point$5(coords.x, coords.y);
        var category = this.categoryAxis.getCategory(point);
        var value = this.valueAxis.getValue(point);

        if (category !== null && value !== null) {
            chart.trigger(eventType, {
                element: eventElement(e),
                category: category,
                value: value
            });
        }
    };

    RadarPlotArea.prototype.createCrosshairs = function createCrosshairs () {};

    RadarPlotArea.prototype._pointsByVertical = function _pointsByVertical (basePoint) {
        return PolarPlotAreaBase.prototype._pointsByVertical.call(this, basePoint).sort(this._getSeriesCompareFn());
    };

    RadarPlotArea.prototype._getSeriesCompareFn = function _getSeriesCompareFn () {
        return function (a, b) { return b.value - a.value; };
    };

    return RadarPlotArea;
}(PolarPlotAreaBase));

deepExtend(RadarPlotArea.prototype, PlotAreaEventsMixin, {
    appendChart: CategoricalPlotArea.prototype.appendChart,
    aggregateSeries: CategoricalPlotArea.prototype.aggregateSeries,
    seriesSourcePoints: CategoricalPlotArea.prototype.seriesSourcePoints,
    seriesValues: CategoricalPlotArea.prototype.seriesValues
});

setDefaultOptions(RadarPlotArea, {
    categoryAxis: {
        categories: []
    },
    valueAxis: {}
});

var FunnelSegment = (function (ChartElement) {
    function FunnelSegment(value, options, segmentOptions) {
        ChartElement.call(this, options);

        this.value = value;
        this.options.index = segmentOptions.index;
    }

    if ( ChartElement ) FunnelSegment.__proto__ = ChartElement;
    FunnelSegment.prototype = Object.create( ChartElement && ChartElement.prototype );
    FunnelSegment.prototype.constructor = FunnelSegment;

    FunnelSegment.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = getTemplate$1(options);

        if (labelTemplate) {
            return labelTemplate(this.pointData());
        } else if (options.format) {
            return this.formatValue(options.format);
        }

        return this.value;
    };

    FunnelSegment.prototype.reflow = function reflow (chartBox) {
        var points = this.points;
        var label = this.children[0];
        var x1 = Math.min(points[0].x, points[3].x);
        var x2 = Math.max(points[1].x, points[2].x);

        this.box = new Box(x1, points[0].y, x2, points[2].y);

        if (label) {
            label.reflow(new Box(chartBox.x1, points[0].y, chartBox.x2, points[2].y));
        }
    };

    FunnelSegment.prototype.createVisual = function createVisual () {
        var this$1$1 = this;

        var options = this.options;
        var visual;

        ChartElement.prototype.createVisual.call(this);

        this.addAccessibilityAttributesToVisual();

        if (options.visual) {
            visual = options.visual({
                category: this.category,
                dataItem: this.dataItem,
                value: this.value,
                series: this.series,
                percentage: this.percentage,
                points: this.points,
                options: options,
                sender: this.getSender(),
                createVisual: function () { return this$1$1.createPath(); }
            });
        } else {
            visual = this.createPath();
        }

        if (visual) {
            this.visual.append(visual);
        }
    };

    FunnelSegment.prototype.createPath = function createPath () {
        var options = this.options;
        var border = options.border;
        var path = Path$7.fromPoints(this.points, {
            fill: createPatternFill(options.pattern, {
                color: options.color,
                opacity: options.opacity
            }),
            stroke: {
                color: border.color,
                opacity: border.opacity,
                width: border.width
            }
        }).close();

        return path;
    };

    FunnelSegment.prototype.createHighlight = function createHighlight (style) {
        return Path$7.fromPoints(this.points, style);
    };

    FunnelSegment.prototype.highlightVisual = function highlightVisual () {
        return this.visual.children[0];
    };

    FunnelSegment.prototype.highlightVisualArgs = function highlightVisualArgs () {
        var path = Path$7.fromPoints(this.points).close();

        return {
            options: this.options,
            path: path
        };
    };

    FunnelSegment.prototype.createFocusHighlight = function createFocusHighlight (style) {
        var borderWidth = this.options.focusHighlight.border.width;
        var result = Path$7.fromPoints(this.points, deepExtend({}, style, {
            stroke: {
                width: borderWidth * 2
            }
        })).close();

        var clipPath = new MultiPath();

        clipPath.paths.push(Path$7.fromRect(this.box.clone().pad(borderWidth).toRect()));
        clipPath.paths.push(Path$7.fromPoints(this.points));

        result.clip(clipPath);

        return result;
    };

    FunnelSegment.prototype.tooltipAnchor = function tooltipAnchor () {
        var box = this.box;
        return {
            point: new Point$5(box.center().x, box.y1),
            align: {
                horizontal: "center",
                vertical: "top"
            }
        };
    };

    FunnelSegment.prototype.formatValue = function formatValue (format) {
        var point = this;
        return point.owner.formatPointValue(point, format);
    };

    FunnelSegment.prototype.pointData = function pointData () {
        return {
            dataItem: this.dataItem,
            category: this.category,
            value: this.value,
            series: this.series,
            percentage: this.percentage
        };
    };

    FunnelSegment.prototype.getIndex = function getIndex () {
        return this.index;
    };

    return FunnelSegment;
}(ChartElement));

setDefaultOptions(FunnelSegment, {
    color: WHITE$1,
    border: {
        width: 1
    },
    labels: {
        format: ""
    },
    accessibility: {
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
});

deepExtend(FunnelSegment.prototype, PointEventsMixin);
deepExtend(FunnelSegment.prototype, AccessibilityAttributesMixin);

var FunnelChart = (function (ChartElement) {
    function FunnelChart(plotArea, options) {
        ChartElement.call(this, options);

        this.plotArea = plotArea;
        this.chartService = plotArea.chartService;
        this.points = [];
        this.labels = [];
        this.legendItems = [];
        this.render();
    }

    if ( ChartElement ) FunnelChart.__proto__ = ChartElement;
    FunnelChart.prototype = Object.create( ChartElement && ChartElement.prototype );
    FunnelChart.prototype.constructor = FunnelChart;

    FunnelChart.prototype.formatPointValue = function formatPointValue (point, format) {
        return this.plotArea.chartService.format.auto(format,point.value);
    };

    FunnelChart.prototype.render = function render () {
        var this$1$1 = this;

        var seriesIx = 0;
        var ref = this;
        var options = ref.options;
        var seriesColors = ref.plotArea.options.seriesColors; if ( seriesColors === void 0 ) seriesColors = [];
        var series = options.series[seriesIx];
        var data = series.data;

        if (!data) {
            return;
        }

        var ref$1 = bindSegments(series);
        var total = ref$1.total;
        var points = ref$1.points;

        for (var i = 0; i < points.length; i++) {
            var pointData = points[i];

            if (!pointData) {
                continue;
            }

            var fields = pointData.fields;

            if (!isFunction(series.color)) {
                series.color = fields.color || seriesColors[i % seriesColors.length];
            }

            fields = deepExtend({
                index: i,
                owner: this$1$1,
                series: series,
                seriesIx: seriesIx,
                dataItem: data[i],
                percentage: pointData.value / total
            }, fields, { visible: pointData.visible });

            var value = pointData.valueFields.value;
            var segment = this$1$1.createSegment(value, fields);
            var label = this$1$1.createLabel(value, fields);

            if (segment && label) {
                segment.append(label);
            }
        }
    };

    FunnelChart.prototype.evalSegmentOptions = function evalSegmentOptions (options, value, fields) {
        var series = fields.series;

        evalOptions(options, {
            value: value,
            series: series,
            dataItem: fields.dataItem,
            index: fields.index
        }, { defaults: series._defaults, excluded: [
            "data", "content", "template", "toggle", "visual",
            "ariaTemplate", "ariaContent"
        ] });
    };

    FunnelChart.prototype.createSegment = function createSegment (value, fields) {
        var seriesOptions = deepExtend({}, fields.series);
        seriesOptions.pattern = fields.pattern || seriesOptions.pattern;

        this.evalSegmentOptions(seriesOptions, value, fields);

        this.createLegendItem(value, seriesOptions, fields);

        if (fields.visible !== false) {

            var segment = new FunnelSegment(value, seriesOptions, fields);
            Object.assign(segment, fields);

            this.append(segment);
            this.points.push(segment);

            return segment;
        }
    };

    FunnelChart.prototype.createLabel = function createLabel (value, fields) {
        var series = fields.series;
        var dataItem = fields.dataItem;
        var labels = deepExtend({}, this.options.labels, series.labels);
        var text = value;

        if (labels.visible) {
            var labelTemplate = getTemplate$1(labels);
            var data = {
                dataItem: dataItem,
                value: value,
                percentage: fields.percentage,
                category: fields.category,
                series: series
            };
            if (labelTemplate) {
                text = labelTemplate(data);
            } else if (labels.format) {
                text = this.chartService.format.auto(labels.format, text);
            }

            if (!labels.color) {
                labels.color = autoTextColor(series.color);
                if (!labels.background) {
                    labels.background = series.color;
                }
            }

            this.evalSegmentOptions(labels, value, fields);
            var textBox = new TextBox(text, deepExtend({
                vAlign: labels.position
            }, labels), data);

            this.labels.push(textBox);

            return textBox;
        }
    };

    FunnelChart.prototype.labelPadding = function labelPadding () {
        var labels = this.labels;
        var padding = { left: 0, right: 0 };

        for (var i = 0; i < labels.length; i++) {
            var label = labels[i];
            var align = label.options.align;
            if (align !== CENTER) {
                var width = labels[i].box.width();

                if (align === LEFT) {
                    padding.left = Math.max(padding.left, width);
                } else {
                    padding.right = Math.max(padding.right, width);
                }
            }
        }

        return padding;
    };

    FunnelChart.prototype.dynamicSlopeReflow = function dynamicSlopeReflow (box, width, totalHeight) {
        var ref = this;
        var options = ref.options;
        var segments = ref.points;
        var count = segments.length;
        var firstSegment = segments[0];
        var maxSegment = firstSegment;

        for (var idx = 0; idx < segments.length; idx++) {
            if (segments[idx].percentage > maxSegment.percentage) {
                maxSegment = segments[idx];
            }
        }

        var lastUpperSide = (firstSegment.percentage / maxSegment.percentage) * width;
        var previousOffset = (width - lastUpperSide) / 2;
        var previousHeight = 0;

        for (var idx$1 = 0; idx$1 < count; idx$1++) {
            var percentage = segments[idx$1].percentage;
            var nextSegment = segments[idx$1 + 1];
            var nextPercentage = (nextSegment ? nextSegment.percentage : percentage);
            var points = segments[idx$1].points = [];
            var height = (options.dynamicHeight) ? (totalHeight * percentage) : (totalHeight / count);
            var offset = (void 0);

            if (!percentage) {
                offset = nextPercentage ? 0 : width / 2;
            } else {
                offset = (width - lastUpperSide * (nextPercentage / percentage)) / 2;
            }

            offset = limitValue(offset, 0, width);

            points.push(new Point$6(box.x1 + previousOffset, box.y1 + previousHeight));
            points.push(new Point$6(box.x1 + width - previousOffset, box.y1 + previousHeight));
            points.push(new Point$6(box.x1 + width - offset, box.y1 + height + previousHeight));
            points.push(new Point$6(box.x1 + offset, box.y1 + height + previousHeight));

            previousOffset = offset;
            previousHeight += height + options.segmentSpacing;
            lastUpperSide = limitValue(width - 2 * offset, 0, width);
        }
    };

    FunnelChart.prototype.constantSlopeReflow = function constantSlopeReflow (box, width, totalHeight) {
        var ref = this;
        var options = ref.options;
        var segments = ref.points;
        var count = segments.length;
        var decreasingWidth = options.neckRatio <= 1;
        var neckRatio = decreasingWidth ? options.neckRatio * width : width;
        var previousOffset = decreasingWidth ? 0 : (width - width / options.neckRatio) / 2;
        var topMostWidth = decreasingWidth ? width : width - previousOffset * 2;
        var finalNarrow = (topMostWidth - neckRatio) / 2;
        var previousHeight = 0;

        for (var idx = 0; idx < count; idx++) {
            var points = segments[idx].points = [];
            var percentage = segments[idx].percentage;
            var offset = (options.dynamicHeight) ? (finalNarrow * percentage) : (finalNarrow / count);
            var height = (options.dynamicHeight) ? (totalHeight * percentage) : (totalHeight / count);

            points.push(new Point$6(box.x1 + previousOffset, box.y1 + previousHeight));
            points.push(new Point$6(box.x1 + width - previousOffset, box.y1 + previousHeight));
            points.push(new Point$6(box.x1 + width - previousOffset - offset, box.y1 + height + previousHeight));
            points.push(new Point$6(box.x1 + previousOffset + offset,box.y1 + height + previousHeight));
            previousOffset += offset;
            previousHeight += height + options.segmentSpacing;
        }
    };

    FunnelChart.prototype.reflow = function reflow (chartBox) {
        var points = this.points;
        var count = points.length;

        if (!count) {
            return;
        }

        var options = this.options;
        var box = chartBox.clone().unpad(this.labelPadding());
        var totalHeight = box.height() - options.segmentSpacing * (count - 1);
        var width = box.width();

        if (options.dynamicSlope) {
            this.dynamicSlopeReflow(box, width, totalHeight);
        } else {
            this.constantSlopeReflow(box, width, totalHeight);
        }

        for (var idx = 0; idx < count; idx++) {
            points[idx].reflow(chartBox);
        }
    };

    return FunnelChart;
}(ChartElement));

setDefaultOptions(FunnelChart, {
    neckRatio: 0.3,
    width: 300,
    dynamicSlope: false,
    dynamicHeight: true,
    segmentSpacing: 0,
    labels: {
        visible: false,
        align: CENTER,
        position: CENTER,
        zIndex: 1
    }
});

deepExtend(FunnelChart.prototype, PieChartMixin);

var MAX_NECK_RATIO = 1e6;

var PyramidChart = (function (FunnelChart) {
    function PyramidChart(plotArea, options) {
        options.dynamicSlope = false;
        options.neckRatio = MAX_NECK_RATIO;

        FunnelChart.call(this, plotArea, options);
    }

    if ( FunnelChart ) PyramidChart.__proto__ = FunnelChart;
    PyramidChart.prototype = Object.create( FunnelChart && FunnelChart.prototype );
    PyramidChart.prototype.constructor = PyramidChart;

    return PyramidChart;
}(FunnelChart));

var FunnelPlotArea = (function (PlotAreaBase) {
    function FunnelPlotArea () {
        PlotAreaBase.apply(this, arguments);
    }

    if ( PlotAreaBase ) FunnelPlotArea.__proto__ = PlotAreaBase;
    FunnelPlotArea.prototype = Object.create( PlotAreaBase && PlotAreaBase.prototype );
    FunnelPlotArea.prototype.constructor = FunnelPlotArea;

    FunnelPlotArea.prototype.render = function render () {
        this.createChart(FunnelChart, filterSeriesByType(this.series, [ FUNNEL ]));
        this.createChart(PyramidChart, filterSeriesByType(this.series, [ PYRAMID ]));
    };

    FunnelPlotArea.prototype.createChart = function createChart (chartType, series) {
        var firstSeries = series[0];
        if (!firstSeries) {
            return;
        }

        var chart = new chartType(this, {
            series: series,
            legend: this.options.legend,
            neckRatio: firstSeries.neckRatio,
            dynamicHeight: firstSeries.dynamicHeight,
            dynamicSlope: firstSeries.dynamicSlope,
            segmentSpacing: firstSeries.segmentSpacing,
            highlight: firstSeries.highlight
        });

        this.appendChart(chart);
    };

    FunnelPlotArea.prototype.appendChart = function appendChart (chart, pane) {
        PlotAreaBase.prototype.appendChart.call(this, chart, pane);
        append(this.options.legend.data, chart.legendItems);
    };

    FunnelPlotArea.prototype._pointsByVertical = function _pointsByVertical (basePoint) {
        return this.pointsBySeriesIndex(basePoint.series.index);
    };

    FunnelPlotArea.prototype.getPointToTheRight = function getPointToTheRight (point) {
        return this.getPointBelow(point);
    };

    FunnelPlotArea.prototype.getPointToTheLeft = function getPointToTheLeft (point) {
        return this.getPointAbove(point);
    };

    return FunnelPlotArea;
}(PlotAreaBase));

// Linear color scale from the given color to white minus minimum lightness offset.
var colorScale = function (color, minLightnessOffset) {
    if ( minLightnessOffset === void 0 ) minLightnessOffset = 0.05;

    var baseColor = parseColor(color);
    var offset = 1 - minLightnessOffset;

    return function (value) {
        var hsl = baseColor.toHSL();
        var range = 100 - hsl.l;
        var point = offset - value;
        hsl.l += Math.min(point * range, range);

        return hsl.toCss();
    };
};

var HeatmapPoint = (function (ChartElement) {
    function HeatmapPoint(value, options) {
        ChartElement.call(this);

        this.options = options;
        this.color = options.color || WHITE$1;
        this.value = value;
    }

    if ( ChartElement ) HeatmapPoint.__proto__ = ChartElement;
    HeatmapPoint.prototype = Object.create( ChartElement && ChartElement.prototype );
    HeatmapPoint.prototype.constructor = HeatmapPoint;

    HeatmapPoint.prototype.render = function render () {
        if (this._rendered) {
            return;
        }

        this._rendered = true;

        this.createMarker();
        this.createLabel();
        this.createNote();
    };

    HeatmapPoint.prototype.createLabel = function createLabel () {
        var options = this.options;
        var labels = options.labels;

        if (labels.visible) {
            this.label = this.createLabelElement(labels);
            this.append(this.label);
        }
    };

    HeatmapPoint.prototype.createLabelElement = function createLabelElement (options) {
        var labelColor = options.color;

        if (!labelColor) {
            labelColor = autoTextColor(this.color);
        }

        return new TextBox(this.getLabelText(options),
            deepExtend({
                align: CENTER,
                vAlign: CENTER,
                margin: {
                    left: 5,
                    right: 5
                },
                zIndex: valueOrDefault(options.zIndex, this.series.zIndex)
            },
            options, {
                color: labelColor
            }),
            this.pointData()
        );
    };

    HeatmapPoint.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = getTemplate$1(options);

        if (labelTemplate) {
            return labelTemplate(this.pointData());
        }

        return this.formatValue(options.format);
    };

    HeatmapPoint.prototype.formatValue = function formatValue (format) {
        return this.owner.formatPointValue(this, format);
    };

    HeatmapPoint.prototype.reflow = function reflow (targetBox) {
        this.render();

        var label = this.label;

        this.box = targetBox;

        if (label) {
            label.reflow(this.markerBox());
        }

        if (this.note) {
            this.note.reflow(targetBox);
        }

        this.marker.reflow(this.markerBox());
    };

    HeatmapPoint.prototype.createVisual = function createVisual () {
        ChartElement.prototype.createVisual.call(this);

        this.addAccessibilityAttributesToVisual();
    };

    HeatmapPoint.prototype.markerBox = function markerBox () {
        var options = this.options;
        var markers = options.markers;
        var border = markers.border;
        var rect = this.box.toRect();
        var type = valueOrDefault(markers.type, 'rect');
        var isRoundRect = type === ROUNDED_RECT;
        var borderWidth = valueOrDefault(border.width, isRoundRect ? 1 : 0);
        var halfBorderWidth = Math.round(borderWidth / 2);

        if (markers.size) {
            var center = rect.center();
            rect.size.width = rect.size.height = markers.size;
            rect.origin.x = Math.round(center.x - rect.size.width / 2);
            rect.origin.y = Math.round(center.y - rect.size.height / 2);
        }

        rect.size.width -= borderWidth;
        rect.size.height -= borderWidth;
        rect.origin.y += halfBorderWidth + 0.5;
        rect.origin.x += halfBorderWidth + 0.5;

        return rectToBox(rect);
    };

    HeatmapPoint.prototype.markerBorder = function markerBorder () {
        var options = this.options;
        var markers = options.markers;
        var border = markers.border;
        var opacity = valueOrDefault(border.opacity, options.opacity);

        return {
            color: border.color || this.color,
            width: border.width,
            opacity: opacity,
            dashType: border.dashType
        };
    };

    HeatmapPoint.prototype.createMarker = function createMarker () {
        var options = this.options;
        var markerOptions = options.markers;
        var marker = new ShapeElement({
            type: valueOrDefault(markerOptions.type, 'rect'),
            width: markerOptions.size,
            height: markerOptions.size,
            rotation: markerOptions.rotation,
            background: this.color,
            border: this.markerBorder(),
            pattern: options.pattern,
            borderRadius: markerOptions.borderRadius,
            opacity: this.series.opacity || options.opacity,
            zIndex: valueOrDefault(options.zIndex, this.series.zIndex),
            animation: options.animation,
            visual: options.visual
        }, {
            dataItem: this.dataItem,
            value: this.value,
            series: this.series,
            category: this.category
        });

        this.marker = marker;
        this.append(marker);
    };

    HeatmapPoint.prototype.createHighlight = function createHighlight (style) {
        var options = this.options;
        var markerOptions = this.options.highlight.markers || this.options.markers;

        var highlight = new ShapeElement({
            type: valueOrDefault(markerOptions.type, 'rect'),
            width: markerOptions.size,
            height: markerOptions.size,
            rotation: markerOptions.rotation,
            background: markerOptions.color || this.color,
            border: this.markerBorder(),
            borderRadius: markerOptions.borderRadius,
            opacity: this.series.opacity || options.opacity,
            zIndex: valueOrDefault(options.zIndex, this.series.zIndex)
        });

        highlight.reflow(this.markerBox());
        var visual = highlight.getElement();

        visual.options.fill = style.fill;
        visual.options.stroke = style.stroke;

        return visual;
    };

    HeatmapPoint.prototype.highlightVisual = function highlightVisual () {
        return this.rectVisual;
    };

    HeatmapPoint.prototype.highlightVisualArgs = function highlightVisualArgs () {
        return {
            options: this.options,
            rect: this.box.toRect(),
            visual: this.rectVisual
        };
    };

    HeatmapPoint.prototype.createFocusHighlight = function createFocusHighlight () {
        var markerOptions = this.options.markers;
        var highlightOptions = this.options.focusHighlight;

        var highlight = new ShapeElement({
            type: valueOrDefault(markerOptions.type, 'rect'),
            width: markerOptions.size,
            height: markerOptions.size,
            rotation: markerOptions.rotation,
            background: highlightOptions.color,
            border: highlightOptions.border,
            borderRadius: markerOptions.borderRadius,
            padding: highlightOptions.border.width / 2,
            zIndex: highlightOptions.zIndex
        });

        highlight.reflow(this.markerBox());

        return highlight.getElement();
    };

    HeatmapPoint.prototype.tooltipAnchor = function tooltipAnchor () {
        var left = this.box.center().x;
        var top = this.box.y1 - TOOLTIP_OFFSET;

        return {
            point: new Point$5(left, top),
            align: {
                horizontal: CENTER,
                vertical: BOTTOM$1
            }
        };
    };

    HeatmapPoint.prototype.overlapsBox = function overlapsBox (box) {
        return this.box.overlaps(box);
    };

    HeatmapPoint.prototype.unclipElements = function unclipElements () {
        /* noop, clip labels */
    };

    HeatmapPoint.prototype.pointData = function pointData () {
        return {
            x: this.value.x,
            y: this.value.y,
            value: this.value.value,
            dataItem: this.dataItem,
            series: this.series
        };
    };

    return HeatmapPoint;
}(ChartElement));

deepExtend(HeatmapPoint.prototype, PointEventsMixin);
deepExtend(HeatmapPoint.prototype, NoteMixin);
deepExtend(HeatmapPoint.prototype, AccessibilityAttributesMixin);

HeatmapPoint.prototype.defaults = {
    markers: {
        type: 'rect',
        borderRadius: 4,
        border: {
            color: 'transparent'
        }
    },
    padding: { top: 1 },
    labels: {
        visible: false,
        padding: 3
    },
    opacity: 1,
    notes: {
        label: {}
    },
    accessibility: {
        role: CHART_POINT_ROLE,
        className: CHART_POINT_CLASSNAME,
        ariaRoleDescription: CHART_POINT_ROLE_DESCRIPTION
    }
};

var HeatmapChart = (function (ChartElement) {
    function HeatmapChart(plotArea, options) {
        ChartElement.call(this, options);

        this.plotArea = plotArea;
        this.chartService = plotArea.chartService;
        this._initFields();

        this.render();
    }

    if ( ChartElement ) HeatmapChart.__proto__ = ChartElement;
    HeatmapChart.prototype = Object.create( ChartElement && ChartElement.prototype );
    HeatmapChart.prototype.constructor = HeatmapChart;

    HeatmapChart.prototype._initFields = function _initFields () {
        this.points = [];
        this.seriesOptions = [];
        this.valueRange = { min: MAX_VALUE, max: MIN_VALUE };
        this._evalSeries = [];
    };

    HeatmapChart.prototype.render = function render () {
        this.setRange();
        this.traverseDataPoints(this.addValue.bind(this));
    };

    HeatmapChart.prototype.setRange = function setRange () {
        var this$1$1 = this;

        var ref = this;
        var series = ref.options.series;

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];

            for (var pointIx = 0; pointIx < currentSeries.data.length; pointIx++) {
                var ref$1 = this$1$1.plotArea.bindPoint(currentSeries, pointIx);
                var valueFields = ref$1.valueFields;
                if (defined(valueFields.value) && valueFields.value !== null) {
                    this$1$1.valueRange.min = Math.min(this$1$1.valueRange.min, valueFields.value);
                    this$1$1.valueRange.max = Math.max(this$1$1.valueRange.max, valueFields.value);
                }
            }
        }
    };

    HeatmapChart.prototype.addValue = function addValue (value, fields) {
        var point;
        if (value && defined(value.value) && value.value !== null) {
            point = this.createPoint(value, fields);
            if (point) {
                Object.assign(point, fields);
            }
        }

        this.points.push(point);
    };

    HeatmapChart.prototype.evalPointOptions = function evalPointOptions (options, value, fields) {
        var series = fields.series;
        var seriesIx = fields.seriesIx;
        var state = {
            defaults: series._defaults,
            excluded: [
                "data", "tooltip", "content", "template",
                "visual", "toggle", "drilldownSeriesFactory",
                "ariaTemplate", "ariaContent"
            ]
        };

        var doEval = this._evalSeries[seriesIx];
        if (!defined(doEval)) {
            this._evalSeries[seriesIx] = doEval = evalOptions(options, {}, state, true);
        }

        var pointOptions = options;
        if (doEval) {
            pointOptions = deepExtend({}, options);
            evalOptions(pointOptions, {
                value: value,
                series: series,
                dataItem: fields.dataItem,
                min: this.valueRange.min,
                max: this.valueRange.max
            }, state);
        }

        return pointOptions;
    };

    HeatmapChart.prototype.pointType = function pointType () {
        return HeatmapPoint;
    };

    HeatmapChart.prototype.pointOptions = function pointOptions (series, seriesIx) {
        var options = this.seriesOptions[seriesIx];
        if (!options) {
            var defaults = this.pointType().prototype.defaults;
            this.seriesOptions[seriesIx] = options = deepExtend({}, defaults, {
                markers: {
                    opacity: series.opacity
                },
                tooltip: {
                    format: this.options.tooltip.format
                },
                labels: {
                    format: this.options.labels.format
                }
            }, series);
        }

        return Object.assign({}, options);
    };

    HeatmapChart.prototype.createPoint = function createPoint (value, fields) {
        var series = fields.series;
        var pointOptions = this.pointOptions(series, fields.seriesIx);
        var color = fields.color || series.color;

        pointOptions.pattern = fields.pattern || pointOptions.pattern;
        pointOptions = this.evalPointOptions(pointOptions, value, fields);

        if (isFunction(series.color)) {
            color = pointOptions.color;
        } else if (this.valueRange.max !== 0) {
            var scale = colorScale(color);
            color = scale(value.value / this.valueRange.max);
        }

        var point = new HeatmapPoint(value, pointOptions);
        point.color = color;

        this.append(point);

        return point;
    };

    HeatmapChart.prototype.seriesAxes = function seriesAxes (series) {
        var xAxisName = series.xAxis;
        var yAxisName = series.yAxis;
        var plotArea = this.plotArea;
        var xAxis = xAxisName ? plotArea.namedXAxes[xAxisName] : plotArea.axisX;
        var yAxis = yAxisName ? plotArea.namedYAxes[yAxisName] : plotArea.axisY;

        if (!xAxis) {
            throw new Error("Unable to locate X axis with name " + xAxisName);
        }

        if (!yAxis) {
            throw new Error("Unable to locate Y axis with name " + yAxisName);
        }

        return { xAxis: xAxis, yAxis: yAxis };
    };

    HeatmapChart.prototype.reflow = function reflow (targetBox) {
        var this$1$1 = this;

        var chartPoints = this.points;
        var limit = !this.options.clip;
        var pointIx = 0;


        this.traverseDataPoints(function (value, fields) {
            var point = chartPoints[pointIx++];
            var ref = this$1$1.seriesAxes(fields.series);
            var xAxis = ref.xAxis;
            var yAxis = ref.yAxis;
            var indexX = xAxis.categoryIndex(value.x);
            var indexY = yAxis.categoryIndex(value.y);
            var slotX = xAxis.getSlot(indexX, indexX, limit);
            var slotY = yAxis.getSlot(indexY, indexY, limit);

            if (point) {
                if (slotX && slotY) {
                    var pointSlot = this$1$1.pointSlot(slotX, slotY);
                    point.reflow(pointSlot);
                } else {
                    point.visible = false;
                }
            }
        });

        this.box = targetBox;
    };

    HeatmapChart.prototype.pointSlot = function pointSlot (slotX, slotY) {
        return new Box(slotX.x1, slotY.y1, slotX.x2, slotY.y2);
    };

    HeatmapChart.prototype.traverseDataPoints = function traverseDataPoints (callback) {
        var this$1$1 = this;

        var ref = this;
        var series = ref.options.series;

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];
            var ref$1 = this$1$1.seriesAxes(currentSeries);
            var xAxis = ref$1.xAxis;
            var yAxis = ref$1.yAxis;
            var xRange = xAxis.currentRangeIndices();
            var yRange = yAxis.currentRangeIndices();

            for (var pointIx = 0; pointIx < currentSeries.data.length; pointIx++) {
                var ref$2 = this$1$1.plotArea.bindPoint(currentSeries, pointIx);
                var value = ref$2.valueFields;
                var fields = ref$2.fields;
                var xIndex = xAxis.totalIndex(value.x);
                var yIndex = yAxis.totalIndex(value.y);
                var xIn = xRange.min <= xIndex && xIndex <= xRange.max;
                var yIn = yRange.min <= yIndex && yIndex <= yRange.max;

                if (xIn && yIn) {
                    callback(value, deepExtend({
                        pointIx: pointIx,
                        series: currentSeries,
                        seriesIx: seriesIx,
                        dataItem: currentSeries.data[pointIx],
                        owner: this$1$1
                    }, fields));
                }
            }
        }
    };

    HeatmapChart.prototype.formatPointValue = function formatPointValue (point, format) {
        var value = point.value;
        return this.chartService.format.auto(format, value.x, value.y, value.value);
    };

    HeatmapChart.prototype.animationPoints = function animationPoints () {
        var points = this.points;
        var result = [];
        for (var idx = 0; idx < points.length; idx++) {
            result.push((points[idx] || {}).marker);
        }
        return result;
    };

    return HeatmapChart;
}(ChartElement));
setDefaultOptions(HeatmapChart, {
    series: [],
    tooltip: {
        format: "{0}, {1}: {2}"
    },
    labels: {
        format: "{2}"
    },
    clip: true
});

var HeatmapPlotArea = (function (PlotAreaBase) {
    function HeatmapPlotArea () {
        PlotAreaBase.apply(this, arguments);
    }

    if ( PlotAreaBase ) HeatmapPlotArea.__proto__ = PlotAreaBase;
    HeatmapPlotArea.prototype = Object.create( PlotAreaBase && PlotAreaBase.prototype );
    HeatmapPlotArea.prototype.constructor = HeatmapPlotArea;

    HeatmapPlotArea.prototype.initFields = function initFields () {
        this.namedXAxes = {};
        this.namedYAxes = {};
    };

    HeatmapPlotArea.prototype.render = function render (panes) {
        if ( panes === void 0 ) panes = this.panes;

        this.bindCategories();
        this.createAxes(panes);
        this.createCharts(panes);
        this.createAxisLabels();
    };

    HeatmapPlotArea.prototype.bindCategories = function bindCategories () {
        var this$1$1 = this;

        var series = this.srcSeries || this.series;

        for (var i = 0; i < series.length; i++) {
            var currentSeries = series[i];
            var data = currentSeries.data || [];
            var ref = this$1$1.seriesAxes(currentSeries);
            var xAxis = ref.xAxis;
            var yAxis = ref.yAxis;

            var xCategories = createHashSet(xAxis.categories || []);
            var yCategories = createHashSet(yAxis.categories || []);

            for (var pointIndex = 0; pointIndex < data.length; pointIndex++) {
                var ref$1 = SeriesBinder.current.bindPoint(currentSeries, pointIndex).valueFields;
                var x = ref$1.x;
                var y = ref$1.y;

                if (!xCategories.has(x)) {
                    xCategories.add(x);
                }

                if (!yCategories.has(y)) {
                    yCategories.add(y);
                }
            }

            xAxis.categories = xCategories.values();
            yAxis.categories = yCategories.values();
        }
    };

    HeatmapPlotArea.prototype.createCharts = function createCharts (panes) {
        var this$1$1 = this;

        var seriesByPane = this.groupSeriesByPane();

        for (var i = 0; i < panes.length; i++) {
            var pane = panes[i];
            var paneSeries = seriesByPane[pane.options.name || "default"] || [];
            this$1$1.addToLegend(paneSeries);
            var filteredSeries = this$1$1.filterVisibleSeries(paneSeries);

            if (!filteredSeries) {
                continue;
            }

            this$1$1.createHeatmapChart(
                filterSeriesByType(filteredSeries, [ HEATMAP ]),
                pane
            );
        }
    };

    HeatmapPlotArea.prototype.createHeatmapChart = function createHeatmapChart (series, pane) {
        var chart = new HeatmapChart(this, {
            series: series
        });

        this.appendChart(chart, pane);
    };

    HeatmapPlotArea.prototype.seriesPaneName = function seriesPaneName (series) {
        var options = this.options;
        var xAxisName = series.xAxis;
        var xAxisOptions = [].concat(options.xAxis);
        var xAxis = grep(xAxisOptions, function(a) { return a.name === xAxisName; })[0];
        var yAxisName = series.yAxis;
        var yAxisOptions = [].concat(options.yAxis);
        var yAxis = grep(yAxisOptions, function(a) { return a.name === yAxisName; })[0];
        var panes = options.panes || [ {} ];
        var defaultPaneName = panes[0].name || "default";
        var paneName = (xAxis || {}).pane || (yAxis || {}).pane || defaultPaneName;

        return paneName;
    };

    HeatmapPlotArea.prototype.seriesAxes = function seriesAxes (series) {
        var xAxis;
        var yAxis;

        var options = this.options;

        var xAxisOptions = [].concat(options.xAxis);
        var xAxisName = series.xAxis;
        if (xAxisName) {
            xAxis = xAxisOptions.find(function (axis) { return axis.name === xAxisName; });
        } else {
            xAxis = xAxisOptions[0];
        }

        var yAxisOptions = [].concat(options.yAxis);
        var yAxisName = series.yAxis;
        if (yAxisName) {
            yAxis = yAxisOptions.find(function (axis) { return axis.name === yAxisName; });
        } else {
            yAxis = yAxisOptions[0];
        }

        if (!xAxis) {
            throw new Error("Unable to locate X axis with name " + xAxisName);
        }

        if (!yAxis) {
            throw new Error("Unable to locate Y axis with name " + yAxisName);
        }

        return { xAxis: xAxis, yAxis: yAxis };
    };

    HeatmapPlotArea.prototype.createAxisLabels = function createAxisLabels () {
        var axes = this.axes;
        for (var i = 0; i < axes.length; i++) {
            axes[i].createLabels();
        }
    };

    HeatmapPlotArea.prototype.createXYAxis = function createXYAxis (options, vertical, axisIndex) {
        var axisName = options.name;
        var namedAxes = vertical ? this.namedYAxes : this.namedXAxes;
        var axisOptions = Object.assign({
            axisCrossingValue: 0
        }, options, {
            vertical: vertical,
            reverse: (vertical || this.chartService.rtl) ? !options.reverse : options.reverse,
            justified: false
        });
        var firstCategory = axisOptions.categories ? axisOptions.categories[0] : null;
        var typeSamples = [ axisOptions.min, axisOptions.max, firstCategory ];
        var series = this.series;

        for (var seriesIx = 0; seriesIx < series.length; seriesIx++) {
            var currentSeries = series[seriesIx];
            var seriesAxisName = currentSeries[vertical ? "yAxis" : "xAxis"];
            if ((seriesAxisName === axisOptions.name) || (axisIndex === 0 && !seriesAxisName)) {
                var firstPointValue = SeriesBinder.current.bindPoint(currentSeries, 0).valueFields;
                typeSamples.push(firstPointValue[vertical ? "y" : "x"]);

                break;
            }
        }

        var inferredDate;

        for (var i = 0; i < typeSamples.length; i++) {
            if (typeSamples[i] instanceof Date) {
                inferredDate = true;
                break;
            }
        }

        var axisType;
        if (equalsIgnoreCase(axisOptions.type, DATE) || (!axisOptions.type && inferredDate)) {
            axisType = DateCategoryAxis;
        } else {
            axisType = CategoryAxis;
        }

        var axis = new axisType(axisOptions, this.chartService);
        axis.axisIndex = axisIndex;

        if (axisName) {
            if (namedAxes[axisName]) {
                throw new Error(((vertical ? "Y" : "X") + " axis with name " + axisName + " is already defined"));
            }
            namedAxes[axisName] = axis;
        }

        this.appendAxis(axis);
        axis.indexCategories();

        return axis;
    };

    HeatmapPlotArea.prototype.createAxes = function createAxes (panes) {
        var this$1$1 = this;

        var options = this.options;
        var xAxesOptions = [].concat(options.xAxis);
        var xAxes = [];
        var yAxesOptions = [].concat(options.yAxis);
        var yAxes = [];

        for (var idx = 0; idx < xAxesOptions.length; idx++) {
            var axisPane = this$1$1.findPane(xAxesOptions[idx].pane);
            if (inArray(axisPane, panes)) {
                xAxes.push(this$1$1.createXYAxis(xAxesOptions[idx], false, idx));
            }
        }

        for (var idx$1 = 0; idx$1 < yAxesOptions.length; idx$1++) {
            var axisPane$1 = this$1$1.findPane(yAxesOptions[idx$1].pane);
            if (inArray(axisPane$1, panes)) {
                yAxes.push(this$1$1.createXYAxis(yAxesOptions[idx$1], true, idx$1));
            }
        }

        this.axisX = this.axisX || xAxes[0];
        this.axisY = this.axisY || yAxes[0];
    };

    HeatmapPlotArea.prototype.removeAxis = function removeAxis (axis) {
        var axisName = axis.options.name;

        PlotAreaBase.prototype.removeAxis.call(this, axis);

        if (axis.options.vertical) {
            delete this.namedYAxes[axisName];
        } else {
            delete this.namedXAxes[axisName];
        }

        if (axis === this.axisX) {
            delete this.axisX;
        }

        if (axis === this.axisY) {
            delete this.axisY;
        }
    };

    HeatmapPlotArea.prototype._dispatchEvent = function _dispatchEvent (chart, e, eventType) {
        var coords = chart._eventCoordinates(e);
        var point = new Point$5(coords.x, coords.y);
        var allAxes = this.axes;
        var length = allAxes.length;
        var xValues = [];
        var yValues = [];

        for (var i = 0; i < length; i++) {
            var axis = allAxes[i];
            var values = axis.options.vertical ? yValues : xValues;
            appendIfNotNull(values, axis.getCategory(point));
        }

        if (xValues.length > 0 && yValues.length > 0) {
            chart.trigger(eventType, {
                element: eventElement(e),
                originalEvent: e,
                x: singleItemOrArray(xValues),
                y: singleItemOrArray(yValues)
            });
        }
    };

    HeatmapPlotArea.prototype.updateAxisOptions = function updateAxisOptions$1 (axis, options) {
        var vertical = axis.options.vertical;
        var axes = this.groupAxes(this.panes);
        var index = (vertical ? axes.y : axes.x).indexOf(axis);

        updateAxisOptions(this.options, index, vertical, options);
        updateAxisOptions(this.originalOptions, index, vertical, options);
    };

    HeatmapPlotArea.prototype.crosshairOptions = function crosshairOptions (axis) {
        // Stack the crosshair above the series points.
        return Object.assign({}, axis.options.crosshair, { zIndex: 0 });
    };

    HeatmapPlotArea.prototype._pointsByVertical = function _pointsByVertical (basePoint, offset) {
        var this$1$1 = this;
        if ( offset === void 0 ) offset = 0;

        var normalizedOffset = this.axisX.options.reverse ? offset * -1 : offset;
        var axisXItems = this.axisX.children;
        var xIndex = this._getPointAxisXIndex(basePoint) + normalizedOffset;

        xIndex = cycleIndex(xIndex, axisXItems.length);
        var targetXValue = axisXItems[xIndex].value;

        var points = this
            .filterPoints(function (point) { return compareValues(point.pointData().x, targetXValue); })
            .sort(function (a, b) { return this$1$1._getPointAxisYIndex(a) - this$1$1._getPointAxisYIndex(b); });

        if (this.axisY.options.reverse) {
            return points.reverse();
        }

        return points;
    };

    HeatmapPlotArea.prototype._pointsByHorizontal = function _pointsByHorizontal (basePoint, offset) {
        var this$1$1 = this;
        if ( offset === void 0 ) offset = 0;

        var normalizedOffset = this.axisY.options.reverse ? offset * -1 : offset;
        var axisYItems = this.axisY.children;
        var yIndex = this._getPointAxisYIndex(basePoint) + normalizedOffset;

        yIndex = cycleIndex(yIndex, axisYItems.length);
        var targetYValue = axisYItems[yIndex].value;

        var points = this
            .filterPoints(function (point) { return compareValues(point.pointData().y, targetYValue); })
            .sort(function (a, b) { return this$1$1._getPointAxisXIndex(a) - this$1$1._getPointAxisXIndex(b); });

        if (this.axisX.options.reverse) {
            return points.reverse();
        }

        return points;
    };

    HeatmapPlotArea.prototype._getPointAxisXIndex = function _getPointAxisXIndex (point) {
        return this._getPointAxisIndex(this.axisX, point.pointData().x);
    };

    HeatmapPlotArea.prototype._getPointAxisYIndex = function _getPointAxisYIndex (point) {
        return this._getPointAxisIndex(this.axisY, point.pointData().y);
    };

    HeatmapPlotArea.prototype._getPointAxisIndex = function _getPointAxisIndex (axis, pointValue) {
        return axis.children.findIndex(function (axisItem) { return compareValues(pointValue, axisItem.value); });
    };

    return HeatmapPlotArea;
}(PlotAreaBase));

function compareValues(a, b) {
    if (a instanceof Date && b instanceof Date) {
        return dateEquals(a, b);
    }

    return a === b;
}

function updateAxisOptions(targetOptions, axisIndex, vertical, options) {
    var axisOptions = ([].concat(vertical ? targetOptions.yAxis : targetOptions.xAxis))[axisIndex];
    deepExtend(axisOptions, options);
}

setDefaultOptions(HeatmapPlotArea, {
    xAxis: {},
    yAxis: {}
});

deepExtend(HeatmapPlotArea.prototype, PlotAreaEventsMixin);

var COLOR = "color";
var FIRST = "first";
var FROM = "from";
var MAX = "max";
var MIN = "min";
var NOTE_TEXT = "noteText";
var SUMMARY_FIELD = "summary";
var TO = "to";

PlotAreaFactory.current.register(CategoricalPlotArea, [
    BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA,
    CANDLESTICK, OHLC, BULLET, VERTICAL_BULLET, BOX_PLOT, VERTICAL_BOX_PLOT,
    RANGE_COLUMN, RANGE_BAR, WATERFALL, HORIZONTAL_WATERFALL, RANGE_AREA, VERTICAL_RANGE_AREA ].concat( TRENDLINE_SERIES
));

PlotAreaFactory.current.register(XYPlotArea, [
    SCATTER, SCATTER_LINE, BUBBLE ].concat( TRENDLINE_SERIES
));

PlotAreaFactory.current.register(PiePlotArea, [ PIE ]);
PlotAreaFactory.current.register(DonutPlotArea, [ DONUT ]);
PlotAreaFactory.current.register(FunnelPlotArea, [ FUNNEL, PYRAMID ]);

PlotAreaFactory.current.register(PolarPlotArea, [
    POLAR_AREA, POLAR_LINE, POLAR_SCATTER ].concat( TRENDLINE_SERIES
));

PlotAreaFactory.current.register(RadarPlotArea, [
    RADAR_AREA, RADAR_COLUMN, RADAR_LINE ].concat( TRENDLINE_SERIES
));

PlotAreaFactory.current.register(HeatmapPlotArea, [ HEATMAP ]);

SeriesBinder.current.register(
    [ BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA ],
    [ VALUE ], [ CATEGORY, COLOR, NOTE_TEXT, ERROR_LOW_FIELD, ERROR_HIGH_FIELD, DRILLDOWN_FIELD, PATTERN_FIELD ]
);

SeriesBinder.current.register(
    [ RANGE_COLUMN, RANGE_BAR, RANGE_AREA, VERTICAL_RANGE_AREA ],
    [ FROM, TO ], [ CATEGORY, COLOR, NOTE_TEXT, DRILLDOWN_FIELD, PATTERN_FIELD ]
);

SeriesBinder.current.register(
    [ WATERFALL, HORIZONTAL_WATERFALL ],
    [ VALUE ], [ CATEGORY, COLOR, NOTE_TEXT, SUMMARY_FIELD, DRILLDOWN_FIELD, PATTERN_FIELD ]
);

SeriesBinder.current.register([ POLAR_AREA, POLAR_LINE, POLAR_SCATTER ], [ X, Y ], [ COLOR, DRILLDOWN_FIELD, PATTERN_FIELD ]);
SeriesBinder.current.register([ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ], [ VALUE ], [ CATEGORY, COLOR, DRILLDOWN_FIELD, PATTERN_FIELD ]);

SeriesBinder.current.register(
    [ FUNNEL, PYRAMID ],
    [ VALUE ], [ CATEGORY, COLOR, "visibleInLegend", "visible", DRILLDOWN_FIELD, PATTERN_FIELD ]
);

DefaultAggregates.current.register(
    [ BAR, COLUMN, LINE, VERTICAL_LINE, AREA, VERTICAL_AREA, WATERFALL, HORIZONTAL_WATERFALL ],
    { value: MAX, color: FIRST, noteText: FIRST, errorLow: MIN, errorHigh: MAX }
);

DefaultAggregates.current.register(
    [ RANGE_COLUMN, RANGE_BAR, RANGE_AREA, VERTICAL_RANGE_AREA ],
    { from: MIN, to: MAX, color: FIRST, noteText: FIRST }
);

DefaultAggregates.current.register(
    [ RADAR_AREA, RADAR_COLUMN, RADAR_LINE ],
    { value: MAX, color: FIRST }
);

SeriesBinder.current.register(
    [ SCATTER, SCATTER_LINE, BUBBLE ],
    [ X, Y ], [ COLOR, NOTE_TEXT, X_ERROR_LOW_FIELD, X_ERROR_HIGH_FIELD, Y_ERROR_LOW_FIELD, Y_ERROR_HIGH_FIELD ]
);

SeriesBinder.current.register(
    [ BUBBLE ], [ X, Y, "size" ], [ COLOR, CATEGORY, NOTE_TEXT, PATTERN_FIELD ]
);

SeriesBinder.current.register(
    [ HEATMAP ],
    [ X, Y, VALUE ], [ COLOR, NOTE_TEXT, PATTERN_FIELD ]
);

SeriesBinder.current.register(
    [ CANDLESTICK, OHLC ],
    [ "open", "high", "low", "close" ], [ CATEGORY, COLOR, "downColor", NOTE_TEXT, PATTERN_FIELD ]
);

DefaultAggregates.current.register(
    [ CANDLESTICK, OHLC ],
    { open: MAX, high: MAX, low: MIN, close: MAX,
        color: FIRST, downColor: FIRST, noteText: FIRST }
);

SeriesBinder.current.register(
    [ BOX_PLOT, VERTICAL_BOX_PLOT ],
    [ "lower", "q1", "median", "q3", "upper", "mean", "outliers" ], [ CATEGORY, COLOR, NOTE_TEXT, DRILLDOWN_FIELD, PATTERN_FIELD ]
);

DefaultAggregates.current.register(
    [ BOX_PLOT, VERTICAL_BOX_PLOT ],
    { lower: MAX, q1: MAX, median: MAX, q3: MAX, upper: MAX, mean: MAX, outliers: FIRST,
        color: FIRST, noteText: FIRST }
);

SeriesBinder.current.register(
    [ BULLET, VERTICAL_BULLET ],
    [ "current", "target" ], [ CATEGORY, COLOR, "visibleInLegend", NOTE_TEXT, DRILLDOWN_FIELD, PATTERN_FIELD ]
);

DefaultAggregates.current.register(
    [ BULLET, VERTICAL_BULLET ],
    { current: MAX, target: MAX, color: FIRST, noteText: FIRST }
);

SeriesBinder.current.register(
    [ PIE, DONUT ],
    [ VALUE ], [ CATEGORY, COLOR, "explode", "visibleInLegend", "visible", DRILLDOWN_FIELD, PATTERN_FIELD ]
);

var AXIS_NAMES = [ CATEGORY, VALUE, X, Y ];

var MOUSEDOWN = "mousedown";
var MOUSEMOVE = "mousemove";
var CONTEXTMENU = "contextmenu";
var MOUSELEAVE = "mouseleave";
var KEYDOWN = "keydown";
var FOCUS = "focus";
var BLUR = "blur";
var MOUSEMOVE_DELAY = 20;
var NO_DATA_OVERLAY_TOP_CLASS = "k-chart-overlay-top";

var Chart = (function (Class) {
    function Chart(element, userOptions, themeOptions, context) {
        var this$1$1 = this;
        if ( context === void 0 ) context = {};

        Class.call(this);

        this.observers = [];
        this.addObserver(context.observer);
        this.chartService = new ChartService(this, context);
        this.chartService.theme = themeOptions;

        this._initElement(element);

        var options = deepExtend({}, this.options, userOptions);
        this._originalOptions = deepExtend({}, options);
        this._theme = themeOptions;
        this._initTheme(options, themeOptions);
        this._focusState = {};

        this._initHandlers();
        this._initSurface();

        this.bindCategories();
        FontLoader.preloadFonts(userOptions, function () {
            this$1$1.fontLoaded = true;
            if (!this$1$1._destroyed) {
                this$1$1.trigger('init');
                this$1$1._redraw();
                this$1$1._attachEvents();
                this$1$1._restoreOverlayElement();
            }
        });
    }

    if ( Class ) Chart.__proto__ = Class;
    Chart.prototype = Object.create( Class && Class.prototype );
    Chart.prototype.constructor = Chart;

    Chart.prototype._initElement = function _initElement (element) {
        var this$1$1 = this;

        this._setElementClass(element);
        element.style.position = "relative";
        element.tabIndex = element.getAttribute("tabindex") ? element.getAttribute("tabindex") : 0;
        // To support user agents and assistive technologies based on the ARIA 1.0 specification, authors may wish to include the document role as a fallback value, in the form role="graphics-document document".
        element.setAttribute("role", "graphics-document document");

        for (var i = element.childNodes.length - 1; i >= 0; i--) {
            var child = element.childNodes[i];

            if (!hasClasses(child, "k-chart-overlay")) {
                element.removeChild(child);
            } else {
                // this is necessary if the overlay is rendered server-side, e.g. in blazor
                // but drawing the surface clears the contents of the element
                // and thus the no data overlay is lost
                this$1$1.overlayElement = child;
            }
        }

        this.element = element;
    };

    Chart.prototype._setElementClass = function _setElementClass (element) {
        addClass(element, "k-chart");
    };

    Chart.prototype._restoreOverlayElement = function _restoreOverlayElement () {
        if (!this.overlayElement) {
            return;
        }

        if (this._hasSeriesData()) {
            this.overlayElement.style.display = "none";
        } else {
            if (!this.options.title || (this.options.title && this.options.title.position !== BOTTOM$1)) {
                addClass(this.overlayElement, NO_DATA_OVERLAY_TOP_CLASS);
            } else {
                removeClass(this.overlayElement, NO_DATA_OVERLAY_TOP_CLASS);
            }

            this.overlayElement.style.display = "";
        }

        if (this.overlayElement.parentElement !== this.element) {
            this.element.appendChild(this.overlayElement);
        }
    };

    Chart.prototype._hasSeriesData = function _hasSeriesData () {
        var series = this.options.series || [];
        var hasData = series.length > 0 && series.some(function (x) { return x.data && x.data.length > 0; });
        return hasData;
    };

    Chart.prototype._initTheme = function _initTheme (options, themeOptions) {
        var seriesCopies = [];
        var series = options.series || [];

        for (var i = 0; i < series.length; i++) {
            seriesCopies.push(Object.assign({}, series[i]));
        }
        options.series = seriesCopies;

        resolveAxisAliases(options);
        this.applyDefaults(options, themeOptions);

        // Clean up default if not overriden by data attributes
        if (options.seriesColors === null) {
            delete options.seriesColors;
        }

        if (isString$1(options.title)) {
            options.title = { text: options.title };
        }

        this.options = deepExtend({}, themeOptions, options);
        this.applySeriesColors();
    };

    Chart.prototype.getSize = function getSize () {
        var chartArea = this.options.chartArea || {};
        var width = chartArea.width ? parseInt(chartArea.width, 10) : Math.floor(this.element.offsetWidth);
        var height = chartArea.height ? parseInt(chartArea.height, 10) : Math.floor(this.element.offsetHeight);

        return {
            width: width,
            height: height
        };
    };

    Chart.prototype.resize = function resize (force) {
        var size = this.getSize();
        var currentSize = this._size;
        var hasSize = size.width > 0 || size.height > 0;

        if (force || hasSize && (!currentSize || size.width !== currentSize.width || size.height !== currentSize.height)) {
            this._size = size;
            this._resize(size, force);
            this.trigger("resize", size);
        } else if (hasSize && this._selections && find(this._selections, function (s) { return !s.visible; })) {
            this._destroySelections();
            this._setupSelection();
        }
    };

    Chart.prototype._resize = function _resize () {
        this._noTransitionsRedraw();
    };

    Chart.prototype.redraw = function redraw (paneName) {
        this.applyDefaults(this.options);
        this.applySeriesColors();

        if (paneName) {
            var plotArea = this._model._plotArea;
            var pane = plotArea.findPane(paneName);
            plotArea.redraw(pane);
        } else {
            this._redraw();
        }
    };

    Chart.prototype.getAxis = function getAxis (name) {
        return findAxisByName(name, this._plotArea.axes);
    };

    Chart.prototype.findAxisByName = function findAxisByName (name) {
        return this.getAxis(name);
    };

    Chart.prototype.findPaneByName = function findPaneByName (name) {
        var panes = this._plotArea.panes;

        for (var idx = 0; idx < panes.length; idx++) {
            if (panes[idx].options.name === name) {
                return new ChartPane(panes[idx]);
            }
        }
    };

    Chart.prototype.findPaneByIndex = function findPaneByIndex (idx) {
        var panes = this._plotArea.panes;
        if (panes[idx]) {
            return new ChartPane(panes[idx]);
        }
    };

    Chart.prototype.plotArea = function plotArea () {
        return new ChartPlotArea(this._plotArea);
    };

    Chart.prototype.toggleHighlight = function toggleHighlight (show, filter) {
        var plotArea = this._plotArea;
        var firstSeries = (plotArea.srcSeries || plotArea.series || [])[0];
        var points;

        if (isFunction(filter)) {
            points = plotArea.filterPoints(filter);
        } else {
            var seriesName, categoryName;
            if (isObject(filter)) {
                seriesName = filter.series;
                categoryName = filter.category;
            } else {
                seriesName = categoryName = filter;
            }

            if (firstSeries.type === DONUT) {
                points = pointByCategoryName(plotArea.pointsBySeriesName(seriesName), categoryName);
            } else if (inArray(firstSeries.type, [ PIE, FUNNEL, PYRAMID ])) {
                points = pointByCategoryName((plotArea.charts[0] || {}).points, categoryName);
            } else {
                points = plotArea.pointsBySeriesName(seriesName);
            }
        }

        if (points) {
            this.togglePointsHighlight(show, points);
        }
    };

    Chart.prototype.togglePointsHighlight = function togglePointsHighlight (show, points) {
        var highlight = this._highlight;
        for (var idx = 0; idx < points.length; idx++) {
            highlight.togglePointHighlight(points[idx], show);
        }
    };

    Chart.prototype.showTooltip = function showTooltip (filter) {
        var shared = this._sharedTooltip();
        var ref = this;
        var tooltip = ref._tooltip;
        var plotArea = ref._plotArea;
        var point, categoryIndex;

        if (isFunction(filter)) {
            point = plotArea.findPoint(filter);
            if (point && shared) {
                categoryIndex = point.categoryIx;
            }
        } else if (shared && defined(filter)) {
            categoryIndex = plotArea.categoryAxis.categoryIndex(filter);
        }

        if (shared) {
            if (categoryIndex >= 0) {
                var points = this._plotArea.pointsByCategoryIndex(categoryIndex);
                tooltip.showAt(points);
            }
        } else if (point) {
            tooltip.show(point);
        }
    };

    Chart.prototype.hideTooltip = function hideTooltip () {
        this._tooltip.hide();
    };

    Chart.prototype._initSurface = function _initSurface () {
        var surface = this.surface;
        var wrap = this._surfaceWrap();

        var chartArea = this.options.chartArea || {};
        if (chartArea.width) {
            elementSize(wrap, { width: chartArea.width });
        }
        if (chartArea.height) {
            elementSize(wrap, { height: chartArea.height });
        }

        if (!surface || surface.options.type !== this.options.renderAs) {
            this._destroySurface();

            this.surface = Surface$1.create(wrap, {
                type: this.options.renderAs
            });

            this.surface.bind("mouseenter", this._surfaceMouseenterHandler);
            this.surface.bind("mouseleave", this._surfaceMouseleaveHandler);

        } else {
            this.surface.clear();
            this.surface.resize();
        }

        // Override the surface _kendoExportVisual in order to accept export options with size.
        this.element._kendoExportVisual = this._kendoExportVisual.bind(this);
    };

    Chart.prototype._surfaceWrap = function _surfaceWrap () {
        return this.element;
    };

    Chart.prototype._redraw = function _redraw () {
        var model = this._getModel();
        this._size = {
            width: model.options.width,
            height: model.options.height
        };

        this._destroyView();

        this._setElementAccessibilityAttributes();

        this._model = model;
        this._plotArea = model._plotArea;
        this._legend = model._legend;

        model.renderVisual();

        if (this.options.transitions !== false) {
            model.traverse(function(element) {
                if (element.animation) {
                    element.animation.setup();
                }
            });
        }

        this._initSurface();
        this.surface.draw(model.visual);

        if (this.options.transitions !== false) {
            model.traverse(function(element) {
                if (element.animation) {
                    element.animation.play();
                }
            });
        }

        this._tooltip = this._createTooltip();
        this._highlight = new Highlight();
        this._setupSelection();
        this._createPannable();
        this._createZoomSelection();
        this._createMousewheelZoom();
        this._setComputedStyles();

        this.trigger(RENDER);
        triggerPaneRender(this._plotArea.panes);

        if (!this._navState) {
            this._cancelDomEvents();
        }

        this._redrawFocusHighlight();
    };

    Chart.prototype._setComputedStyles = function _setComputedStyles () {
        var titleHeight = this.titleHeight();
        this.element.style.setProperty('--kendo-chart-computed-title-height', (titleHeight + "px"));
    };

    Chart.prototype._redrawFocusHighlight = function _redrawFocusHighlight () {
        if (this._destroyed) {
            return;
        }

        var ref = this;
        var ref_focusState = ref._focusState;
        var legendInFocus = ref_focusState.legendInFocus;
        var preserveHighlight = ref_focusState.preserveHighlight;

        if (legendInFocus && preserveHighlight) {
            this._focusElement(this._getFocusedLegendItem(), false);
            this._focusState.preserveHighlight = false;
        }
    };

    Chart.prototype._setElementAccessibilityAttributes = function _setElementAccessibilityAttributes () {
        var titleOptions = this.options.title;
        var title = isString$1(titleOptions) ? titleOptions : (titleOptions.description || titleOptions.text);

        if (title) {
            this.element.setAttribute("aria-roledescription", title);
        }
    };

    Chart.prototype._kendoExportVisual = function _kendoExportVisual (size) {
        if (size && size.width && size.height) {
            var chartArea = this._originalOptions.chartArea || {};
            var exportOptions = {
                width: chartArea.width || size.width,
                height: chartArea.height || size.height
            };

            return this.exportVisual(exportOptions);
        }

        return this.exportVisual();
    };

    Chart.prototype.exportVisual = function exportVisual (exportOptions) {
        var visual;
        if (exportOptions && (exportOptions.width || exportOptions.height || exportOptions.options)) {
            var currentOptions = this.options;
            var options = deepExtend({}, exportOptions.options, {
                chartArea: {
                    width: exportOptions.width,
                    height: exportOptions.height
                }
            });

            clearMissingValues(this._originalOptions, options);
            this.options = deepExtend({}, this._originalOptions, options);
            this._initTheme(this.options, this._theme);
            this.bindCategories();

            var model = this._getModel();

            model.renderVisual();
            triggerPaneRender(model._plotArea.panes);

            visual = model.visual;

            this.options = currentOptions;
        } else {
            visual = this.surface.exportVisual();
        }

        return visual;
    };

    Chart.prototype._sharedTooltip = function _sharedTooltip () {
        return this._plotArea instanceof CategoricalPlotArea && this.options.tooltip && this.options.tooltip.shared;
    };

    Chart.prototype._createPannable = function _createPannable () {
        var options = this.options;
        if (options.pannable !== false) {
            this._pannable = new Pannable(this._plotArea, options.pannable);
        }
    };

    Chart.prototype._createZoomSelection = function _createZoomSelection () {
        var zoomable = this.options.zoomable;
        var selection = (zoomable || {}).selection;
        if (zoomable !== false && selection !== false) {
            this._zoomSelection = new ZoomSelection(this, selection);
        }
    };

    Chart.prototype._createMousewheelZoom = function _createMousewheelZoom () {
        var zoomable = this.options.zoomable;
        var mousewheel = (zoomable || {}).mousewheel;
        if (zoomable !== false && mousewheel !== false) {
            this._mousewheelZoom = new MousewheelZoom(this, mousewheel);
        }
    };

    Chart.prototype._toggleDragZoomEvents = function _toggleDragZoomEvents () {
        var pannable = this.options.pannable;
        var zoomable = this.options.zoomable;
        var selection = (zoomable || {}).selection;
        var mousewheel = (zoomable || {}).mousewheel;
        var allowDrag = !pannable && (zoomable === false || selection === false) && !this.requiresHandlers([ DRAG_START, DRAG, DRAG_END ]);
        var allowZoom = (zoomable === false || mousewheel === false) && !this.requiresHandlers([ ZOOM_START, ZOOM, ZOOM_END ]);
        var element = this.element;

        if (this._dragZoomEnabled && allowDrag && allowZoom) {
            element.style.touchAction = this._touchAction || '';
            this._dragZoomEnabled = false;
        } else if (!this._dragZoomEnabled && !(allowDrag && allowZoom)) {
            element.style.touchAction = "none";

            this._dragZoomEnabled = true;
        }

        this._toggleDomEvents(!allowDrag, !allowZoom);
    };

    Chart.prototype._toggleDomEvents = function _toggleDomEvents (drag, zoom) {
        var domEvents = this.domEvents;
        if (!domEvents) {
            return;
        }

        if (domEvents.toggleDrag) {
            domEvents.toggleDrag(drag);
        }

        if (domEvents.toggleZoom) {
            domEvents.toggleZoom(zoom);
        }
    };

    Chart.prototype._createTooltip = function _createTooltip () {
        var ref = this;
        var tooltipOptions = ref.options.tooltip;
        var tooltip;

        if (this._sharedTooltip()) {
            tooltip = this._createSharedTooltip(tooltipOptions);
        } else {
            tooltip = new Tooltip$1(this.chartService, tooltipOptions);
        }

        return tooltip;
    };

    Chart.prototype._createSharedTooltip = function _createSharedTooltip (options) {
        return new SharedTooltip$1(this._plotArea, options);
    };

    Chart.prototype.applyDefaults = function applyDefaults (options, themeOptions) {
        applyAxisDefaults(options, themeOptions);
        applySeriesDefaults(options, themeOptions);
    };

    Chart.prototype.applySeriesColors = function applySeriesColors () {
        var options = this.options;
        var series = options.series;
        var colors = options.seriesColors || [];

        for (var i = 0; i < series.length; i++) {
            var currentSeries = series[i];
            var seriesColor = colors[i % colors.length];
            var defaults = currentSeries._defaults;

            currentSeries.color = currentSeries.color || seriesColor;
            if (defaults) {
                defaults.color = defaults.color || seriesColor;
            }
        }
    };

    Chart.prototype._getModel = function _getModel () {
        var options = this.options;
        var plotArea = this._createPlotArea();
        var model = new RootElement(this._modelOptions());
        model.chart = this;
        model._plotArea = plotArea;

        var title = Title$1.buildTitle(options.title);
        var subtitle = Title$1.buildTitle(options.subtitle, {
            align: options.title.align,
            position: options.title.position
        });
        model.append.apply(model, Title$1.orderTitles([title, subtitle]));

        if (options.legend && options.legend.visible) {
            var legend = new Legend$1(plotArea.options.legend, this.chartService);
            model.append(legend);
            model._legend = legend;
        }
        model.append(plotArea);
        model.reflow();

        this._setTitleBox(title, subtitle);

        return model;
    };

    Chart.prototype._setTitleBox = function _setTitleBox (title, subtitle) {
        if (!title && !subtitle) {
            return;
        }

        this._titleBox = (title || subtitle).box.clone();

        var titlePosition = title ? title.options.position : '';
        var subtitlePosition = subtitle ? subtitle.options.position : '';
        var samePosition = titlePosition === subtitlePosition;
        var subtitleAtTop = subtitlePosition !== BOTTOM$1;

        if (samePosition && subtitle) {
            this._titleBox.wrap(subtitle.box);
        } else if (title && subtitle && subtitleAtTop) {
            this._titleBox = subtitle.box.clone();
        }
    };

    Chart.prototype._modelOptions = function _modelOptions () {
        var options = this.options;
        var size = this.getSize();

        return deepExtend({
            transitions: options.transitions,
            width: size.width || DEFAULT_WIDTH$1,
            height: size.height || DEFAULT_HEIGHT$1
        }, options.chartArea);
    };

    Chart.prototype._createPlotArea = function _createPlotArea (skipSeries) {
        var options = this.options;

        var plotArea = PlotAreaFactory.current.create(skipSeries ? [] : options.series, options, this.chartService);

        return plotArea;
    };

    Chart.prototype._setupSelection = function _setupSelection () {
        var this$1$1 = this;

        var ref = this;
        var axes = ref._plotArea.axes;
        var selections = this._selections = [];

        for (var i = 0; i < axes.length; i++) {
            var axis = axes[i];
            var options = axis.options;
            if (axis instanceof CategoryAxis && options.select && !options.vertical) {
                var range = axis.range();

                var selection = new Selection(this$1$1, axis,
                    deepExtend({ min: range.min, max: range.max }, options.select)
                );

                selections.push(selection);
            }
        }
    };

    Chart.prototype._selectStart = function _selectStart (e) {
        return this.trigger(SELECT_START, e);
    };

    Chart.prototype._select = function _select (e) {
        return this.trigger(SELECT, e);
    };

    Chart.prototype._selectEnd = function _selectEnd (e) {
        return this.trigger(SELECT_END, e);
    };

    Chart.prototype._initHandlers = function _initHandlers () {
        this._clickHandler = this._click.bind(this);
        this._keydownHandler = this._keydown.bind(this);
        this._focusHandler = this._focus.bind(this);
        this._blurHandler = this._blur.bind(this);
        this._mousedownHandler = this._mousedown.bind(this);
        this._mousewheelHandler = this._mousewheel.bind(this);
        this._mouseleaveHandler = this._mouseleave.bind(this);
        this._surfaceMouseenterHandler = this._mouseover.bind(this);
        this._surfaceMouseleaveHandler = this._mouseout.bind(this);

        this._mousemove = throttle(
            this._mousemove.bind(this),
            MOUSEMOVE_DELAY
        );
    };

    Chart.prototype.addObserver = function addObserver (observer) {
        if (observer) {
            this.observers.push(observer);
        }
    };

    Chart.prototype.removeObserver = function removeObserver (observer) {
        var index = this.observers.indexOf(observer);
        if (index >= 0) {
            this.observers.splice(index, 1);
        }
    };

    Chart.prototype.requiresHandlers = function requiresHandlers (eventNames) {
        var observers = this.observers;
        for (var idx = 0; idx < observers.length; idx++) {
            if (observers[idx].requiresHandlers(eventNames)) {
                return true;
            }
        }
    };

    Chart.prototype.trigger = function trigger (name, args) {
        if ( args === void 0 ) args = {};

        args.sender = this;

        if (name === SHOW_TOOLTIP$1) {
            args.anchor.point = this._toDocumentCoordinates(args.anchor.point);
        } else if (name === SERIES_OVER) {
            this._updateDrilldownPoint(args.point);
        } else if (name === SERIES_LEAVE) {
            this._resetDrilldownPoint();
        } else if (name === SERIES_CLICK) {
            this._focusPoint(args.point);
            this._startDrilldown(args.point);
        } else if (name === LEGEND_ITEM_CLICK) {
            this._focusLegendItem(args);
        }

        var observers = this.observers;
        var isDefaultPrevented = false;
        for (var idx = 0; idx < observers.length; idx++) {
            if (observers[idx].trigger(name, args)) {
                isDefaultPrevented = true;
            }
        }

        return isDefaultPrevented;
    };

    Chart.prototype.titleHeight = function titleHeight () {
        if (!this._titleBox) {
            return 0;
        }

        return this._titleBox.height();
    };

    Chart.prototype._attachEvents = function _attachEvents () {
        var obj, obj$1;

        var element = this.element;

        this._touchAction = element.style.touchAction;

        bindEvents(element, ( obj = {}, obj[ CONTEXTMENU ] = this._clickHandler, obj[ MOUSEWHEEL$1 ] = this._mousewheelHandler, obj[ MOUSELEAVE ] = this._mouseleaveHandler, obj[ KEYDOWN ] = this._keydownHandler, obj[ MOUSEDOWN ] = this._mousedownHandler, obj[ FOCUS ] = this._focusHandler, obj[ BLUR] = this._blurHandler, obj ));

        if (this._shouldAttachMouseMove()) {
            bindEvents(element, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mousemove, obj$1 ));
        }

        this.domEvents = DomEventsBuilder.create(this.element, {
            start: this._start.bind(this),
            move: this._move.bind(this),
            end: this._end.bind(this),
            tap: this._tap.bind(this),
            gesturestart: this._gesturestart.bind(this),
            gesturechange: this._gesturechange.bind(this),
            gestureend: this._gestureend.bind(this)
        });

        this._toggleDragZoomEvents();
    };

    Chart.prototype._mouseleave = function _mouseleave (e) {
        if (this._hoveredPoint) {
            this._hoveredPoint.out(this, e);
            this._hoveredPoint = null;
        }

        if (this._plotAreaHovered) {
            this._plotAreaHovered = false;
            this.trigger(PLOT_AREA_LEAVE);
        }

        if (this._hasInactiveOpacity() && this._activeChartInstance) {
            this._applySeriesOpacity(this._activeChartInstance.children, null, true);
            this._updateSeriesOpacity(null, true);
        }
    };

    Chart.prototype._cancelDomEvents = function _cancelDomEvents () {
        if (this.domEvents && this.domEvents.cancel) {
            this.domEvents.cancel();
        }
    };

    Chart.prototype._gesturestart = function _gesturestart (e) {
        if (this._mousewheelZoom && !this._stopChartHandlers(e)) {
            this._gestureDistance = e.distance;
            this._unsetActivePoint();
            this._clearFocusedElement();
            this.surface.suspendTracking();
        }
    };

    Chart.prototype._gestureend = function _gestureend (e) {
        if (this._zooming && !this._stopChartHandlers(e)) {
            if (this.surface) {
                this.surface.resumeTracking();
            }
            this._zooming = false;
            this.trigger(ZOOM_END, {});
        }
    };

    Chart.prototype._gesturechange = function _gesturechange (e) {
        var mousewheelZoom = this._mousewheelZoom;

        if (mousewheelZoom && !this._stopChartHandlers(e)) {
            e.preventDefault();
            var previousGestureDistance = this._gestureDistance;
            var scaleDelta = -e.distance / previousGestureDistance + 1;

            if (Math.abs(scaleDelta) >= 0.1) {
                scaleDelta = Math.round(scaleDelta * 10);

                this._gestureDistance = e.distance;
                var args = { delta: scaleDelta, axisRanges: axisRanges(this._plotArea.axes), originalEvent: e };
                if (this._zooming || !this.trigger(ZOOM_START, args)) {
                    var coords = this._eventCoordinates(e);

                    if (!this._zooming) {
                        this._zooming = true;
                    }

                    var ranges = args.axisRanges = mousewheelZoom.updateRanges(scaleDelta, coords);
                    if (ranges && !this.trigger(ZOOM, args)) {
                        mousewheelZoom.zoom();
                    }
                }
            }
        }
    };

    Chart.prototype._mouseout = function _mouseout (e) {
        if (e.element) {
            var element = this._drawingChartElement(e.element, e);

            if (element && element.leave) {
                element.leave(this, e.originalEvent);
            }
        }
    };

    Chart.prototype._start = function _start (e) {
        var coords = this._eventCoordinates(e);

        if (this._stopChartHandlers(e) || !this._plotArea.backgroundContainsPoint(coords)) {
            return;
        }


        if (this.requiresHandlers([ DRAG_START, DRAG, DRAG_END ])) {
            this._startNavigation(e, coords, DRAG_START);
        }

        if (this._pannable && this._pannable.start(e)) {
            this.surface.suspendTracking();
            this._unsetActivePoint();
            this._clearFocusedElement();
            this._suppressHover = true;
            this.chartService.panning = true;
        }

        if (this._zoomSelection) {
            if (this._zoomSelection.start(e)) {
                this.trigger(ZOOM_START, { axisRanges: axisRanges(this._plotArea.axes), originalEvent: e });
            }
        }
    };

    Chart.prototype._move = function _move (e) {
        var ref = this;
        var state = ref._navState;
        var pannable = ref._pannable;

        if (this._stopChartHandlers(e)) {
            return;
        }

        if (pannable) {
            var ranges = pannable.move(e);

            if (ranges && !this.trigger(DRAG, { axisRanges: ranges, originalEvent: e })) {
                pannable.pan();
            }
        } else if (state) {
            var ranges$1 = {};
            var axes = state.axes;

            for (var i = 0; i < axes.length; i++) {
                var currentAxis = axes[i];
                var axisName = currentAxis.options.name;
                if (axisName) {
                    var axis = currentAxis.options.vertical ? e.y : e.x;
                    var delta = axis.startLocation - axis.location;

                    if (delta !== 0) {
                        ranges$1[currentAxis.options.name] = currentAxis.translateRange(delta);
                    }
                }
            }

            state.axisRanges = ranges$1;
            this.trigger(DRAG, {
                axisRanges: ranges$1,
                originalEvent: e
            });
        }

        if (this._zoomSelection) {
            this._zoomSelection.move(e);
        }
    };

    Chart.prototype._end = function _end (e) {
        if (this._stopChartHandlers(e)) {
            return;
        }

        var pannable = this._pannable;
        if (pannable && pannable.end(e)) {
            this.surface.resumeTracking();
            this.trigger(DRAG_END, {
                axisRanges: axisRanges(this._plotArea.axes),
                originalEvent: e
            });
            this._suppressHover = false;
            this.chartService.panning = false;
        } else {
            this._endNavigation(e, DRAG_END);
        }

        if (this._zoomSelection) {
            var ranges = this._zoomSelection.end(e);
            if (ranges && !this.trigger(ZOOM, { axisRanges: ranges, originalEvent: e })) {
                this._zoomSelection.zoom();
                this.trigger(ZOOM_END, { axisRanges: ranges, originalEvent: e });
            }
        }
    };

    Chart.prototype._stopChartHandlers = function _stopChartHandlers (e) {
        var selections = this._selections || [];
        if (!selections.length) {
            return false;
        }

        var coords = this._eventCoordinates(e);
        var pane = this._plotArea.paneByPoint(coords);
        if (pane) {
            for (var idx = 0; idx < selections.length; idx++) {
                if (selections[idx].onPane(pane)) {
                    return true;
                }
            }
        }
    };

    Chart.prototype._mousewheelZoomRate = function _mousewheelZoomRate () {
        var zoomable = this.options.zoomable;
        var mousewheel = (zoomable || {}).mousewheel || {};
        return valueOrDefault(mousewheel.rate, MOUSEWHEEL_ZOOM_RATE);
    };

    Chart.prototype._mousewheel = function _mousewheel (e) {
        var this$1$1 = this;

        var delta = mousewheelDelta(e);
        var mousewheelZoom = this._mousewheelZoom;
        var coords = this._eventCoordinates(e);

        if (this._stopChartHandlers(e) || !this._plotArea.backgroundContainsPoint(coords)) {
            return;
        }

        if (mousewheelZoom) {
            var args = { delta: delta, axisRanges: axisRanges(this._plotArea.axes), originalEvent: e };
            if (this._zooming || !this.trigger(ZOOM_START, args)) {
                e.preventDefault();

                if (!this._zooming) {
                    this._unsetActivePoint();
                    this._clearFocusedElement();
                    this.surface.suspendTracking();
                    this._zooming = true;
                }

                if (this._mwTimeout) {
                    clearTimeout(this._mwTimeout);
                }

                args.axisRanges = mousewheelZoom.updateRanges(delta, coords);
                if (args.axisRanges && !this.trigger(ZOOM, args)) {
                    mousewheelZoom.zoom();
                }

                this._mwTimeout = setTimeout(function () {
                    this$1$1.trigger(ZOOM_END, args);
                    this$1$1._zooming = false;
                    if (this$1$1.surface) {
                        this$1$1.surface.resumeTracking();
                    }
                }, MOUSEWHEEL_DELAY);
            }
        } else {
            var state = this._navState;
            if (!state) {
                var prevented = this._startNavigation(e, coords, ZOOM_START);
                if (!prevented) {
                    state = this._navState;
                }
            }

            if (state) {
                var totalDelta = state.totalDelta || delta;
                state.totalDelta = totalDelta + delta;

                var axes = this._navState.axes;
                var ranges = {};

                for (var i = 0; i < axes.length; i++) {
                    var currentAxis = axes[i];
                    var axisName = currentAxis.options.name;
                    if (axisName) {
                        ranges[axisName] = currentAxis.scaleRange(-totalDelta * this$1$1._mousewheelZoomRate(), coords);
                    }
                }

                this.trigger(ZOOM, {
                    delta: delta,
                    axisRanges: ranges,
                    originalEvent: e
                });

                if (this._mwTimeout) {
                    clearTimeout(this._mwTimeout);
                }

                this._mwTimeout = setTimeout(function () {
                    this$1$1._endNavigation(e, ZOOM_END);
                }, MOUSEWHEEL_DELAY);
            }
        }
    };

    Chart.prototype._startNavigation = function _startNavigation (e, coords, chartEvent) {
        var plotArea = this._model._plotArea;
        var pane = plotArea.findPointPane(coords);
        var axes = plotArea.axes.slice(0);

        if (!pane) {
            return;
        }

        var ranges = axisRanges(axes);

        var prevented = this.trigger(chartEvent, {
            axisRanges: ranges,
            originalEvent: e
        });

        if (prevented) {
            this._cancelDomEvents();
        } else {
            this._suppressHover = true;
            this._unsetActivePoint();
            this._clearFocusedElement();
            this._navState = {
                axisRanges: ranges,
                pane: pane,
                axes: axes
            };
        }
    };

    Chart.prototype._endNavigation = function _endNavigation (e, chartEvent) {
        if (this._navState) {
            this.trigger(chartEvent, {
                axisRanges: this._navState.axisRanges,
                originalEvent: e
            });
            this._suppressHover = false;
            this._navState = null;
        }
    };

    Chart.prototype._getChartElement = function _getChartElement (e, match) {
        var element = this.surface.eventTarget(e);
        if (element) {
            return this._drawingChartElement(element, e, match);
        }
    };

    Chart.prototype._drawingChartElement = function _drawingChartElement (element, e, match) {
        var current = element;
        var chartElement;
        while (current && !chartElement) {
            chartElement = current.chartElement;
            current = current.parent;
        }

        if (chartElement) {
            if (chartElement.aliasFor) {
                chartElement = chartElement.aliasFor(e, this._eventCoordinates(e));
            }

            if (match) {
                chartElement = chartElement.closest(match);
                if (chartElement && chartElement.aliasFor) {
                    chartElement = chartElement.aliasFor();
                }
            }

            return chartElement;
        }
    };

    Chart.prototype._eventCoordinates = function _eventCoordinates (e) {
        var coordinates = eventCoordinates(e);
        return this._toModelCoordinates(coordinates.x, coordinates.y);
    };

    Chart.prototype._elementPadding = function _elementPadding () {
        if (!this._padding) {
            var ref = elementStyles$1(this.element, [ "paddingLeft", "paddingTop" ]);
            var paddingLeft = ref.paddingLeft;
            var paddingTop = ref.paddingTop;
            this._padding = {
                top: paddingTop,
                left: paddingLeft
            };
        }

        return this._padding;
    };

    Chart.prototype._toDocumentCoordinates = function _toDocumentCoordinates (point) {
        var padding = this._elementPadding();
        var offset = elementOffset(this.element);

        return {
            left: round$1(point.x + padding.left + offset.left),
            top: round$1(point.y + padding.top + offset.top)
        };
    };

    // TODO: Breaking change due to peer version change
    // Reuse by exposing _surfacePoint on Surface
    Chart.prototype._toModelCoordinates = function _toModelCoordinates (clientX, clientY) {
        var element = this.element;
        var offset = elementOffset(element);
        var padding = this._elementPadding();
        var inverseTransform = elementScale(element).invert();
        var point = new Point$6(
            clientX - offset.left - padding.left,
            clientY - offset.top - padding.top
        ).transform(inverseTransform);

        return new Point$5(point.x, point.y);
    };

    Chart.prototype._tap = function _tap (e) {
        var this$1$1 = this;

        var drawingElement = this.surface.eventTarget(e);
        var element = this._drawingChartElement(drawingElement, e);
        var sharedTooltip = this._sharedTooltip();

        if (!this._startHover(drawingElement, e) && !sharedTooltip) {
            this._unsetActivePoint();
        }

        if (sharedTooltip) {
            this._trackSharedTooltip(this._eventCoordinates(e), e, true);
        }

        this._propagateClick(element, e);

        //part of fix for hover issue on windows touch
        this.handlingTap = true;
        setTimeout(function () {
            this$1$1.handlingTap = false;
        }, 0);
    };

    Chart.prototype._click = function _click (e) {
        var element = this._getChartElement(e);
        this._propagateClick(element, e);
    };

    Chart.prototype._propagateClick = function _propagateClick (element, e) {
        var this$1$1 = this;

        var current = element;
        while (current) {
            if (current.click) {
                current.click(this$1$1, e);
            }

            current = current.parent;
        }
    };

    Chart.prototype._isLegendBeforeChart = function _isLegendBeforeChart () {
        var ref = this;
        var legendPosition = ref.options.legend.position;
        var legend = ref._legend;

        return legend && legend.hasItems() && (legendPosition === TOP || legendPosition === LEFT);
    };

    Chart.prototype._focus = function _focus () {
        if (!this._preventInitialPointFocus) {
            if (this._isLegendBeforeChart()) {
                this._focusFirstLegendItem();
            } else {
                this._focusFirstPoint();
            }
        }

        this._preventInitialPointFocus = false;
    };

    Chart.prototype._keydown = function _keydown (e) {
        var ref = this;
        var ref_focusState = ref._focusState;
        var legendInFocus = ref_focusState.legendInFocus;
        var focusedElement = ref_focusState.focusedElement;
        var legend = ref._legend;

        if (e.key === TAB) {
            this._clearFocusedElement();
            var isLegendBeforeChart = this._isLegendBeforeChart();

            if (legendInFocus && isLegendBeforeChart !== e.shiftKey) {
                this._navigatePoints(e);
            } else if (!legendInFocus && isLegendBeforeChart === e.shiftKey && legend.hasItems()) {
                this._navigateLegend(e);
            }
        } else if (e.key === ESCAPE) {
            if (focusedElement) {
                e.stopPropagation();
            }

            if (this._tooltip && this._tooltip.visible) {
                this._hideTooltip();
            } else {
                this._blur();
            }
        } else if (e.key === ENTER) {
            if (focusedElement) {
                this._focusState.preserveHighlight = true;
                this._propagateClick(focusedElement, e);
                this._focusElement(focusedElement);
            }
        } else if (!legendInFocus) {
            this._navigatePoints(e);
        } else {
            this._navigateLegend(e);
        }
    };

    Chart.prototype._navigatePoints = function _navigatePoints (e) {
        var this$1$1 = this;

        var ref = this;
        var focusState = ref._focusState;
        var plotArea = ref._plotArea;

        focusState.legendInFocus = false;

        if (!focusState.focusedElement) {
            this._focusFirstPoint();
            e.preventDefault();
            return;
        }

        var moveFocus = function (point) {
            focusState.focusedPoint = point;

            this$1$1._focusElement(focusState.focusedPoint);
            this$1$1._displayTooltip(point);
            e.preventDefault();
        };

        switch (e.key) {
            case ARROW_RIGHT:
                moveFocus(plotArea.getPointToTheRight(focusState.focusedPoint));
                break;
            case ARROW_LEFT:
                moveFocus(plotArea.getPointToTheLeft(focusState.focusedPoint));
                break;
            case ARROW_DOWN:
                moveFocus(plotArea.getPointBelow(focusState.focusedPoint));
                break;
            case ARROW_UP:
                moveFocus(plotArea.getPointAbove(focusState.focusedPoint));
                break;
            default:
                break;
        }
    };

    Chart.prototype._navigateLegend = function _navigateLegend (e) {
        var this$1$1 = this;

        var ref = this;
        var focusState = ref._focusState;
        var legend = ref._legend;
        var rtl = ref.chartService.rtl;

        focusState.legendInFocus = true;

        if (!focusState.focusedElement) {
            this._focusFirstLegendItem();
            e.preventDefault();
            return;
        }

        var itemsLength = legend.getItems().length;
        var moveFocus = function (cycleFunc) {
            focusState.focusedLegendItemIndex = cycleFunc(
                focusState.focusedLegendItemIndex,
                itemsLength
            );
            this$1$1._focusElement(this$1$1._getFocusedLegendItem());
            e.preventDefault();
        };

        switch (e.key) {
            case ARROW_UP:
            case ARROW_LEFT:
                moveFocus(rtl ? cycleUp : cycleDown);
                break;
            case ARROW_DOWN:
            case ARROW_RIGHT:
                moveFocus(rtl ? cycleDown : cycleUp);
                break;
            default:
                break;
        }
    };

    Chart.prototype._focusFirstPoint = function _focusFirstPoint () {
        var point = this._focusState.focusedPoint = this._plotArea.getFirstPoint();

        if (point) {
            this._focusElement(point);
            this._displayTooltip(point);
        }
    };

    Chart.prototype._hasFocus = function _hasFocus () {
        return this.element.ownerDocument.activeElement === this.element;
    };

    Chart.prototype._mousedown = function _mousedown () {
        if (!this._hasFocus()) {
            this._preventInitialPointFocus = true;
        }
    };

    Chart.prototype._focusChart = function _focusChart () {
        if (!this._hasFocus()) {
            this._preventInitialPointFocus = true;
            this.element.focus();
        }
    };

    Chart.prototype._focusPoint = function _focusPoint (point) {
        this._focusState.focusedPoint = point;

        this._focusChart();

        this._focusElement(point, true);
    };

    Chart.prototype._focusFirstLegendItem = function _focusFirstLegendItem () {
        var ref = this;
        var focusState = ref._focusState;

        focusState.focusedLegendItemIndex = 0;
        this._focusElement(this._getFocusedLegendItem());
        focusState.legendInFocus = true;

        this._hideTooltip();
    };

    Chart.prototype._focusLegendItem = function _focusLegendItem (args) {
        var ref = this;
        var focusState = ref._focusState;

        focusState.focusedLegendItemIndex = this._legend
            .getItems()
            .findIndex(function (x) { return x.options.series.index === args.seriesIndex
                && x.options.pointIndex === args.pointIndex; });

        focusState.legendInFocus = true;

        this._focusChart();

        this._focusElement(this._getFocusedLegendItem(), true);
    };

    Chart.prototype._getFocusedLegendItem = function _getFocusedLegendItem () {
        var ref = this;
        var focusState = ref._focusState;
        var legend = ref._legend;

        return legend.getItems()[focusState.focusedLegendItemIndex];
    };

    Chart.prototype._focusElement = function _focusElement (element, omitHighlight) {
        var ref = this;
        var focusState = ref._focusState;

        this._clearFocusedElement();

        if (!element) {
            return;
        }

        focusState.focusedElement = element;

        this._setElementActiveDescendant(element);

        if (!omitHighlight) {
            element.focusVisual();

            if (focusState.legendInFocus) {
                var options = element.options;

                this._showSeriesInactiveOpacity(options.series.index, options.pointIndex);
            } else {
                this._showInactiveOpacity(element);
            }
        }
    };

    Chart.prototype._clearFocusedElement = function _clearFocusedElement () {
        var ref = this;
        var focusState = ref._focusState;

        if (!focusState) {
            return;
        }

        if (focusState.focusedElement && focusState.focusedElement.clearFocusFromVisual) {
            focusState.focusedElement.clearFocusFromVisual();
            this._clearElementActiveDescendant();
        }

        focusState.focusedElement = null;
    };

    Chart.prototype._setElementActiveDescendant = function _setElementActiveDescendant (element) {
        if (this.options.renderAs === "canvas") {
            this._pseudoFocusedElement = this._createPseudoFocusedElement(element);
            this.element.append(this._pseudoFocusedElement);
        }

        this.element.setAttribute(ARIA_ACTIVE_DESCENDANT, element._id);
    };

    Chart.prototype._clearElementActiveDescendant = function _clearElementActiveDescendant () {
        if (this._pseudoFocusedElement) {
            this._pseudoFocusedElement.remove();
            this._pseudoFocusedElement = null;
        }

        this.element.removeAttribute(ARIA_ACTIVE_DESCENDANT);
    };

    Chart.prototype._createPseudoFocusedElement = function _createPseudoFocusedElement (element) {
        var pseudoElement = document.createElement("div");
        var accessibilityOptions = element.options.accessibility;

        pseudoElement.id = element._id;
        pseudoElement.setAttribute("aria-label", element.getAriaLabelText());
        pseudoElement.setAttribute("role", accessibilityOptions.role);
        pseudoElement.setAttribute("aria-roledescription", accessibilityOptions.ariaRoleDescription);

        var checked = accessibilityOptions.ariaChecked;
        if (defined(checked)) {
            pseudoElement.setAttribute("aria-checked", checked);
        }

        return pseudoElement;
    };

    Chart.prototype._blur = function _blur () {
        this._focusState.legendInFocus = false;
        this._clearFocusedElement();
        this._hideInactiveOpacity();
    };

    Chart.prototype._startHover = function _startHover (element, e) {
        if (this._suppressHover) {
            return false;
        }

        var point = this._drawingChartElement(element, e, function(element) {
            return (element.hover || element.over) && !(element instanceof PlotAreaBase);
        });

        var activePoint = this._activePoint;

        this._updateHoveredPoint(point, e);

        if (point && activePoint !== point && point.hover) {
            this._activePoint = point;

            if (!this._sharedTooltip() && !point.hover(this, e)) {
                this._displayTooltip(point);

                this._showInactiveOpacity(point);
            }
        }

        return point;
    };

    Chart.prototype._displayTooltip = function _displayTooltip (point) {
        var tooltipOptions = deepExtend({}, this.options.tooltip, point.options.tooltip);
        if (tooltipOptions.visible) {
            if (this._sharedTooltip() && point.box) {
                this._trackSharedTooltip(point.box.center(), {});
            } else {
                this._tooltip.show(point);
            }
        }
    };

    Chart.prototype._hideTooltip = function _hideTooltip () {
        if (this._tooltip) {
            this._tooltip.hide();
        }
    };

    Chart.prototype._displayInactiveOpacity = function _displayInactiveOpacity (activePoint, multipleSeries, highlightPoints) {
        var chartInstance = this._activeChartInstance = this._chartInstanceFromPoint(activePoint);
        if (!chartInstance) {
            return;
        }

        if (multipleSeries) {
            this._updateSeriesOpacity(activePoint);
            this._applySeriesOpacity(chartInstance.children, null, true);
            this._applySeriesOpacity(chartInstance.children, activePoint.series);
            this._highlight.show(highlightPoints || activePoint);
        } else {
            var inactivePoints;

            if (!chartInstance.supportsPointInactiveOpacity()) {
                this._highlight.show(activePoint);
                return;
            }

            inactivePoints = this._getInactivePoints(activePoint, chartInstance);

            if (inactivePoints && inactivePoints.length) {
                this._highlight.show(inactivePoints, 1 - this._getInactiveOpacityForSeries(activePoint.series));
            }
        }
    };

    Chart.prototype._getInactivePoints = function _getInactivePoints (activePoint, chartInstance) {
        var allPoints = this._getAllPointsOfType(chartInstance, activePoint.constructor);

        return allPoints.filter(function (point) { return point !== activePoint; });
    };

    Chart.prototype._getAllPointsOfType = function _getAllPointsOfType (container, type) {
        var this$1$1 = this;

        var points = [];

        for (var i = 0; i < container.children.length; i++) {
            var element = container.children[i];

            if (element.constructor === type) {
                points.push(element);
            } else if (element.children && element.children.length) {
                points = points.concat(this$1$1._getAllPointsOfType(element, type));
            }
        }

        return points;
    };

    Chart.prototype._updateHoveredPoint = function _updateHoveredPoint (point, e) {
        var hoveredPoint = this._hoveredPoint;

        if (hoveredPoint && hoveredPoint !== point) {
            hoveredPoint.out(this, e);
            this._hoveredPoint = null;
        }

        if (point && hoveredPoint !== point && point.over) {
            this._hoveredPoint = point;
            point.over(this, e);
        }
    };

    Chart.prototype._updateDrilldownPoint = function _updateDrilldownPoint (point) {
        if (!point || !point.series) {
            return;
        }

        var ref = SeriesBinder.current.bindPoint(point.series, null, point.dataItem);
        var fields = ref.fields;
        if (fields.drilldown) {
            this._drilldownState = { cursor: this.element.style.cursor };
            this.element.style.cursor = 'pointer';
        }
    };

    Chart.prototype._resetDrilldownPoint = function _resetDrilldownPoint () {
        if (this._drilldownState) {
            this.element.style.cursor = this._drilldownState.cursor;
            this._drilldownState = null;
        }
    };

    Chart.prototype._startDrilldown = function _startDrilldown (point) {
        if (!point || !point.series) {
            return;
        }

        var series = point.series;
        var ref = SeriesBinder.current.bindPoint(series, null, point.dataItem);
        var fields = ref.fields;
        var value = fields.drilldown;
        if (value) {
            var args = { series: series, point: point, value: value, sender: this };
            this.trigger(DRILLDOWN, args);
        }
    };

    Chart.prototype._updateSeriesOpacity = function _updateSeriesOpacity (point, resetOpacity) {
        var this$1$1 = this;

        var plotArea = this._plotArea;
        var length = plotArea.series.length;

        for (var i = 0; i < length; i++) {
            var currSeries = plotArea.series[i];
            var defaultOpacity = this$1$1._getDefaultOpacityForSeries(currSeries);
            var inactiveOpacity = this$1$1._getInactiveOpacityForSeries(currSeries);

            if (!resetOpacity && currSeries !== point.series) {
                currSeries.defaultOpacity = defaultOpacity;
                currSeries.opacity = inactiveOpacity;

                if (currSeries.line) {
                    currSeries.line.opacity = inactiveOpacity;
                }
            } else {
                currSeries.opacity = defaultOpacity;

                if (currSeries.line) {
                    currSeries.line.opacity = defaultOpacity;
                }
            }
        }
    };

    Chart.prototype._applySeriesOpacity = function _applySeriesOpacity (elements, activeSeries, reset, series) {
        var this$1$1 = this;

        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            var currSeries = element.series || series;
            var shouldHighlight = currSeries && (currSeries.highlight || {}).visible;

            if (shouldHighlight && element.visual) {
                var opacity = series ? series.opacity : element.series.opacity;
                if (currSeries !== activeSeries || reset) {
                    element.visual.opacity(reset ? 1 : opacity);
                }
            }

            if (element.children && element.children.length) {
                this$1$1._applySeriesOpacity(element.children, activeSeries, reset, element.series);
            }
        }
    };

    Chart.prototype._chartInstanceFromPoint = function _chartInstanceFromPoint (point) {
        var chartInstance = point.parent;

        while (chartInstance && !chartInstance.plotArea) {
            chartInstance = chartInstance.parent;
        }

        return chartInstance;
    };

    Chart.prototype._showInactiveOpacity = function _showInactiveOpacity (point) {
        var multipleSeries = this._plotArea.series.length > 1;
        var hasInactiveOpacity = this._hasInactiveOpacity();

        if (hasInactiveOpacity) {
            this._displayInactiveOpacity(point, multipleSeries);
        } else {
            this._highlight.show(point);
        }
    };

    Chart.prototype._hideInactiveOpacity = function _hideInactiveOpacity (point) {
        var multipleSeries = this._plotArea.series.length > 1;
        var hasInactiveOpacity = this._hasInactiveOpacity();
        if (hasInactiveOpacity) {
            if (multipleSeries && this._activeChartInstance) {
                this._updateSeriesOpacity(point, true);
                this._applySeriesOpacity(this._activeChartInstance.children, null, true);
                this._activeChartInstance = null;
            }
            this._highlight && this._highlight.hide();
            this._activePoint = null;
        }
    };

    Chart.prototype._hasInactiveOpacity = function _hasInactiveOpacity () {
        var hasDefaultInactiveOpacity = this.options.seriesDefaults.highlight.inactiveOpacity !== undefined;
        var hasInactiveOpacity = this.options.series.filter(function (s) { return s.highlight.inactiveOpacity !== undefined; } ).length > 0;
        return hasDefaultInactiveOpacity || hasInactiveOpacity;
    };

    Chart.prototype._getInactiveOpacityForSeries = function _getInactiveOpacityForSeries (series) {
        var defaultInactiveOpacity = this.options.seriesDefaults.highlight.inactiveOpacity;
        var seriesInactiveOpacity = series.highlight.inactiveOpacity;
        return seriesInactiveOpacity || defaultInactiveOpacity || series.opacity || DEFAULT_SERIES_OPACITY;
    };

    Chart.prototype._getDefaultOpacityForSeries = function _getDefaultOpacityForSeries (series) {
        return series.defaultOpacity || series.opacity || DEFAULT_SERIES_OPACITY;
    };

    Chart.prototype._mouseover = function _mouseover (e) {
        var obj;

        var point = this._startHover(e.element, e.originalEvent);

        if (point && point.tooltipTracking && !this._mouseMoveTrackHandler && !this._sharedTooltip()) {
            this._mouseMoveTrackHandler = this._mouseMoveTracking.bind(this);
            bindEvents(document, ( obj = {}, obj[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj ));
        }
    };

    Chart.prototype._mouseMoveTracking = function _mouseMoveTracking (e) {
        var obj;

        var ref = this;
        var options = ref.options;
        var tooltip = ref._tooltip;
        var highlight = ref._highlight;
        var point = ref._activePoint;
        var coords = this._eventCoordinates(e);

        if (this._plotArea.box.containsPoint(coords)) {
            if (point && point.tooltipTracking && point.series && point.parent.getNearestPoint) {
                var seriesPoint = point.parent.getNearestPoint(coords.x, coords.y, point.seriesIx);
                if (seriesPoint && seriesPoint !== point) {
                    this._activePoint = seriesPoint;

                    if (!seriesPoint.hover(this, e)) {
                        var tooltipOptions = deepExtend({}, options.tooltip, seriesPoint.options.tooltip);
                        if (tooltipOptions.visible) {
                            tooltip.show(seriesPoint);
                        }

                        highlight.show(seriesPoint);
                    }
                }
            }
        } else {
            unbindEvents(document, ( obj = {}, obj[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj ));
            this._unsetActivePoint();
            this._clearFocusedElement();
            this._mouseMoveTrackHandler = null;

            this._hideInactiveOpacity(point);
        }
    };

    Chart.prototype._mousemove = function _mousemove (e) {
        var coords = this._eventCoordinates(e);
        var plotArea = this._plotArea;

        this._trackCrosshairs(coords);

        if (plotArea.hover) {
            var overPlotArea = plotArea.backgroundContainsPoint(coords);
            if (overPlotArea) {
                this._plotAreaHovered = true;
                this._plotArea.hover(this, e);
            } else if (this._plotAreaHovered && !overPlotArea) {
                this._plotAreaHovered = false;
                this.trigger(PLOT_AREA_LEAVE);
            }
        }

        if (this._sharedTooltip()) {
            this._trackSharedTooltip(coords, e);
        }
    };

    Chart.prototype._trackCrosshairs = function _trackCrosshairs (coords) {
        var crosshairs = this._plotArea.crosshairs;

        for (var i = 0; i < crosshairs.length; i++) {
            var current = crosshairs[i];

            if (current.box.containsPoint(coords)) {
                current.showAt(coords);
            } else {
                current.hide();
            }
        }
    };

    Chart.prototype._trackSharedTooltip = function _trackSharedTooltip (coords, e, toggle) {
        if (this._suppressHover) {
            return;
        }

        var ref = this;
        var tooltipOptions = ref.options.tooltip;
        var plotArea = ref._plotArea;
        var categoryAxis = ref._plotArea.categoryAxis;
        var tooltip = ref._tooltip;
        var highlight = ref._highlight;

        if (plotArea.backgroundContainsPoint(coords)) {
            var index = categoryAxis.pointCategoryIndex(coords);
            if (index !== this._tooltipCategoryIx || (!this._sharedHighlight && toggle)) {
                var points = plotArea.pointsByCategoryIndex(index);
                var pointArgs = points.map(function(point) {
                    return point.eventArgs(e);
                });
                var hoverArgs = pointArgs[0] || {};
                hoverArgs.categoryPoints = pointArgs;

                if (points.length > 0 && !this.trigger(SERIES_HOVER, hoverArgs)) {
                    if (tooltipOptions.visible) {
                        tooltip.showAt(points, coords);
                    }

                    highlight.show(points);

                    this._sharedHighlight = true;
                } else {
                    tooltip.hide();
                }

                this._tooltipCategoryIx = index;
            } else if (toggle && this._sharedHighlight) {
                highlight.hide();
                tooltip.hide();
                this._sharedHighlight = false;
            }
        } else if (this._sharedHighlight) {
            highlight.hide();
            tooltip.hide();
            this._tooltipCategoryIx = null;
            this._sharedHighlight = false;
        }
    };

    Chart.prototype.hideElements = function hideElements (options) {
        var plotArea = this._plotArea;
        this._mousemove.cancel();

        plotArea.hideCrosshairs();

        this._unsetActivePoint(options);
    };

    Chart.prototype._unsetActivePoint = function _unsetActivePoint (options) {
        var ref = this;
        var highlight = ref._highlight;

        this._activePoint = null;
        this._hoveredPoint = null;

        if (!options || !options.keepTooltipOpen) {
            this._hideTooltip();
        }

        this._tooltipCategoryIx = null;
        this._sharedHighlight = false;

        if (highlight) {
            highlight.hide();
        }
    };

    Chart.prototype._deferRedraw = function _deferRedraw () {
        this._redraw();
    };

    Chart.prototype._clearRedrawTimeout = function _clearRedrawTimeout () {
        if (this._redrawTimeout) {
            clearInterval(this._redrawTimeout);
            this._redrawTimeout = null;
        }
    };

    Chart.prototype.bindCategories = function bindCategories () {
        var this$1$1 = this;

        var options = this.options;
        var definitions = [].concat(options.categoryAxis);

        for (var axisIx = 0; axisIx < definitions.length; axisIx++) {
            var axis = definitions[axisIx];
            if (axis.autoBind !== false) {
                this$1$1.bindCategoryAxisFromSeries(axis, axisIx);
            }
        }
    };

    Chart.prototype.bindCategoryAxisFromSeries = function bindCategoryAxisFromSeries (axis, axisIx) {
        var this$1$1 = this;

        var uniqueCategories = new Set();
        var seriesOnAxis = this.options.series.filter(function (series) { return series.categoryAxis === axis.name || (!series.categoryAxis && axisIx === 0); });
        var hasCategoryBinding = seriesOnAxis.some(function (series) { return Boolean(series.categoryField); });
        var seriesWithData = seriesOnAxis.filter(function (series) { return series.data && series.data.length > 0; });
        var categorySamples = seriesWithData.map(function (series) { return SeriesBinder.current.bindPoint(series, 0).fields.category; });
        var dateAxis = categorySamples.reduce(function (result, firstCategory) { return result || isDateAxis(axis, firstCategory); }, false);
        var seriesWithBinding = seriesWithData.filter(function (series, seriesIx) { return series.categoryField || defined(categorySamples[seriesIx]); });

        seriesWithBinding.forEach(function (series) { return series.data.forEach(function (row, index) {
            var category = SeriesBinder.current.bindPoint(series, index).fields.category;
            if (dateAxis) {
                var date = parseDateCategory(category, row, this$1$1.chartService.intl);
                category = date ? date.getTime() : undefined;
            }

            uniqueCategories.add(category);
        }); });

        if (uniqueCategories.size > 0) {
            var categories = Array.from(uniqueCategories.values());
            if (dateAxis) {
                categories = categories.sort().map(function (time) { return time && new Date(time); });
            }

            axis.categories = categories;
        } else if (hasCategoryBinding) {
            axis.categories = [];
        }
    };

    Chart.prototype._isBindable = function _isBindable (series) {
        var valueFields = SeriesBinder.current.valueFields(series);
        var result = true;

        for (var i = 0; i < valueFields.length; i++) {
            var field = valueFields[i];
            if (field === VALUE) {
                field = "field";
            } else {
                field = field + "Field";
            }

            if (!defined(series[field])) {
                result = false;
                break;
            }
        }

        return result;
    };

    Chart.prototype._noTransitionsRedraw = function _noTransitionsRedraw () {
        var options = this.options;
        var transitionsState;

        if (options.transitions !== false) {
            options.transitions = false;
            transitionsState = true;
        }

        this._redraw();

        if (transitionsState) {
            options.transitions = true;
        }
    };

    Chart.prototype._legendItemHover = function _legendItemHover (seriesIndex, pointIndex) {
        this._showSeriesInactiveOpacity(seriesIndex, pointIndex);
    };

    Chart.prototype._showSeriesInactiveOpacity = function _showSeriesInactiveOpacity (seriesIndex, pointIndex) {
        var ref = this;
        var plotArea = ref._plotArea;
        var highlight = ref._highlight;
        var currentSeries = (plotArea.srcSeries || plotArea.series)[seriesIndex];
        var items;

        if (inArray(currentSeries.type, [ PIE, DONUT, FUNNEL, PYRAMID ])) {
            items = plotArea.findPoint(function(point) {
                return point.series.index === seriesIndex && point.index === pointIndex;
            });
        } else {
            items = plotArea.pointsBySeriesIndex(seriesIndex);
        }

        if (this._hasInactiveOpacity() && currentSeries.visible && items) {
            var multipleSeries = plotArea.series.length > 1;
            var point = items.length ? items[0] : items;

            this._displayInactiveOpacity(point, multipleSeries, items);
        } else {
            highlight.show(items);
        }
    };

    Chart.prototype._shouldAttachMouseMove = function _shouldAttachMouseMove () {
        return this._plotArea.crosshairs.length || (this._tooltip && this._sharedTooltip()) || this.requiresHandlers([ PLOT_AREA_HOVER, PLOT_AREA_LEAVE ]);
    };

    Chart.prototype.updateMouseMoveHandler = function updateMouseMoveHandler () {
        var obj, obj$1;

        unbindEvents(this.element, ( obj = {}, obj[ MOUSEMOVE ] = this._mousemove, obj ));

        if (this._shouldAttachMouseMove()) {
            bindEvents(this.element, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mousemove, obj$1 ));
        }
    };

    Chart.prototype.applyOptions = function applyOptions (options, theme) {
        clearMissingValues(this._originalOptions, options);
        this._originalOptions = deepExtend(this._originalOptions, options);
        this.options = deepExtend({}, this._originalOptions);

        if (theme) {
            this._theme = theme;
            this.chartService.theme = theme;
        }
        this._initTheme(this.options, this._theme);

        this._toggleDragZoomEvents();
    };

    Chart.prototype.setOptions = function setOptions (options, theme) {
        this.applyOptions(options, theme);
        this.bindCategories();
        this.redraw();
        this.updateMouseMoveHandler();
        this._restoreOverlayElement();
    };

    Chart.prototype.setDirection = function setDirection (rtl) {
        this.chartService.rtl = Boolean(rtl);
        if (this.surface && this.surface.type === 'svg') {
            this._destroySurface();
        }
    };

    Chart.prototype.setIntlService = function setIntlService (intl) {
        this.chartService.intl = intl;
    };

    Chart.prototype.noTransitionsRedraw = function noTransitionsRedraw () {
        this._noTransitionsRedraw();
    };

    Chart.prototype.destroy = function destroy () {
        var obj, obj$1;

        this._destroyed = true;

        unbindEvents(this.element, ( obj = {}, obj[ CONTEXTMENU ] = this._clickHandler, obj[ MOUSEWHEEL$1 ] = this._mousewheelHandler, obj[ MOUSEMOVE ] = this._mousemove, obj[ MOUSELEAVE ] = this._mouseleaveHandler, obj[ KEYDOWN ] = this._keydownHandler, obj[ FOCUS ] = this._focusHandler, obj[ BLUR] = this._blurHandler, obj ));

        if (this.domEvents) {
            this.domEvents.destroy();
            delete this.domEvents;
        }

        if (this._mouseMoveTrackHandler) {
            unbindEvents(document, ( obj$1 = {}, obj$1[ MOUSEMOVE ] = this._mouseMoveTrackHandler, obj$1 ));
        }

        this._focusState = null;

        this._destroyView();

        this._destroySurface();

        this._clearRedrawTimeout();
    };

    Chart.prototype._destroySurface = function _destroySurface () {
        var surface = this.surface;
        if (surface) {
            surface.unbind("mouseenter", this._surfaceMouseenterHandler);
            surface.unbind("mouseleave", this._surfaceMouseleaveHandler);
            surface.destroy();

            this.surface = null;
        }
    };

    Chart.prototype._destroySelections = function _destroySelections () {
        var selections = this._selections;

        if (selections) {
            while (selections.length > 0) {
                selections.shift().destroy();
            }
        }
    };

    Chart.prototype._destroyView = function _destroyView () {
        var model = this._model;

        if (model) {
            model.destroy();
            this._model = null;
        }

        this._unsetActivePoint();
        this._clearFocusedElement();
        this._resetDrilldownPoint();
        this._destroySelections();

        if (this._tooltip) {
            this._tooltip.destroy();
        }

        if (this._highlight) {
            this._highlight.destroy();
        }

        if (this._zoomSelection) {
            this._zoomSelection.destroy();
            delete this._zoomSelection;
        }

        if (this._pannable) {
            this._pannable.destroy();
            delete this._pannable;
        }

        if (this._mousewheelZoom) {
            this._mousewheelZoom.destroy();
            delete this._mousewheelZoom;
        }
    };

    return Chart;
}(Class));

function resolveAxisAliases(options) {
    var aliases = AXIS_NAMES;

    for (var idx = 0; idx < aliases.length; idx++) {
        var alias = aliases[idx] + "Axes";
        if (options[alias]) {
            options[aliases[idx] + "Axis"] = options[alias];
            delete options[alias];
        }
    }
}

function pointByCategoryName(points, name) {
    if (points) {
        for (var idx = 0; idx < points.length; idx++) {
            if (points[idx].category === name) {
                return [ points[idx] ];
            }
        }
    }
}

function applyAxisDefaults(options, themeOptions) {
    var themeAxisDefaults = ((themeOptions || {}).axisDefaults) || {};
    var axisName, axisDefaults, axes;

    function mapAxisOptions(axisOptions) {
        var axisColor = (axisOptions || {}).color || axisDefaults.color;
        var result = deepExtend({},
            themeAxisDefaults,
            themeAxisDefaults[axisName],
            axisDefaults,
            axisDefaults[axisName], {
                line: { color: axisColor },
                labels: { color: axisColor },
                title: { color: axisColor }
            },
            axisOptions
        );

        delete result[axisName];

        return result;
    }

    for (var idx = 0; idx < AXIS_NAMES.length; idx++) {
        axisName = AXIS_NAMES[idx] + "Axis";
        axisDefaults = options.axisDefaults || {};
        axes = [].concat(options[axisName]);

        axes = axes.map(mapAxisOptions);

        options[axisName] = axes.length > 1 ? axes : axes[0];
    }
}

function applySeriesDefaults(options, themeOptions) {
    var series = options.series;
    var seriesLength = series.length;
    var seriesDefaults = options.seriesDefaults;
    var commonDefaults = deepExtend({}, options.seriesDefaults);
    var themeSeriesDefaults = themeOptions ? deepExtend({}, themeOptions.seriesDefaults) : {};
    var commonThemeDefaults = deepExtend({}, themeSeriesDefaults);

    cleanupNestedSeriesDefaults(commonDefaults);
    cleanupNestedSeriesDefaults(commonThemeDefaults);

    for (var i = 0; i < seriesLength; i++) {
        var seriesType = series[i].type || options.seriesDefaults.type;

        var baseOptions = deepExtend(
            { data: [] },
            commonThemeDefaults,
            themeSeriesDefaults[seriesType],
            { tooltip: options.tooltip },
            commonDefaults,
            seriesDefaults[seriesType]
        );

        series[i]._defaults = baseOptions;
        series[i] = deepExtend({}, baseOptions, series[i]);
        series[i].data = series[i].data || [];
    }
}

function cleanupNestedSeriesDefaults(seriesDefaults) {
    delete seriesDefaults.bar;
    delete seriesDefaults.column;
    delete seriesDefaults.rangeColumn;
    delete seriesDefaults.line;
    delete seriesDefaults.verticalLine;
    delete seriesDefaults.pie;
    delete seriesDefaults.donut;
    delete seriesDefaults.area;
    delete seriesDefaults.verticalArea;
    delete seriesDefaults.scatter;
    delete seriesDefaults.scatterLine;
    delete seriesDefaults.bubble;
    delete seriesDefaults.candlestick;
    delete seriesDefaults.ohlc;
    delete seriesDefaults.boxPlot;
    delete seriesDefaults.bullet;
    delete seriesDefaults.verticalBullet;
    delete seriesDefaults.polarArea;
    delete seriesDefaults.polarLine;
    delete seriesDefaults.radarArea;
    delete seriesDefaults.radarLine;
    delete seriesDefaults.waterfall;
}


function axisRanges(axes) {
    var ranges = {};

    for (var i = 0; i < axes.length; i++) {
        var axis = axes[i];
        var axisName = axis.options.name;
        if (axisName) {
            ranges[axisName] = axis.range();
        }
    }

    return ranges;
}

var DATA_FIELDS = [ 'data', 'categories' ];

function clearMissingValues(originalOptions, options) {
    for (var field in options) {
        if (!inArray(field, DATA_FIELDS) && hasOwnProperty(options, field)) {
            var fieldValue = options[field];
            var originalValue = originalOptions[field];
            if (defined(originalValue)) {
                var nullValue = fieldValue === null;
                if ((nullValue || !defined(fieldValue))) {
                    delete originalOptions[field];
                    if (nullValue) {
                        delete options[field];
                    }
                } else if (originalValue && isObject(fieldValue)) {
                    if (isObject(originalValue)) {
                        clearMissingValues(originalValue, fieldValue);
                    }
                }
            }
        }
    }
}

function triggerPaneRender(panes) {
    for (var idx = 0; idx < panes.length; idx++) {
        panes[idx].notifyRender();
    }
}

setDefaultOptions(Chart, {
    renderAs: "",
    chartArea: {},
    legend: {
        visible: true,
        labels: {},
        accessibility: {},
        focusHighlight: {
            border: {
                opacity: 1,
                color: BLACK$1,
                width: 2
            }
        }
    },
    categoryAxis: {},
    seriesDefaults: {
        type: COLUMN,
        data: [],
        highlight: {
            visible: true
        },
        labels: {},
        negativeValues: {
            visible: false
        },
        accessibility: {},
        focusHighlight: {
            border: {
                opacity: 1,
                width: 2
            },
            zIndex: 200
        }
    },
    series: [],
    seriesColors: null,
    tooltip: {
        visible: false
    },
    transitions: true,
    valueAxis: {},
    plotArea: {},
    title: {},
    xAxis: {},
    yAxis: {},
    panes: [ {} ],
    pannable: false,
    zoomable: false
});

var TOP_OFFSET = -2;

var SharedTooltip = (function (ChartSharedTooltip) {
    function SharedTooltip () {
        ChartSharedTooltip.apply(this, arguments);
    }

    if ( ChartSharedTooltip ) SharedTooltip.__proto__ = ChartSharedTooltip;
    SharedTooltip.prototype = Object.create( ChartSharedTooltip && ChartSharedTooltip.prototype );
    SharedTooltip.prototype.constructor = SharedTooltip;

    SharedTooltip.prototype._slotAnchor = function _slotAnchor (coords, slot) {
        var axis = this.plotArea.categoryAxis;
        var vertical = axis.options.vertical;
        var align = vertical ? {
            horizontal: "left",
            vertical: "center"
        } : {
            horizontal: "center",
            vertical: "bottom"
        };

        var point;

        if (vertical) {
            point = new Point$5(this.plotArea.box.x2, slot.center().y);
        } else {
            point = new Point$5(slot.center().x, TOP_OFFSET);
        }

        return {
            point: point,
            align: align
        };
    };

    SharedTooltip.prototype._defaultAnchor = function _defaultAnchor (point, slot) {
        return this._slotAnchor({}, slot);
    };

    return SharedTooltip;
}(SharedTooltip$1));

var DEAULT_BAR_WIDTH = 150;
var DEAULT_BULLET_WIDTH = 150;
var NO_CROSSHAIR = [ BAR, BULLET ];

function hide(children) {
    var state = [];
    for (var idx = 0; idx < children.length; idx++) {
        var child = children[idx];
        state[idx] = child.style.display;
        child.style.display = "none";
    }

    return state;
}

function show(children, state) {
    for (var idx = 0; idx < children.length; idx++) {
        children[idx].style.display = state[idx];
    }
}

function wrapNumber(value) {
    return isNumber(value) ? [ value ] : value;
}

var Sparkline = (function (Chart) {
    function Sparkline () {
        Chart.apply(this, arguments);
    }

    if ( Chart ) Sparkline.__proto__ = Chart;
    Sparkline.prototype = Object.create( Chart && Chart.prototype );
    Sparkline.prototype.constructor = Sparkline;

    Sparkline.prototype._setElementClass = function _setElementClass (element) {
        addClass(element, 'k-sparkline');
    };

    Sparkline.prototype._initElement = function _initElement (element) {
        Chart.prototype._initElement.call(this, element);

        this._initialWidth = Math.floor(elementSize(element).width);
    };

    Sparkline.prototype._resize = function _resize () {
        var element = this.element;
        var state = hide(element.childNodes);

        this._initialWidth = Math.floor(elementSize(element).width);

        show(element.childNodes, state);

        Chart.prototype._resize.call(this);
    };

    Sparkline.prototype._modelOptions = function _modelOptions () {
        var chartOptions = this.options;
        var stage = this._surfaceWrap();
        var displayState = hide(stage.childNodes);

        var space = document.createElement('span');
        space.innerHTML = '&nbsp;';

        stage.appendChild(space);

        var options = deepExtend({
            width: this._autoWidth,
            height: elementSize(stage).height,
            transitions: chartOptions.transitions
        }, chartOptions.chartArea, {
            inline: true,
            align: false
        });

        elementSize(stage, {
            width: options.width,
            height: options.height
        });

        stage.removeChild(space);

        show(stage.childNodes, displayState);

        if (this.surface) {
            this.surface.resize();
        }

        return options;
    };

    Sparkline.prototype._surfaceWrap = function _surfaceWrap () {
        if (!this.stage) {
            var stage = this.stage = document.createElement('span');
            this.element.appendChild(stage);
        }
        return this.stage;
    };

    Sparkline.prototype._createPlotArea = function _createPlotArea (skipSeries) {
        var plotArea = Chart.prototype._createPlotArea.call(this, skipSeries);
        this._autoWidth = this._initialWidth || this._calculateWidth(plotArea);

        return plotArea;
    };

    Sparkline.prototype._calculateWidth = function _calculateWidth (plotArea) {
        var options = this.options;
        var margin = getSpacing(options.chartArea.margin);
        var charts = plotArea.charts;
        var stage = this._surfaceWrap();
        var total = 0;


        for (var i = 0; i < charts.length; i++) {
            var currentChart = charts[i];
            var firstSeries = (currentChart.options.series || [])[0];
            if (!firstSeries) {
                continue;
            }

            if (firstSeries.type === BAR) {
                return DEAULT_BAR_WIDTH;
            }

            if (firstSeries.type === BULLET) {
                return DEAULT_BULLET_WIDTH;
            }

            if (firstSeries.type === PIE) {
                return elementSize(stage).height;
            }

            var categoryAxis = currentChart.categoryAxis;
            if (categoryAxis) {
                var pointsCount = categoryAxis.categoriesCount() *
                    (!currentChart.options.isStacked && inArray(firstSeries.type, [ COLUMN, VERTICAL_BULLET ]) ? currentChart.seriesOptions.length : 1);

                total = Math.max(total, pointsCount);
            }
        }

        var size = total * options.pointWidth;
        if (size > 0) {
            size += margin.left + margin.right;
        }

        return size;
    };

    Sparkline.prototype._createSharedTooltip = function _createSharedTooltip (options) {
        return new SharedTooltip(this._plotArea, options);
    };

    Sparkline.normalizeOptions = function normalizeOptions (userOptions) {
        var options = wrapNumber(userOptions);

        if (isArray(options)) {
            options = { seriesDefaults: { data: options } };
        } else {
            options = deepExtend({}, options);
        }

        if (!options.series) {
            options.series = [ { data: wrapNumber(options.data) } ];
        }

        deepExtend(options, {
            seriesDefaults: {
                type: options.type
            }
        });

        if (inArray(options.series[0].type, NO_CROSSHAIR) ||
            inArray(options.seriesDefaults.type, NO_CROSSHAIR)) {
            options = deepExtend({}, {
                categoryAxis: {
                    crosshair: {
                        visible: false
                    }
                }
            }, options);
        }

        return options;
    };

    return Sparkline;
}(Chart));

setDefaultOptions(Sparkline, {
    chartArea: {
        margin: 2
    },
    axisDefaults: {
        visible: false,
        majorGridLines: {
            visible: false
        },
        valueAxis: {
            narrowRange: true
        }
    },
    seriesDefaults: {
        type: "line",
        area: {
            line: {
                width: 0.5
            }
        },
        bar: {
            stack: true
        },
        padding: 2,
        width: 0.5,
        overlay: {
            gradient: null
        },
        highlight: {
            visible: false
        },
        border: {
            width: 0
        },
        markers: {
            size: 2,
            visible: false
        }
    },
    tooltip: {
        visible: true,
        shared: true
    },
    categoryAxis: {
        crosshair: {
            visible: true,
            tooltip: {
                visible: false
            }
        }
    },
    legend: {
        visible: false
    },
    transitions: false,

    pointWidth: 5,

    panes: [ { clip: false } ]
});

var FadeOutAnimation = (function (superclass) {
    function FadeOutAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) FadeOutAnimation.__proto__ = superclass;
    FadeOutAnimation.prototype = Object.create( superclass && superclass.prototype );
    FadeOutAnimation.prototype.constructor = FadeOutAnimation;

    FadeOutAnimation.prototype.setup = function setup () {
        this._initialOpacity = parseFloat(elementStyles$1(this.element, 'opacity').opacity);
    };

    FadeOutAnimation.prototype.step = function step (pos) {
        elementStyles$1(this.element, {
            opacity: String(interpolateValue(this._initialOpacity, 0, pos))
        });
    };

    FadeOutAnimation.prototype.abort = function abort () {
        superclass.prototype.abort.call(this);
        elementStyles$1(this.element, {
            display: 'none',
            opacity: String(this._initialOpacity)
        });
    };

    FadeOutAnimation.prototype.cancel = function cancel () {
        superclass.prototype.abort.call(this);
        elementStyles$1(this.element, {
            opacity: String(this._initialOpacity)
        });
    };

    return FadeOutAnimation;
}(Animation$1));

function createDiv(className, style) {
    var div = document.createElement("div");
    div.className = className;
    if (style) {
        div.style.cssText = style;
    }

    return div;
}

var NavigatorHint = (function (Class) {
    function NavigatorHint(container, chartService, options) {
        Class.call(this);

        this.options = deepExtend({}, this.options, options);
        this.container = container;
        this.chartService = chartService;

        var padding = elementStyles$1(container, [ "paddingLeft", "paddingTop" ]);
        this.chartPadding = {
            top: padding.paddingTop,
            left: padding.paddingLeft
        };

        this.createElements();
        container.appendChild(this.element);
    }

    if ( Class ) NavigatorHint.__proto__ = Class;
    NavigatorHint.prototype = Object.create( Class && Class.prototype );
    NavigatorHint.prototype.constructor = NavigatorHint;

    NavigatorHint.prototype.createElements = function createElements () {
        var element = this.element = createDiv('k-navigator-hint', 'display: none; position: absolute; top: 1px; left: 1px;');
        var tooltip = this.tooltip = createDiv('k-tooltip k-chart-tooltip');
        var scroll = this.scroll = createDiv('k-scroll');

        tooltip.innerHTML = '&nbsp;';

        element.appendChild(tooltip);
        element.appendChild(scroll);
    };

    NavigatorHint.prototype.show = function show (from, to, bbox) {
        var ref = this;
        var element = ref.element;
        var options = ref.options;
        var scroll = ref.scroll;
        var tooltip = ref.tooltip;
        var middle = toDate(toTime(from) + toTime(to - from) / 2);
        var scrollWidth = bbox.width() * 0.4;
        var minPos = bbox.center().x - scrollWidth;
        var maxPos = bbox.center().x;
        var posRange = maxPos - minPos;
        var range = options.max - options.min;
        var scale = posRange / range;
        var offset = middle - options.min;
        var text = this.chartService.intl.format(options.format, from, to);
        var template = getTemplate$1(options);

        this.clearHideTimeout();

        if (!this._visible) {
            elementStyles$1(element, {
                visibility: 'hidden',
                display: 'block'
            });
            this._visible = true;
        }

        if (template) {
            text = template({
                from: from,
                to: to
            });
        }

        tooltip.innerHTML = text;
        elementStyles$1(tooltip, {
            left: bbox.center().x - tooltip.offsetWidth / 2,
            top: bbox.y1
        });

        var tooltipStyle = elementStyles$1(tooltip, [ 'marginTop', 'borderTopWidth', 'height' ]);

        elementStyles$1(scroll, {
            width: scrollWidth,
            left: minPos + offset * scale,
            top: bbox.y1 + tooltipStyle.marginTop + tooltipStyle.borderTopWidth + tooltipStyle.height / 2
        });

        elementStyles$1(element, {
            visibility: 'visible'
        });
    };

    NavigatorHint.prototype.clearHideTimeout = function clearHideTimeout () {
        if (this._hideTimeout) {
            clearTimeout(this._hideTimeout);
        }

        if (this._hideAnimation) {
            this._hideAnimation.cancel();
        }
    };

    NavigatorHint.prototype.hide = function hide () {
        var this$1$1 = this;

        this.clearHideTimeout();

        this._hideTimeout = setTimeout(function () {
            this$1$1._visible = false;
            this$1$1._hideAnimation = new FadeOutAnimation(this$1$1.element);
            this$1$1._hideAnimation.setup();
            this$1$1._hideAnimation.play();
        }, this.options.hideDelay);
    };

    NavigatorHint.prototype.destroy = function destroy () {
        this.clearHideTimeout();
        if (this.container) {
            this.container.removeChild(this.element);
        }
        delete this.container;
        delete this.chartService;
        delete this.element;
        delete this.tooltip;
        delete this.scroll;
    };

    return NavigatorHint;
}(Class));

setDefaultOptions(NavigatorHint, {
    format: "{0:d} - {1:d}",
    hideDelay: 500
});

var NAVIGATOR_PANE = "_navigator";
var NAVIGATOR_AXIS = NAVIGATOR_PANE;
var DEFAULT_PANE = "_default";

var constants = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DEFAULT_PANE: DEFAULT_PANE,
    NAVIGATOR_AXIS: NAVIGATOR_AXIS,
    NAVIGATOR_PANE: NAVIGATOR_PANE
});

var ZOOM_ACCELERATION = 3;

var Navigator$1 = (function (Class) {
    function Navigator(chart) {
        var obj;

        Class.call(this);

        this.chart = chart;
        var options = this.options = deepExtend({}, this.options, chart.options.navigator);
        var select = options.select;
        if (select) {
            select.from = this.parseDate(select.from);
            select.to = this.parseDate(select.to);
        }

        if (!defined(options.hint.visible)) {
            options.hint.visible = options.visible;
        }

        this.chartObserver = new InstanceObserver(this, ( obj = {}, obj[DRAG] = '_drag', obj[DRAG_END] = '_dragEnd', obj[ZOOM] = '_zoom', obj[ZOOM_END] = '_zoomEnd', obj ));
        chart.addObserver(this.chartObserver);
    }

    if ( Class ) Navigator.__proto__ = Class;
    Navigator.prototype = Object.create( Class && Class.prototype );
    Navigator.prototype.constructor = Navigator;

    Navigator.prototype.parseDate = function parseDate$1 (value) {
        return parseDate(this.chart.chartService.intl, value);
    };

    Navigator.prototype.clean = function clean () {
        if (this.selection) {
            this.selection.destroy();
            this.selection = null;
        }

        if (this.hint) {
            this.hint.destroy();
            this.hint = null;
        }
    };

    Navigator.prototype.destroy = function destroy () {
        if (this.chart) {
            this.chart.removeObserver(this.chartObserver);
            delete this.chart;
        }

        this.clean();
    };

    Navigator.prototype.redraw = function redraw () {
        this._redrawSelf();
        this.initSelection();
    };

    Navigator.prototype.initSelection = function initSelection () {
        var ref = this;
        var chart = ref.chart;
        var options = ref.options;
        var axis = this.mainAxis();
        var ref$1 = axis.roundedRange();
        var min = ref$1.min;
        var max = ref$1.max;
        var ref$2 = options.select;
        var from = ref$2.from;
        var to = ref$2.to;
        var mousewheel = ref$2.mousewheel;
        var axisClone = clone(axis);

        if (axis.categoriesCount() === 0) {
            return;
        }

        this.clean();

        // "Freeze" the selection axis position until the next redraw
        axisClone.box = axis.box;

        this.selection = new Selection(chart, axisClone, {
            min: min,
            max: max,
            from: from || min,
            to: to || max,
            mousewheel: valueOrDefault(mousewheel, { zoom: "left" }),
            visible: options.visible
        }, new InstanceObserver(this, {
            selectStart: '_selectStart',
            select: '_select',
            selectEnd: '_selectEnd'
        }));

        if (options.hint.visible) {
            this.hint = new NavigatorHint(chart.element, chart.chartService, {
                min: min,
                max: max,
                template: getTemplate$1(options.hint),
                format: options.hint.format
            });
        }
    };

    Navigator.prototype.setRange = function setRange () {
        var plotArea = this.chart._createPlotArea(true);
        var axis = plotArea.namedCategoryAxes[NAVIGATOR_AXIS];

        var ref = axis.roundedRange();
        var min = ref.min;
        var max = ref.max;

        var select = this.options.select || {};
        var from = select.from || min;
        if (from < min) {
            from = min;
        }

        var to = select.to || max;
        if (to > max) {
            to = max;
        }

        this.options.select = deepExtend({}, select, {
            from: from,
            to: to
        });

        this.filterAxes();
    };

    Navigator.prototype._redrawSelf = function _redrawSelf (silent) {
        var plotArea = this.chart._plotArea;

        if (plotArea) {
            plotArea.redraw(last(plotArea.panes), silent);
        }
    };

    Navigator.prototype.redrawSlaves = function redrawSlaves () {
        var chart = this.chart;
        var plotArea = chart._plotArea;
        var slavePanes = plotArea.panes.filter(function (pane) { return pane.options.name !== NAVIGATOR_PANE; });

        // Update the original series and categoryAxis before partial refresh.
        plotArea.srcSeries = chart.options.series;
        plotArea.options.categoryAxis = chart.options.categoryAxis;
        plotArea.clearSeriesPointsCache();

        plotArea.redraw(slavePanes);
    };

    Navigator.prototype._drag = function _drag (e) {
        var ref = this;
        var chart = ref.chart;
        var selection = ref.selection;
        var coords = chart._eventCoordinates(e.originalEvent);
        var navigatorAxis = this.mainAxis();
        var naviRange = navigatorAxis.roundedRange();
        var inNavigator = navigatorAxis.pane.box.containsPoint(coords);
        var axis = chart._plotArea.categoryAxis;
        var range = e.axisRanges[axis.options.name];
        var select = this.options.select;
        var duration;

        if (!range || inNavigator || !selection) {
            return;
        }

        if (select.from && select.to) {
            duration = toTime(select.to) - toTime(select.from);
        } else {
            duration = toTime(selection.options.to) - toTime(selection.options.from);
        }

        var from = toDate(limitValue(
            toTime(range.min),
            naviRange.min, toTime(naviRange.max) - duration
        ));

        var to = toDate(limitValue(
            toTime(from) + duration,
            toTime(naviRange.min) + duration, naviRange.max
        ));

        this.options.select = { from: from, to: to };

        if (this.options.liveDrag) {
            this.filterAxes();
            this.redrawSlaves();
        }

        selection.set(from, to);

        this.showHint(from, to);
    };

    Navigator.prototype._dragEnd = function _dragEnd () {
        this.filterAxes();
        this.filter();
        this.redrawSlaves();

        if (this.hint) {
            this.hint.hide();
        }
    };

    Navigator.prototype.readSelection = function readSelection () {
        var ref = this;
        var ref_selection_options = ref.selection.options;
        var from = ref_selection_options.from;
        var to = ref_selection_options.to;
        var select = ref.options.select;

        select.from = from;
        select.to = to;
    };

    Navigator.prototype.filterAxes = function filterAxes () {
        var ref = this;
        var select = ref.options.select; if ( select === void 0 ) select = { };
        var chart = ref.chart;
        var allAxes = chart.options.categoryAxis;
        var from = select.from;
        var to = select.to;

        for (var idx = 0; idx < allAxes.length; idx++) {
            var axis = allAxes[idx];
            if (axis.pane !== NAVIGATOR_PANE) {
                axis.min = from;
                axis.max = to;
            }
        }
    };

    Navigator.prototype.filter = function filter () {
        var ref = this;
        var chart = ref.chart;
        var select = ref.options.select;

        if (!chart.requiresHandlers([ "navigatorFilter" ])) {
            return;
        }

        var mainAxis = this.mainAxis();
        var args = {
            from: select.from,
            to: select.to
        };

        if (mainAxis.options.type !== 'category') {
            var axisOptions = new DateCategoryAxis(deepExtend({
                baseUnit: "fit"
            }, chart.options.categoryAxis[0], {
                categories: [ select.from, select.to ]
            }), chart.chartService).options;

            args.from = addDuration(axisOptions.min, -axisOptions.baseUnitStep, axisOptions.baseUnit);
            args.to = addDuration(axisOptions.max, axisOptions.baseUnitStep, axisOptions.baseUnit);
        }

        this.chart.trigger("navigatorFilter", args);
    };

    Navigator.prototype._zoom = function _zoom (e) {
        var ref = this;
        var axis = ref.chart._plotArea.categoryAxis;
        var selection = ref.selection;
        var ref_options = ref.options;
        var select = ref_options.select;
        var liveDrag = ref_options.liveDrag;
        var mainAxis = this.mainAxis();
        var delta = e.delta;

        if (!selection) {
            return;
        }

        var fromIx = mainAxis.categoryIndex(selection.options.from);
        var toIx = mainAxis.categoryIndex(selection.options.to);
        var coords = this.chart._eventCoordinates(e.originalEvent);

        e.originalEvent.preventDefault();

        if (Math.abs(delta) > 1) {
            delta *= ZOOM_ACCELERATION;
        }

        if (toIx - fromIx > 1) {
            selection.zoom(delta, coords);
            this.readSelection();
        } else {
            axis.options.min = select.from;
            select.from = axis.scaleRange(-e.delta * this.chart._mousewheelZoomRate(), coords).min;
        }

        if (liveDrag) {
            this.filterAxes();
            this.redrawSlaves();
        }

        selection.set(select.from, select.to);

        this.showHint(this.options.select.from, this.options.select.to);
    };

    Navigator.prototype._zoomEnd = function _zoomEnd (e) {
        this._dragEnd(e);
    };

    Navigator.prototype.showHint = function showHint (from, to) {
        var plotArea = this.chart._plotArea;

        if (this.hint) {
            this.hint.show(from, to, plotArea.backgroundBox());
        }
    };

    Navigator.prototype._selectStart = function _selectStart (e) {
        return this.chart._selectStart(e);
    };

    Navigator.prototype._select = function _select (e) {
        this.showHint(e.from, e.to);

        return this.chart._select(e);
    };

    Navigator.prototype._selectEnd = function _selectEnd (e) {
        if (this.hint) {
            this.hint.hide();
        }

        this.readSelection();
        this.filterAxes();
        this.filter();
        this.redrawSlaves();

        return this.chart._selectEnd(e);
    };

    Navigator.prototype.mainAxis = function mainAxis () {
        var plotArea = this.chart._plotArea;

        if (plotArea) {
            return plotArea.namedCategoryAxes[NAVIGATOR_AXIS];
        }
    };

    Navigator.prototype.select = function select (from, to) {
        var select = this.options.select;

        if (from && to) {
            select.from = this.parseDate(from);
            select.to = this.parseDate(to);

            this.filterAxes();
            this.filter();
            this.redrawSlaves();

            this.selection.set(from, to);
        }

        return {
            from: select.from,
            to: select.to
        };
    };

    Navigator.setup = function setup (options, themeOptions) {
        if ( options === void 0 ) options = {};
        if ( themeOptions === void 0 ) themeOptions = {};

        if (options.__navi) {
            return;
        }
        options.__navi = true;

        var naviOptions = deepExtend({}, themeOptions.navigator, options.navigator);
        var panes = options.panes = [].concat(options.panes);
        var paneOptions = deepExtend({}, naviOptions.pane, { name: NAVIGATOR_PANE });

        if (!naviOptions.visible) {
            paneOptions.visible = false;
            paneOptions.height = 0.1;
        }

        if (options.navigator.position !== 'top') {
            panes.push(paneOptions);
        } else {
            panes.unshift(paneOptions);
        }

        panes.forEach(function (pane) {
            pane.name = pane.name || DEFAULT_PANE;
        });

        Navigator.attachAxes(options, naviOptions);
        Navigator.attachSeries(options, naviOptions, themeOptions);
    };

    Navigator.attachAxes = function attachAxes (options, naviOptions) {
        var series = naviOptions.series || [];
        var categoryAxes = options.categoryAxis = [].concat(options.categoryAxis);
        var valueAxes = options.valueAxis = [].concat(options.valueAxis);
        var allAxes = categoryAxes.concat(valueAxes);
        allAxes.forEach(function (axis) {
            axis.pane = axis.pane || DEFAULT_PANE;
        });

        var equallySpacedSeries = filterSeriesByType(series, EQUALLY_SPACED_SERIES);
        var justifyAxis = equallySpacedSeries.length === 0;

        var base = deepExtend({
            type: "date",
            pane: NAVIGATOR_PANE,
            roundToBaseUnit: !justifyAxis,
            justified: justifyAxis,
            _collapse: false,
            majorTicks: { visible: true },
            tooltip: { visible: false },
            labels: { step: 1 },
            autoBind: naviOptions.autoBindElements,
            autoBaseUnitSteps: {
                minutes: [ 1 ],
                hours: [ 1, 2 ],
                days: [ 1, 2 ],
                weeks: [],
                months: [ 1 ],
                years: [ 1 ]
            }
        });
        var user = naviOptions.categoryAxis;

        categoryAxes.push(
            deepExtend({}, base, {
                maxDateGroups: 200
            }, user, {
                name: NAVIGATOR_AXIS,
                title: null,
                baseUnit: "fit",
                baseUnitStep: "auto",
                labels: { visible: false },
                majorTicks: { visible: false }
            }), deepExtend({}, base, user, {
                name: NAVIGATOR_AXIS + "_labels",
                maxDateGroups: 20,
                baseUnitStep: "auto",
                labels: { position: "" },
                plotBands: [],
                autoBaseUnitSteps: {
                    minutes: []
                },
                _overlap: true
            }), deepExtend({}, base, user, {
                name: NAVIGATOR_AXIS + "_ticks",
                maxDateGroups: 200,
                majorTicks: {
                    width: 0.5
                },
                plotBands: [],
                title: null,
                labels: { visible: false, mirror: true },
                _overlap: true
            })
        );

        valueAxes.push(deepExtend({
            name: NAVIGATOR_AXIS,
            pane: NAVIGATOR_PANE,
            majorGridLines: {
                visible: false
            },
            visible: false
        }, naviOptions.valueAxis));
    };

    Navigator.attachSeries = function attachSeries (options, naviOptions, themeOptions) {
        var series = options.series = options.series || [];
        var navigatorSeries = [].concat(naviOptions.series || []);
        var seriesColors = themeOptions.seriesColors;
        var defaults = naviOptions.seriesDefaults;

        for (var idx = 0; idx < navigatorSeries.length; idx++) {
            series.push(
                deepExtend({
                    color: seriesColors[idx % seriesColors.length],
                    categoryField: naviOptions.dateField,
                    visibleInLegend: false,
                    tooltip: {
                        visible: false
                    }
                }, defaults, navigatorSeries[idx], {
                    axis: NAVIGATOR_AXIS,
                    categoryAxis: NAVIGATOR_AXIS,
                    autoBind: naviOptions.autoBindElements
                })
            );
        }
    };

    return Navigator;
}(Class));

function ClonedObject() { }
function clone(obj) {
    ClonedObject.prototype = obj;
    return new ClonedObject();
}

var AUTO_CATEGORY_WIDTH = 28;

var StockChart = (function (Chart) {
    function StockChart () {
        Chart.apply(this, arguments);
    }

    if ( Chart ) StockChart.__proto__ = Chart;
    StockChart.prototype = Object.create( Chart && Chart.prototype );
    StockChart.prototype.constructor = StockChart;

    StockChart.prototype.applyDefaults = function applyDefaults (options, themeOptions) {
        var width = elementSize(this.element).width || DEFAULT_WIDTH$1;
        var theme = themeOptions;

        var stockDefaults = {
            seriesDefaults: {
                categoryField: options.dateField
            },
            axisDefaults: {
                categoryAxis: {
                    name: "default",
                    majorGridLines: {
                        visible: false
                    },
                    labels: {
                        step: 2
                    },
                    majorTicks: {
                        visible: false
                    },
                    maxDateGroups: Math.floor(width / AUTO_CATEGORY_WIDTH)
                }
            }
        };

        if (theme) {
            theme = deepExtend({}, theme, stockDefaults);
        }

        Navigator$1.setup(options, theme);

        Chart.prototype.applyDefaults.call(this, options, theme);
    };

    StockChart.prototype._setElementClass = function _setElementClass (element) {
        addClass(element, 'k-chart k-stockchart');
    };

    StockChart.prototype.setOptions = function setOptions (options) {
        this.destroyNavigator();
        Chart.prototype.setOptions.call(this, options);
    };

    StockChart.prototype.noTransitionsRedraw = function noTransitionsRedraw () {
        var transitions = this.options.transitions;

        this.options.transitions = false;
        this._fullRedraw();
        this.options.transitions = transitions;
    };

    StockChart.prototype._resize = function _resize () {
        this.noTransitionsRedraw();
    };

    StockChart.prototype._redraw = function _redraw () {
        var navigator = this.navigator;

        if (!this._dirty() && navigator && navigator.options.partialRedraw) {
            navigator.redrawSlaves();
        } else {
            this._fullRedraw();
        }
    };

    StockChart.prototype._dirty = function _dirty () {
        var options = this.options;
        var series = [].concat(options.series, options.navigator.series);
        var seriesCount = grep(series, function(s) { return s && s.visible; }).length;
        var dirty = this._seriesCount !== seriesCount;
        this._seriesCount = seriesCount;

        return dirty;
    };

    StockChart.prototype._fullRedraw = function _fullRedraw () {
        var navigator = this.navigator;

        if (!navigator) {
            navigator = this.navigator = new Navigator$1(this);
            this.trigger("navigatorCreated", { navigator: navigator });
        }

        navigator.clean();
        navigator.setRange();

        Chart.prototype._redraw.call(this);

        navigator.initSelection();
    };

    StockChart.prototype._trackSharedTooltip = function _trackSharedTooltip (coords) {
        var plotArea = this._plotArea;
        var pane = plotArea.paneByPoint(coords);

        if (pane && pane.options.name === NAVIGATOR_PANE) {
            this._unsetActivePoint();
        } else {
            Chart.prototype._trackSharedTooltip.call(this, coords);
        }
    };

    StockChart.prototype.bindCategories = function bindCategories () {
        Chart.prototype.bindCategories.call(this);
        this.copyNavigatorCategories();
    };

    StockChart.prototype.copyNavigatorCategories = function copyNavigatorCategories () {
        var definitions = [].concat(this.options.categoryAxis);
        var categories;

        for (var axisIx = 0; axisIx < definitions.length; axisIx++) {
            var axis = definitions[axisIx];
            if (axis.name === NAVIGATOR_AXIS) {
                categories = axis.categories;
            } else if (categories && axis.pane === NAVIGATOR_PANE) {
                axis.categories = categories;
            }
        }
    };

    StockChart.prototype.destroyNavigator = function destroyNavigator () {
        if (this.navigator) {
            this.navigator.destroy();
            this.navigator = null;
        }
    };

    StockChart.prototype.destroy = function destroy () {
        this.destroyNavigator();
        Chart.prototype.destroy.call(this);
    };

    StockChart.prototype._stopChartHandlers = function _stopChartHandlers (e) {
        var coords = this._eventCoordinates(e);
        var pane = this._plotArea.paneByPoint(coords);

        return Chart.prototype._stopChartHandlers.call(this, e) || (pane && pane.options.name === NAVIGATOR_PANE);
    };

    StockChart.prototype._toggleDragZoomEvents = function _toggleDragZoomEvents () {
        if (!this._dragZoomEnabled) {
            this.element.style.touchAction = "none";

            this._dragZoomEnabled = true;
        }
    };

    return StockChart;
}(Chart));

setDefaultOptions(StockChart, {
    dateField: "date",
    axisDefaults: {
        categoryAxis: {
            type: "date",
            baseUnit: "fit",
            justified: true
        },
        valueAxis: {
            narrowRange: true,
            labels: {
                format: "C"
            }
        }
    },
    navigator: {
        select: {},
        seriesDefaults: {
            markers: {
                visible: false
            },
            tooltip: {
                visible: false
            },
            highlight: {
                visible: false
            },
            line: {
                width: 2
            }
        },
        hint: {},
        visible: true
    },
    tooltip: {
        visible: true
    },
    legend: {
        visible: false
    }
});

var ANGULAR_SPEED = 150;
var LINEAR_SPEED = 250;
var ARROW = "arrow";
var ARROW_POINTER = "arrowPointer";
var BAR_POINTER = "barPointer";
var DEFAULT_HEIGHT = 200;
var DEFAULT_LINE_WIDTH = 0.5;
var DEFAULT_WIDTH = 200;
var DEGREE = Math.PI / 180;
var INSIDE$1 = "inside";
var LINEAR = "linear";
var OUTSIDE = "outside";
var RADIAL_POINTER = "radialPointer";
var RADIAL_RANGE_POINTER = "radialRangePointer";

function pad(bbox, value) {
    var origin = bbox.getOrigin();
    var size = bbox.getSize();
    var spacing = getSpacing(value);

    bbox.setOrigin([ origin.x - spacing.left, origin.y - spacing.top ]);
    bbox.setSize([ size.width + (spacing.left + spacing.right), size.height + (spacing.top + spacing.bottom) ]);

    return bbox;
}

var Group$7 = Group$8;
var Path$6 = Path$7;
var Text = Text$2;

function buildLabelElement(label, options) {
    var labelBox = label.box;
    var textBox = label.children[0].box;
    var border = options.border || {};
    var background = options.background || "";

    var wrapper = Path$6.fromRect(new Rect([ labelBox.x1, labelBox.y1 ], [ labelBox.width(), labelBox.height() ]), {
        stroke: {}
    });

    var text = new Text(label.text, new Point$6(textBox.x1, textBox.y1), {
        font: options.font,
        fill: { color: options.color }
    });

    var styleGeometry = pad(text.bbox().clone(), options.padding);

    var styleBox = Path$6.fromRect(styleGeometry, {
        stroke: {
            color: border.width ? border.color : "",
            width: border.width,
            opacity: border.opacity,
            dashType: border.dashType,
            lineJoin: "round",
            lineCap: "round"
        },
        fill: {
            color: background
        }
    });

    var elements = new Group$7();
    elements.append(wrapper);
    elements.append(styleBox);
    elements.append(text);

    return elements;
}

function getRange(range, min, max) {
    var from = defined(range.from) ? range.from : MIN_VALUE;
    var to = defined(range.to) ? range.to : MAX_VALUE;

    range.from = Math.max(Math.min(to, from), min);
    range.to = Math.min(Math.max(to, from), max);

    return range;
}

function unpad(bbox, value) {
    var spacing = getSpacing(value);

    spacing.left = -spacing.left; spacing.top = -spacing.top;
    spacing.right = -spacing.right; spacing.bottom = -spacing.bottom;

    return pad(bbox, spacing);
}

var DEFAULT_MARGIN = 5;
var Path$5 = Path$7;
var Surface = Surface$1;

var Gauge = (function (Class) {
    function Gauge(element, userOptions, theme, context) {
        if ( context === void 0 ) context = {};

        Class.call(this);

        this.element = element;
        this.theme = theme;
        this.contextService = new ChartService(this, context);
        this._originalOptions = deepExtend({}, this.options, userOptions);
        this.options = deepExtend({}, this._originalOptions);
        this._initTheme(theme);

        this.redraw();
    }

    if ( Class ) Gauge.__proto__ = Class;
    Gauge.prototype = Object.create( Class && Class.prototype );
    Gauge.prototype.constructor = Gauge;

    Gauge.prototype.destroy = function destroy () {
        if (this.surface) {
            this.surface.destroy();
            this.surface = null;
        }

        delete this.element;
        delete this.surfaceElement;
    };

    Gauge.prototype.value = function value (pointerValue) {
        var pointer = this.pointers[0];

        if (arguments.length === 0) {
            return pointer.value();
        }

        pointer.value(pointerValue);
        this._setValueOptions(pointerValue);
    };

    Gauge.prototype._draw = function _draw () {
        var surface = this.surface;

        surface.clear();
        surface.draw(this._visuals);
    };

    Gauge.prototype.exportVisual = function exportVisual () {
        return this._visuals;
    };

    Gauge.prototype.allValues = function allValues (values) {
        var pointers = this.pointers;
        var allValues = [];

        if (arguments.length === 0) {
            for (var i = 0; i < pointers.length; i++) {
                allValues.push(pointers[i].value());
            }

            return allValues;
        }

        if (isArray(values)) {
            for (var i$1 = 0; i$1 < values.length; i$1++) {
                if (isNumber(values[i$1])) {
                    pointers[i$1].value(values[i$1]);
                }
            }
        }

        this._setValueOptions(values);
    };

    Gauge.prototype._setValueOptions = function _setValueOptions (values) {
        var pointers = [].concat(this.options.pointer);
        var arrayValues = [].concat(values);

        for (var i = 0; i < arrayValues.length; i++) {
            pointers[i].value = arrayValues[i];
        }
    };

    Gauge.prototype.resize = function resize () {
        this.noTransitionsRedraw();
    };

    Gauge.prototype.noTransitionsRedraw = function noTransitionsRedraw () {
        var transitions = this.options.transitions;

        this._toggleTransitions(false);

        this.redraw();

        this._toggleTransitions(transitions);
    };

    Gauge.prototype.redraw = function redraw () {
        var size = this._surfaceSize();
        var wrapper = new Rect([ 0, 0 ], [ size.width, size.height ]);

        this._initSurface();

        this.gaugeArea = this._createGaugeArea();

        this._createModel();

        var bbox = unpad(wrapper.bbox(), this._gaugeAreaMargin);
        this.reflow(bbox);
    };

    Gauge.prototype.setOptions = function setOptions (options, theme) {
        this._originalOptions = deepExtend(this._originalOptions, options);
        this.options = deepExtend({}, this._originalOptions);

        this._initTheme(theme);

        this.redraw();
    };

    Gauge.prototype.setDirection = function setDirection (rtl) {
        this.contextService.rtl = Boolean(rtl);
        if (this.surface && this.surface.type === 'svg') {
            this.surface.destroy();
            this.surface = null;
        }
    };

    Gauge.prototype.setIntlService = function setIntlService (intl) {
        this.contextService.intl = intl;
    };

    Gauge.prototype._initTheme = function _initTheme (theme) {
        var currentTheme = theme || this.theme || {};
        this.theme = currentTheme;

        this.options = deepExtend({}, currentTheme, this.options);
        var options = this.options;
        var pointer = options.pointer;

        if (isArray(pointer)) {
            var pointers = [];
            for (var i = 0; i < pointer.length; i++) {
                pointers.push(deepExtend({}, currentTheme.pointer, pointer[i]));
            }
            options.pointer = pointers;
        }
    };

    Gauge.prototype._createGaugeArea = function _createGaugeArea () {
        var options = this.options.gaugeArea;
        var size = this.surface.size();
        var border = options.border || {};
        var areaGeometry = new Rect([ 0, 0 ], [ size.width, size.height ]);

        this._gaugeAreaMargin = options.margin || DEFAULT_MARGIN;

        if (border.width > 0) {
            areaGeometry = unpad(areaGeometry, border.width);
        }

        var gaugeArea = Path$5.fromRect(areaGeometry, {
            stroke: {
                color: border.width ? border.color : "",
                width: border.width,
                opacity: border.opacity,
                dashType: border.dashType,
                lineJoin: "round",
                lineCap: "round"
            },
            fill: {
                color: options.background
            }
        });

        return gaugeArea;
    };

    Gauge.prototype._initSurface = function _initSurface () {
        var ref = this;
        var options = ref.options;
        var surface = ref.surface;
        var element = this._surfaceElement();
        var size = this._surfaceSize();

        elementSize(element, size);

        if (!surface || surface.options.type !== options.renderAs) {
            if (surface) {
                surface.destroy();
            }

            this.surface = Surface.create(element, {
                type: options.renderAs
            });
        } else {
            this.surface.clear();
            this.surface.resize();
        }
    };

    Gauge.prototype._surfaceSize = function _surfaceSize () {
        var options = this.options;
        var size = this._getSize();

        if (options.gaugeArea) {
            deepExtend(size, options.gaugeArea);
        }

        return size;
    };

    Gauge.prototype._surfaceElement = function _surfaceElement () {
        if (!this.surfaceElement) {
            this.surfaceElement = document.createElement('div');
            this.element.appendChild(this.surfaceElement);
        }

        return this.surfaceElement;
    };

    Gauge.prototype.getSize = function getSize () {
        return this._getSize();
    };

    Gauge.prototype._getSize = function _getSize () {
        var element = this.element;
        var defaultSize = this._defaultSize();
        var width = element.offsetWidth;
        var height = element.offsetHeight;

        if (!width) {
            width = defaultSize.width;
        }

        if (!height) {
            height = defaultSize.height;
        }

        return { width: width, height: height };
    };

    Gauge.prototype._defaultSize = function _defaultSize () {
        return {
            width: DEFAULT_WIDTH,
            height: DEFAULT_HEIGHT
        };
    };

    Gauge.prototype._toggleTransitions = function _toggleTransitions (value) {
        var this$1$1 = this;

        this.options.transitions = value;
        for (var i = 0; i < this.pointers.length; i++) {
            this$1$1.pointers[i].options.animation.transitions = value;
        }
    };

    return Gauge;
}(Class));

setDefaultOptions(Gauge, {
    plotArea: {},
    theme: "default",
    renderAs: "",
    pointer: {},
    scale: {},
    gaugeArea: {}
});

var Path$4 = Path$7;
var Group$6 = Group$8;
var Point$4 = Point$6;

function renderAxisTick(tickRenderOptions, tickOptions) {
    var position = tickRenderOptions.position;
    var tickX = tickRenderOptions.tickX;
    var tickY = tickRenderOptions.tickY;
    var start, end;

    if (tickRenderOptions.vertical) {
        start = new Point$4(tickX, position);
        end = new Point$4(tickX + tickOptions.size, position);
    } else {
        start = new Point$4(position, tickY);
        end = new Point$4(position, tickY + tickOptions.size);
    }

    var tickPath = new Path$4({
        stroke: {
            color: tickOptions.color,
            width: tickOptions.width
        }
    }).moveTo(start).lineTo(end);

    return tickPath;
}

function renderTicks(tickGroup, tickPositions, tickRenderOptions, tickOptions) {
    var count = tickPositions.length;

    if (tickOptions.visible) {
        var mirror = tickRenderOptions.mirror;
        var lineBox = tickRenderOptions.lineBox;
        for (var i = tickOptions.skip; i < count; i += tickOptions.step) {
            if (i % tickOptions.skipUnit === 0) {
                continue;
            }

            tickRenderOptions.tickX = mirror ? lineBox.x2 : lineBox.x2 - tickOptions.size;
            tickRenderOptions.tickY = mirror ? lineBox.y1 - tickOptions.size : lineBox.y1;
            tickRenderOptions.position = tickPositions[i];

            tickGroup.append(renderAxisTick(tickRenderOptions, tickOptions));
        }
    }
}

var LinearScale = (function (NumericAxis) {
    function LinearScale(options, service) {
        var scaleOptions = options || {};
        if (!defined(scaleOptions.reverse) && scaleOptions.vertical === false && (service || {}).rtl) {
            scaleOptions = Object.assign({}, scaleOptions, {
                reverse: true
            });
        }

        NumericAxis.call(this, 0, 1, scaleOptions, service);

        this.options.minorUnit = this.options.minorUnit || this.options.majorUnit / 10;
    }

    if ( NumericAxis ) LinearScale.__proto__ = NumericAxis;
    LinearScale.prototype = Object.create( NumericAxis && NumericAxis.prototype );
    LinearScale.prototype.constructor = LinearScale;

    LinearScale.prototype.initUserOptions = function initUserOptions (options) {
        var scaleOptions = deepExtend({}, this.options, options);
        scaleOptions = deepExtend({}, scaleOptions , { labels: { mirror: scaleOptions.mirror } });
        scaleOptions.majorUnit = scaleOptions.majorUnit || autoMajorUnit(scaleOptions.min, scaleOptions.max);

        return scaleOptions;
    };

    LinearScale.prototype.initFields = function initFields () {
    };

    LinearScale.prototype.render = function render () {
        var elements = this.elements = new Group$6();
        var labels = this.renderLabels();
        var scaleLine = this.renderLine();
        var scaleTicks = this.renderTicks();
        var ranges = this.renderRanges();

        elements.append(scaleLine, labels, scaleTicks, ranges);

        return elements;
    };

    LinearScale.prototype.renderRanges = function renderRanges () {
        var this$1$1 = this;

        var options = this.options;
        var min = options.min;
        var max = options.max;
        var vertical = options.vertical;
        var mirror = options.labels.mirror;
        var ranges = options.ranges || [];
        var elements = new Group$6();
        var count = ranges.length;
        var rangeSize = options.rangeSize || options.minorTicks.size / 2;

        for (var i = 0; i < count; i++) {
            var range = getRange(ranges[i], min, max);
            var slot = this$1$1.getSlot(range.from, range.to);
            var slotX = vertical ? this$1$1.lineBox() : slot;
            var slotY = vertical ? slot : this$1$1.lineBox();
            if (vertical) {
                slotX.x1 -= rangeSize * (mirror ? -1 : 1);
            } else {
                slotY.y2 += rangeSize * (mirror ? -1 : 1);
            }

            elements.append(Path$4.fromRect(new Rect([ slotX.x1, slotY.y1 ], [ slotX.x2 - slotX.x1, slotY.y2 - slotY.y1 ]), {
                fill: { color: range.color, opacity: range.opacity },
                stroke: { }
            }));
        }

        return elements;
    };

    LinearScale.prototype.renderLabels = function renderLabels () {
        var ref = this;
        var labels = ref.labels;
        var options = ref.options;
        var elements = new Group$6();

        for (var i = 0; i < labels.length; i++) {
            elements.append(buildLabelElement(labels[i], options.labels));
        }

        return elements;
    };

    LinearScale.prototype.renderLine = function renderLine () {
        var line = this.options.line;
        var lineBox = this.lineBox();
        var elements = new Group$6();

        if (line.width > 0 && line.visible) {
            var linePath = new Path$4({
                stroke: {
                    color: line.color,
                    dashType: line.dashType,
                    width: line.width
                }
            });

            linePath.moveTo(lineBox.x1, lineBox.y1).lineTo(lineBox.x2, lineBox.y2);
            elements.append(linePath);
        }

        return elements;
    };

    LinearScale.prototype.renderTicks = function renderTicks$1 () {
        var ticks = new Group$6();
        var options = this.options;
        var majorUnit = options.majorTicks.visible ? options.majorUnit : 0;
        var tickRenderOptions = {
            vertical: options.vertical,
            mirror: options.labels.mirror,
            lineBox: this.lineBox()
        };

        renderTicks(ticks, this.getMajorTickPositions(), tickRenderOptions, options.majorTicks);
        renderTicks(ticks, this.getMinorTickPositions(), tickRenderOptions, deepExtend({}, {
            skipUnit: majorUnit / options.minorUnit
        }, options.minorTicks));

        return ticks;
    };

    return LinearScale;
}(NumericAxis));

setDefaultOptions(LinearScale, {
    min: 0,
    max: 50,

    majorTicks: {
        size: 15,
        align: INSIDE$1,
        color: BLACK$1,
        width: DEFAULT_LINE_WIDTH,
        visible: true
    },

    minorTicks: {
        size: 10,
        align: INSIDE$1,
        color: BLACK$1,
        width: DEFAULT_LINE_WIDTH,
        visible: true
    },

    line: {
        width: DEFAULT_LINE_WIDTH
    },

    labels: {
        position: INSIDE$1,
        padding: 2
    },
    mirror: false,
    _alignLines: false
});

var Pointer = (function (Class) {
    function Pointer(scale, userOptions) {
        Class.call(this);

        var ref = scale.options;
        var min = ref.min;
        var max = ref.max;
        var options = this.options = deepExtend({}, this.options, userOptions);

        options.fill = options.color;

        this.scale = scale;

        if (defined(options.value)) {
            options.value = limitValue(options.value, min, max);
        } else {
            options.value = min;
        }
    }

    if ( Class ) Pointer.__proto__ = Class;
    Pointer.prototype = Object.create( Class && Class.prototype );
    Pointer.prototype.constructor = Pointer;

    Pointer.prototype.value = function value (newValue) {
        var options = this.options;
        var value = options.value;

        if (arguments.length === 0) {
            return value;
        }

        var ref = this.scale.options;
        var min = ref.min;
        var max = ref.max;

        options._oldValue = defined(options._oldValue) ? options.value : min;
        options.value = limitValue(newValue, min, max);

        if (this.elements) {
            this.repaint();
        }
    };

    return Pointer;
}(Class));

setDefaultOptions(Pointer, {
    color: BLACK$1
});

var LinearPointer = (function (Pointer) {
    function LinearPointer(scale, options) {
        Pointer.call(this, scale, options);

        this.options = deepExtend({
            track: {
                visible: defined(options.track)
            }
        }, this.options);
    }

    if ( Pointer ) LinearPointer.__proto__ = Pointer;
    LinearPointer.prototype = Object.create( Pointer && Pointer.prototype );
    LinearPointer.prototype.constructor = LinearPointer;

    LinearPointer.prototype.reflow = function reflow () {
        var ref = this;
        var options = ref.options;
        var scale = ref.scale;
        var ref$1 = scale.options;
        var mirror = ref$1.mirror;
        var vertical = ref$1.vertical;
        var scaleLine = scale.lineBox();
        var trackSize = options.track.size || options.size;
        var pointerHalfSize = options.size / 2;
        var margin = getSpacing(options.margin);
        var space = vertical ?
            margin[mirror ? "left" : "right"] :
            margin[mirror ? "bottom" : "top"];
        var pointerBox, pointerRangeBox, trackBox;

        space = mirror ? -space : space;

        if (vertical) {
            trackBox = new Box(
                scaleLine.x1 + space, scaleLine.y1,
                scaleLine.x1 + space, scaleLine.y2);

            if (mirror) {
                trackBox.x1 -= trackSize;
            } else {
                trackBox.x2 += trackSize;
            }

            if (options.shape !== BAR_POINTER) {
                pointerRangeBox = new Box(
                    scaleLine.x2 + space, scaleLine.y1 - pointerHalfSize,
                    scaleLine.x2 + space, scaleLine.y2 + pointerHalfSize
                );
                pointerBox = pointerRangeBox;
            }
        } else {
            trackBox = new Box(
                scaleLine.x1, scaleLine.y1 - space,
                scaleLine.x2, scaleLine.y1 - space);

            if (mirror) {
                trackBox.y2 += trackSize;
            } else {
                trackBox.y1 -= trackSize;
            }

            if (options.shape !== BAR_POINTER) {
                pointerRangeBox = new Box(
                    scaleLine.x1 - pointerHalfSize, scaleLine.y1 - space,
                    scaleLine.x2 + pointerHalfSize, scaleLine.y1 - space
                );
                pointerBox = pointerRangeBox;
            }
        }

        this.trackBox = trackBox;
        this.pointerRangeBox = pointerRangeBox;
        this.box = pointerBox || trackBox.clone().pad(options.border.width);
    };

    LinearPointer.prototype.getElementOptions = function getElementOptions () {
        var options = this.options;

        return {
            fill: {
                color: options.color,
                opacity: options.opacity
            },
            stroke: defined(options.border) ? {
                color: options.border.width ? options.border.color || options.color : "",
                width: options.border.width,
                dashType: options.border.dashType,
                opacity: options.opacity
            } : null
        };
    };

    LinearPointer.prototype._margin = function _margin () {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var ref$1 = scale.options;
        var mirror = ref$1.mirror;
        var vertical = ref$1.vertical;
        var margin = getSpacing(options.margin);

        var space = vertical ?
            margin[mirror ? "left" : "right"] :
            margin[mirror ? "bottom" : "top"];

        return space;
    };

    return LinearPointer;
}(Pointer));

setDefaultOptions(LinearPointer, {
    shape: BAR_POINTER,

    track: {
        border: {
            width: 1
        }
    },

    color: BLACK$1,
    border: {
        width: 1
    },
    opacity: 1,

    margin: getSpacing(3),
    animation: {
        type: BAR_POINTER
    },
    visible: true
});

var ArrowLinearPointerAnimation = (function (superclass) {
    function ArrowLinearPointerAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) ArrowLinearPointerAnimation.__proto__ = superclass;
    ArrowLinearPointerAnimation.prototype = Object.create( superclass && superclass.prototype );
    ArrowLinearPointerAnimation.prototype.constructor = ArrowLinearPointerAnimation;

    ArrowLinearPointerAnimation.prototype.setup = function setup () {
        var options = this.options;
        var margin = options.margin;
        var from = options.from;
        var to = options.to;
        var vertical = options.vertical;
        var axis = vertical ? "x1" : "y1";

        if (options.mirror === vertical) {
            from[axis] -= margin; to[axis] -= margin;
        } else {
            from[axis] += margin; to[axis] += margin;
        }

        var fromScale = this.fromScale = new Point$6(from.x1, from.y1);
        var toScale = this.toScale = new Point$6(to.x1, to.y1);

        if (options.duration !== 0) {
            options.duration = Math.max((fromScale.distanceTo(toScale) / options.duration) * 1000, 1);
        }
    };

    ArrowLinearPointerAnimation.prototype.step = function step (pos) {
        var translateX = interpolateValue(this.fromScale.x, this.toScale.x, pos);
        var translateY = interpolateValue(this.fromScale.y, this.toScale.y, pos);

        this.element.transform(transform().translate(translateX, translateY));
    };

    return ArrowLinearPointerAnimation;
}(Animation$1));

setDefaultOptions(ArrowLinearPointerAnimation, {
    easing: LINEAR,
    duration: LINEAR_SPEED
});

AnimationFactory.current.register(ARROW_POINTER, ArrowLinearPointerAnimation);

var Point$3 = Point$6;
var Path$3 = Path$7;

var ArrowLinearPointer = (function (LinearPointer) {
    function ArrowLinearPointer(scale, options) {
        LinearPointer.call(this, scale, options);

        if (!defined(this.options.size)) {
            this.options.size = this.scale.options.majorTicks.size * 0.6;
        }
    }

    if ( LinearPointer ) ArrowLinearPointer.__proto__ = LinearPointer;
    ArrowLinearPointer.prototype = Object.create( LinearPointer && LinearPointer.prototype );
    ArrowLinearPointer.prototype.constructor = ArrowLinearPointer;

    ArrowLinearPointer.prototype.pointerShape = function pointerShape () {
        var ref = this;
        var scale = ref.scale;
        var size = ref.options.size;
        var halfSize = size / 2;
        var sign = (scale.options.mirror ? -1 : 1);
        var shape;

        if (scale.options.vertical) {
            shape = [
                new Point$3(0, 0 - halfSize), new Point$3(0 - sign * size, 0), new Point$3(0, 0 + halfSize)
            ];
        } else {
            shape = [
                new Point$3(0 - halfSize, 0), new Point$3(0, 0 + sign * size), new Point$3(0 + halfSize, 0)
            ];
        }

        return shape;
    };

    ArrowLinearPointer.prototype.repaint = function repaint () {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var animation = new ArrowLinearPointerAnimation(this.elements, deepExtend(options.animation, {
            vertical: scale.options.vertical,
            mirror: scale.options.mirror,
            margin: this._margin(options.margin),
            from: scale.getSlot(options._oldValue),
            to: scale.getSlot(options.value)
        }));

        if (options.animation.transitions === false) {
            animation.options.duration = 0;
        }

        animation.setup();
        animation.play();
    };

    ArrowLinearPointer.prototype.render = function render () {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var elementOptions = this.getElementOptions();
        var shape = this.pointerShape(options.value);

        options.animation.type = ARROW_POINTER;

        var elements = new Path$3({
            stroke: elementOptions.stroke,
            fill: elementOptions.fill
        }).moveTo(shape[0]).lineTo(shape[1]).lineTo(shape[2]).close();

        var slot = scale.getSlot(options.value);
        elements.transform(transform().translate(slot.x1, slot.y1));

        this.elements = elements;

        return elements;
    };

    return ArrowLinearPointer;
}(LinearPointer));

var BarLinearPointerAnimation = (function (superclass) {
    function BarLinearPointerAnimation () {
        superclass.apply(this, arguments);
    }

    if ( superclass ) BarLinearPointerAnimation.__proto__ = superclass;
    BarLinearPointerAnimation.prototype = Object.create( superclass && superclass.prototype );
    BarLinearPointerAnimation.prototype.constructor = BarLinearPointerAnimation;

    BarLinearPointerAnimation.prototype.setup = function setup () {
        var options = this.options;
        var axis = this.axis = options.vertical ? Y : X;
        var to = this.to = options.newPoints[0][axis];
        var from = this.from = options.oldPoints[0][axis];

        if (options.duration !== 0) {
            options.duration = Math.max((Math.abs(to - from) / options.speed) * 1000, 1);
        }

        this._set(from);
    };

    BarLinearPointerAnimation.prototype.step = function step (pos) {
        var value = interpolateValue(this.from, this.to, pos);
        this._set(value);
    };

    BarLinearPointerAnimation.prototype._set = function _set (value) {
        var setter = "set" + this.axis.toUpperCase();
        var points = this.options.newPoints;

        points[0][setter](value);
        points[1][setter](value);
    };

    return BarLinearPointerAnimation;
}(Animation$1));

setDefaultOptions(BarLinearPointerAnimation, {
    easing: LINEAR,
    speed: LINEAR_SPEED
});

AnimationFactory.current.register(BAR_POINTER, BarLinearPointerAnimation);

var Group$5 = Group$8;
var Path$2 = Path$7;

var BarLinearPointer = (function (LinearPointer) {
    function BarLinearPointer(scale, options) {
        LinearPointer.call(this, scale, options);

        if (!defined(this.options.size)) {
            this.options.size = this.scale.options.majorTicks.size * 0.3;
        }
    }

    if ( LinearPointer ) BarLinearPointer.__proto__ = LinearPointer;
    BarLinearPointer.prototype = Object.create( LinearPointer && LinearPointer.prototype );
    BarLinearPointer.prototype.constructor = BarLinearPointer;

    BarLinearPointer.prototype.pointerShape = function pointerShape (value) {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var ref$1 = scale.options;
        var mirror = ref$1.mirror;
        var vertical = ref$1.vertical;
        var dir = mirror === vertical ? -1 : 1;
        var size = options.size * dir;
        var minSlot = scale.getSlot(scale.options.min);
        var slot = scale.getSlot(value);
        var axis = vertical ? Y : X;
        var sizeAxis = vertical ? X : Y;
        var margin = this._margin() * dir;

        var p1 = new Point$6();
        p1[axis] = minSlot[axis + "1"];
        p1[sizeAxis] = minSlot[sizeAxis + "1"];

        var p2 = new Point$6();
        p2[axis] = slot[axis + "1"];
        p2[sizeAxis] = slot[sizeAxis + "1"];

        if (vertical) {
            p1.translate(margin, 0);
            p2.translate(margin, 0);
        } else {
            p1.translate(0, margin);
            p2.translate(0, margin);
        }

        var p3 = p2.clone();
        var p4 = p1.clone();

        if (vertical) {
            p3.translate(size, 0);
            p4.translate(size, 0);
        } else {
            p3.translate(0, size);
            p4.translate(0, size);
        }

        return [ p1, p2, p3, p4 ];
    };

    BarLinearPointer.prototype.repaint = function repaint () {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var shape = this.pointerShape(options.value);
        var pointerPath = this.pointerPath;
        var oldShape = this.pointerShape(options._oldValue);

        pointerPath.moveTo(shape[0]).lineTo(shape[1]).lineTo(shape[2]).lineTo(shape[3]).close();

        var animation = new BarLinearPointerAnimation(pointerPath, deepExtend(options.animation, {
            reverse: scale.options.reverse,
            vertical: scale.options.vertical,
            oldPoints: [ oldShape[1], oldShape[2] ],
            newPoints: [ shape[1], shape[2] ]
        }));

        if (options.animation.transitions === false) {
            animation.options.duration = 0;
        }

        animation.setup();
        animation.play();
    };

    BarLinearPointer.prototype.render = function render () {
        var group = new Group$5();
        var elementOptions = this.getElementOptions();

        if (this.options.track.visible) {
            group.append(this.renderTrack());
        }

        var pointer = this.pointerPath = new Path$2({
            stroke: elementOptions.stroke,
            fill: elementOptions.fill
        });

        group.append(pointer);

        this.elements = group;

        return group;
    };

    BarLinearPointer.prototype.renderTrack = function renderTrack () {
        var trackOptions = this.options.track;
        var border = trackOptions.border || {};
        var trackBox = this.trackBox.clone().pad(border.width || 0);

        return new Path$2.fromRect(trackBox.toRect(), {
            fill: {
                color: trackOptions.color,
                opacity: trackOptions.opacity
            },
            stroke: {
                color: border.width ? border.color || trackOptions.color : "",
                width: border.width,
                dashType: border.dashType
            }
        });
    };

    return BarLinearPointer;
}(LinearPointer));

var DEFAULT_MIN_WIDTH = 60;
var DEFAULT_MIN_HEIGHT = 60;

var Group$4 = Group$8;

var LinearGauge = (function (Gauge) {
    function LinearGauge () {
        Gauge.apply(this, arguments);
    }

    if ( Gauge ) LinearGauge.__proto__ = Gauge;
    LinearGauge.prototype = Object.create( Gauge && Gauge.prototype );
    LinearGauge.prototype.constructor = LinearGauge;

    LinearGauge.prototype.reflow = function reflow (bbox) {
        var pointers = this.pointers;
        var bboxX = bbox.origin.x;
        var bboxY = bbox.origin.y;

        var box = new Box(bboxX, bboxY, bboxX + bbox.width(), bboxY + bbox.height());

        this.scale.reflow(box);
        this._shrinkScaleWidth(box);

        for (var i = 0; i < pointers.length; i++) {
            pointers[i].reflow();
        }

        this.bbox = this._getBox(box);
        this._alignElements();
        this._shrinkElements();
        this._buildVisual();
        this._draw();
    };

    LinearGauge.prototype._buildVisual = function _buildVisual () {
        var visuals = new Group$4();
        var scaleElements = this.scale.render();
        var pointers = this.pointers;

        visuals.append(this.gaugeArea);
        visuals.append(scaleElements);

        for (var i = 0; i < pointers.length; i++) {
            var current = pointers[i];
            visuals.append(current.render());
            current.value(current.options.value);
        }

        this._visuals = visuals;
    };

    LinearGauge.prototype._createModel = function _createModel () {
        var this$1$1 = this;

        var options = this.options;
        var scale = this.scale = new LinearScale(options.scale, this.contextService);

        this.pointers = [];

        var pointers = options.pointer;
        pointers = isArray(pointers) ? pointers : [ pointers ];

        for (var i = 0; i < pointers.length; i++) {
            var currentOptions = deepExtend({}, pointers[i], {
                animation: {
                    transitions: options.transitions
                }
            });
            var pointerType = currentOptions.shape === ARROW ? ArrowLinearPointer : BarLinearPointer;

            this$1$1.pointers.push(new pointerType(scale, currentOptions));
        }
    };

    LinearGauge.prototype._defaultSize = function _defaultSize () {
        var vertical = this.options.scale.vertical;

        return {
            width: vertical ? DEFAULT_MIN_WIDTH : DEFAULT_WIDTH,
            height: vertical ? DEFAULT_HEIGHT : DEFAULT_MIN_HEIGHT
        };
    };

    LinearGauge.prototype._getBox = function _getBox (box) {
        var ref = this;
        var scale = ref.scale;
        var pointers = ref.pointers;
        var boxCenter = box.center();
        var plotAreaBox = pointers[0].box.clone().wrap(scale.box);

        for (var i = 0; i < pointers.length; i++) {
            plotAreaBox.wrap(pointers[i].box.clone());
        }

        var size;
        if (scale.options.vertical) {
            size = plotAreaBox.width() / 2;
            plotAreaBox = new Box(
                boxCenter.x - size, box.y1,
                boxCenter.x + size, box.y2
            );
        } else {
            size = plotAreaBox.height() / 2;
            plotAreaBox = new Box(
                box.x1, boxCenter.y - size,
                box.x2, boxCenter.y + size
            );
        }

        return plotAreaBox;
    };

    LinearGauge.prototype._alignElements = function _alignElements () {
        var this$1$1 = this;

        var ref = this;
        var scale = ref.scale;
        var pointers = ref.pointers;
        var scaleBox = scale.box;
        var box = pointers[0].box.clone().wrap(scale.box);
        var plotAreaBox = this.bbox;

        for (var i = 0; i < pointers.length; i++) {
            box.wrap(pointers[i].box.clone());
        }

        var diff;
        if (scale.options.vertical) {
            diff = plotAreaBox.center().x - box.center().x;
            scale.reflow(new Box(
                scaleBox.x1 + diff, plotAreaBox.y1,
                scaleBox.x2 + diff, plotAreaBox.y2
            ));
        } else {
            diff = plotAreaBox.center().y - box.center().y;
            scale.reflow(new Box(
                scaleBox.x1, scaleBox.y1 + diff,
                scaleBox.x2, scaleBox.y2 + diff
            ));
        }

        for (var i$1 = 0; i$1 < pointers.length; i$1++) {
            pointers[i$1].reflow(this$1$1.bbox);
        }
    };

    LinearGauge.prototype._shrinkScaleWidth = function _shrinkScaleWidth (bbox) {
        var ref = this;
        var scale = ref.scale;
        if (!scale.options.vertical) {
            var overflow = scale.contentBox().width() - bbox.width();
            if (overflow > 0) {
                scale.box.shrink(overflow, 0);
                scale.box.alignTo(bbox, 'center');
                scale.reflow(scale.box);
            }
        }
    };

    LinearGauge.prototype._shrinkElements = function _shrinkElements () {
        var this$1$1 = this;

        var ref = this;
        var scale = ref.scale;
        var pointers = ref.pointers;
        var scaleBox = scale.box.clone();
        var pos = scale.options.vertical ? "y" : "x";
        var pointerBox = pointers[0].box;

        for (var i = 0; i < pointers.length; i++) {
            pointerBox.wrap(pointers[i].box.clone());
        }

        scaleBox[pos + 1] += Math.max(scaleBox[pos + 1] - pointerBox[pos + 1], 0);
        scaleBox[pos + 2] -= Math.max(pointerBox[pos + 2] - scaleBox[pos + 2], 0);

        scale.reflow(scaleBox);

        for (var i$1 = 0; i$1 < pointers.length; i$1++) {
            pointers[i$1].reflow(this$1$1.bbox);
        }
    };

    return LinearGauge;
}(Gauge));

setDefaultOptions(LinearGauge, {
    transitions: true,
    gaugeArea: {
        background: ""
    },
    scale: {
        vertical: true
    }
});

var GEO_ARC_ADJUST_ANGLE = 180;

var Arc = Arc$2;
var Path$1 = Path$7;
var Group$3 = Group$8;

function drawTicks(arc, tickAngles, unit, tickOptions) {
    var ticks = new Group$3();
    var center = arc.center;
    var radius = arc.getRadiusX();

    if (tickOptions.visible) {
        for (var i = 0; i < tickAngles.length; i++) {
            var tickStart = arc.pointAt(tickAngles[i]);
            var tickEnd = new Point$6(center.x + radius - tickOptions.size, center.y).rotate(tickAngles[i], center);

            ticks.append(new Path$1({
                stroke: {
                    color: tickOptions.color,
                    width: tickOptions.width
                }
            }).moveTo(tickStart).lineTo(tickEnd));
        }
    }

    return ticks;
}

function rangeSegment(from, to, color, opacity) {
    return { from: from, to: to, color: color, opacity: opacity };
}

var RadialScale = (function (NumericAxis) {
    function RadialScale(options, service) {
        NumericAxis.call(this, 0, 1, options, service);
    }

    if ( NumericAxis ) RadialScale.__proto__ = NumericAxis;
    RadialScale.prototype = Object.create( NumericAxis && NumericAxis.prototype );
    RadialScale.prototype.constructor = RadialScale;

    RadialScale.prototype.initUserOptions = function initUserOptions (options) {
        var scaleOptions = deepExtend({}, this.options, options);
        scaleOptions.majorUnit = scaleOptions.majorUnit || autoMajorUnit(scaleOptions.min, scaleOptions.max);
        scaleOptions.minorUnit = scaleOptions.minorUnit || scaleOptions.majorUnit / 10;

        return scaleOptions;
    };

    RadialScale.prototype.initFields = function initFields () {
    };

    RadialScale.prototype.render = function render (center, radius) {
        var arc = this.renderArc(center, radius);

        this.bbox = arc.bbox();
        this.labelElements = this.renderLabels();
        this.ticks = this.renderTicks();
        this.ranges = this.renderRanges();
    };

    RadialScale.prototype.reflow = function reflow (bbox) {
        var center = bbox.center();
        var radius = Math.min(bbox.height(), bbox.width()) / 2;

        if (defined(this.bbox)) {
            this.bbox = this.arc.bbox();
            this.radius(this.arc.getRadiusX());
            this.repositionRanges();
            this.renderLabels();
        } else {
            return this.render(center, radius);
        }
    };

    RadialScale.prototype.slotAngle = function slotAngle (value) {
        var ref = this.options;
        var min = ref.min;
        var max = ref.max;
        var reverse = ref.reverse;
        var startAngle = ref.startAngle;
        var endAngle = ref.endAngle;
        var angle = endAngle - startAngle;
        var result;

        if (reverse) {
            result = endAngle - (value - min) / (max - min) * angle;
        } else {
            result = ((value - min) / (max - min) * angle) + startAngle;
        }

        return result + GEO_ARC_ADJUST_ANGLE;
    };

    RadialScale.prototype.hasRanges = function hasRanges () {
        var ranges = this.options.ranges;

        return ranges && ranges.length;
    };

    RadialScale.prototype.ticksSize = function ticksSize () {
        var ref = this.options;
        var majorTicks = ref.majorTicks;
        var minorTicks = ref.minorTicks;
        var size = 0;
        if (majorTicks.visible) {
            size = majorTicks.size;
        }

        if (minorTicks.visible) {
            size = Math.max(minorTicks.size, size);
        }

        return size;
    };

    RadialScale.prototype.labelsCount = function labelsCount () {
        var count = NumericAxis.prototype.labelsCount.call(this);
        var options = this.options;
        var angle = options.endAngle - options.startAngle;

        if (angle >= 360 && (options.max % options.majorUnit === 0)) {
            count -= 1;
        }

        return count;
    };

    RadialScale.prototype.renderLabels = function renderLabels () {
        var this$1$1 = this;

        var options = this.options;
        var arc = this.arc.clone();
        var radius = arc.getRadiusX();
        var tickAngles = this.tickAngles(arc, options.majorUnit);
        var rangeSize = options.rangeSize = options.rangeSize || radius * 0.1;
        var labelsGroup = new Group$3();

        var rangeDistance = radius * 0.05;
        if (defined(options.rangeDistance)) {
            rangeDistance = options.rangeDistance;
        } else {
            options.rangeDistance = rangeDistance;
        }

        var labelsOptions = options.labels;
        var isInside = labelsOptions.position === INSIDE$1;
        var hasLabelElements = defined(this.labelElements);

        if (isInside) {
            radius -= this.ticksSize();

            if (this.hasRanges() && !hasLabelElements) {
                radius -= rangeSize + rangeDistance;
            }
            arc.setRadiusX(radius).setRadiusY(radius);
        }

        var labels = this.labels;
        var count = labels.length;
        var padding = getSpacing(labelsOptions.padding);
        var paddingWidth = (padding.left + padding.right) / 2;
        var paddingHeight = (padding.top + padding.bottom) / 2;

        for (var i = 0; i < count; i++) {
            var label = labels[i];
            var halfWidth = label.box.width() / 2;
            var halfHeight = label.box.height() / 2;
            var angle = tickAngles[i];
            var labelAngle = (angle - GEO_ARC_ADJUST_ANGLE) * DEGREE;

            var lp = arc.pointAt(angle);
            var cx = lp.x + (Math.cos(labelAngle) * (halfWidth + paddingWidth) * (isInside ? 1 : -1));
            var cy = lp.y + (Math.sin(labelAngle) * (halfHeight + paddingHeight) * (isInside ? 1 : -1));

            label.reflow(new Box(cx - halfWidth, cy - halfHeight, cx + halfWidth, cy + halfHeight));
            var labelPos = new Point$6(label.box.x1, label.box.y1);

            var labelElement = (void 0);
            if (!hasLabelElements) {
                labelElement = buildLabelElement(label, options.labels);
                labelsGroup.append(labelElement);
            } else {
                labelElement = this$1$1.labelElements.children[i];
                var prevLabelPos = labelElement.bbox().origin;

                var labelTransform = labelElement.transform() || transform();
                labelTransform.translate(labelPos.x - prevLabelPos.x, labelPos.y - prevLabelPos.y);
                labelElement.transform(labelTransform);
            }

            this$1$1.bbox = Rect.union(this$1$1.bbox, labelElement.bbox());
        }

        return labelsGroup;
    };

    RadialScale.prototype.repositionRanges = function repositionRanges () {
        var ranges = this.ranges.children;

        if (ranges.length > 0) {
            var ref = this.options;
            var rangeDistance = ref.rangeDistance;
            var rangeSize = ref.rangeSize;
            var rangeRadius = this.getRangeRadius();

            if (this.options.labels.position === INSIDE$1) {
                rangeRadius += rangeSize + rangeDistance;
            }

            var newRadius = rangeRadius + (rangeSize / 2);

            for (var i = 0; i < ranges.length; i++) {
                ranges[i]._geometry.setRadiusX(newRadius).setRadiusY(newRadius);
            }

            this.bbox = Rect.union(this.bbox, this.ranges.bbox());
        }
    };

    RadialScale.prototype.renderRanges = function renderRanges () {
        var this$1$1 = this;

        var segments = this.rangeSegments();
        var segmentsCount = segments.length;
        var result = new Group$3();

        if (segmentsCount) {
            var ref = this.options;
            var rangeSize = ref.rangeSize;
            var reverse = ref.reverse;
            var rangeDistance = ref.rangeDistance;
            var rangeRadius = this.getRangeRadius();

            // move the ticks with a range distance and a range size
            this.radius(this.radius() - rangeSize - rangeDistance);

            for (var i = 0; i < segmentsCount; i++) {
                var segment = segments[i];
                var from = this$1$1.slotAngle(segment[reverse ? "to" : "from"]);
                var to = this$1$1.slotAngle(segment[!reverse ? "to" : "from"]);

                if (to - from !== 0) {
                    result.append(this$1$1.createRange(from, to, rangeRadius, segment));
                }
            }
        }

        return result;
    };

    RadialScale.prototype.createRange = function createRange (startAngle, endAngle, rangeRadius, options) {
        var rangeSize = this.options.rangeSize;
        var rangeGeom = new Arc$1(this.arc.center, {
            radiusX: rangeRadius + (rangeSize / 2),
            radiusY: rangeRadius + (rangeSize / 2),
            startAngle: startAngle,
            endAngle: endAngle
        });

        return new Arc(rangeGeom, {
            stroke: {
                width: rangeSize,
                color: options.color,
                opacity: options.opacity,
                lineCap: options.lineCap
            }
        });
    };

    RadialScale.prototype.rangeSegments = function rangeSegments () {
        var options = this.options;
        var ranges = options.ranges || [];
        var count = ranges.length;
        var segments = [];

        if (count) {
            var min = options.min;
            var max = options.max;
            var defaultColor = options.rangePlaceholderColor;
            segments.push(rangeSegment(min, max, defaultColor));

            for (var i = 0; i < count; i++) {
                var range = getRange(ranges[i], min, max);
                var segmentsCount = segments.length;

                for (var j = 0; j < segmentsCount; j++) {
                    var segment = segments[j];

                    if (segment.from <= range.from && range.from <= segment.to) {
                        segments.push(rangeSegment(range.from, range.to, range.color, range.opacity));

                        if (segment.from <= range.to && range.to <= segment.to) {
                            segments.push(rangeSegment(range.to, segment.to, defaultColor, range.opacity));
                        }

                        segment.to = range.from;

                        break;
                    }
                }
            }
        }

        return segments;
    };

    RadialScale.prototype.getRangeRadius = function getRangeRadius () {
        var ref = this;
        var arc = ref.arc;
        var options = ref.options;
        var rangeSize = options.rangeSize;
        var rangeDistance = options.rangeDistance;
        var majorTickSize = options.majorTicks.size;
        var radius;

        if (options.labels.position === OUTSIDE) {
            radius = arc.getRadiusX() - majorTickSize - rangeDistance - rangeSize;
        } else {
            radius = arc.getRadiusX() - rangeSize;
        }

        return radius;
    };

    RadialScale.prototype.renderArc = function renderArc (center, radius) {
        var options = this.options;

        var arc = this.arc = new Arc$1(center, {
            radiusX: radius,
            radiusY: radius,
            startAngle: options.startAngle + GEO_ARC_ADJUST_ANGLE,
            endAngle: options.endAngle + GEO_ARC_ADJUST_ANGLE
        });

        return arc;
    };

    RadialScale.prototype.renderTicks = function renderTicks () {
        var ref = this;
        var arc = ref.arc;
        var options = ref.options;
        var tickArc = arc.clone();

        this.majorTickAngles = this.tickAngles(arc, options.majorUnit);
        this.majorTicks = drawTicks(tickArc, this.majorTickAngles, options.majorUnit, options.majorTicks);

        var allTicks = new Group$3();
        allTicks.append(this.majorTicks);

        var majorTickSize = options.majorTicks.size;
        var minorTickSize = options.minorTicks.size;

        this._tickDifference = majorTickSize - minorTickSize;

        if (options.labels.position === OUTSIDE) {
            var radius = tickArc.getRadiusX();
            tickArc.setRadiusX(radius - majorTickSize + minorTickSize)
                .setRadiusY(radius - majorTickSize + minorTickSize);
        }

        this.minorTickAngles = this.normalizeTickAngles(this.tickAngles(arc, options.minorUnit));
        this.minorTicks = drawTicks(tickArc, this.minorTickAngles, options.minorUnit, options.minorTicks);
        allTicks.append(this.minorTicks);

        return allTicks;
    };

    RadialScale.prototype.normalizeTickAngles = function normalizeTickAngles (angles) {
        var options = this.options;
        var skip = options.majorUnit / options.minorUnit;

        for (var i = angles.length - 1; i >= 0; i--) {
            if (i % skip === 0) {
                angles.splice(i, 1);
            }
        }

        return angles;
    };

    RadialScale.prototype.tickAngles = function tickAngles (ring, stepValue) {
        var options = this.options;
        var reverse = options.reverse;
        var range = options.max - options.min;
        var angle = ring.endAngle - ring.startAngle;
        var tickCount = range / stepValue;
        var pos = ring.startAngle;
        var step = angle / tickCount;

        if (reverse) {
            pos += angle;
            step = -step;
        }

        if (angle >= 360 && (options.max % stepValue === 0)) {
            tickCount -= 1;
        }

        var positions = [];
        for (var i = 0; i < tickCount; i++) {
            positions.push(round$1(pos, COORD_PRECISION));
            pos += step;
        }

        if (round$1(pos) <= ring.endAngle) {
            positions.push(pos);
        }

        return positions;
    };

    RadialScale.prototype.radius = function radius (value) {
        if (value) {
            this.arc.setRadiusX(value).setRadiusY(value);
            this.repositionTicks(this.majorTicks.children, this.majorTickAngles);
            this.repositionTicks(this.minorTicks.children, this.minorTickAngles, true);
        } else {
            return this.arc.getRadiusX();
        }
    };

    RadialScale.prototype.repositionTicks = function repositionTicks (ticks, tickAngles, minor) {
        var diff = minor ? (this._tickDifference || 0) : 0;
        var tickArc = this.arc;
        var radius = tickArc.getRadiusX();

        if (minor && this.options.labels.position === OUTSIDE && diff !== 0) {
            tickArc = this.arc.clone();
            tickArc.setRadiusX(radius - diff).setRadiusY(radius - diff);
        }

        for (var i = 0; i < ticks.length; i++) {
            var newPoint = tickArc.pointAt(tickAngles[i]);
            var segments = ticks[i].segments;
            var xDiff = newPoint.x - segments[0].anchor().x;
            var yDiff = newPoint.y - segments[0].anchor().y;

            ticks[i].transform(new transform().translate(xDiff, yDiff));
        }
    };

    return RadialScale;
}(NumericAxis));

setDefaultOptions(RadialScale, {
    min: 0,
    max: 100,

    majorTicks: {
        size: 15,
        align: INSIDE$1,
        color: BLACK$1,
        width: DEFAULT_LINE_WIDTH,
        visible: true
    },

    minorTicks: {
        size: 10,
        align: INSIDE$1,
        color: BLACK$1,
        width: DEFAULT_LINE_WIDTH,
        visible: true
    },

    startAngle: -30,
    endAngle: 210,

    labels: {
        position: INSIDE$1,
        padding: 2
    }
});

var RadialPointerAnimation = (function (superclass) {
    function RadialPointerAnimation(element, options) {
        superclass.call(this, element, options);

        var animationOptions = this.options;

        animationOptions.duration = Math.max((Math.abs(animationOptions.newAngle - animationOptions.oldAngle) / animationOptions.duration) * 1000, 1);
    }

    if ( superclass ) RadialPointerAnimation.__proto__ = superclass;
    RadialPointerAnimation.prototype = Object.create( superclass && superclass.prototype );
    RadialPointerAnimation.prototype.constructor = RadialPointerAnimation;

    RadialPointerAnimation.prototype.step = function step (pos) {
        var options = this.options;
        var angle = interpolateValue(options.oldAngle, options.newAngle, pos);

        this.element.transform(transform().rotate(angle, options.center));
    };

    return RadialPointerAnimation;
}(Animation$1));

setDefaultOptions(RadialPointerAnimation, {
    easing: LINEAR,
    duration: ANGULAR_SPEED
});

AnimationFactory.current.register(RADIAL_POINTER, RadialPointerAnimation);

var CAP_SIZE = 0.05;
var Circle = Circle$1;
var Group$2 = Group$8;
var Path = Path$7;

var RadialPointer = (function (Pointer) {
    function RadialPointer () {
        Pointer.apply(this, arguments);
    }

    if ( Pointer ) RadialPointer.__proto__ = Pointer;
    RadialPointer.prototype = Object.create( Pointer && Pointer.prototype );
    RadialPointer.prototype.constructor = RadialPointer;

    RadialPointer.prototype.setAngle = function setAngle (angle) {
        this.elements.transform(transform().rotate(angle, this.center));
    };

    RadialPointer.prototype.repaint = function repaint () {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var oldAngle = scale.slotAngle(options._oldValue);
        var newAngle = scale.slotAngle(options.value);

        if (options.animation.transitions === false) {
            this.setAngle(newAngle);
        } else {
            new RadialPointerAnimation(this.elements, deepExtend(options.animation, {
                oldAngle: oldAngle,
                newAngle: newAngle
            })).play();
        }
    };

    RadialPointer.prototype.render = function render () {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var elements = new Group$2();

        if (options.animation !== false) {
            deepExtend(options.animation, {
                startAngle: 0,
                center: scale.arc.center,
                reverse: scale.options.reverse
            });
        }

        elements.append(this._renderNeedle(), this._renderCap());

        this.elements = elements;
        this.setAngle(DEGREE);

        return elements;
    };

    RadialPointer.prototype.reflow = function reflow (arc) {
        var center = this.center = arc.center;
        var length = limitValue(this.options.length || 1, 0.1, 1.5);
        var radius = this.radius = arc.getRadiusX() * length;
        var capSize = this.capSize = Math.round(radius * this.options.cap.size);

        this.bbox = Rect.fromPoints(new Point$6(center.x - capSize, center.y - capSize),
            new Point$6(center.x + capSize, center.y + capSize));
    };

    RadialPointer.prototype._renderNeedle = function _renderNeedle () {
        var minorTickSize = this.scale.options.minorTicks.size;
        var center = this.center;
        var needleColor = this.options.color;

        var needlePath = new Path({
            fill: { color: needleColor },
            stroke: { color: needleColor, width: DEFAULT_LINE_WIDTH }
        });

        needlePath.moveTo(center.x + this.radius - minorTickSize, center.y)
            .lineTo(center.x, center.y - (this.capSize / 2))
            .lineTo(center.x, center.y + (this.capSize / 2))
            .close();

        return needlePath;
    };

    RadialPointer.prototype._renderCap = function _renderCap () {
        var options = this.options;
        var capColor = options.cap.color || options.color;
        var circle = new Circle$2(this.center, this.capSize);

        var cap = new Circle(circle, {
            fill: { color: capColor },
            stroke: { color: capColor }
        });

        return cap;
    };

    return RadialPointer;
}(Pointer));

setDefaultOptions(RadialPointer, {
    cap: {
        size: CAP_SIZE
    },
    arrow: {
        width: 16,
        height: 14
    },
    animation: {
        type: RADIAL_POINTER,
        duration: ANGULAR_SPEED
    }
});

var Group$1 = Group$8;

var RadialGauge = (function (Gauge) {
    function RadialGauge () {
        Gauge.apply(this, arguments);
    }

    if ( Gauge ) RadialGauge.__proto__ = Gauge;
    RadialGauge.prototype = Object.create( Gauge && Gauge.prototype );
    RadialGauge.prototype.constructor = RadialGauge;

    RadialGauge.prototype.reflow = function reflow (bbox) {
        var this$1$1 = this;

        var pointers = this.pointers;
        this.scale.reflow(bbox);
        this._initialPlotArea = this.scale.bbox;

        for (var i = 0; i < pointers.length; i++) {
            pointers[i].reflow(this$1$1.scale.arc);
            this$1$1._initialPlotArea = Rect.union(this$1$1._initialPlotArea, pointers[i].bbox);
        }

        this.fitScale(bbox);
        this.alignScale(bbox);
        this._buildVisual(this.gaugeArea, pointers, this.scale);
        this._draw();
    };

    RadialGauge.prototype._buildVisual = function _buildVisual (gaugeArea, pointers, scale) {
        var visuals = this._visuals = new Group$1();

        visuals.append(gaugeArea);
        visuals.append(scale.ticks);
        visuals.append(scale.ranges);
        this._buildPointers(pointers);
        visuals.append(scale.labelElements);
    };

    RadialGauge.prototype._buildPointers = function _buildPointers (pointers) {
        var this$1$1 = this;

        for (var i = 0; i < pointers.length; i++) {
            var current = pointers[i];
            current.render();
            this$1$1._visuals.append(current.elements);

            current.value(current.options.value);
        }
    };

    RadialGauge.prototype.fitScale = function fitScale (bbox) {
        var this$1$1 = this;

        var arc = this.scale.arc;
        var plotAreaBox = this._initialPlotArea;
        var step = Math.abs(this.getDiff(plotAreaBox, bbox));
        var min = round$1(step, COORD_PRECISION);
        var max = round$1(-step, COORD_PRECISION);
        var minDiff, midDiff, maxDiff, mid, oldDiff;
        var staleFlag = 0;
        var i = 0;

        while (i++ < 100) {
            staleFlag = (oldDiff === maxDiff) ? (staleFlag + 1) : 0;

            if (staleFlag > 5) {
                break;
            }

            if (min !== mid) {
                minDiff = this$1$1.getPlotBox(min, bbox, arc);
                if (0 <= minDiff && minDiff <= 2) {
                    break;
                }
            }

            if (max !== mid) {
                maxDiff = this$1$1.getPlotBox(max, bbox, arc);
                if (0 <= maxDiff && maxDiff <= 2) {
                    break;
                }
            }

            if (minDiff > 0 && maxDiff > 0) {
                mid = min * 2;
            } else if (minDiff < 0 && maxDiff < 0) {
                mid = max * 2;
            } else {
                mid = round$1(((min + max) / 2) || 1, COORD_PRECISION);
            }

            midDiff = this$1$1.getPlotBox(mid, bbox, arc);
            if (0 <= midDiff && midDiff <= 2) {
                break;
            }

            oldDiff = maxDiff;

            if (midDiff > 0) {
                max = mid;
                maxDiff = midDiff;
            } else {
                min = mid;
                minDiff = midDiff;
            }
        }
    };

    RadialGauge.prototype.getPlotBox = function getPlotBox (step, bbox, arc) {
        var this$1$1 = this;

        var scale = this.scale;
        var pointers = this.pointers;
        var radius = arc.getRadiusX();
        var scaleArc = arc.clone();

        scaleArc.setRadiusX(radius + step).setRadiusY(radius + step);

        scale.arc = scaleArc;
        scale.reflow(bbox);
        this.plotBbox = scale.bbox;

        for (var i = 0; i < pointers.length; i++) {
            pointers[i].reflow(scaleArc);
            this$1$1.plotBbox = Rect.union(this$1$1.plotBbox, pointers[i].bbox);
        }

        return this.getDiff(this.plotBbox, bbox);
    };

    RadialGauge.prototype.getDiff = function getDiff (plotBox, box) {
        return Math.min(box.width() - plotBox.width(), box.height() - plotBox.height());
    };

    RadialGauge.prototype.alignScale = function alignScale (bbox) {
        var this$1$1 = this;

        var plotBoxCenter = this.plotBbox.center();
        var boxCenter = bbox.center();
        var paddingX = plotBoxCenter.x - boxCenter.x;
        var paddingY = plotBoxCenter.y - boxCenter.y;
        var ref = this;
        var scale = ref.scale;
        var pointers = ref.pointers;

        scale.arc.center.x -= paddingX;
        scale.arc.center.y -= paddingY;

        scale.reflow(bbox);

        for (var i = 0; i < pointers.length; i++) {
            pointers[i].reflow(scale.arc);
            this$1$1.plotBbox = Rect.union(scale.bbox, pointers[i].bbox);
        }
    };

    RadialGauge.prototype._createModel = function _createModel () {
        var this$1$1 = this;

        var options = this.options;
        var pointers = options.pointer;
        var scale = this.scale = new RadialScale(options.scale, this.contextService);

        this.pointers = [];

        var pointersArr = isArray(pointers) ? pointers : [ pointers ];
        for (var i = 0; i < pointersArr.length; i++) {
            var current = new RadialPointer(scale, deepExtend({}, pointersArr[i], {
                animation: {
                    transitions: options.transitions
                }
            }));

            this$1$1.pointers.push(current);
        }
    };

    return RadialGauge;
}(Gauge));

setDefaultOptions(RadialGauge, {
    transitions: true,
    gaugeArea: {
        background: ""
    }
});

var ArcScale = (function (RadialScale) {
    function ArcScale () {
        RadialScale.apply(this, arguments);
    }

    if ( RadialScale ) ArcScale.__proto__ = RadialScale;
    ArcScale.prototype = Object.create( RadialScale && RadialScale.prototype );
    ArcScale.prototype.constructor = ArcScale;

    ArcScale.prototype.rangeSegments = function rangeSegments () {
        var ref = this.options;
        var min = ref.min;
        var max = ref.max;
        var rangePlaceholderColor = ref.rangePlaceholderColor;
        var rangeLineCap = ref.rangeLineCap;

        return [ { from: min, to: max, color: rangePlaceholderColor, lineCap: rangeLineCap } ];
    };

    ArcScale.prototype.hasRanges = function hasRanges () {
        return true;
    };

    ArcScale.prototype.placeholderRangeAngle = function placeholderRangeAngle (angle) {
        var geometry = this.ranges.children[0].geometry();

        if (this.options.reverse) {
            geometry.setEndAngle(angle);
        } else {
            geometry.setStartAngle(angle);
        }
    };

    ArcScale.prototype.addRange = function addRange (from, to, options) {
        var reverse = this.options.reverse;

        var startAngle = this.slotAngle(reverse ? to : from);
        var endAngle = this.slotAngle(reverse ? from : to);

        var range = this.createRange(startAngle, endAngle, this.getRangeRadius(), options);

        this.ranges.append(range);

        return range;
    };

    return ArcScale;
}(RadialScale));

setDefaultOptions(ArcScale, {
    min: 0,
    max: 100,

    majorTicks: {
        visible: false
    },

    minorTicks: {
        visible: false
    },

    labels: {
        visible: false
    },

    startAngle: 0,
    endAngle: 180,
    rangeLineCap: 'round'
});

var MAX_DURATION = 800;

var RangePointerAnimation = (function (superclass) {
    function RangePointerAnimation(element, options) {
        superclass.call(this, element, options);

        var animationOptions = this.options;
        var duration = (Math.abs(animationOptions.newAngle - animationOptions.oldAngle) / animationOptions.duration) * 1000;
        animationOptions.duration = limitValue(duration, ANGULAR_SPEED, MAX_DURATION);

        var startColor = element.elements.options.get("stroke.color");
        var color = element.currentColor();
        if (startColor !== color) {
            this.startColor = new Color(startColor);
            this.color = new Color(color);
        }
    }

    if ( superclass ) RangePointerAnimation.__proto__ = superclass;
    RangePointerAnimation.prototype = Object.create( superclass && superclass.prototype );
    RangePointerAnimation.prototype.constructor = RangePointerAnimation;

    RangePointerAnimation.prototype.step = function step (pos) {
        var ref = this;
        var options = ref.options;
        var startColor = ref.startColor;
        var color = ref.color;
        var angle = interpolateValue(options.oldAngle, options.newAngle, pos);
        this.element.angle(angle);

        if (color) {
            var r = round$1(interpolateValue(startColor.r, color.r, pos));
            var g = round$1(interpolateValue(startColor.g, color.g, pos));
            var b = round$1(interpolateValue(startColor.b, color.b, pos));

            this.element.stroke(new Color(r, g, b).toHex());
        }
    };

    return RangePointerAnimation;
}(Animation$1));

setDefaultOptions(RangePointerAnimation, {
    easing: LINEAR,
    duration: ANGULAR_SPEED
});

AnimationFactory.current.register(RADIAL_RANGE_POINTER, RangePointerAnimation);

var RangePointer = (function (Pointer) {
    function RangePointer () {
        Pointer.apply(this, arguments);
    }

    if ( Pointer ) RangePointer.__proto__ = Pointer;
    RangePointer.prototype = Object.create( Pointer && Pointer.prototype );
    RangePointer.prototype.constructor = RangePointer;

    RangePointer.prototype.repaint = function repaint () {
        var ref = this;
        var scale = ref.scale;
        var options = ref.options;
        var oldAngle = scale.slotAngle(options._oldValue);
        var newAngle = scale.slotAngle(options.value);

        if (this.animation) {
            this.animation.abort();
        }

        if (options.animation.transitions === false) {
            this.angle(newAngle);
            this.stroke(this.currentColor());
        } else {
            this.animation = new RangePointerAnimation(this, deepExtend(options.animation, {
                oldAngle: oldAngle,
                newAngle: newAngle
            }));

            this.animation.play();
        }
    };

    RangePointer.prototype.angle = function angle (value) {
        var geometry = this.elements.geometry();
        if (this.scale.options.reverse) {
            geometry.setStartAngle(value);
        } else {
            geometry.setEndAngle(value);
        }
        this.scale.placeholderRangeAngle(value);
    };

    RangePointer.prototype.stroke = function stroke (value) {
        this.elements.stroke(value);
    };

    RangePointer.prototype.render = function render () {
        if (this.elements) {
            return;
        }

        var ref = this;
        var scale = ref.scale;
        var options = ref.options;

        if (options.animation !== false) {
            deepExtend(options.animation, {
                startAngle: 0,
                center: scale.arc.center,
                reverse: scale.options.reverse
            });
        }

        this.elements = scale.addRange(scale.options.min, this.options.value, {
            color: this.currentColor(),
            opacity: options.opacity,
            lineCap: scale.options.rangeLineCap
        });
    };

    RangePointer.prototype.currentColor = function currentColor () {
        var ref = this.scale.options;
        var min = ref.min;
        var max = ref.max;
        var ref$1 = this.options;
        var colors = ref$1.colors;
        var color = ref$1.color;
        var value = ref$1.value;
        var currentValue = isNumber(value) ? value : min;

        if (colors) {
            for (var idx = 0; idx < colors.length; idx++) {
                var ref$2 = colors[idx];
                var rangeColor = ref$2.color;
                var from = ref$2.from; if ( from === void 0 ) from = min;
                var to = ref$2.to; if ( to === void 0 ) to = max;

                if (from <= currentValue && currentValue <= to) {
                    return rangeColor;
                }
            }
        }

        return color;
    };

    RangePointer.prototype.reflow = function reflow () {
        this.render();

        this.bbox = this.elements.bbox();
    };

    return RangePointer;
}(Pointer));

setDefaultOptions(RangePointer, {
    animation: {
        type: RADIAL_RANGE_POINTER,
        duration: ANGULAR_SPEED
    }
});

var ArcGauge = (function (RadialGauge) {
    function ArcGauge () {
        RadialGauge.apply(this, arguments);
    }

    if ( RadialGauge ) ArcGauge.__proto__ = RadialGauge;
    ArcGauge.prototype = Object.create( RadialGauge && RadialGauge.prototype );
    ArcGauge.prototype.constructor = ArcGauge;

    ArcGauge.prototype._initTheme = function _initTheme (theme) {
        RadialGauge.prototype._initTheme.call(this, theme);

        this.options.color = this.options.color || (this.theme.pointer || {}).color;
    };

    ArcGauge.prototype._createModel = function _createModel () {
        var options = this.options;
        var scale = this.scale = new ArcScale(options.scale, this.contextService);

        var pointer = new RangePointer(scale, deepExtend({}, {
            colors: options.colors,
            color: options.color,
            value: options.value,
            opacity: options.opacity,
            animation: {
                transitions: options.transitions
            }
        }));

        this.pointers = [ pointer ];
    };

    ArcGauge.prototype._buildPointers = function _buildPointers (pointers) {
        for (var i = 0; i < pointers.length; i++) {
            var current = pointers[i];
            current.render();

            current.value(current.options.value);
        }
    };

    ArcGauge.prototype._setValueOptions = function _setValueOptions (value) {
        this.options.value = value;
    };

    ArcGauge.prototype.currentColor = function currentColor () {
        var pointer = this.pointers[0];
        if (pointer) {
            return pointer.currentColor();
        }
    };

    ArcGauge.prototype.centerLabelPosition = function centerLabelPosition (width, height) {
        var size = this.getSize();
        var center = this.scale.arc.center;

        var left = center.x - width / 2;
        var top = center.y - height / 2;

        if (width < size.width) {
            var right = left + width;

            left = Math.max(left, 0);

            if (right > size.width) {
                left -= right - size.width;
            }
        }

        if (height < size.height) {
            var bbox = this.scale.bbox;
            var yLimit = bbox.bottomRight().y;
            var bottom = top + height;

            top = Math.max(top, bbox.origin.y);

            if (bottom > yLimit) {
                top -= bottom - yLimit;
            }
        }

        return {
            left: left,
            top: top
        };
    };

    return ArcGauge;
}(RadialGauge));

var defaultStartAngle = 90;

var CircularGauge = (function (ArcGauge) {
    function CircularGauge () {
        ArcGauge.apply(this, arguments);
    }

    if ( ArcGauge ) CircularGauge.__proto__ = ArcGauge;
    CircularGauge.prototype = Object.create( ArcGauge && ArcGauge.prototype );
    CircularGauge.prototype.constructor = CircularGauge;

    CircularGauge.prototype._createModel = function _createModel () {
        var scaleOptions = this.options.scale;
        if (typeof scaleOptions.startAngle !== 'number') {
            scaleOptions.startAngle = defaultStartAngle;
        }

        scaleOptions.endAngle = scaleOptions.startAngle + 360;

        ArcGauge.prototype._createModel.call(this);
    };

    return CircularGauge;
}(ArcGauge));

var DEFAULT_QUIET_ZONE_LENGTH = 10;

var Encoding = (function (Class) {
    function Encoding(options) {
        Class.call(this);
        this.setOptions(options);
        this.initProperties();
    }

    if ( Class ) Encoding.__proto__ = Class;
    Encoding.prototype = Object.create( Class && Class.prototype );
    Encoding.prototype.constructor = Encoding;

    Encoding.prototype.initProperties = function initProperties () { };

    Encoding.prototype.setOptions = function setOptions (options) {
        this.options = Object.assign({}, this.options, options);
        this.quietZoneLength = this.options.addQuietZone ? 2 * this.options.quietZoneLength : 0;
    };

    Encoding.prototype.encode = function encode (value, width, height) {
        var convertedValue = defined(value) ? String(value) : value;

        this.initValue(convertedValue, width, height);

        if (this.options.addQuietZone) {
            this.addQuietZone();
        }

        this.addData();

        if (this.options.addQuietZone) {
            this.addQuietZone();
        }

        return {
            baseUnit: this.baseUnit,
            pattern: this.pattern
        };
    };

    Encoding.prototype.initValue = function initValue () { };

    Encoding.prototype.addQuietZone = function addQuietZone () {
        this.pattern.push(this.options.quietZoneLength || DEFAULT_QUIET_ZONE_LENGTH);
    };

    Encoding.prototype.addData = function addData () { };

    Encoding.prototype.invalidCharacterError = function invalidCharacterError (character) {
        throw new Error(("Character \"" + character + "\" is not valid for symbology " + (this.name) + "."));
    };

    return Encoding;
}(Class));

setDefaultOptions(Encoding, {
    quietZoneLength: DEFAULT_QUIET_ZONE_LENGTH,
    addQuietZone: true,
    addCheckSum: true
});

var extend$d = Object.assign;

var Code11 = (function (Encoding) {
    function Code11 () {
        Encoding.apply(this, arguments);
    }

    if ( Encoding ) Code11.__proto__ = Encoding;
    Code11.prototype = Object.create( Encoding && Encoding.prototype );
    Code11.prototype.constructor = Code11;

    Code11.prototype.initProperties = function initProperties () {
        Encoding.prototype.initProperties.call(this);

        extend$d(this, {
            name: "Code 11",
            characterMap: ["111121", "211121", "121121", "221111", "112121", "212111", "122111", "111221", "211211", "211111", "112111"],
            cCheckSumTotal: 10,
            kCheckSumTotal: 9,
            kCheckSumMinLength: 10,
            checkSumMod: 11,
            DASH_VALUE: 10,
            DASH: "-",
            START: "112211",
            STOP: "11221"
        });
    };

    Code11.prototype.initValue = function initValue (value, width) {
        this.pattern = [];
        this.value = value;
        this.width = width;
        this.totalUnits = 0;
    };

    Code11.prototype.addData = function addData () {
        var this$1$1 = this;

        var value = this.value;

        this.addPattern(this.START);

        for (var i = 0; i < value.length; i++) {
            this$1$1.addCharacter(value.charAt(i));
        }

        if (this.options.addCheckSum) {
            this.addCheckSum();
        }

        this.addPattern(this.STOP);
        this.setBaseUnit();
    };

    Code11.prototype.setBaseUnit = function setBaseUnit () {
        this.baseUnit = this.width / (this.totalUnits + this.quietZoneLength);
    };

    Code11.prototype.addCheckSum = function addCheckSum () {
        var value = this.value;
        var length = value.length;
        var cValue = this.getWeightedSum(value, length, this.cCheckSumTotal) % this.checkSumMod;

        this.checksum = String(cValue);
        this.addPattern(this.characterMap[cValue]);

        length++;

        if (length >= this.kCheckSumMinLength) {
            var kValue = (cValue + this.getWeightedSum(value, length, this.kCheckSumTotal)) % this.checkSumMod;
            this.checksum += kValue;
            this.addPattern(this.characterMap[kValue]);
        }
    };

    Code11.prototype.getWeightedSum = function getWeightedSum (value, length, total) {
        var this$1$1 = this;

        var weightedSum = 0;

        for (var i = 0; i < value.length; i++) {
            weightedSum += this$1$1.weightedValue(this$1$1.getValue(value.charAt(i)), length, i, total);
        }

        return weightedSum;
    };

    Code11.prototype.weightedValue = function weightedValue (value, length, index, total) {
        var weight = (length - index) % total || total;
        return weight * value;
    };

    Code11.prototype.getValue = function getValue (character) {
        if (!isNaN(character)) {
            return parseInt(character, 10);
        } else if (character !== this.DASH) {
            this.invalidCharacterError(character);
        }

        return this.DASH_VALUE;
    };

    Code11.prototype.addCharacter = function addCharacter (character) {
        var value = this.getValue(character);
        var pattern = this.characterMap[value];

        this.addPattern(pattern);
    };

    Code11.prototype.addPattern = function addPattern (pattern) {
        var this$1$1 = this;

        var value;

        for (var i = 0; i < pattern.length; i++) {
            value = parseInt(pattern.charAt(i), 10);
            this$1$1.pattern.push(value);
            this$1$1.totalUnits += value;
        }
    };

    return Code11;
}(Encoding));

setDefaultOptions(Code11, {
    addCheckSum: true
});

var extend$c = Object.assign;

var Code39Base = (function (Encoding) {
    function Code39Base () {
        Encoding.apply(this, arguments);
    }

    if ( Encoding ) Code39Base.__proto__ = Encoding;
    Code39Base.prototype = Object.create( Encoding && Encoding.prototype );
    Code39Base.prototype.constructor = Code39Base;

    Code39Base.prototype.initProperties = function initProperties () {
        Encoding.prototype.initProperties.call(this);

        extend$c(this, {
            minBaseUnitLength: 0.7
        });
    };

    Code39Base.prototype.addData = function addData () {
        var this$1$1 = this;

        var value = this.value;

        this.addStart();

        for (var idx = 0; idx < value.length; idx++) {
            this$1$1.addCharacter(value.charAt(idx));
        }

        if (this.options.addCheckSum) {
            this.pushCheckSum();
        }

        this.addStop();
        this.prepareValues();
    };

    Code39Base.prototype.addCharacter = function addCharacter (character) {
        var characterData = this.characterMap[character];

        if (!characterData) {
            this.invalidCharacterError(character);
        }

        this.addBase(characterData);
    };

    Code39Base.prototype.addBase = function addBase () { };

    return Code39Base;
}(Encoding));

var Code39 = (function (Code39Base) {
    function Code39 () {
        Code39Base.apply(this, arguments);
    }

    if ( Code39Base ) Code39.__proto__ = Code39Base;
    Code39.prototype = Object.create( Code39Base && Code39Base.prototype );
    Code39.prototype.constructor = Code39;

    Code39.prototype.initProperties = function initProperties () {
        Code39Base.prototype.initProperties.call(this);

        extend$c(this, {
            name: "Code 39",
            checkSumMod: 43,
            minRatio: 2.5,
            maxRatio: 3,
            gapWidth: 1,
            splitCharacter: "|",
            patternMappings: {
                "b": "1|",
                "w": "1|",
                "B": "ratio|",
                "W": "ratio|"
            },
            characterMap: {
                "0": { "pattern": "bwbWBwBwb", "value": 0 },
                "1": { "pattern": "BwbWbwbwB", "value": 1 },
                "2": { "pattern": "bwBWbwbwB", "value": 2 },
                "3": { "pattern": "BwBWbwbwb", "value": 3 },
                "4": { "pattern": "bwbWBwbwB", "value": 4 },
                "5": { "pattern": "BwbWBwbwb", "value": 5 },
                "6": { "pattern": "bwBWBwbwb", "value": 6 },
                "7": { "pattern": "bwbWbwBwB", "value": 7 },
                "8": { "pattern": "BwbWbwBwb", "value": 8 },
                "9": { "pattern": "bwBWbwBwb", "value": 9 },
                "A": { "pattern": "BwbwbWbwB", "value": 10 },
                "B": { "pattern": "bwBwbWbwB", "value": 11 },
                "C": { "pattern": "BwBwbWbwb", "value": 12 },
                "D": { "pattern": "bwbwBWbwB", "value": 13 },
                "E": { "pattern": "BwbwBWbwb", "value": 14 },
                "F": { "pattern": "bwBwBWbwb", "value": 15 },
                "G": { "pattern": "bwbwbWBwB", "value": 16 },
                "H": { "pattern": "BwbwbWBwb", "value": 17 },
                "I": { "pattern": "bwBwbWBwb", "value": 18 },
                "J": { "pattern": "bwbwBWBwb", "value": 19 },
                "K": { "pattern": "BwbwbwbWB", "value": 20 },
                "L": { "pattern": "bwBwbwbWB", "value": 21 },
                "M": { "pattern": "BwBwbwbWb", "value": 22 },
                "N": { "pattern": "bwbwBwbWB", "value": 23 },
                "O": { "pattern": "BwbwBwbWb", "value": 24 },
                "P": { "pattern": "bwBwBwbWb", "value": 25 },
                "Q": { "pattern": "bwbwbwBWB", "value": 26 },
                "R": { "pattern": "BwbwbwBWb", "value": 27 },
                "S": { "pattern": "bwBwbwBWb", "value": 28 },
                "T": { "pattern": "bwbwBwBWb", "value": 29 },
                "U": { "pattern": "BWbwbwbwB", "value": 30 },
                "V": { "pattern": "bWBwbwbwB", "value": 31 },
                "W": { "pattern": "BWBwbwbwb", "value": 32 },
                "X": { "pattern": "bWbwBwbwB", "value": 33 },
                "Y": { "pattern": "BWbwBwbwb", "value": 34 },
                "Z": { "pattern": "bWBwBwbwb", "value": 35 },
                "-": { "pattern": "bWbwbwBwB", "value": 36 },
                ".": { "pattern": "BWbwbwBwb", "value": 37 },
                " ": { "pattern": "bWBwbwBwb", "value": 38 },
                "$": { "pattern": "bWbWbWbwb", "value": 39 },
                "/": { "pattern": "bWbWbwbWb", "value": 40 },
                "+": { "pattern": "bWbwbWbWb", "value": 41 },
                "%": { "pattern": "bwbWbWbWb", "value": 42 },
                START: { pattern: "bWbwBwBwb" }
            }
        });
    };

    Code39.prototype.initValue = function initValue (value, width, height) {
        this.width = width;
        this.height = height;
        this.value = value;
        this.dataLength = value.length;
        this.pattern = [];
        this.patternString = "";
    };

    Code39.prototype.prepareValues = function prepareValues () {
        var this$1$1 = this;

        var minBaseUnit = this.minBaseUnitLength;
        var minRatio = this.minRatio;
        var minHeight = Math.ceil(Math.max(0.15 * this.width, 24));
        var baseUnit;
        var ratio = this.maxRatio;

        if (this.height < minHeight) {
            throw new Error(("Insufficient height for Code39 encoding: the current height is " + (this.height) + "px and the minimum height is " + minHeight + "px."));
        }

        baseUnit = this.getBaseUnit(ratio);

        while (baseUnit < minBaseUnit && ratio > minRatio) {
            ratio = parseFloat((ratio - 0.1).toFixed(1));
            baseUnit = this$1$1.getBaseUnit(ratio);
        }

        if (baseUnit < minBaseUnit) {
            var minWidth = Math.ceil(this.getBaseWidth(minRatio) * minBaseUnit);
            throw new Error(("Insufficient width for Code39 encoding: the current width is " + (this.width) + "px and the minimum width for value \"" + (this.value) + "\" is " + minWidth + "px."));
        }

        this.ratio = ratio;
        this.baseUnit = baseUnit;
        this.patternString = this.patternString.substring(0, this.patternString.length - 1);
        this.pattern = this.pattern.concat(this.patternString.replace(/ratio/g, ratio).split(this.splitCharacter));
    };

    Code39.prototype.getBaseUnit = function getBaseUnit (ratio) {
        return this.width / this.getBaseWidth(ratio);
    };

    Code39.prototype.getBaseWidth = function getBaseWidth (ratio) {
        var characterLength = 3 * (ratio + 2);
        return this.quietZoneLength + characterLength * (this.dataLength + 2) + this.gapWidth * (this.dataLength + 1);
    };

    Code39.prototype.addStart = function addStart () {
        this.addPattern(this.characterMap.START.pattern);
        this.addCharacterGap();
    };

    Code39.prototype.addBase = function addBase (character) {
        this.addPattern(character.pattern);
        this.addCharacterGap();
    };

    Code39.prototype.addStop = function addStop () {
        this.addPattern(this.characterMap.START.pattern);
    };

    Code39.prototype.addPattern = function addPattern (pattern) {
        var this$1$1 = this;

        for (var i = 0; i < pattern.length; i++) {
            this$1$1.patternString += this$1$1.patternMappings[pattern.charAt(i)];
        }
    };

    Code39.prototype.addCharacterGap = function addCharacterGap () {
        this.patternString += this.gapWidth + this.splitCharacter;
    };

    return Code39;
}(Code39Base));

setDefaultOptions(Code39, {
    addCheckSum: false
});

var Code39ExtendedBase = {
    addCharacter: function addCharacter(character) {
        if (this.characterMap[character]) {
            this.addBase(this.characterMap[character]);
        } else if (character.charCodeAt(0) > 127) {
            this.invalidCharacterError(character);
        } else {
            this.addExtended(character.charCodeAt(0));
        }
    },

    addExtended: function addExtended(code) {
        var this$1$1 = this;

        var patterns;

        for (var i = 0; i < this.extendedMappings.length; i++) {
            patterns = this$1$1.extendedMappings[i].call(this$1$1, code);

            if (patterns) {
                for (var patternIndex = 0; patternIndex < patterns.length; patternIndex++) {
                    var pattern = patterns[patternIndex];
                    this$1$1.addBase(pattern);
                }

                this$1$1.dataLength += patterns.length - 1;
                return;
            }
        }
    },

    extendedMappings: [
        function(code) {
            if (97 <= code && code <= 122) {
                return [this.characterMap[this.shiftCharacters[0]], this.characterMap[String.fromCharCode(code - 32)]];
            }
        },
        function(code) {
            if (33 <= code && code <= 58) {
                return [this.characterMap[this.shiftCharacters[1]], this.characterMap[String.fromCharCode(code + 32)]];
            }
        },
        function(code) {
            if (1 <= code && code <= 26) {
                return [this.characterMap[this.shiftCharacters[2]], this.characterMap[String.fromCharCode(code + 64)]];
            }
        },
        function(code) {
            var this$1$1 = this;

            var result;
            var dataCharacter;

            if (!this.specialAsciiCodes[code]) {
                dataCharacter = Math.floor(code / 32) * 6 + (code - 27) % 32 + 64;
                result = [this.characterMap[this.shiftCharacters[3]], this.characterMap[String.fromCharCode(dataCharacter)]];
            } else {
                result = [];

                for (var i = 0; i < this.specialAsciiCodes[code].length; i++) {
                    result.push(this$1$1.characterMap[this$1$1.shiftCharacters[3]]);
                    result.push(this$1$1.characterMap[this$1$1.specialAsciiCodes[code][i]]);
                }
            }

            return result;
        }
    ],
    specialAsciiCodes: {
        "0": ["U"],
        "64": ["V"],
        "96": ["W"],
        "127": ["T", "X", "Y", "Z"]
    },
    shiftValuesAsciiCodes: {
        "39": 36,
        "40": 47,
        "41": 43,
        "42": 37
    },
    characterMap: {
        "+": false,
        "/": false,
        "$": false,
        "%": false
    },
    shiftCharacters: ["SHIFT0", "SHIFT1", "SHIFT2", "SHIFT3"]
};

var Code39Extended = (function (Code39) {
    function Code39Extended () {
        Code39.apply(this, arguments);
    }

    if ( Code39 ) Code39Extended.__proto__ = Code39;
    Code39Extended.prototype = Object.create( Code39 && Code39.prototype );
    Code39Extended.prototype.constructor = Code39Extended;

    Code39Extended.prototype.initProperties = function initProperties () {
        Code39.prototype.initProperties.call(this);

        deepExtend(this, Code39ExtendedBase, {
            name: "Code 39 extended",
            characterMap: {
                SHIFT0: { "pattern": "bWbwbWbWb", "value": 41 },
                SHIFT1: { "pattern": "bWbWbwbWb", "value": 40 },
                SHIFT2: { "pattern": "bWbWbWbwb", "value": 39 },
                SHIFT3: { "pattern": "bwbWbWbWb", "value": 42 }
            }
        });
    };

    return Code39Extended;
}(Code39));

var extend$b = Object.assign;

var Code93 = (function (Code39Base) {
    function Code93 () {
        Code39Base.apply(this, arguments);
    }

    if ( Code39Base ) Code93.__proto__ = Code39Base;
    Code93.prototype = Object.create( Code39Base && Code39Base.prototype );
    Code93.prototype.constructor = Code93;

    Code93.prototype.initProperties = function initProperties () {
        Code39Base.prototype.initProperties.call(this);

        extend$b(this, {
            name: "Code 93",
            cCheckSumTotal: 20,
            kCheckSumTotal: 15,
            checkSumMod: 47,
            characterMap: {
                "0": { "pattern": "131112", "value": 0 },
                "1": { "pattern": "111213", "value": 1 },
                "2": { "pattern": "111312", "value": 2 },
                "3": { "pattern": "111411", "value": 3 },
                "4": { "pattern": "121113", "value": 4 },
                "5": { "pattern": "121212", "value": 5 },
                "6": { "pattern": "121311", "value": 6 },
                "7": { "pattern": "111114", "value": 7 },
                "8": { "pattern": "131211", "value": 8 },
                "9": { "pattern": "141111", "value": 9 },
                "A": { "pattern": "211113", "value": 10 },
                "B": { "pattern": "211212", "value": 11 },
                "C": { "pattern": "211311", "value": 12 },
                "D": { "pattern": "221112", "value": 13 },
                "E": { "pattern": "221211", "value": 14 },
                "F": { "pattern": "231111", "value": 15 },
                "G": { "pattern": "112113", "value": 16 },
                "H": { "pattern": "112212", "value": 17 },
                "I": { "pattern": "112311", "value": 18 },
                "J": { "pattern": "122112", "value": 19 },
                "K": { "pattern": "132111", "value": 20 },
                "L": { "pattern": "111123", "value": 21 },
                "M": { "pattern": "111222", "value": 22 },
                "N": { "pattern": "111321", "value": 23 },
                "O": { "pattern": "121122", "value": 24 },
                "P": { "pattern": "131121", "value": 25 },
                "Q": { "pattern": "212112", "value": 26 },
                "R": { "pattern": "212211", "value": 27 },
                "S": { "pattern": "211122", "value": 28 },
                "T": { "pattern": "211221", "value": 29 },
                "U": { "pattern": "221121", "value": 30 },
                "V": { "pattern": "222111", "value": 31 },
                "W": { "pattern": "112122", "value": 32 },
                "X": { "pattern": "112221", "value": 33 },
                "Y": { "pattern": "122121", "value": 34 },
                "Z": { "pattern": "123111", "value": 35 },
                "-": { "pattern": "121131", "value": 36 },
                ".": { "pattern": "311112", "value": 37 },
                " ": { "pattern": "311211", "value": 38 },
                "$": { "pattern": "321111", "value": 39 },
                "/": { "pattern": "112131", "value": 40 },
                "+": { "pattern": "113121", "value": 41 },
                "%": { "pattern": "211131", "value": 42 },
                SHIFT0: { "pattern": "122211", "value": 46 },
                SHIFT1: { "pattern": "311121", "value": 45 },
                SHIFT2: { "pattern": "121221", "value": 43 },
                SHIFT3: { "pattern": "312111", "value": 44 },
                START: { "pattern": "111141" },
                TERMINATION_BAR: "1"
            }
        });
    };

    Code93.prototype.initValue = function initValue (value, width, height) {
        this.value = value;
        this.width = width;
        this.height = height;
        this.pattern = [];
        this.values = [];
        this.dataLength = value.length;
    };

    Code93.prototype.prepareValues = function prepareValues () {
        var minHeight = Math.ceil(Math.max(0.15 * this.width, 24));

        if (this.height < minHeight) {
            throw new Error(("Insufficient height for Code93 encoding: the current height is " + (this.height) + "px, the minimum required height is " + minHeight + "px."));
        }

        this.setBaseUnit();

        if (this.baseUnit < this.minBaseUnitLength) {
            var minWidth = Math.ceil(this.minBaseUnitLength * (this.width / this.baseUnit));
            throw new Error(("Insufficient width for Code93 encoding: the current width is " + (this.width) + "px and the minimum required width for value \"" + (this.value) + "\" is " + minWidth + "px."));
        }
    };

    Code93.prototype.setBaseUnit = function setBaseUnit () {
        var checkSumLength = 2;

        this.baseUnit = this.width / (9 * (this.dataLength + 2 + checkSumLength) + this.quietZoneLength + 1);
    };

    Code93.prototype.addStart = function addStart () {
        var pattern = this.characterMap.START.pattern;
        this.addPattern(pattern);
    };

    Code93.prototype.addStop = function addStop () {
        this.addStart();
        this.pattern.push(this.characterMap.TERMINATION_BAR);
    };

    Code93.prototype.addBase = function addBase (charData) {
        this.addPattern(charData.pattern);
        this.values.push(charData.value);
    };

    Code93.prototype.pushCheckSum = function pushCheckSum () {
        var this$1$1 = this;

        var checkValues = this._getCheckValues();
        var charData;

        this.checksum = checkValues.join("");

        for (var i = 0; i < checkValues.length; i++) {
            charData = this$1$1.characterMap[this$1$1._findCharacterByValue(checkValues[i])];
            this$1$1.addPattern(charData.pattern);
        }
    };

    Code93.prototype._getCheckValues = function _getCheckValues () {
        var this$1$1 = this;

        var values = this.values;
        var length = values.length;
        var wightedSum = 0;
        var cValue;
        var kValue;
        var idx;

        for (idx = length - 1; idx >= 0; idx--) {
            wightedSum += this$1$1.weightedValue(values[idx], length - idx, this$1$1.cCheckSumTotal);
        }

        cValue = wightedSum % this.checkSumMod;

        wightedSum = this.weightedValue(cValue, 1, this.kCheckSumTotal);

        for (idx = length - 1; idx >= 0; idx--) {
            wightedSum += this$1$1.weightedValue(values[idx], length - idx + 1, this$1$1.kCheckSumTotal);
        }

        kValue = wightedSum % this.checkSumMod;
        return [cValue, kValue];
    };

    Code93.prototype._findCharacterByValue = function _findCharacterByValue (value) {
        var this$1$1 = this;

        for (var character in this$1$1.characterMap) {
            if (this$1$1.characterMap[character].value === value) {
                return character;
            }
        }
    };

    Code93.prototype.weightedValue = function weightedValue (value, index, total) {
        return (index % total || total) * value;
    };

    Code93.prototype.addPattern = function addPattern (pattern) {
        var this$1$1 = this;

        var value;

        for (var i = 0; i < pattern.length; i++) {
            value = parseInt(pattern.charAt(i), 10);
            this$1$1.pattern.push(value);
        }
    };

    return Code93;
}(Code39Base));

var Code93Extended = (function (Code93) {
    function Code93Extended () {
        Code93.apply(this, arguments);
    }

    if ( Code93 ) Code93Extended.__proto__ = Code93;
    Code93Extended.prototype = Object.create( Code93 && Code93.prototype );
    Code93Extended.prototype.constructor = Code93Extended;

    Code93Extended.prototype.initProperties = function initProperties () {
        Code93.prototype.initProperties.call(this);

        deepExtend(this, Code39ExtendedBase, {
            name: "Code 93 extended",
            pushCheckSum: function() {
                var this$1$1 = this;

                var checkValues = this._getCheckValues();
                var value;

                this.checksum = checkValues.join("");

                for (var i = 0; i < checkValues.length; i++) {
                    value = checkValues[i];

                    if (this$1$1.shiftValuesAsciiCodes[value]) {
                        this$1$1.addExtended(this$1$1.shiftValuesAsciiCodes[value]);
                    } else {
                        var characterByValue = this$1$1._findCharacterByValue(value);
                        this$1$1.addPattern(this$1$1.characterMap[characterByValue].pattern);
                    }
                }
            }
        });
    };

    return Code93Extended;
}(Code93));

var numberRegex$2 = /^\d+$/;
var extend$a = Object.assign;

var Postnet = (function (Encoding) {
    function Postnet () {
        Encoding.apply(this, arguments);
    }

    if ( Encoding ) Postnet.__proto__ = Encoding;
    Postnet.prototype = Object.create( Encoding && Encoding.prototype );
    Postnet.prototype.constructor = Postnet;

    Postnet.prototype.initProperties = function initProperties () {
        Encoding.prototype.initProperties.call(this);

        extend$a(this, {
            name: "Postnet",
            START: "2",
            VALID_CODE_LENGTHS: [5, 9, 11],
            DIGIT_SEPARATOR: "-",
            characterMap: ["22111", "11122", "11212", "11221", "12112", "12121", "12211", "21112", "21121", "21211"]
        });
    };

    Postnet.prototype.initValue = function initValue (value, width, height) {
        this.height = height;
        this.width = width;
        this.baseHeight = height / 2;
        this.value = value.replace(new RegExp(this.DIGIT_SEPARATOR, "g"), "");
        this.pattern = [];
        this.validate(this.value);
        this.checkSum = 0;
        this.setBaseUnit();
    };

    Postnet.prototype.addData = function addData () {
        var this$1$1 = this;

        var value = this.value;

        this.addPattern(this.START);

        for (var i = 0; i < value.length; i++) {
            this$1$1.addCharacter(value.charAt(i));
        }

        if (this.options.addCheckSum) {
            this.addCheckSum();
        }

        this.addPattern(this.START);
        this.pattern.pop();
    };

    Postnet.prototype.addCharacter = function addCharacter (character) {
        var pattern = this.characterMap[character];
        this.checkSum += parseInt(character, 10);
        this.addPattern(pattern);
    };

    Postnet.prototype.addCheckSum = function addCheckSum () {
        this.checksum = (10 - (this.checkSum % 10)) % 10;
        this.addCharacter(this.checksum);
    };

    Postnet.prototype.setBaseUnit = function setBaseUnit () {
        var startStopLength = 3;

        this.baseUnit = this.width / ((this.value.length + 1) * 10 + startStopLength + this.quietZoneLength);
    };

    Postnet.prototype.validate = function validate (value) {
        if (!numberRegex$2.test(value)) {
            this.invalidCharacterError(value.match(/[^0-9]/)[0]);
        }

        if (!inArray(value.length, this.VALID_CODE_LENGTHS)) {
            throw new Error("Invalid value length. Valid lengths for the Postnet symbology are " + this.VALID_CODE_LENGTHS.join(",") + ".");
        }
    };

    Postnet.prototype.addPattern = function addPattern (pattern) {
        var this$1$1 = this;

        var y1;

        for (var i = 0; i < pattern.length; i++) {
            y1 = this$1$1.height - this$1$1.baseHeight * pattern.charAt(i);
            this$1$1.pattern.push({ width: 1, y1: y1, y2: this$1$1.height });
            this$1$1.pattern.push(1);
        }
    };

    return Postnet;
}(Encoding));

var numberRegex$1 = /^\d+$/;
var alphanumericRegex = /^[a-z0-9]+$/i;
var extend$9 = Object.assign;

var State128 = (function (Class) {
    function State128(encoding) {
        Class.call(this);
        this.encoding = encoding;
        this.initProperties();
    }

    if ( Class ) State128.__proto__ = Class;
    State128.prototype = Object.create( Class && Class.prototype );
    State128.prototype.constructor = State128;

    State128.prototype.initProperties = function initProperties () { };

    State128.prototype.addStart = function addStart () { };

    State128.prototype.is = function is () { };

    State128.prototype.isCode = function isCode () {
        return false;
    };

    State128.prototype.move = function move () { };

    State128.prototype.pushState = function pushState () { };

    return State128;
}(Class));

var State128AB = (function (State128) {
    function State128AB(encoding, states) {
        State128.call(this, encoding);
        this.states = states;
        this._initMoves(states);
    }

    if ( State128 ) State128AB.__proto__ = State128;
    State128AB.prototype = Object.create( State128 && State128.prototype );
    State128AB.prototype.constructor = State128AB;

    State128AB.prototype.initProperties = function initProperties () {
        State128.prototype.initProperties.call(this);

        deepExtend(this, {
            FNC4: "FNC4",
            SHIFT: 98
        });
    };

    State128AB.prototype.addStart = function addStart () {
        this.encoding.addPattern(this.START);
    };

    State128AB.prototype.is = function is (value, index) {
        var code = value.charCodeAt(index);
        return this.isCode(code);
    };

    State128AB.prototype.move = function move (encodingState) {
        var idx = 0;

        while (!this._moves[idx].call(this, encodingState) && idx < this._moves.length) {
            idx++;
        }
    };

    State128AB.prototype.pushState = function pushState (encodingState) {
        var this$1$1 = this;

        var states = this.states,
            value = encodingState.value,
            maxLength = value.length,
            code;

        if (inArray("C", states)) {
            var numberMatch = value.substr(encodingState.index).match(/\d{4,}/g);

            if (numberMatch) {
                maxLength = value.indexOf(numberMatch[0], encodingState.index);
            }
        }

        while ((code = encodingState.value.charCodeAt(encodingState.index)) >= 0 &&
            this.isCode(code) &&
            encodingState.index < maxLength) {
            this$1$1.encoding.addPattern(this$1$1.getValue(code));
            encodingState.index++;
        }
    };

    State128AB.prototype._initMoves = function _initMoves (states) {
        this._moves = [];

        if (inArray(this.FNC4, states)) {
            this._moves.push(this._moveFNC);
        }

        if (inArray(this.shiftKey, states)) {
            this._moves.push(this._shiftState);
        }

        this._moves.push(this._moveState);
    };

    State128AB.prototype._moveFNC = function _moveFNC (encodingState) {
        if (encodingState.fnc) {
            encodingState.fnc = false;
            return encodingState.previousState === this.key;
        }
    };

    State128AB.prototype._shiftState = function _shiftState (encodingState) {
        if (encodingState.previousState === this.shiftKey &&
            (encodingState.index + 1 >= encodingState.value.length ||
                this.encoding[this.shiftKey].is(encodingState.value, encodingState.index + 1))) {
            this.encoding.addPattern(this.SHIFT);
            encodingState.shifted = true;
            return true;
        }
    };

    State128AB.prototype._moveState = function _moveState () {
        this.encoding.addPattern(this.MOVE);
        return true;
    };

    return State128AB;
}(State128));

var states128 = {};

states128.A = (function (State128AB) {
    function State128A () {
        State128AB.apply(this, arguments);
    }

    if ( State128AB ) State128A.__proto__ = State128AB;
    State128A.prototype = Object.create( State128AB && State128AB.prototype );
    State128A.prototype.constructor = State128A;

    State128A.prototype.initProperties = function initProperties () {
        State128AB.prototype.initProperties.call(this);

        extend$9(this, {
            key: "A",
            shiftKey: "B",
            MOVE: 101,
            START: 103
        });
    };

    State128A.prototype.isCode = function isCode (code) {
        return 0 <= code && code < 96;
    };

    State128A.prototype.getValue = function getValue (code) {
        if (code < 32) {
            return code + 64;
        }

        return code - 32;
    };

    return State128A;
}(State128AB));

states128.B = (function (State128AB) {
    function State128B () {
        State128AB.apply(this, arguments);
    }

    if ( State128AB ) State128B.__proto__ = State128AB;
    State128B.prototype = Object.create( State128AB && State128AB.prototype );
    State128B.prototype.constructor = State128B;

    State128B.prototype.initProperties = function initProperties () {
        State128AB.prototype.initProperties.call(this);

        extend$9(this, {
            key: "B",
            shiftKey: "A",
            MOVE: 100,
            START: 104
        });
    };

    State128B.prototype.isCode = function isCode (code) {
        return 32 <= code && code < 128;
    };

    State128B.prototype.getValue = function getValue (code) {
        return code - 32;
    };

    return State128B;
}(State128AB));

states128.C = (function (State128) {
    function State128C () {
        State128.apply(this, arguments);
    }

    if ( State128 ) State128C.__proto__ = State128;
    State128C.prototype = Object.create( State128 && State128.prototype );
    State128C.prototype.constructor = State128C;

    State128C.prototype.initProperties = function initProperties () {
        State128.prototype.initProperties.call(this);

        extend$9(this, {
            key: "C",
            MOVE: 99,
            START: 105
        });
    };

    State128C.prototype.addStart = function addStart () {
        this.encoding.addPattern(this.START);
    };

    State128C.prototype.is = function is (value, index) {
        var next4 = getSubstring(value, index, 4);
        return (index + 4 <= value.length || value.length === 2) && numberRegex$1.test(next4);
    };

    State128C.prototype.move = function move () {
        this.encoding.addPattern(this.MOVE);
    };

    State128C.prototype.pushState = function pushState (encodingState) {
        var this$1$1 = this;

        var code;

        while ((code = getSubstring(encodingState.value, encodingState.index, 2)) &&
            numberRegex$1.test(code) && code.length === 2) {
            this$1$1.encoding.addPattern(parseInt(code, 10));
            encodingState.index += 2;
        }
    };

    State128C.prototype.getValue = function getValue (code) {
        return code;
    };

    return State128C;
}(State128));

states128.FNC4 = (function (State128) {
    function State128FNC4(encoding, states) {
        State128.call(this, encoding);
        this._initSubStates(states);
    }

    if ( State128 ) State128FNC4.__proto__ = State128;
    State128FNC4.prototype = Object.create( State128 && State128.prototype );
    State128FNC4.prototype.constructor = State128FNC4;

    State128FNC4.prototype.initProperties = function initProperties () {
        State128.prototype.initProperties.call(this);

        extend$9(this, {
            key: "FNC4",
            dependentStates: ["A", "B"]
        });
    };

    State128FNC4.prototype.addStart = function addStart (encodingState) {
        var code = encodingState.value.charCodeAt(0) - 128,
            subState = this._getSubState(code);

        this.encoding[subState].addStart();
    };

    State128FNC4.prototype.is = function is (value, index) {
        var code = value.charCodeAt(index);
        return this.isCode(code);
    };

    State128FNC4.prototype.isCode = function isCode (code) {
        return 128 <= code && code < 256;
    };

    State128FNC4.prototype.pushState = function pushState (encodingState) {
        var this$1$1 = this;

        var subState = this._initSubState(encodingState),
            encoding = this.encoding,
            length = subState.value.length;
        var code;

        encodingState.index += length;

        if (length < 3) {
            for (; subState.index < length; subState.index++) {
                code = subState.value.charCodeAt(subState.index);
                subState.state = this$1$1._getSubState(code);

                if (subState.previousState !== subState.state) {
                    subState.previousState = subState.state;
                    encoding[subState.state].move(subState);
                }

                encoding.addPattern(encoding[subState.state].MOVE);
                encoding.addPattern(encoding[subState.state].getValue(code));
            }
        } else {
            if (subState.state !== subState.previousState) {
                encoding[subState.state].move(subState);
            }

            this._pushStart(subState);
            encoding.pushData(subState, this.subStates);

            if (encodingState.index < encodingState.value.length) {
                this._pushStart(subState);
            }
        }

        encodingState.fnc = true;
        encodingState.state = subState.state;
    };

    State128FNC4.prototype._pushStart = function _pushStart (subState) {
        this.encoding.addPattern(this.encoding[subState.state].MOVE);
        this.encoding.addPattern(this.encoding[subState.state].MOVE);
    };

    State128FNC4.prototype._initSubState = function _initSubState (encodingState) {
        var subState = {
            value: this._getAll(encodingState.value, encodingState.index),
            index: 0
        };

        subState.state = this._getSubState(subState.value.charCodeAt(0));
        subState.previousState = encodingState.previousState === this.key ?
            subState.state :
            encodingState.previousState;

        return subState;
    };

    State128FNC4.prototype._initSubStates = function _initSubStates (states) {
        var this$1$1 = this;

        this.subStates = [];

        for (var i = 0; i < states.length; i++) {
            if (inArray(states[i], this$1$1.dependentStates)) {
                this$1$1.subStates.push(states[i]);
            }
        }
    };

    State128FNC4.prototype._getSubState = function _getSubState (code) {
        var this$1$1 = this;

        for (var i = 0; i < this.subStates.length; i++) {
            if (this$1$1.encoding[this$1$1.subStates[i]].isCode(code)) {
                return this$1$1.subStates[i];
            }
        }
    };

    State128FNC4.prototype._getAll = function _getAll (value, index) {
        var code;
        var result = "";
        var i = index;

        while ((code = value.charCodeAt(i++)) && this.isCode(code)) {
            result += String.fromCharCode(code - 128);
        }

        return result;
    };

    return State128FNC4;
}(State128));

states128.FNC1 = (function (State128) {
    function States128FNC1(encoding, states) {
        State128.call(this, encoding);
        this.states = states;
    }

    if ( State128 ) States128FNC1.__proto__ = State128;
    States128FNC1.prototype = Object.create( State128 && State128.prototype );
    States128FNC1.prototype.constructor = States128FNC1;

    States128FNC1.prototype.initProperties = function initProperties () {
        State128.prototype.initProperties.call(this);

        extend$9(this, {
            key: "FNC1",
            startState: "C",
            startAI: "(",
            endAI: ")",
            dependentStates: ["C", "B"],
            applicationIdentifiers: {
                "22": { max: 29, type: "alphanumeric" },
                "402": { length: 17 },
                "7004": { max: 4, type: "alphanumeric" },
                "242": { max: 6, type: "alphanumeric" },
                "8020": { max: 25, type: "alphanumeric" },
                "703": { min: 3, max: 30, type: "alphanumeric" },
                "8008": { min: 8, max: 12, type: "alphanumeric" },
                "253": { min: 13, max: 17, type: "alphanumeric" },
                "8003": { min: 14, max: 30, type: "alphanumeric" },
                multiKey: [{
                    ids: ["15", "17", "8005", "8100"],
                    ranges: [
                        [11, 13],
                        [310, 316],
                        [320, 336],
                        [340, 369]
                    ],
                    type: { length: 6 }
                }, {
                    ids: ["240", "241", "250", "251", "400", "401", "403", "7002", "8004", "8007", "8110"],
                    ranges: [[90 - 99]],
                    type: { max: 30, type: "alphanumeric" }
                }, {
                    ids: ["7001"],
                    ranges: [[410, 414]],
                    type: { length: 13 }
                }, {
                    ids: ["10", "21", "254", "420", "8002"],
                    type: { max: 20, type: "alphanumeric" }
                }, {
                    ids: ["00", "8006", "8017", "8018"],
                    type: { length: 18 }
                }, {
                    ids: ["01", "02", "8001"],
                    type: { length: 14 }
                }, {
                    ids: ["422"],
                    ranges: [
                        [424, 426]
                    ],
                    type: { length: 3 }
                }, {
                    ids: ["20", "8102"],
                    type: { length: 2 }
                }, {
                    ids: ["30", "37"],
                    type: { max: 8, type: "alphanumeric" }
                }, {
                    ids: ["390", "392"],
                    type: { max: 15, type: "alphanumeric" }
                }, {
                    ids: ["421", "423"],
                    type: { min: 3, max: 15, type: "alphanumeric" }
                }, {
                    ids: ["391", "393"],
                    type: { min: 3, max: 18, type: "alphanumeric" }
                }, {
                    ids: ["7003", "8101"],
                    type: { length: 10 }
                }]
            },
            START: 102
        });
    };


    States128FNC1.prototype.addStart = function addStart () {
        this.encoding[this.startState].addStart();
    };

    States128FNC1.prototype.is = function is () {
        return inArray(this.key, this.states);
    };

    States128FNC1.prototype.pushState = function pushState (encodingState) {
        var this$1$1 = this;

        var encoding = this.encoding,
            value = encodingState.value.replace(/\s/g, ""),
            regexSeparators = new RegExp("[" + this.startAI + this.endAI + "]", "g"),
            index = encodingState.index,
            subState = {
                state: this.startState
            },
            current,
            nextStart,
            separatorLength;

        encoding.addPattern(this.START);

        var trueCondition = true;

        while (trueCondition) {
            subState.index = 0;

            separatorLength = value.charAt(index) === this$1$1.startAI ? 2 : 0;
            current = separatorLength > 0 ? this$1$1.getBySeparator(value, index) : this$1$1.getByLength(value, index);

            if (current.ai.length) {
                nextStart = index + separatorLength + current.id.length + current.ai.length;
            } else {
                nextStart = value.indexOf(this$1$1.startAI, index + 1);

                if (nextStart < 0) {
                    if (index + current.ai.max + current.id.length + separatorLength < value.length) {
                        throw new Error("Separators are required after variable length identifiers");
                    }

                    nextStart = value.length;
                }
            }

            subState.value = value.substring(index, nextStart).replace(regexSeparators, "");
            this$1$1.validate(current, subState.value);
            encoding.pushData(subState, this$1$1.dependentStates);

            if (nextStart >= value.length) {
                break;
            }

            index = nextStart;

            if (subState.state !== this$1$1.startState) {
                encoding[this$1$1.startState].move(subState);
                subState.state = this$1$1.startState;
            }

            if (!current.ai.length) {
                encoding.addPattern(this$1$1.START);
            }
        }

        encodingState.index = encodingState.value.length;
    };

    States128FNC1.prototype.validate = function validate (current, value) {
        var code = value.substr(current.id.length),
            ai = current.ai;

        if (!ai.type && !numberRegex$1.test(code)) {
            throw new Error("Application identifier " + current.id + " is numeric only but contains non numeric character(s).");
        }

        if (ai.type === "alphanumeric" && !alphanumericRegex.test(code)) {
            throw new Error("Application identifier " + current.id + " is alphanumeric only but contains non alphanumeric character(s).");
        }

        if (ai.length && ai.length !== code.length) {
            throw new Error("Application identifier " + current.id + " must be " + ai.length + " characters long.");
        }

        if (ai.min && ai.min > code.length) {
            throw new Error("Application identifier " + current.id + " must be at least " + ai.min + " characters long.");
        }

        if (ai.max && ai.max < code.length) {
            throw new Error("Application identifier " + current.id + " must be at most " + ai.max + " characters long.");
        }
    };

    States128FNC1.prototype.getByLength = function getByLength (value, index) {
        var this$1$1 = this;

        var id;
        var applicationIdentifier;

        for (var i = 2; i <= 4; i++) {
            id = getSubstring(value, index, i);
            applicationIdentifier = this$1$1.getApplicationIdentifier(id) || this$1$1.getApplicationIdentifier(id.substring(0, id.length - 1));
            if (applicationIdentifier) {
                return {
                    id: id,
                    ai: applicationIdentifier
                };
            }
        }
        this.unsupportedAIError(id);
    };

    States128FNC1.prototype.unsupportedAIError = function unsupportedAIError (id) {
        throw new Error("'" + id + "' is not a supported Application Identifier");
    };

    States128FNC1.prototype.getBySeparator = function getBySeparator (value, index) {
        var start = value.indexOf(this.startAI, index),
            end = value.indexOf(this.endAI, start),
            id = value.substring(start + 1, end),
            ai = this.getApplicationIdentifier(id) || this.getApplicationIdentifier(id.substr(id.length - 1));

        if (!ai) {
            this.unsupportedAIError(id);
        }

        return {
            ai: ai,
            id: id
        };
    };

    States128FNC1.prototype.getApplicationIdentifier = function getApplicationIdentifier (id) {
        var applicationIdentifier = this.applicationIdentifiers,
            multiKey = applicationIdentifier.multiKey;

        if (applicationIdentifier[id]) {
            return applicationIdentifier[id];
        }

        for (var i = 0; i < multiKey.length; i++) {
            if (multiKey[i].ids && inArray(id, multiKey[i].ids)) {
                return multiKey[i].type;
            } else if (multiKey[i].ranges) {
                var ranges = multiKey[i].ranges;

                for (var j = 0; j < ranges.length; j++) {
                    if (ranges[j][0] <= id && id <= ranges[j][1]) {
                        return multiKey[i].type;
                    }
                }
            }
        }
    };

    return States128FNC1;
}(State128));

var Code128Base = (function (Encoding) {
    function Code128Base(options) {
        Encoding.call(this, options);
        this._initStates();
    }

    if ( Encoding ) Code128Base.__proto__ = Encoding;
    Code128Base.prototype = Object.create( Encoding && Encoding.prototype );
    Code128Base.prototype.constructor = Code128Base;

    Code128Base.prototype.initProperties = function initProperties () {
        Encoding.prototype.initProperties.call(this);

        extend$9(this, {
            characterMap: [
                212222, 222122, 222221, 121223, 121322, 131222, 122213, 122312, 132212, 221213,
                221312, 231212, 112232, 122132, 122231, 113222, 123122, 123221, 223211, 221132,
                221231, 213212, 223112, 312131, 311222, 321122, 321221, 312212, 322112, 322211,
                212123, 212321, 232121, 111323, 131123, 131321, 112313, 132113, 132311, 211313,
                231113, 231311, 112133, 112331, 132131, 113123, 113321, 133121, 313121, 211331,
                231131, 213113, 213311, 213131, 311123, 311321, 331121, 312113, 312311, 332111,
                314111, 221411, 431111, 111224, 111422, 121124, 121421, 141122, 141221, 112214,
                112412, 122114, 122411, 142112, 142211, 241211, 221114, 413111, 241112, 134111,
                111242, 121142, 121241, 114212, 124112, 124211, 411212, 421112, 421211, 212141,
                214121, 412121, 111143, 111341, 131141, 114113, 114311, 411113, 411311, 113141,
                114131, 311141, 411131, 211412, 211214, 211232, 2331112
            ],
            STOP: 106
        });
    };

    Code128Base.prototype._initStates = function _initStates () {
        var this$1$1 = this;

        for (var i = 0; i < this.states.length; i++) {
            this$1$1[this$1$1.states[i]] = new states128[this$1$1.states[i]](this$1$1, this$1$1.states);
        }
    };

    Code128Base.prototype.initValue = function initValue (value, width, height) {
        this.pattern = [];
        this.value = value;
        this.width = width;
        this.height = height;
        this.checkSum = 0;
        this.totalUnits = 0;
        this.index = 0;
        this.position = 1;
    };

    Code128Base.prototype.addData = function addData () {
        var encodingState = {
            value: this.value,
            index: 0,
            state: ""
        };

        if (this.value.length === 0) {
            return;
        }

        encodingState.state =
            encodingState.previousState = this.getNextState(encodingState, this.states);

        this.addStart(encodingState);

        this.pushData(encodingState, this.states);

        this.addCheckSum();
        this.addStop();
        this.setBaseUnit();
    };

    Code128Base.prototype.pushData = function pushData (encodingState, states) {
        var this$1$1 = this;

        var trueCondition = true;

        while (trueCondition) {
            this$1$1[encodingState.state].pushState(encodingState);

            if (encodingState.index >= encodingState.value.length) {
                break;
            }

            if (!encodingState.shifted) {
                encodingState.previousState = encodingState.state;
                encodingState.state = this$1$1.getNextState(encodingState, states);
                this$1$1[encodingState.state].move(encodingState);
            } else {
                var temp = encodingState.state;
                encodingState.state = encodingState.previousState;
                encodingState.previousState = temp;
                encodingState.shifted = false;
            }
        }
    };

    Code128Base.prototype.addStart = function addStart (encodingState) {
        this[encodingState.state].addStart(encodingState);
        this.position = 1;
    };

    Code128Base.prototype.addCheckSum = function addCheckSum () {
        this.checksum = this.checkSum % 103;
        this.addPattern(this.checksum);
    };

    Code128Base.prototype.addStop = function addStop () {
        this.addPattern(this.STOP);
    };

    Code128Base.prototype.setBaseUnit = function setBaseUnit () {
        this.baseUnit = this.width / (this.totalUnits + this.quietZoneLength);
    };

    Code128Base.prototype.addPattern = function addPattern (code) {
        var this$1$1 = this;

        var pattern = this.characterMap[code].toString();
        var value;

        for (var i = 0; i < pattern.length; i++) {
            value = parseInt(pattern.charAt(i), 10);
            this$1$1.pattern.push(value);
            this$1$1.totalUnits += value;
        }
        this.checkSum += code * this.position++;
    };

    Code128Base.prototype.getNextState = function getNextState (encodingState, states) {
        var this$1$1 = this;

        for (var i = 0; i < states.length; i++) {
            if (this$1$1[states[i]].is(encodingState.value, encodingState.index)) {
                return states[i];
            }
        }

        this.invalidCharacterError(encodingState.value.charAt(encodingState.index));
    };

    return Code128Base;
}(Encoding));

var Code128a = (function (Code128Base) {
    function Code128a () {
        Code128Base.apply(this, arguments);
    }

    if ( Code128Base ) Code128a.__proto__ = Code128Base;
    Code128a.prototype = Object.create( Code128Base && Code128Base.prototype );
    Code128a.prototype.constructor = Code128a;

    Code128a.prototype.initProperties = function initProperties () {
        Code128Base.prototype.initProperties.call(this);

        extend$9(this, {
            name: "Code 128 A",
            states: ["A"]
        });
    };

    return Code128a;
}(Code128Base));

var Code128b = (function (Code128Base) {
    function Code128b () {
        Code128Base.apply(this, arguments);
    }

    if ( Code128Base ) Code128b.__proto__ = Code128Base;
    Code128b.prototype = Object.create( Code128Base && Code128Base.prototype );
    Code128b.prototype.constructor = Code128b;

    Code128b.prototype.initProperties = function initProperties () {
        Code128Base.prototype.initProperties.call(this);

        extend$9(this, {
            name: "Code 128 B",
            states: ["B"]
        });
    };

    return Code128b;
}(Code128Base));

var Code128c = (function (Code128Base) {
    function Code128c () {
        Code128Base.apply(this, arguments);
    }

    if ( Code128Base ) Code128c.__proto__ = Code128Base;
    Code128c.prototype = Object.create( Code128Base && Code128Base.prototype );
    Code128c.prototype.constructor = Code128c;

    Code128c.prototype.initProperties = function initProperties () {
        Code128Base.prototype.initProperties.call(this);

        extend$9(this, {
            name: "Code 128 C",
            states: ["C"]
        });
    };

    return Code128c;
}(Code128Base));

var Code128 = (function (Code128Base) {
    function Code128 () {
        Code128Base.apply(this, arguments);
    }

    if ( Code128Base ) Code128.__proto__ = Code128Base;
    Code128.prototype = Object.create( Code128Base && Code128Base.prototype );
    Code128.prototype.constructor = Code128;

    Code128.prototype.initProperties = function initProperties () {
        Code128Base.prototype.initProperties.call(this);

        extend$9(this, {
            name: "Code 128",
            states: ["C", "B", "A", "FNC4"]
        });
    };

    return Code128;
}(Code128Base));

var CodeGS1128 = (function (Code128Base) {
    function CodeGS1128 () {
        Code128Base.apply(this, arguments);
    }

    if ( Code128Base ) CodeGS1128.__proto__ = Code128Base;
    CodeGS1128.prototype = Object.create( Code128Base && Code128Base.prototype );
    CodeGS1128.prototype.constructor = CodeGS1128;

    CodeGS1128.prototype.initProperties = function initProperties () {
        Code128Base.prototype.initProperties.call(this);

        extend$9(this, {
            name: "Code GS1-128",
            states: ["FNC1", "C", "B"]
        });
    };

    return CodeGS1128;
}(Code128Base));

function getSubstring(value, index, count) {
    return value.substring(index, index + count);
}

var extend$8 = Object.assign;

var MsiBase = (function (Encoding) {
    function MsiBase () {
        Encoding.apply(this, arguments);
    }

    if ( Encoding ) MsiBase.__proto__ = Encoding;
    MsiBase.prototype = Object.create( Encoding && Encoding.prototype );
    MsiBase.prototype.constructor = MsiBase;

    MsiBase.prototype.initProperties = function initProperties () {
        Encoding.prototype.initProperties.call(this);

        extend$8(this, {
            characterMap: [
                "12121212",
                "12121221",
                "12122112",
                "12122121",
                "12211212",
                "12211221",
                "12212112",
                "12212121",
                "21121212",
                "21121221"
            ],
            START: "21",
            STOP: "121",
            checkSumType: "",
            checkSums: checkSums
        });
    };

    MsiBase.prototype.initValue = function initValue (value, width) {
        this.pattern = [];
        this.value = value;
        this.checkSumLength = 0;
        this.width = width;
    };

    MsiBase.prototype.setBaseUnit = function setBaseUnit () {
        var startStopLength = 7;

        this.baseUnit = this.width /
            (12 * (this.value.length + this.checkSumLength) + this.quietZoneLength + startStopLength);
    };

    MsiBase.prototype.addData = function addData () {
        var this$1$1 = this;

        var value = this.value;

        this.addPattern(this.START);

        for (var i = 0; i < value.length; i++) {
            this$1$1.addCharacter(value.charAt(i));
        }

        if (this.options.addCheckSum) {
            this.addCheckSum();
        }

        this.addPattern(this.STOP);
        this.setBaseUnit();
    };

    MsiBase.prototype.addCharacter = function addCharacter (character) {
        var pattern = this.characterMap[character];

        if (!pattern) {
            this.invalidCharacterError(character);
        }

        this.addPattern(pattern);
    };

    MsiBase.prototype.addPattern = function addPattern (pattern) {
        var this$1$1 = this;

        for (var i = 0; i < pattern.length; i++) {
            this$1$1.pattern.push(parseInt(pattern.charAt(i), 10));
        }
    };

    MsiBase.prototype.addCheckSum = function addCheckSum () {
        var this$1$1 = this;

        var checkSumFunction = this.checkSums[this.checkSumType];
        var checkValues = checkSumFunction.call(this.checkSums, this.value);

        this.checksum = checkValues.join("");

        for (var i = 0; i < checkValues.length; i++) {
            this$1$1.checkSumLength++;
            this$1$1.addPattern(this$1$1.characterMap[checkValues[i]]);
        }
    };

    return MsiBase;
}(Encoding));

var MsiMod10 = (function (MsiBase) {
    function MsiMod10 () {
        MsiBase.apply(this, arguments);
    }

    if ( MsiBase ) MsiMod10.__proto__ = MsiBase;
    MsiMod10.prototype = Object.create( MsiBase && MsiBase.prototype );
    MsiMod10.prototype.constructor = MsiMod10;

    MsiMod10.prototype.initProperties = function initProperties () {
        MsiBase.prototype.initProperties.call(this);

        extend$8(this, {
            name: "MSI Modulo10",
            checkSumType: "Modulo10"
        });
    };

    return MsiMod10;
}(MsiBase));

var MsiMod11 = (function (MsiBase) {
    function MsiMod11 () {
        MsiBase.apply(this, arguments);
    }

    if ( MsiBase ) MsiMod11.__proto__ = MsiBase;
    MsiMod11.prototype = Object.create( MsiBase && MsiBase.prototype );
    MsiMod11.prototype.constructor = MsiMod11;

    MsiMod11.prototype.initProperties = function initProperties () {
        MsiBase.prototype.initProperties.call(this);

        extend$8(this, {
            name: "MSI Modulo11",
            checkSumType: "Modulo11"
        });
    };

    return MsiMod11;
}(MsiBase));

var MsiMod1010 = (function (MsiBase) {
    function MsiMod1010 () {
        MsiBase.apply(this, arguments);
    }

    if ( MsiBase ) MsiMod1010.__proto__ = MsiBase;
    MsiMod1010.prototype = Object.create( MsiBase && MsiBase.prototype );
    MsiMod1010.prototype.constructor = MsiMod1010;

    MsiMod1010.prototype.initProperties = function initProperties () {
        MsiBase.prototype.initProperties.call(this);

        extend$8(this, {
            name: "MSI Modulo10 Modulo10",
            checkSumType: "Modulo10Modulo10"
        });
    };

    return MsiMod1010;
}(MsiBase));

var MsiMod1110 = (function (MsiBase) {
    function MsiMod1110 () {
        MsiBase.apply(this, arguments);
    }

    if ( MsiBase ) MsiMod1110.__proto__ = MsiBase;
    MsiMod1110.prototype = Object.create( MsiBase && MsiBase.prototype );
    MsiMod1110.prototype.constructor = MsiMod1110;

    MsiMod1110.prototype.initProperties = function initProperties () {
        MsiBase.prototype.initProperties.call(this);

        extend$8(this, {
            name: "MSI Modulo11 Modulo10",
            checkSumType: "Modulo11Modulo10"
        });
    };

    return MsiMod1110;
}(MsiBase));

var checkSums = {
    Modulo10: function Modulo10(value) {
        var checkValues = [0, ""],
            odd = value.length % 2,
            idx,
            evenSum,
            oddSum;

        for (idx = 0; idx < value.length; idx++) {
            checkValues[(idx + odd) % 2] += parseInt(value.charAt(idx), 10);
        }

        oddSum = checkValues[0];
        evenSum = (checkValues[1] * 2).toString();

        for (idx = 0; idx < evenSum.length; idx++) {
            oddSum += parseInt(evenSum.charAt(idx), 10);
        }

        return [(10 - (oddSum % 10)) % 10];
    },
    Modulo11: function Modulo11(value) {
        var weightedSum = 0,
            mod = 11,
            length = value.length,
            weight,
            checkValue;

        for (var i = 0; i < length; i++) {
            weight = ((length - i) % 6 || 6) + 1;
            weightedSum += weight * value.charAt(i);
        }

        checkValue = (mod - weightedSum % mod) % mod;

        if (checkValue !== 10) {
            return [checkValue];
        }

        return [1, 0];
    },
    Modulo11Modulo10: function Modulo11Modulo10(value) {
        var checkValues = this.Modulo11(value),
            mod11Value;
        mod11Value = value + checkValues[0];

        return checkValues.concat(this.Modulo10(mod11Value));
    },
    Modulo10Modulo10: function Modulo10Modulo10(value) {
        var checkValues = this.Modulo10(value),
            mod10Value;
        mod10Value = value + checkValues[0];

        return checkValues.concat(this.Modulo10(mod10Value));
    }
};

var extend$7 = Object.assign;

var Ean13 = (function (Encoding) {
    function Ean13 () {
        Encoding.apply(this, arguments);
    }

    if ( Encoding ) Ean13.__proto__ = Encoding;
    Ean13.prototype = Object.create( Encoding && Encoding.prototype );
    Ean13.prototype.constructor = Ean13;

    Ean13.prototype.initProperties = function initProperties () {
        Encoding.prototype.initProperties.call(this);

        extend$7(this, {
            name: "EAN 13",
            keyTable: [
                '000000',
                '001011',
                '001101',
                '001110',
                '010011',
                '011001',
                '011100',
                '010101',
                '010110',
                '011010'
            ],
            characterMap: {
                digits: [
                    [3, 2, 1, 1],
                    [2, 2, 2, 1],
                    [2, 1, 2, 2],
                    [1, 4, 1, 1],
                    [1, 1, 3, 2],
                    [1, 2, 3, 1],
                    [1, 1, 1, 4],
                    [1, 3, 1, 2],
                    [1, 2, 1, 3],
                    [3, 1, 1, 2]
                ],
                start: [1, 1, 1],
                middle: [1, 1, 1, 1, 1]
            }
        });
    };

    Ean13.prototype.initValue = function initValue (value, width, height) {
        var valueAsString = String(value);

        if (valueAsString.length !== 12 || /\D/.test(valueAsString)) {
            throw new Error('The value of the "EAN13" encoding should be 12 symbols');
        }

        this.pattern = [];
        this.options.height = height;
        this.baseUnit = width / (95 + this.quietZoneLength);
        this.value = valueAsString;
        this.checksum = this.calculateChecksum();
        this.leftKey = valueAsString[0];
        this.leftPart = valueAsString.substr(1, 6);
        this.rightPart = valueAsString.substr(7) + this.checksum;
    };

    Ean13.prototype.addData = function addData () {
        this.addPieces(this.characterMap.start);
        this.addSide(this.leftPart, this.leftKey);
        this.addPieces(this.characterMap.middle);
        this.addSide(this.rightPart);
        this.addPieces(this.characterMap.start);
    };

    Ean13.prototype.addSide = function addSide (leftPart, key) {
        var this$1$1 = this;

        for (var i = 0; i < leftPart.length; i++) {
            if (key && parseInt(this$1$1.keyTable[key].charAt(i), 10)) {
                this$1$1.addPieces(Array.prototype.slice.call(this$1$1.characterMap.digits[leftPart.charAt(i)]).reverse(), true);
            } else {
                this$1$1.addPieces(this$1$1.characterMap.digits[leftPart.charAt(i)], true);
            }
        }
    };

    Ean13.prototype.addPieces = function addPieces (arrToAdd, limitedHeight) {
        var this$1$1 = this;

        for (var i = 0; i < arrToAdd.length; i++) {
            if (limitedHeight) {
                this$1$1.pattern.push({
                    y1: 0,
                    y2: this$1$1.options.height * 0.95,
                    width: arrToAdd[i]
                });
            } else {
                this$1$1.pattern.push(arrToAdd[i]);
            }
        }
    };

    Ean13.prototype.calculateChecksum = function calculateChecksum () {
        var odd = 0,
            even = 0,
            value = this.value.split("").reverse().join("");

        for (var i = 0; i < value.length; i++) {
            if (i % 2) {
                even += parseInt(value.charAt(i), 10);
            } else {
                odd += parseInt(value.charAt(i), 10);
            }
        }

        var checksum = (10 - ((3 * odd + even) % 10)) % 10;

        return checksum;
    };

    return Ean13;
}(Encoding));

var extend$6 = Object.assign;

var Ean8 = (function (Ean13) {
    function Ean8 () {
        Ean13.apply(this, arguments);
    }

    if ( Ean13 ) Ean8.__proto__ = Ean13;
    Ean8.prototype = Object.create( Ean13 && Ean13.prototype );
    Ean8.prototype.constructor = Ean8;

    Ean8.prototype.initProperties = function initProperties () {
        Ean13.prototype.initProperties.call(this);

        extend$6(this, {
            name: "EAN 8"
        });
    };

    Ean8.prototype.initValue = function initValue (value, width, height) {
        if (value.length !== 7 || /\D/.test(value)) {
            throw new Error('Invalid value provided');
        }

        this.value = value;
        this.options.height = height;
        this.checksum = this.calculateChecksum(this.value);
        this.leftPart = this.value.substr(0, 4);
        this.rightPart = this.value.substr(4) + this.checksum;
        this.pattern = [];
        this.baseUnit = width / (67 + this.quietZoneLength);
    };

    return Ean8;
}(Ean13));

var Encodings = {
    code11: Code11,

    code39: Code39,
    code39extended: Code39Extended,

    code93: Code93,
    code93extended: Code93Extended,

    code128: Code128,
    code128a: Code128a,
    code128b: Code128b,
    code128c: Code128c
};
Encodings["gs1-128"] = CodeGS1128;
Encodings.msimod10 = MsiMod10;
Encodings.msimod11 = MsiMod11;
Encodings.msimod1010 = MsiMod1010;
Encodings.msimod1110 = MsiMod1110;
Encodings.postnet = Postnet;
Encodings.ean8 = Ean8;
Encodings.ean13 = Ean13;

function surfaceSize(element, surfaceType) {
    var display = element.style.display;
    if (surfaceType === 'canvas') {
        // The Canvas default size is different from SVG for
        // inline-block containers such as the Barcode and QR Code.
        //
        // Switch to display: block to get same dimensions.
        element.style.display = 'block';
    }

    var size = {
        width: element.clientWidth,
        height: element.clientHeight
    };

    element.style.display = display;

    return size;
}

var DEFAULT_BARCODE_WIDTH = 300;
var DEFAULT_BARCODE_HEIGHT = 100;

var Barcode = (function (Class) {
    function Barcode(element, options, errorHandler) {
        if ( errorHandler === void 0 ) errorHandler = defaultErrorHandler;

        Class.call(this);

        this.options = deepExtend({}, this.options, options);
        this.element = element;
        this.onError = errorHandler;

        this._initElement();
        this._initSurface();
        this._setOptions(options);

        if (options && defined(options.value)) {
            this.redraw();
        }
    }

    if ( Class ) Barcode.__proto__ = Class;
    Barcode.prototype = Object.create( Class && Class.prototype );
    Barcode.prototype.constructor = Barcode;

    Barcode.prototype.destroy = function destroy () {
        this._destroySurface();
    };

    Barcode.prototype._initElement = function _initElement () {
        addClass(this.element, "k-barcode");
    };

    Barcode.prototype._initSurface = function _initSurface () {
        var ref = this;
        var options = ref.options;
        var surface = ref.surface;

        if (!surface || surface.options.type !== options.renderAs) {
            this._destroySurface();
            this._initSurfaceElement();
            this.surface = this._createSurface();
        }
    };

    Barcode.prototype._createSurface = function _createSurface () {
        return Surface$1.create(this.surfaceElement, {
            type: this.options.renderAs
        });
    };

    Barcode.prototype._destroySurface = function _destroySurface () {
        if (this.surface) {
            this.surface.destroy();
            this.surface = null;
            this._destroySurfaceElement();
        }
    };

    Barcode.prototype._initSurfaceElement = function _initSurfaceElement () {
        if (!this.surfaceElement) {
            this.surfaceElement = document.createElement('div');
            this.surfaceElement.style.position = 'relative';
            this.element.appendChild(this.surfaceElement);
        }
    };

    Barcode.prototype._destroySurfaceElement = function _destroySurfaceElement () {
        if (this.surfaceElement && this.surfaceElement.parentNode) {
            this.surfaceElement.parentNode.removeChild(this.surfaceElement);
            this.surfaceElement = null;
        }
    };

    Barcode.prototype.setOptions = function setOptions (options) {
        this._setOptions(options);
        this._initSurface();
        this.redraw();
    };

    Barcode.prototype.redraw = function redraw () {
        var size = this._getSize();

        this.surface.clear();

        this.surface.setSize({
            width: size.width,
            height: size.height
        });

        this.createVisual();

        this.surface.draw(this.visual);
    };

    Barcode.prototype.getSize = function getSize () {
        return {
            width: this.element.offsetWidth,
            height: this.element.offsetHeight
        };
    };

    Barcode.prototype._resize = function _resize () {
        this.redraw();
    };

    Barcode.prototype.createVisual = function createVisual () {
        this.visual = this._render();
    };

    Barcode.prototype._render = function _render () {
        var options = this.options;
        var value = options.value;
        var textOptions = options.text;
        var textMargin = getSpacing(textOptions.margin);
        var size = this._getSize();
        var border = options.border || {};
        var encoding = this.encoding;
        var contentBox = new Box(0, 0, size.width, size.height).unpad(border.width).unpad(options.padding);
        var barHeight = contentBox.height();
        var encodedValue;
        var textToDisplay;
        var textHeight;
        var visual = new Group$8();

        this.contentBox = contentBox;
        visual.append(this._getBackground(size));

        if (textOptions.visible) {
            textHeight = measureText(value, { font: textOptions.font }).height;
            barHeight -= textHeight + textMargin.top + textMargin.bottom;
        }

        try {
            encodedValue = encoding.encode(value, contentBox.width(), barHeight);
        } catch (error) {
            this.onError(error);
            return visual;
        }

        if (textOptions.visible) {
            textToDisplay = value;

            if (options.checksum && defined(encoding.checksum)) {
                textToDisplay += " " + encoding.checksum;
            }

            visual.append(this._getText(textToDisplay));
        }

        this.barHeight = barHeight;
        this._bandsGroup = this._getBands(encodedValue.pattern, encodedValue.baseUnit);
        visual.append(this._bandsGroup);

        return visual;
    };

    Barcode.prototype.exportVisual = function exportVisual () {
        return this._render();
    };

    Barcode.prototype._getSize = function _getSize () {
        var element = this.element;
        var elementSize = surfaceSize(element, this.options.renderAs);
        var size = new Size(DEFAULT_BARCODE_WIDTH, DEFAULT_BARCODE_HEIGHT);

        if (elementSize.width > 0) {
            size.width = elementSize.width;
        }

        if (elementSize.height > 0) {
            size.height = elementSize.height;
        }

        if (this.options.width) {
            size.width = this.options.width;
        }

        if (this.options.height) {
            size.height = this.options.height;
        }

        return size;
    };

    Barcode.prototype.value = function value (value$1) {
        if (!defined(value$1)) {
            return this.options.value;
        }

        this.options.value = String(value$1);
        this.redraw();
    };

    Barcode.prototype._getBands = function _getBands (pattern, baseUnit) {
        var this$1$1 = this;

        var contentBox = this.contentBox;
        var offsetX = contentBox.x1;
        var stepX;
        var patternItem;
        var group = new Group$8();

        for (var i = 0; i < pattern.length; i++) {
            patternItem = isObject(pattern[i]) ? pattern[i] : {
                width: pattern[i],
                y1: 0,
                y2: this$1$1.barHeight
            };

            stepX = patternItem.width * baseUnit;

            if (i % 2) {
                var rect = Rect.fromPoints(
                    new Point$6(offsetX, patternItem.y1 + contentBox.y1),
                    new Point$6(offsetX + stepX, patternItem.y2 + contentBox.y1)
                );

                var path = Path$7.fromRect(rect, {
                    fill: {
                        color: this$1$1.options.color
                    },
                    stroke: null
                });

                group.append(path);
            }

            offsetX += stepX;
        }

        return group;
    };

    Barcode.prototype._getBackground = function _getBackground (size) {
        var options = this.options;
        var border = options.border || {};
        var box = new Box(0, 0, size.width, size.height).unpad(border.width / 2);
        var path = Path$7.fromRect(box.toRect(), {
            fill: {
                color: options.background
            },
            stroke: {
                color: border.width ? border.color : "",
                width: border.width,
                dashType: border.dashType
            }
        });

        return path;
    };

    Barcode.prototype._getText = function _getText (value) {
        var textOptions = this.options.text;
        var text = this._textbox = new TextBox(value, {
            font: textOptions.font,
            color: textOptions.color,
            align: "center",
            vAlign: "bottom",
            margin: textOptions.margin
        });

        text.reflow(this.contentBox);
        text.renderVisual();

        return text.visual;
    };

    Barcode.prototype._setOptions = function _setOptions (options) {
        this.type = (options.type || this.options.type).toLowerCase();

        if (this.type === "upca") {
            this.type = "ean13";
            options.value = '0' + options.value;
        }

        if (this.type === "upce") {
            this.type = "ean8";
            options.value = '0' + options.value;
        }

        if (!Encodings[this.type]) {
            throw new Error(("Encoding '" + (this.type) + "' is not supported."));
        }

        this.encoding = new Encodings[this.type]();

        this.options = deepExtend({}, this.options, options);
    };

    return Barcode;
}(Class));

setDefaultOptions(Barcode, {
    name: "Barcode",
    renderAs: "svg",
    value: "",
    type: "code39",
    checksum: false,
    width: 0,
    height: 0,
    color: "black",
    background: "white",
    text: {
        visible: true,
        font: "16px Consolas, Monaco, Sans Mono, monospace, sans-serif",
        color: "black",
        margin: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        }
    },
    border: {
        width: 0,
        dashType: "solid",
        color: "black"
    },
    padding: {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0
    }
});

var validate = function (encoding, size, prefix) { return function (value) {
    try {
        encoding.encode(
            prefix + value,
            size.width,
            size.height
        );
    } catch (error) {
        return {
            valid: false,
            error: error
        };
    }

    return {
        valid: true
    };
}; };

// A default size for encodings, so the validator can check only the value if no size is provided.
var fallbackSize = { width: 500, height: 100 };

function barcodeValidator(type, size) {
    if ( size === void 0 ) size = fallbackSize;

    if (!type) {
        throw new Error("Please specify barcode type to validate.");
    }

    var resolvedType = type.toLowerCase();
    var prefix = '';
    if (resolvedType === 'upca') {
        resolvedType = 'ean13';
        prefix = '0';
    } else if (resolvedType === 'upce') {
        resolvedType = 'ean8';
        prefix = '0';
    }

    if (!Encodings[resolvedType]) {
        throw new Error(("Encoding '" + type + "' is not supported."));
    }

    var encoding = new Encodings[resolvedType]();
    return validate(encoding, size, prefix);
}

var extend$5 = Object.assign;

function splitInto(str, chunkLength) {
    var result = [];
    var idx = 0;

    while (idx < str.length) {
        result.push(str.substring(idx, idx + chunkLength));
        idx += chunkLength;
    }

    return result;
}

function toBitsString(value, length) {
    var bitString = Number(value).toString(2);

    if (bitString.length < length) {
        bitString = new Array(length - bitString.length + 1).join(0) + bitString;
    }

    return bitString;
}

function toDecimal(value) {
    return parseInt(value, 2);
}

var FreeCellVisitor = (function (Class) {
    function FreeCellVisitor(matrix) {
        Class.call(this);

        this.matrix = matrix;
        this.row = matrix.length - 1;
        this.column = matrix.length - 1;
        this.startColumn = this.column;
        this.dir = -1;
        this.c = 0;
    }

    if ( Class ) FreeCellVisitor.__proto__ = Class;
    FreeCellVisitor.prototype = Object.create( Class && Class.prototype );
    FreeCellVisitor.prototype.constructor = FreeCellVisitor;

    FreeCellVisitor.prototype.move = function move () {
        this.row += this.dir * this.c;
        this.c ^= 1;
        this.column = this.startColumn - this.c;
    };

    FreeCellVisitor.prototype.getNextCell = function getNextCell () {
        var this$1$1 = this;

        while (this.matrix[this.row][this.column] !== undefined) {
            this$1$1.move();

            if (this$1$1.row < 0 || this$1$1.row >= this$1$1.matrix.length) {
                this$1$1.dir = -this$1$1.dir;
                this$1$1.startColumn -= this$1$1.startColumn !== 8 ? 2 : 3;
                this$1$1.column = this$1$1.startColumn;
                this$1$1.row = this$1$1.dir < 0 ? this$1$1.matrix.length - 1 : 0;
            }
        }

        return {
            row: this.row,
            column: this.column
        };
    };

    FreeCellVisitor.prototype.getNextRemainderCell = function getNextRemainderCell () {
        this.move();

        if (this.matrix[this.row][this.column] === undefined) {
            return {
                row: this.row,
                column: this.column
            };
        }
    };

    return FreeCellVisitor;
}(Class));

var EncodingResult = (function (Class) {
    function EncodingResult(dataString, version) {
        Class.call(this);

        this.dataString = dataString;
        this.version = version;
    }

    if ( Class ) EncodingResult.__proto__ = Class;
    EncodingResult.prototype = Object.create( Class && Class.prototype );
    EncodingResult.prototype.constructor = EncodingResult;

    return EncodingResult;
}(Class));

var IsoEncoder = (function (Class) {
    function IsoEncoder () {
        Class.apply(this, arguments);
    }

    if ( Class ) IsoEncoder.__proto__ = Class;
    IsoEncoder.prototype = Object.create( Class && Class.prototype );
    IsoEncoder.prototype.constructor = IsoEncoder;

    IsoEncoder.prototype.getEncodingResult = function getEncodingResult (inputString, errorCorrectionLevel) {
        var modes = getModes(inputString),
            dataCodewordsCount = getDataCodewordsCount(modes),
            version = getVersion(dataCodewordsCount, errorCorrectionLevel),
            dataString = getDataString(modes, version);

        return new EncodingResult(dataString, version);
    };

    return IsoEncoder;
}(Class));

var QRDataMode = (function (Class) {
    function QRDataMode() {
        Class.call(this);

        this.initProperties();
    }

    if ( Class ) QRDataMode.__proto__ = Class;
    QRDataMode.prototype = Object.create( Class && Class.prototype );
    QRDataMode.prototype.constructor = QRDataMode;

    QRDataMode.prototype.initProperties = function initProperties () {
        extend$5(this, {
            modeIndicator: "",
            bitsInCharacterCount: []
        });
    };

    QRDataMode.prototype.getVersionIndex = function getVersionIndex (version) {
        if (version < 10) {
            return 0;
        } else if (version > 26) {
            return 2;
        }

        return 1;
    };

    QRDataMode.prototype.getBitsCharacterCount = function getBitsCharacterCount (version) {
        return this.bitsInCharacterCount[this.getVersionIndex(version || 40)];
    };

    QRDataMode.prototype.getModeCountString = function getModeCountString (length, version) {
        return this.modeIndicator + toBitsString(length, this.getBitsCharacterCount(version));
    };

    QRDataMode.prototype.encode = function encode () { };

    QRDataMode.prototype.getStringBitsLength = function getStringBitsLength () { };

    QRDataMode.prototype.getValue = function getValue () { };

    return QRDataMode;
}(Class));

var NumericQRDataMode = (function (QRDataMode) {
    function NumericQRDataMode () {
        QRDataMode.apply(this, arguments);
    }

    if ( QRDataMode ) NumericQRDataMode.__proto__ = QRDataMode;
    NumericQRDataMode.prototype = Object.create( QRDataMode && QRDataMode.prototype );
    NumericQRDataMode.prototype.constructor = NumericQRDataMode;

    NumericQRDataMode.prototype.initProperties = function initProperties () {
        QRDataMode.prototype.initProperties.call(this);

        extend$5(this, {
            bitsInCharacterCount: [10, 12, 14],
            modeIndicator: "0001"
        });
    };

    NumericQRDataMode.prototype.getValue = function getValue (character) {
        return parseInt(character, 10);
    };

    NumericQRDataMode.prototype.encode = function encode (str, version) {
        var mode = this,
            parts = splitInto(str, 3),
            result = mode.getModeCountString(str.length, version);
        var i;

        for (i = 0; i < parts.length - 1; i++) {
            result += toBitsString(parts[i], 10);
        }

        return result + toBitsString(parts[i], 1 + 3 * parts[i].length);
    };

    NumericQRDataMode.prototype.getStringBitsLength = function getStringBitsLength (inputLength, version) {
        var mod3 = inputLength % 3;
        return 4 + this.getBitsCharacterCount(version) + 10 * Math.floor(inputLength / 3) + 3 * mod3 + (mod3 === 0 ? 0 : 1);
    };

    return NumericQRDataMode;
}(QRDataMode));

var AlphaNumericQRDataMode = (function (QRDataMode) {
    function AlphaNumericQRDataMode () {
        QRDataMode.apply(this, arguments);
    }

    if ( QRDataMode ) AlphaNumericQRDataMode.__proto__ = QRDataMode;
    AlphaNumericQRDataMode.prototype = Object.create( QRDataMode && QRDataMode.prototype );
    AlphaNumericQRDataMode.prototype.constructor = AlphaNumericQRDataMode;

    AlphaNumericQRDataMode.prototype.initProperties = function initProperties () {
        QRDataMode.prototype.initProperties.call(this);

        extend$5(this, {
            characters: {
                "0": 0,
                "1": 1,
                "2": 2,
                "3": 3,
                "4": 4,
                "5": 5,
                "6": 6,
                "7": 7,
                "8": 8,
                "9": 9,
                "A": 10,
                "B": 11,
                "C": 12,
                "D": 13,
                "E": 14,
                "F": 15,
                "G": 16,
                "H": 17,
                "I": 18,
                "J": 19,
                "K": 20,
                "L": 21,
                "M": 22,
                "N": 23,
                "O": 24,
                "P": 25,
                "Q": 26,
                "R": 27,
                "S": 28,
                "T": 29,
                "U": 30,
                "V": 31,
                "W": 32,
                "X": 33,
                "Y": 34,
                "Z": 35,
                " ": 36,
                "$": 37,
                "%": 38,
                "*": 39,
                "+": 40,
                "-": 41,
                ".": 42,
                "/": 43,
                ":": 44
            },
            bitsInCharacterCount: [9, 11, 13],
            modeIndicator: "0010"
        });
    };

    AlphaNumericQRDataMode.prototype.getValue = function getValue (character) {
        return this.characters[character];
    };

    AlphaNumericQRDataMode.prototype.encode = function encode (str, version) {
        var this$1$1 = this;

        var
            parts = splitInto(str, 2),
            result = this.getModeCountString(str.length, version),
            value;
        var i;

        for (i = 0; i < parts.length - 1; i++) {
            value = 45 * this$1$1.getValue(parts[i].charAt(0)) + this$1$1.getValue(parts[i].charAt(1));
            result += toBitsString(value, 11);
        }

        value = parts[i].length === 2 ?
            45 * this.getValue(parts[i].charAt(0)) + this.getValue(parts[i].charAt(1)) :
            this.getValue(parts[i].charAt(0));

        return result + toBitsString(value, 1 + 5 * parts[i].length);
    };

    AlphaNumericQRDataMode.prototype.getStringBitsLength = function getStringBitsLength (inputLength, version) {
        return 4 + this.getBitsCharacterCount(version) + 11 * Math.floor(inputLength / 2) + 6 * (inputLength % 2);
    };

    return AlphaNumericQRDataMode;
}(QRDataMode));

var ByteQRDataMode = (function (QRDataMode) {
    function ByteQRDataMode () {
        QRDataMode.apply(this, arguments);
    }

    if ( QRDataMode ) ByteQRDataMode.__proto__ = QRDataMode;
    ByteQRDataMode.prototype = Object.create( QRDataMode && QRDataMode.prototype );
    ByteQRDataMode.prototype.constructor = ByteQRDataMode;

    ByteQRDataMode.prototype.initProperties = function initProperties () {
        QRDataMode.prototype.initProperties.call(this);

        extend$5(this, {
            bitsInCharacterCount: [8, 16, 16],
            modeIndicator: "0100"
        });
    };

    ByteQRDataMode.prototype.getValue = function getValue (character) {
        var code = character.charCodeAt(0);

        if (code <= 127 || (160 <= code && code <= 255)) {
            return code;
        }

        throw new Error(("Unsupported character in QR Code: \"" + character + "\"."));
    };

    ByteQRDataMode.prototype.encode = function encode (str, version) {
        var mode = this,
            result = mode.getModeCountString(str.length, version);

        for (var i = 0; i < str.length; i++) {
            result += toBitsString(mode.getValue(str.charAt(i)), 8);
        }

        return result;
    };

    ByteQRDataMode.prototype.getStringBitsLength = function getStringBitsLength (inputLength, version) {
        return 4 + this.getBitsCharacterCount(version) + 8 * inputLength;
    };

    return ByteQRDataMode;
}(QRDataMode));

var NUMERIC$1 = "numeric";
var ALPHA_NUMERIC$1 = "alphanumeric";
var BYTE$2 = "byte";

var DataModeInstances = {};
DataModeInstances[NUMERIC$1] = new NumericQRDataMode();
DataModeInstances[ALPHA_NUMERIC$1] = new AlphaNumericQRDataMode();
DataModeInstances[BYTE$2] = new ByteQRDataMode();

var BYTE$1 = "byte";

var Utf8Encoder = (function (Class) {
    function Utf8Encoder() {
        Class.call(this);

        this.initProperties();

        this.mode = DataModeInstances[this.encodingMode];
    }

    if ( Class ) Utf8Encoder.__proto__ = Class;
    Utf8Encoder.prototype = Object.create( Class && Class.prototype );
    Utf8Encoder.prototype.constructor = Utf8Encoder;

    Utf8Encoder.prototype.initProperties = function initProperties () {
        extend$5(this, {
            encodingMode: BYTE$1,
            utfBOM: "111011111011101110111111",
            initialModeCountStringLength: 20,
            ranges: [128, 2048, 65536, 2097152, 67108864]
        });
    };

    Utf8Encoder.prototype.getEncodingResult = function getEncodingResult (inputString, errorCorrectionLevel) {
        var data = this.encode(inputString),
            dataCodewordsCount = this.getDataCodewordsCount(data),
            version = getVersion(dataCodewordsCount, errorCorrectionLevel),
            dataString = this.mode.getModeCountString(data.length / 8, version) + data;

        return new EncodingResult(dataString, version);
    };

    Utf8Encoder.prototype.getDataCodewordsCount = function getDataCodewordsCount (data) {
        var dataLength = data.length,
            dataCodewordsCount = Math.ceil((this.initialModeCountStringLength + dataLength) / 8);

        return dataCodewordsCount;
    };

    Utf8Encoder.prototype.encode = function encode (str) {
        var this$1$1 = this;

        var result = this.utfBOM;

        for (var i = 0; i < str.length; i++) {
            result += this$1$1.encodeCharacter(str.charCodeAt(i));
        }

        return result;
    };

    Utf8Encoder.prototype.encodeCharacter = function encodeCharacter (code) {
        var bytesCount = this.getBytesCount(code),
            bc = bytesCount - 1,
            result = "";

        if (bytesCount === 1) {
            result = toBitsString(code, 8);
        } else {
            var significantOnes = 8 - bytesCount;

            for (var i = 0; i < bc; i++) {
                result = toBitsString(code >> (i * 6) & 63 | 128, 8) + result;
            }

            result = ((code >> bc * 6) | ((255 >> significantOnes) << significantOnes)).toString(2) + result;
        }

        return result;
    };

    Utf8Encoder.prototype.getBytesCount = function getBytesCount (code) {
        var ranges = this.ranges;

        for (var i = 0; i < ranges.length; i++) {
            if (code < ranges[i]) {
                return i + 1;
            }
        }
    };

    return Utf8Encoder;
}(Class));

var VersionsCodewordsInformation = [{
    L: {
        groups: [
            [1, 19]
        ],
        totalDataCodewords: 19,
        errorCodewordsPerBlock: 7
    },
    M: {
        groups: [
            [1, 16]
        ],
        totalDataCodewords: 16,
        errorCodewordsPerBlock: 10
    },
    Q: {
        groups: [
            [1, 13]
        ],
        totalDataCodewords: 13,
        errorCodewordsPerBlock: 13
    },
    H: {
        groups: [
            [1, 9]
        ],
        totalDataCodewords: 9,
        errorCodewordsPerBlock: 17
    }
}, {
    L: {
        groups: [
            [1, 34]
        ],
        totalDataCodewords: 34,
        errorCodewordsPerBlock: 10
    },
    M: {
        groups: [
            [1, 28]
        ],
        totalDataCodewords: 28,
        errorCodewordsPerBlock: 16
    },
    Q: {
        groups: [
            [1, 22]
        ],
        totalDataCodewords: 22,
        errorCodewordsPerBlock: 22
    },
    H: {
        groups: [
            [1, 16]
        ],
        totalDataCodewords: 16,
        errorCodewordsPerBlock: 28
    }
}, {
    L: {
        groups: [
            [1, 55]
        ],
        totalDataCodewords: 55,
        errorCodewordsPerBlock: 15
    },
    M: {
        groups: [
            [1, 44]
        ],
        totalDataCodewords: 44,
        errorCodewordsPerBlock: 26
    },
    Q: {
        groups: [
            [2, 17]
        ],
        totalDataCodewords: 34,
        errorCodewordsPerBlock: 18
    },
    H: {
        groups: [
            [2, 13]
        ],
        totalDataCodewords: 26,
        errorCodewordsPerBlock: 22
    }
}, {
    L: {
        groups: [
            [1, 80]
        ],
        totalDataCodewords: 80,
        errorCodewordsPerBlock: 20
    },
    M: {
        groups: [
            [2, 32]
        ],
        totalDataCodewords: 64,
        errorCodewordsPerBlock: 18
    },
    Q: {
        groups: [
            [2, 24]
        ],
        totalDataCodewords: 48,
        errorCodewordsPerBlock: 26
    },
    H: {
        groups: [
            [4, 9]
        ],
        totalDataCodewords: 36,
        errorCodewordsPerBlock: 16
    }
}, {
    L: {
        groups: [
            [1, 108]
        ],
        totalDataCodewords: 108,
        errorCodewordsPerBlock: 26
    },
    M: {
        groups: [
            [2, 43]
        ],
        totalDataCodewords: 86,
        errorCodewordsPerBlock: 24
    },
    Q: {
        groups: [
            [2, 15],
            [2, 16]
        ],
        totalDataCodewords: 62,
        errorCodewordsPerBlock: 18
    },
    H: {
        groups: [
            [2, 11],
            [2, 12]
        ],
        totalDataCodewords: 46,
        errorCodewordsPerBlock: 22
    }
}, {
    L: {
        groups: [
            [2, 68]
        ],
        totalDataCodewords: 136,
        errorCodewordsPerBlock: 18
    },
    M: {
        groups: [
            [4, 27]
        ],
        totalDataCodewords: 108,
        errorCodewordsPerBlock: 16
    },
    Q: {
        groups: [
            [4, 19]
        ],
        totalDataCodewords: 76,
        errorCodewordsPerBlock: 24
    },
    H: {
        groups: [
            [4, 15]
        ],
        totalDataCodewords: 60,
        errorCodewordsPerBlock: 28
    }
}, {
    L: {
        groups: [
            [2, 78]
        ],
        totalDataCodewords: 156,
        errorCodewordsPerBlock: 20
    },
    M: {
        groups: [
            [4, 31]
        ],
        totalDataCodewords: 124,
        errorCodewordsPerBlock: 18
    },
    Q: {
        groups: [
            [2, 14],
            [4, 15]
        ],
        totalDataCodewords: 88,
        errorCodewordsPerBlock: 18
    },
    H: {
        groups: [
            [4, 13],
            [1, 14]
        ],
        totalDataCodewords: 66,
        errorCodewordsPerBlock: 26
    }
}, {
    L: {
        groups: [
            [2, 97]
        ],
        totalDataCodewords: 194,
        errorCodewordsPerBlock: 24
    },
    M: {
        groups: [
            [2, 38],
            [2, 39]
        ],
        totalDataCodewords: 154,
        errorCodewordsPerBlock: 22
    },
    Q: {
        groups: [
            [4, 18],
            [2, 19]
        ],
        totalDataCodewords: 110,
        errorCodewordsPerBlock: 22
    },
    H: {
        groups: [
            [4, 14],
            [2, 15]
        ],
        totalDataCodewords: 86,
        errorCodewordsPerBlock: 26
    }
}, {
    L: {
        groups: [
            [2, 116]
        ],
        totalDataCodewords: 232,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [3, 36],
            [2, 37]
        ],
        totalDataCodewords: 182,
        errorCodewordsPerBlock: 22
    },
    Q: {
        groups: [
            [4, 16],
            [4, 17]
        ],
        totalDataCodewords: 132,
        errorCodewordsPerBlock: 20
    },
    H: {
        groups: [
            [4, 12],
            [4, 13]
        ],
        totalDataCodewords: 100,
        errorCodewordsPerBlock: 24
    }
}, {
    L: {
        groups: [
            [2, 68],
            [2, 69]
        ],
        totalDataCodewords: 274,
        errorCodewordsPerBlock: 18
    },
    M: {
        groups: [
            [4, 43],
            [1, 44]
        ],
        totalDataCodewords: 216,
        errorCodewordsPerBlock: 26
    },
    Q: {
        groups: [
            [6, 19],
            [2, 20]
        ],
        totalDataCodewords: 154,
        errorCodewordsPerBlock: 24
    },
    H: {
        groups: [
            [6, 15],
            [2, 16]
        ],
        totalDataCodewords: 122,
        errorCodewordsPerBlock: 28
    }
}, {
    L: {
        groups: [
            [4, 81]
        ],
        totalDataCodewords: 324,
        errorCodewordsPerBlock: 20
    },
    M: {
        groups: [
            [1, 50],
            [4, 51]
        ],
        totalDataCodewords: 254,
        errorCodewordsPerBlock: 30
    },
    Q: {
        groups: [
            [4, 22],
            [4, 23]
        ],
        totalDataCodewords: 180,
        errorCodewordsPerBlock: 28
    },
    H: {
        groups: [
            [3, 12],
            [8, 13]
        ],
        totalDataCodewords: 140,
        errorCodewordsPerBlock: 24
    }
}, {
    L: {
        groups: [
            [2, 92],
            [2, 93]
        ],
        totalDataCodewords: 370,
        errorCodewordsPerBlock: 24
    },
    M: {
        groups: [
            [6, 36],
            [2, 37]
        ],
        totalDataCodewords: 290,
        errorCodewordsPerBlock: 22
    },
    Q: {
        groups: [
            [4, 20],
            [6, 21]
        ],
        totalDataCodewords: 206,
        errorCodewordsPerBlock: 26
    },
    H: {
        groups: [
            [7, 14],
            [4, 15]
        ],
        totalDataCodewords: 158,
        errorCodewordsPerBlock: 28
    }
}, {
    L: {
        groups: [
            [4, 107]
        ],
        totalDataCodewords: 428,
        errorCodewordsPerBlock: 26
    },
    M: {
        groups: [
            [8, 37],
            [1, 38]
        ],
        totalDataCodewords: 334,
        errorCodewordsPerBlock: 22
    },
    Q: {
        groups: [
            [8, 20],
            [4, 21]
        ],
        totalDataCodewords: 244,
        errorCodewordsPerBlock: 24
    },
    H: {
        groups: [
            [12, 11],
            [4, 12]
        ],
        totalDataCodewords: 180,
        errorCodewordsPerBlock: 22
    }
}, {
    L: {
        groups: [
            [3, 115],
            [1, 116]
        ],
        totalDataCodewords: 461,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [4, 40],
            [5, 41]
        ],
        totalDataCodewords: 365,
        errorCodewordsPerBlock: 24
    },
    Q: {
        groups: [
            [11, 16],
            [5, 17]
        ],
        totalDataCodewords: 261,
        errorCodewordsPerBlock: 20
    },
    H: {
        groups: [
            [11, 12],
            [5, 13]
        ],
        totalDataCodewords: 197,
        errorCodewordsPerBlock: 24
    }
}, {
    L: {
        groups: [
            [5, 87],
            [1, 88]
        ],
        totalDataCodewords: 523,
        errorCodewordsPerBlock: 22
    },
    M: {
        groups: [
            [5, 41],
            [5, 42]
        ],
        totalDataCodewords: 415,
        errorCodewordsPerBlock: 24
    },
    Q: {
        groups: [
            [5, 24],
            [7, 25]
        ],
        totalDataCodewords: 295,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [11, 12],
            [7, 13]
        ],
        totalDataCodewords: 223,
        errorCodewordsPerBlock: 24
    }
}, {
    L: {
        groups: [
            [5, 98],
            [1, 99]
        ],
        totalDataCodewords: 589,
        errorCodewordsPerBlock: 24
    },
    M: {
        groups: [
            [7, 45],
            [3, 46]
        ],
        totalDataCodewords: 453,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [15, 19],
            [2, 20]
        ],
        totalDataCodewords: 325,
        errorCodewordsPerBlock: 24
    },
    H: {
        groups: [
            [3, 15],
            [13, 16]
        ],
        totalDataCodewords: 253,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [1, 107],
            [5, 108]
        ],
        totalDataCodewords: 647,
        errorCodewordsPerBlock: 28
    },
    M: {
        groups: [
            [10, 46],
            [1, 47]
        ],
        totalDataCodewords: 507,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [1, 22],
            [15, 23]
        ],
        totalDataCodewords: 367,
        errorCodewordsPerBlock: 28
    },
    H: {
        groups: [
            [2, 14],
            [17, 15]
        ],
        totalDataCodewords: 283,
        errorCodewordsPerBlock: 28
    }
}, {
    L: {
        groups: [
            [5, 120],
            [1, 121]
        ],
        totalDataCodewords: 721,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [9, 43],
            [4, 44]
        ],
        totalDataCodewords: 563,
        errorCodewordsPerBlock: 26
    },
    Q: {
        groups: [
            [17, 22],
            [1, 23]
        ],
        totalDataCodewords: 397,
        errorCodewordsPerBlock: 28
    },
    H: {
        groups: [
            [2, 14],
            [19, 15]
        ],
        totalDataCodewords: 313,
        errorCodewordsPerBlock: 28
    }
}, {
    L: {
        groups: [
            [3, 113],
            [4, 114]
        ],
        totalDataCodewords: 795,
        errorCodewordsPerBlock: 28
    },
    M: {
        groups: [
            [3, 44],
            [11, 45]
        ],
        totalDataCodewords: 627,
        errorCodewordsPerBlock: 26
    },
    Q: {
        groups: [
            [17, 21],
            [4, 22]
        ],
        totalDataCodewords: 445,
        errorCodewordsPerBlock: 26
    },
    H: {
        groups: [
            [9, 13],
            [16, 14]
        ],
        totalDataCodewords: 341,
        errorCodewordsPerBlock: 26
    }
}, {
    L: {
        groups: [
            [3, 107],
            [5, 108]
        ],
        totalDataCodewords: 861,
        errorCodewordsPerBlock: 28
    },
    M: {
        groups: [
            [3, 41],
            [13, 42]
        ],
        totalDataCodewords: 669,
        errorCodewordsPerBlock: 26
    },
    Q: {
        groups: [
            [15, 24],
            [5, 25]
        ],
        totalDataCodewords: 485,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [15, 15],
            [10, 16]
        ],
        totalDataCodewords: 385,
        errorCodewordsPerBlock: 28
    }
}, {
    L: {
        groups: [
            [4, 116],
            [4, 117]
        ],
        totalDataCodewords: 932,
        errorCodewordsPerBlock: 28
    },
    M: {
        groups: [
            [17, 42]
        ],
        totalDataCodewords: 714,
        errorCodewordsPerBlock: 26
    },
    Q: {
        groups: [
            [17, 22],
            [6, 23]
        ],
        totalDataCodewords: 512,
        errorCodewordsPerBlock: 28
    },
    H: {
        groups: [
            [19, 16],
            [6, 17]
        ],
        totalDataCodewords: 406,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [2, 111],
            [7, 112]
        ],
        totalDataCodewords: 1006,
        errorCodewordsPerBlock: 28
    },
    M: {
        groups: [
            [17, 46]
        ],
        totalDataCodewords: 782,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [7, 24],
            [16, 25]
        ],
        totalDataCodewords: 568,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [34, 13]
        ],
        totalDataCodewords: 442,
        errorCodewordsPerBlock: 24
    }
}, {
    L: {
        groups: [
            [4, 121],
            [5, 122]
        ],
        totalDataCodewords: 1094,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [4, 47],
            [14, 48]
        ],
        totalDataCodewords: 860,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [11, 24],
            [14, 25]
        ],
        totalDataCodewords: 614,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [16, 15],
            [14, 16]
        ],
        totalDataCodewords: 464,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [6, 117],
            [4, 118]
        ],
        totalDataCodewords: 1174,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [6, 45],
            [14, 46]
        ],
        totalDataCodewords: 914,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [11, 24],
            [16, 25]
        ],
        totalDataCodewords: 664,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [30, 16],
            [2, 17]
        ],
        totalDataCodewords: 514,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [8, 106],
            [4, 107]
        ],
        totalDataCodewords: 1276,
        errorCodewordsPerBlock: 26
    },
    M: {
        groups: [
            [8, 47],
            [13, 48]
        ],
        totalDataCodewords: 1000,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [7, 24],
            [22, 25]
        ],
        totalDataCodewords: 718,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [22, 15],
            [13, 16]
        ],
        totalDataCodewords: 538,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [10, 114],
            [2, 115]
        ],
        totalDataCodewords: 1370,
        errorCodewordsPerBlock: 28
    },
    M: {
        groups: [
            [19, 46],
            [4, 47]
        ],
        totalDataCodewords: 1062,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [28, 22],
            [6, 23]
        ],
        totalDataCodewords: 754,
        errorCodewordsPerBlock: 28
    },
    H: {
        groups: [
            [33, 16],
            [4, 17]
        ],
        totalDataCodewords: 596,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [8, 122],
            [4, 123]
        ],
        totalDataCodewords: 1468,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [22, 45],
            [3, 46]
        ],
        totalDataCodewords: 1128,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [8, 23],
            [26, 24]
        ],
        totalDataCodewords: 808,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [12, 15],
            [28, 16]
        ],
        totalDataCodewords: 628,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [3, 117],
            [10, 118]
        ],
        totalDataCodewords: 1531,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [3, 45],
            [23, 46]
        ],
        totalDataCodewords: 1193,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [4, 24],
            [31, 25]
        ],
        totalDataCodewords: 871,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [11, 15],
            [31, 16]
        ],
        totalDataCodewords: 661,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [7, 116],
            [7, 117]
        ],
        totalDataCodewords: 1631,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [21, 45],
            [7, 46]
        ],
        totalDataCodewords: 1267,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [1, 23],
            [37, 24]
        ],
        totalDataCodewords: 911,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [19, 15],
            [26, 16]
        ],
        totalDataCodewords: 701,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [5, 115],
            [10, 116]
        ],
        totalDataCodewords: 1735,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [19, 47],
            [10, 48]
        ],
        totalDataCodewords: 1373,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [15, 24],
            [25, 25]
        ],
        totalDataCodewords: 985,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [23, 15],
            [25, 16]
        ],
        totalDataCodewords: 745,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [13, 115],
            [3, 116]
        ],
        totalDataCodewords: 1843,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [2, 46],
            [29, 47]
        ],
        totalDataCodewords: 1455,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [42, 24],
            [1, 25]
        ],
        totalDataCodewords: 1033,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [23, 15],
            [28, 16]
        ],
        totalDataCodewords: 793,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [17, 115]
        ],
        totalDataCodewords: 1955,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [10, 46],
            [23, 47]
        ],
        totalDataCodewords: 1541,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [10, 24],
            [35, 25]
        ],
        totalDataCodewords: 1115,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [19, 15],
            [35, 16]
        ],
        totalDataCodewords: 845,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [17, 115],
            [1, 116]
        ],
        totalDataCodewords: 2071,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [14, 46],
            [21, 47]
        ],
        totalDataCodewords: 1631,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [29, 24],
            [19, 25]
        ],
        totalDataCodewords: 1171,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [11, 15],
            [46, 16]
        ],
        totalDataCodewords: 901,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [13, 115],
            [6, 116]
        ],
        totalDataCodewords: 2191,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [14, 46],
            [23, 47]
        ],
        totalDataCodewords: 1725,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [44, 24],
            [7, 25]
        ],
        totalDataCodewords: 1231,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [59, 16],
            [1, 17]
        ],
        totalDataCodewords: 961,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [12, 121],
            [7, 122]
        ],
        totalDataCodewords: 2306,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [12, 47],
            [26, 48]
        ],
        totalDataCodewords: 1812,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [39, 24],
            [14, 25]
        ],
        totalDataCodewords: 1286,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [22, 15],
            [41, 16]
        ],
        totalDataCodewords: 986,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [6, 121],
            [14, 122]
        ],
        totalDataCodewords: 2434,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [6, 47],
            [34, 48]
        ],
        totalDataCodewords: 1914,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [46, 24],
            [10, 25]
        ],
        totalDataCodewords: 1354,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [2, 15],
            [64, 16]
        ],
        totalDataCodewords: 1054,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [17, 122],
            [4, 123]
        ],
        totalDataCodewords: 2566,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [29, 46],
            [14, 47]
        ],
        totalDataCodewords: 1992,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [49, 24],
            [10, 25]
        ],
        totalDataCodewords: 1426,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [24, 15],
            [46, 16]
        ],
        totalDataCodewords: 1096,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [4, 122],
            [18, 123]
        ],
        totalDataCodewords: 2702,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [13, 46],
            [32, 47]
        ],
        totalDataCodewords: 2102,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [48, 24],
            [14, 25]
        ],
        totalDataCodewords: 1502,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [42, 15],
            [32, 16]
        ],
        totalDataCodewords: 1142,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [20, 117],
            [4, 118]
        ],
        totalDataCodewords: 2812,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [40, 47],
            [7, 48]
        ],
        totalDataCodewords: 2216,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [43, 24],
            [22, 25]
        ],
        totalDataCodewords: 1582,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [10, 15],
            [67, 16]
        ],
        totalDataCodewords: 1222,
        errorCodewordsPerBlock: 30
    }
}, {
    L: {
        groups: [
            [19, 118],
            [6, 119]
        ],
        totalDataCodewords: 2956,
        errorCodewordsPerBlock: 30
    },
    M: {
        groups: [
            [18, 47],
            [31, 48]
        ],
        totalDataCodewords: 2334,
        errorCodewordsPerBlock: 28
    },
    Q: {
        groups: [
            [34, 24],
            [34, 25]
        ],
        totalDataCodewords: 1666,
        errorCodewordsPerBlock: 30
    },
    H: {
        groups: [
            [20, 15],
            [61, 16]
        ],
        totalDataCodewords: 1276,
        errorCodewordsPerBlock: 30
    }
}];

var terminator = "0000",
    NUMERIC = "numeric",
    ALPHA_NUMERIC = "alphanumeric",
    BYTE = "byte",
    powersOfTwo = { "1": 0 },
    powersOfTwoResult = { "0": 1 },
    irregularAlignmentPatternsStartDistance = {
        15: 20, 16: 20, 18: 24, 19: 24, 22: 20,
        24: 22, 26: 24, 28: 20, 30: 20, 31: 24,
        32: 28, 33: 24, 36: 18, 37: 22, 39: 20, 40: 24
    },
    finderPattern = [1, 0, 1, 1, 1],
    alignmentPattern = [1, 0, 1],
    errorCorrectionPatterns = { L: "01", M: "00", Q: "11", H: "10" },
    formatMaskPattern = "101010000010010",
    formatGeneratorPolynomial = "10100110111",
    versionGeneratorPolynomial = "1111100100101",
    paddingCodewords = ["11101100", "00010001"],
    finderPatternValue = 93,
    /* eslint-disable arrow-body-style */
    /* eslint-disable no-unused-vars */
    maskPatternConditions = [
        function (row, column) { return (row + column) % 2 === 0; },
        function (row, column) { return row % 2 === 0; },
        function (row, column) { return column % 3 === 0; },
        function (row, column) { return (row + column) % 3 === 0; },
        function (row, column) { return (Math.floor(row / 2) + Math.floor(column / 3)) % 2 === 0; },
        function (row, column) { return ((row * column) % 2) + ((row * column) % 3) === 0; },
        function (row, column) { return (((row * column) % 2) + ((row * column) % 3)) % 2 === 0; },
        function (row, column) { return (((row + column) % 2) + ((row * column) % 3)) % 2 === 0; }
    ],
    /* eslint-enable no-unused-vars */
    /* eslint-enable arrow-body-style */
    numberRegex = /^\d+/,
    alphaPattern = "A-Z0-9 $%*+./:-",
    alphaExclusiveSet = "A-Z $%*+./:-",
    alphaRegex = new RegExp("^[" + alphaExclusiveSet + "]+"),
    alphaNumericRegex = new RegExp("^[" + alphaPattern + "]+"),
    byteRegex = new RegExp("^[^" + alphaPattern + "]+"),
    initMinNumericBeforeAlpha = 8,
    initMinNumericBeforeByte = 5,
    initMinAlphaBeforeByte = 8,
    minNumericBeforeAlpha = 17,
    minNumericBeforeByte = 9,
    minAlphaBeforeByte = 16;

var generatorPolynomials = [[1, 0], [1, 25, 0]];

function fillFunctionCell(matrices, bit, x, y) {
    for (var i = 0; i < matrices.length; i++) {
        matrices[i][x][y] = bit;
    }
}

function fillDataCell(matrices, bit, x, y) {
    for (var i = 0; i < maskPatternConditions.length; i++) {
        matrices[i][x][y] = maskPatternConditions[i](x, y) ? bit ^ 1 : parseInt(bit, 10);
    }
}

function fillData(matrices, blocks) {
    var cellVisitor = new FreeCellVisitor(matrices[0]),
        block,
        codewordIdx,
        cell;

    for (var blockIdx = 0; blockIdx < blocks.length; blockIdx++) {
        block = blocks[blockIdx];
        codewordIdx = 0;

        while (block.length > 0) {
            for (var i = 0; i < block.length; i++) {
                for (var j = 0; j < 8; j++) {
                    cell = cellVisitor.getNextCell();
                    fillDataCell(matrices, block[i][codewordIdx].charAt(j), cell.row, cell.column);
                }
            }

            codewordIdx++;

            while (block[0] && codewordIdx === block[0].length) {
                block.splice(0, 1);
            }
        }
    }

    while ((cell = cellVisitor.getNextRemainderCell())) {
        fillDataCell(matrices, 0, cell.row, cell.column);
    }
}

function padDataString(initialDataString, totalDataCodewords) {
    var dataBitsCount = totalDataCodewords * 8,
        terminatorIndex = 0,
        paddingCodewordIndex = 0;
    var dataString = initialDataString;

    while (dataString.length < dataBitsCount && terminatorIndex < terminator.length) {
        dataString += terminator.charAt(terminatorIndex++);
    }

    if (dataString.length % 8 !== 0) {
        dataString += new Array(9 - dataString.length % 8).join("0");
    }

    while (dataString.length < dataBitsCount) {
        dataString += paddingCodewords[paddingCodewordIndex];
        paddingCodewordIndex ^= 1;
    }

    return dataString;
}

function generatePowersOfTwo() {
    var result;
    var power;

    for (power = 1; power < 255; power++) {
        result = powersOfTwoResult[power - 1] * 2;
        if (result > 255) {
            result = result ^ 285;
        }

        powersOfTwoResult[power] = result;
        powersOfTwo[result] = power;
    }

    result = (powersOfTwoResult[power - 1] * 2) ^ 285;
    powersOfTwoResult[power] = result;
    powersOfTwoResult[-1] = 0;
}

function xorPolynomials(x, y) {
    var result = [],
        idx = x.length - 2;

    for (var i = idx; i >= 0; i--) {
        result[i] = x[i] ^ y[i];
    }

    return result;
}

function multiplyPolynomials(x, y) {
    var result = [];

    for (var i = 0; i < x.length; i++) {
        for (var j = 0; j < y.length; j++) {
            if (result[i + j] === undefined) {
                result[i + j] = (x[i] + (y[j] >= 0 ? y[j] : 0)) % 255;
            } else {
                result[i + j] = powersOfTwo[powersOfTwoResult[result[i + j]] ^ powersOfTwoResult[(x[i] + y[j]) % 255]];
            }
        }
    }

    return result;
}

function generateGeneratorPolynomials() {
    var maxErrorCorrectionCodeWordsCount = 68;

    for (var idx = 2; idx <= maxErrorCorrectionCodeWordsCount; idx++) {
        var firstPolynomial = generatorPolynomials[idx - 1],
            secondPolynomial = [idx, 0];

        generatorPolynomials[idx] = multiplyPolynomials(firstPolynomial, secondPolynomial);
    }
}

//possibly generate on demand
generatePowersOfTwo();
generateGeneratorPolynomials();

function multiplyByConstant(polynomial, power) {
    var result = [],
        idx = polynomial.length - 1;

    do {
        result[idx] = powersOfTwoResult[(polynomial[idx] + power) % 255];
        idx--;
    }
    while (polynomial[idx] !== undefined);

    return result;
}

function generateErrorCodewords(data, errorCodewordsCount) {
    var generator = generatorPolynomials[errorCodewordsCount - 1],
        result = new Array(errorCodewordsCount).concat(data),
        generatorPolynomial = new Array(result.length - generator.length).concat(generator),
        steps = data.length,
        errorCodewords = [],
        divisor,
        idx;

    for (idx = 0; idx < steps; idx++) {
        divisor = multiplyByConstant(generatorPolynomial, powersOfTwo[result[result.length - 1]]);
        generatorPolynomial.splice(0, 1);

        result = xorPolynomials(divisor, result);
    }

    for (idx = result.length - 1; idx >= 0; idx--) {
        errorCodewords[errorCodewordsCount - 1 - idx] = toBitsString(result[idx], 8);
    }

    return errorCodewords;
}

function getBlocks(dataStream, versionCodewordsInformation) {
    var codewordStart = 0,
        dataBlocks = [],
        errorBlocks = [],
        dataBlock,
        versionGroups = versionCodewordsInformation.groups,
        blockCodewordsCount,
        groupBlocksCount,
        messagePolynomial,
        codeword;

    for (var groupIdx = 0; groupIdx < versionGroups.length; groupIdx++) {
        groupBlocksCount = versionGroups[groupIdx][0];

        for (var blockIdx = 0; blockIdx < groupBlocksCount; blockIdx++) {
            blockCodewordsCount = versionGroups[groupIdx][1];
            dataBlock = [];
            messagePolynomial = [];

            for (var codewordIdx = 1; codewordIdx <= blockCodewordsCount; codewordIdx++) {
                codeword = dataStream.substring(codewordStart, codewordStart + 8);
                dataBlock.push(codeword);
                messagePolynomial[blockCodewordsCount - codewordIdx] = toDecimal(codeword);
                codewordStart += 8;
            }

            dataBlocks.push(dataBlock);
            errorBlocks.push(generateErrorCodewords(messagePolynomial,
                versionCodewordsInformation.errorCodewordsPerBlock));
        }
    }
    return [dataBlocks, errorBlocks];
}

function chooseMode(str, minNumericBeforeAlpha, minNumericBeforeByte, minAlphaBeforeByte, previousMode) {
    var numeric = numberRegex.exec(str),
        numericMatch = numeric ? numeric[0] : "",
        alpha = alphaRegex.exec(str),
        alphaMatch = alpha ? alpha[0] : "",
        alphaNumeric = alphaNumericRegex.exec(str),
        alphaNumericMatch = alphaNumeric ? alphaNumeric[0] : "",
        mode,
        modeString;

    if (numericMatch &&
        (numericMatch.length >= minNumericBeforeAlpha || str.length === numericMatch.length ||
        (numericMatch.length >= minNumericBeforeByte && !alphaNumericRegex.test(str.charAt(numericMatch.length))))) {
        mode = NUMERIC;
        modeString = numericMatch;
    } else if (alphaNumericMatch && (str.length === alphaNumericMatch.length ||
        alphaNumericMatch.length >= minAlphaBeforeByte || previousMode === ALPHA_NUMERIC)) {
        mode = ALPHA_NUMERIC;
        modeString = numericMatch || alphaMatch;
    } else {
        mode = BYTE;

        if (alphaNumericMatch) {
            modeString = alphaNumericMatch + byteRegex.exec(str.substring(alphaNumericMatch.length))[0];
        } else {
            modeString = byteRegex.exec(str)[0];
        }
    }

    return {
        mode: mode,
        modeString: modeString
    };
}

function getModes(inputString) {
    var modes = [],
        previousMode,
        idx = 0;
    var str = inputString;

    modes.push(chooseMode(str, initMinNumericBeforeAlpha, initMinNumericBeforeByte, initMinAlphaBeforeByte, previousMode));
    previousMode = modes[0].mode;
    str = str.substr(modes[0].modeString.length);

    while (str.length > 0) {
        var nextMode = chooseMode(str, minNumericBeforeAlpha, minNumericBeforeByte, minAlphaBeforeByte, previousMode);

        if (nextMode.mode !== previousMode) {
            previousMode = nextMode.mode;
            modes.push(nextMode);
            idx++;
        } else {
            modes[idx].modeString += nextMode.modeString;
        }

        str = str.substr(nextMode.modeString.length);
    }

    return modes;
}

function getDataCodewordsCount(modes) {
    var length = 0,
        mode;

    for (var i = 0; i < modes.length; i++) {
        mode = DataModeInstances[modes[i].mode];
        length += mode.getStringBitsLength(modes[i].modeString.length);
    }

    return Math.ceil(length / 8);
}

function getVersion(dataCodewordsCount, errorCorrectionLevel) {
    var x = 0,
        y = VersionsCodewordsInformation.length - 1,
        version = Math.floor(VersionsCodewordsInformation.length / 2);

    do {
        if (dataCodewordsCount < VersionsCodewordsInformation[version][errorCorrectionLevel].totalDataCodewords) {
            y = version;
        } else {
            x = version;
        }

        version = x + Math.floor((y - x) / 2);
    } while (y - x > 1);

    if (dataCodewordsCount <= VersionsCodewordsInformation[x][errorCorrectionLevel].totalDataCodewords) {
        return version + 1;
    }

    return y + 1;
}

function getDataString(modes, version) {
    var dataString = "",
        mode;

    for (var i = 0; i < modes.length; i++) {
        mode = DataModeInstances[modes[i].mode];
        dataString += mode.encode(modes[i].modeString, version);
    }

    return dataString;
}

//fix case all zeros
function encodeFormatInformation(format) {
    var formatNumber = toDecimal(format),
        encodedString,
        result = "";

    if (formatNumber === 0) {
        return "101010000010010";
    }

    encodedString = encodeBCH(toDecimal(format), formatGeneratorPolynomial, 15);

    for (var i = 0; i < encodedString.length; i++) {
        result += encodedString.charAt(i) ^ formatMaskPattern.charAt(i);
    }

    return result;
}

function encodeBCH(value, generatorPolynomial, codeLength) {
    var generatorNumber = toDecimal(generatorPolynomial),
        polynomialLength = generatorPolynomial.length - 1,
        valueNumber = value << polynomialLength,
        length = codeLength - polynomialLength,
        valueString = toBitsString(value, length),
        result = dividePolynomials(valueNumber, generatorNumber);

    result = valueString + toBitsString(result, polynomialLength);

    return result;
}

function dividePolynomials(numberX, numberY) {
    var yLength = numberY.toString(2).length,
        xLength = numberX.toString(2).length;
    var x = numberX;

    do {
        x ^= numberY << xLength - yLength;
        xLength = x.toString(2).length;
    }
    while (xLength >= yLength);

    return x;
}

function getNumberAt(str, idx) {
    return parseInt(str.charAt(idx), 10);
}

function initMatrices(version) {
    var matrices = [],
        modules = 17 + 4 * version;

    for (var i = 0; i < maskPatternConditions.length; i++) {
        matrices[i] = new Array(modules);

        for (var j = 0; j < modules; j++) {
            matrices[i][j] = new Array(modules);
        }
    }

    return matrices;
}

function addFormatInformation(matrices, formatString) {
    var matrix = matrices[0],
        x,
        y,
        idx = 0,
        length = formatString.length;

    for (x = 0, y = 8; x <= 8; x++) {
        if (x !== 6) {
            fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
        }
    }

    for (x = 8, y = 7; y >= 0; y--) {
        if (y !== 6) {
            fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
        }
    }

    idx = 0;

    for (y = matrix.length - 1, x = 8; y >= matrix.length - 8; y--) {
        fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
    }

    fillFunctionCell(matrices, 1, matrix.length - 8, 8);

    for (x = matrix.length - 7, y = 8; x < matrix.length; x++) {
        fillFunctionCell(matrices, getNumberAt(formatString, length - 1 - idx++), x, y);
    }
}

function encodeVersionInformation(version) {
    return encodeBCH(version, versionGeneratorPolynomial, 18);
}

function addVersionInformation(matrices, dataString) {
    var matrix = matrices[0],
        modules = matrix.length,
        x1 = 0,
        y1 = modules - 11,
        x2 = modules - 11,
        y2 = 0,
        quotient,
        mod,
        value;

    for (var idx = 0; idx < dataString.length; idx++) {
        quotient = Math.floor(idx / 3);
        mod = idx % 3;
        value = getNumberAt(dataString, dataString.length - idx - 1);

        fillFunctionCell(matrices, value, x1 + quotient, y1 + mod);
        fillFunctionCell(matrices, value, x2 + mod, y2 + quotient);
    }
}

function addCentricPattern(matrices, pattern, x, y) {
    var size = pattern.length + 2,
        length = pattern.length + 1,
        value;

    for (var i = 0; i < pattern.length; i++) {
        for (var j = i; j < size - i; j++) {
            value = pattern[i];

            fillFunctionCell(matrices, value, x + j, y + i);
            fillFunctionCell(matrices, value, x + i, y + j);
            fillFunctionCell(matrices, value, x + length - j, y + length - i);
            fillFunctionCell(matrices, value, x + length - i, y + length - j);
        }
    }
}

function addFinderSeparator(matrices, direction, x, y) {
    var nextX = x,
        nextY = y,
        matrix = matrices[0];

    do {
        fillFunctionCell(matrices, 0, nextX, y);
        fillFunctionCell(matrices, 0, x, nextY);
        nextX += direction[0];
        nextY += direction[1];
    }
    while (nextX >= 0 && nextX < matrix.length);
}

function addFinderPatterns(matrices) {
    var modules = matrices[0].length;

    addCentricPattern(matrices, finderPattern, 0, 0);
    addFinderSeparator(matrices, [-1, -1], 7, 7);
    addCentricPattern(matrices, finderPattern, modules - 7, 0);
    addFinderSeparator(matrices, [1, -1], modules - 8, 7);
    addCentricPattern(matrices, finderPattern, 0, modules - 7);
    addFinderSeparator(matrices, [-1, 1], 7, modules - 8);
}

function addAlignmentPatterns(matrices, version) {
    if (version < 2) {
        return;
    }

    var matrix = matrices[0],
        modules = matrix.length,
        pointsCount = Math.floor(version / 7),
        points = [6],
        startDistance,
        distance,
        idx = 0;

    if ((startDistance = irregularAlignmentPatternsStartDistance[version])) {
        distance = (modules - 13 - startDistance) / pointsCount;
    } else {
        startDistance = distance = (modules - 13) / (pointsCount + 1);
    }

    points.push(points[idx++] + startDistance);

    while ((points[idx] + distance) < modules) {
        points.push(points[idx++] + distance);
    }

    for (var i = 0; i < points.length; i++) {
        for (var j = 0; j < points.length; j++) {
            if (matrix[points[i]][points[j]] === undefined) {
                addCentricPattern(matrices, alignmentPattern, points[i] - 2, points[j] - 2);
            }
        }
    }
}

function addTimingFunctions(matrices) {
    var row = 6,
        column = 6,
        value = 1,
        modules = matrices[0].length;

    for (var i = 8; i < modules - 8; i++) {
        fillFunctionCell(matrices, value, row, i);
        fillFunctionCell(matrices, value, i, column);
        value ^= 1;
    }
}

function scoreMaskMatrixes(matrices) {
    var scores = [],
        previousBits = [],
        darkModules = [],
        patterns = [],
        adjacentSameBits = [],
        matrix,
        i,
        row = 0,
        column = 1,
        modulesLength = matrices[0].length;

    for (i = 0; i < matrices.length; i++) {
        scores[i] = 0;
        darkModules[i] = 0;
        adjacentSameBits[i] = [0, 0];
        patterns[i] = [0, 0];
        previousBits[i] = [];
    }

    for (var rowIndex = 0; rowIndex < modulesLength; rowIndex++) {
        for (var columnIndex = 0; columnIndex < modulesLength; columnIndex++) {
            for (var matrixIndex = 0; matrixIndex < matrices.length; matrixIndex++) {
                matrix = matrices[matrixIndex];
                darkModules[matrixIndex] += parseInt(matrix[rowIndex][columnIndex], 10);

                if (previousBits[matrixIndex][row] === matrix[rowIndex][columnIndex] &&
                    rowIndex + 1 < modulesLength &&
                    columnIndex - 1 >= 0 &&
                    matrix[rowIndex + 1][columnIndex] === previousBits[matrixIndex][row] &&
                    matrix[rowIndex + 1][columnIndex - 1] === previousBits[matrixIndex][row]) {
                    scores[matrixIndex] += 3;
                }

                scoreFinderPatternOccurance(matrixIndex, patterns, scores, row, matrix[rowIndex][columnIndex]);
                scoreFinderPatternOccurance(matrixIndex, patterns, scores, column, matrix[columnIndex][rowIndex]);
                scoreAdjacentSameBits(matrixIndex, scores, previousBits, matrix[rowIndex][columnIndex], adjacentSameBits, row);
                scoreAdjacentSameBits(matrixIndex, scores, previousBits, matrix[columnIndex][rowIndex], adjacentSameBits, column);
            }
        }
    }

    var total = modulesLength * modulesLength,
        minIdx,
        min = Number.MAX_VALUE;

    for (i = 0; i < scores.length; i++) {
        scores[i] += calculateDarkModulesRatioScore(darkModules[i], total);

        if (scores[i] < min) {
            min = scores[i];
            minIdx = i;
        }
    }

    return minIdx;
}

function scoreFinderPatternOccurance(idx, patterns, scores, rowColumn, bit) {
    patterns[idx][rowColumn] = ((patterns[idx][rowColumn] << 1) ^ bit) % 128;

    if (patterns[idx][rowColumn] === finderPatternValue) {
        scores[idx] += 40;
    }
}

function scoreAdjacentSameBits(idx, scores, previousBits, bit, adjacentBits, rowColumn) {
    if (previousBits[idx][rowColumn] === bit) {
        adjacentBits[idx][rowColumn]++;
    } else {
        previousBits[idx][rowColumn] = bit;

        if (adjacentBits[idx][rowColumn] >= 5) {
            scores[idx] += 3 + adjacentBits[idx][rowColumn] - 5;
        }

        adjacentBits[idx][rowColumn] = 1;
    }
}

function calculateDarkModulesRatioScore(darkModules, total) {
    var percent = Math.floor((darkModules / total) * 100),
        mod5 = percent % 5,
        previous = Math.abs(percent - mod5 - 50),
        next = Math.abs(percent + 5 - mod5 - 50),
        score = 10 * Math.min(previous / 5, next / 5);

    return score;
}

function createQRCodeDataEncoder(encoding) {
    if (encoding && encoding.toLowerCase().indexOf("utf_8") >= 0) {
        return new Utf8Encoder();
    }

    return new IsoEncoder();
}

function encodeData(inputString, errorCorrectionLevel, encoding) {
    var encoder = createQRCodeDataEncoder(encoding),
        encodingResult = encoder.getEncodingResult(inputString, errorCorrectionLevel),
        version = encodingResult.version,
        versionInformation = VersionsCodewordsInformation[version - 1][errorCorrectionLevel],
        dataString = padDataString(encodingResult.dataString, versionInformation.totalDataCodewords),
        blocks = getBlocks(dataString, versionInformation),
        matrices = initMatrices(version);

    addFinderPatterns(matrices);
    addAlignmentPatterns(matrices, version);
    addTimingFunctions(matrices);

    if (version >= 7) {
        addVersionInformation(matrices, toBitsString(0, 18));
    }

    addFormatInformation(matrices, toBitsString(0, 15));
    fillData(matrices, blocks);

    var minIdx = scoreMaskMatrixes(matrices),
        optimalMatrix = matrices[minIdx];

    if (version >= 7) {
        addVersionInformation([optimalMatrix], encodeVersionInformation(version));
    }

    var formatString = errorCorrectionPatterns[errorCorrectionLevel] + toBitsString(minIdx, 3);
    addFormatInformation([optimalMatrix], encodeFormatInformation(formatString));

    return optimalMatrix;
}

var round = Math.round;
var crossPattern = [[0, 1], [1, 1], [1, 2], [2, 2], [2, 1], [3, 1], [3, 0], [2, 0], [2, -1], [1, -1], [1, 0]];
var squarePattern = [[0, 1], [1, 1], [1, 0]];

var QRCodeDefaults = {
    DEFAULT_SIZE: 200,
    QUIET_ZONE_LENGTH: 4,
    DEFAULT_ERROR_CORRECTION_LEVEL: "L",
    DEFAULT_BACKGROUND: "#fff",
    DEFAULT_DARK_MODULE_COLOR: "#000",
    MIN_BASE_UNIT_SIZE: 1,
    DEFAULT_LOGO_SIZE: 7
};

var QRCode = (function (Class) {
    function QRCode(element, options, errorHandler) {
        if ( errorHandler === void 0 ) errorHandler = defaultErrorHandler;

        Class.call(this);

        this.options = deepExtend({}, this.options, options);
        this.element = element;
        this.wrapper = this.element;
        this.onError = errorHandler;

        this._initElement();
        this._initSurface();

        this.setOptions(options);
    }

    if ( Class ) QRCode.__proto__ = Class;
    QRCode.prototype = Object.create( Class && Class.prototype );
    QRCode.prototype.constructor = QRCode;

    QRCode.prototype.destroy = function destroy () {
        this._destroySurface();
    };

    QRCode.prototype._initElement = function _initElement () {
        addClass(this.element, "k-qrcode");
    };

    QRCode.prototype._initSurface = function _initSurface () {
        var ref = this;
        var options = ref.options;
        var surface = ref.surface;

        if (!surface || surface.options.type !== options.renderAs) {
            this._destroySurface();
            this._initSurfaceElement();
            this.surface = this._createSurface();
        }
    };

    QRCode.prototype._createSurface = function _createSurface () {
        return Surface$1.create(this.surfaceElement, {
            type: this.options.renderAs
        });
    };

    QRCode.prototype._destroySurface = function _destroySurface () {
        if (this.surface) {
            this.surface.destroy();
            this.surface = null;
            this._destroySurfaceElement();
        }
    };

    QRCode.prototype._initSurfaceElement = function _initSurfaceElement () {
        if (!this.surfaceElement) {
            this.surfaceElement = document.createElement('div');
            this.surfaceElement.style.position = "relative";
            this.element.appendChild(this.surfaceElement);
        }
    };

    QRCode.prototype._destroySurfaceElement = function _destroySurfaceElement () {
        if (this.surfaceElement && this.surfaceElement.parentNode) {
            this.surfaceElement.parentNode.removeChild(this.surfaceElement);
            this.surfaceElement = null;
        }
    };

    QRCode.prototype.redraw = function redraw () {
        var size = this._getSize();

        this.surface.clear();

        this.surface.setSize({
            width: size,
            height: size
        });

        this.createVisual();

        this.surface.draw(this.visual);
    };

    QRCode.prototype.getSize = function getSize () {
        var element = this.element;
        var elementWidth = element.clientWidth;
        var elementHeight = element.clientHeight;
        var size = { width: 0, height: 0 };

        if (elementWidth > 0) {
            size.width = elementWidth;
        }

        if (elementHeight) {
            size.height = elementHeight;
        }

        return size;
    };

    QRCode.prototype._resize = function _resize () {
        this.redraw();
    };

    QRCode.prototype.createVisual = function createVisual () {
        this.visual = this._render();
    };

    QRCode.prototype.exportVisual = function exportVisual () {
        return this._render();
    };

    QRCode.prototype._render = function _render () {
        var value = this._value,
            baseUnit,
            border = this.options.border || {},
            padding = this.options.padding || 0,
            borderWidth = border.width || 0,
            quietZoneSize,
            matrix,
            size,
            dataSize,
            contentSize;

        border.width = borderWidth;

        var visual = new Group$8();

        try {
            if (value) {
                matrix = encodeData(value, this.options.errorCorrection, this.options.encoding);
                size = this._getSize();
                contentSize = size - 2 * (borderWidth + padding);
                baseUnit = this._calculateBaseUnit(contentSize, matrix.length);
                dataSize = matrix.length * baseUnit;
                quietZoneSize = borderWidth + padding + (contentSize - dataSize) / 2;

                visual.append(this._renderBackground(size, border));
                visual.append(this._renderMatrix(matrix, baseUnit, quietZoneSize));

                if (this._hasCustomLogo()) {
                    visual.append(this._renderLogo(size, baseUnit));
                } else if (this._isSwiss()) {
                    visual.append(this._renderSwissCode(size, baseUnit));
                }
            }
        } catch (error) {
            this.onError(error);
        }

        return visual;
    };

    QRCode.prototype._renderLogo = function _renderLogo (qrSize, baseUnit) {
        var image;
        var imageRect;
        var center = round(qrSize / 2);
        var logoSize = this._getLogoSize(baseUnit * QRCodeDefaults.DEFAULT_LOGO_SIZE);
        var logoUrl = this.options.overlay.imageUrl;
        var position = {
            x: center - logoSize.width / 2,
            y: center - logoSize.height / 2
        };

        imageRect = new Rect(
            new Point$6(position.x, position.y),
            new Size(logoSize.width, logoSize.height)
        );

        image = new Image(logoUrl, imageRect);

        return image;
    };

    QRCode.prototype._renderSwissCode = function _renderSwissCode (qrSize, baseUnit) {
        var logoSize = this._getLogoSize(baseUnit * QRCodeDefaults.DEFAULT_LOGO_SIZE);
        logoSize = Math.max(logoSize.width, logoSize.height);
        var crossSize = logoSize / 4;
        var crossOffset = crossSize / 2;
        var center = qrSize / 2;
        var start = {};
        var visual = new Group$8();

        start.x = start.y = Math.ceil(center - baseUnit - logoSize / 2);
        visual.append(this._renderShape(start, Math.ceil(logoSize + baseUnit * 2), squarePattern, "#fff"));

        start.x = start.y = center - logoSize / 2;
        visual.append(this._renderShape(start, logoSize, squarePattern, this.options.color));

        start.x = center + crossOffset - logoSize / 2;
        start.y = center + crossOffset + crossSize - logoSize / 2;
        visual.append(this._renderShape(start, crossSize, crossPattern, "#fff"));

        return visual;
    };

    QRCode.prototype._renderShape = function _renderShape (start, step, pattern, color) {
        var path = new MultiPath({
            fill: {
                color: color
            },
            stroke: null
        });

        path.moveTo(start.x, start.y);

        for (var i = 0; i < pattern.length; i++) {
            path.lineTo(start.x + step * pattern[i][0], start.y + step * pattern[i][1]);
        }

        path.close();

        return path;
    };

    QRCode.prototype._getSize = function _getSize () {
        var size;

        if (this.options.size) {
            size = parseInt(this.options.size, 10);
        } else {
            var element = this.element;
            var elementSize = surfaceSize(element, this.options.renderAs);
            var min = Math.min(elementSize.width, elementSize.height);

            if (min > 0) {
                size = min;
            } else {
                size = QRCodeDefaults.DEFAULT_SIZE;
            }
        }

        return size;
    };

    QRCode.prototype._calculateBaseUnit = function _calculateBaseUnit (size, matrixSize) {
        var baseUnit = Math.floor(size / matrixSize);

        if (baseUnit < QRCodeDefaults.MIN_BASE_UNIT_SIZE) {
            var minSize = Math.ceil(matrixSize * QRCodeDefaults.MIN_BASE_UNIT_SIZE);
            this.onError(new Error(
                ("Insufficient size for QR Code: the current size is " + size + "px and the minimum size is " + minSize + "px.")
            ));
        } else if (baseUnit * matrixSize >= size &&
            baseUnit - 1 >= QRCodeDefaults.MIN_BASE_UNIT_SIZE) {
            baseUnit--;
        }

        return baseUnit;
    };

    QRCode.prototype._renderMatrix = function _renderMatrix (matrix, baseUnit, quietZoneSize) {
        var path = new MultiPath({
            fill: {
                color: this.options.color
            },
            stroke: null
        });

        for (var row = 0; row < matrix.length; row++) {
            var y = quietZoneSize + row * baseUnit;
            var column = 0;

            while (column < matrix.length) {
                while (matrix[row][column] === 0 && column < matrix.length) {
                    column++;
                }

                if (column < matrix.length) {
                    var x = column;
                    while (matrix[row][column] === 1) {
                        column++;
                    }

                    var x1 = round(quietZoneSize + x * baseUnit);
                    var y1 = round(y);
                    var x2 = round(quietZoneSize + column * baseUnit);
                    var y2 = round(y + baseUnit);

                    path.moveTo(x1, y1)
                        .lineTo(x1, y2)
                        .lineTo(x2, y2)
                        .lineTo(x2, y1)
                        .close();
                }
            }
        }

        return path;
    };

    QRCode.prototype._renderBackground = function _renderBackground (size, border) {
        var box = new Box(0, 0, size, size).unpad(border.width / 2);
        var background = Path$7.fromRect(box.toRect(), {
            fill: {
                color: this.options.background
            },
            stroke: {
                color: border.color,
                width: border.width
            }
        });

        return background;
    };

    QRCode.prototype.setOptions = function setOptions (options) {
        var newOptions = options || {};
        this.options = extend$5(this.options, newOptions);

        if (options.value !== undefined) {
            this._value = String(this.options.value);
        }

        this._initSurface();
        this.redraw();
    };

    QRCode.prototype.value = function value (value$1) {
        if (value$1 === undefined) {
            return this._value;
        }

        this._value = String(value$1);

        this.redraw();
    };

    QRCode.prototype._hasCustomLogo = function _hasCustomLogo () {
        return Boolean(this.options.overlay.imageUrl);
    };

    QRCode.prototype._isSwiss = function _isSwiss () {
        return this.options.overlay.type === "swiss";
    };

    QRCode.prototype._getLogoSize = function _getLogoSize (defautLogoSize) {
        var width = this.options.overlay.width;
        var height = this.options.overlay.height;

        if (!width && !height) {
            width = height = defautLogoSize;
        } else if (width && !height) {
            height = width;
        } else if (!width && height) {
            width = height;
        }

        return {
            width: width,
            height: height
        };
    };

    return QRCode;
}(Class));

setDefaultOptions(QRCode, {
    name: "QRCode",
    renderAs: "svg",
    encoding: "ISO_8859_1",
    value: "",
    errorCorrection: QRCodeDefaults.DEFAULT_ERROR_CORRECTION_LEVEL,
    background: QRCodeDefaults.DEFAULT_BACKGROUND,
    color: QRCodeDefaults.DEFAULT_DARK_MODULE_COLOR,
    size: "",
    padding: 0,
    border: {
        color: "",
        width: 0
    },
    overlay: {
        type: "image",
        imageUrl: "",
        width: 0,
        height: 0
    }
});

var ISO = 'ISO_8859_1';

function qrcodeValidator(encoding) {
    if ( encoding === void 0 ) encoding = ISO;

    return function(value) {
        try {
            encodeData(value, 'L', encoding);
        } catch (error) {
            return {
                valid: false,
                error: error
            };
        }

        return {
            valid: true
        };
    };
}

// Coordinate reference system
// World Geodetic System of 1984
var WGS84$1 = {
    a: 6378137,                 // Semi-major radius
    b: 6356752.314245179,       // Semi-minor radius
    f: 0.0033528106647474805,   // Flattening
    e: 0.08181919084262149      // Eccentricity
};

// Geographic coordinate systems use a spheroid to calculate positions on the earth.
// A datum defines the position of the spheroid relative to the center of the earth
// it provides a frame of reference for measuring locations on the surface of the earth
// and defines the origin and orientation of latitude and longitude lines.
var datums = {
    WGS84: WGS84$1
};

function toSquare(value) {
    return value * value;
}


var math$4 = Math,
    abs$1 = math$4.abs,
    atan$1 = math$4.atan,
    atan2 = math$4.atan2,
    cos = math$4.cos,
    sin$1 = math$4.sin,
    tan$1 = math$4.tan;

var Location = (function (Class) {
    function Location(lat, lng) {
        Class.call(this);

        this.initProperties();

        if (arguments.length === 1) {
            this.lat = lat[0];
            this.lng = lat[1];
        } else {
            this.lat = lat;
            this.lng = lng;
        }
    }

    if ( Class ) Location.__proto__ = Class;
    Location.prototype = Object.create( Class && Class.prototype );
    Location.prototype.constructor = Location;

    Location.prototype.initProperties = function initProperties () {
        deepExtend(this, {
            DISTANCE_ITERATIONS: 100,
            DISTANCE_CONVERGENCE: 1e-12,
            DISTANCE_PRECISION: 2,
            FORMAT: '{0:N6}{1:N6}'
        });
    };

    Location.prototype.toArray = function toArray () {
        return [
            this.lat,
            this.lng
        ];
    };

    Location.prototype.equals = function equals (loc) {
        return loc && loc.lat === this.lat && loc.lng === this.lng;
    };

    Location.prototype.clone = function clone () {
        return new Location(this.lat, this.lng);
    };

    Location.prototype.round = function round$1$1 (precision) {
        this.lng = round$1(this.lng, precision);
        this.lat = round$1(this.lat, precision);
        return this;
    };

    Location.prototype.wrap = function wrap () {
        this.lng = this.lng % 180;
        this.lat = this.lat % 90;
        return this;
    };

    Location.prototype.distanceTo = function distanceTo (dest, datum) {
        return this.greatCircleTo(dest, datum).distance;
    };

    Location.prototype.destination = function destination (distance, initialBearing, initialDatum) {
        var bearing = rad(initialBearing);
        var datum = initialDatum || datums.WGS84;
        var fromLat = rad(this.lat);
        var fromLng = rad(this.lng);
        var dToR = distance / datum.a;
        var lat = math$4.asin(sin$1(fromLat) * cos(dToR) + cos(fromLat) * sin$1(dToR) * cos(bearing));
        var lng = fromLng + atan2(sin$1(bearing) * sin$1(dToR) * cos(fromLat), cos(dToR) - sin$1(fromLat) * sin$1(lat));

        return new Location(deg(lat), deg(lng));
    };

    Location.prototype.greatCircleTo = function greatCircleTo (initialDest, initialDatum) {
        var this$1$1 = this;

        var dest = Location.create(dest);
        var datum = initialDatum || datums.WGS84;

        if (!dest || this.clone().round(8).equals(dest.clone().round(8))) {
            return {
                distance: 0,
                azimuthFrom: 0,
                azimuthTo: 0
            };
        }

        // See http://en.wikipedia.org/wiki/Vincenty's_formulae#Notation
        // o == sigma
        // A == alpha

        var a = datum.a;
        var b = datum.b;
        var f = datum.f;
        var L = rad(dest.lng - this.lng);
        var U1 = atan$1((1 - f) * tan$1(rad(this.lat)));
        var sinU1 = sin$1(U1);
        var cosU1 = cos(U1);
        var U2 = atan$1((1 - f) * tan$1(rad(dest.lat)));
        var sinU2 = sin$1(U2);
        var cosU2 = cos(U2);
        var lambda = L;
        var prevLambda;
        var i = this.DISTANCE_ITERATIONS;
        var converged = false;
        var sinLambda;
        var cosLambda;
        var sino;
        var cosA2;
        var coso;
        var cos2om;
        var sigma;

        while (!converged && i-- > 0) {
            sinLambda = sin$1(lambda);
            cosLambda = cos(lambda);
            sino = math$4.sqrt(toSquare(cosU2 * sinLambda) + toSquare(cosU1 * sinU2 - sinU1 * cosU2 * cosLambda));
            coso = sinU1 * sinU2 + cosU1 * cosU2 * cosLambda;
            sigma = atan2(sino, coso);

            var sinA = cosU1 * cosU2 * sinLambda / sino;
            cosA2 = 1 - toSquare(sinA);
            cos2om = 0;

            if (cosA2 !== 0) {
                cos2om = coso - 2 * sinU1 * sinU2 / cosA2;
            }

            prevLambda = lambda;
            var C = f / 16 * cosA2 * (4 + f * (4 - 3 * cosA2));
            lambda = L + (1 - C) * f * sinA * (sigma + C * sino * (cos2om + C * coso * (-1 + 2 * toSquare(cos2om))));
            converged = abs$1(lambda - prevLambda) <= this$1$1.DISTANCE_CONVERGENCE;
        }

        var u2 = cosA2 * (toSquare(a) - toSquare(b)) / toSquare(b);
        var A = 1 + u2 / 16384 * (4096 + u2 * (-768 + u2 * (320 - 175 * u2)));
        var B = u2 / 1024 * (256 + u2 * (-128 + u2 * (74 - 47 * u2)));
        var deltao = B * sino * (cos2om + B / 4 * (coso * (-1 + 2 * toSquare(cos2om)) - B / 6 * cos2om * (-3 + 4 * toSquare(sino)) * (-3 + 4 * toSquare(cos2om))));

        var azimuthFrom = atan2(cosU2 * sinLambda, cosU1 * sinU2 - sinU1 * cosU2 * cosLambda);
        var azimuthTo = atan2(cosU1 * sinLambda, -sinU1 * cosU2 + cosU1 * sinU2 * cosLambda);

        return {
            distance: round$1(b * A * (sigma - deltao), this.DISTANCE_PRECISION),
            azimuthFrom: deg(azimuthFrom),
            azimuthTo: deg(azimuthTo)
        };
    };

    // IE < 9 doesn't allow to override toString on definition
    Location.prototype.toString = function toString () {
        // return kendo.format(this.FORMAT, this.lat, this.lng);
        return String(this.lat) + "," + String(this.lng);
    };

    Location.fromLngLat = function fromLngLat (lngAndLat) {
        return new Location(lngAndLat[1], lngAndLat[0]);
    };

    Location.fromLatLng = function fromLatLng (lngAndLat) {
        return new Location(lngAndLat[0], lngAndLat[1]);
    };

    Location.create = function create (a, b) {
        if (defined(a)) {
            if (a instanceof Location) {
                return a.clone();
            } else if (arguments.length === 1 && a.length === 2) {
                return Location.fromLatLng(a);
            }

            return new Location(a, b);
        }
    };

    return Location;
}(Class));

var math$3 = Math,
    atan = math$3.atan,
    exp = math$3.exp,
    pow$1 = math$3.pow,
    sin = math$3.sin,
    log = math$3.log,
    tan = math$3.tan,
    Point$2 = Point$6;

var PI = math$3.PI,
    PI_DIV_2 = PI / 2,
    PI_DIV_4 = PI / 4,
    DEG_TO_RAD = PI / 180;

var WGS84 = datums.WGS84;

// WGS 84 / World Mercator
var Mercator = (function (Class) {
    function Mercator(options) {
        Class.call(this);
        this.initProperties();
        this._initOptions(options);
    }

    if ( Class ) Mercator.__proto__ = Class;
    Mercator.prototype = Object.create( Class && Class.prototype );
    Mercator.prototype.constructor = Mercator;

    Mercator.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    Mercator.prototype.initProperties = function initProperties () {
        // super.initProperties();

        deepExtend(this, {
            MAX_LNG: 180,
            MAX_LAT: 85.0840590501,
            INVERSE_ITERATIONS: 15,
            INVERSE_CONVERGENCE: 1e-12
        });
    };

    Mercator.prototype.forward = function forward (loc, clamp) {
        var proj = this,
            options = proj.options,
            datum = options.datum,
            r = datum.a,
            lng0 = options.centralMeridian,
            lat = limitValue(loc.lat, -proj.MAX_LAT, proj.MAX_LAT),
            lng = clamp ? limitValue(loc.lng, -proj.MAX_LNG, proj.MAX_LNG) : loc.lng,
            x = rad(lng - lng0) * r,
            y = proj._projectLat(lat);
        return new Point$2(x, y);
    };
    Mercator.prototype._projectLat = function _projectLat (lat) {
        var datum = this.options.datum,
            ecc = datum.e,
            r = datum.a,
            y = rad(lat),
            ts = tan(PI_DIV_4 + y / 2),
            con = ecc * sin(y),
            p = pow$1((1 - con) / (1 + con), ecc / 2);

        // See: http://en.wikipedia.org/wiki/Mercator_projection#Generalization_to_the_ellipsoid
        return r * log(ts * p);
    };
    Mercator.prototype.inverse = function inverse (point, clamp) {
        var proj = this,
            options = proj.options,
            datum = options.datum,
            r = datum.a,
            lng0 = options.centralMeridian,
            lng = point.x / (DEG_TO_RAD * r) + lng0,
            lat = limitValue(proj._inverseY(point.y), -proj.MAX_LAT, proj.MAX_LAT);
        if (clamp) {
            lng = limitValue(lng, -proj.MAX_LNG, proj.MAX_LNG);
        }
        return new Location(lat, lng);
    };
    Mercator.prototype._inverseY = function _inverseY (y) {
        var proj = this,
            datum = proj.options.datum,
            r = datum.a,
            ecc = datum.e,
            ecch = ecc / 2,
            ts = exp(-y / r),
            phi = PI_DIV_2 - 2 * atan(ts),
            i;
        for (i = 0; i <= proj.INVERSE_ITERATIONS; i++) {
            var con = ecc * sin(phi),
                p = pow$1((1 - con) / (1 + con), ecch),
                dphi = PI_DIV_2 - 2 * atan(ts * p) - phi;
            phi += dphi;
            if (math$3.abs(dphi) <= proj.INVERSE_CONVERGENCE) {
                break;
            }
        }
        return deg(phi);
    };

    return Mercator;
}(Class));

setDefaultOptions(Mercator, {
    centralMeridian: 0,
    datum: WGS84
});


// WGS 84 / Pseudo-Mercator
// Used by Google Maps, Bing, OSM, etc.
// Spherical projection of ellipsoidal coordinates.
var SphericalMercator = (function (Mercator) {
    function SphericalMercator () {
        Mercator.apply(this, arguments);
    }

    if ( Mercator ) SphericalMercator.__proto__ = Mercator;
    SphericalMercator.prototype = Object.create( Mercator && Mercator.prototype );
    SphericalMercator.prototype.constructor = SphericalMercator;

    SphericalMercator.prototype.initProperties = function initProperties () {
        Mercator.prototype.initProperties.call(this);

        deepExtend(this, {
            MAX_LAT: 85.0511287798
        });
    };

    SphericalMercator.prototype._projectLat = function _projectLat (lat) {
        var r = this.options.datum.a,
            y = rad(lat),
            ts = tan(PI_DIV_4 + y / 2);
        return r * log(ts);
    };

    SphericalMercator.prototype._inverseY = function _inverseY (y) {
        var r = this.options.datum.a,
            ts = exp(-y / r);
        return deg(PI_DIV_2 - 2 * atan(ts));
    };

    return SphericalMercator;
}(Mercator));

var Equirectangular = (function (Class) {
    function Equirectangular () {
        Class.apply(this, arguments);
    }

    if ( Class ) Equirectangular.__proto__ = Class;
    Equirectangular.prototype = Object.create( Class && Class.prototype );
    Equirectangular.prototype.constructor = Equirectangular;

    Equirectangular.prototype.forward = function forward (loc) {
        return new Point$2(loc.lng, loc.lat);
    };
    Equirectangular.prototype.inverse = function inverse (point) {
        return new Location(point.y, point.x);
    };

    return Equirectangular;
}(Class));

// This is the projected coordinate system used for rendering maps in Google Maps, OpenStreetMap, etc
// Unit: metre
// Geodetic CRS: WGS 84
// Scope: Certain Web mapping and visualisation applications. It is not a recognised geodetic system: for that see ellipsoidal Mercator CRS code 3395 (WGS 84 / World Mercator).
// Remarks: Uses spherical development of ellipsoidal coordinates. Relative to WGS 84 / World Mercator (CRS code 3395) errors of 0.7 percent in scale and differences in northing of up to 43km in the map (equivalent to 21km on the ground) may arise.
// Area of use: World between 85.06°S and 85.06°N.
// Coordinate system: Cartesian 2D CS. Axes: easting, northing (X,Y). Orientations: east, north. UoM: m.
// https://epsg.io/3857
var EPSG3857 = (function (Class) {
    function EPSG3857() {
        Class.call(this);
        var crs = this,
            proj = crs._proj = new SphericalMercator();
        var c = this.c = 2 * PI * proj.options.datum.a;

        // transfrom matrix
        // Scale circumference to 1, mirror Y and shift origin to top left
        this._tm = transform().translate(0.5, 0.5).scale(1 / c, -1 / c);

        // Inverse transform matrix
        this._itm = transform().scale(c, -c).translate(-0.5, -0.5);
    }

    if ( Class ) EPSG3857.__proto__ = Class;
    EPSG3857.prototype = Object.create( Class && Class.prototype );
    EPSG3857.prototype.constructor = EPSG3857;

    // Location <-> Point (screen coordinates for a given scale)
    EPSG3857.prototype.toPoint = function toPoint (loc, scale, clamp) {
        var point = this._proj.forward(loc, clamp);
        return point.transform(this._tm).scale(scale || 1);
    };
    EPSG3857.prototype.toLocation = function toLocation (point, scale, clamp) {
        var newPoint = point.clone().scale(1 / (scale || 1)).transform(this._itm);
        return this._proj.inverse(newPoint, clamp);
    };

    return EPSG3857;
}(Class));

// Unit: metre
// Geodetic CRS: WGS 84
// Scope: Very small scale mapping.
// Remarks: Euro-centric view of world excluding polar areas.
// Area of use: World between 80°S and 84°N.
// Coordinate system: Cartesian 2D CS. Axes: easting, northing (E,N). Orientations: east, north. UoM: m.
// https://epsg.io/3395
var EPSG3395 = (function (Class) {
    function EPSG3395() {
        Class.call(this);
        this._proj = new Mercator();
    }

    if ( Class ) EPSG3395.__proto__ = Class;
    EPSG3395.prototype = Object.create( Class && Class.prototype );
    EPSG3395.prototype.constructor = EPSG3395;
    EPSG3395.prototype.toPoint = function toPoint (loc) {
        return this._proj.forward(loc);
    };
    EPSG3395.prototype.toLocation = function toLocation (point) {
        return this._proj.inverse(point);
    };

    return EPSG3395;
}(Class));

// Unit: degree
// Geodetic CRS: WGS 84
// Scope: Horizontal component of 3D system. Used by the GPS satellite navigation system and for NATO military geodetic surveying.
// Area of use: World.
// Coordinate system: Ellipsoidal 2D CS. Axes: latitude, longitude. Orientations: north, east. UoM: degree
// https://epsg.io/4326
var EPSG4326 = (function (Class) {
    function EPSG4326() {
        Class.call(this);
        this._proj = new Equirectangular();
    }

    if ( Class ) EPSG4326.__proto__ = Class;
    EPSG4326.prototype = Object.create( Class && Class.prototype );
    EPSG4326.prototype.constructor = EPSG4326;
    EPSG4326.prototype.toPoint = function toPoint (loc) {
        return this._proj.forward(loc);
    };
    EPSG4326.prototype.toLocation = function toLocation (point) {
        return this._proj.inverse(point);
    };

    return EPSG4326;
}(Class));

/* eslint-disable arrow-body-style, no-useless-escape */

var extend$4 = Object.assign;

var proxy = function (method, context) {
    return method.bind(context);
};

var convertToHtml = function (html) {
    var div = document.createElement("div");
    div.innerHTML = html;
    return div.firstChild;
};

var appendHtml = function (html, element) {
    var div = document.createElement('div');
    div.innerHTML = html;

    // use childNodes instead of children
    // to cover text nodes as well
    while (div.childNodes.length > 0) {
        element.appendChild(div.childNodes[0]);
    }
};

var removeChildren = function (element) {
    while (element.firstChild) {
        element.removeChild(element.firstChild);
    }
};

var prepend = function (element, originElement) {
    originElement.insertBefore(element, originElement.firstChild);
};

var wrapInner = function (parent, wrapper) {
    parent.appendChild(wrapper);

    while (parent.firstChild !== wrapper) {
        wrapper.appendChild(parent.firstChild);
    }
};

var toHyphens = function (str) {
    var result = str.replace(/([a-z][A-Z])/g, function(g) {
        return g.charAt(0) + '-' + g.charAt(1).toLowerCase();
    });

    return result;
};

var toPixels = function (value) {
    var result;

    if (value && String(value).endsWith("px")) {
        result = value;
    } else {
        result = String(value) + "px";
    }

    return result;
};

var hasNativeScrolling = function (userAgent) {
    var ref = getSupportedFeatures(userAgent);
    var mobileOS = ref.mobileOS;
    return mobileOS.ios || mobileOS.android;
};

var setDefaultEvents = function (type, events) {
    var proto = type.prototype;

    if (proto.events) {
        events.forEach(function (event) {
            if (proto.events.indexOf(event) < 0) {
                proto.events.push(event);
            }
        });
    } else {
        proto.events = events;
    }
};

var wheelDeltaY = function (e) {
    var deltaY = e.wheelDeltaY;
    var delta;

    if (e.wheelDelta) { // Webkit and IE
        if (deltaY === undefined || deltaY) { // IE does not have deltaY, thus always scroll (horizontal scrolling is treated as vertical)
            delta = e.wheelDelta;
        }
    } else if (e.detail && e.axis === e.VERTICAL_AXIS) { // Firefox and Opera
        delta = (-e.detail) * 10;
    }

    return delta;
};

var renderPos = function (pos) {
    var result = [];

    if (pos) {
        var parts = toHyphens(pos).split("-");

        for (var i = 0; i < parts.length; i++) {
            result.push("k-pos-" + parts[i]);
        }
    }

    return result.join(" ");
};

/* eslint-enable arrow-body-style, no-useless-escape */

var Attribution = (function (Observable) {
    function Attribution(element, options) {
        Observable.call(this);
        this.element = element;

        this._initOptions(options);
        this.items = [];

        addClass(this.element, 'k-widget k-attribution');
    }

    if ( Observable ) Attribution.__proto__ = Observable;
    Attribution.prototype = Object.create( Observable && Observable.prototype );
    Attribution.prototype.constructor = Attribution;

    Attribution.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    Attribution.prototype.filter = function filter (extent, zoom) {
        this._extent = extent;
        this._zoom = zoom;
        this._render();
    };

    Attribution.prototype.add = function add (item) {
        var newItem = item;

        if (defined(item)) {
            if (typeof item === 'string') {
                newItem = {
                    text: item
                };
            }

            this.items.push(newItem);
            this._render();
        }
    };

    Attribution.prototype.remove = function remove (text) {
        var this$1$1 = this;

        var result = [];

        for (var i = 0; i < this.items.length; i++) {
            var item = this$1$1.items[i];

            if (item.text !== text) {
                result.push(item);
            }
        }

        this.items = result;
        this._render();
    };

    Attribution.prototype.clear = function clear () {
        this.items = [];
        removeChildren(this.element);
    };

    Attribution.prototype._render = function _render () {
        var this$1$1 = this;

        var result = [];

        for (var i = 0; i < this.items.length; i++) {
            var item = this$1$1.items[i];
            var text = this$1$1._itemText(item);

            if (text !== '') {
                result.push(text);
            }
        }

        if (result.length > 0) {
            removeChildren(this.element);

            var html = result.join(this.options.separator);
            appendHtml(html, this.element);

            this.showElement();
        } else {
            this.hideElement();
        }
    };

    Attribution.prototype.hideElement = function hideElement () {
        this.element.style.display = "none";
    };

    Attribution.prototype.showElement = function showElement () {
        this.element.style.display = "";
    };

    Attribution.prototype._itemText = function _itemText (item) {
        var text = '';
        var inZoomLevel = this._inZoomLevel(item.minZoom, item.maxZoom);
        var inArea = this._inArea(item.extent);

        if (inZoomLevel && inArea) {
            text += item.text;
        }

        return text;
    };

    Attribution.prototype._inZoomLevel = function _inZoomLevel (min, max) {
        var result = true;
        var newMin = valueOrDefault(min, -Number.MAX_VALUE);
        var newMax = valueOrDefault(max, Number.MAX_VALUE);

        result = this._zoom > newMin && this._zoom < newMax;
        return result;
    };

    Attribution.prototype._inArea = function _inArea (area) {
        var result = true;

        if (area) {
            result = area.contains(this._extent);
        }

        return result;
    };

    return Attribution;
}(Observable));

setDefaultOptions(Attribution, {
    name: 'Attribution',
    separator: '&nbsp;|&nbsp;'
});

var PAN = "pan";

var directionsMap = {
    up: {
        className: "k-navigator-n",
        iconClass: "k-i-caret-alt-up"
    },
    down: {
        className: "k-navigator-s",
        iconClass: "k-i-caret-alt-down"
    },
    right: {
        className: "k-navigator-e",
        iconClass: "k-i-caret-alt-right"
    },
    left: {
        className: "k-navigator-w",
        iconClass: "k-i-caret-alt-left"
    }
};

function createButton$1(direction, iconOptions) {
    var html =
        '<button class="k-button k-button-square k-rounded-full k-button-flat k-button-flat-base k-icon-button ' +
            directionsMap[direction].className +
            '" aria-label="move ' + direction + '">' +
            renderIcon({ icon: ("caret-alt-" + direction), iconClass: "k-button-icon", svgIcons: iconOptions.svgIcons, type: iconOptions.type }) +
        '</button>';

    return convertToHtml(html);
}

var Navigator = (function (Observable) {
    function Navigator(element, options) {
        Observable.call(this);

        this.element = element;
        this._initOptions(options);

        var navigateUpButton = createButton$1("up", options.icons);
        var navigateRightlButton = createButton$1("right", options.icons);
        var navigateDownButton = createButton$1("down", options.icons);
        var navigateLeftButton = createButton$1("left", options.icons);

        this.element.appendChild(navigateUpButton);
        this.element.appendChild(navigateRightlButton);
        this.element.appendChild(navigateDownButton);
        this.element.appendChild(navigateLeftButton);

        addClass(this.element, 'k-widget k-navigator');

        on(this.element, "click", ".k-button", proxy(this._click, this));

        var parentElement = this.element.parentNode.closest("[data-role]");

        this._keyroot = parentElement ? parentElement : this.element;
        this._tabindex(this._keyroot);

        this._keydownHandler = proxy(this._keydown, this);
        on(this._keyroot, "keydown", this._keydownHandler);
    }

    if ( Observable ) Navigator.__proto__ = Observable;
    Navigator.prototype = Object.create( Observable && Observable.prototype );
    Navigator.prototype.constructor = Navigator;

    Navigator.prototype.destroy = function destroy () {
        this.dispose();
    };

    // originates from the kendo.jquery version
    Navigator.prototype.dispose = function dispose () {
        off(this._keyroot, "keydown", this._keydownHandler);
    };

    Navigator.prototype._tabindex = function _tabindex (target) {
        var targetElement = target || this.wrapper || this.element;

        var element = this.element,
            TABINDEX = "tabindex",
            tabindex = targetElement.getAttribute(TABINDEX) || element.getAttribute(TABINDEX);

        element.removeAttribute(TABINDEX);

        targetElement.setAttribute(TABINDEX, !isNaN(tabindex) ? tabindex : 0);
    };

    Navigator.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    Navigator.prototype._pan = function _pan (x, y) {
        var panStep = this.options.panStep;

        this.trigger(PAN, {
            x: x * panStep,
            y: y * panStep
        });
    };

    Navigator.prototype._click = function _click (e) {
        var x = 0;
        var y = 0;
        var button = e.currentTarget;

        if (button.matches('.k-navigator-n')) {
            y = 1;
        } else if (button.matches('.k-navigator-s')) {
            y = -1;
        } else if (button.matches('.k-navigator-e')) {
            x = 1;
        } else if (button.matches('.k-navigator-w')) {
            x = -1;
        }

        this._pan(x, y);

        e.preventDefault();
    };

    Navigator.prototype._keydown = function _keydown (e) {
        switch (e.which) {
            case keys.UP:
                this._pan(0, 1);
                e.preventDefault();
                break;
            case keys.DOWN:
                this._pan(0, -1);
                e.preventDefault();
                break;
            case keys.RIGHT:
                this._pan(1, 0);
                e.preventDefault();
                break;
            case keys.LEFT:
                this._pan(-1, 0);
                e.preventDefault();
                break;
            default:
                break;
        }
    };

    return Navigator;
}(Observable));

setDefaultOptions(Navigator, {
    name: 'Navigator',
    panStep: 1
});


setDefaultEvents(Navigator, [
    PAN
]);

function createButton(direction, icon, iconOptions) {
    var html =
        '<button class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-icon-button k-zoom-' + direction +
            '" title="zoom-' + direction +
            '" aria-label="zoom-' + direction + '">' +
            renderIcon({ icon: icon, iconClass: "k-button-icon", svgIcons: iconOptions.svgIcons, type: iconOptions.type }) +
        '</button>';

    return convertToHtml(html);
}

var PLUS = 187;
var MINUS = 189;
var FF_PLUS = 61;
var FF_MINUS = 173;
var CHANGE$2 = "change";

var ZoomControl = (function (Observable) {
    function ZoomControl(element, options, iconOptions) {
        Observable.call(this);
        this.element = element;
        this._initOptions(options);

        var zoomInButton = createButton('in', 'plus', iconOptions);
        var zoomOutButton = createButton('out', 'minus', iconOptions);

        this.element.appendChild(zoomInButton);
        this.element.appendChild(zoomOutButton);
        this.element.setAttribute("role", "group");

        addClass(this.element, 'k-widget k-zoom-control k-button-group k-group-horizontal');

        this._clickHandler = this._click.bind(this);
        on(this.element, "click", ".k-button", this._clickHandler);

        var parentElement = this.element.parentNode.closest("[data-role]");

        this._keyroot = parentElement ? parentElement : this.element;

        this._tabindex(this._keyroot);

        this._keydownHandler = this._keydown.bind(this);
        on(this._keyroot, "keydown", this._keydownHandler);
    }

    if ( Observable ) ZoomControl.__proto__ = Observable;
    ZoomControl.prototype = Object.create( Observable && Observable.prototype );
    ZoomControl.prototype.constructor = ZoomControl;

    ZoomControl.prototype.destroy = function destroy () {
        if (this.element) {
            off(this.element, "click", this._clickHandler);
        }

        if (this._keyroot) {
            off(this._keyroot, 'keydown', this._keydownHandler);
        }
    };

    ZoomControl.prototype._tabindex = function _tabindex (target) {
        var targetElement = target || this.wrapper || this.element;

        var element = this.element,
            TABINDEX = "tabindex",
            tabindex = targetElement.getAttribute(TABINDEX) || element.getAttribute(TABINDEX);

        element.removeAttribute(TABINDEX);

        targetElement.setAttribute(TABINDEX, !isNaN(tabindex) ? tabindex : 0);
    };

    ZoomControl.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    ZoomControl.prototype._change = function _change (direction) {
        var zoomStep = this.options.zoomStep;
        this.trigger(CHANGE$2, { delta: direction * zoomStep });
    };

    ZoomControl.prototype._click = function _click (e) {
        var button = e.currentTarget;
        var direction = 1;

        if (hasClasses(button, 'k-zoom-out')) {
            direction = -1;
        }

        this._change(direction);
        e.preventDefault();
    };

    ZoomControl.prototype._keydown = function _keydown (e) {
        switch (e.which) {
            case keys.NUMPAD_PLUS:
            case PLUS:
            case FF_PLUS:
                this._change(1);
                break;
            case keys.NUMPAD_MINUS:
            case MINUS:
            case FF_MINUS:
                this._change(-1);
                break;
            default:
                break;
        }
    };

    return ZoomControl;
}(Observable));

setDefaultOptions(ZoomControl, {
    name: 'ZoomControl',
    zoomStep: 1
});

setDefaultEvents(ZoomControl, [
    CHANGE$2
]);

var math$2 = Math,
    max$1 = math$2.max,
    min$2 = math$2.min;

var Extent = (function (Class) {
    function Extent(initialNw, initialSe) {
        Class.call(this);
        var nw = Location.create(initialNw);
        var se = Location.create(initialSe);

        if (nw.lng + 180 > se.lng + 180 && nw.lat + 90 < se.lat + 90) {
            this.se = nw;
            this.nw = se;
        } else {
            this.se = se;
            this.nw = nw;
        }
    }

    if ( Class ) Extent.__proto__ = Class;
    Extent.prototype = Object.create( Class && Class.prototype );
    Extent.prototype.constructor = Extent;

    var staticAccessors = { World: { configurable: true } };

    Extent.prototype.contains = function contains (loc) {
        var nw = this.nw, se = this.se, lng = valueOrDefault(loc.lng, loc[1]), lat = valueOrDefault(loc.lat, loc[0]);

        return loc &&
            lng + 180 >= nw.lng + 180 && lng + 180 <= se.lng + 180 &&
            lat + 90 >= se.lat + 90 && lat + 90 <= nw.lat + 90;
    };

    Extent.prototype.center = function center () {
        var nw = this.nw;
        var se = this.se;
        var lng = nw.lng + (se.lng - nw.lng) / 2;
        var lat = nw.lat + (se.lat - nw.lat) / 2;

        return new Location(lat, lng);
    };

    Extent.prototype.containsAny = function containsAny (locs) {
        var this$1$1 = this;

        var result = false;

        for (var i = 0; i < locs.length; i++) {
            result = result || this$1$1.contains(locs[i]);
        }

        return result;
    };

    Extent.prototype.include = function include (loc) {
        var nw = this.nw, se = this.se, lng = valueOrDefault(loc.lng, loc[1]), lat = valueOrDefault(loc.lat, loc[0]);

        nw.lng = min$2(nw.lng, lng);
        nw.lat = max$1(nw.lat, lat);
        se.lng = max$1(se.lng, lng);
        se.lat = min$2(se.lat, lat);
    };

    Extent.prototype.includeAll = function includeAll (locs) {
        var this$1$1 = this;

        for (var i = 0; i < locs.length; i++) {
            this$1$1.include(locs[i]);
        }
    };

    Extent.prototype.edges = function edges () {
        var nw = this.nw, se = this.se;

        return {
            nw: this.nw,
            ne: new Location(nw.lat, se.lng),
            se: this.se,
            sw: new Location(se.lat, nw.lng)
        };
    };

    Extent.prototype.toArray = function toArray () {
        var nw = this.nw, se = this.se;

        return [
            nw,
            new Location(nw.lat, se.lng),
            se,
            new Location(se.lat, nw.lng)
        ];
    };

    Extent.prototype.overlaps = function overlaps (extent) {
        return this.containsAny(extent.toArray()) ||
            extent.containsAny(this.toArray());
    };

    Extent.create = function create (a, b) {
        if (a instanceof Extent) {
            return a;
        } else if (a && b) {
            return new Extent(a, b);
        } else if (a && a.length === 4 && !b) {
            return new Extent([
                a[0],
                a[1]
            ], [
                a[2],
                a[3]
            ]);
        }
    };

    staticAccessors.World.get = function () {
        return new Extent([ 90, -180 ], [ -90, 180 ]);
    };

    Object.defineProperties( Extent, staticAccessors );

    return Extent;
}(Class));

var SHOW_TOOLTIP = 'showTooltip';
var HIDE_TOOLTIP = 'hideTooltip';
var CENTER_CHANGE = 'centerChange';
var ZOOM_CHANGE = 'zoomChange';
var INIT = 'init';

var Tooltip = (function (Class) {
    function Tooltip(widgetService, options) {
        Class.call(this);

        this.widgetService = widgetService;
        this.options = deepExtend({}, this.options, options);
        this.offset = { x: 0, y: 0 };
    }

    if ( Class ) Tooltip.__proto__ = Class;
    Tooltip.prototype = Object.create( Class && Class.prototype );
    Tooltip.prototype.constructor = Tooltip;

    var prototypeAccessors = { anchor: { configurable: true } };

    Tooltip.prototype.show = function show (anchor, args) {
        if (this.location === args.location) {
            return;
        }

        this.anchor = anchor;
        this.location = args.location;

        this.widgetService.notify(SHOW_TOOLTIP,
            Object.assign({ anchor: this.anchor }, args)
        );

        this.visible = true;
    };

    Tooltip.prototype.hide = function hide () {
        if (this.widgetService) {
            this.widgetService.notify(HIDE_TOOLTIP);
        }

        this.visible = false;
        this.location = null;
    };

    prototypeAccessors.anchor.get = function () {
        return this._anchor;
    };

    prototypeAccessors.anchor.set = function (anchor) {
        var documentPoint = this.widgetService.widget._toDocumentCoordinates({
            x: anchor.left - this.offset.x,
            y: anchor.top - this.offset.y
        });

        this._anchor = {
            left: documentPoint.left,
            top: documentPoint.top
        };
    };

    Tooltip.prototype.destroy = function destroy () {
        this.widgetService = null;
    };

    Object.defineProperties( Tooltip.prototype, prototypeAccessors );

    return Tooltip;
}(Class));

setDefaultOptions(Tooltip, {
    border: {
        width: 1
    },
    opacity: 1
});

var Layer = (function (Class) {
    function Layer(map, options) {
        Class.call(this);

        this.support = getSupportedFeatures();

        this._initOptions(options);
        this.map = map;

        var element = document.createElement("div");
        addClass(element, "k-layer");
        element.style.zIndex = this.options.zIndex;
        element.style.opacity = this.options.opacity;

        this.element = element;

        map.scrollElement.appendChild(this.element);

        this._beforeReset = this._beforeReset.bind(this);
        this._reset = this._reset.bind(this);
        this._resize = this._resize.bind(this);
        this._panEnd = this._panEnd.bind(this);

        this._activate();
        this._updateAttribution();
    }

    if ( Class ) Layer.__proto__ = Class;
    Layer.prototype = Object.create( Class && Class.prototype );
    Layer.prototype.constructor = Layer;

    Layer.prototype.destroy = function destroy () {
        this._deactivate();
    };

    Layer.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    Layer.prototype.show = function show () {
        this.reset();
        this._activate();
        this._applyExtent(true);
    };

    Layer.prototype.hide = function hide () {
        this._deactivate();
        this._setVisibility(false);
    };

    Layer.prototype.reset = function reset () {
        this._beforeReset();
        this._reset();
    };

    Layer.prototype._reset = function _reset () {
        this._applyExtent();
    };

    Layer.prototype._beforeReset = function _beforeReset () {

    };

    Layer.prototype._resize = function _resize () {

    };

    Layer.prototype._panEnd = function _panEnd () {
        this._applyExtent();
    };

    Layer.prototype._applyExtent = function _applyExtent () {
        var options = this.options;
        var zoom = this.map.zoom();
        var matchMinZoom = !defined(options.minZoom) || zoom >= options.minZoom;
        var matchMaxZoom = !defined(options.maxZoom) || zoom <= options.maxZoom;
        var extent = Extent.create(options.extent);
        var inside = !extent || extent.overlaps(this.map.extent());

        this._setVisibility(matchMinZoom && matchMaxZoom && inside);
    };

    Layer.prototype._setVisibility = function _setVisibility (visible) {
        this.element.style.display = visible ? '' : 'none';
    };

    Layer.prototype._activate = function _activate () {
        var map = this.map;

        this._deactivate();

        map.bind('beforeReset', this._beforeReset);
        map.bind('reset', this._reset);
        map.bind('resize', this._resize);
        map.bind('panEnd', this._panEnd);
    };

    Layer.prototype._deactivate = function _deactivate () {
        var map = this.map;

        map.unbind('beforeReset', this._beforeReset);
        map.unbind('reset', this._reset);
        map.unbind('resize', this._resize);
        map.unbind('panEnd', this._panEnd);
    };

    Layer.prototype._updateAttribution = function _updateAttribution () {
        var attribution = this.map.attribution;

        if (attribution) {
            attribution.add(this.options.attribution);
        }
    };

    Layer.prototype._readData = function _readData () {
        var data = this.options.data || [];
        return data;
    };

    Layer.prototype._hasData = function _hasData () {
        return this._data && this._data.length > 0;
    };

    Layer.prototype._layerIndex = function _layerIndex () {
        var layers = this.map.layers || [];
        return layers.indexOf(this);
    };

    return Layer;
}(Class));

var math$1 = Math,
    Point$1 = Point$6;

function compileTemplate(template) {
    if (isFunction(template)) {
        return template;
    }

    return TemplateService.compile(template);
}

function roundPoint(point) {
    return new Point$1(round$1(point.x), round$1(point.y));
}

function renderSize(size) {
    var newSize = size;

    if (typeof(size) !== "string") {
        newSize += "px";
    }

    return newSize;
}

var TileLayer = (function (Layer) {
    function TileLayer(map, options) {
        Layer.call(this, map, options);

        if (typeof this.options.subdomains === 'string') {
            this.options.subdomains = this.options.subdomains.split('');
        }

        var viewType = this._viewType();
        this._view = new viewType(this.element, this.options);
    }

    if ( Layer ) TileLayer.__proto__ = Layer;
    TileLayer.prototype = Object.create( Layer && Layer.prototype );
    TileLayer.prototype.constructor = TileLayer;

    TileLayer.prototype.destroy = function destroy () {
        Layer.prototype.destroy.call(this);
        this._view.destroy();
        this._view = null;
    };

    TileLayer.prototype._beforeReset = function _beforeReset () {
        var map = this.map;
        var origin = map.locationToLayer(map.extent().nw).round();
        this._view.viewOrigin(origin);
    };

    TileLayer.prototype._reset = function _reset () {
        Layer.prototype._reset.call(this);
        this._updateView();
        this._view.reset();
    };

    TileLayer.prototype._viewType = function _viewType () {
        return TileView;
    };

    TileLayer.prototype._activate = function _activate () {
        Layer.prototype._activate.call(this);

        if (!this.support.mobileOS) {
            if (!this._pan) {
                this._pan = throttle(this._render.bind(this), 100);
            }

            this.map.bind('pan', this._pan);
        }
    };

    TileLayer.prototype._deactivate = function _deactivate () {
        Layer.prototype._deactivate.call(this);

        if (this._pan) {
            this.map.unbind('pan', this._pan);
        }
    };

    TileLayer.prototype._updateView = function _updateView () {
        var view = this._view,
            map = this.map,
            extent = map.extent(),
            extentToPoint = {
                nw: map.locationToLayer(extent.nw).round(),
                se: map.locationToLayer(extent.se).round()
            };

        view.center(map.locationToLayer(map.center()));
        view.extent(extentToPoint);
        view.zoom(map.zoom());
    };

    TileLayer.prototype._resize = function _resize () {
        this._render();
    };

    TileLayer.prototype._panEnd = function _panEnd (e) {
        Layer.prototype._panEnd.call(this, e);
        this._render();
    };

    TileLayer.prototype._render = function _render () {
        this._updateView();
        this._view.render();
    };

    return TileLayer;
}(Layer));

setDefaultOptions(TileLayer, {
    tileSize: 256,
    subdomains: ['a', 'b', 'c'],
    urlTemplate: '',
    zIndex: 1
});

var TileView = (function (Class) {
    function TileView(element, options) {
        Class.call(this);
        this.element = element;
        this._initOptions(options);
        this.pool = new TilePool();
    }

    if ( Class ) TileView.__proto__ = Class;
    TileView.prototype = Object.create( Class && Class.prototype );
    TileView.prototype.constructor = TileView;

    TileView.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    TileView.prototype.center = function center (center$1) {
        this._center = center$1;
    };

    TileView.prototype.extent = function extent (extent$1) {
        this._extent = extent$1;
    };

    TileView.prototype.viewOrigin = function viewOrigin (origin) {
        this._viewOrigin = origin;
    };

    TileView.prototype.zoom = function zoom (zoom$1) {
        this._zoom = zoom$1;
    };

    TileView.prototype.pointToTileIndex = function pointToTileIndex (point) {
        return new Point$1(math$1.floor(point.x / this.options.tileSize), math$1.floor(point.y / this.options.tileSize));
    };

    TileView.prototype.tileCount = function tileCount () {
        var size = this.size(),
            firstTileIndex = this.pointToTileIndex(this._extent.nw),
            nw = this._extent.nw,
            point = this.indexToPoint(firstTileIndex).translate(-nw.x, -nw.y);

        return {
            x: math$1.ceil((math$1.abs(point.x) + size.width) / this.options.tileSize),
            y: math$1.ceil((math$1.abs(point.y) + size.height) / this.options.tileSize)
        };
    };

    TileView.prototype.size = function size () {
        var nw = this._extent.nw,
            se = this._extent.se,
            diff = se.clone().translate(-nw.x, -nw.y);

        return {
            width: diff.x,
            height: diff.y
        };
    };

    TileView.prototype.indexToPoint = function indexToPoint (index) {
        var x = index.x,
            y = index.y;

        return new Point$1(x * this.options.tileSize, y * this.options.tileSize);
    };

    TileView.prototype.subdomainText = function subdomainText () {
        var subdomains = this.options.subdomains;
        return subdomains[this.subdomainIndex++ % subdomains.length];
    };

    TileView.prototype.destroy = function destroy () {
        removeChildren(this.element);
        this.pool.empty();
    };

    TileView.prototype.reset = function reset () {
        this.pool.reset();
        this.subdomainIndex = 0;
        this.render();
    };

    TileView.prototype.render = function render () {
        var this$1$1 = this;

        var size = this.tileCount(),
            firstTileIndex = this.pointToTileIndex(this._extent.nw),
            tile, x, y;

        for (x = 0; x < size.x; x++) {
            for (y = 0; y < size.y; y++) {
                tile = this$1$1.createTile({
                    x: firstTileIndex.x + x,
                    y: firstTileIndex.y + y
                });

                if (!tile.visible) {
                    tile.show();
                }
            }
        }
    };

    TileView.prototype.createTile = function createTile (currentIndex) {
        var options = this.tileOptions(currentIndex);
        var tile = this.pool.get(this._center, options);

        if (!tile.element.parentNode) {
            this.element.append(tile.element);
        }

        return tile;
    };

    TileView.prototype.tileOptions = function tileOptions (currentIndex) {
        var index = this.wrapIndex(currentIndex),
            point = this.indexToPoint(currentIndex),
            origin = this._viewOrigin,
            offset = point.clone().translate(-origin.x, -origin.y);

        return {
            index: index,
            currentIndex: currentIndex,
            point: point,
            offset: roundPoint(offset),
            zoom: this._zoom,
            size: this.options.tileSize,
            subdomain: this.subdomainText(),
            urlTemplate: this.options.urlTemplate,
            errorUrlTemplate: this.options.errorUrlTemplate
        };
    };

    TileView.prototype.wrapIndex = function wrapIndex (index) {
        var boundary = math$1.pow(2, this._zoom);

        return {
            x: this.wrapValue(index.x, boundary),
            y: limitValue(index.y, 0, boundary - 1)
        };
    };

    TileView.prototype.wrapValue = function wrapValue (value, boundary) {
        var remainder = math$1.abs(value) % boundary;
        var wrappedValue = value;

        if (value >= 0) {
            wrappedValue = remainder;
        } else {
            wrappedValue = boundary - (remainder === 0 ? boundary : remainder);
        }

        return wrappedValue;
    };

    return TileView;
}(Class));

var ImageTile = (function (Class) {
    function ImageTile(id, options) {
        Class.call(this);
        this.id = id;
        this.visible = true;
        this._initOptions(options);
        this.createElement();
        this.show();
    }

    if ( Class ) ImageTile.__proto__ = Class;
    ImageTile.prototype = Object.create( Class && Class.prototype );
    ImageTile.prototype.constructor = ImageTile;

    ImageTile.prototype.destroy = function destroy () {
        var element = this.element;
        var parentNode = element ? element.parentNode : null;

        if (element) {
            if (parentNode) {
                parentNode.removeChild(element);
            }

            this.element = null;
        }
    };

    ImageTile.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    ImageTile.prototype.createElement = function createElement () {
        var el = document.createElement("img");
        var size = this.options.size + "px";
        el.setAttribute("alt", "");
        el.style.position = "absolute";
        el.style.display = "block";
        el.style.width = el.style.maxWidth = size;
        el.style.height = el.style.maxHeight = size;

        this.element = el;

        // todo
        // add on error handler

        // this.element =
        // $('<img style=\'position: absolute; display: block;\' alt=\'\' />')
        // .css({
        //     width: this.options.size,
        //     height: this.options.size
        // })
        // .on('error', proxy(function(e) {
        //     if (this.errorUrl()) {
        //         e.target.setAttribute('src', this.errorUrl());
        //     } else {
        //         e.target.removeAttribute('src');
        //     }
        // }, this));
    };

    ImageTile.prototype.show = function show () {
        var element = this.element;
        element.style.top = renderSize(this.options.offset.y);
        element.style.left = renderSize(this.options.offset.x);

        var url = this.url();

        if (url) {
            element.setAttribute('src', url);
        }

        element.style.visibility = 'visible';
        this.visible = true;
    };

    ImageTile.prototype.hide = function hide () {
        this.element.style.visibility = 'hidden';
        this.visible = false;
    };

    ImageTile.prototype.url = function url () {
        var urlResult = compileTemplate(this.options.urlTemplate);
        return urlResult(this.urlOptions());
    };

    ImageTile.prototype.errorUrl = function errorUrl () {
        var urlResult = compileTemplate(this.options.errorUrlTemplate);
        return urlResult(this.urlOptions());
    };

    ImageTile.prototype.urlOptions = function urlOptions () {
        var options = this.options;

        return {
            zoom: options.zoom,
            subdomain: options.subdomain,
            z: options.zoom,
            x: options.index.x,
            y: options.index.y,
            s: options.subdomain,
            quadkey: options.quadkey,
            q: options.quadkey,
            culture: options.culture,
            c: options.culture
        };
    };

    return ImageTile;
}(Class));

setDefaultOptions(ImageTile, {
    urlTemplate: '',
    errorUrlTemplate: ''
});

var TilePool = (function (Class) {
    function TilePool() {
        Class.call(this);
        this._items = [];
    }

    if ( Class ) TilePool.__proto__ = Class;
    TilePool.prototype = Object.create( Class && Class.prototype );
    TilePool.prototype.constructor = TilePool;

    TilePool.prototype.get = function get (center, options) {
        if (this._items.length >= this.options.maxSize) {
            this._remove(center);
        }

        return this._create(options);
    };

    TilePool.prototype.empty = function empty () {
        var items = this._items;

        for (var i = 0; i < items.length; i++) {
            items[i].destroy();
        }

        this._items = [];
    };

    TilePool.prototype.reset = function reset () {
        var items = this._items;

        for (var i = 0; i < items.length; i++) {
            items[i].hide();
        }
    };

    TilePool.prototype._create = function _create (options) {
        var items = this._items;
        var tile;
        var id = hashKey(options.point.toString() + options.offset.toString() + options.zoom + options.urlTemplate);

        for (var i = 0; i < items.length; i++) {
            if (items[i].id === id) {
                tile = items[i];
                break;
            }
        }

        if (tile) {
            tile.show();
        } else {
            tile = new ImageTile(id, options);
            this._items.push(tile);
        }

        return tile;
    };

    TilePool.prototype._remove = function _remove (center) {
        var items = this._items;
        var maxDist = -1;
        var index = -1;

        for (var i = 0; i < items.length; i++) {
            var dist = items[i].options.point.distanceTo(center);

            if (dist > maxDist && !items[i].visible) {
                index = i;
                maxDist = dist;
            }
        }

        if (index !== -1) {
            items[index].destroy();
            items.splice(index, 1);
        }
    };

    return TilePool;
}(Class));

setDefaultOptions(TilePool, {
    maxSize: 100
});

var extend$3 = Object.assign;

var CHANGE$1 = 'change';

var TapCapture = (function (Observable) {
    function TapCapture(element, options) {
        Observable.call(this);
        var that = this,
            domElement = element[0] || element;

        that.capture = false;

        if (domElement.addEventListener) {
            eventMap.down.split(' ').forEach(function(event) {
                domElement.addEventListener(event, proxy(that._press, that), true);
            });
            eventMap.up.split(' ').forEach(function(event) {
                domElement.addEventListener(event, proxy(that._release, that), true);
            });
        } else {
            eventMap.down.split(' ').forEach(function(event) {
                domElement.attachEvent(event, proxy(that._press, that));
            });
            eventMap.up.split(' ').forEach(function(event) {
                domElement.attachEvent(event, proxy(that._release, that));
            });
        }

        that.bind([
            'press',
            'release'
        ], options || {});
    }

    if ( Observable ) TapCapture.__proto__ = Observable;
    TapCapture.prototype = Object.create( Observable && Observable.prototype );
    TapCapture.prototype.constructor = TapCapture;

    TapCapture.prototype.captureNext = function captureNext () {
        this.capture = true;
    };

    TapCapture.prototype.cancelCapture = function cancelCapture () {
        this.capture = false;
    };

    TapCapture.prototype._press = function _press (e) {
        var that = this;

        that.trigger('press');

        if (that.capture) {
            e.preventDefault();
        }
    };

    TapCapture.prototype._release = function _release (e) {
        var that = this;

        that.trigger('release');

        if (that.capture) {
            e.preventDefault();
            that.cancelCapture();
        }
    };

    return TapCapture;
}(Observable));

var PaneDimension = (function (Observable) {
    function PaneDimension(options) {
        Observable.call(this);
        var that = this;
        that.forcedEnabled = false;
        extend$3(that, options);
        that.scale = 1;

        if (that.horizontal) {
            that.measure = 'offsetWidth';
            that.scrollSize = 'scrollWidth';
            that.axis = 'x';
        } else {
            that.measure = 'offsetHeight';
            that.scrollSize = 'scrollHeight';
            that.axis = 'y';
        }
    }

    if ( Observable ) PaneDimension.__proto__ = Observable;
    PaneDimension.prototype = Object.create( Observable && Observable.prototype );
    PaneDimension.prototype.constructor = PaneDimension;

    PaneDimension.prototype.makeVirtual = function makeVirtual () {
        extend$3(this, {
            virtual: true,
            forcedEnabled: true,
            _virtualMin: 0,
            _virtualMax: 0
        });
    };

    PaneDimension.prototype.virtualSize = function virtualSize (min, max) {
        if (this._virtualMin !== min || this._virtualMax !== max) {
            this._virtualMin = min;
            this._virtualMax = max;
            this.update();
        }
    };

    PaneDimension.prototype.outOfBounds = function outOfBounds (offset) {
        return offset > this.max || offset < this.min;
    };

    PaneDimension.prototype.forceEnabled = function forceEnabled () {
        this.forcedEnabled = true;
    };

    PaneDimension.prototype.getSize = function getSize () {
        return this.container[this.measure];
    };

    PaneDimension.prototype.getTotal = function getTotal () {
        return this.element[this.scrollSize];
    };

    PaneDimension.prototype.rescale = function rescale (scale) {
        this.scale = scale;
    };

    PaneDimension.prototype.update = function update (silent) {
        var that = this,
            total = that.virtual ? that._virtualMax : that.getTotal(),
            scaledTotal = total * that.scale,
            size = that.getSize();

        if (total === 0 && !that.forcedEnabled) {
            return;
        }

        that.max = that.virtual ? -that._virtualMin : 0;
        that.size = size;
        that.total = scaledTotal;
        that.min = Math.min(that.max, size - scaledTotal);
        that.minScale = size / total;
        that.centerOffset = (scaledTotal - size) / 2;
        that.enabled = that.forcedEnabled || scaledTotal > size;

        if (!silent) {
            that.trigger(CHANGE$1, that);
        }
    };

    return PaneDimension;
}(Observable));

var PaneDimensions = (function (Observable) {
    function PaneDimensions(options) {
        Observable.call(this);
        var that = this;

        that.x = new PaneDimension(extend$3({
            horizontal: true
        }, options));

        that.y = new PaneDimension(extend$3({
            horizontal: false
        }, options));

        that.container = options.container;
        that.forcedMinScale = options.minScale;
        that.maxScale = options.maxScale || 100;
        that.bind(CHANGE$1, options);
    }

    if ( Observable ) PaneDimensions.__proto__ = Observable;
    PaneDimensions.prototype = Object.create( Observable && Observable.prototype );
    PaneDimensions.prototype.constructor = PaneDimensions;

    PaneDimensions.prototype.rescale = function rescale (newScale) {
        this.x.rescale(newScale);
        this.y.rescale(newScale);
        this.refresh();
    };

    PaneDimensions.prototype.centerCoordinates = function centerCoordinates () {
        return {
            x: Math.min(0, -this.x.centerOffset),
            y: Math.min(0, -this.y.centerOffset)
        };
    };

    PaneDimensions.prototype.refresh = function refresh () {
        var that = this;
        that.x.update();
        that.y.update();
        that.enabled = that.x.enabled || that.y.enabled;
        that.minScale = that.forcedMinScale || Math.min(that.x.minScale, that.y.minScale);
        that.fitScale = Math.max(that.x.minScale, that.y.minScale);
        that.trigger(CHANGE$1);
    };

    return PaneDimensions;
}(Observable));

var PaneAxis = (function (Observable) {
    function PaneAxis(options) {
        Observable.call(this);
        extend$3(this, options);
    }

    if ( Observable ) PaneAxis.__proto__ = Observable;
    PaneAxis.prototype = Object.create( Observable && Observable.prototype );
    PaneAxis.prototype.constructor = PaneAxis;

    PaneAxis.prototype.outOfBounds = function outOfBounds () {
        return this.dimension.outOfBounds(this.movable[this.axis]);
    };

    PaneAxis.prototype.dragMove = function dragMove (delta) {
        var that = this,
            dimension = that.dimension,
            axis = that.axis,
            movable = that.movable,
            position = movable[axis] + delta;

        if (!dimension.enabled) {
            return;
        }

        var dragDelta = delta;

        if (position < dimension.min && delta < 0 || position > dimension.max && delta > 0) {
            dragDelta *= that.resistance;
        }

        movable.translateAxis(axis, dragDelta);
        that.trigger(CHANGE$1, that);
    };

    return PaneAxis;
}(Observable));

var Pane = (function (Class) {
    function Pane(options) {
        Class.call(this);

        var that = this,
            x, y,
            resistance,
            movable;

        extend$3(that, {
            elastic: true
        }, options);

        resistance = that.elastic ? 0.5 : 0;
        movable = that.movable;

        that.x = x = new PaneAxis({
            axis: 'x',
            dimension: that.dimensions.x,
            resistance: resistance,
            movable: movable
        });

        that.y = y = new PaneAxis({
            axis: 'y',
            dimension: that.dimensions.y,
            resistance: resistance,
            movable: movable
        });

        that.userEvents.bind([
            'press',
            'move',
            'end',
            'gesturestart',
            'gesturechange'
        ], {
            gesturestart: function gesturestart(e) {
                that.gesture = e;

                that.offset = elementOffset(that.dimensions.container);
            },
            press: function press(e) {
                var closestAnchor = e.event.target.closest('a');

                if (closestAnchor && closestAnchor.matches('[data-navigate-on-press=true]')) {
                    e.sender.cancel();
                }
            },
            gesturechange: function gesturechange(e) {
                var previousGesture = that.gesture,
                    previousCenter = previousGesture.center,
                    center = e.center,
                    scaleDelta = e.distance / previousGesture.distance,
                    minScale = that.dimensions.minScale,
                    maxScale = that.dimensions.maxScale,
                    coordinates;
                if (movable.scale <= minScale && scaleDelta < 1) {
                    scaleDelta += (1 - scaleDelta) * 0.8;
                }

                if (movable.scale * scaleDelta >= maxScale) {
                    scaleDelta = maxScale / movable.scale;
                }

                var offsetX = movable.x + that.offset.left,
                    offsetY = movable.y + that.offset.top;
                coordinates = {
                    x: (offsetX - previousCenter.x) * scaleDelta + center.x - offsetX,
                    y: (offsetY - previousCenter.y) * scaleDelta + center.y - offsetY
                };

                movable.scaleWith(scaleDelta);

                x.dragMove(coordinates.x);
                y.dragMove(coordinates.y);

                that.dimensions.rescale(movable.scale);
                that.gesture = e;

                e.preventDefault();
            },
            move: function move(e) {
                if (e.event.target.tagName.match(/textarea|input/i)) {
                    return;
                }

                if (x.dimension.enabled || y.dimension.enabled) {
                    x.dragMove(e.x.delta);
                    y.dragMove(e.y.delta);
                    e.preventDefault();
                } else {
                    e.touch.skip();
                }
            },
            end: function end(e) {
                e.preventDefault();
            }
        });
    }

    if ( Class ) Pane.__proto__ = Class;
    Pane.prototype = Object.create( Class && Class.prototype );
    Pane.prototype.constructor = Pane;

    return Pane;
}(Class));

var translate = function(x, y, scale) {
    return 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')';
};

var Movable = (function (Observable) {
    function Movable(element) {
        Observable.call(this);

        var that = this;

        that.element = element;
        that.element.style.transformOrigin = 'left top';
        that.x = 0;
        that.y = 0;
        that.scale = 1;

        var coordinates = translate(that.x, that.y, that.scale);
        that.element.style.transform = coordinates;

        that._saveCoordinates(coordinates);
    }

    if ( Observable ) Movable.__proto__ = Observable;
    Movable.prototype = Object.create( Observable && Observable.prototype );
    Movable.prototype.constructor = Movable;

    Movable.prototype.translateAxis = function translateAxis (axis, by) {
        this[axis] += by;
        this.refresh();
    };

    Movable.prototype.scaleTo = function scaleTo (scale) {
        this.scale = scale;
        this.refresh();
    };

    Movable.prototype.scaleWith = function scaleWith (scaleDelta) {
        this.scale *= scaleDelta;
        this.refresh();
    };

    Movable.prototype.translate = function translate (coordinates) {
        this.x += coordinates.x;
        this.y += coordinates.y;
        this.refresh();
    };

    Movable.prototype.moveAxis = function moveAxis (axis, value) {
        this[axis] = value;
        this.refresh();
    };

    Movable.prototype.moveTo = function moveTo (coordinates) {
        extend$3(this, coordinates);
        this.refresh();
    };

    Movable.prototype.refresh = function refresh () {
        var that = this,
            x = that.x,
            y = that.y,
            newCoordinates;

        if (that.round) {
            x = Math.round(x);
            y = Math.round(y);
        }

        newCoordinates = translate(x, y, that.scale);

        if (newCoordinates !== that.coordinates) {
            that.element.style.transform = newCoordinates;

            that._saveCoordinates(newCoordinates);
            that.trigger(CHANGE$1);
        }
    };

    Movable.prototype._saveCoordinates = function _saveCoordinates (coordinates) {
        this.coordinates = coordinates;
    };

    return Movable;
}(Observable));

var Group = Group$8;

var ShapeLayer = (function (Layer) {
    function ShapeLayer(map, options) {
        Layer.call(this, map, options);

        this._pan = proxy(this._pan, this);

        this.surface = Surface$1.create(this.element, {
            width: map.scrollElement.clientWidth,
            height: map.scrollElement.clientHeight
        });

        this._initRoot();
        this.movable = new Movable(this.surface.element);
        this._markers = [];

        this._click = this._handler('shapeClick');
        this.surface.bind('click', this._click);
        this._mouseleave = this._handler('shapeMouseLeave');
        this.surface.bind('mouseleave', this._mouseleave);
        this.surface.bind('mouseenter', this._mouseenter.bind(this));
    }

    if ( Layer ) ShapeLayer.__proto__ = Layer;
    ShapeLayer.prototype = Object.create( Layer && Layer.prototype );
    ShapeLayer.prototype.constructor = ShapeLayer;

    ShapeLayer.prototype.destroy = function destroy () {
        Layer.prototype.destroy.call(this);

        this.surface.destroy();
    };

    ShapeLayer.prototype._reset = function _reset () {
        Layer.prototype._reset.call(this);

        this._translateSurface();

        this._data = this._readData();

        if (this._hasData()) {
            this._load(this._data);
        }
    };

    ShapeLayer.prototype._initRoot = function _initRoot () {
        this._root = new Group();
        this.surface.draw(this._root);
    };

    ShapeLayer.prototype._beforeReset = function _beforeReset () {
        this.surface.clear();
        this._initRoot();
    };

    ShapeLayer.prototype._resize = function _resize () {
        this.surface.size(this.map.size());
    };

    ShapeLayer.prototype._readData = function _readData () {
        var data = Layer.prototype._readData.call(this);

        if (data.type === "FeatureCollection") {
            return data.features;
        }

        if (data.type === "GeometryCollection") {
            return data.geometries;
        }

        return data;
    };

    ShapeLayer.prototype._load = function _load (data) {
        var this$1$1 = this;

        this._data = data;
        this._clearMarkers();

        if (!this._loader) {
            this._loader = new GeoJsonLoader(this.map, this.options.style, this);
        }

        var container = new Group();

        for (var i = 0; i < data.length; i++) {
            var shape = this$1$1._loader.parse(data[i]);

            if (shape) {
                container.append(shape);
            }
        }

        this._root.clear();
        this._root.append(container);
    };

    ShapeLayer.prototype.shapeCreated = function shapeCreated (shape) {
        var cancelled = false;

        // the GeoJSON loader builds "Point" type as a circle
        // use the circle shape type as and indicator for rendering a marker
        // keep the behavior under a setting as this is supported by kendo jQuery Map
        // but we opted out of this in blazor
        if (shape instanceof Circle$1 && this.map.options.renderPointsAsMarkers) {
            cancelled = defined(this._createMarker(shape));
        }

        if (!cancelled) {
            var args = {
                layer: this,
                shape: shape
            };

            cancelled = this.map.trigger('shapeCreated', args);
        }

        return cancelled;
    };

    ShapeLayer.prototype.featureCreated = function featureCreated (e) {
        e.layer = this;
        this.map.trigger('shapeFeatureCreated', e);
    };

    ShapeLayer.prototype._createMarker = function _createMarker (shape) {
        var marker = this.map.markers.bind({
            location: shape.location
        }, shape.dataItem);

        if (marker) {
            this._markers.push(marker);
        }

        return marker;
    };

    ShapeLayer.prototype._clearMarkers = function _clearMarkers () {
        var this$1$1 = this;

        for (var i = 0; i < this._markers.length; i++) {
            this$1$1.map.markers.remove(this$1$1._markers[i]);
        }

        this._markers = [];
    };

    ShapeLayer.prototype._pan = function _pan () {
        if (!this._panning) {
            this._panning = true;
            this.surface.suspendTracking();
        }
    };

    ShapeLayer.prototype._panEnd = function _panEnd (e) {
        Layer.prototype._panEnd.call(this, e);
        this._translateSurface();
        this.surface.resumeTracking();
        this._panning = false;
    };

    ShapeLayer.prototype._translateSurface = function _translateSurface () {
        var map = this.map;
        var nw = map.locationToView(map.extent().nw);

        if (this.surface.translate) {
            this.surface.translate(nw);
            this.movable.moveTo({
                x: nw.x,
                y: nw.y
            });
        }
    };

    ShapeLayer.prototype._eventArgs = function _eventArgs (e) {
        return {
            layer: this,
            layerIndex: this._layerIndex(),
            shape: e.element,
            shapeIndex: (this._data || []).indexOf(e.element.dataItem),
            originalEvent: e.originalEvent
        };
    };

    ShapeLayer.prototype._handler = function _handler (eventName) {
        var this$1$1 = this;

        return function (e) {
            if (e.element) {
                this$1$1.map.trigger(eventName, this$1$1._eventArgs(e));
            }
        };
    };

    ShapeLayer.prototype._mouseenter = function _mouseenter (e) {
        if (!e.element) {
            return;
        }

        this.map.trigger('shapeMouseEnter', this._eventArgs(e));

        var shape = e.element;
        var anchor = this._tooltipAnchor(e);
        this.map._tooltip.show(anchor, this._tooltipContext(shape));
    };

    ShapeLayer.prototype._tooltipContext = function _tooltipContext (shape) {
        return {
            type: 'shape',
            layerIndex: this._layerIndex(),
            className: 'k-map-shape-tooltip',
            dataItem: shape.dataItem,
            location: shape.location
        };
    };

    ShapeLayer.prototype._tooltipAnchor = function _tooltipAnchor (e) {
        var cursor = this.map.eventOffset(e.originalEvent);
        return {
            top: cursor.y,
            left: cursor.x
        };
    };

    ShapeLayer.prototype._activate = function _activate () {
        Layer.prototype._activate.call(this);
        this._panHandler = proxy(this._pan, this);
        this.map.bind('pan', this.panHandler);
    };

    ShapeLayer.prototype._deactivate = function _deactivate () {
        Layer.prototype._deactivate.call(this);
        this.map.unbind('pan', this._panHandler);
    };

    return ShapeLayer;
}(Layer));

setDefaultOptions(ShapeLayer, {
    autoBind: true,
    zIndex: 100
});

var GeoJsonLoader = (function (Class) {
    function GeoJsonLoader(locator, defaultStyle, observer) {
        Class.call(this);
        this.observer = observer;
        this.locator = locator;
        this.style = defaultStyle;
    }

    if ( Class ) GeoJsonLoader.__proto__ = Class;
    GeoJsonLoader.prototype = Object.create( Class && Class.prototype );
    GeoJsonLoader.prototype.constructor = GeoJsonLoader;

    GeoJsonLoader.prototype.parse = function parse (item) {
        var root = new Group();
        var unwrap = true;

        if (item.type === 'Feature') {
            unwrap = false;
            this._loadGeometryTo(root, item.geometry, item);
            this._featureCreated(root, item);
        } else {
            this._loadGeometryTo(root, item, item);
        }

        if (unwrap && root.children.length < 2) {
            root = root.children[0];
        }

        return root;
    };

    GeoJsonLoader.prototype._shapeCreated = function _shapeCreated (shape) {
        var cancelled = false;

        if (this.observer && this.observer.shapeCreated) {
            cancelled = this.observer.shapeCreated(shape);
        }

        return cancelled;
    };

    GeoJsonLoader.prototype._featureCreated = function _featureCreated (group, dataItem) {
        if (this.observer && this.observer.featureCreated) {
            this.observer.featureCreated({
                group: group,
                dataItem: dataItem,
                properties: dataItem.properties
            });
        }
    };

    GeoJsonLoader.prototype._loadGeometryTo = function _loadGeometryTo (container, geometry, dataItem) {
        var this$1$1 = this;

        var coords = geometry.coordinates;
        var i;
        var path;

        switch (geometry.type) {
            case 'LineString':
                path = this._loadPolygon(container, [coords], dataItem);
                this._setLineFill(path);
                break;
            case 'MultiLineString':
                for (i = 0; i < coords.length; i++) {
                    path = this$1$1._loadPolygon(container, [coords[i]], dataItem);
                    this$1$1._setLineFill(path);
                }
                break;
            case 'Polygon':
                this._loadPolygon(container, coords, dataItem);
                break;
            case 'MultiPolygon':
                for (i = 0; i < coords.length; i++) {
                    this$1$1._loadPolygon(container, coords[i], dataItem);
                }
                break;
            case 'Point':
                this._loadPoint(container, coords, dataItem);
                break;
            case 'MultiPoint':
                for (i = 0; i < coords.length; i++) {
                    this$1$1._loadPoint(container, coords[i], dataItem);
                }
                break;
            default:
                break;
        }
    };

    GeoJsonLoader.prototype._setLineFill = function _setLineFill (path) {
        var segments = path.segments;

        if (segments.length < 4 || !segments[0].anchor().equals(last(segments).anchor())) {
            path.options.fill = null;
        }
    };

    GeoJsonLoader.prototype._loadShape = function _loadShape (container, shape) {
        if (!this._shapeCreated(shape)) {
            container.append(shape);
        }

        return shape;
    };

    GeoJsonLoader.prototype._loadPolygon = function _loadPolygon (container, rings, dataItem) {
        var shape = this._buildPolygon(rings);
        shape.dataItem = dataItem;
        shape.location = this.locator.viewToLocation(shape.bbox().center());
        return this._loadShape(container, shape);
    };

    GeoJsonLoader.prototype._buildPolygon = function _buildPolygon (rings) {
        var this$1$1 = this;

        var type = rings.length > 1 ? MultiPath : Path$7;
        var path = new type(this.style);

        for (var i = 0; i < rings.length; i++) {
            for (var j = 0; j < rings[i].length; j++) {
                var point = this$1$1.locator.locationToView(Location.fromLngLat(rings[i][j]));
                if (j === 0) {
                    path.moveTo(point.x, point.y);
                } else {
                    path.lineTo(point.x, point.y);
                }
            }
        }

        return path;
    };

    GeoJsonLoader.prototype._loadPoint = function _loadPoint (container, coords, dataItem) {
        var location = Location.fromLngLat(coords);
        var point = this.locator.locationToView(location);
        var circle = new Circle$2(point, 10);
        var shape = new Circle$1(circle, this.style);

        shape.dataItem = dataItem;
        shape.location = location;

        return this._loadShape(container, shape);
    };

    return GeoJsonLoader;
}(Class));

var BubbleLayer = (function (ShapeLayer) {
    function BubbleLayer () {
        ShapeLayer.apply(this, arguments);
    }

    if ( ShapeLayer ) BubbleLayer.__proto__ = ShapeLayer;
    BubbleLayer.prototype = Object.create( ShapeLayer && ShapeLayer.prototype );
    BubbleLayer.prototype.constructor = BubbleLayer;

    BubbleLayer.prototype._readData = function _readData () {
        var data = this.options.data || [];
        return data;
    };

    BubbleLayer.prototype._load = function _load (data) {
        var this$1$1 = this;

        this._data = data;
        this.surface.clear();

        if (data.length === 0) {
            return;
        }

        var options = this.options;
        var getValue = getter(options.valueField);

        var newData = data.slice(0);
        newData.sort(function(a, b) {
            return getValue(b) - getValue(a);
        });

        var scaleType = this._scaleType();
        var scale;
        var getLocation = getter(this.options.locationField);

        for (var i = 0; i < newData.length; i++) {
            var dataItem = newData[i];
            var location = getLocation(dataItem);
            var value = getValue(dataItem);

            if (defined(location) && defined(value)) {
                if (!scale) {
                    scale = new scaleType([
                        0,
                        value
                    ], [
                        options.minSize,
                        options.maxSize
                    ]);
                }

                location = Location.create(location);

                var center = this$1$1.map.locationToView(location);
                var size = scale.map(value);
                var symbol = this$1$1._createSymbol({
                    center: center,
                    size: size,
                    style: options.style,
                    dataItem: dataItem,
                    location: location
                });

                symbol.dataItem = dataItem;
                symbol.location = location;
                symbol.value = value;

                this$1$1._drawSymbol(symbol);
            }
        }
    };

    BubbleLayer.prototype._scaleType = function _scaleType () {
        var scale = this.options.scale;

        if (isFunction(scale)) {
            return scale;
        }

        return Scales[scale];
    };

    BubbleLayer.prototype._createSymbol = function _createSymbol (args) {
        var symbol = this.options.symbol;

        if (!isFunction(symbol)) {
            symbol = Symbols[symbol];
        }

        return symbol(args);
    };

    BubbleLayer.prototype._drawSymbol = function _drawSymbol (shape) {
        var args = {
            layer: this,
            shape: shape
        };

        var cancelled = this.map.trigger('shapeCreated', args);

        if (!cancelled) {
            this.surface.draw(shape);
        }
    };

    BubbleLayer.prototype._tooltipContext = function _tooltipContext (shape) {
        return {
            type: 'bubble',
            layerIndex: this._layerIndex(),
            className: 'k-map-bubble-tooltip',
            dataItem: shape.dataItem,
            location: shape.location,
            value: shape.value
        };
    };

    BubbleLayer.prototype._tooltipAnchor = function _tooltipAnchor (e) {
        var shape = e.element;
        var center = shape.bbox().center();

        return {
            top: center.y,
            left: center.x
        };
    };

    return BubbleLayer;
}(ShapeLayer));

setDefaultOptions(BubbleLayer, {
    // autoBind: true,
    locationField: 'location',
    valueField: 'value',
    minSize: 0,
    maxSize: 100,
    scale: 'sqrt',
    symbol: 'circle',
    // ensure bubble layers are displayed over tile and shape layers
    zIndex: 200
});

var SqrtScale = (function (Class) {
    function SqrtScale(domain, range) {
        Class.call(this);

        this._domain = domain;
        this._range = range;

        var domainRange = Math.sqrt(domain[1]) - Math.sqrt(domain[0]);
        var outputRange = range[1] - range[0];

        this._ratio = outputRange / domainRange;
    }

    if ( Class ) SqrtScale.__proto__ = Class;
    SqrtScale.prototype = Object.create( Class && Class.prototype );
    SqrtScale.prototype.constructor = SqrtScale;

    SqrtScale.prototype.map = function map (value) {
        var rel = (Math.sqrt(value) - Math.sqrt(this._domain[0])) * this._ratio;
        return this._range[0] + rel;
    };

    return SqrtScale;
}(Class));

var Scales = {
    sqrt: SqrtScale
};

var Symbols = {
    circle: function(args) {
        var geo = new Circle$2(args.center, args.size / 2);
        return new Circle$1(geo, args.style);
    },

    square: function(args) {
        var path = new Path$7(args.style);
        var halfSize = args.size / 2;
        var center = args.center;
        path.moveTo(center.x - halfSize, center.y - halfSize).lineTo(center.x + halfSize, center.y - halfSize).lineTo(center.x + halfSize, center.y + halfSize).lineTo(center.x - halfSize, center.y + halfSize).close();
        return path;
    }
};

var CLICK = "click";
var MOUSE_ENTER = "mouseenter";
var MOUSE_LEAVE = "mouseleave";

var extend$2 = Object.assign;
var MARKER_CLASS_NAME = "k-marker";
var MARKER_CLASS = "." + MARKER_CLASS_NAME;

var MarkerLayer = (function (Layer) {
    function MarkerLayer(map, options) {
        Layer.call(this, map, options);

        this._markerClickHandler = proxy(this._markerClick, this);
        on(this.element, CLICK, MARKER_CLASS, this._markerClickHandler);

        this.items = [];

        this._load(this._readData());
    }

    if ( Layer ) MarkerLayer.__proto__ = Layer;
    MarkerLayer.prototype = Object.create( Layer && Layer.prototype );
    MarkerLayer.prototype.constructor = MarkerLayer;

    MarkerLayer.prototype.destroy = function destroy () {
        Layer.prototype.destroy.call(this);
        off(this.element, CLICK, this._markerClickHandler);
        this.clear();
    };

    MarkerLayer.prototype.add = function add (args) {
        var this$1$1 = this;

        if (isArray(args)) {
            for (var i = 0; i < args.length; i++) {
                this$1$1._addOne(args[i]);
            }
        } else {
            return this._addOne(args);
        }
    };

    MarkerLayer.prototype.remove = function remove (marker) {
        marker.destroy();
        var index = (this.items || []).indexOf(marker);

        if (index > -1) {
            this.items.splice(index, 1);
        }
    };

    MarkerLayer.prototype.clear = function clear () {
        var this$1$1 = this;

        for (var i = 0; i < this.items.length; i++) {
            this$1$1.items[i].destroy();
        }

        this.items = [];
    };

    MarkerLayer.prototype.update = function update (marker) {
        var location = marker.location();

        if (location) {
            marker.showAt(this.map.locationToView(location));

            var args = {
                marker: marker,
                layer: this
            };

            this.map.trigger('markerActivate', args);
        }
    };

    MarkerLayer.prototype._reset = function _reset () {
        var this$1$1 = this;

        Layer.prototype._reset.call(this);

        var items = this.items;

        for (var i = 0; i < items.length; i++) {
            this$1$1.update(items[i]);
        }
    };

    MarkerLayer.prototype.bind = function bind (options, dataItem) {
        var marker = Marker.create(options, this.options);
        marker.dataItem = dataItem;

        var args = {
            marker: marker,
            layer: this
        };

        var cancelled = this.map.trigger('markerCreated', args);

        if (!cancelled) {
            this.add(marker);
            return marker;
        }
    };

    MarkerLayer.prototype._addOne = function _addOne (arg) {
        var marker = Marker.create(arg, this.options);
        marker.addTo(this);
        return marker;
    };

    MarkerLayer.prototype._readData = function _readData () {
        var data = this.options.data || [];
        return data;
    };

    MarkerLayer.prototype._load = function _load (data) {
        var this$1$1 = this;

        this._data = data;
        this.clear();

        var getLocation = getter(this.options.locationField);
        var getTitle = getter(this.options.titleField);

        for (var i = 0; i < data.length; i++) {
            var dataItem = data[i];

            this$1$1.bind({
                location: getLocation(dataItem),
                title: getTitle(dataItem)
            }, dataItem);
        }
    };

    MarkerLayer.prototype._markerClick = function _markerClick (e) {
        var marker = e.currentTarget._kendoNode;

        var args = {
            layer: this,
            layerIndex: this._layerIndex(),
            marker: marker,
            markerIndex: (this.items || []).indexOf(marker),
            originalEvent: e
        };

        this.map.trigger('markerClick', args);
    };

    MarkerLayer.prototype._markerMouseEnter = function _markerMouseEnter (e) {
        var args = this._createMarkerEventArgs(e);
        this.map.trigger("markerMouseEnter", args);
    };

    MarkerLayer.prototype._markerMouseLeave = function _markerMouseLeave (e) {
        var args = this._createMarkerEventArgs(e);
        this.map.trigger("markerMouseLeave", args);
    };

    MarkerLayer.prototype._createMarkerEventArgs = function _createMarkerEventArgs (e) {
        var marker = e.marker;

        var args = extend$2({}, {
            layer: this,
            layerIndex: this._layerIndex(),
            marker: marker,
            markerIndex: (this.items || []).indexOf(marker)
        }, e);

        return args;
    };

    return MarkerLayer;
}(Layer));

setDefaultOptions(MarkerLayer, {
    zIndex: 1000,
    autoBind: true,
    locationField: 'location',
    titleField: 'title',
    template: ""
});

var Marker = (function (Class) {
    function Marker(options) {
        Class.call(this);
        this.options = options || {};
    }

    if ( Class ) Marker.__proto__ = Class;
    Marker.prototype = Object.create( Class && Class.prototype );
    Marker.prototype.constructor = Marker;

    Marker.prototype.destroy = function destroy () {
        this.layer = null;
        this.unbindEvents();
        this.hide();
    };

    Marker.prototype.addTo = function addTo (parent) {
        this.layer = parent.markers || parent;
        this.layer.items.push(this);
        this.layer.update(this);
    };

    Marker.prototype.location = function location (value) {
        if (value) {
            this.options.location = Location.create(value).toArray();

            if (this.layer) {
                this.layer.update(this);
            }

            return this;
        }

        return Location.create(this.options.location);
    };

    Marker.prototype.showAt = function showAt (point) {
        this.render();

        this._anchor = { left: Math.round(point.x), top: Math.round(point.y) };
        this.element.style.left = toPixels(this._anchor.left);
        this.element.style.top = toPixels(this._anchor.top);
    };

    Marker.prototype.hide = function hide () {
        if (this.element) {
            this.element.remove();
            this.element = null;
        }
    };

    Marker.prototype.bindEvents = function bindEvents () {
        if (!this.element) {
            return;
        }

        this._mouseEnterHandler = proxy(this._mouseEnter, this);
        on(this.element, MOUSE_ENTER, MARKER_CLASS, this._mouseEnterHandler);
        this._mouseLeaveHandler = proxy(this._mouseLeave, this);
        on(this.element, MOUSE_LEAVE, MARKER_CLASS, this._mouseLeaveHandler);
    };

    Marker.prototype.unbindEvents = function unbindEvents () {
        if (!this.element) {
            return;
        }

        off(this.element, MOUSE_ENTER, this._mouseEnterHandler);
        off(this.element, MOUSE_LEAVE, this._mouseLeaveHandler);
    };

    Marker.prototype.render = function render () {
        if (!this.element) {
            var options = this.options;
            var layer = this.layer;
            var element = document.createElement('span');
            addClass(element, MARKER_CLASS_NAME);

            if (this.options.template) {
                var templateFn = this._compileTemplate(this.options.template);
                var templateHtml = templateFn(this.dataItem);
                var templateElement = convertToHtml(templateHtml);
                element.appendChild(templateElement);
            } else if (options.svgIcon) {
                renderIcon(element, { icon: options.svgIcon, iconClass: "k-icon-xxl", svgIcons: this.options.icons.svgIcons, type: "svg" });
            } else {
                var iconOptions = { icon: "map-marker", iconClass: "k-icon-xxl", svgIcons: this.options.icons.svgIcons, type: this.options.icons.type };

                if (options.shape) {
                    if (options.shape === "pinTarget") {
                        iconOptions.icon = "map-marker-target";
                        renderIcon(element, iconOptions);
                    } else if (options.shape === "pin") {
                        renderIcon(element, iconOptions);
                    } else {
                        addClass(element, 'k-icon k-icon-xxl k-i-marker-' + toHyphens(options.shape || 'pin'));
                    }
                } else {
                    renderIcon(element, iconOptions);
                }
            }

            if (options.title) {
                element.setAttribute("title", options.title);
            }

            var attributes = options.attributes || {};
            Object.keys(attributes).forEach(function(key) {
                element.setAttribute(key, attributes[key]);
            });

            element._kendoNode = this;
            element.style.zIndex = options.zIndex;

            this.element = element;

            if (layer) {
                layer.element.appendChild(this.element);
            }

            this.bindEvents();
        }
    };

    Marker.prototype._mouseEnter = function _mouseEnter (e) {
        var args = this._createEventArgs(e);
        this.layer._markerMouseEnter(args);

        this.layer.map._tooltip.show({
            top: this._anchor.top - this.element.offsetHeight,
            left: this._anchor.left
        }, this._tooltipContext());
    };

    Marker.prototype._tooltipContext = function _tooltipContext () {
        return {
            type: 'marker',
            layerIndex: this.layer._layerIndex(),
            className: 'k-map-marker-tooltip',
            dataItem: this.dataItem,
            title: this.options.title,
            location: this.location()
        };
    };

    Marker.prototype._mouseLeave = function _mouseLeave (e) {
        var args = this._createEventArgs(e);
        this.layer._markerMouseLeave(args);
    };

    Marker.prototype._createEventArgs = function _createEventArgs (e) {
        var args = {
            marker: this,
            originalEvent: e
        };

        return args;
    };

    Marker.prototype._compileTemplate = function _compileTemplate (template) {
        return TemplateService.compile(template, {
            paramName: "dataItem",
            useWithBlock: false
        });
    };

    Marker.create = function create (arg, defaults) {
        if (arg instanceof Marker) {
            return arg;
        }

        return new Marker(deepExtend({}, defaults, arg));
    };

    return Marker;
}(Class));

var extend$1 = Object.assign;

function animationFrame(callback) {
    window.requestAnimationFrame(callback);
}

var Animation = (function (Class) {
    function Animation() {
        Class.call(this);
        var that = this;

        that._tickProxy = proxy(that._tick, that);
        that._started = false;
    }

    if ( Class ) Animation.__proto__ = Class;
    Animation.prototype = Object.create( Class && Class.prototype );
    Animation.prototype.constructor = Animation;

    Animation.prototype.tick = function tick () { };
    Animation.prototype.done = function done () { };
    Animation.prototype.onEnd = function onEnd () { };
    Animation.prototype.onCancel = function onCancel () { };

    Animation.prototype.start = function start () {
        if (!this.enabled()) {
            return;
        }

        if (!this.done()) {
            this._started = true;
            animationFrame(this._tickProxy);
        } else {
            this.onEnd();
        }
    };

    Animation.prototype.enabled = function enabled () {
        return true;
    };

    Animation.prototype.cancel = function cancel () {
        this._started = false;
        this.onCancel();
    };

    Animation.prototype._tick = function _tick () {
        var that = this;

        if (!that._started) {
            return;
        }

        that.tick();

        if (!that.done()) {
            animationFrame(that._tickProxy);
        } else {
            that._started = false;
            that.onEnd();
        }
    };

    return Animation;
}(Class));

var Transition = (function (Animation) {
    function Transition(options) {
        Animation.call(this);
        extend$1(this, options);
    }

    if ( Animation ) Transition.__proto__ = Animation;
    Transition.prototype = Object.create( Animation && Animation.prototype );
    Transition.prototype.constructor = Transition;

    Transition.prototype.done = function done () {
        return this.timePassed() >= this.duration;
    };

    Transition.prototype.timePassed = function timePassed () {
        return Math.min(this.duration, now() - this.startDate);
    };

    Transition.prototype.moveTo = function moveTo (options) {
        var that = this,
            movable = that.movable;

        that.initial = movable[that.axis];
        that.delta = options.location - that.initial;
        that.duration = typeof options.duration === 'number' ? options.duration : 300;
        that.tick = that._easeProxy(options.ease);
        that.startDate = now();
        that.start();
    };

    Transition.prototype._easeProxy = function _easeProxy (ease) {
        var that = this;

        return function() {
            that.movable.moveAxis(that.axis, ease(that.timePassed(), that.initial, that.delta, that.duration));
        };
    };

    Transition.easeOutExpo = function easeOutExpo (t, b, c, d) {
        return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    };

    return Transition;
}(Animation));

// todo: extract to a separate place


var
    extend = Object.assign,
    abs = Math.abs,
    SNAPBACK_DURATION = 500,
    SCROLLBAR_OPACITY = 0.7,
    FRICTION$1 = 0.96,
    VELOCITY_MULTIPLIER$1 = 10,
    MAX_VELOCITY = 55,
    OUT_OF_BOUNDS_FRICTION = 0.5,
    ANIMATED_SCROLLER_PRECISION = 5,
    // SCROLLER_RELEASE_CLASS = 'km-scroller-release',
    // SCROLLER_REFRESH_CLASS = 'km-scroller-refresh',
    PULL = 'pull',
    CHANGE = 'change',
    RESIZE = 'resize',
    SCROLL = 'scroll',
    MOUSE_WHEEL_ID = 2;

var ZoomSnapBack = (function (Animation) {
    function ZoomSnapBack(options) {
        Animation.call(this, options);
        var that = this;
        extend(that, options);
        that.userEvents.bind('gestureend', that.start.bind(this));
        that.tapCapture.bind('press', that.cancel.bind(this));
    }

    if ( Animation ) ZoomSnapBack.__proto__ = Animation;
    ZoomSnapBack.prototype = Object.create( Animation && Animation.prototype );
    ZoomSnapBack.prototype.constructor = ZoomSnapBack;

    ZoomSnapBack.prototype.enabled = function enabled () {
        return this.movable.scale < this.dimensions.minScale;
    };

    ZoomSnapBack.prototype.done = function done () {
        return this.dimensions.minScale - this.movable.scale < 0.01;
    };

    ZoomSnapBack.prototype.tick = function tick () {
        var movable = this.movable;
        movable.scaleWith(1.1);
        this.dimensions.rescale(movable.scale);
    };

    ZoomSnapBack.prototype.onEnd = function onEnd () {
        var movable = this.movable;
        movable.scaleTo(this.dimensions.minScale);
        this.dimensions.rescale(movable.scale);
    };

    return ZoomSnapBack;
}(Animation));

var DragInertia = (function (Animation) {
    function DragInertia(options) {
        Animation.call(this);
        var that = this;

        extend(that, options, {
            transition: new Transition({
                axis: options.axis,
                movable: options.movable,
                onEnd: function onEnd() {
                    that._end();
                }
            })
        });

        that.tapCapture.bind('press', function() {
            that.cancel();
        });

        that.userEvents.bind('end', proxy(that.start, that));
        that.userEvents.bind('gestureend', proxy(that.start, that));
        that.userEvents.bind('tap', proxy(that.onEnd, that));
    }

    if ( Animation ) DragInertia.__proto__ = Animation;
    DragInertia.prototype = Object.create( Animation && Animation.prototype );
    DragInertia.prototype.constructor = DragInertia;

    DragInertia.prototype.onCancel = function onCancel () {
        this.transition.cancel();
    };

    DragInertia.prototype.freeze = function freeze (location) {
        var that = this;
        that.cancel();
        that._moveTo(location);
    };

    DragInertia.prototype.onEnd = function onEnd () {
        var that = this;
        if (that.paneAxis.outOfBounds()) {
            that._snapBack();
        } else {
            that._end();
        }
    };

    DragInertia.prototype.done = function done () {
        return abs(this.velocity) < 1;
    };

    DragInertia.prototype.start = function start (e) {
        var that = this,
            velocity;
        if (!that.dimension.enabled) {
            return;
        }
        if (that.paneAxis.outOfBounds()) {
            if (that.transition._started) {
                that.transition.cancel();
                that.velocity = Math.min(e.touch[that.axis].velocity * that.velocityMultiplier, MAX_VELOCITY);
                Animation.prototype.start.call(this);
            } else {
                that._snapBack();
            }
        } else {
            velocity = e.touch.id === MOUSE_WHEEL_ID ? 0 : e.touch[that.axis].velocity;
            that.velocity = Math.max(Math.min(velocity * that.velocityMultiplier, MAX_VELOCITY), -MAX_VELOCITY);
            that.tapCapture.captureNext();
            Animation.prototype.start.call(this);
        }
    };

    DragInertia.prototype.tick = function tick () {
        var that = this,
            dimension = that.dimension,
            friction = that.paneAxis.outOfBounds() ? OUT_OF_BOUNDS_FRICTION : that.friction,
            delta = that.velocity *= friction,
            location = that.movable[that.axis] + delta;

        if (!that.elastic && dimension.outOfBounds(location)) {
            location = Math.max(Math.min(location, dimension.max), dimension.min);
            that.velocity = 0;
        }

        that.movable.moveAxis(that.axis, location);
    };

    DragInertia.prototype._end = function _end () {
        this.tapCapture.cancelCapture();
        this.end();
    };

    DragInertia.prototype._snapBack = function _snapBack () {
        var that = this,
            dimension = that.dimension,
            snapBack = that.movable[that.axis] > dimension.max ? dimension.max : dimension.min;

        that._moveTo(snapBack);
    };

    DragInertia.prototype._moveTo = function _moveTo (location) {
        this.transition.moveTo({
            location: location,
            duration: SNAPBACK_DURATION,
            ease: Transition.easeOutExpo
        });
    };

    return DragInertia;
}(Animation));

var AnimatedScroller = (function (Animation) {
    function AnimatedScroller(options) {
        Animation.call(this, options);
        var that = this;

        extend(that, options, {
            origin: {},
            destination: {},
            offset: {}
        });
    }

    if ( Animation ) AnimatedScroller.__proto__ = Animation;
    AnimatedScroller.prototype = Object.create( Animation && Animation.prototype );
    AnimatedScroller.prototype.constructor = AnimatedScroller;

    AnimatedScroller.prototype.tick = function tick () {
        this._updateCoordinates();
        this.moveTo(this.origin);
    };

    AnimatedScroller.prototype.done = function done () {
        return abs(this.offset.y) < ANIMATED_SCROLLER_PRECISION && abs(this.offset.x) < ANIMATED_SCROLLER_PRECISION;
    };

    AnimatedScroller.prototype.onEnd = function onEnd () {
        this.moveTo(this.destination);
        if (this.callback) {
            this.callback.call();
        }
    };

    AnimatedScroller.prototype.setCoordinates = function setCoordinates (from, to) {
        this.offset = {};
        this.origin = from;
        this.destination = to;
    };

    /* eslint-disable no-param-reassign */
    AnimatedScroller.prototype.setCallback = function setCallback (callback) {
        if (callback && isFunction(callback)) {
            this.callback = callback;
        } else {
            callback = undefined;
        }
    };
    /* eslint-enable no-param-reassign */

    AnimatedScroller.prototype._updateCoordinates = function _updateCoordinates () {
        this.offset = {
            x: (this.destination.x - this.origin.x) / 4,
            y: (this.destination.y - this.origin.y) / 4
        };
        this.origin = {
            y: this.origin.y + this.offset.y,
            x: this.origin.x + this.offset.x
        };
    };

    return AnimatedScroller;
}(Animation));

var ScrollBar = (function (Class) {
    function ScrollBar(options) {
        Class.call(this);
        var that = this,
            horizontal = options.axis === 'x';

        var orientation = (horizontal ? 'horizontal' : 'vertical');
        var element = convertToHtml('<div class="km-touch-scrollbar km-' + orientation + '-scrollbar" />');

        extend(that, options, {
            element: element,
            elementSize: 0,
            movable: new Movable(element),
            scrollMovable: options.movable,
            alwaysVisible: options.alwaysVisible,
            size: horizontal ? 'width' : 'height'
        });

        that.scrollMovable.bind(CHANGE, that.refresh.bind(that));

        that.container.appendChild(element);

        if (options.alwaysVisible) {
            that.show();
        }
    }

    if ( Class ) ScrollBar.__proto__ = Class;
    ScrollBar.prototype = Object.create( Class && Class.prototype );
    ScrollBar.prototype.constructor = ScrollBar;

    ScrollBar.prototype.refresh = function refresh () {
        var that = this,
            axis = that.axis,
            dimension = that.dimension,
            paneSize = dimension.size,
            scrollMovable = that.scrollMovable,
            sizeRatio = paneSize / dimension.total,
            position = Math.round(-scrollMovable[axis] * sizeRatio),
            size = Math.round(paneSize * sizeRatio);
        if (sizeRatio >= 1) {
            this.element.style.display = "none";
        } else {
            this.element.style.display = "";
        }
        if (position + size > paneSize) {
            size = paneSize - position;
        } else if (position < 0) {
            size += position;
            position = 0;
        }
        if (that.elementSize !== size) {
            that.element.style[that.size] = size + 'px';
            that.elementSize = size;
        }
        that.movable.moveAxis(axis, position);
    };

    ScrollBar.prototype.show = function show () {
        this.element.style.opacity = SCROLLBAR_OPACITY;
        this.element.style.visibility = "visible";
    };

    ScrollBar.prototype.hide = function hide () {
        if (!this.alwaysVisible) {
            this.element.style.opacity = 0;
        }
    };

    return ScrollBar;
}(Class));

// export class Scroller extends Class {
var Scroller = (function (Observable) {
    function Scroller(element, options) {
        Observable.call(this);
        var that = this;
        this.element = element;

        this._initOptions(options);

        var hasScrolling = hasNativeScrolling(navigator.userAgent);
        that._native = that.options.useNative && hasScrolling;
        var scrollHeader = convertToHtml('<div class="km-scroll-header"/>');

        if (that._native) {
            addClass(element, 'km-native-scroller');
            prepend(scrollHeader, element);

            extend(that, {
                scrollElement: element,
                fixedContainer: element.children[0]
            });

            return;
        }

        element.style.overflow = "hidden";
        addClass(element, 'km-scroll-wrapper');

        var scrollContainer = convertToHtml('<div class="km-scroll-container"/>');
        wrapInner(element, scrollContainer);
        prepend(scrollHeader, element);

        var inner = element.children[1],
            tapCapture = new TapCapture(element),
            movable = new Movable(inner),

            dimensions = new PaneDimensions({
                element: inner,
                container: element,
                forcedEnabled: that.options.zoom
            }),
            avoidScrolling = this.options.avoidScrolling,

            userEvents = new UserEvents(element, {
                touchAction: 'none',
                allowSelection: true,
                preventDragEvent: true,
                captureUpIfMoved: true,
                multiTouch: that.options.zoom,
                supportDoubleTap: that.options.supportDoubleTap,
                start: function start(e) {
                    dimensions.refresh();
                    var velocityX = abs(e.x.velocity),
                        velocityY = abs(e.y.velocity),
                        horizontalSwipe = velocityX * 2 >= velocityY,
                        originatedFromFixedContainer = that.fixedContainer.contains(e.event.target),
                        verticalSwipe = velocityY * 2 >= velocityX;
                    if (!originatedFromFixedContainer && !avoidScrolling(e) && that.enabled && (dimensions.x.enabled && horizontalSwipe || dimensions.y.enabled && verticalSwipe)) {
                        userEvents.capture();
                    } else {
                        userEvents.cancel();
                    }
                }
            }),

            pane = new Pane({
                movable: movable,
                dimensions: dimensions,
                userEvents: userEvents,
                elastic: that.options.elastic
            }),

            zoomSnapBack = new ZoomSnapBack({
                movable: movable,
                dimensions: dimensions,
                userEvents: userEvents,
                tapCapture: tapCapture
            }),

            animatedScroller = new AnimatedScroller({
                moveTo: function moveTo(coordinates) {
                    that.scrollTo(coordinates.x, coordinates.y);
                }
            });

        movable.bind(CHANGE, function() {
            that.scrollTop = -movable.y;
            that.scrollLeft = -movable.x;
            that.trigger(SCROLL, {
                scrollTop: that.scrollTop,
                scrollLeft: that.scrollLeft
            });
        });

        if (that.options.mousewheelScrolling) {
            this._wheelScrollHandler = this._wheelScroll.bind(this);
            on(element, 'wheel', this._wheelScrollHandler);
        }

        extend(that, {
            movable: movable,
            dimensions: dimensions,
            zoomSnapBack: zoomSnapBack,
            animatedScroller: animatedScroller,
            userEvents: userEvents,
            pane: pane,
            tapCapture: tapCapture,
            pulled: false,
            enabled: true,
            scrollElement: inner,
            scrollTop: 0,
            scrollLeft: 0,
            fixedContainer: element.children[0]
        });

        that._initAxis('x');
        that._initAxis('y');

        that._wheelEnd = function() {
            that._wheel = false;
            that.userEvents.end(0, that._wheelY);
        };

        dimensions.refresh();

        if (that.options.pullToRefresh) {
            that._initPullToRefresh();
        }
    }

    if ( Observable ) Scroller.__proto__ = Observable;
    Scroller.prototype = Object.create( Observable && Observable.prototype );
    Scroller.prototype.constructor = Scroller;

    Scroller.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    Scroller.prototype._wheelScroll = function _wheelScroll (e) {
        if (e.ctrlKey) {
            return;
        }
        if (!this._wheel) {
            this._wheel = true;
            this._wheelY = 0;
            this.userEvents.press(0, this._wheelY);
        }

        clearTimeout(this._wheelTimeout);
        this._wheelTimeout = setTimeout(this._wheelEnd, 50);
        var delta = wheelDeltaY(e);

        if (delta) {
            this._wheelY += delta;
            this.userEvents.move(0, this._wheelY);
        }

        e.preventDefault();
    };

    Scroller.prototype.makeVirtual = function makeVirtual () {
        this.dimensions.y.makeVirtual();
    };

    Scroller.prototype.virtualSize = function virtualSize (min, max) {
        this.dimensions.y.virtualSize(min, max);
    };

    Scroller.prototype.height = function height () {
        return this.dimensions.y.size;
    };

    Scroller.prototype.scrollHeight = function scrollHeight () {
        return this.scrollElement.scrollHeight;
    };

    Scroller.prototype.scrollWidth = function scrollWidth () {
        return this.scrollElement.scrollWidth;
    };

    Scroller.prototype._resize = function _resize () {
        if (!this._native) {
            this.contentResized();
        }
    };

    Scroller.prototype.setOptions = function setOptions (options) {
        var that = this;

        this._initOptions(options);

        if (options.pullToRefresh) {
            that._initPullToRefresh();
        }
    };

    Scroller.prototype.reset = function reset () {
        if (this._native) {
            this.scrollElement.scrollTop(0);
        } else {
            this.movable.moveTo({
                x: 0,
                y: 0
            });
            this._scale(1);
        }
    };

    Scroller.prototype.contentResized = function contentResized () {
        this.dimensions.refresh();
        if (this.pane.x.outOfBounds()) {
            this.movable.moveAxis('x', this.dimensions.x.min);
        }
        if (this.pane.y.outOfBounds()) {
            this.movable.moveAxis('y', this.dimensions.y.min);
        }
    };

    Scroller.prototype.zoomOut = function zoomOut () {
        var dimensions = this.dimensions;
        dimensions.refresh();
        this._scale(dimensions.fitScale);
        this.movable.moveTo(dimensions.centerCoordinates());
    };

    Scroller.prototype.enable = function enable () {
        this.enabled = true;
    };

    Scroller.prototype.disable = function disable () {
        this.enabled = false;
    };

    Scroller.prototype.scrollTo = function scrollTo (x, y) {
        if (this._native) {
            this.scrollElement.scrollLeft(abs(x));
            this.scrollElement.scrollTop(abs(y));
        } else {
            this.dimensions.refresh();
            this.movable.moveTo({
                x: x,
                y: y
            });
        }
    };

    Scroller.prototype.animatedScrollTo = function animatedScrollTo (x, y, callback) {
        var from, to;
        if (this._native) {
            this.scrollTo(x, y);
        } else {
            from = {
                x: this.movable.x,
                y: this.movable.y
            };
            to = {
                x: x,
                y: y
            };
            this.animatedScroller.setCoordinates(from, to);
            this.animatedScroller.setCallback(callback);
            this.animatedScroller.start();
        }
    };

    // kept for API compatibility, not used
    Scroller.prototype.pullHandled = function pullHandled () {
        // let that = this;

        // removeClass(that.refreshHint, SCROLLER_REFRESH_CLASS);
        // that.hintContainer.innerHTML = that.pullTemplate({}));

        // that.yinertia.onEnd();
        // that.xinertia.onEnd();
        // that.userEvents.cancel();
    };

    Scroller.prototype.destroy = function destroy () {
        var element = this.element;

        off(element, 'wheel', this._wheelScrollHandler);

        if (this.userEvents) {
            this.userEvents.destroy();
        }
    };

    Scroller.prototype._scale = function _scale (scale) {
        this.dimensions.rescale(scale);
        this.movable.scaleTo(scale);
    };

    Scroller.prototype._initPullToRefresh = function _initPullToRefresh () {
    };

    // kept for API compatibility, not used
    Scroller.prototype._dragEnd = function _dragEnd () {
        // let that = this;

        // if (!that.pulled) {
        //     return;
        // }

        // that.pulled = false;

        // removeClass(that.refreshHint, SCROLLER_RELEASE_CLASS);
        // addClass(that.refreshHint, SCROLLER_REFRESH_CLASS);

        // that.hintContainer.innerHTML = that.refreshTemplate({});

        // that.yinertia.freeze(that.options.pullOffset / 2);
        // that.trigger('pull');
    };

    // kept for API compatibility, not used
    Scroller.prototype._paneChange = function _paneChange () {
        // let that = this;
        // if (that.movable.y / OUT_OF_BOUNDS_FRICTION > that.options.pullOffset) {
        //     if (!that.pulled) {
        //         that.pulled = true;
        //         that.refreshHint.removeClass(SCROLLER_REFRESH_CLASS).addClass(SCROLLER_RELEASE_CLASS);
        //         that.hintContainer.html(that.releaseTemplate({}));
        //         that.hintContainer.html(that.releaseTemplate({}));
        //     }
        // } else if (that.pulled) {
        //     that.pulled = false;
        //     that.refreshHint.removeClass(SCROLLER_RELEASE_CLASS);
        //     that.hintContainer.html(that.pullTemplate({}));
        // }
    };

    Scroller.prototype._initAxis = function _initAxis (axis) {
        var that = this,
            movable = that.movable,
            dimension = that.dimensions[axis],
            tapCapture = that.tapCapture,
            paneAxis = that.pane[axis],
            scrollBar = new ScrollBar({
                axis: axis,
                movable: movable,
                dimension: dimension,
                container: that.element,
                alwaysVisible: that.options.visibleScrollHints
            });

        dimension.bind(CHANGE, function() {
            scrollBar.refresh();
        });

        paneAxis.bind(CHANGE, function() {
            scrollBar.show();
        });

        that[axis + 'inertia'] = new DragInertia({
            axis: axis,
            paneAxis: paneAxis,
            movable: movable,
            tapCapture: tapCapture,
            userEvents: that.userEvents,
            dimension: dimension,
            elastic: that.options.elastic,
            friction: that.options.friction || FRICTION$1,
            velocityMultiplier: that.options.velocityMultiplier || VELOCITY_MULTIPLIER$1,
            end: function end() {
                scrollBar.hide();
                that.trigger('scrollEnd', {
                    axis: axis,
                    scrollTop: that.scrollTop,
                    scrollLeft: that.scrollLeft
                });
            }
        });
    };

    return Scroller;
}(Observable));

setDefaultOptions(Scroller, {
    name: 'Scroller',
    zoom: false,
    pullOffset: 140,
    visibleScrollHints: false,
    elastic: true,
    useNative: false,
    mousewheelScrolling: true,
    avoidScrolling: function avoidScrolling() {
        return false;
    },
    pullToRefresh: false,
    messages: {
        pullTemplate: 'Pull to refresh',
        releaseTemplate: 'Release to refresh',
        refreshTemplate: 'Refreshing'
    }
});

setDefaultEvents(Scroller, [
    PULL,
    SCROLL,
    RESIZE
]);

var MapService = function MapService(widget, context) {
    if ( context === void 0 ) context = {};

    this.sender = context.sender || widget;
    this.widget = widget;
    this.rtl = Boolean(context.rtl);
};

MapService.prototype.notify = function notify (name, args) {
    if (this.widget) {
        this.widget.trigger(name, args);
    }
};

var math = Math,
    min$1 = math.min,
    pow = math.pow,
    Point = Point$6,
    MARKER = "marker",
    LOCATION = "location",
    FRICTION = 0.9,
    FRICTION_MOBILE = 0.93,
    MOUSEWHEEL = 'wheel',
    MOUSEWHEEL_THROTTLE = 50,
    VELOCITY_MULTIPLIER = 5,
    DEFAULT_ZOOM_RATE = 1;

var layersMap = {
    bubble: BubbleLayer,
    shape: ShapeLayer,
    tile: TileLayer
};
layersMap[MARKER] = MarkerLayer;

var Map$1 = (function (Observable) {
    function Map(element, options, themeOptions, context) {
        if ( options === void 0 ) options = {};
        if ( themeOptions === void 0 ) themeOptions = {};
        if ( context === void 0 ) context = {};

        Observable.call(this);

        this._init(element, options, themeOptions, context);
    }

    if ( Observable ) Map.__proto__ = Observable;
    Map.prototype = Object.create( Observable && Observable.prototype );
    Map.prototype.constructor = Map;

    Map.prototype.destroy = function destroy () {
        var this$1$1 = this;

        this.scroller.destroy();

        if (this._tooltip) {
            this._tooltip.destroy();
        }

        if (this.navigator) {
            this.navigator.destroy();
        }
        if (this.attribution) {
            this.attribution.destroy();
        }
        if (this.zoomControl) {
            this.zoomControl.destroy();
        }

        if (isArray(this.markers)) {
            this.markers.forEach(function (markerLayer) {
                markerLayer.destroy();
            });
        } else {
            this.markers.destroy();
        }

        for (var i = 0; i < this.layers.length; i++) {
            this$1$1.layers[i].destroy();
        }

        off(this.element, MOUSEWHEEL, this._mousewheelHandler);

        Observable.prototype.destroy.call(this);
    };

    // eslint-disable-next-line no-unused-vars
    Map.prototype._init = function _init (element, options, themeOptions, context) {
        if ( options === void 0 ) options = {};
        if ( themeOptions === void 0 ) themeOptions = {};
        if ( context === void 0 ) context = {};

        this.support = getSupportedFeatures();
        this.context = context;

        this.initObserver(context);
        this.initServices(context);
        this._notifyObserver(INIT);

        this._initOptions(options);
        this._setEvents(options);
        this.crs = new EPSG3857();

        this._initElement(element);

        this._viewOrigin = this._getOrigin();

        this._tooltip = this._createTooltip();
        this._initScroller();
        this._initMarkers();
        this._initControls();
        this._initLayers();
        this._reset();

        var mousewheelThrottled = throttle(this._mousewheel.bind(this), MOUSEWHEEL_THROTTLE);
        this._mousewheelHandler = function (e) {
            e.preventDefault();
            mousewheelThrottled(e);
        };
        on(this.element, MOUSEWHEEL, this._mousewheelHandler);
    };

    Map.prototype._initOptions = function _initOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    Map.prototype._initElement = function _initElement (element) {
        this.element = element;

        addClass(element, "k-map");
        element.style.position = "relative";
        element.setAttribute("data-role", "map");
        removeChildren(element);

        var div = convertToHtml("<div />");
        this.element.appendChild(div);
    };

    Map.prototype.initServices = function initServices (context) {
        if ( context === void 0 ) context = {};

        this.widgetService = new MapService(this, context);
    };

    Map.prototype.initObserver = function initObserver (context) {
        if ( context === void 0 ) context = {};

        this.observers = [];
        this.addObserver(context.observer);
    };

    Map.prototype.addObserver = function addObserver (observer) {
        if (observer) {
            this.observers.push(observer);
        }
    };

    Map.prototype.removeObserver = function removeObserver (observer) {
        var index = this.observers.indexOf(observer);

        if (index >= 0) {
            this.observers.splice(index, 1);
        }
    };

    Map.prototype.requiresHandlers = function requiresHandlers (eventNames) {
        var observers = this.observers;

        for (var idx = 0; idx < observers.length; idx++) {
            if (observers[idx].requiresHandlers(eventNames)) {
                return true;
            }
        }
    };

    Map.prototype.trigger = function trigger (name, args) {
        if ( args === void 0 ) args = {};

        args.sender = this;

        var observers = this.observers;
        var isDefaultPrevented = false;

        for (var idx = 0; idx < observers.length; idx++) {
            if (observers[idx].trigger(name, args)) {
                isDefaultPrevented = true;
            }
        }

        if (!isDefaultPrevented) {
            Observable.prototype.trigger.call(this, name, args);
        }

        return isDefaultPrevented;
    };

    Map.prototype._notifyObserver = function _notifyObserver (name, args) {
        if ( args === void 0 ) args = {};

        args.sender = this;

        var observers = this.observers;
        var isDefaultPrevented = false;

        for (var idx = 0; idx < observers.length; idx++) {
            if (observers[idx].trigger(name, args)) {
                isDefaultPrevented = true;
            }
        }

        return isDefaultPrevented;
    };

    Map.prototype.zoom = function zoom (level) {
        var options = this.options;
        var result;

        if (defined(level)) {
            var zoomLevel = math.round(limitValue(level, options.minZoom, options.maxZoom));

            if (options.zoom !== zoomLevel) {
                options.zoom = zoomLevel;
                this.widgetService.notify(ZOOM_CHANGE, { zoom: options.zoom });

                this._reset();
            }
            result = this;
        } else {
            result = options.zoom;
        }

        return result;
    };

    Map.prototype.center = function center (center$1) {
        var result;

        if (center$1) {
            var current = Location.create(center$1);
            var previous = Location.create(this.options.center);
            if (!current.equals(previous)) {
                this.options.center = current.toArray();
                this.widgetService.notify(CENTER_CHANGE, { center: this.options.center });
                this._reset();
            }

            result = this;
        } else {
            result = Location.create(this.options.center);
        }

        return result;
    };

    Map.prototype.extent = function extent (extent$1) {
        var result;

        if (extent$1) {
            this._setExtent(extent$1);
            result = this;
        } else {
            result = this._getExtent();
        }

        return result;
    };

    Map.prototype.setOptions = function setOptions (options) {
        if ( options === void 0 ) options = {};

        var element = this.element;

        this.destroy();
        removeChildren(element);
        this._init(element, options, {}, this.context);

        this._reset();
    };

    Map.prototype.locationToLayer = function locationToLayer (location, zoom) {
        var clamp = !this.options.wraparound;
        var locationObject = Location.create(location);

        return this.crs.toPoint(locationObject, this._layerSize(zoom), clamp);
    };

    Map.prototype.layerToLocation = function layerToLocation (point, zoom) {
        var clamp = !this.options.wraparound;
        var pointObject = Point.create(point);

        return this.crs.toLocation(pointObject, this._layerSize(zoom), clamp);
    };

    Map.prototype.locationToView = function locationToView (location) {
        var locationObject = Location.create(location);
        var origin = this.locationToLayer(this._viewOrigin);
        var point = this.locationToLayer(locationObject);

        return point.translateWith(origin.scale(-1));
    };

    Map.prototype.viewToLocation = function viewToLocation (point, zoom) {
        var origin = this.locationToLayer(this._getOrigin(), zoom);
        var pointObject = Point.create(point);
        var pointResult = pointObject.clone().translateWith(origin);

        return this.layerToLocation(pointResult, zoom);
    };

    Map.prototype.eventOffset = function eventOffset (e) {
        var x;
        var y;
        var offset = elementOffset(this.element);

        if ((e.x && e.x[LOCATION]) || (e.y && e.y[LOCATION])) {
            x = e.x[LOCATION] - offset.left;
            y = e.y[LOCATION] - offset.top;
        } else {
            var event = e.originalEvent || e;
            x = valueOrDefault(event.pageX, event.clientX) - offset.left;
            y = valueOrDefault(event.pageY, event.clientY) - offset.top;
        }

        var point = new Point$6(x, y);

        return point;
    };

    Map.prototype.eventToView = function eventToView (e) {
        var cursor = this.eventOffset(e);
        return this.locationToView(this.viewToLocation(cursor));
    };

    Map.prototype.eventToLayer = function eventToLayer (e) {
        return this.locationToLayer(this.eventToLocation(e));
    };

    Map.prototype.eventToLocation = function eventToLocation (e) {
        var cursor = this.eventOffset(e);
        return this.viewToLocation(cursor);
    };

    Map.prototype.viewSize = function viewSize () {
        var element = this.element;
        var scale = this._layerSize();
        var width = element.clientWidth;

        if (!this.options.wraparound) {
            width = min$1(scale, width);
        }

        return {
            width: width,
            height: min$1(scale, element.clientHeight)
        };
    };

    Map.prototype.exportVisual = function exportVisual () {
        this._reset();
        return false;
    };

    Map.prototype.hideTooltip = function hideTooltip () {
        if (this._tooltip) {
            this._tooltip.hide();
        }
    };

    Map.prototype._setOrigin = function _setOrigin (origin, zoom) {
        var size = this.viewSize(),
            topLeft;

        var originLocation = this._origin = Location.create(origin);
        topLeft = this.locationToLayer(originLocation, zoom);
        topLeft.x += size.width / 2;
        topLeft.y += size.height / 2;
        this.options.center = this.layerToLocation(topLeft, zoom).toArray();
        this.widgetService.notify(CENTER_CHANGE, { center: this.options.center });

        return this;
    };

    Map.prototype._getOrigin = function _getOrigin (invalidate) {
        var size = this.viewSize(),
            topLeft;

        if (invalidate || !this._origin) {
            topLeft = this.locationToLayer(this.center());
            topLeft.x -= size.width / 2;
            topLeft.y -= size.height / 2;
            this._origin = this.layerToLocation(topLeft);
        }

        return this._origin;
    };

    Map.prototype._setExtent = function _setExtent (newExtent) {
        var this$1$1 = this;

        var raw = Extent.create(newExtent);
        var se = raw.se.clone();

        if (this.options.wraparound && se.lng < 0 && newExtent.nw.lng > 0) {
            se.lng = 180 + (180 + se.lng);
        }

        var extent = new Extent(raw.nw, se);
        this.center(extent.center());
        var width = this.element.clientWidth;
        var height = this.element.clientHeight;
        var zoom;

        for (zoom = this.options.maxZoom; zoom >= this.options.minZoom; zoom--) {
            var topLeft = this$1$1.locationToLayer(extent.nw, zoom);
            var bottomRight = this$1$1.locationToLayer(extent.se, zoom);
            var layerWidth = math.abs(bottomRight.x - topLeft.x);
            var layerHeight = math.abs(bottomRight.y - topLeft.y);

            if (layerWidth <= width && layerHeight <= height) {
                break;
            }
        }

        this.zoom(zoom);
    };

    Map.prototype._getExtent = function _getExtent () {
        var nw = this._getOrigin();
        var bottomRight = this.locationToLayer(nw);
        var size = this.viewSize();

        bottomRight.x += size.width;
        bottomRight.y += size.height;

        var se = this.layerToLocation(bottomRight);

        return new Extent(nw, se);
    };

    Map.prototype._zoomAround = function _zoomAround (pivot, level) {
        this._setOrigin(this.layerToLocation(pivot, level), level);
        this.zoom(level);
    };

    Map.prototype._initControls = function _initControls () {
        var controls = this.options.controls;
        if (controls.attribution) {
            this._createAttribution(controls.attribution);
        }

        if (!this.support.mobileOS) {
            if (controls.navigator) {
                this._createNavigator(controls.navigator);
            }

            if (controls.zoom) {
                this._createZoomControl(controls.zoom);
            }
        }
    };

    Map.prototype._createControlElement = function _createControlElement (options, defaultPosition) {
        var pos = options.position || defaultPosition;
        var posSelector = '.' + renderPos(pos).replace(' ', '.');
        var wrap = this.element.querySelector('.k-map-controls' + posSelector) || [];

        if (wrap.length === 0) {
            var div$1 = document.createElement("div");
            addClass(div$1, 'k-map-controls ' + renderPos(pos));
            wrap = div$1;
            this.element.appendChild(wrap);
        }

        var div = document.createElement("div");

        wrap.appendChild(div);

        return div;
    };

    Map.prototype._createAttribution = function _createAttribution (options) {
        var element = this._createControlElement(options, 'bottomRight');
        this.attribution = new Attribution(element, options);
    };

    Map.prototype._createNavigator = function _createNavigator (options) {
        var element = this._createControlElement(options, 'topLeft');
        var navigator = this.navigator = new Navigator(element, deepExtend({}, options, { icons: this.options.icons }));

        this._navigatorPan = this._navigatorPan.bind(this);
        navigator.bind('pan', this._navigatorPan);

        this._navigatorCenter = this._navigatorCenter.bind(this);
        navigator.bind('center', this._navigatorCenter);
    };

    Map.prototype._navigatorPan = function _navigatorPan (e) {
        var scroller = this.scroller;
        var x = scroller.scrollLeft + e.x;
        var y = scroller.scrollTop - e.y;
        var bounds = this._virtualSize;
        var width = this.element.clientWidth;
        var height = this.element.clientHeight;

        // TODO: Move limits to scroller
        x = limitValue(x, bounds.x.min, bounds.x.max - width);
        y = limitValue(y, bounds.y.min, bounds.y.max - height);

        this.scroller.one('scroll', proxy(this._scrollEnd, this));

        this.scroller.scrollTo(-x, -y);
    };

    Map.prototype._navigatorCenter = function _navigatorCenter () {
        this.center(this.options.center);
    };

    Map.prototype._createZoomControl = function _createZoomControl (options) {
        var element = this._createControlElement(options, 'topLeft');
        var zoomControl = this.zoomControl = new ZoomControl(element, options, this.options.icons);

        this._zoomControlChange = this._zoomControlChange.bind(this);
        zoomControl.bind('change', this._zoomControlChange);
    };

    Map.prototype._zoomControlChange = function _zoomControlChange (e) {
        if (!this.trigger('zoomStart', { originalEvent: e })) {
            this.zoom(this.zoom() + e.delta);

            this.trigger('zoomEnd', {
                originalEvent: e
            });
        }
    };

    Map.prototype._initScroller = function _initScroller () {
        var friction = this.support.mobileOS ? FRICTION_MOBILE : FRICTION;
        var zoomable = this.options.zoomable !== false;
        var scroller = this.scroller = new Scroller(this.element.children[0], {
            friction: friction,
            velocityMultiplier: VELOCITY_MULTIPLIER,
            zoom: zoomable,
            mousewheelScrolling: false,
            supportDoubleTap: true
        });

        scroller.bind('scroll', proxy(this._scroll, this));
        scroller.bind('scrollEnd', proxy(this._scrollEnd, this));

        scroller.userEvents.bind('gesturestart', proxy(this._scaleStart, this));
        scroller.userEvents.bind('gestureend', proxy(this._scale, this));
        scroller.userEvents.bind('doubleTap', proxy(this._doubleTap, this));
        scroller.userEvents.bind('tap', proxy(this._tap, this));

        this.scrollElement = scroller.scrollElement;
    };

    Map.prototype._initLayers = function _initLayers () {
        var this$1$1 = this;

        var defs = this.options.layers,
            layers = this.layers = [];

        for (var i = 0; i < defs.length; i++) {
            var options = defs[i];

            var layer = this$1$1._createLayer(options);
            layers.push(layer);
        }
    };

    Map.prototype._createLayer = function _createLayer (options) {
        var type = options.type || 'shape';
        var layerDefaults = this.options.layerDefaults[type];
        var layerOptions = type === MARKER ?
            deepExtend({}, this.options.markerDefaults, options, { icons: this.options.icons }) :
            deepExtend({}, layerDefaults, options);

        var layerConstructor = layersMap[type];
        var layer = new layerConstructor(this, layerOptions);

        if (type === MARKER) {
            this.markers = layer;
        }

        return layer;
    };

    Map.prototype._createTooltip = function _createTooltip () {
        return new Tooltip(this.widgetService, this.options.tooltip);
    };

    /* eslint-disable arrow-body-style */
    Map.prototype._initMarkers = function _initMarkers () {
        var markerLayers = (this.options.layers || []).filter(function (x) {
            return x && x.type === MARKER;
        });

        if (markerLayers.length > 0) {
            // render the markers from options.layers
            // instead of options.markers
            return;
        }

        this.markers = new MarkerLayer(this, deepExtend({}, this.options.markerDefaults, { icons: this.options.icons }));
        this.markers.add(this.options.markers);
    };
    /* eslint-enable arrow-body-style */

    Map.prototype._scroll = function _scroll (e) {
        var origin = this.locationToLayer(this._viewOrigin).round();
        var movable = e.sender.movable;
        var offset = new Point$6(movable.x, movable.y).scale(-1).scale(1 / movable.scale);

        origin.x += offset.x;
        origin.y += offset.y;
        this._scrollOffset = offset;

        this._tooltip.offset = offset;
        this.hideTooltip();

        this._setOrigin(this.layerToLocation(origin));

        this.trigger('pan', {
            originalEvent: e,
            origin: this._getOrigin(),
            center: this.center()
        });
    };

    Map.prototype._scrollEnd = function _scrollEnd (e) {
        if (!this._scrollOffset || !this._panComplete()) {
            return;
        }

        this._scrollOffset = null;
        this._panEndTimestamp = now();

        this.trigger('panEnd', {
            originalEvent: e,
            origin: this._getOrigin(),
            center: this.center()
        });
    };

    Map.prototype._panComplete = function _panComplete () {
        return now() - (this._panEndTimestamp || 0) > 50;
    };

    Map.prototype._scaleStart = function _scaleStart (e) {
        if (this.trigger('zoomStart', { originalEvent: e })) {
            var touch = e.touches[1];

            if (touch) {
                touch.cancel();
            }
        }
    };

    Map.prototype._scale = function _scale (e) {
        var scale = this.scroller.movable.scale;
        var zoom = this._scaleToZoom(scale);
        var gestureCenter = new Point$6(e.center.x, e.center.y);
        var centerLocation = this.viewToLocation(gestureCenter, zoom);
        var centerPoint = this.locationToLayer(centerLocation, zoom);
        var originPoint = centerPoint.translate(-gestureCenter.x, -gestureCenter.y);

        this._zoomAround(originPoint, zoom);

        this.trigger('zoomEnd', {
            originalEvent: e
        });
    };

    Map.prototype._scaleToZoom = function _scaleToZoom (scaleDelta) {
        var scale = this._layerSize() * scaleDelta;
        var tiles = scale / this.options.minSize;
        var zoom = math.log(tiles) / math.log(2);

        return math.round(zoom);
    };

    Map.prototype._reset = function _reset () {
        if (this.attribution) {
            this.attribution.filter(this.center(), this.zoom());
        }

        this._viewOrigin = this._getOrigin(true);

        this._resetScroller();
        this.hideTooltip();

        this.trigger('beforeReset');
        this.trigger('reset');
    };

    Map.prototype._resetScroller = function _resetScroller () {
        var scroller = this.scroller;
        var x = scroller.dimensions.x;
        var y = scroller.dimensions.y;
        var scale = this._layerSize();
        var nw = this.extent().nw;
        var topLeft = this.locationToLayer(nw).round();

        scroller.movable.round = true;
        scroller.reset();
        scroller.userEvents.cancel();

        var zoom = this.zoom();

        scroller.dimensions.forcedMinScale = pow(2, this.options.minZoom - zoom);
        scroller.dimensions.maxScale = pow(2, this.options.maxZoom - zoom);

        var xBounds = {
            min: -topLeft.x,
            max: scale - topLeft.x
        };

        var yBounds = {
            min: -topLeft.y,
            max: scale - topLeft.y
        };

        if (this.options.wraparound) {
            xBounds.max = 20 * scale;
            xBounds.min = -xBounds.max;
        }

        if (this.options.pannable === false) {
            var viewSize = this.viewSize();
            xBounds.min = yBounds.min = 0;
            xBounds.max = viewSize.width;
            yBounds.max = viewSize.height;
        }

        x.makeVirtual();
        y.makeVirtual();

        x.virtualSize(xBounds.min, xBounds.max);
        y.virtualSize(yBounds.min, yBounds.max);

        this._virtualSize = {
            x: xBounds,
            y: yBounds
        };
    };

    // kept for API compatibility, not used
    Map.prototype._renderLayers = function _renderLayers () {
    };

    Map.prototype._layerSize = function _layerSize (zoom) {
        var newZoom = valueOrDefault(zoom, this.options.zoom);
        return this.options.minSize * pow(2, newZoom);
    };

    Map.prototype._tap = function _tap (e) {
        if (!this._panComplete()) {
            return;
        }

        var cursor = this.eventOffset(e);
        this.hideTooltip();

        this.trigger('click', {
            originalEvent: e,
            location: this.viewToLocation(cursor)
        });
    };

    Map.prototype._doubleTap = function _doubleTap (e) {
        var options = this.options;

        if (options.zoomable !== false) {
            if (!this.trigger('zoomStart', { originalEvent: e })) {
                var toZoom = this.zoom() + DEFAULT_ZOOM_RATE;
                var cursor = this.eventOffset(e);
                var location = this.viewToLocation(cursor);
                var postZoom = this.locationToLayer(location, toZoom);
                var origin = postZoom.translate(-cursor.x, -cursor.y);

                this._zoomAround(origin, toZoom);

                this.trigger('zoomEnd', {
                    originalEvent: e
                });
            }
        }
    };

    Map.prototype._mousewheel = function _mousewheel (e) {
        var delta = mousewheelDelta(e) > 0 ? -1 : 1;
        var options = this.options;
        var fromZoom = this.zoom();
        var toZoom = limitValue(fromZoom + delta, options.minZoom, options.maxZoom);

        if (options.zoomable !== false && toZoom !== fromZoom) {
            if (!this.trigger('zoomStart', { originalEvent: e })) {
                var cursor = this.eventOffset(e);
                var location = this.viewToLocation(cursor);
                var postZoom = this.locationToLayer(location, toZoom);
                var origin = postZoom.translate(-cursor.x, -cursor.y);

                this._zoomAround(origin, toZoom);

                this.trigger('zoomEnd', {
                    originalEvent: e
                });
            }
        }
    };

    Map.prototype._toDocumentCoordinates = function _toDocumentCoordinates (point) {
        var offset = elementOffset(this.element);

        return {
            left: round$1(point.x + offset.left),
            top: round$1(point.y + offset.top)
        };
    };

    return Map;
}(Observable));

setDefaultOptions(Map$1, {
    name: 'Map',
    controls: {
        attribution: true,
        navigator: {
            panStep: 100
        },
        zoom: true
    },
    layers: [],
    layerDefaults: {
        shape: {
            style: {
                fill: {
                    color: '#fff'
                },
                stroke: {
                    color: '#aaa',
                    width: 0.5
                }
            }
        },
        bubble: {
            style: {
                fill: {
                    color: '#fff',
                    opacity: 0.5
                },
                stroke: {
                    color: '#aaa',
                    width: 0.5
                }
            }
        },
        marker: {
            shape: 'pinTarget',
            tooltip: {
                position: 'top'
            }
        }
    },
    center: [
        0,
        0
    ],
    icons: {
        type: "font",
        svgIcons: {}
    },
    zoom: 3,
    minSize: 256,
    minZoom: 1,
    maxZoom: 19,
    markers: [],
    markerDefaults: {
        shape: 'pinTarget',
        tooltip: {
            position: 'top'
        }
    },
    wraparound: true,
    // If set to true, GeoJSON layer "Point" features will be rendered as markers.
    // Otherwise, the points will be rendered as circles.
    // Defaults to `true` for KUI/jQuery, `false` everywhere else.
    renderPointsAsMarkers: false
});

setDefaultEvents(Map$1, [
    'beforeReset',
    'click',
    'markerActivate',
    'markerClick',
    'markerCreated',

    // Events for implementing custom tooltips.
    'markerMouseEnter',
    'markerMouseLeave',

    'pan',
    'panEnd',
    'reset',
    'shapeClick',
    'shapeCreated',
    'shapeFeatureCreated',
    'shapeMouseEnter',
    'shapeMouseLeave',
    'zoomEnd',
    'zoomStart'
]);

var max = function (array, mapFn) { return Math.max.apply(null, array.map(mapFn)); };
var min = function (array, mapFn) { return Math.min.apply(null, array.map(mapFn)); };
var sum = function (array, mapFn) { return array.map(mapFn).reduce(function (acc, curr) { return (acc + curr); }, 0); };
var sortAsc = function (a, b) { return (a.y0 === b.y0 ? a.index - b.index : a.y0 + a.y1 - b.y0 - b.y1); };
var sortSource = function (a, b) { return sortAsc(a.source, b.source); };
var sortTarget = function (a, b) { return sortAsc(a.target, b.target); };
var value = function (node) { return node.value; };

function sortLinks(nodes) {
    nodes.forEach(function (node) {
        node.targetLinks.forEach(function (link) {
            link.source.sourceLinks.sort(sortTarget);
        });
        node.sourceLinks.forEach(function (link) {
            link.target.targetLinks.sort(sortSource);
        });
    });
}

var calcLayer = function (node, maxDepth) {
    if (node.align === 'left') {
        return node.depth;
    }

    if (node.align === 'right') {
        return maxDepth - node.height;
    }

    return node.sourceLinks.length ? node.depth : maxDepth;
};

var Sankey$1 = function Sankey(options) {
    var ref = options.nodesOptions;
    var offset = ref.offset; if ( offset === void 0 ) offset = {};
    var align = ref.align;
    this.data = {
        nodes: options.nodes.map(function (node) { return deepExtend({}, { offset: offset, align: align }, node); }),
        links: options.links.map(function (link) { return deepExtend({}, link); })
    };

    this.width = options.width;
    this.height = options.height;
    this.offsetX = options.offsetX || 0;
    this.offsetY = options.offsetY || 0;
    this.nodeWidth = options.nodesOptions.width;
    this.nodePadding = options.nodesOptions.padding;
    this.reverse = options.reverse;
    this.targetColumnIndex = options.targetColumnIndex;
    this.loops = options.loops;
    this.autoLayout = options.autoLayout;
};

Sankey$1.prototype.calculate = function calculate () {
    var ref = this.data;
        var nodes = ref.nodes;
        var links = ref.links;
    this.connectLinksToNodes(nodes, links);
    this.calculateNodeValues(nodes);

    var circularLinks = this.calculateNodeHeights(nodes);

    if (circularLinks) {
        return { nodes: [], links: [], columns: [], circularLinks: circularLinks };
    }

    this.calculateNodeDepths(nodes);
    var columns = this.calculateNodeColumns(nodes);
    this.calculateNodeBreadths(columns);
    this.applyNodesOffset(nodes);
    this.calculateLinkBreadths(nodes);

    return Object.assign({}, this.data, {columns: columns});
};

Sankey$1.prototype.connectLinksToNodes = function connectLinksToNodes (nodes, links) {
    var nodesMap = new Map();

    nodes.forEach(function (node, i) {
        node.index = i;
        node.sourceLinks = [];
        node.targetLinks = [];
        node.id = node.id !== undefined ? node.id : node.label.text;
        nodesMap.set(node.id, node);
    });

    links.forEach(function (link) {
        link.source = nodesMap.get(link.sourceId);
        link.target = nodesMap.get(link.targetId);
        link.source.sourceLinks.push(link);
        link.target.targetLinks.push(link);
    });
};

Sankey$1.prototype.calculateNodeValues = function calculateNodeValues (nodes) {
    nodes.forEach(function (node) {
        node.value = Math.max(
            sum(node.sourceLinks, value),
            sum(node.targetLinks, value)
        );
    });
};

Sankey$1.prototype.calculateNodeDepths = function calculateNodeDepths (nodes) {
    var current = new Set(nodes);
    var next = new Set();
    var currDepth = 0;
    while (current.size) {
        var currentNodes = Array.from(current);
        for (var n = 0; n < currentNodes.length; n++) {
            var node = currentNodes[n];
            node.depth = currDepth;
            for (var l = 0; l < node.sourceLinks.length; l++) {
                var link = node.sourceLinks[l];
                next.add(link.target);
            }
        }
        currDepth++;
        current = next;
        next = new Set();
    }
};

Sankey$1.prototype.calculateNodeHeights = function calculateNodeHeights (nodes) {
    var nodesLength = nodes.length;
    var current = new Set(nodes);
    var next = new Set;
    var currentHeight = 0;
    var eachNode = function (node) {
        node.height = currentHeight;
        node.targetLinks.forEach(function (link) {
            next.add(link.source);
        });
    };
    while (current.size) {
        current.forEach(eachNode);
        currentHeight++;
        if (currentHeight > nodesLength) {
            return true;
        }
        current = next;
        next = new Set;
    }
    return false;
};

Sankey$1.prototype.calculateNodeColumns = function calculateNodeColumns (nodes) {
        var this$1$1 = this;

    var maxDepth = max(nodes, function (d) { return d.depth; });
    var columnWidth = (this.width - this.offsetX - this.nodeWidth) / maxDepth;
    var columns = new Array(maxDepth + 1);
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var layer = Math.max(0, Math.min(maxDepth, calcLayer(node, maxDepth)));
        node.x0 = this$1$1.offsetX + layer * columnWidth;
        node.x1 = node.x0 + this$1$1.nodeWidth;
        node.layer = layer;
        columns[layer] = columns[layer] || [];
        columns[layer].push(node);
    }

    return columns;
};

Sankey$1.prototype.calculateNodeBreadths = function calculateNodeBreadths (columns) {
        var this$1$1 = this;

    var kSize = min(columns, function (c) { return (this$1$1.height - this$1$1.offsetY - (c.length - 1) * this$1$1.nodePadding) / sum(c, value); });

    columns.forEach(function (nodes) {
        var y = this$1$1.offsetY;
        nodes.forEach(function (node) {
            node.y0 = y;
            node.y1 = y + node.value * kSize;
            y = node.y1 + this$1$1.nodePadding;
            node.sourceLinks.forEach(function (link) {
                link.width = link.value * kSize;
            });
        });
        y = (this$1$1.height - y + this$1$1.nodePadding) / (nodes.length + 1);
        nodes.forEach(function (node, i) {
            node.y0 += y * (i + 1);
            node.y1 += y * (i + 1);
        });
    });

    if (this.autoLayout !== false) {
        var loops = this.loops !== undefined ? this.loops : columns.length - 1;
        var targetColumnIndex = this.targetColumnIndex || 1;

        for (var i = 0; i < loops; i++) {
            if (!this$1$1.reverse) {
                this$1$1.uncurlLinksToLeft(columns, targetColumnIndex);
                this$1$1.uncurlLinksToRight(columns, targetColumnIndex);
            } else {
                this$1$1.uncurlLinksToRight(columns, targetColumnIndex);
                this$1$1.uncurlLinksToLeft(columns, targetColumnIndex);
            }
        }
    }

    columns.forEach(sortLinks);
};

Sankey$1.prototype.applyNodesOffset = function applyNodesOffset (nodes) {
    nodes.forEach(function (node) {
        var offsetX = (node.offset ? node.offset.left : 0) || 0;
        var offsetY = (node.offset ? node.offset.top : 0) || 0;
        node.x0 += offsetX;
        node.x1 += offsetX;
        node.y0 += offsetY;
        node.y1 += offsetY;
    });
};

Sankey$1.prototype.calculateLinkBreadths = function calculateLinkBreadths (nodes) {
    nodes.forEach(function (node) {
        var sourceLinks = node.sourceLinks;
            var targetLinks = node.targetLinks;
        var y = node.y0;
        var y1 = y;
        sourceLinks.forEach(function (link) {
            link.x0 = link.source.x1;
            link.y0 = y + link.width / 2;
            y += link.width;
        });
        targetLinks.forEach(function (link) {
            link.x1 = link.target.x0;
            link.y1 = y1 + link.width / 2;
            y1 += link.width;
        });
    });
};

Sankey$1.prototype.uncurlLinksToRight = function uncurlLinksToRight (columns, targetColumnIndex) {
        var this$1$1 = this;

    var n = columns.length;
    for (var i = targetColumnIndex; i < n; i++) {
        var column = columns[i];
        column.forEach(function (target) {
            var y = 0;
            var sum = 0;
            target.targetLinks.forEach(function (link) {
                var kValue = link.value * (target.layer - link.source.layer);
                y += this$1$1.targetTopPos(link.source, target) * kValue;
                sum += kValue;
            });

            var dy = y === 0 ? 0 : (y / sum - target.y0);
            target.y0 += dy;
            target.y1 += dy;
            sortLinks([target]);
        });
        column.sort(sortAsc);
        this$1$1.arrangeNodesVertically(column);
    }
};

Sankey$1.prototype.uncurlLinksToLeft = function uncurlLinksToLeft (columns, targetColumnIndex) {
        var this$1$1 = this;

    var l = columns.length;
    var startIndex = l - 1 - targetColumnIndex;
    for (var i = startIndex; i >= 0; i--) {
        var column = columns[i];
        var loop = function ( j ) {
            var source = column[j];
            var y = 0;
            var sum = 0;
            source.sourceLinks.forEach(function (link) {
                var kValue = link.value * (link.target.layer - source.layer);
                y += this$1$1.sourceTopPos(source, link.target) * kValue;
                sum += kValue;
            });
            var dy = y === 0 ? 0 : (y / sum - source.y0);
            source.y0 += dy;
            source.y1 += dy;
            sortLinks([source]);
        };

            for (var j = 0; j < column.length; j++) loop( j );

        column.sort(sortAsc);
        this$1$1.arrangeNodesVertically(column);
    }
};

Sankey$1.prototype.arrangeNodesVertically = function arrangeNodesVertically (nodes) {
    var startIndex = 0;
    var endIndex = nodes.length - 1;

    this.arrangeUp(nodes, this.height, endIndex);
    this.arrangeDown(nodes, this.offsetY, startIndex);
};

Sankey$1.prototype.arrangeDown = function arrangeDown (nodes, yPos, index) {
        var this$1$1 = this;

    var currentY = yPos;

    for (var i = index; i < nodes.length; i++) {
        var node = nodes[i];
        var dy = Math.max(0, currentY - node.y0);
        node.y0 += dy;
        node.y1 += dy;
        currentY = node.y1 + this$1$1.nodePadding;
    }
};

Sankey$1.prototype.arrangeUp = function arrangeUp (nodes, yPos, index) {
        var this$1$1 = this;

    var currentY = yPos;
    for (var i = index; i >= 0; --i) {
        var node = nodes[i];
        var dy = Math.max(0, node.y1 - currentY);
        node.y0 -= dy;
        node.y1 -= dy;
        currentY = node.y0 - this$1$1.nodePadding;
    }
};

Sankey$1.prototype.sourceTopPos = function sourceTopPos (source, target) {
        var this$1$1 = this;

    var y = target.y0 - ((target.targetLinks.length - 1) * this.nodePadding) / 2;
    for (var i = 0; i < target.targetLinks.length; i++) {
        var link = target.targetLinks[i];
        if (link.source === source) {
            break;
        }
        y += link.width + this$1$1.nodePadding;
    }
    for (var i$1 = 0; i$1 < source.sourceLinks.length; i$1++) {
        var link$1 = source.sourceLinks[i$1];
        if (link$1.target === target) {
            break;
        }
        y -= link$1.width;
    }
    return y;
};

Sankey$1.prototype.targetTopPos = function targetTopPos (source, target) {
        var this$1$1 = this;

    var y = source.y0 - ((source.sourceLinks.length - 1) * this.nodePadding) / 2;
    for (var i = 0; i < source.sourceLinks.length; i++) {
        var link = source.sourceLinks[i];
        if (link.target === target) {
            break;
        }
        y += link.width + this$1$1.nodePadding;
    }
    for (var i$1 = 0; i$1 < target.targetLinks.length; i$1++) {
        var link$1 = target.targetLinks[i$1];
        if (link$1.source === source) {
            break;
        }
        y -= link$1.width;
    }
    return y;
};

var calculateSankey = function (options) { return new Sankey$1(options).calculate(); };

var crossesValue = function (links) {
    var value = 0;
    var linksLength = links.length;

    for (var i = 0; i < linksLength; i++) {
        var link = links[i];

        for (var lNext = i + 1; lNext < linksLength; lNext++) {
            var nextLink = links[lNext];

            if (intersect(link, nextLink)) {
                value += Math.min(link.value, nextLink.value);
            }
        }
    }

    return value;
};

function rotationDirection(p1x, p1y, p2x, p2y, p3x, p3y) {
    var expression1 = (p3y - p1y) * (p2x - p1x);
    var expression2 = (p2y - p1y) * (p3x - p1x);

    if (expression1 > expression2) {
        return 1;
    } else if (expression1 === expression2) {
        return 0;
    }

    return -1;
}

function intersect(link1, link2) {
    var f1 = rotationDirection(link1.x0, link1.y0, link1.x1, link1.y1, link2.x1, link2.y1);
    var f2 = rotationDirection(link1.x0, link1.y0, link1.x1, link1.y1, link2.x0, link2.y0);
    var f3 = rotationDirection(link1.x0, link1.y0, link2.x0, link2.y0, link2.x1, link2.y1);
    var f4 = rotationDirection(link1.x1, link1.y1, link2.x0, link2.y0, link2.x1, link2.y1);

    return f1 !== f2 && f3 !== f4;
}

var SankeyElement = (function (Class) {
    function SankeyElement(options) {
        Class.call(this);
        this.options = deepExtend({}, this.options, options);
        this.createVisual();
    }

    if ( Class ) SankeyElement.__proto__ = Class;
    SankeyElement.prototype = Object.create( Class && Class.prototype );
    SankeyElement.prototype.constructor = SankeyElement;

    SankeyElement.prototype.createVisual = function createVisual () {
        this.visual = this.createElement();
    };

    SankeyElement.prototype.exportVisual = function exportVisual () {
        return this.visual;
    };

    SankeyElement.prototype.createElement = function createElement () {
        var this$1$1 = this;

        var customVisual = this.options.visual;
        var visual;

        if (customVisual) {
            visual = customVisual({
                sender: this.getSender(),
                options: this.visualOptions(),
                createVisual: function () { return this$1$1.getElement(); }
            });
        } else {
            visual = this.getElement();
        }

        return visual;
    };

    SankeyElement.prototype.getSender = function getSender () {
        return this;
    };

    return SankeyElement;
}(Class));

var Node = (function (SankeyElement) {
    function Node () {
        SankeyElement.apply(this, arguments);
    }

    if ( SankeyElement ) Node.__proto__ = SankeyElement;
    Node.prototype = Object.create( SankeyElement && SankeyElement.prototype );
    Node.prototype.constructor = Node;

    Node.prototype.getElement = function getElement () {
        return Path$7.fromRect(this.getRect(), this.visualOptions());
    };

    Node.prototype.getRect = function getRect () {
        var node = this.options.node;
        return new Rect([node.x0, node.y0], [node.x1 - node.x0, node.y1 - node.y0]);
    };

    Node.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = options.labels.ariaTemplate;

        if (labelTemplate) {
            return labelTemplate({ node: options.node });
        }
    };

    Node.prototype.visualOptions = function visualOptions () {
        var options = deepExtend({}, this.options, this.options.node);
        var ariaLabel = this.getLabelText(options);

        return {
            fill: {
                color: options.color,
                opacity: options.opacity
            },
            stroke: { width: 0 },
            className: 'k-sankey-node',
            role: 'graphics-symbol',
            ariaRoleDescription: 'Node',
            ariaLabel: ariaLabel
        };
    };

    Node.prototype.createFocusHighlight = function createFocusHighlight () {
        if (!this.options.navigatable) {
            return;
        }

        this._highlight = Path$7.fromRect(this.getRect(), {
            stroke: this.options.focusHighlight.border,
            visible: false
        });

        return this._highlight;
    };

    Node.prototype.focus = function focus (options) {
        if (this._highlight) {
            var ref = options || {};
            var highlight = ref.highlight; if ( highlight === void 0 ) highlight = true;
            if (highlight) {
                this._highlight.options.set('visible', true);
            }
            var id = this.options.node.id;
            this.visual.options.set('id', id);

            if (this.options.root()) {
                this.options.root().setAttribute(ARIA_ACTIVE_DESCENDANT, id);
            }
        }
    };

    Node.prototype.blur = function blur () {
        if (this._highlight) {
            this._highlight.options.set('visible', false);
            this.visual.options.set('id', '');

            if (this.options.root()) {
                this.options.root().removeAttribute(ARIA_ACTIVE_DESCENDANT);
            }
        }
    };

    return Node;
}(SankeyElement));

var nodeColor = function (node, nodeColors, index) { return node.color || nodeColors[index % nodeColors.length]; };

var resolveNodeOptions = function (node, options, nodeColors, index) {
    var nodeOptions = deepExtend({}, options, options.node);
    return deepExtend({},
        { color: nodeColor(node, nodeColors, index) },
        nodeOptions,
        { node: node },
        {
            visual: node.visual,
            opacity: node.opacity,
            offset: node.offset,
            color: node.color
        }
    );
};

/* eslint-disable camelcase */

var bezierPoint = function (p1, p2, p3, p4, t) {
    var t1 = 1 - t;
    var t1t1 = t1 * t1;
    var tt = t * t;
    return (p1 * t1t1 * t1) + (3 * p2 * t * t1t1) + (3 * p3 * tt * t1) + (p4 * tt * t);
};

function calculatePerpendicularLine(x1, y1, x2, y2, L) {
    // 1. Calculate the midpoint M
    var xM = (x1 + x2) / 2;
    var yM = (y1 + y2) / 2;

    var dx, dy;
    if (y1 === y2) {
        // The line AB is horizontal
        dx = 0;
        dy = L / 2;
    } else if (x1 === x2) {
        // The line AB is vertical
        dx = L / 2;
        dy = 0;
    } else {
        // Common case when the line is not horizontal or vertical
        // 2. Calculate the slope of the original line
        var m = (y2 - y1) / (x2 - x1);

        // 3. Calculate the slope of the perpendicular line
        var mPerp = -1 / m;

        // 4. Calculate dx and dy
        dx = (L / 2) / Math.sqrt(1 + mPerp * mPerp);
        dy = mPerp * dx;
    }

    // 5. Coordinates of the points of the perpendicular line
    var P1 = { x: xM - dx, y: yM - dy };
    var P2 = { x: xM + dx, y: yM + dy };

    return { P1: P1, P2: P2 };
}

function findIntersection(a, b, L, p, q) {
    // Midpoint between a and b
    var midpoint = {
        x: (a.x + b.x) / 2,
        y: (a.y + b.y) / 2
    };

    // Vector of the line ab
    var ab_dx = b.x - a.x;
    var ab_dy = b.y - a.y;

    // Vector, perpendicular to ab
    var perp_dx = -ab_dy;
    var perp_dy = ab_dx;

    // Normalize the perpendicular vector and scale it to 2*L
    var magnitude = Math.sqrt(perp_dx * perp_dx + perp_dy * perp_dy);
    perp_dx = (perp_dx / magnitude) * L;
    perp_dy = (perp_dy / magnitude) * L;

    // The endpoints of the perpendicular, 2*L long
    var c1 = {
        x: midpoint.x + perp_dx,
        y: midpoint.y + perp_dy
    };
    var c2 = {
        x: midpoint.x - perp_dx,
        y: midpoint.y - perp_dy
    };

    // Check for intersection of the lines pq and the perpendicular
    var pq_dx = q.x - p.x;
    var pq_dy = q.y - p.y;

    var denominator = (pq_dy) * (c1.x - c2.x) - (pq_dx) * (c1.y - c2.y);

    if (Math.abs(denominator) < 1e-10) {
        // The lines are almost parallel, no intersection
        return null;
    }

    var ua = (pq_dx * (c2.y - p.y) - pq_dy * (c2.x - p.x)) / denominator;
    var ub = ((c1.x - c2.x) * (c2.y - p.y) - (c1.y - c2.y) * (c2.x - p.x)) / denominator;

    if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
        var intersection = {
            x: c2.x + ua * (c1.x - c2.x),
            // y: c2.y + ua * (c1.y - c2.y)
        };
        return intersection;
    }

    // No intersection of the segments
    return null;
}

var calculateControlPointsOffsetX = function (link, rtl) {
    var halfWidth = link.width / 2;
    var x0 = rtl ? link.x1 : link.x0;
    var x1 = rtl ? link.x0 : link.x1;
    var y0 = rtl ? link.y1 : link.y0;
    var y1 = rtl ? link.y0 : link.y1;

    var xC = (x0 + x1) / 2;
    var middlePoint = [xC, bezierPoint(y0, y0, y1, y1, 0.5)];

    var tH = 0.4999;

    var pointH = [
        bezierPoint(x0, xC, xC, x1, tH),
        bezierPoint(y0, y0, y1, y1, tH)
    ];

    var line = calculatePerpendicularLine(middlePoint[0], middlePoint[1], pointH[0], pointH[1], link.width);

    var middlePointDown = [xC, bezierPoint(y0 + halfWidth, y0 + halfWidth, y1 + halfWidth, y1 + halfWidth, 0.5)];
    // const middlePointUp = [xC, bezierPoint(y0 - halfWidth, y0 - halfWidth, y1 - halfWidth, y1 - halfWidth, 0.5)];

    var P = line.P1.y > line.P2.y ? line.P1 : line.P2;
    var L = halfWidth;
    var LDir = (y0 > y1 ? 1 : -1) * L;
    var a = P;
    var b = { x: middlePointDown[0], y: middlePointDown[1] };
    var p = { x: middlePointDown[0], y: middlePointDown[1] };
    var q = { x: Math.max(1, middlePointDown[0] + LDir), y: middlePointDown[1] };
    var Pmx = findIntersection(a, b, L, p, q) || { x: (middlePointDown[0] + P.x) / 2 };
    var P1 = x0;
    var P4 = x1;
    var P2 = (Pmx.x - (0.125 * P1) - (0.125 * P4)) / 0.75;

    return xC - P2;
};

var Link = (function (SankeyElement) {
    function Link () {
        SankeyElement.apply(this, arguments);
    }

    if ( SankeyElement ) Link.__proto__ = SankeyElement;
    Link.prototype = Object.create( SankeyElement && SankeyElement.prototype );
    Link.prototype.constructor = Link;

    Link.prototype.getElement = function getElement () {
        var link = this.options.link;
        var x0 = link.x0;
        var x1 = link.x1;
        var y0 = link.y0;
        var y1 = link.y1;
        var xC = (x0 + x1) / 2;

        return new Path$7(this.visualOptions())
            .moveTo(x0, y0).curveTo([xC, y0], [xC, y1], [x1, y1]);
    };

    Link.prototype.getLabelText = function getLabelText (options) {
        var labelTemplate = options.labels.ariaTemplate;

        if (labelTemplate) {
            return labelTemplate({ link: options.link });
        }
    };

    Link.prototype.visualOptions = function visualOptions () {
        var options = this.options;
        var link = this.options.link;
        var ariaLabel = this.getLabelText(options);

        return {
            stroke: {
                width: options.link.width,
                color: link.color || options.color,
                opacity: defined(link.opacity) ? link.opacity : options.opacity
            },
            role: 'graphics-symbol',
            ariaRoleDescription: 'Link',
            ariaLabel: ariaLabel
        };
    };

    Link.prototype.createFocusHighlight = function createFocusHighlight () {
        if (!this.options.navigatable) {
            return;
        }

        var ref = this.options;
        var link = ref.link;
        var x0 = link.x0;
        var x1 = link.x1;
        var y0 = link.y0;
        var y1 = link.y1;
        var xC = (x0 + x1) / 2;
        var halfWidth = link.width / 2;

        var offset = calculateControlPointsOffsetX(link, this.options.rtl);

        this._highlight = new Path$7({ stroke: this.options.focusHighlight.border, visible: false })
            .moveTo(x0, y0 + halfWidth)
            .lineTo(x0, y0 - halfWidth)
            .curveTo([xC + offset, y0 - halfWidth], [xC + offset, y1 - halfWidth], [x1, y1 - halfWidth])
            .lineTo(x1, y1 + halfWidth)
            .curveTo([xC - offset, y1 + halfWidth], [xC - offset, y0 + halfWidth], [x0, y0 + halfWidth]);
    };

    Link.prototype.focus = function focus (options) {
        if (this._highlight) {
            var ref = options || {};
            var highlight = ref.highlight; if ( highlight === void 0 ) highlight = true;
            if (highlight) {
                this._highlight.options.set('visible', true);
            }
            var id = (this.options.link.sourceId) + "->" + (this.options.link.targetId);
            this.visual.options.set('id', id);

            if (this.options.root()) {
                this.options.root().setAttribute(ARIA_ACTIVE_DESCENDANT, id);
            }
        }
    };

    Link.prototype.blur = function blur () {
        if (this._highlight) {
            this._highlight.options.set('visible', false);
            this.visual.options.set('id', '');

            if (this.options.root()) {
                this.options.root().removeAttribute(ARIA_ACTIVE_DESCENDANT);
            }
        }
    };

    return Link;
}(SankeyElement));

var resolveLinkOptions = function (link, options, sourceNode, targetNode) {
    var linkOptions = deepExtend({},
        options,
        {
            link: link,
            opacity: link.opacity,
            color: link.color,
            colorType: link.colorType,
            visual: link.visual,
            highlight: link.highlight
        }
    );

    if (linkOptions.colorType === 'source') {
        linkOptions.color = sourceNode.options.fill.color;
    } else if (linkOptions.colorType === 'target') {
        linkOptions.color = targetNode.options.fill.color;
    }

    return linkOptions;
};

var INSIDE = 'inside';
var BEFORE = 'before';
var AFTER = 'after';

var Label = (function (SankeyElement) {
    function Label () {
        SankeyElement.apply(this, arguments);
    }

    if ( SankeyElement ) Label.__proto__ = SankeyElement;
    Label.prototype = Object.create( SankeyElement && SankeyElement.prototype );
    Label.prototype.constructor = Label;

    Label.prototype.getElement = function getElement () {
        var options = deepExtend({}, this.options, this.options.node.label);
        var node = options.node;
        var diagramMinX = options.diagramMinX;
        var diagramMaxX = options.diagramMaxX;
        var text = options.text;
        var offset = options.offset;
        var rtl = options.rtl;
        var position = options.position;
        if (rtl && position !== INSIDE) {
            position = position === BEFORE ? AFTER : BEFORE;
        }

        if (!options.visible || !text) {
            return null;
        }

        var nodeBox = new Box(node.x0, node.y0, node.x1, node.y1);
        var visualOptions = this.visualOptions();
        if (rtl && !visualOptions.align) {
            visualOptions.align = 'right';
        }
        var textbox = new TextBox(text, visualOptions);
        textbox.reflow(new Box());
        var textSizeBox = textbox.box;
        var textY = nodeBox.center().y - (textSizeBox.height() / 2);

        var labelAfterLastNode = node.x1 + textSizeBox.width() > diagramMaxX;
        var labelBeforeFirstNode = node.x0 - textSizeBox.width() < diagramMinX;
        var side = position === BEFORE || (position === INSIDE && labelAfterLastNode) ? BEFORE : AFTER;
        if (rtl) {
            side = position === AFTER || (position === INSIDE && labelBeforeFirstNode) ? AFTER : BEFORE;
        }
        var textOrigin = [side === BEFORE ? node.x0 - textSizeBox.width() : node.x1, textY];

        var textRect = new Box(textOrigin[0], textOrigin[1], textOrigin[0] + textSizeBox.width(), textOrigin[1] + textSizeBox.height());
        textRect.translate(offset.left || 0, offset.top || 0);
        textbox.reflow(textRect);

        textbox.renderVisual();

        return textbox.visual;
    };

    Label.prototype.visualOptions = function visualOptions () {
        var options = deepExtend({}, this.options, this.options.node.label);
        return {
            color: options.color,
            font: options.font,
            border: options.border,
            margin: options.margin,
            padding: options.padding,
            align: options.align,
            paintOrder: options.paintOrder,
            stroke: options.stroke,
        };
    };

    return Label;
}(SankeyElement));

setDefaultOptions(Label, {
    position: INSIDE, // inside, before, after
});

var resolveLabelOptions = function (node, options, rtl, diagramMinX, diagramMaxX) { return deepExtend({},
    options,
    {
        node: node,
        diagramMinX: diagramMinX,
        diagramMaxX: diagramMaxX,
        rtl: rtl,
        visual: node.label.visual,
        visible: node.label.visible,
        margin: node.label.margin,
        padding: node.label.padding,
        border: node.label.border,
        align: node.label.align,
        offset: node.label.offset
    }
); };

var Title = (function (SankeyElement) {
    function Title () {
        SankeyElement.apply(this, arguments);
    }

    if ( SankeyElement ) Title.__proto__ = SankeyElement;
    Title.prototype = Object.create( SankeyElement && SankeyElement.prototype );
    Title.prototype.constructor = Title;

    Title.prototype.getElement = function getElement () {
        var options = this.options;
        var drawingRect = options.drawingRect;
        var text = options.text;

        if (options.visible === false || !text) {
            return null;
        }

        var title = Title$1.buildTitle(text, options);

        title.reflow(drawingRect);

        title.renderVisual();
        return title.visual;
    };

    Title.prototype.createElement = function createElement () {
        return this.getElement();
    };

    return Title;
}(SankeyElement));

setDefaultOptions(Title, {
    align: CENTER, // 'left', 'right', 'center'
    border: {
        width: 0
    },
    margin: getSpacing(5),
    padding: getSpacing(5)
});

var sortData = function (a, b) {
    if (a.node.x0 - b.node.x0 !== 0) {
        return a.node.x0 - b.node.x0;
    }
    return a.node.y0 - b.node.y0;
};

var sortDataRTL = function (a, b) {
    if (a.node.x1 - b.node.x1 !== 0) {
        return a.node.x1 - b.node.x1;
    }
    return b.node.y0 - a.node.y0;
};

var sort = function (rtl) { return (rtl ? sortDataRTL : sortData); };

var Legend = (function (SankeyElement) {
    function Legend () {
        SankeyElement.apply(this, arguments);
    }

    if ( SankeyElement ) Legend.__proto__ = SankeyElement;
    Legend.prototype = Object.create( SankeyElement && SankeyElement.prototype );
    Legend.prototype.constructor = Legend;

    Legend.prototype.getElement = function getElement () {
        var options = this.options;
        var drawingRect = options.drawingRect;
        var rtl = options.rtl;
        var nodes = options.nodes; if ( nodes === void 0 ) nodes = [];
        var item = options.item;
        var position = options.position;

        if (options.visible === false || !nodes.length) {
            return null;
        }

        var data = nodes.map(function (node) { return ({
            text: (node.label && node.label.text) || '',
            area: {
                background: item.areaBackground !== undefined ? item.areaBackground : node.color,
                opacity: item.areaOpacity !== undefined ? item.areaOpacity : node.opacity
            },
            node: node
        }); });

        data.sort(sort(rtl));

        var reverse = rtl && position !== LEFT && position !== RIGHT;
        var legend = new Legend$1(Object.assign({}, options, {data: data, reverse: reverse}), { rtl: rtl });
        legend.reflow(drawingRect);

        legend.renderVisual();
        return legend.visual;
    };

    Legend.prototype.createElement = function createElement () {
        return this.getElement();
    };

    return Legend;
}(SankeyElement));

setDefaultOptions(Legend, {
    markers: { visible: false },
    item: {
        type: AREA,
        cursor: POINTER,
        opacity: 1
    },
    position: BOTTOM$1,
    align: CENTER,
    accessibility: {
        role: 'presentation',
        ariaLabel: null,
        ariaRoleDescription: null
    },
    border: {
        width: 0
    }
});

var LINK = 'link';
var NODE = 'node';

var toRtl = function (sankey) {
    var nodes = sankey.nodes;
    var links = sankey.links;
    var startX = Math.min.apply(Math, nodes.map(function (node) { return node.x0; }));
    var endX = Math.max.apply(Math, nodes.map(function (node) { return node.x1; }));
    var width = endX - startX;

    nodes.forEach(function (node) {
        var x0 = width - (node.x1 - 2 * startX);
        var x1 = width - (node.x0 - 2 * startX);
        node.x0 = x0;
        node.x1 = x1;
    });

    links.forEach(function (link) {
        var x0 = width - (link.x1 - 2 * startX);
        var x1 = width - (link.x0 - 2 * startX);
        link.x1 = x0;
        link.x0 = x1;
    });
};

var Sankey = (function (Observable) {
    function Sankey(element, options, theme) {
        Observable.call(this);

        this._initTheme(theme);
        this._setOptions(options);
        this._initElement(element);
        this._initSurface();

        if (options && options.data) {
            this._redraw();
            this._initResizeObserver();
            this._initNavigation(element);
        }
    }

    if ( Observable ) Sankey.__proto__ = Observable;
    Sankey.prototype = Object.create( Observable && Observable.prototype );
    Sankey.prototype.constructor = Sankey;

    Sankey.prototype.destroy = function destroy () {
        this.unbind();
        this._destroySurface();
        this._destroyResizeObserver();

        if (this.element) {
            this.element.removeEventListener('keydown', this._keydownHandler);
            this.element.removeEventListener('focus', this._focusHandler);
            this.element.removeEventListener('mousedown', this._onDownHandler);
            this.element.removeEventListener('touchstart', this._onDownHandler);
            this.element.removeEventListener('pointerdown', this._onDownHandler);
        }

        this._focusState = null;

        this.element = null;
    };

    Sankey.prototype._initElement = function _initElement (element) {
        this.element = element;
        addClass(element, [ "k-chart", "k-sankey" ]);
        element.setAttribute('role', 'graphics-document');

        var ref = this.options;
        var title = ref.title;

        if (title.text) {
            element.setAttribute('aria-label', title.text);
        }

        if (title.description) {
            element.setAttribute("aria-roledescription", title.description);
        }
    };

    Sankey.prototype._initSurface = function _initSurface () {
        if (!this.surface) {
            this._destroySurface();
            this._initSurfaceElement();
            this.surface = this._createSurface();
        }
    };

    Sankey.prototype._initNavigation = function _initNavigation (element) {
        element.tabIndex = element.getAttribute("tabindex") || 0;

        if (this.options.disableKeyboardNavigation) {
            return;
        }

        this._keydownHandler = this._keydown.bind(this);
        this._focusHandler = this._focus.bind(this);
        this._blurHandler = this._blur.bind(this);
        this._onDownHandler = this._onDown.bind(this);

        element.addEventListener('keydown', this._keydownHandler);
        element.addEventListener('focus', this._focusHandler);
        element.addEventListener('blur', this._blurHandler);
        element.addEventListener('mousedown', this._onDownHandler);
        element.addEventListener('touchstart', this._onDownHandler);
        element.addEventListener('pointerdown', this._onDownHandler);

        this._focusState = {
            node: this.firstFocusableNode(),
            link: null
        };
    };

    Sankey.prototype.firstFocusableNode = function firstFocusableNode () {
        return this.columns[0][0];
    };

    Sankey.prototype._initResizeObserver = function _initResizeObserver () {
        var this$1$1 = this;

        var observer = new ResizeObserver(function (entries) {
            entries.forEach(function (entry) {
                var ref = entry.contentRect;
                var width = ref.width;
                var height = ref.height;
                if (entry.target !== this$1$1.element ||
                    (this$1$1.size && this$1$1.size.width === width && this$1$1.size.height === height)) {
                    return;
                }
                this$1$1.size = { width: width, height: height };
                this$1$1.surface.setSize(this$1$1.size);
                this$1$1.resize = true;
                this$1$1._redraw();
            });
        });
        this._resizeObserver = observer;
        observer.observe(this.element);
    };

    Sankey.prototype._createSurface = function _createSurface () {
        return Surface$1.create(this.surfaceElement, {
            mouseenter: this._mouseenter.bind(this),
            mouseleave: this._mouseleave.bind(this),
            mousemove: this._mousemove.bind(this),
            click: this._click.bind(this)
        });
    };

    Sankey.prototype._initTheme = function _initTheme (theme) {
        var currentTheme = theme || this.theme || {};
        this.theme = currentTheme;
        this.options = deepExtend({}, currentTheme, this.options);
    };

    Sankey.prototype.setLinksOpacity = function setLinksOpacity (opacity) {
        var this$1$1 = this;

        this.linksVisuals.forEach(function (link) {
            this$1$1.setOpacity(link, opacity, link.linkOptions.opacity);
        });
    };

    Sankey.prototype.setLinksInactivityOpacity = function setLinksInactivityOpacity (inactiveOpacity) {
        var this$1$1 = this;

        this.linksVisuals.forEach(function (link) {
            this$1$1.setOpacity(link, inactiveOpacity, link.linkOptions.highlight.inactiveOpacity);
        });
    };

    Sankey.prototype.setOpacity = function setOpacity (link, opacity, linkValue) {
        link.options.set('stroke', Object.assign({}, link.options.stroke,
            {opacity: defined(linkValue) ? linkValue : opacity}));
    };

    Sankey.prototype.trigger = function trigger (name, ev) {
        var dataItem = ev.element.dataItem;
        var targetType = ev.element.type;

        var event = Object.assign({}, ev,
            {type: name,
            targetType: targetType,
            dataItem: dataItem});

        return Observable.prototype.trigger.call(this, name, event);
    };

    Sankey.prototype._mouseenter = function _mouseenter (ev) {
        var element = ev.element;
        var isLink = element.type === LINK;
        var isNode = element.type === NODE;
        var isLegendItem = Boolean(element.chartElement && element.chartElement.options.node);

        if ((isLink && this.trigger('linkEnter', ev)) ||
            (isNode && this.trigger('nodeEnter', ev))) {
            return;
        }

        var ref = this.options.links;
        var highlight = ref.highlight;
        if (isLink) {
            this.setLinksInactivityOpacity(highlight.inactiveOpacity);
            this.setOpacity(element, highlight.opacity, element.linkOptions.highlight.opacity);
        } else if (isNode) {
            this.highlightLinks(element, highlight);
        } else if (isLegendItem) {
            var nodeVisual = this.nodesVisuals.get(element.chartElement.options.node.id);
            this.highlightLinks(nodeVisual, highlight);
        }
    };

    Sankey.prototype._mouseleave = function _mouseleave (ev) {
        var this$1$1 = this;

        var element = ev.element;
        var isLink = element.type === LINK;
        var isNode = element.type === NODE;
        var isLegendItem = Boolean(element.chartElement && element.chartElement.options.node);
        var target = ev.originalEvent.relatedTarget;

        if (isLink && target && target.nodeName === 'text') {
            return;
        }

        if (isLink || isNode) {
            if (this.tooltipTimeOut) {
                clearTimeout(this.tooltipTimeOut);
                this.tooltipTimeOut = null;
            }
            this.tooltipShown = false;
            this.trigger('tooltipHide', ev);
        }

        if ((isLink && this.trigger('linkLeave', ev)) ||
            (isNode && this.trigger('nodeLeave', ev))) {
            return;
        }

        if (isLink || isNode || isLegendItem) {
            this.linksVisuals.forEach(function (link) {
                this$1$1.setOpacity(link, this$1$1.options.links.opacity, link.linkOptions.opacity);
            });
        }
    };

    Sankey.prototype._mousemove = function _mousemove (ev) {
        var this$1$1 = this;

        var ref = this.options.tooltip;
        var followPointer = ref.followPointer;
        var delay = ref.delay;
        var element = ev.element;
        var tooltipElType = element.type;

        if ((tooltipElType !== LINK && tooltipElType !== NODE) || (this.tooltipShown && !followPointer)) {
            return;
        }

        var mouseEvent = ev.originalEvent;
        var rect = this.element.getBoundingClientRect();
        var isLeft = mouseEvent.clientX - rect.left < rect.width / 2;
        var isTop = mouseEvent.clientY - rect.top < rect.height / 2;

        ev.tooltipData = {
            popupOffset: {
                left: mouseEvent.pageX,
                top: mouseEvent.pageY
            },
            popupAlign: {
                horizontal: isLeft ? 'left' : 'right',
                vertical: isTop ? 'top' : 'bottom'
            }
        };

        if (tooltipElType === NODE) {
            var ref$1 = element.dataItem;
            var sourceLinks = ref$1.sourceLinks;
            var targetLinks = ref$1.targetLinks;
            var links = targetLinks.length ? targetLinks : sourceLinks;
            ev.nodeValue = links.reduce(function (acc, link) { return acc + link.value; }, 0);
        }

        if (this.tooltipTimeOut) {
            clearTimeout(this.tooltipTimeOut);
            this.tooltipTimeOut = null;
        }

        var nextDelay = followPointer && this.tooltipShown ? 0 : delay;

        this.tooltipTimeOut = setTimeout(function () {
            this$1$1.trigger('tooltipShow', ev);
            this$1$1.tooltipShown = true;
            this$1$1.tooltipTimeOut = null;
        }, nextDelay);
    };

    Sankey.prototype._click = function _click (ev) {
        var element = ev.element;
        var dataItem = element.dataItem;
        var isLink = element.type === LINK;
        var isNode = element.type === NODE;
        var focusState = this._focusState || {};

        if (isNode) {
            var focusedNodeClicked = !focusState.link && this.sameNode(focusState.node, dataItem);

            if (!focusedNodeClicked) {
                this._focusState = { node: dataItem, link: null };
                this._focusNode({ highlight: false });
            }

            this.trigger('nodeClick', ev);
        } else if (isLink) {
            var link = {
                sourceId: dataItem.source.id,
                targetId: dataItem.target.id,
                value: dataItem.value
            };
            var focusedLinkClicked = this.sameLink(focusState.link, link);

            if (!focusedLinkClicked) {
                this._focusState = { node: dataItem.source, link: link };
                this._focusLink({ highlight: false });
            }

            this.trigger('linkClick', ev);
        }
    };

    Sankey.prototype.sameNode = function sameNode (node1, node2) {
        return node1 && node2 && node1.id === node2.id;
    };

    Sankey.prototype.sameLink = function sameLink (link1, link2) {
        return link1 && link2 && link1.sourceId === link2.sourceId && link1.targetId === link2.targetId;
    };

    Sankey.prototype._focusNode = function _focusNode (options) {
        this._cleanFocusHighlight();

        var nodeData = this._focusState.node;
        var node = this.models.map.get(nodeData.id);
        node.focus(options);
    };

    Sankey.prototype._focusLink = function _focusLink (options) {
        this._cleanFocusHighlight();

        var linkData = this._focusState.link;
        var link = this.models.map.get(((linkData.sourceId) + "-" + (linkData.targetId)));
        link.focus(options);
    };

    Sankey.prototype._focusNextNode = function _focusNextNode (direction) {
        if ( direction === void 0 ) direction = 1;

        var current = this._focusState.node;

        var columnIndex = this.columns.findIndex(function (column) { return column.find(function (n) { return n.id === current.id; }); });
        var columnNodes = this.columns[columnIndex];
        var nodeIndex = columnNodes.findIndex(function (n) { return n.id === current.id; });

        var nextNode = columnNodes[nodeIndex + direction];
        if (nextNode) {
            this._focusState.node = nextNode;
            this._focusNode();
        }
    };

    Sankey.prototype._focusNextLink = function _focusNextLink (direction) {
        if ( direction === void 0 ) direction = 1;

        var node = this._focusState.node;
        var link = this._focusState.link;

        var sourceLinkIndex = node.sourceLinks.findIndex(function (l) { return l.sourceId === link.sourceId && l.targetId === link.targetId; });
        var targetLinkIndex = node.targetLinks.findIndex(function (l) { return l.sourceId === link.sourceId && l.targetId === link.targetId; });

        if (sourceLinkIndex !== -1) {
            var nextLink = node.sourceLinks[sourceLinkIndex + direction];

            if (nextLink) {
                this._focusState.link = nextLink;
                this._focusLink();
            }
        } else if (targetLinkIndex !== -1) {
            var nextLink$1 = node.targetLinks[targetLinkIndex + direction];

            if (nextLink$1) {
                this._focusState.link = nextLink$1;
                this._focusLink();
            }
        }
    };

    Sankey.prototype._focusSourceNode = function _focusSourceNode () {
        var linkData = this._focusState.link;
        var sourceNode = this.models.map.get(linkData.sourceId);
        this._focusState = { node: sourceNode.options.node, link: null };
        this._focusNode();
    };

    Sankey.prototype._focusTargetNode = function _focusTargetNode () {
        var linkData = this._focusState.link;
        var targetNode = this.models.map.get(linkData.targetId);
        this._focusState = { node: targetNode.options.node, link: null };
        this._focusNode();
    };

    Sankey.prototype._focusSourceLink = function _focusSourceLink () {
        var nodeData = this._focusState.node;
        var sourceLinks = nodeData.sourceLinks;
        var linkData = sourceLinks[0];
        if (linkData) {
            this._focusState.link = linkData;
            this._focusLink();
        }
    };

    Sankey.prototype._focusTargetLink = function _focusTargetLink () {
        var nodeData = this._focusState.node;
        var targetLinks = nodeData.targetLinks;
        var linkData = targetLinks[0];
        if (linkData) {
            this._focusState.link = linkData;
            this._focusLink();
        }
    };

    Sankey.prototype._focus = function _focus () {
        if (!this._skipFocusHighlight) {
            if (this._focusState.link) {
                this._focusLink();
            } else {
                this._focusNode();
            }
        }

        this._skipFocusHighlight = false;
    };

    Sankey.prototype._blur = function _blur () {
        this._cleanFocusHighlight();
    };

    Sankey.prototype._onDown = function _onDown () {
        if (!this._hasFocus()) {
            this._skipFocusHighlight = true;
        }
    };

    Sankey.prototype._hasFocus = function _hasFocus () {
        return this.element.ownerDocument.activeElement === this.element;
    };

    Sankey.prototype._cleanFocusHighlight = function _cleanFocusHighlight () {
        this.models.nodes.forEach(function (node) { return node.blur(); });
        this.models.links.forEach(function (link) { return link.blur(); });
    };

    Sankey.prototype._keydown = function _keydown (ev) {
        var handler = this['on' + ev.key];
        var rtl = this.options.rtl;

        if (rtl && ev.key === 'ArrowLeft') {
            handler = this.onArrowRight;
        } else if (rtl && ev.key === 'ArrowRight') {
            handler = this.onArrowLeft;
        }

        if (handler) {
            handler.call(this, ev);
        }
    };

    Sankey.prototype.onEscape = function onEscape (ev) {
        ev.preventDefault();

        this._focusState = { node: this.firstFocusableNode(), link: null };
        this._focusNode();
    };

    Sankey.prototype.onArrowDown = function onArrowDown (ev) {
        ev.preventDefault();

        if (this._focusState.link) {
            this._focusNextLink(1);
        } else {
            this._focusNextNode(1);
        }
    };

    Sankey.prototype.onArrowUp = function onArrowUp (ev) {
        ev.preventDefault();

        if (this._focusState.link) {
            this._focusNextLink(-1);
        } else {
            this._focusNextNode(-1);
        }
    };

    Sankey.prototype.onArrowLeft = function onArrowLeft (ev) {
        ev.preventDefault();

        if (this._focusState.link) {
            this._focusSourceNode();
        } else {
            this._focusTargetLink();
        }
    };

    Sankey.prototype.onArrowRight = function onArrowRight (ev) {
        ev.preventDefault();

        if (this._focusState.link) {
            this._focusTargetNode();
        } else {
            this._focusSourceLink();
        }
    };

    Sankey.prototype.highlightLinks = function highlightLinks (node, highlight) {
        var this$1$1 = this;

        if (node) {
            this.setLinksInactivityOpacity(highlight.inactiveOpacity);
            node.links.forEach(function (link) {
                this$1$1.setOpacity(link, highlight.opacity, link.linkOptions.highlight.opacity);
            });
        }
    };

    Sankey.prototype._destroySurface = function _destroySurface () {
        if (this.surface) {
            this.surface.destroy();
            this.surface = null;
            this._destroySurfaceElement();
        }
    };

    Sankey.prototype._destroyResizeObserver = function _destroyResizeObserver () {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = null;
        }
    };

    Sankey.prototype._initSurfaceElement = function _initSurfaceElement () {
        if (!this.surfaceElement) {
            this.surfaceElement = document.createElement('div');
            this.element.appendChild(this.surfaceElement);
        }
    };

    Sankey.prototype._destroySurfaceElement = function _destroySurfaceElement () {
        if (this.surfaceElement && this.surfaceElement.parentNode) {
            this.surfaceElement.parentNode.removeChild(this.surfaceElement);
            this.surfaceElement = null;
        }
    };

    Sankey.prototype.setOptions = function setOptions (options, theme) {
        this._setOptions(options);
        this._initTheme(theme);
        this._initSurface();
        this._redraw();
    };

    Sankey.prototype._redraw = function _redraw () {
        this.surface.clear();

        var ref = this._getSize();
        var width = ref.width;
        var height = ref.height;
        this.size = { width: width, height: height };
        this.surface.setSize(this.size);

        this.createVisual();

        this.surface.draw(this.visual);
    };

    Sankey.prototype._getSize = function _getSize () {
        return this.element.getBoundingClientRect();
    };

    Sankey.prototype.createVisual = function createVisual () {
        this.visual = this._render();
    };

    Sankey.prototype.titleBox = function titleBox (title, drawingRect) {
        if (!title || title.visible === false || !title.text) {
            return null;
        }

        var titleElement = new Title(Object.assign({}, {drawingRect: drawingRect}, title));
        var titleVisual = titleElement.exportVisual();
        return titleVisual.chartElement.box;
    };

    Sankey.prototype.legendBox = function legendBox (options, nodes, drawingRect) {
        if (!options || options.visible === false) {
            return null;
        }

        var legend = new Legend(Object.assign({}, {nodes: nodes}, options, {drawingRect: drawingRect}));
        var legendVisual = legend.exportVisual();

        return legendVisual.chartElement.box;
    };

    Sankey.prototype.calculateSankey = function calculateSankey$1 (calcOptions, sankeyOptions) {
        var title = sankeyOptions.title;
        var legend = sankeyOptions.legend;
        var data = sankeyOptions.data;
        var nodes = sankeyOptions.nodes;
        var labels = sankeyOptions.labels;
        var nodeColors = sankeyOptions.nodeColors;
        var disableAutoLayout = sankeyOptions.disableAutoLayout;
        var disableKeyboardNavigation = sankeyOptions.disableKeyboardNavigation;
        var rtl = sankeyOptions.rtl;
        var autoLayout = !disableAutoLayout;
        var focusHighlightWidth = ((nodes.focusHighlight || {}).border || {}).width || 0;
        var padding = disableKeyboardNavigation ? 0 : focusHighlightWidth / 2;

        var sankeyBox = new Box(0, 0, calcOptions.width, calcOptions.height);
        sankeyBox.unpad(padding);

        var titleBox = this.titleBox(title, sankeyBox);

        var legendArea = sankeyBox.clone();

        if (titleBox) {
            var titleHeight = titleBox.height();
            if (title.position === TOP) {
                sankeyBox.unpad({ top: titleHeight });
                legendArea = new Box(0, titleHeight, calcOptions.width, calcOptions.height);
            } else {
                sankeyBox.shrink(0, titleHeight);
                legendArea = new Box(0, 0, calcOptions.width, calcOptions.height - titleHeight);
            }
        }

        var legendBox = this.legendBox(legend, data.nodes, legendArea);
        var legendPosition = (legend && legend.position) || Legend.prototype.options.position;

        if (legendBox) {
            if (legendPosition === LEFT) {
                sankeyBox.unpad({ left: legendBox.width() });
            }

            if (legendPosition === RIGHT) {
                sankeyBox.shrink(legendBox.width(), 0);
            }

            if (legendPosition === TOP) {
                sankeyBox.unpad({ top: legendBox.height() });
            }

            if (legendPosition === BOTTOM$1) {
                sankeyBox.shrink(0, legendBox.height());
            }
        }

        var ref = calculateSankey(Object.assign({}, calcOptions, {offsetX: 0, offsetY: 0, width: sankeyBox.width(), height: sankeyBox.height()}));
        var calculatedNodes = ref.nodes;
        var circularLinks = ref.circularLinks;
        if (circularLinks) {
            console.warn('Circular links detected. Kendo Sankey diagram does not support circular links.');
            return { sankey: { nodes: [], links: [], columns: [[]], circularLinks: circularLinks }, legendBox: legendBox, titleBox: titleBox };
        }

        var box = new Box();

        var diagramMinX = calculatedNodes.reduce(function (acc, node) { return Math.min(acc, node.x0); }, Infinity);
        var diagramMaxX = calculatedNodes.reduce(function (acc, node) { return Math.max(acc, node.x1); }, 0);

        calculatedNodes.forEach(function (nodeEl, i) {
            if (rtl) {
                var x0 = nodeEl.x0;
                var x1 = nodeEl.x1;
                nodeEl.x0 = diagramMaxX - x1;
                nodeEl.x1 = diagramMaxX - x0;
            }
            var nodeOps = resolveNodeOptions(nodeEl, nodes, nodeColors, i);
            var nodeInstance = new Node(nodeOps);
            box.wrap(rectToBox(nodeInstance.exportVisual().rawBBox()));

            var labelInstance = new Label(resolveLabelOptions(nodeEl, labels, rtl, diagramMinX, diagramMaxX));
            var labelVisual = labelInstance.exportVisual();
            if (labelVisual) {
                box.wrap(rectToBox(labelVisual.rawBBox()));
            }
        });

        var offsetX = sankeyBox.x1;
        var offsetY = sankeyBox.y1;

        var width = sankeyBox.width() + offsetX;
        var height = sankeyBox.height() + offsetY;

        width -= box.x2 > sankeyBox.width() ? box.x2 - sankeyBox.width() : 0;
        height -= box.y2 > sankeyBox.height() ? box.y2 - sankeyBox.height() : 0;

        offsetX += box.x1 < 0 ? -box.x1 : 0;
        offsetY += box.y1 < 0 ? -box.y1 : 0;

        if (autoLayout === false) {
            return {
                sankey: calculateSankey(Object.assign({}, calcOptions, {offsetX: offsetX, offsetY: offsetY, width: width, height: height, autoLayout: false})),
                legendBox: legendBox,
                titleBox: titleBox
            };
        }

        if (this.resize && autoLayout && this.permutation) {
            this.resize = false;
            return {
                sankey: calculateSankey(Object.assign({}, calcOptions, {offsetX: offsetX, offsetY: offsetY, width: width, height: height}, this.permutation)),
                legendBox: legendBox,
                titleBox: titleBox
            };
        }

        var startColumn = 1;
        var loops = 2;
        var columnsLength = calculateSankey(Object.assign({}, calcOptions, {offsetX: offsetX, offsetY: offsetY, width: width, height: height, autoLayout: false})).columns.length;
        var results = [];

        var permutation = function (targetColumnIndex, reverse) {
            var currPerm = calculateSankey(Object.assign({}, calcOptions, {offsetX: offsetX, offsetY: offsetY, width: width, height: height, loops: loops, targetColumnIndex: targetColumnIndex, reverse: reverse}));
            var crosses = crossesValue(currPerm.links);
            results.push({
                crosses: crosses,
                reverse: reverse,
                targetColumnIndex: targetColumnIndex
            });
            return crosses === 0;
        };

        for (var index = startColumn; index <= columnsLength - 1; index++) {
            if (permutation(index, false) || permutation(index, true)) {
                break;
            }
        }

        var minCrosses = Math.min.apply(null, results.map(function (r) { return r.crosses; }));
        var bestResult = results.find(function (r) { return r.crosses === minCrosses; });
        this.permutation = { targetColumnIndex: bestResult.targetColumnIndex, reverse: bestResult.reverse };
        var result = calculateSankey(Object.assign({}, calcOptions, {offsetX: offsetX, offsetY: offsetY, width: width, height: height}, this.permutation));

        return {
            sankey: result,
            legendBox: legendBox,
            titleBox: titleBox
        };
    };

    Sankey.prototype._render = function _render (options, context) {
        var sankeyOptions = options || this.options;
        var sankeyContext = context || this;

        var labelOptions = sankeyOptions.labels;
        var nodesOptions = sankeyOptions.nodes;
        var linkOptions = sankeyOptions.links;
        var nodeColors = sankeyOptions.nodeColors;
        var title = sankeyOptions.title;
        var legend = sankeyOptions.legend;
        var rtl = sankeyOptions.rtl;
        var disableKeyboardNavigation = sankeyOptions.disableKeyboardNavigation;
        var data = sankeyOptions.data;
        var ref = sankeyContext.size;
        var width = ref.width;
        var height = ref.height;

        var calcOptions = Object.assign({}, data, {width: width, height: height, nodesOptions: nodesOptions, title: title, legend: legend});
        var ref$1 = this.calculateSankey(calcOptions, sankeyOptions);
        var sankey = ref$1.sankey;
        var titleBox = ref$1.titleBox;
        var legendBox = ref$1.legendBox;
        if (rtl) {
            toRtl(sankey);
        }
        var nodes = sankey.nodes;
        var links = sankey.links;
        var columns = sankey.columns;

        sankeyContext.columns = columns.map(function (column) {
            var newColumn = column.slice();
            newColumn.sort(function (a, b) { return a.y0 - b.y0; });
            return newColumn;
        });

        var visual = new Group$8({
            clip: Path$7.fromRect(new Rect([0, 0], [width, height]))
        });

        if (titleBox) {
            var titleElement = new Title(Object.assign({}, title, {drawingRect: titleBox}));
            var titleVisual = titleElement.exportVisual();
            visual.append(titleVisual);
        }

        if (sankey.circularLinks) {
            return visual;
        }

        var visualNodes = new Map();
        sankeyContext.nodesVisuals = visualNodes;

        var models = {
            nodes: [],
            links: [],
            map: new Map()
        };
        sankeyContext.models = models;

        var focusHighlights = [];

        nodes.forEach(function (node, i) {
            var nodeOps = resolveNodeOptions(node, nodesOptions, nodeColors, i);
            nodeOps.root = function () { return sankeyContext.element; };
            nodeOps.navigatable = disableKeyboardNavigation !== true;

            var nodeInstance = new Node(nodeOps);
            var nodeVisual = nodeInstance.exportVisual();
            nodeVisual.links = [];
            nodeVisual.type = NODE;

            node.color = nodeOps.color;
            node.opacity = nodeOps.opacity;

            nodeVisual.dataItem = Object.assign({}, data.nodes[i],
                {color: nodeOps.color,
                opacity: nodeOps.opacity,
                sourceLinks: node.sourceLinks.map(function (link) { return ({ sourceId: link.sourceId, targetId: link.targetId, value: link.value }); }),
                targetLinks: node.targetLinks.map(function (link) { return ({ sourceId: link.sourceId, targetId: link.targetId, value: link.value }); })});
            visualNodes.set(node.id, nodeVisual);

            models.nodes.push(nodeInstance);
            models.map.set(node.id, nodeInstance);

            visual.append(nodeVisual);

            nodeInstance.createFocusHighlight();

            if (nodeInstance._highlight) {
                focusHighlights.push(nodeInstance._highlight);
            }
        });

        var sortedLinks = links.slice().sort(function (a, b) { return b.value - a.value; });

        var linksVisuals = [];
        sankeyContext.linksVisuals = linksVisuals;

        sortedLinks.forEach(function (link) {
            var source = link.source;
            var target = link.target;
            var sourceNode = visualNodes.get(source.id);
            var targetNode = visualNodes.get(target.id);
            var resolvedOptions = resolveLinkOptions(link, linkOptions, sourceNode, targetNode);
            resolvedOptions.root = function () { return sankeyContext.element; };
            resolvedOptions.navigatable = disableKeyboardNavigation !== true;
            resolvedOptions.rtl = rtl;
            var linkInstance = new Link(resolvedOptions);
            var linkVisual = linkInstance.exportVisual();

            linkVisual.type = LINK;
            linkVisual.dataItem = {
                source: Object.assign({}, sourceNode.dataItem),
                target: Object.assign({}, targetNode.dataItem),
                value: link.value
            };
            linkVisual.linkOptions = resolvedOptions;
            linksVisuals.push(linkVisual);

            sourceNode.links.push(linkVisual);
            targetNode.links.push(linkVisual);

            models.links.push(linkInstance);
            models.map.set(((source.id) + "-" + (target.id)), linkInstance);

            linkInstance.createFocusHighlight();

            if (linkInstance._highlight) {
                focusHighlights.push(linkInstance._highlight);
            }

            visual.append(linkVisual);
        });

        var diagramMinX = nodes.reduce(function (acc, node) { return Math.min(acc, node.x0); }, Infinity);
        var diagramMaxX = nodes.reduce(function (acc, node) { return Math.max(acc, node.x1); }, 0);

        nodes.forEach(function (node) {
            var textOps = resolveLabelOptions(node, labelOptions, rtl, diagramMinX, diagramMaxX);
            var labelInstance = new Label(textOps);
            var labelVisual = labelInstance.exportVisual();

            if (labelVisual) {
                visual.append(labelVisual);
            }
        });

        if (legendBox) {
            var legendElement = new Legend(Object.assign({}, legend, {rtl: rtl, drawingRect: legendBox, nodes: nodes}));
            var legendVisual = legendElement.exportVisual();
            visual.append(legendVisual);
        }

        if (focusHighlights.length !== 0) {
            var focusHighlight = new Group$8();
            focusHighlight.append.apply(focusHighlight, focusHighlights);
            visual.append(focusHighlight);
        }

        return visual;
    };

    Sankey.prototype.exportVisual = function exportVisual (exportOptions) {
        var options = (exportOptions && exportOptions.options) ?
            deepExtend({}, this.options, exportOptions.options) : this.options;

        var context = {
            size: {
                width: defined(exportOptions && exportOptions.width) ? exportOptions.width : this.size.width,
                height: defined(exportOptions && exportOptions.height) ? exportOptions.height : this.size.height
            }
        };

        return this._render(options, context);
    };

    Sankey.prototype._setOptions = function _setOptions (options) {
        this.options = deepExtend({}, this.options, options);
    };

    return Sankey;
}(Observable));

var highlightOptions = {
    opacity: 1,
    width: 2,
    color: BLACK$1
};

setDefaultOptions(Sankey, {
    title: {
        position: TOP, // 'top', 'bottom'
    },
    labels: {
        visible: true,
        margin: {
            left: 8,
            right: 8
        },
        padding: 0,
        border: {
            width: 0
        },
        paintOrder: 'stroke',
        stroke: {
            lineJoin: "round",
            width: 1
        },
        offset: { left: 0, top: 0 }
    },
    nodes: {
        width: 24,
        padding: 16,
        opacity: 1,
        align: 'stretch', // 'left', 'right', 'stretch'
        offset: { left: 0, top: 0 },
        focusHighlight: {
            border: Object.assign({}, highlightOptions)
        },
        labels: {
            ariaTemplate: function (ref) {
                var node = ref.node;

                return node.label.text;
}
        }
    },
    links: {
        colorType: 'static', // 'source', 'target', 'static'
        opacity: 0.4,
        highlight: {
            opacity: 0.8,
            inactiveOpacity: 0.2
        },
        focusHighlight: {
            border: Object.assign({}, highlightOptions)
        },
        labels: {
            ariaTemplate: function (ref) {
                var link = ref.link;

                return ((link.source.label.text) + " to " + (link.target.label.text));
}
        }
    },
    tooltip: {
        followPointer: false,
        delay: 200
    }
});

var createSankeyData = function (data, dimensions, measure) {
    var nodes = new Set();
    var links = new Map();
    var linksMap = new Map();

    data.forEach(function (row) {
        dimensions.forEach(function (dimension) {
            nodes.add(dimension.value(row));
        });

        for (var i = 0; i < dimensions.length - 1; i++) {
            var source = dimensions[i].value(row);
            var target = dimensions[i + 1].value(row);
            var key = source + "_" + target;
            var value = measure.value(row);
            var existingValue = links.get(key);

            if (existingValue !== undefined) {
                links.set(key, existingValue + value);
            } else {
                links.set(key, value);
                linksMap.set(key, { source: source, target: target });
            }
        }
    });

    var nodesId = new Map();
    var nodesArray = Array.from(nodes).map(function (node, index) {
        nodesId.set(node, index);
        return { id: index, label: { text: String(node) } };
    });

    var linksArray = Array.from(links).map(function (ref) {
        var key = ref[0];
        var value = ref[1];

        var ref$1 = linksMap.get(key);
        var source = ref$1.source;
        var target = ref$1.target;
        return {
            sourceId: nodesId.get(source),
            targetId: nodesId.get(target),
            value: value
        };
    });

    return { nodes: nodesArray, links: linksArray };
};

function getWizardDataFromDataRows(dataRows) {
    var result = [];

    dataRows.forEach(function (item) {
        var dataItem = item.dataItem;
        var dataColumns = item.dataColumns;

        var row = [];
        dataColumns.forEach(function (column) {
            row.push({
                field: column.title || column.field,
                value: getter(column.field)(dataItem)
            });
        });

        result.push(row);
    });

    return result;
}

var ActionTypes = Object.freeze({
    seriesType: 0,
    stacked: 1,

    categoryAxisX: 2,
    valueAxisY: 3,

    seriesChange: 4,

    areaMarginLeft: 5,
    areaMarginRight: 6,
    areaMarginTop: 7,
    areaMarginBottom: 8,
    areaBackground: 9,

    titleText: 10,
    titleFontName: 11,
    titleFontSize: 12,
    titleColor: 13,

    subtitleText: 14,
    subtitleFontName: 15,
    subtitleFontSize: 16,
    subtitleColor: 17,

    seriesColor: 18,
    seriesLabel: 19,

    legendVisible: 20,
    legendFontName: 21,
    legendFontSize: 22,
    legendColor: 23,
    legendPosition: 24,

    categoryAxisTitleText: 25,
    categoryAxisTitleFontName: 26,
    categoryAxisTitleFontSize: 27,
    categoryAxisTitleColor: 28,
    categoryAxisLabelsFontName: 29,
    categoryAxisLabelsFontSize: 30,
    categoryAxisLabelsColor: 31,
    categoryAxisLabelsRotation: 32,
    categoryAxisReverseOrder: 33,

    valueAxisTitleText: 34,
    valueAxisTitleFontName: 35,
    valueAxisTitleFontSize: 36,
    valueAxisTitleColor: 37,
    valueAxisLabelsFormat: 38,
    valueAxisLabelsFontName: 39,
    valueAxisLabelsFontSize: 40,
    valueAxisLabelsColor: 41,
    valueAxisLabelsRotation: 42,
});

var fontSizes = [
    { text: "10", value: "10px" },
    { text: "12", value: "12px" },
    { text: "14", value: "14px" },
    { text: "16", value: "16px" },
    { text: "20", value: "20px" },
    { text: "28", value: "28px" },
    { text: "42", value: "42px" },
    { text: "56", value: "56px" }
];

var titleSizeDefault = '20px';
var subtitleSizeDefault = '16px';
var labelSizeDefault = '12px';
var axisTitleSizeDefault = '16px';

var fontNames = [
    {
        text: "Arial",
        value: "Arial, Helvetica, sans-serif",
        style: { fontFamily: "Arial, Helvetica, sans-serif" },
    },
    {
        text: "Courier New",
        value: "'Courier New', Courier, monospace",
        style: { fontFamily: "'Courier New', Courier, monospace" },
    },
    {
        text: "Georgia",
        value: "Georgia, serif",
        style: { fontFamily: "Georgia, serif" },
    },
    {
        text: "Impact",
        value: "Impact, Charcoal, sans-serif",
        style: { fontFamily: "Impact, Charcoal, sans-serif" },
    },
    {
        text: "Lucida Console",
        value: "'Lucida Console', Monaco, monospace",
        style: { fontFamily: "'Lucida Console', Monaco, monospace" },
    },
    {
        text: "Tahoma",
        value: "Tahoma, Geneva, sans-serif",
        style: { fontFamily: "Tahoma, Geneva, sans-serif" },
    },
    {
        text: "Times New Roman",
        value: "'Times New Roman', Times,serif",
        style: { fontFamily: "'Times New Roman', Times,serif" },
    },
    {
        text: "Trebuchet MS",
        value: "'Trebuchet MS', Helvetica, sans-serif",
        style: { fontFamily: "'Trebuchet MS', Helvetica, sans-serif" },
    },
    {
        text: "Verdana",
        value: "Verdana, Geneva, sans-serif",
        style: { fontFamily: "Verdana, Geneva, sans-serif" },
    } ];

var fontNameDefault = fontNames[0].value;

var columnType = "column";
var barType = "bar";
var lineType = "line";
var pieType = "pie";
var scatterType = "scatter";
var categoricalTypes = [columnType, barType, lineType, scatterType];

var scatterSeries$1 = {
    type: lineType,
    width: 0,
};

function isCategorical(type) {
    return type && categoricalTypes.includes(type);
}

var categoryTypes = ["string", "date", "number"];
var valueTypes = ["number"];

var axesDefinitions = {
    bar: [
        { axisType: "category", types: categoryTypes },
        { axisType: "value", types: valueTypes } ],
    column: [
        { axisType: "category", types: categoryTypes },
        { axisType: "value", types: valueTypes } ],
    line: [
        { axisType: "category", types: categoryTypes },
        { axisType: "value", types: valueTypes } ],
    pie: [
        { axisType: "category", types: categoryTypes },
        { axisType: "value", types: valueTypes, count: 1 } ],
    scatter: [
        { axisType: "category", types: categoryTypes },
        { axisType: "value", types: valueTypes } ],
};

function getFont$1(font, size) {
    return ((size || "") + " " + (font || "")).trim();
}

function parseFont(font) {
    var spaceIndex = (font || "").indexOf(" ");
    var size = font && font.substring(0, spaceIndex);
    var name = font && font.substring(spaceIndex + 1);
    return { size: size, name: name };
}

var updateFontName = function (fontName, defaultSize, currentFont) {
    var ref = parseFont(currentFont);
    var size = ref.size;
    return fontName ? getFont$1(fontName, size || defaultSize) : "";
};

var updateFontSize = function (fontSize, defaultFontName, currentFont) {
    var ref = parseFont(currentFont);
    var name = ref.name;
    return fontSize ? getFont$1(name || defaultFontName, fontSize) : "";
};

var hasValue = function (value) { return value !== undefined && value !== null; };

var recordWithValues = function (data) {
    var result = structuredClone(data[0]);
    result.forEach(function (item, i) {
        if (!hasValue(item.value)) {
            for (var index = 0; index < data.length; index++) {
                var value = data[index][i].value;
                if (hasValue(value)) {
                    item.value = value;
                    break;
                }
            }
        }
    });

    return result;
};

var getCategoryColumnIndex = function (data, categoryDef) {
    var candidates = [];
    var sampleRecord = recordWithValues(data);

    categoryDef.types.forEach(function (type) {
        sampleRecord.forEach(function (item, i) {
            if (typeof item.value === type) {
                candidates.push(i);
            }
        });
    });

    var result = candidates.findIndex(function (index) {
        var values = data.map(function (record) { return record[index].value; });
        return new Set(values).size === values.length;
    });

    return Math.max(result, 0);
};

var getValueColumnIndexes = function (data, valuesDef) {
    var candidates = [];
    var sampleRecord = recordWithValues(data);

    valuesDef.forEach(function (def) {
        def.types.forEach(function (type) {
            sampleRecord.forEach(function (item, i) {
                if (typeof item.value === type) {
                    candidates.push(i);
                }
            });
        });
    });

    return candidates;
};

var emptyState = function () { return structuredClone({
        columns: [],
        data: [],
        series: [],
        initialSeries: [],
        categoryAxis: [ { categories: [], labels: { visible: true, rotation: "auto" }, title: { text: '' } } ],
        valueAxis: [{ labels: { visible: true, rotation: 'auto' } }],
        area: {
            margin: {
                left: undefined,
                right: undefined,
                top: undefined,
                bottom: undefined,
            },
        },
        title: { text: '' },
        subtitle: { text: '' },
        stack: false,
    }); };

var categoryValueChartState = function (data, seriesType, options) {
    var state = emptyState();
    state.seriesType = seriesType;
    state.data = data || [];
    state.legend = { visible: true, position: "bottom" };
    var chartDef = axesDefinitions[seriesType];

    if (!chartDef || !data.length) {
        return state;
    }

    var firstRecord = data[0].slice();
    state.columns = data[0].map(function (i) { return String(i.field); });

    var categoryDef = chartDef.find(function (def) { return def.axisType === "category"; });
    var catIndex = -1;
    if (categoryDef) {
        catIndex =
            options && options.categoryAxis
                ? state.columns.indexOf(options.categoryAxis)
                : getCategoryColumnIndex(data, categoryDef);
    }

    var valuesDef = chartDef.filter(function (def) { return def.axisType === "value"; });
    var valuesIndexes = getValueColumnIndexes(data, valuesDef);

    if (valuesIndexes.includes(catIndex)) {
        if (valuesIndexes.length > 1) {
            valuesIndexes = valuesIndexes.filter(function (index) { return index !== catIndex; });
        } else {
            catIndex = -1;
        }
    }

    var series = [];
    valuesIndexes.forEach(function (index) {
        var valuesColumn = firstRecord[index];
        var valuesResult = [];
        data.forEach(function (record) {
            valuesResult.push(record[index].value);
        });
        series.push(Object.assign({}, {name: valuesColumn.field,
            type: seriesType,
            data: valuesResult,
            stack: false,
            labels: { visible: false }},
            (seriesType === scatterType ? scatterSeries$1 : {})));
    });

    var categories =
        catIndex > -1
            ? data.map(function (item) { return String(
                    hasValue(item[catIndex].value)
                        ? item[catIndex].value
                        : " "
                ); }
            )
            : [];

    if (series.length) {
        state.series = series.map(function (s, i) { return (Object.assign({}, s, {id: i})); });
        state.initialSeries = structuredClone(state.series);
    }

    state.categoryAxis = [
        { categories: categories, labels: { visible: true, rotation: "auto" } } ];
    state.categoryField = state.columns[catIndex];

    return state;
};

var pieChartState = function (data, seriesType, options) {
    var state = emptyState();
    state.seriesType = seriesType;
    state.data = data || [];

    var chartDef = axesDefinitions[seriesType];

    if (!chartDef || !data.length) {
        return state;
    }

    var categoriesAxis = data[0].map(function (i) { return i.field; });
    var categoryDef = chartDef.find(function (def) { return def.axisType === "category"; });
    var catIndex = -1;
    if (categoryDef) {
        catIndex =
            options && options.categoryAxis
                ? categoriesAxis.indexOf(options.categoryAxis)
                : getCategoryColumnIndex(data, categoryDef);
    }

    var valuesDef = chartDef.filter(function (def) { return def.axisType === "value"; });

    var valuesIndexes = [];
    if (options && options.valueAxis) {
        valuesIndexes = [categoriesAxis.indexOf(options.valueAxis)];
    } else {
        valuesIndexes = getValueColumnIndexes(data, valuesDef);
    }

    if (valuesIndexes.includes(catIndex) && valuesIndexes.length > 1) {
        valuesIndexes = valuesIndexes.filter(function (index) { return index !== catIndex; });
    }

    if (typeof valuesDef[0].count === "number") {
        valuesIndexes = valuesIndexes.slice(0, valuesDef[0].count);
    }

    var categories =
        catIndex > -1 ? data.map(function (item) { return String(item[catIndex].value); }) : [];

    var flatData = [];

    data.forEach(function (item) {
        var record = {};
        valuesIndexes.forEach(function (index) {
            var col = item[index];
            record[col.field] = col.value || 0;
            record[item[catIndex].field] = item[catIndex].value || " ";
        });
        flatData.push(record);
    });

    state.columns = categoriesAxis;
    state.categoryAxis = [{ categories: categories, title: { text: "" } }];

    state.series = [
        {
            id: 0,
            data: flatData,
            type: seriesType,
            name: categoriesAxis[catIndex],
            labels: { visible: true },
            categoryField: categoriesAxis[catIndex],
            field: categoriesAxis[valuesIndexes[0]],
        } ];

    state.categoryField = categoriesAxis[catIndex];
    state.valueField = categoriesAxis[valuesIndexes[0]];

    state.initialSeries = structuredClone(state.series);

    return state;
};

function createInitialState(data, seriesType, defaultState) {
    var state = createState(
        data,
        (defaultState && defaultState.seriesType) || seriesType
    );

    return typeof (defaultState && defaultState.stack) !== "undefined"
        ? updateState(state, ActionTypes.stacked, defaultState.stack)
        : state;
}

function createState(data, seriesType) {
    return (isCategorical(seriesType) ? categoryValueChartState : pieChartState)(
        data,
        seriesType
    );
}

function mergeStates(source, target) {
    var newState = structuredClone(target);
    newState.legend = source.legend;
    newState.area = source.area;
    newState.title = source.title;
    newState.subtitle = source.subtitle;
    if (newState.series.length === source.series.length) {
        for (var i = 0; i < newState.series.length; i++) {
            newState.series[i].color = source.series[i].color;
            newState.series[i].labels = source.series[i].labels;
        }
    }

    if (
        source.series.every(function (s) { return s.labels && s.labels.visible; }) &&
        isCategorical(newState.seriesType) &&
        isCategorical(source.seriesType)
    ) {
        newState.series.forEach(function (s) {
            s.labels = s.labels || {};
            s.labels.visible = true;
        });
    }

    return newState;
}

/* eslint-disable complexity */
function updateState(currentState, action, value) {
    var state = Object.assign({}, currentState);

    switch (action) {
        case ActionTypes.seriesType:
            return createState(state.data, value);

        case ActionTypes.stacked:
            state.series = state.series.map(function (s) { return (Object.assign({}, s, {stack: value})); });
            state.stack = value;
            return state;

        case ActionTypes.categoryAxisX: {
            if (state.seriesType && isCategorical(state.seriesType)) {
                var newState = categoryValueChartState(
                    state.data,
                    state.seriesType,
                    { categoryAxis: value }
                );
                return mergeStates(state, newState);
            } else if (state.seriesType === pieType) {
                var newState$1 = pieChartState(state.data, state.seriesType, {
                    categoryAxis: value,
                });
                return mergeStates(state, newState$1);
            }

            return state;
        }

        case ActionTypes.valueAxisY: {
            if (state.seriesType === pieType) {
                var newState$2 = pieChartState(state.data, state.seriesType, {
                    categoryAxis: state.categoryField,
                    valueAxis: value,
                });
                return mergeStates(state, newState$2);
            }

            return state;
        }

        case ActionTypes.seriesChange:
            state.series = value;
            return state;

        case ActionTypes.areaMarginLeft:
            state.area = Object.assign({}, state.area,
                {margin: Object.assign({}, ((state.area && state.area.margin) || {}),
                    {left: value})});
            return state;

        case ActionTypes.areaMarginRight:
            state.area = Object.assign({}, state.area,
                {margin: Object.assign({}, ((state.area && state.area.margin) || {}),
                    {right: value})});
            return state;

        case ActionTypes.areaMarginTop:
            state.area = Object.assign({}, state.area,
                {margin: Object.assign({}, ((state.area && state.area.margin) || {}),
                    {top: value})});
            return state;

        case ActionTypes.areaMarginBottom:
            state.area = Object.assign({}, state.area,
                {margin: Object.assign({}, ((state.area && state.area.margin) || {}),
                    {bottom: value})});
            return state;

        case ActionTypes.areaBackground:
            state.area = Object.assign({}, state.area, {background: value});
            return state;

        case ActionTypes.titleText:
            state.title = Object.assign({}, state.title, {text: value});
            return state;

        case ActionTypes.titleFontName: {
            state.title = Object.assign({}, state.title,
                {font: updateFontName(
                    value,
                    titleSizeDefault,
                    state.title && state.title.font
                )});
            return state;
        }
        case ActionTypes.titleFontSize:
            state.title = Object.assign({}, state.title,
                {font: updateFontSize(
                    value,
                    fontNameDefault,
                    state.title && state.title.font
                )});
            return state;

        case ActionTypes.titleColor:
            state.title = Object.assign({}, state.title, {color: value});
            return state;

        case ActionTypes.subtitleText:
            state.subtitle = Object.assign({}, state.subtitle, {text: value});
            return state;

        case ActionTypes.subtitleFontName:
            state.subtitle = Object.assign({}, state.subtitle,
                {font: updateFontName(
                    value,
                    subtitleSizeDefault,
                    state.subtitle && state.subtitle.font
                )});
            return state;

        case ActionTypes.subtitleFontSize:
            state.subtitle = Object.assign({}, state.subtitle,
                {font: updateFontSize(
                    value,
                    fontNameDefault,
                    state.subtitle && state.subtitle.font
                )});
            return state;

        case ActionTypes.subtitleColor:
            state.subtitle = Object.assign({}, state.subtitle, {color: value});
            return state;

        case ActionTypes.seriesColor:
            state.series = state.series.map(function (s) { return (Object.assign({}, s,
                {color: value.seriesName === s.name ? value.color : s.color})); });
            return state;

        case ActionTypes.seriesLabel:
            state.series = state.series.map(function (s) {
                if (value.all || value.seriesName === s.name) {
                    return Object.assign({}, s, {labels: { visible: value.visible }});
                }
                return s;
            });
            return state;

        case ActionTypes.legendVisible:
            state.legend = Object.assign({}, state.legend, {visible: value});
            return state;

        case ActionTypes.legendFontName: {
            var legend = state.legend || {};
            state.legend = Object.assign({}, legend,
                {labels: Object.assign({}, legend.labels,
                    {font: updateFontName(
                        value,
                        labelSizeDefault,
                        legend.labels && legend.labels.font
                    )})});
            return state;
        }
        case ActionTypes.legendFontSize: {
            var legend$1 = state.legend || {};
            state.legend = Object.assign({}, legend$1,
                {labels: Object.assign({}, legend$1.labels,
                    {font: updateFontSize(
                        value,
                        fontNameDefault,
                        legend$1.labels && legend$1.labels.font
                    )})});
            return state;
        }
        case ActionTypes.legendColor: {
            var legend$2 = state.legend || {};
            state.legend = Object.assign({}, legend$2,
                {labels: Object.assign({}, legend$2.labels, {color: value})});
            return state;
        }
        case ActionTypes.legendPosition:
            state.legend = Object.assign({}, state.legend, {position: value});
            return state;

        case ActionTypes.categoryAxisTitleText:
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {text: value})})); });
            return state;

        case ActionTypes.categoryAxisTitleFontName: {
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {font: updateFontName(value, axisTitleSizeDefault, axis.title && axis.title.font)})})); });
            return state;
        }
        case ActionTypes.categoryAxisTitleFontSize:
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {font: updateFontSize(value, fontNameDefault, axis.title && axis.title.font)})})); });
            return state;

        case ActionTypes.categoryAxisTitleColor:
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {color: value})})); });
            return state;

        case ActionTypes.categoryAxisLabelsFontName: {
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {font: updateFontName(value, labelSizeDefault, axis.labels && axis.labels.font)})})); });
            return state;
        }

        case ActionTypes.categoryAxisLabelsFontSize:
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {font: updateFontSize(value, fontNameDefault, axis.labels && axis.labels.font)})})); });
            return state;

        case ActionTypes.categoryAxisLabelsColor:
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {color: value})})); });
            return state;

        case ActionTypes.categoryAxisLabelsRotation: {
            var rotation = hasValue(value) ? value : 'auto';
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {rotation: rotation})})); });
            return state;
        }
        case ActionTypes.categoryAxisReverseOrder:
            state.categoryAxis = (state.categoryAxis || []).map(function (axis) { return (Object.assign({}, axis, {reverse: value})); });
            return state;

        case ActionTypes.valueAxisTitleText: {
            if (!state.valueAxis || state.valueAxis.length === 0) {
                state.valueAxis = [{ title: { text: value } }];
            } else {
                state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {text: value})})); });
            }
            return state;
        }
        case ActionTypes.valueAxisTitleFontName: {
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {font: updateFontName(value, axisTitleSizeDefault, axis.title && axis.title.font)})})); });
            return state;
        }
        case ActionTypes.valueAxisTitleFontSize:
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {font: updateFontSize(value, fontNameDefault, axis.title && axis.title.font)})})); });
            return state;
        case ActionTypes.valueAxisTitleColor:
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {title: Object.assign({}, axis.title, {color: value})})); });
            return state;

        case ActionTypes.valueAxisLabelsFormat:
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {format: value})})); });
            return state;

        case ActionTypes.valueAxisLabelsFontName: {
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {font: updateFontName(value, labelSizeDefault, axis.labels && axis.labels.font)})})); });
            return state;
        }
        case ActionTypes.valueAxisLabelsFontSize:
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {font: updateFontSize(value, fontNameDefault, axis.labels && axis.labels.font)})})); });
            return state;
        case ActionTypes.valueAxisLabelsColor:
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {color: value})})); });
            return state;

        case ActionTypes.valueAxisLabelsRotation: {
            var rotation$1 = hasValue(value) ? value : 'auto';
            state.valueAxis = (state.valueAxis || []).map(function (axis) { return (Object.assign({}, axis, {labels: Object.assign({}, axis.labels, {rotation: rotation$1})})); });
            return state;
        }

        default:
            return state;
    }
}

var messages = Object.freeze({
    windowTitle: 'Chart Preview',
    exportButton: 'Export',
    exportPDFButton: 'PDF File',
    exportSVGButton: 'SVG File',
    exportPNGButton: 'PNG File',
    tabChart: 'Chart',
    tabData: 'Data',
    tabFormat: 'Format',
    barChart: 'Bar Chart',
    barChartBar: 'Bar',
    barChartStackedBar: 'Stacked Bar',
    barChart100StackedBar: '100% Stacked Bar',
    pieChart: 'Pie Chart',
    pieChartPie: 'Pie',
    columnChart: 'Column Chart',
    columnChartColumn: 'Column',
    columnChartStackedColumn: 'Stacked Column',
    columnChart100StackedColumn: '100% Stacked Column',
    lineChart: 'Line Chart',
    lineChartLine: 'Line',
    lineChartStackedLine: 'Stacked Line',
    lineChart100StackedLine: '100% Stacked Line',
    scatterChart: 'Scatter Chart',
    scatterChartScatter: 'Scatter',
    configuration: 'Configuration',
    configurationCategoryAxis: 'Category Axis',
    configurationXAxis: 'X Axis',
    configurationValueAxis: 'Value Axis',
    configurationSeries: 'Series',
    configurationSeriesAdd: 'Add',
    formatChartArea: 'Chart Area',
    formatChartAreaMargins: 'Margins',
    formatChartAreaMarginsAuto: 'Auto',
    formatChartAreaMarginsLeft: 'Left',
    formatChartAreaMarginsRight: 'Right',
    formatChartAreaMarginsTop: 'Top',
    formatChartAreaMarginsBottom: 'Bottom',
    formatChartAreaBackground: 'Background',
    formatChartAreaBackgroundColor: 'Color',
    formatTitle: 'Title',
    formatTitleApplyTo: 'Apply to',
    formatTitleChartTitle: 'Chart Title',
    formatTitleChartSubtitle: 'Chart Subtitle',
    formatTitleLabel: 'Title',
    formatTitleFont: 'Font',
    formatTitleFontPlaceholder: '(inherited font)',
    formatTitleSize: 'Size',
    formatTitleSizePlaceholder: 'px',
    formatTitleColor: 'Color',
    formatSeries: 'Series',
    formatSeriesApplyTo: 'Apply to',
    formatSeriesAllSeries: 'All Series',
    formatSeriesColor: 'Color',
    formatSeriesShowLabels: 'Show Labels',
    formatLegend: 'Legend',
    formatLegendShowLegend: 'Show Legend',
    formatLegendFont: 'Font',
    formatLegendFontPlaceholder: '(inherited font)',
    formatLegendSize: 'Size',
    formatLegendSizePlaceholder: 'px',
    formatLegendColor: 'Color',
    formatLegendPosition: 'Position',
    formatLegendPositionTop: 'Top',
    formatLegendPositionBottom: 'Bottom',
    formatLegendPositionLeft: 'Left',
    formatLegendPositionRight: 'Right',
    formatCategoryAxis: 'Category Axis',
    formatXAxis: 'X Axis',
    formatCategoryAxisTitle: 'Title',
    formatCategoryAxisTitlePlaceholder: 'Axis Title',
    formatCategoryAxisTitleFont: 'Font',
    formatCategoryAxisTitleFontPlaceholder: '(inherited font)',
    formatCategoryAxisTitleSize: 'Size',
    formatCategoryAxisTitleSizePlaceholder: 'px',
    formatCategoryAxisTitleColor: 'Color',
    formatCategoryAxisLabels: 'Labels',
    formatCategoryAxisLabelsFont: 'Font',
    formatCategoryAxisLabelsFontPlaceholder: '(inherited font)',
    formatCategoryAxisLabelsSize: 'Size',
    formatCategoryAxisLabelsSizePlaceholder: 'px',
    formatCategoryAxisLabelsColor: 'Color',
    formatCategoryAxisLabelsRotation: 'Rotation',
    formatCategoryAxisLabelsRotationAuto: 'Auto',
    formatCategoryAxisLabelsReverseOrder: 'Reverse Order',
    formatValueAxis: 'Value Axis',
    formatYAxis: 'Y Axis',
    formatValueAxisTitle: 'Title',
    formatValueAxisTitlePlaceholder: 'Axis Title',
    formatValueAxisTitleFont: 'Font',
    formatValueAxisTitleFontPlaceholder: '(inherited font)',
    formatValueAxisTitleSize: 'Size',
    formatValueAxisTitleSizePlaceholder: 'px',
    formatValueAxisTitleColor: 'Color',
    formatValueAxisLabels: 'Labels',
    formatValueAxisLabelsFormat: 'Label Format',
    formatValueAxisLabelsFormatText: 'Text',
    formatValueAxisLabelsFormatNumber: 'Number',
    formatValueAxisLabelsFormatCurrency: 'Currency',
    formatValueAxisLabelsFormatPercent: 'Percent',
    formatValueAxisLabelsFont: 'Font',
    formatValueAxisLabelsFontPlaceholder: '(inherited font)',
    formatValueAxisLabelsSize: 'Size',
    formatValueAxisLabelsSizePlaceholder: 'px',
    formatValueAxisLabelsColor: 'Color',
    formatValueAxisLabelsRotation: 'Rotation',
    formatValueAxisLabelsRotationAuto: 'Auto'
});

var ChartWizardCommon = Object.freeze({
    getWizardDataFromDataRows: getWizardDataFromDataRows,
    ActionTypes: ActionTypes,
    createInitialState: createInitialState,
    createState: createState,
    fontNames: fontNames,
    fontSizes: fontSizes,
    isCategorical: isCategorical,
    mergeStates: mergeStates,
    parseFont: parseFont,
    updateState: updateState,
    messages: messages
});

var BAR_GAP = 1.5;
var BAR_SPACING = 0.4;
var BLACK = '#000';
var SANS = 'Arial, Helvetica, sans-serif';
var SANS11 = "11px " + SANS;
var SANS12 = '12px ' + SANS;
var SANS16 = '16px ' + SANS;
var TRANSPARENT = 'transparent';
var WHITE = '#fff';

var lineSeriesLegendItem = {
    type: LINE
};

var areaSeriesLegendItem = {
    type: AREA
};

var areaNoMarkersSeriesLegendItem = Object.assign({}, areaSeriesLegendItem,
    {markers: {
        visible: false
    },
    highlight: {
        visible: false
    }});

var notes$1 = function () { return ({
    icon: {
        border: {
            width: 1
        }
    },
    label: {
        font: SANS12,
        padding: 3
    },
    line: {
        length: 10,
        width: 2
    },
    legendItem: areaNoMarkersSeriesLegendItem,
    visible: true
}); };

var axisDefaults = function () { return ({
    labels: {
        font: SANS12
    },
    notes: notes$1(),
    title: {
        font: SANS16,
        margin: 5
    }
}); };

var areaSeries = function () { return ({
    highlight: {
        markers: {
            border: {}
        }
    },
    line: {
        opacity: 1,
        width: 0
    },
    markers: {
        size: 6,
        visible: false
    },
    legendItem: areaSeriesLegendItem,
    opacity: 0.4
}); };

var rangeAreaSeries = function () { return ({
    highlight: {
        markers: {
            border: {}
        }
    },
    line: {
        opacity: 1,
        width: 0
    },
    markers: {
        size: 6,
        visible: false
    },
    legendItem: areaSeriesLegendItem,
    opacity: 0.4
}); };

var barSeries = function () { return ({
    gap: BAR_GAP,
    spacing: BAR_SPACING,
    legendItem: areaNoMarkersSeriesLegendItem,
}); };

var boxPlotSeries = function () { return ({
    outliersField: "",
    meanField: "",
    border: {
        _brightness: 0.8,
        width: 1
    },
    downColor: WHITE,
    gap: 1,
    highlight: {
        border: {
            opacity: 1,
            width: 2
        },
        whiskers: {
            width: 3
        },
        mean: {
            width: 2
        },
        median: {
            width: 2
        }
    },
    mean: {
        width: 2
    },
    median: {
        width: 2
    },
    spacing: 0.3,
    whiskers: {
        width: 2
    },
    legendItem: areaNoMarkersSeriesLegendItem,
}); };

var bubbleSeries = function () { return ({
    border: {
        width: 0
    },
    labels: {
        background: TRANSPARENT
    },
    legendItem: areaNoMarkersSeriesLegendItem,
    opacity: 0.6
}); };

var bulletSeries = function () { return ({
    gap: BAR_GAP,
    spacing: BAR_SPACING,
    target: {
        color: "#ff0000"
    },
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var candlestickSeries = function () { return ({
    border: {
        _brightness: 0.8,
        width: 1
    },
    downColor: WHITE,
    gap: 1,
    highlight: {
        border: {
            opacity: 1,
            width: 2
        },
        line: {
            width: 2
        }
    },
    line: {
        color: BLACK,
        width: 1
    },
    legendItem: areaNoMarkersSeriesLegendItem,
    spacing: 0.3
}); };

var columnSeries = function () { return ({
    gap: BAR_GAP,
    spacing: BAR_SPACING,
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var radarColumnSeries = function () { return ({
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var polarScatterSeries = function () { return ({
    legendItem: lineSeriesLegendItem
}); };

var scatterSeries = function () { return ({
    legendItem: lineSeriesLegendItem
}); };

var donutSeries = function () { return ({
    margin: 1,
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var lineSeries = function () { return ({
    width: 2,
    legendItem: lineSeriesLegendItem
}); };

var ohlcSeries = function () { return ({
    gap: 1,
    highlight: {
        line: {
            opacity: 1,
            width: 3
        }
    },
    line: {
        width: 1
    },
    legendItem: areaNoMarkersSeriesLegendItem,
    spacing: 0.3
}); };

var radarAreaSeries = function () { return ({
    line: {
        opacity: 1,
        width: 0
    },
    markers: {
        size: 6,
        visible: false
    },
    legendItem: areaSeriesLegendItem,
    opacity: 0.5
}); };

var radarLineSeries = function () { return ({
    markers: {
        visible: false
    },
    legendItem: lineSeriesLegendItem,
    width: 2
}); };

var rangeBarSeries = function () { return ({
    gap: BAR_GAP,
    spacing: BAR_SPACING,
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var rangeColumnSeries = function () { return ({
    gap: BAR_GAP,
    spacing: BAR_SPACING,
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var scatterLineSeries = function () { return ({
    width: 1,
    legendItem: lineSeriesLegendItem
}); };

var waterfallSeries = function () { return ({
    gap: 0.5,
    line: {
        color: BLACK,
        width: 1
    },
    legendItem: areaNoMarkersSeriesLegendItem,
    spacing: BAR_SPACING
}); };

var pieSeries = function () { return ({
    labels: {
        background: '',
        color: '',
        padding: {
            top: 5,
            bottom: 5,
            left: 7,
            right: 7
        }
    },
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var funnelSeries = function () { return ({
    labels: {
        background: '',
        color: '',
        padding: {
            top: 5,
            bottom: 5,
            left: 7,
            right: 7
        }
    },
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var pyramidSeries = funnelSeries;

var heatmapSeries = function () { return ({
    labels: {
        color: '',
        background: TRANSPARENT,
        visible: true
    },
    highlight: {
        border: {
            width: 0
        }
    },
    legendItem: areaNoMarkersSeriesLegendItem
}); };

var trendlineSeriesDefaults = function (options) { return Object.assign({
    color: INHERIT,
    trendline: {},
    markers: {
        visible: false
    },
    width: 1,
    dashType: 'longDash',
    legendItem: lineSeriesLegendItem
}, options); };

var seriesDefaults = function (options) { return ({
    visible: true,
    labels: {
        font: SANS11
    },
    overlay: options.gradients ? {} : {
        gradient: "none"
    },
    area: areaSeries(),
    rangeArea: rangeAreaSeries(),
    verticalRangeArea: rangeAreaSeries(),
    bar: barSeries(),
    boxPlot: boxPlotSeries(),
    bubble: bubbleSeries(),
    bullet: bulletSeries(),
    candlestick: candlestickSeries(),
    column: columnSeries(),
    heatmap: heatmapSeries(),
    pie: pieSeries(),
    donut: donutSeries(),
    funnel: funnelSeries(),
    pyramid: pyramidSeries(),
    horizontalWaterfall: waterfallSeries(),
    line: lineSeries(),
    notes: notes$1(),
    ohlc: ohlcSeries(),
    radarArea: radarAreaSeries(),
    radarLine: radarLineSeries(),
    radarColumn: radarColumnSeries(),
    polarArea: radarAreaSeries(),
    polarLine: radarLineSeries(),
    polarScatter: polarScatterSeries(),
    rangeBar: rangeBarSeries(),
    rangeColumn: rangeColumnSeries(),
    scatter: scatterSeries(),
    scatterLine: scatterLineSeries(),
    verticalArea: areaSeries(),
    verticalBoxPlot: boxPlotSeries(),
    verticalBullet: bulletSeries(),
    verticalLine: lineSeries(),
    waterfall: waterfallSeries(),
    linearTrendline: trendlineSeriesDefaults(),
    exponentialTrendline: trendlineSeriesDefaults({ style: 'smooth' }),
    logarithmicTrendline: trendlineSeriesDefaults({ style: 'smooth' }),
    polynomialTrendline: trendlineSeriesDefaults({ style: 'smooth' }),
    powerTrendline: trendlineSeriesDefaults({ style: 'smooth' }),
    movingAverageTrendline: trendlineSeriesDefaults()
}); };

var title$1 = function () { return ({
    font: SANS16
}); };

var subtitle = function () { return ({
    font: SANS12
}); };

var legend = function () { return ({
    labels: {
        font: SANS12
    }
}); };

var baseTheme = function (options) {
    if ( options === void 0 ) options = {};

    return ({
    axisDefaults: axisDefaults(),
    categoryAxis: {
        majorGridLines: {
            visible: true
        }
    },
    navigator: {
        pane: {
            height: 90,
            margin: {
                top: 10
            }
        }
    },
    seriesDefaults: seriesDefaults(options),
    title: title$1(),
    subtitle: subtitle(),
    legend: legend()
});
};

var SERIES_COLORS = 30;
var seriesVar = '--kendo-chart-series-';
var elementStyles = function (element) { return element.ownerDocument.defaultView.getComputedStyle(element); };
var cache = {};

var toColor = function (colorMix, element) {
    if (cache[colorMix]) {
        return cache[colorMix];
    }

    var curColor = element.style.color;
    element.style.color = colorMix;
    var color = elementStyles(element).color;
    element.style.color = curColor;

    cache[colorMix] = color;

    return color;
};

var getProp = function (element, prop) {
    var value = elementStyles(element).getPropertyValue(prop);
    if (/^color-mix/i.test(value)) {
        value = toColor(value, element);
    }
    return value;
};

var getNumberProp = function (element, prop) { return parseFloat(elementStyles(element).getPropertyValue(prop)); };

var getFont = function (element, weightProp, sizeProp, familyProp) {
    var styles = elementStyles(element);
    return [styles.getPropertyValue(weightProp), styles.getPropertyValue(sizeProp), styles.getPropertyValue(familyProp) || styles.fontFamily].join(" ");
};

var getSeriesColors = function (element) {
    var styles = elementStyles(element);
    var result = [];
    var count = 1;
    var color = styles.getPropertyValue(("" + seriesVar + count));
    while (color || count <= SERIES_COLORS) {
        result.push(color);
        count++;
        color = styles.getPropertyValue(("" + seriesVar + count));
    }
    return result;
};

var defaultFont = function (element) { return getFont(element, "--kendo-font-weight", '--kendo-chart-font-size', "--kendo-font-family"); };
var paneTitleFont = function (element) { return getFont(element, "--kendo-chart-pane-title-font-weight", '--kendo-chart-pane-title-font-size', "--kendo-font-family"); };
var normalTextColor = function (element) { return getProp(element, "--kendo-chart-text"); };

var title = function (element) { return ({
    color: normalTextColor(element),
    font: getFont(element, "--kendo-font-weight", '--kendo-chart-title-font-size', "--kendo-font-family"),
}); };

var sankeyLegend = function (element) {
    var textColorNormal = normalTextColor(element);
    return {
        labels: {
            color: textColorNormal,
            font: defaultFont(element),
        },
        title: {
            color: textColorNormal,
        }
    };
};

var chartLegend = function (element) {
    var inactiveColor = getProp(element, "--kendo-chart-inactive");
    return Object.assign({}, {inactiveItems: {
            labels: {
                color: inactiveColor,
            },
            markers: {
                color: inactiveColor,
            },
        }},
        sankeyLegend(element));
};

var gaugeTheme = function (element) {
    var textColorNormal = normalTextColor(element);
    return {
        pointer: {
            color: getProp(element, "--kendo-chart-gauge-pointer")
        },
        scale: {
            labels: {
                color: textColorNormal
            },

            rangePlaceholderColor: getProp(element, "--kendo-chart-gauge-track"),

            minorTicks: {
                color: textColorNormal
            },

            majorTicks: {
                color: textColorNormal
            },

            line: {
                color: textColorNormal
            }
        }
    };
};

var sankeyTheme = function (element) { return ({
    labels: {
        color: normalTextColor(element),
        font: defaultFont(element),
        stroke: {
            color: getProp(element, "--kendo-chart-bg"),
        },
    },
    links: {
        color: getProp(element, "--kendo-color-subtle"),
    },
    nodeColors: getSeriesColors(element),
    title: title(element),
    legend: sankeyLegend(element),
}); };

var notes = function (element) { return ({
    icon: {
        background: getProp(element, "--kendo-chart-notes-bg"),
        border: {
            color: getProp(element, "--kendo-chart-notes-border"),
        },
    },
    line: {
        color: getProp(element, "--kendo-chart-notes-lines"),
    },
    label: {
        font: defaultFont(element),
    },
}); };

var chartTheme = function (element) {
    var majorLines = getProp(element, "--kendo-chart-major-lines");
    var normalTextColor = getProp(element, "--kendo-chart-text");
    var axisLabelFont = getFont(element, "--kendo-font-weight", "--kendo-chart-label-font-size", "--kendo-font-family");
    var chartBg = getProp(element, "--kendo-chart-bg");
    var notesProps = notes(element);
    var areaOpacity = getNumberProp(element, "--kendo-chart-area-opacity");
    var surfaceColor = getProp(element, "--kendo-color-surface");
    var primaryBg = getProp(element, "--kendo-chart-primary-bg");

    var boxPlot = function () { return ({
        downColor: majorLines,
        mean: {
            color: surfaceColor,
        },
        median: {
            color: surfaceColor,
        },
        whiskers: {
            color: primaryBg,
        },
    }); };

    var waterfall = function () { return ({
        line: {
            color: majorLines,
        },
    }); };

    var area = function () { return ({
        opacity: areaOpacity,
        highlight: {
            inactiveOpacity: getNumberProp(element, "--kendo-chart-area-inactive-opacity"),
        },
    }); };

    var line = function () { return ({
        highlight: {
            inactiveOpacity: getNumberProp(element, "--kendo-chart-line-inactive-opacity"),
        },
    }); };

    var bullet = function () { return ({
        target: {
            color: normalTextColor,
        },
    }); };

    return {
        axisDefaults: {
            crosshair: {
                color: getProp(element, "--kendo-chart-crosshair-bg"),
            },
            labels: {
                color: normalTextColor,
                font: axisLabelFont,
            },
            line: {
                color: majorLines,
            },
            majorGridLines: {
                color: majorLines,
            },
            minorGridLines: {
                color: getProp(element, "--kendo-chart-minor-lines"),
            },
            notes: structuredClone(notesProps),
            title: {
                color: normalTextColor,
                font: defaultFont(element),
            }
        },
        chartArea: {
            background: chartBg,
        },
        legend: chartLegend(element),
        seriesColors: getSeriesColors(element),
        seriesDefaults: {
            area: area(),
            verticalArea: area(),
            radarArea: area(),

            boxPlot: boxPlot(),
            verticalBoxPlot: boxPlot(),

            bullet: bullet(),
            verticalBullet: bullet(),

            horizontalWaterfall: waterfall(),
            waterfall: waterfall(),

            line: line(),
            verticalLine: line(),

            candlestick: {
                downColor: normalTextColor,
                line: {
                    color: normalTextColor,
                },
            },
            errorBars: {
                color: getProp(element, "--kendo-chart-error-bars-bg"),
            },
            icon: {
                border: {
                    color: majorLines,
                },
            },
            labels: {
                background: chartBg,
                color: normalTextColor,
                font: axisLabelFont,
                opacity: areaOpacity,
            },
            notes: structuredClone(notesProps),
        },
        subtitle: {
            color: normalTextColor,
            font: paneTitleFont(element),
        },
        title: title(element),
        paneDefaults: {
            title: {
                font: paneTitleFont(element),
            }
        }
    };
};

var chartExport = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Aggregates: Aggregates,
    AreaChart: AreaChart,
    AreaSegment: AreaSegment,
    AxisGroupRangeTracker: AxisGroupRangeTracker,
    Bar: Bar,
    BarChart: BarChart,
    BarLabel: BarLabel,
    BoxPlot: BoxPlot,
    BoxPlotChart: BoxPlotChart,
    BubbleChart: BubbleChart,
    Bullet: Bullet,
    BulletChart: BulletChart,
    Candlestick: Candlestick,
    CandlestickChart: CandlestickChart,
    CategoricalChart: CategoricalChart,
    CategoricalErrorBar: CategoricalErrorBar,
    CategoricalPlotArea: CategoricalPlotArea,
    Chart: Chart,
    ChartAxis: ChartAxis,
    ChartContainer: ChartContainer,
    ChartPane: ChartPane,
    ChartPlotArea: ChartPlotArea,
    ClipAnimation: ClipAnimation,
    ClusterLayout: ClusterLayout,
    Crosshair: Crosshair,
    CrosshairTooltip: CrosshairTooltip,
    DefaultAggregates: DefaultAggregates,
    DonutChart: DonutChart,
    DonutPlotArea: DonutPlotArea,
    DonutSegment: DonutSegment,
    ErrorBarBase: ErrorBarBase,
    ErrorRangeCalculator: ErrorRangeCalculator,
    Highlight: Highlight,
    Legend: Legend$1,
    LegendItem: LegendItem,
    LegendLayout: LegendLayout,
    LineChart: LineChart,
    LinePoint: LinePoint,
    LineSegment: LineSegment,
    MousewheelZoom: MousewheelZoom,
    OHLCChart: OHLCChart,
    OHLCPoint: OHLCPoint,
    Pane: Pane$1,
    Pannable: Pannable,
    PieAnimation: PieAnimation,
    PieChart: PieChart,
    PieChartMixin: PieChartMixin,
    PiePlotArea: PiePlotArea,
    PieSegment: PieSegment,
    PlotAreaBase: PlotAreaBase,
    PlotAreaEventsMixin: PlotAreaEventsMixin,
    PlotAreaFactory: PlotAreaFactory,
    PointEventsMixin: PointEventsMixin,
    RangeAreaChart: RangeAreaChart,
    RangeAreaPoint: RangeAreaPoint,
    RangeBar: RangeBar,
    RangeBarChart: RangeBarChart,
    ScatterChart: ScatterChart,
    ScatterErrorBar: ScatterErrorBar,
    ScatterLineChart: ScatterLineChart,
    Selection: Selection,
    SeriesAggregator: SeriesAggregator,
    SeriesBinder: SeriesBinder,
    SharedTooltip: SharedTooltip$1,
    SplineAreaSegment: SplineAreaSegment,
    SplineSegment: SplineSegment,
    StackWrap: StackWrap,
    Tooltip: Tooltip$1,
    WaterfallChart: WaterfallChart,
    WaterfallSegment: WaterfallSegment,
    XYPlotArea: XYPlotArea,
    ZoomSelection: ZoomSelection,
    anyHasZIndex: anyHasZIndex,
    appendIfNotNull: appendIfNotNull,
    areNumbers: areNumbers,
    bindSegments: bindSegments,
    categoriesCount: categoriesCount,
    constants: constants$1,
    countNumbers: countNumbers,
    createOutOfRangePoints: createOutOfRangePoints,
    equalsIgnoreCase: equalsIgnoreCase,
    evalOptions: evalOptions,
    filterSeriesByType: filterSeriesByType,
    findAxisByName: findAxisByName,
    getField: getField,
    hasGradientOverlay: hasGradientOverlay,
    hasValue: hasValue$2,
    isDateAxis: isDateAxis,
    parseDateCategory: parseDateCategory,
    segmentVisible: segmentVisible,
    singleItemOrArray: singleItemOrArray
});

export { ArcGauge as A, Box as B, ChartWizardCommon as C, DomEventsBuilder as D, getSpacing as E, NAVIGATOR_PANE as F, GRADIENTS as G, StockChart as H, InstanceObserver as I, constants as J, Navigator$1 as K, LinearGauge as L, NavigatorHint as M, NAVIGATOR_AXIS as N, Sparkline as O, Point$5 as P, RadialGauge as R, SeriesBinder as S, TextBox as T, chartExport as a, baseTheme as b, coreExport as c, constants$1 as d, defined as e, chartTheme as f, gaugeTheme as g, hasOwnProperty as h, interpolateValue as i, Chart as j, getField as k, grep as l, mousewheelDelta as m, inArray as n, Sankey as o, sankeyTheme as p, createSankeyData as q, round$1 as r, services as s, CircularGauge as t, LinearScale as u, RadialScale as v, RadialPointer as w, LinearPointer as x, BarLinearPointer as y, ArrowLinearPointer as z };
export { __meta__ };